import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  AddressId: any,
  UserId: any,
  CategoryId: any,
  AttributeSchemaId: any,
  SessionId: any,
  AnyId: any,
  BrandId: any,
  MediaId: any,
  ContactId: any,
  MerchantId: any,
  BusinessAccountId: any,
  OperatorId: any,
  PathFlowId: any,
  DealRequestId: any,
  /** Date and time component in ISO-8601. See https://en.wikipedia.org/wiki/ISO_8601 */
  Date: any,
  /** Long type */
  Long: any,
  /** Built-in java.math.BigDecimal */
  BigDecimal: any,
  /** Only time in ISO-8601. See https://en.wikipedia.org/wiki/ISO_8601#Times */
  Time: any,
  ConversationId: any,
  LeadId: any,
  LeadLabelId: any,
  BroadcastOfferId: any,
  OrderId: any,
  /** javax.money.CurrencyUnit stored in ISO 4217 currency code standard, which use 3 letter codes */
  CurrencyUnit: any,
  ShippingCarrierId: any,
  TransactionId: any,
  PaymentSourceId: any,
  PaymentProcessorAccountId: any,
  OrderLineItemId: any,
  SellableTermsId: any,
  ExpertCuratedItemId: any,
  SellableId: any,
  SellablePriceSourceId: any,
  FulfillmentChannelId: any,
  SystemId: any,
  SavedSellableId: any,
  DepartmentId: any,
  BusinessUserTeamId: any,
  ConsumerExpertReviewId: any,
  ConsumerSellableReactionId: any,
  ExpertCuratedItemNoteId: any,
  ExpertCuratedItemNoteHistoryId: any,
  FulfillmentOrderId: any,
  FulfillmentCenterId: any,
  FulfillmentShipmentMethodId: any,
  OrderRefundId: any,
  OrderEscalationId: any,
  SupportConversationId: any,
  ScheduledPaymentId: any,
  PromotionId: any,
  PromotionRuleReferenceId: any,
  PromotionActionReferenceId: any,
  SimpleCuratedOrderId: any,
  BusinessUserId: any,
  PostCartOrderActivityId: any,
  TicketId: any,
  TicketActivityId: any,
  DealId: any,
  LeadNoteId: any,
  ExpertRecommendationId: any,
  SystemCuratedItemSurveyId: any,
  SystemCuratedItemId: any,
  LeadEscalationId: any,
  LeadActivityId: any,
  SupportTaskActivityId: any,
  SupportTaskId: any,
  ExpertApplicationId: any,
  ExpertProfileId: any,
  ProfileHighlightTypeId: any,
  PathFlowPageId: any,
  ReferralCodeId: any,
  UserActivityId: any,
  AwayAutoReplyId: any,
  BusinessUserActivityId: any,
  PayStructureId: any,
  PayStructureRevisionId: any,
  SchedulingTypeId: any,
  LocalTime: any,
  SchedulingDepartmentId: any,
  CommTemplateId: any,
  CommTemplateVersionHistoryId: any,
  CommTemplateTypeId: any,
  CommTemplateFragmentId: any,
  CommTemplateFragmentVersionHistoryId: any,
  PendingAccessContactId: any,
  FrontendTaskId: any,
  CallActivityId: any,
  GuestConversationSequenceId: any,
  TagId: any,
  ExpertApplicationFolderId: any,
  ExpertReferralId: any,
  SellableResearchLinkId: any,
  QuickReplyId: any,
  ExpertLeadFolderId: any,
  PredictedLifeTimeValueId: any,
  LeadSurgeId: any,
  LeadCampaignId: any,
  TriggerId: any,
  TriggerNodeId: any,
  TriggerVersionHistoryId: any,
  LeadCampaignRecipientId: any,
  SavedSearchId: any,
  AirportId: any,
  ReportId: any,
  ExpertCuratedItemActivationId: any,
  ExpertCuratedOrderId: any,
  FlightPlanId: any,
  FlightPlanLegId: any,
  /** Date only component in ISO-8601. See https://en.wikipedia.org/wiki/ISO_8601#Calendar_dates */
  LocalDate: any,
  ExpertCuratedOrderListActivationId: any,
  SuggestedAlternativeSellableId: any,
  ExpertCuratedActivityFeedItemId: any,
  SavedExpertCuratedItemsId: any,
  RecommendedListDefinitionId: any,
  ConfigEntryId: any,
  ExternalAdCampaignId: any,
  ExternalAdGroupId: any,
  SupportTaskFolderId: any,
  SellableInventoryItemId: any,
  PayoutId: any,
  PayLineItemId: any,
  RawSellableSourceId: any,
  RawSellableId: any,
  StandardizedSellableId: any,
  StandardizedSellableGroupId: any,
  RawSellableStandardizationRuleId: any,
  StandardizedSellableGroupCandidateId: any,
  SchedulingDemandForecastId: any,
  SchedulingUserAvailabilityId: any,
  ShiftId: any,
  ShiftSlotId: any,
  ShiftSlotUserViewId: any,
  ReferralCodeShareId: any,
  ExperimentId: any,
  BookingId: any,
  PathSchemaId: any,
  /** The scalar type for multipart file uploads. It should be used for input only. */
  Upload: any,
};


export type AcceptEscalationInput = {
  id: Scalars['LeadEscalationId'],
};

export type AcceptEscalationResult = {
   __typename: 'AcceptEscalationResult',
  status: AcceptEscalationResultStatus,
  escalation: LeadEscalation,
};

export enum AcceptEscalationResultStatus {
  NOT_ALLOWED = 'NOT_ALLOWED',
  ACCEPTED = 'ACCEPTED',
  ALREADY_CLAIMED = 'ALREADY_CLAIMED',
  ESCALATION_CLOSED = 'ESCALATION_CLOSED'
}

export enum AcceptRequestMode {
  ALWAYS = 'ALWAYS',
  WHEN_ACTIVATED = 'WHEN_ACTIVATED',
  WHEN_ACTIVATED_AND_AS_BACKUP = 'WHEN_ACTIVATED_AND_AS_BACKUP'
}

export type AcceptStandardizedSellableGroupCandidateInput = {
  id: Scalars['StandardizedSellableGroupCandidateId'],
};

export type AcceptStandardizedSellableGroupCandidatePayload = {
   __typename: 'AcceptStandardizedSellableGroupCandidatePayload',
  candidate: StandardizedSellableGroupCandidate,
};

export type AcceptSurgeShiftInput = {
  expertId: Scalars['BusinessUserId'],
  leadSurgeId: Scalars['LeadSurgeId'],
};

export type AcceptSurgeShiftPayload = {
   __typename: 'AcceptSurgeShiftPayload',
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
  shift?: Maybe<Shift>,
};

export type ActivateExpertCuratedOrderAsBookableInput = {
  id: Scalars['ExpertCuratedOrderId'],
};

export type ActivateExpertCuratedOrderAsBookablePayload = {
   __typename: 'ActivateExpertCuratedOrderAsBookablePayload',
  /** 
 * The expert curated order that was activated if `hasError` is `false`, or the latest state of the still draft expert
   * curated order
 **/
  expertCuratedOrder: ExpertCuratedOrder,
  /** If there was an error activating the curated order */
  hasError: Scalars['Boolean'],
  /** User displayable message for why the activation failed */
  errorMessage?: Maybe<Scalars['String']>,
};

export type ActivateExpertCuratedOrdersForLeadInput = {
  leadId: Scalars['LeadId'],
};

export type ActivateExpertCuratedOrdersForLeadPayload = {
   __typename: 'ActivateExpertCuratedOrdersForLeadPayload',
  /** If successful, hasError will be false, and activation will be present */
  activation?: Maybe<ExpertCuratedOrderListActivation>,
  /** 
 * If there were any errors encountered while activating the curated orders. If true, `errors` will be non empty,
   * and/or errorMessage will have a top level error message
 **/
  hasError: Scalars['Boolean'],
  /** Individual errors for each expert curated order */
  errors: Array<ExpertCuratedOrderActivationError>,
  /** 
 * Top level error that's not associated with a particular ExpertCuratedOrder. This is mutually exclusive with
   * `errors` that contain errors for particular expert curated orders.
 **/
  errorMessage?: Maybe<Scalars['String']>,
};

export type ActivateExpertInput = {
  id: Scalars['BusinessUserId'],
};

export type ActivateExpertPayload = {
   __typename: 'ActivateExpertPayload',
  error?: Maybe<Scalars['String']>,
  businessUser: BusinessUser,
};

export type ActivateFlightPlanInput = {
  id: Scalars['FlightPlanId'],
};

export type ActivateFlightPlanPayload = {
   __typename: 'ActivateFlightPlanPayload',
  flightPlan: FlightPlan,
  errorCode?: Maybe<FlightPlanEditErrorCode>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type ActivateGuestConversationSequenceInput = {
  id: Scalars['GuestConversationSequenceId'],
};

export type ActivateGuestConversationSequencePayload = {
   __typename: 'ActivateGuestConversationSequencePayload',
  sequence: GuestConversationSequence,
};

export type ActivatePayStructureRevisionInput = {
  id: Scalars['PayStructureRevisionId'],
  effectiveNow: Scalars['Boolean'],
};

export type ActivatePromotionInput = {
  id: Scalars['PromotionId'],
};

export type ActivatePromotionPayload = {
   __typename: 'ActivatePromotionPayload',
  promotion: Promotion,
  /** 
 * The promotion that was previously active with the same promotion code, but was deactivated as a result of
   * `promotion` being activated.
 **/
  replacedPromotion?: Maybe<Promotion>,
};

export type AddAddressInput = {
  userId: Scalars['UserId'],
  addressFieldInput?: Maybe<AddressFieldInput>,
};

export type AddAddresssPayload = {
   __typename: 'AddAddresssPayload',
  address?: Maybe<Address>,
  error?: Maybe<Scalars['String']>,
};

export type AddBlacklistChannelAddressInput = {
  type: MessagingChannelType,
  address: Scalars['String'],
};

export type AddBlacklistChannelAddressPayload = {
   __typename: 'AddBlacklistChannelAddressPayload',
  hasError: Scalars['Boolean'],
};

export type AddChannelTemplateInput = {
  templateId: Scalars['CommTemplateId'],
  channelType: ChannelType,
};

export type AddCommentInput = {
  ticketId: Scalars['TicketId'],
  comment: Scalars['String'],
};

export type AddEscalationLabelInput = {
  escalationId: Scalars['OrderEscalationId'],
  escalationLabel: OrderEscalationLabel,
};

export type AddEscalationOperatorNoteInput = {
  escalationId: Scalars['OrderEscalationId'],
  note: Scalars['String'],
};

export type AddExpertApplicationNoteInput = {
  applicationId: Scalars['ExpertApplicationId'],
  note: Scalars['String'],
};

export type AddExpertApplicationReviewInput = {
  applicationId: Scalars['ExpertApplicationId'],
  rating: ExpertApplicationRating,
  reason?: Maybe<Scalars['String']>,
};

export type AddExpertApplicationReviewPayload = {
   __typename: 'AddExpertApplicationReviewPayload',
  application: ExpertApplication,
};

export type AddExpertCuratedItemToCartInput = {
  id: Scalars['ExpertCuratedItemId'],
};

export type AddExpertCuratedItemToCartPayload = {
   __typename: 'AddExpertCuratedItemToCartPayload',
  expertCuratedItem: ExpertCuratedItem,
  order: Order,
};

export type AddGuestConversationSequenceMessageInput = {
  sequenceId: Scalars['GuestConversationSequenceId'],
  templateName: Scalars['String'],
  richCardType?: Maybe<MessageRichCardType>,
};

export type AddGuestConversationSequenceMessagePayload = {
   __typename: 'AddGuestConversationSequenceMessagePayload',
  sequence: GuestConversationSequence,
};

export type AddItemsToOrderInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>,
  /** Simplified API that only adds sellables */
  sellableIds?: Maybe<Array<Scalars['SellableId']>>,
  sellables?: Maybe<Array<AddItemsToOrderSellableInput>>,
};

export type AddItemsToOrderPayload = {
   __typename: 'AddItemsToOrderPayload',
  order: Order,
};

export type AddItemsToOrderSellableInput = {
  sellableId: Scalars['SellableId'],
  /** Quantity of items to add; defaults to 1 if omitted */
  quantity?: Maybe<Scalars['Int']>,
  /** 
 * Expert only property; if this line item is explicitly marked as not taxable.
   * Note that by this being `false` does not mean this line item is guaranteed to be taxed - it just means the
   * natural taxation logic will apply to this item.
 **/
  nonTaxable?: Maybe<Scalars['Boolean']>,
  /** Expert only property; override the sellable price with a custom one */
  priceOverride?: Maybe<MonetaryAmountInput>,
};

export type AddManualAdjustmentPayLineItemInput = {
  payoutId: Scalars['PayoutId'],
  amount: MonetaryAmountInput,
  reason: Scalars['String'],
};

export type AddOfferToCartInput = {
  id: Scalars['BroadcastOfferId'],
};

export type AddOfferToCartPayload = {
   __typename: 'AddOfferToCartPayload',
  order: Order,
};

export type AddOperatorNoteInput = {
  orderId: Scalars['OrderId'],
  title?: Maybe<Scalars['String']>,
  note: Scalars['String'],
  emailSupport?: Maybe<Scalars['Boolean']>,
  lineItemId?: Maybe<Scalars['OrderLineItemId']>,
};

export type AddOrderReturnShipmentTrackingInput = {
  orderRefundId: Scalars['OrderRefundId'],
  shippingCarrierId: Scalars['ShippingCarrierId'],
  trackingNumber: Scalars['String'],
};

export type AddProfileHighlightInput = {
  expertProfileId: Scalars['ExpertProfileId'],
  highlight: ProfileHighlightInput,
};

export type AddPromotionToOrderInput = {
  id: Scalars['OrderId'],
  promotionCode: Scalars['String'],
};

export type AddPromotionToOrderPayload = {
   __typename: 'AddPromotionToOrderPayload',
  order: Order,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

/** 
 * Use Address if you want to save Address data in a separate collection vs PostalAddress,
 * which is used as an embeddable object
 * All new implementations should prefer Address going forward as they allows reusablity of Addresses
 **/
export type Address = AddressFields & {
   __typename: 'Address',
  addresseeName?: Maybe<Scalars['String']>,
  businessName?: Maybe<Scalars['String']>,
  line1?: Maybe<Scalars['String']>,
  line2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  countryDetails?: Maybe<Country>,
  postalCode: Scalars['String'],
  securityCode?: Maybe<Scalars['String']>,
  phoneNumber?: Maybe<Scalars['String']>,
  parsedPhoneNumber?: Maybe<ParsedPhoneNumber>,
  id: Scalars['AddressId'],
  userId: Scalars['UserId'],
  active: Scalars['Boolean'],
  userFriendlyName?: Maybe<Scalars['String']>,
  isDefault?: Maybe<Scalars['Boolean']>,
};

export type AddressFieldInput = {
  reusableAddress?: Maybe<Scalars['Boolean']>,
  addresseeName: Scalars['String'],
  businessName?: Maybe<Scalars['String']>,
  line1: Scalars['String'],
  line2?: Maybe<Scalars['String']>,
  city: Scalars['String'],
  state?: Maybe<Scalars['String']>,
  country: Scalars['String'],
  postalCode: Scalars['String'],
  securityCode?: Maybe<Scalars['String']>,
  phoneNumber?: Maybe<Scalars['String']>,
  userFriendlyName?: Maybe<Scalars['String']>,
  isDefault?: Maybe<Scalars['Boolean']>,
};

export type AddressFields = {
  addresseeName?: Maybe<Scalars['String']>,
  businessName?: Maybe<Scalars['String']>,
  line1?: Maybe<Scalars['String']>,
  line2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  countryDetails?: Maybe<Country>,
  postalCode: Scalars['String'],
};


/** Either addressId or addressFieldInput must be provided */
export type AddressInput = {
  addressId?: Maybe<Scalars['AddressId']>,
  addressFieldInput?: Maybe<AddressFieldInput>,
};

export type AddScheduleReportInput = {
  reportId: Scalars['ReportId'],
  refreshIntervalInMinutes: Scalars['Int'],
  runImmediately: Scalars['Boolean'],
};

export type AddSupportToLeadConversationInput = {
  leadId: Scalars['LeadId'],
};

export type AddSupportToLeadConversationPayload = {
   __typename: 'AddSupportToLeadConversationPayload',
  success: Scalars['Boolean'],
  lead?: Maybe<Lead>,
};

export type AddTipToOrderInput = {
  id: Scalars['OrderId'],
  tip: MonetaryAmountInput,
  /** 
 * It is required to indicate which expert receives the tip. All entries in this array must add up to 100%.
   * Use `recommendTipPercentagesForOrder` to get recommended experts and tip percentages
 **/
  tipPercentages: Array<ExpertTipPercentageInput>,
};

export type AddTipToOrderPayload = {
   __typename: 'AddTipToOrderPayload',
  order: Order,
};

export type AddUserInfoForLeadInput = {
  leadId: Scalars['LeadId'],
  firstName: Scalars['String'],
  lastName?: Maybe<Scalars['String']>,
  emailAddress?: Maybe<Scalars['String']>,
  phoneNumber?: Maybe<Scalars['String']>,
};

export type AddUserInfoForLeadPayload = {
   __typename: 'AddUserInfoForLeadPayload',
  lead: Lead,
};

export type AdjustRequestedRefundAmountInput = {
  orderRefundId: Scalars['OrderRefundId'],
  requestedAmount: MonetaryAmountInput,
};

export type AdministrativeArea = {
   __typename: 'AdministrativeArea',
  /** country code this administrative area is associated with, e.g.: "US", "AU", etc */
  countryCode: Scalars['String'],
  /** the code for this administrative area, e.g.: "CA" for California in US */
  code: Scalars['String'],
  /** the display name for this administrative area, e.g.: "California" */
  displayName: Scalars['String'],
};

export type AffirmAccount = PaymentProcessorAccount & {
   __typename: 'AffirmAccount',
  id: Scalars['PaymentProcessorAccountId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  type: PaymentProcessorType,
  userId: Scalars['UserId'],
  paymentSources: Array<PaymentSource>,
  /** This is same as email but with Affirm prefix, as the Affirm doesn't return an Id in the response. */
  externalAccountId?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
};

export type AffirmPaymentSource = PaymentSource & {
   __typename: 'AffirmPaymentSource',
  id: Scalars['PaymentSourceId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  externalSourceId: Scalars['String'],
  type: PaymentProcessorType,
  usage: PaymentSourceUsage,
  status: PaymentSourceStatus,
  userId: Scalars['UserId'],
  billingAddress?: Maybe<Address>,
  paymentEntity: PaymentEntity,
  isDefault: Scalars['Boolean'],
};

export type AfterPayAccount = PaymentProcessorAccount & {
   __typename: 'AfterPayAccount',
  id: Scalars['PaymentProcessorAccountId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  type: PaymentProcessorType,
  userId: Scalars['UserId'],
  paymentSources: Array<PaymentSource>,
  /** This is same as email but with Afterpay prefix, as the Afterpay doesn't return an Id in the response. */
  externalAccountId?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
};

export type AfterpayPaymentSource = PaymentSource & {
   __typename: 'AfterpayPaymentSource',
  id: Scalars['PaymentSourceId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  externalSourceId: Scalars['String'],
  type: PaymentProcessorType,
  usage: PaymentSourceUsage,
  status: PaymentSourceStatus,
  userId: Scalars['UserId'],
  billingAddress?: Maybe<Address>,
  paymentEntity: PaymentEntity,
  isDefault: Scalars['Boolean'],
};

export type AggregateExpertReport = {
   __typename: 'AggregateExpertReport',
  globalStats: GlobalStatsAggregateExpertReport,
  categoryBrandStats: Array<BrandStatsAggregateExpertReport>,
  categoryGroupedBrandStats: CategoryGroupedBrandStatsAggregateExpertReport,
  departmentBrandStats: Array<BrandStatsAggregateExpertReport>,
};


export type AggregateExpertReportCategoryBrandStatsArgs = {
  categoryId: Scalars['CategoryId'],
  limit?: Maybe<Scalars['Int']>
};


export type AggregateExpertReportCategoryGroupedBrandStatsArgs = {
  departmentId: Scalars['DepartmentId']
};


export type AggregateExpertReportDepartmentBrandStatsArgs = {
  departmentId: Scalars['DepartmentId'],
  limit?: Maybe<Scalars['Int']>
};

export type Airport = {
   __typename: 'Airport',
  id: Scalars['AirportId'],
  type: AirportType,
  active: Scalars['Boolean'],
  name: Scalars['String'],
  latitudeDegree: Scalars['Float'],
  longitudeDegree: Scalars['Float'],
  continentCode: Scalars['String'],
  countryCode: Scalars['String'],
  zoneId: Scalars['String'],
  dataSourceCode: Scalars['String'],
  iataCode?: Maybe<Scalars['String']>,
  icaoCode?: Maybe<Scalars['String']>,
  displayCode: Scalars['String'],
};


export enum AirportType {
  LARGE_AIRPORT = 'LARGE_AIRPORT',
  MEDIUM_AIRPORT = 'MEDIUM_AIRPORT',
  SMALL_AIRPORT = 'SMALL_AIRPORT'
}

export type AirportTypeaheadHit = {
   __typename: 'AirportTypeaheadHit',
  id: Scalars['AirportId'],
  /** The matched text string in the indexed keywords */
  text: Scalars['String'],
  /** The airport name */
  name: Scalars['String'],
  dataSourceCode: Scalars['String'],
  iataCode?: Maybe<Scalars['String']>,
  icaoCode?: Maybe<Scalars['String']>,
  displayCode: Scalars['String'],
  airport: Airport,
};

export type AirportTypeaheadPayload = {
   __typename: 'AirportTypeaheadPayload',
  hits: Array<AirportTypeaheadHit>,
};

export type AirportTypeaheadQuery = {
  prefixSearch?: Maybe<Scalars['String']>,
};

export type AlwaysTrueConditionDefinition = ConditionDefinition & {
   __typename: 'AlwaysTrueConditionDefinition',
  type: ConditionType,
};

export type AmazonSellablePriceSource = SellablePriceSource & {
   __typename: 'AmazonSellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  bestOfferPrice?: Maybe<MonetaryAmount>,
  cost?: Maybe<MonetaryAmount>,
  expiresAt?: Maybe<Scalars['Date']>,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  asin: Scalars['String'],
};

/** 
 * Flat amount taken off the order. This is implemented by taking the amount off of line items that meet
 * `Promotion.rules` criteria. If the amount off is more than the cost of the line items, the promotion will not be
 * applied as its assumed it's an error in defining the promotion action.
 **/
export type AmountOffOrderPromotionActionReference = PromotionActionReference & {
   __typename: 'AmountOffOrderPromotionActionReference',
  id: Scalars['PromotionActionReferenceId'],
  type: PromotionActionType,
  /** Total amount off order; amount greater than zero */
  amountOff: MonetaryAmount,
};

/** See `AmountOffOrderPromotionActionReference` for documentation */
export type AmountOffOrderPromotionActionReferenceInput = {
  /** Total amount off order; amount greater than zero */
  amountOff: MonetaryAmountInput,
};


export type ApplyExternalAdBudgetInput = {
  categoryId: Scalars['CategoryId'],
};

export type ApplyExternalAdBudgetPayload = {
   __typename: 'ApplyExternalAdBudgetPayload',
  hasError: Scalars['Boolean'],
};

export type ApproveExpertApplicationInput = {
  applicationId: Scalars['ExpertApplicationId'],
};

export type ApproveExpertApplicationPayload = {
   __typename: 'ApproveExpertApplicationPayload',
  application: ExpertApplication,
};

export type ArchiveExperimentInput = {
  id: Scalars['ExperimentId'],
};

export type ArchiveExperimentPayload = {
   __typename: 'ArchiveExperimentPayload',
  experiment: ExperimentDefinition,
  errorMessage?: Maybe<Scalars['String']>,
  hasError: Scalars['Boolean'],
};

export type ArchiveTriggerInput = {
  triggerId: Scalars['TriggerId'],
  notes?: Maybe<Scalars['String']>,
};

export type ArchiveTriggerPayload = {
   __typename: 'ArchiveTriggerPayload',
  triggersArchived: Array<Trigger>,
  error?: Maybe<Scalars['String']>,
};

export type AssignEscalationInput = {
  escalationId: Scalars['OrderEscalationId'],
  assignedToId: Scalars['OperatorId'],
};

export type AssignFulfillmentOperatorInput = {
  orderId: Scalars['OrderId'],
  operatorId: Scalars['OperatorId'],
};

export type AssignOrderLineItemInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
  assignedToId: Scalars['OperatorId'],
};

export type AssignSupportTaskActivity = SupportTaskActivity & {
   __typename: 'AssignSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  assignedTo: Operator,
};

export type AssignSupportTaskInput = {
  supportTaskId: Scalars['SupportTaskId'],
  assigneeId?: Maybe<Scalars['OperatorId']>,
};

export type AssignSupportTaskPayload = {
   __typename: 'AssignSupportTaskPayload',
  supportTask?: Maybe<SupportTask>,
  error?: Maybe<Scalars['String']>,
};

export type AssignTicketInput = {
  ticketId: Scalars['TicketId'],
  assignToId: Scalars['AnyId'],
};

export type AssumeBusinessUserIdentityInput = {
  businessUserId: Scalars['BusinessUserId'],
};

export type AssumeBusinessUserIdentityPayload = EncodedAuthenticationTokensPayload & {
   __typename: 'AssumeBusinessUserIdentityPayload',
  myself?: Maybe<Myself>,
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

export type AssumeConsumerIdentityInput = {
  userId: Scalars['UserId'],
};

export type AssumeConsumerIdentityPayload = EncodedAuthenticationTokensPayload & {
   __typename: 'AssumeConsumerIdentityPayload',
  user?: Maybe<User>,
  myself?: Maybe<Myself>,
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

export type AssumeOperatorIdentityInput = {
  operatorId: Scalars['OperatorId'],
};

export type AssumeOperatorIdentityPayload = EncodedAuthenticationTokensPayload & {
   __typename: 'AssumeOperatorIdentityPayload',
  operator?: Maybe<Operator>,
  myself?: Maybe<Myself>,
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

export type Attribute = {
   __typename: 'Attribute',
  schema: AttributeSchema,
  values: Array<AttributeValue>,
  formatted?: Maybe<FormattedAttribute>,
};

export type AttributedHtmlTextViewModel = {
   __typename: 'AttributedHtmlTextViewModel',
  /** 
 * This text can be HTML so the client shouldn't escape it (will be pre-sanitized by the server)
   * Text can have placeholders in the form of <%Key%>, where "Key" is present in attributes key
   * property.
 **/
  text: Scalars['String'],
  attributes?: Maybe<Array<AttributedHtmlTextViewModelAttribute>>,
};

export type AttributedHtmlTextViewModelAttribute = {
   __typename: 'AttributedHtmlTextViewModelAttribute',
  key: Scalars['String'],
  type: AttributedHtmlTextViewModelAttributeType,
  image?: Maybe<ImageViewModel>,
};

export enum AttributedHtmlTextViewModelAttributeType {
  /** Denotes this attribute is an image view model */
  IMAGE = 'IMAGE'
}

export type AttributeEnumerationMapping = {
   __typename: 'AttributeEnumerationMapping',
  value: Scalars['String'],
  description?: Maybe<Scalars['String']>,
};

/** 
 * Exploded union of attribute values.
 * See corresponding AttributeValue* types that correspond with AttributeType to see which fields to fill out
 * depending on which enum type is used
 **/
export type AttributeInput = {
  name: Scalars['String'],
  type: AttributeType,
  decimal?: Maybe<Scalars['BigDecimal']>,
  integer?: Maybe<Scalars['Long']>,
  minInteger?: Maybe<Scalars['Long']>,
  maxInteger?: Maybe<Scalars['Long']>,
  minDecimal?: Maybe<Scalars['BigDecimal']>,
  maxDecimal?: Maybe<Scalars['BigDecimal']>,
  text?: Maybe<Scalars['String']>,
  enumerationValue?: Maybe<Scalars['String']>,
};

export type AttributeSchema = {
   __typename: 'AttributeSchema',
  id: Scalars['AttributeSchemaId'],
  name: Scalars['String'],
  displayName: Scalars['String'],
  type: AttributeType,
  validations?: Maybe<Array<AttributeValidation>>,
  /** Only present for enumeration types */
  enumerationMappings?: Maybe<Array<AttributeEnumerationMapping>>,
};


export type AttributeSchemasByCategoriesConnection = {
   __typename: 'AttributeSchemasByCategoriesConnection',
  edges?: Maybe<Array<Maybe<AttributeSchemasByCategoriesEdge>>>,
  pageInfo?: Maybe<PageInfo>,
};

export type AttributeSchemasByCategoriesEdge = {
   __typename: 'AttributeSchemasByCategoriesEdge',
  node: AttributeSchema,
  cursor: Scalars['String'],
};

/** 
 * There is a 1:1 correlation between AttributeType and a GraphQL type.
 * The corresponding GraphQL type declaration name is ("AttributeValue" + pascalCaseOf(AttributeType))
 **/
export enum AttributeType {
  INTEGER = 'INTEGER',
  INTEGER_RANGE = 'INTEGER_RANGE',
  DECIMAL = 'DECIMAL',
  DECIMAL_RANGE = 'DECIMAL_RANGE',
  TEXT = 'TEXT',
  ENUMERATION = 'ENUMERATION',
  LOCAL_DATE = 'LOCAL_DATE',
  LOCAL_DATE_RANGE = 'LOCAL_DATE_RANGE',
  LOCAL_TIME = 'LOCAL_TIME',
  LOCAL_TIME_RANGE = 'LOCAL_TIME_RANGE',
  LOCAL_DATE_TIME = 'LOCAL_DATE_TIME',
  LOCAL_DATE_TIME_RANGE = 'LOCAL_DATE_TIME_RANGE',
  ZONE_ID = 'ZONE_ID',
  ID = 'ID'
}

export type AttributeValidation = {
  type: AttributeValidationType,
};

export type AttributeValidationRegex = AttributeValidation & {
   __typename: 'AttributeValidationRegex',
  type: AttributeValidationType,
  /** Regular expression used for validation */
  regex: Scalars['String'],
  /** Error message that should be displayed if the regular expression match fails */
  errorMessage: Scalars['String'],
};

export enum AttributeValidationType {
  /** 
 * Text value must conform to a regular expression
   * Validates TEXT attribute types
 **/
  REGEX = 'REGEX',
  /** 
 * Ensure the amount of attribute values falls between a specified range.
   * Validates all attribute types.
 **/
  VALUE_AMOUNT = 'VALUE_AMOUNT'
}

export type AttributeValidationValueAmount = AttributeValidation & {
   __typename: 'AttributeValidationValueAmount',
  type: AttributeValidationType,
  /** Mimumum amount of values that can be provided, inclusive. If omitted, there is no minumum enforced. */
  min?: Maybe<Scalars['Long']>,
  /** Maximum amount of values that can be provided, inclusive. If omitted, there is no maxmimum enforced. */
  max?: Maybe<Scalars['Long']>,
};

export type AttributeValue = AttributeValueInteger | AttributeValueIntegerRange | AttributeValueDecimal | AttributeValueDecimalRange | AttributeValueText | AttributeValueEnumeration | AttributeValueDate | AttributeValueDateRange | AttributeValueTime | AttributeValueTimeRange | AttributeValueDateTime | AttributeValueDateTimeRange | AttributeValueZoneId | AttributeValueId;

export type AttributeValueDate = {
   __typename: 'AttributeValueDate',
  date: Scalars['Date'],
};

export type AttributeValueDateRange = {
   __typename: 'AttributeValueDateRange',
  minDate?: Maybe<Scalars['Date']>,
  maxDate?: Maybe<Scalars['Date']>,
};

export type AttributeValueDateTime = {
   __typename: 'AttributeValueDateTime',
  dateTime: Scalars['Date'],
};

export type AttributeValueDateTimeRange = {
   __typename: 'AttributeValueDateTimeRange',
  minDateTime?: Maybe<Scalars['Date']>,
  maxDateTime?: Maybe<Scalars['Date']>,
};

export type AttributeValueDecimal = {
   __typename: 'AttributeValueDecimal',
  decimal: Scalars['BigDecimal'],
};

export type AttributeValueDecimalRange = {
   __typename: 'AttributeValueDecimalRange',
  minDecimal?: Maybe<Scalars['BigDecimal']>,
  maxDecimal?: Maybe<Scalars['BigDecimal']>,
};

export type AttributeValueEnumeration = {
   __typename: 'AttributeValueEnumeration',
  enumerationValue: Scalars['String'],
  enumerationValueDescription: Scalars['String'],
};

export type AttributeValueId = {
   __typename: 'AttributeValueId',
  id?: Maybe<Scalars['AnyId']>,
};

export type AttributeValueInteger = {
   __typename: 'AttributeValueInteger',
  integer: Scalars['Long'],
};

export type AttributeValueIntegerRange = {
   __typename: 'AttributeValueIntegerRange',
  minInteger?: Maybe<Scalars['Long']>,
  maxInteger?: Maybe<Scalars['Long']>,
};

export type AttributeValueText = {
   __typename: 'AttributeValueText',
  text: Scalars['String'],
};

export type AttributeValueTime = {
   __typename: 'AttributeValueTime',
  time: Scalars['Time'],
};

export type AttributeValueTimeRange = {
   __typename: 'AttributeValueTimeRange',
  minTime?: Maybe<Scalars['Time']>,
  maxTime?: Maybe<Scalars['Time']>,
};

export type AttributeValueZoneId = {
   __typename: 'AttributeValueZoneId',
  zoneId?: Maybe<Scalars['String']>,
};

export type AuthenticateByExternalOAuthTokenInput = {
  type: OAuthType,
  token: Scalars['String'],
};

export type AuthenticateByExternalOAuthTokenPayload = EncodedAuthenticationTokensPayload & {
   __typename: 'AuthenticateByExternalOAuthTokenPayload',
  result: AuthenticationResult,
  user?: Maybe<User>,
  message?: Maybe<Scalars['String']>,
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

export type AuthenticationInput = {
  handle?: Maybe<Scalars['String']>,
  handleType?: Maybe<HandleType>,
  handleId?: Maybe<Scalars['AnyId']>,
  challenge: Scalars['String'],
};

export enum AuthenticationMethod {
  NO_PASSWORD = 'NO_PASSWORD',
  PASSWORD = 'PASSWORD',
  CHALLENGE = 'CHALLENGE',
  LOGIN_TOKEN = 'LOGIN_TOKEN',
  EXTERNAL_OAUTH = 'EXTERNAL_OAUTH'
}

export enum AuthenticationResult {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  CHALLENGE = 'CHALLENGE'
}

export type AuthenticationResultPayload = EncodedAuthenticationTokensPayload & {
   __typename: 'AuthenticationResultPayload',
  result: AuthenticationResult,
  user?: Maybe<User>,
  message?: Maybe<Scalars['String']>,
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

export type AuthenticationSessionState = {
   __typename: 'AuthenticationSessionState',
  handle?: Maybe<Scalars['String']>,
  handleId?: Maybe<Scalars['AnyId']>,
  loginChallengeType?: Maybe<ChallengeType>,
  resetPasswordChallengeVerified: Scalars['Boolean'],
};

export type AvailabilityByFulfillmentCenter = {
   __typename: 'AvailabilityByFulfillmentCenter',
  fulfillmentCenter: FulfillmentCenter,
  /** Items available to order on our site from this Fulfillment Center */
  count: Scalars['Int'],
};

export type AwayAutoReply = {
   __typename: 'AwayAutoReply',
  id: Scalars['AwayAutoReplyId'],
  effectiveFrom: Scalars['Date'],
  effectiveUntil: Scalars['Date'],
  status: AwayAutoReplyStatus,
  message: Scalars['String'],
};


export enum AwayAutoReplyStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED'
}

export type BackgroundFacetImageMetadata = FacetImageMetadata & {
   __typename: 'BackgroundFacetImageMetadata',
  type: FacetImageType,
  imageUrl: Scalars['String'],
};

export type BankCheckPaymentEntity = PaymentEntity & {
   __typename: 'BankCheckPaymentEntity',
  paymentMethod: PaymentMethod,
  bankName: Scalars['String'],
  recipientName: Scalars['String'],
  accountNumber: Scalars['String'],
  amount: MonetaryAmount,
};

export type BasicPathFlowPageMetadata = PathFlowPageMetadata & {
   __typename: 'BasicPathFlowPageMetadata',
  type: PathFlowPageMetadataType,
};


export type Booking = {
   __typename: 'Booking',
  id: Scalars['BookingId'],
  createdAt: Scalars['Date'],
  order: Order,
  state: BookingState,
};

export type BookingEdge = {
   __typename: 'BookingEdge',
  node: Booking,
  cursor: Scalars['String'],
};


export type BookingsConnection = {
   __typename: 'BookingsConnection',
  facets: Array<DisplayFacet>,
  edges: Array<BookingEdge>,
  pageInfo: PageInfo,
  count: Scalars['Int'],
};

export type BookingSearchQueryInput = {
  orderIds?: Maybe<Scalars['OrderId']>,
  bookingStates?: Maybe<BookingState>,
  facets?: Maybe<Array<FacetSelection>>,
  facetedSearch: Scalars['Boolean'],
};

export enum BookingSearchSort {
  DEFAULT = 'DEFAULT',
  ORDER_CREATE_AT = 'ORDER_CREATE_AT'
}

export enum BookingState {
  TRIP_COMPLETED = 'TRIP_COMPLETED',
  TRIP_UPCOMING = 'TRIP_UPCOMING',
  VERIFYING_PAYMENT = 'VERIFYING_PAYMENT'
}

export type Brand = {
   __typename: 'Brand',
  id: Scalars['BrandId'],
  name: Scalars['String'],
  displayName: Scalars['String'],
  active: Scalars['Boolean'],
  slug: Scalars['String'],
  logo?: Maybe<MediaFile>,
};

export type BrandConnection = {
   __typename: 'BrandConnection',
  edges: Array<BrandEdge>,
  pageInfo: PageInfo,
};

export type BrandEdge = {
   __typename: 'BrandEdge',
  node: Brand,
  cursor: Scalars['String'],
};


export type BrandStatsAggregateExpertReport = {
   __typename: 'BrandStatsAggregateExpertReport',
  category: Category,
  brand: Brand,
  recommendedThisWeek: Scalars['Int'],
  recommendedLastWeek: Scalars['Int'],
  rankLast7Days: Scalars['Int'],
  rankLastWeek7Days: Scalars['Int'],
};

export type BrandUploadTaskPayload = {
   __typename: 'BrandUploadTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  numBrandsCreated: Scalars['Int'],
  numBrandsUpdated: Scalars['Int'],
  errorRows: Array<Scalars['Int']>,
  googleSpreadsheetId: Scalars['String'],
};

export type BridgeExpertApplicantPhoneCallInput = {
  fromMessagingUserId: Scalars['AnyId'],
  applicationId: Scalars['ExpertApplicationId'],
};

export type BridgeLeadPhoneCallInput = {
  fromMessagingUserId: Scalars['AnyId'],
  leadId: Scalars['LeadId'],
};

export type BridgePhoneCallInput = {
  conversationId: Scalars['ConversationId'],
  fromMessagingUserId: Scalars['AnyId'],
  toMessagingUserId: Scalars['AnyId'],
};

export type BridgePhoneCallPayload = {
   __typename: 'BridgePhoneCallPayload',
  success: Scalars['Boolean'],
};

export type BroadcastOffer = {
   __typename: 'BroadcastOffer',
  id: Scalars['BroadcastOfferId'],
  conversation?: Maybe<Conversation>,
  type?: Maybe<BroadcastOfferType>,
  title: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  state: OfferState,
  createdBy: BusinessUser,
  createdFor: User,
  expiresAt?: Maybe<Scalars['Date']>,
  price: Money,
  originalPrice?: Maybe<Money>,
  originalPriceSource?: Maybe<Scalars['String']>,
  tax?: Maybe<Money>,
  freeAddOns: Array<OfferAddOn>,
  images: Array<MediaFile>,
  videos: Array<MediaFile>,
  publicOffer: Scalars['Boolean'],
  publicOfferUrl?: Maybe<Scalars['String']>,
  terms?: Maybe<OfferTerms>,
  brand?: Maybe<Brand>,
  comments?: Maybe<Scalars['String']>,
  order?: Maybe<Order>,
  totalCost: Money,
  shippingCost?: Maybe<Money>,
  discount?: Maybe<Scalars['Float']>,
  deal?: Maybe<Deal>,
  sellable?: Maybe<Sellable>,
  lastViewedAt?: Maybe<Scalars['Date']>,
  userDocuments: Array<MediaFile>,
  consumerUrl: Scalars['String'],
  canAddToCart: Scalars['Boolean'],
};


export enum BroadcastOfferType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE'
}

export type BsonObject = {
   __typename: 'BsonObject',
  version: Scalars['Int'],
  data: Scalars['String'],
};

/** Buckets of values and counts that are individually selectable */
export type BucketedDisplayFacet = DisplayFacet & {
   __typename: 'BucketedDisplayFacet',
  /** Name to display in the UI for this facet */
  displayName: Scalars['String'],
  /** Internal name that should be provided back to FacetSelection.name when selecting facet values */
  name: Scalars['String'],
  /** 
 * Alias for this facet if one exist. Aliases provide a semi user friendly name that can be used
   * in the urls for example.
 **/
  alias?: Maybe<Scalars['String']>,
  /** Facet buckets */
  buckets: Array<IndividualBucketedDisplayFacet>,
};

/** Display facet for buckets with range values */
export type BucketedRangeDisplayFacet = DisplayFacet & {
   __typename: 'BucketedRangeDisplayFacet',
  /** Name to display in the UI for this facet */
  displayName: Scalars['String'],
  /** Internal name that should be provided back to FacetSelection.name when selecting facet values */
  name: Scalars['String'],
  /** 
 * Alias for this facet if one exist. Aliases provide a semi user friendly name that can be used
   * in the urls for example.
 **/
  alias?: Maybe<Scalars['String']>,
  /** Facet buckets */
  buckets: Array<IndividualBucketedRangeDisplayFacet>,
};

export type BulkUpdatePayoutPayload = {
   __typename: 'BulkUpdatePayoutPayload',
  results: Array<UpdatePayoutPayload>,
};

export type BusinessAccount = {
   __typename: 'BusinessAccount',
  id: Scalars['BusinessAccountId'],
  name: Scalars['String'],
  merchant?: Maybe<Merchant>,
};


export type BusinessUser = {
   __typename: 'BusinessUser',
  /** 
 * This needs to AnyId instead of BusinessUserId since it is used with other identity objects such as User
   * in a few union type.  Graphql will complain if the same field return different types
 **/
  id: Scalars['AnyId'],
  facetValue: Scalars['String'],
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  displayName: Scalars['String'],
  shortName: Scalars['String'],
  user: User,
  contacts: Array<Contact>,
  messagingUserId: Scalars['AnyId'],
  messagingUser: MessagingUser,
  permissions: Array<Permission>,
  roles: Array<Scalars['String']>,
  isExpert: Scalars['Boolean'],
  isOverloaded: Scalars['Boolean'],
  expertAttributes: BusinessUserExpertAttributes,
  expertProfile?: Maybe<ExpertProfile>,
  presence: PresenceStatus,
  active: Scalars['Boolean'],
  state: BusinessUserState,
  team?: Maybe<BusinessUserTeam>,
  profileUrl: Scalars['String'],
  /** 
 * This might be null because not all the expert are eligible for referral. For example, pending experts don't have
   * vanity id and are not eligible for referral
 **/
  referralUrl?: Maybe<Scalars['String']>,
  profileSetupUrl: Scalars['String'],
  profileShareUrl: Scalars['String'],
  consumerReviewUrl: Scalars['String'],
  assignedAddresses: Array<ChannelAddress>,
  assignedAddress?: Maybe<Scalars['String']>,
  department: Department,
  existingLeadForConsumer?: Maybe<Lead>,
  featured: Scalars['Boolean'],
  spotlightExpert: Scalars['Boolean'],
  contactCardUrl: Scalars['String'],
  deactivated: Scalars['Boolean'],
  performance?: Maybe<ExpertPerformance>,
  timeZone: Scalars['String'],
  zoneId: Scalars['String'],
  internal: Scalars['Boolean'],
  activeOrPendingAwayAutoReply?: Maybe<AwayAutoReply>,
  expertPresence: ExpertPresence,
  consumerExpertReviewConnection: ConsumerExpertReviewConnection,
  vanityId?: Maybe<Scalars['String']>,
  expertStats?: Maybe<ExpertStats>,
  expertApplicationReviewEnabled: Scalars['Boolean'],
  expertApplication?: Maybe<ExpertApplication>,
  activityConnection: BusinessUserActivityConnection,
  payStructure?: Maybe<PayStructure>,
  schedulingUser?: Maybe<SchedulingUser>,
  schedulingDepartment?: Maybe<SchedulingDepartment>,
  skiTripExpert: Scalars['Boolean'],
};


export type BusinessUserAssignedAddressArgs = {
  type: MessagingChannelType
};


export type BusinessUserConsumerExpertReviewConnectionArgs = {
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type BusinessUserActivityConnectionArgs = {
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};

export type BusinessUserActivity = {
  id: Scalars['BusinessUserActivityId'],
  type: BusinessUserActivityType,
  occurredAt: Scalars['Date'],
};

export type BusinessUserActivityConnection = {
   __typename: 'BusinessUserActivityConnection',
  edges: Array<BusinessUserActivityEdge>,
  pageInfo: PageInfo,
};

export type BusinessUserActivityEdge = {
   __typename: 'BusinessUserActivityEdge',
  node: BusinessUserActivity,
  cursor: Scalars['String'],
};


export enum BusinessUserActivityType {
  START_RECEIVING_LEADS = 'START_RECEIVING_LEADS',
  STOP_RECEIVING_LEADS = 'STOP_RECEIVING_LEADS',
  START_ON_CALL = 'START_ON_CALL',
  STOP_ON_CALL = 'STOP_ON_CALL'
}

export type BusinessUserExpertAttributes = {
   __typename: 'BusinessUserExpertAttributes',
  categories: Array<Category>,
  category: Category,
  specialtyCategory?: Maybe<Category>,
  acceptRequestMode: AcceptRequestMode,
  newMessageNotificationMode: ExpertNewMessageNotificationMode,
  maxActivationDurationInMinutes?: Maybe<Scalars['Int']>,
  assistExpert: Scalars['Boolean'],
  placeholderExpert: Scalars['Boolean'],
  onCallExpert: Scalars['Boolean'],
  acceptingNewRequests: Scalars['Boolean'],
  broadcastLeadClaimDisabled: Scalars['Boolean'],
};


export enum BusinessUserState {
  ACTIVE = 'ACTIVE',
  DEACTIVATING = 'DEACTIVATING',
  DEACTIVATED = 'DEACTIVATED',
  PENDING = 'PENDING'
}

export type BusinessUserTeam = {
   __typename: 'BusinessUserTeam',
  id: Scalars['BusinessUserTeamId'],
  department: Department,
  name: Scalars['String'],
  members: Array<BusinessUser>,
  leaders: Array<BusinessUser>,
};


export type CallActivity = {
   __typename: 'CallActivity',
  id: Scalars['CallActivityId'],
  fromNumber: Scalars['String'],
  toNumber: Scalars['String'],
  forwardedToNumber?: Maybe<Scalars['String']>,
  callee: CallParticipant,
  caller?: Maybe<CallParticipant>,
  calledAt: Scalars['Date'],
  durationInSeconds?: Maybe<Scalars['Int']>,
  status: CallStatus,
  type: CallType,
};

export type CallActivityConnection = {
   __typename: 'CallActivityConnection',
  edges: Array<CallActivityEdge>,
  pageInfo: PageInfo,
};

export type CallActivityEdge = {
   __typename: 'CallActivityEdge',
  node: CallActivity,
  cursor: Scalars['String'],
};

export type CallActivityFilterInput = {
  expertId: Scalars['BusinessUserId'],
  from?: Maybe<Scalars['Date']>,
  to?: Maybe<Scalars['Date']>,
};


export type CallParticipant = BusinessUser | User;

export enum CallStatus {
  QUEUED = 'QUEUED',
  INITIATED = 'INITIATED',
  RINGING = 'RINGING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  BUSY = 'BUSY',
  NO_ANSWER = 'NO_ANSWER',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  OTHER = 'OTHER'
}

export enum CallType {
  EXPERT_TO_CONSUMER = 'EXPERT_TO_CONSUMER',
  CONSUMER_TO_EXPERT = 'CONSUMER_TO_EXPERT'
}

export type Campaign = LeadCampaign;

export type CampaignRecipient = {
   __typename: 'CampaignRecipient',
  id: Scalars['LeadCampaignRecipientId'],
  lead: Lead,
  campaign: LeadCampaign,
};

export type CancelExpertApplicationSnoozeInput = {
  applicationId: Scalars['ExpertApplicationId'],
};

export type CancelLeadSnoozeInput = {
  leadId: Scalars['LeadId'],
};

export type CancelOrderRefundInput = {
  orderRefundId: Scalars['OrderRefundId'],
};

export type CancelPaymentRequestForOrderInput = {
  orderId: Scalars['OrderId'],
  /** The unique id or token on the external platform that was used for initiating the Payment Authorization process. */
  paymentProcessorPlatformSourceId: Scalars['String'],
  paymentProcessorType: PaymentProcessorType,
};

export type CancelPaymentRequestForOrderPayload = {
   __typename: 'CancelPaymentRequestForOrderPayload',
  order: Order,
};

export type CancelScheduledLeadCampaignInput = {
  id: Scalars['LeadCampaignId'],
};

export type CancelSubmittedOrderInput = {
  orderId: Scalars['OrderId'],
};

export type CancelSubmittedOrderPayload = {
   __typename: 'CancelSubmittedOrderPayload',
  order: Order,
};

export enum CardFieldValidationStatus {
  PASS = 'PASS',
  FAIL = 'FAIL',
  UNAVAILABLE = 'UNAVAILABLE',
  UNCHECKED = 'UNCHECKED'
}

export enum CardFundingType {
  UNKNOWN = 'UNKNOWN',
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
  PREPAID = 'PREPAID'
}

export enum CartSyncUseCase {
  /** Syncing to display the cart */
  CART_VIEW = 'CART_VIEW',
  /** Syncing to display during the checkout flow */
  CHECKOUT = 'CHECKOUT'
}

export type CategoriesConnection = {
   __typename: 'CategoriesConnection',
  edges: Array<CategoriesEdge>,
  pageInfo?: Maybe<PageInfo>,
};

export type CategoriesEdge = {
   __typename: 'CategoriesEdge',
  node: Category,
  cursor: Scalars['String'],
};

export type Category = {
   __typename: 'Category',
  id: Scalars['CategoryId'],
  name: Scalars['String'],
  singularDisplayName: Scalars['String'],
  pluralDisplayName: Scalars['String'],
  type: CategoryType,
  slug: Scalars['String'],
  /** 
 * Parent categories listed in order of root to this category.
   * (e.g.: ["Product", "Winter Sports", "Skiing"] if this category is "Skis")
   * Args: last - depth of the parent hierarchy to walk up the hierarchy chain.
   * For example if the category was "Skis", last = 1 will return the parent ["Skiing'], last = 2 will return
   * the parent and grandparent, ["Winter Sports", "Skiing"]
 **/
  parents: Array<Category>,
  /** 
 * Builds a list of children of the requested Category.
   * 
   * If recursive it finds all children in the Category Hierarchy that are flattened into a single list
 **/
  children: Array<Category>,
  /** List of all brands associated with this category */
  brands: Array<Brand>,
  /** Addresses of all Merchants's associated with this Category if its of CategoryType SERVICE */
  serviceLocations: Array<SellableServiceLocation>,
  /** The category itself or its ancestor which has a path defined */
  ancestorWithPath?: Maybe<Category>,
  /** browse url.  null if the category is not list or has no slug */
  browseUrl?: Maybe<Scalars['String']>,
  /** start path url. null if the category is not listed or has no slug */
  startPathUrl?: Maybe<Scalars['String']>,
  /** Experts assigned to this or parent categories */
  experts: Array<BusinessUser>,
  expertCategories: Array<Category>,
  contentAssets: CategoryContentAssets,
  accessory: Scalars['Boolean'],
  department?: Maybe<Department>,
  /** 
 * Get sellable search facets associated with this category, by default only brands and first primary attribute
   * of the category are returned as facets. Additionally, it excludes out of stock sellables when building the facets.
 **/
  sellableSearchFacets: Array<DisplayFacetSelection>,
  recommendExpertForConsumer: RecommendExpertPayload,
};


export type CategoryParentsArgs = {
  last?: Maybe<Scalars['Int']>
};


export type CategoryChildrenArgs = {
  recurse?: Maybe<Scalars['Boolean']>
};


export type CategoryBrandsArgs = {
  activeOnly?: Maybe<Scalars['Boolean']>
};


export type CategoryServiceLocationsArgs = {
  displayType?: Maybe<SellableServiceLocationDisplayType>
};


export type CategoryExpertsArgs = {
  limit?: Maybe<Scalars['Int']>
};


export type CategorySellableSearchFacetsArgs = {
  query: CategorySellableSearchFacetQuery
};

export type CategoryContentAssets = {
   __typename: 'CategoryContentAssets',
  bannerImages: Array<ContentAsset>,
  posterImages: Array<ContentAsset>,
  fixedBarDesktop?: Maybe<ContentAsset>,
  fullPageTakeover?: Maybe<ContentAsset>,
  communityPoster?: Maybe<ContentAsset>,
  modalHeader?: Maybe<ContentAsset>,
  callout?: Maybe<ContentAsset>,
};

export type CategoryGroupedBrandStatsAggregateExpertReport = {
   __typename: 'CategoryGroupedBrandStatsAggregateExpertReport',
  id: Scalars['DepartmentId'],
  department: Department,
  departmentStats: Array<BrandStatsAggregateExpertReport>,
  categories: Array<SingleCategoryGroupedBrandStatsAggregateExpertReport>,
};


export type CategoryGroupedBrandStatsAggregateExpertReportDepartmentStatsArgs = {
  limit?: Maybe<Scalars['Int']>
};


export type CategoryGroupedBrandStatsAggregateExpertReportCategoriesArgs = {
  limit?: Maybe<Scalars['Int']>
};


export type CategorySellableSearchFacetQuery = {
  sellableSearchUseCase?: Maybe<SellableSearchUseCase>,
  facetFilters?: Maybe<Array<SellableSearchFacetsQueryFilter>>,
  maxFacets?: Maybe<Scalars['Int']>,
  maxFacetTerms?: Maybe<Scalars['Int']>,
  expandToChildCategories?: Maybe<Scalars['Boolean']>,
};

export enum CategoryType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE'
}

export enum ChallengeType {
  OTP = 'OTP',
  PASSWORD = 'PASSWORD'
}

export type ChangePasswordInput = {
  oldPassword: Scalars['String'],
  newPassword: Scalars['String'],
  refreshToken?: Maybe<Scalars['String']>,
};

export type ChangePasswordPayload = EncodedAuthenticationTokensPayload & {
   __typename: 'ChangePasswordPayload',
  result: AuthenticationResult,
  message?: Maybe<Scalars['String']>,
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

export type ChannelAddress = {
   __typename: 'ChannelAddress',
  type: MessagingChannelType,
  address: Scalars['String'],
};

export type ChannelTemplate = {
  channelType: ChannelType,
};

export enum ChannelType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  INAPP = 'INAPP',
  FACEBOOK = 'FACEBOOK',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION',
  SLACK = 'SLACK'
}

export type ChargeInfoInput = {
  paymentSourceChargeAmount: MonetaryAmountInput,
  paymentProcessorPlatformSourceId: Scalars['String'],
  paymentSourceType: PaymentProcessorType,
  paymentSourceUsage: PaymentSourceUsage,
  billingAddress?: Maybe<AddressInput>,
};

export type CheckedOnReturnLabelFromMerchantInput = {
  ticketId: Scalars['TicketId'],
};

export type CheckoutStartedUserActivity = UserActivity & {
   __typename: 'CheckoutStartedUserActivity',
  id: Scalars['UserActivityId'],
  userId: Scalars['UserId'],
  type: UserActivityType,
  occurredAt: Scalars['Date'],
};

export type ClaimConsumerReferralUserSourceInput = {
  requestingConsumerId: Scalars['UserId'],
  referrerEmail?: Maybe<Scalars['String']>,
  referrerPhone?: Maybe<Scalars['String']>,
};

export type ClaimConsumerReferralUserSourcePayload = {
   __typename: 'ClaimConsumerReferralUserSourcePayload',
  updateUserSourceResult: UpdateUserSourceToConsumerReferralResult,
  claimReferralPromotionResult?: Maybe<ClaimPromotionPayload>,
};

export type ClaimOrderLineItemInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
  merchantId: Scalars['MerchantId'],
  merchantQuote?: Maybe<MonetaryAmountInput>,
  merchantOrderId?: Maybe<Scalars['String']>,
  merchantEta?: Maybe<Scalars['Date']>,
  merchantMaxEta?: Maybe<Scalars['Date']>,
  merchantTax?: Maybe<MonetaryAmountInput>,
  merchantShippingCost?: Maybe<MonetaryAmountInput>,
};

export type ClaimOrderLineItemPayload = {
   __typename: 'ClaimOrderLineItemPayload',
  order: Order,
};

export enum ClaimPromotionErrorCode {
  NOT_FIRST_PURCHASE = 'NOT_FIRST_PURCHASE',
  NO_PROMOTION_FOUND = 'NO_PROMOTION_FOUND',
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED'
}

export type ClaimPromotionPayload = {
   __typename: 'ClaimPromotionPayload',
  promotion?: Maybe<Promotion>,
  hasError: Scalars['Boolean'],
  errorCode?: Maybe<ClaimPromotionErrorCode>,
  errorMessage?: Maybe<Scalars['String']>,
};

export type CloseExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'],
};

export type CloseExpertCuratedOrderPayload = {
   __typename: 'CloseExpertCuratedOrderPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

export type CloseTicketInput = {
  ticketId: Scalars['TicketId'],
};

export type CommTemplateDataModelInput = {
  templateTypeId: Scalars['CommTemplateTypeId'],
  variables: Array<RenderCommTemplateVariableInput>,
};

export type CommTemplateDataModelPayload = {
   __typename: 'CommTemplateDataModelPayload',
  error?: Maybe<Scalars['String']>,
  dataJson?: Maybe<Scalars['String']>,
};

export type CommTemplateDirective = {
   __typename: 'CommTemplateDirective',
  name: Scalars['String'],
  displayName: Scalars['String'],
  parameters: Array<TemplateFragmentParameter>,
};

export type CommTemplateFilter = {
  state?: Maybe<TemplateState>,
};

export type CommTemplateFragment = {
   __typename: 'CommTemplateFragment',
  id: Scalars['CommTemplateFragmentId'],
  active: Scalars['Boolean'],
  state: TemplateState,
  historyId: Scalars['CommTemplateFragmentVersionHistoryId'],
  versionNumber: Scalars['Int'],
  name: Scalars['String'],
  title: Scalars['String'],
  description: Scalars['String'],
  content: Scalars['String'],
  usage?: Maybe<Scalars['String']>,
  updatedAt: Scalars['Date'],
  pendingDraft?: Maybe<CommTemplateFragment>,
  changes: Array<TemplateChange>,
  type: TemplateFragmentType,
  nestedContentAllowed: Scalars['Boolean'],
  nestedContentExample?: Maybe<Scalars['String']>,
  parameters: Array<TemplateFragmentParameter>,
};

export type CommTemplateFragmentFilter = {
  state?: Maybe<TemplateState>,
  type?: Maybe<TemplateFragmentType>,
};




export type CommTemplateQueryVariable = {
   __typename: 'CommTemplateQueryVariable',
  name: Scalars['String'],
  type: Scalars['String'],
};

export type CommTemplateType = {
   __typename: 'CommTemplateType',
  id: Scalars['CommTemplateTypeId'],
  name: Scalars['String'],
  displayName: Scalars['String'],
  group: TemplateTypeGroup,
  groupName: Scalars['String'],
  unsubscribeTag?: Maybe<MessageUnsubscribeTag>,
  entityName: Scalars['String'],
  description: Scalars['String'],
  templates: Array<MultiLocaleTemplateSet>,
  requiredChannels: Array<ChannelType>,
  queryVariables: Array<CommTemplateQueryVariable>,
  experimentSupported: Scalars['Boolean'],
  categorySupported: Scalars['Boolean'],
  categoryTypeRequired: Scalars['Boolean'],
  activeTemplateCount: Scalars['Int'],
  internal: Scalars['Boolean'],
  hardcoded: Scalars['Boolean'],
  richCardType?: Maybe<MessageRichCardType>,
  optionalChannelSupported: Scalars['Boolean'],
  dataModel: TemplateDataModel,
};


export type CommTemplateTypeTemplatesArgs = {
  state?: Maybe<TemplateState>,
  categoryId?: Maybe<Scalars['CategoryId']>
};

export type CommTemplateTypeFilter = {
  internal?: Maybe<Scalars['Boolean']>,
  hardcoded?: Maybe<Scalars['Boolean']>,
};



export type CompleteEscalationInput = {
  escalationId: Scalars['OrderEscalationId'],
};

export type CompleteLeadSupportTaskAssignLeadActionsInput = {
  supportTaskId: Scalars['SupportTaskId'],
  actions: Array<SuggestedActionType>,
};

export type CompleteLeadSupportTaskAssignLeadActionsPayload = {
   __typename: 'CompleteLeadSupportTaskAssignLeadActionsPayload',
  supportTask: LeadSupportTask,
};

export type CompleteLeadSupportTaskDelegateLeadInput = {
  supportTaskId: Scalars['SupportTaskId'],
  expertId: Scalars['BusinessUserId'],
};

export type CompleteLeadSupportTaskDelegateLeadPayload = {
   __typename: 'CompleteLeadSupportTaskDelegateLeadPayload',
  supportTask: LeadSupportTask,
};

export type CompleteLeadSupportTaskEscalateForReassignmentInput = {
  supportTaskId: Scalars['SupportTaskId'],
};

export type CompleteLeadSupportTaskEscalateForReassignmentPayload = {
   __typename: 'CompleteLeadSupportTaskEscalateForReassignmentPayload',
  supportTask: LeadSupportTask,
};

export type CompleteLeadSupportTaskEscalateToTeamForDelegationInput = {
  supportTaskId: Scalars['SupportTaskId'],
};

export type CompleteLeadSupportTaskEscalateToTeamForDelegationPayload = {
   __typename: 'CompleteLeadSupportTaskEscalateToTeamForDelegationPayload',
  supportTask: LeadSupportTask,
};

export type CompleteLeadSupportTaskReassignLeadInput = {
  supportTaskId: Scalars['SupportTaskId'],
  expertId: Scalars['BusinessUserId'],
};

export type CompleteLeadSupportTaskReassignLeadPayload = {
   __typename: 'CompleteLeadSupportTaskReassignLeadPayload',
  supportTask: LeadSupportTask,
};

export type CompleteLeadSupportTaskRequestOrderSupportInput = {
  supportTaskId: Scalars['SupportTaskId'],
  note: Scalars['String'],
};

export type CompleteLeadSupportTaskRequestOrderSupportPayload = {
   __typename: 'CompleteLeadSupportTaskRequestOrderSupportPayload',
  supportTask: LeadSupportTask,
};

export type CompleteSupportTaskNoActionNeededInput = {
  supportTaskId: Scalars['SupportTaskId'],
};

export type CompleteSupportTaskNoActionNeededPayload = {
   __typename: 'CompleteSupportTaskNoActionNeededPayload',
  error?: Maybe<Scalars['String']>,
  supportTask?: Maybe<SupportTask>,
};

export type CompleteSupportTaskSnoozeInput = {
  supportTaskId: Scalars['SupportTaskId'],
  wakeAt: Scalars['Date'],
};

export type CompleteSupportTaskSnoozePayload = {
   __typename: 'CompleteSupportTaskSnoozePayload',
  supportTask: SupportTask,
};

export type ConditionDefinition = {
  type: ConditionType,
};

export type ConditionDefinitionInput = {
  type: ConditionType,
  subjectIdIn?: Maybe<SubjectIdInConditionDefinitionInput>,
};

export enum ConditionType {
  ALWAYS_TRUE = 'ALWAYS_TRUE',
  SUBJECT_ID_IN = 'SUBJECT_ID_IN'
}

export type Config = {
   __typename: 'Config',
  id: Scalars['ConfigEntryId'],
  domain: Scalars['String'],
  key: Scalars['String'],
  value?: Maybe<Scalars['String']>,
};

export type ConfigDomain = {
   __typename: 'ConfigDomain',
  name: Scalars['String'],
  displayName: Scalars['String'],
};


export type ConfirmedReturnShippingLabelSentActivity = OrderActivityDetail & {
   __typename: 'ConfirmedReturnShippingLabelSentActivity',
  type: OrderActivityDetailType,
  confirmedBy: Operator,
  orderRefund: OrderRefund,
};

export type ConfirmReturnShippingLabelSentInput = {
  ticketId: Scalars['TicketId'],
};

export type ConsumerCalledActivity = LeadActivity & {
   __typename: 'ConsumerCalledActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  performedBy: Identity,
};

export type ConsumerExpertReview = {
   __typename: 'ConsumerExpertReview',
  id: Scalars['ConsumerExpertReviewId'],
  expert: BusinessUser,
  /** only admin have access to this */
  consumer: User,
  active: Scalars['Boolean'],
  rating: Scalars['Int'],
  headline?: Maybe<Scalars['String']>,
  comments?: Maybe<Scalars['String']>,
  goodQualities: Array<Scalars['String']>,
  createdAt: Scalars['Date'],
  reviewedAt: Scalars['Date'],
  consumerName?: Maybe<Scalars['String']>,
  consumerLocation?: Maybe<Scalars['String']>,
  source: ConsumerReviewSource,
  verifiedPurchases: Array<Sellable>,
  featured: Scalars['Boolean'],
  spotlight: Scalars['Boolean'],
};


export type ConsumerExpertReviewVerifiedPurchasesArgs = {
  limit?: Maybe<Scalars['Int']>
};

export type ConsumerExpertReviewConnection = {
   __typename: 'ConsumerExpertReviewConnection',
  facets: Array<DisplayFacet>,
  edges: Array<ConsumerExpertReviewEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export type ConsumerExpertReviewEdge = {
   __typename: 'ConsumerExpertReviewEdge',
  node: ConsumerExpertReview,
  cursor: Scalars['String'],
};

export type ConsumerExpertReviewFilter = {
  source?: Maybe<ConsumerReviewSource>,
  rating?: Maybe<Scalars['Int']>,
};


export type ConsumerFirstMessageSentActivity = LeadActivity & {
   __typename: 'ConsumerFirstMessageSentActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  performedBy: Identity,
};

export enum ConsumerInitialLeadAction {
  BROWSE = 'BROWSE',
  CHAT = 'CHAT'
}

export type ConsumerRefundTicket = TicketDetail & {
   __typename: 'ConsumerRefundTicket',
  type: TicketType,
  consumer: User,
  order: Order,
  orderRefund: OrderRefund,
};

export type ConsumerReviewAddedActivity = LeadActivity & {
   __typename: 'ConsumerReviewAddedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  rating: Scalars['Int'],
  headline?: Maybe<Scalars['String']>,
  comments?: Maybe<Scalars['String']>,
  goodQualities: Array<Scalars['String']>,
  performedBy: Identity,
};

export type ConsumerReviewSearchQuery = {
  expertIds?: Maybe<Array<Scalars['BusinessUserId']>>,
  departmentIds?: Maybe<Array<Scalars['DepartmentId']>>,
  facetedSearch?: Maybe<Scalars['Boolean']>,
  facets?: Maybe<Array<FacetSelection>>,
};

export enum ConsumerReviewSearchSort {
  RELEVANCE = 'RELEVANCE',
  REVIEWED_AT = 'REVIEWED_AT'
}

export enum ConsumerReviewSource {
  CURATED = 'CURATED',
  SHOPPER_APPROVED = 'SHOPPER_APPROVED'
}

export type ConsumerSellableReaction = {
   __typename: 'ConsumerSellableReaction',
  id: Scalars['ConsumerSellableReactionId'],
  ratingWithDisplayName: ConsumerSellableReactionRatingWithDisplayName,
  reasonsWithDisplayName: Array<ConsumerSellableReactionReasonWithDisplayName>,
  additionalReason?: Maybe<Scalars['String']>,
  sellable: Sellable,
  systemRecommended: Scalars['Boolean'],
  /** the BusinessUser if it was recommended by an expert */
  recommendedBy?: Maybe<BusinessUser>,
  /** Logical Component on the UI that triggered this reaction */
  reactionSource?: Maybe<ConsumerSellableReactionSource>,
};

export type ConsumerSellableReactionConnection = {
   __typename: 'ConsumerSellableReactionConnection',
  edges: Array<ConsumerSellableReactionEdge>,
  pageInfo: PageInfo,
};

export type ConsumerSellableReactionEdge = {
   __typename: 'ConsumerSellableReactionEdge',
  node: ConsumerSellableReaction,
  cursor: Scalars['String'],
};


export enum ConsumerSellableReactionRating {
  SKIP = 'SKIP',
  DISLIKE = 'DISLIKE',
  LIKE = 'LIKE',
  LOVE = 'LOVE'
}

export type ConsumerSellableReactionRatingStats = {
   __typename: 'ConsumerSellableReactionRatingStats',
  rating: SystemCuratedConsumerSellableReactionRating,
  displayName: Scalars['String'],
  count: Scalars['Int'],
};

export type ConsumerSellableReactionRatingWithDisplayName = {
   __typename: 'ConsumerSellableReactionRatingWithDisplayName',
  rating: ConsumerSellableReactionRating,
  displayName: Scalars['String'],
};

export enum ConsumerSellableReactionReason {
  PRICE = 'PRICE',
  BRAND = 'BRAND',
  STYLE = 'STYLE',
  FEATURES = 'FEATURES'
}

export type ConsumerSellableReactionReasonWithDisplayName = {
   __typename: 'ConsumerSellableReactionReasonWithDisplayName',
  reason: ConsumerSellableReactionReason,
  displayName: Scalars['String'],
};

export type ConsumerSellableReactionRecommendationSourceInput = {
  expertCuratedItemId?: Maybe<Scalars['ExpertCuratedItemId']>,
  recommendedListDefinitionId?: Maybe<Scalars['RecommendedListDefinitionId']>,
  systemCuratedItemId?: Maybe<Scalars['SystemCuratedItemId']>,
};

export enum ConsumerSellableReactionSource {
  SYSTEM_CURATED_ITEM_SURVEY = 'SYSTEM_CURATED_ITEM_SURVEY',
  FAVORITES_PAGE = 'FAVORITES_PAGE',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  PRODUCT_DETAILS = 'PRODUCT_DETAILS'
}

export type ConsumerSellableReactionsQuery = {
  /** The user whose reviews are needed */
  reviewedBy: Scalars['UserId'],
  /** Reactions for specific sellables by a user */
  sellableIds?: Maybe<Array<Scalars['SellableId']>>,
  /** Reactions for sellables recommended by the specified Expert Id */
  recommendedBy?: Maybe<Scalars['BusinessUserId']>,
  /** Reactions for specific department by user */
  departmentId?: Maybe<Scalars['DepartmentId']>,
  /** Reactions for specific categories by user */
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
};

export type Contact = {
   __typename: 'Contact',
  id: Scalars['ContactId'],
  type: ContactType,
  value: Scalars['String'],
  /** The value as email address, if type is EMAIL */
  emailAddress?: Maybe<Scalars['String']>,
  /** The value as phone number, if type is PHONE */
  phoneNumber?: Maybe<Scalars['String']>,
  parsedPhoneNumber?: Maybe<ParsedPhoneNumber>,
  verified: Scalars['Boolean'],
};


export type ContactPrivacyMetadata = PathFlowPageMetadata & {
   __typename: 'ContactPrivacyMetadata',
  type: PathFlowPageMetadataType,
};

export type ContactTcpaComplianceMetadata = PathFlowPageMetadata & {
   __typename: 'ContactTCPAComplianceMetadata',
  type: PathFlowPageMetadataType,
};

export enum ContactType {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  FACEBOOK = 'FACEBOOK',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION'
}

export type ContentAsset = {
   __typename: 'ContentAsset',
  title: Scalars['String'],
  url: Scalars['String'],
  mimeType: Scalars['String'],
  imageUrl?: Maybe<Scalars['String']>,
};

export type ContentBooleanValue = {
   __typename: 'ContentBooleanValue',
  booleanValue: Scalars['Boolean'],
};

export type ContentFloatValue = {
   __typename: 'ContentFloatValue',
  floatValue: Scalars['Float'],
};

export type ContentIntValue = {
   __typename: 'ContentIntValue',
  intValue: Scalars['Int'],
};

export type ContentObject = {
   __typename: 'ContentObject',
  entries: Array<ContentObjectEntry>,
};

export type ContentObjectEntry = {
   __typename: 'ContentObjectEntry',
  key: Scalars['String'],
  value: ContentValue,
};

export type ContentStringValue = {
   __typename: 'ContentStringValue',
  stringValue: Scalars['String'],
};

export type ContentValue = ContentBooleanValue | ContentStringValue | ContentIntValue | ContentFloatValue | ContentAsset | ContentValueArray | ContentObject;

export type ContentValueArray = {
   __typename: 'ContentValueArray',
  values: Array<ContentValue>,
};

export type Conversation = {
   __typename: 'Conversation',
  id: Scalars['ConversationId'],
  externalId: Scalars['String'],
  title: Scalars['String'],
  active: Scalars['Boolean'],
  participants: Array<MessagingUser>,
  unreadCount: Scalars['Int'],
  lead?: Maybe<Lead>,
  owner?: Maybe<MessagingUser>,
  message: Message,
};


export type ConversationUnreadCountArgs = {
  participantId: Scalars['AnyId']
};


export type ConversationMessageArgs = {
  id?: Maybe<Scalars['String']>
};


export type ConversationMessagePart = {
   __typename: 'ConversationMessagePart',
  type: Scalars['String'],
  body: Scalars['String'],
};

export type ConversationMessagePartInput = {
  type: Scalars['String'],
  body: Scalars['String'],
};

export type ConversationMetrics = {
   __typename: 'ConversationMetrics',
  initialSentAt?: Maybe<Scalars['Date']>,
  firstManualMessageSentAt?: Maybe<Scalars['Date']>,
  lastSentAt?: Maybe<Scalars['Date']>,
  lastManualMessageSentAt?: Maybe<Scalars['Date']>,
  messageCount?: Maybe<Scalars['Int']>,
  manualMessageCount?: Maybe<Scalars['Int']>,
  unreadMessageCount?: Maybe<Scalars['Int']>,
  lastMessageSummary?: Maybe<MessageSummary>,
};

export type CopyFlightPlanAsDraftInput = {
  id: Scalars['FlightPlanId'],
};

export type CopyFlightPlanAsDraftPayload = {
   __typename: 'CopyFlightPlanAsDraftPayload',
  flightPlan: FlightPlan,
};

export type CopyFromExpertCuratedItemsInput = {
  leadId: Scalars['LeadId'],
  /** Suggested ExpertCuratedItemId's used to copy data into the new ExpertCuratedItem */
  sourceExpertCuratedItemIds: Array<Scalars['ExpertCuratedItemId']>,
  shouldAddToCartOnActive?: Maybe<Scalars['Boolean']>,
  /** Relevance metadata passed in the SuggestedExpertCuratedItems response if this */
  suggestExpertCuratedItemRelevanceMetadata?: Maybe<Scalars['String']>,
  /** 
 * If this expert curated item is being built from a Suggested alternative
   * sellable, the id of the SuggestedAlternativeSellable
 **/
  suggestedAlternativeSellableId?: Maybe<Scalars['SuggestedAlternativeSellableId']>,
  /** 
 * If this ExpertCuratedItem is being created from a recommendation, whether to auto fill this with the
   * most popular tag used with the underlying Sellable
 **/
  fillWithMostPopularTag?: Maybe<Scalars['Boolean']>,
  /** 
 * If this ExpertCuratedItem is being created from a recommendation, whether to auto fill this with the
   * most popular note used with the underlying Sellable
 **/
  fillWithMostPopularNote?: Maybe<Scalars['Boolean']>,
};

export type CopyFromExpertCuratedItemsPayload = {
   __typename: 'CopyFromExpertCuratedItemsPayload',
  expertCuratedItems: Array<ExpertCuratedItem>,
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories,
};

export type CopyItemsFromExpertCuratedOrderInput = {
  sourceId: Scalars['ExpertCuratedOrderId'],
  destinationId: Scalars['ExpertCuratedOrderId'],
};

export type CopyItemsFromExpertCuratedOrderPayload = {
   __typename: 'CopyItemsFromExpertCuratedOrderPayload',
  source: ExpertCuratedOrder,
  destination: ExpertCuratedOrder,
};

export type CopyLeadCampaignInput = {
  id: Scalars['LeadCampaignId'],
};

export type CopyPromotionInput = {
  id: Scalars['PromotionId'],
};

export type CopyPromotionPayload = {
   __typename: 'CopyPromotionPayload',
  promotion: Promotion,
};

export type CopySchedulingDemandForecastInput = {
  sourceRangeStart: Scalars['Date'],
  sourceRangeEnd: Scalars['Date'],
  schedulingTypeId: Scalars['SchedulingTypeId'],
};

export type CopySchedulingDemandForecastPayload = {
   __typename: 'CopySchedulingDemandForecastPayload',
  hasErrors: Scalars['Boolean'],
  totalCopied: Scalars['Int'],
  error?: Maybe<Scalars['String']>,
};

export type CopyTemplateFragmentInput = {
  id: Scalars['CommTemplateFragmentId'],
};

export type CopyTemplateFragmentPayload = {
   __typename: 'CopyTemplateFragmentPayload',
  fragment: CommTemplateFragment,
};

export type CopyTemplateInput = {
  templateId: Scalars['CommTemplateId'],
};

export type CopyTemplateTypeInput = {
  templateTypeId: Scalars['CommTemplateTypeId'],
  group: TemplateTypeGroup,
  unsubscribeTag?: Maybe<MessageUnsubscribeTag>,
  displayName: Scalars['String'],
  description: Scalars['String'],
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  parameterName: Scalars['String'],
  richCardType?: Maybe<MessageRichCardType>,
  dataModel: TemplateDataModelInput,
};

export type CopyTemplateTypePayload = {
   __typename: 'CopyTemplateTypePayload',
  trigger: Trigger,
  templateType: CommTemplateType,
};

export type Country = {
   __typename: 'Country',
  /** country code, e.g.: "US", "AU", etc */
  countryCode: Scalars['String'],
  /** country display name, e.g.: "United States", "Australia", etc */
  displayCountry: Scalars['String'],
  /** 
 * Depending on country, this will be things like "State", "Territory", "Province", etc. If null, the user shouldn't
   * be prompted for first administrative area
 **/
  displayFirstAdministrativeAreaLabel?: Maybe<Scalars['String']>,
  /** Depending on country, this will be "Zip code", "Postcode", etc */
  displayPostalCodeLabel: Scalars['String'],
  /** Depending on country, this will be "City", "Suburb & City", etc */
  displayCityLabel: Scalars['String'],
  /** 
 * First administrative area corresponds to things like states, territories, provinces, etc. See
   * https://en.wikipedia.org/wiki/Administrative_division for more information.
 **/
  firstAdministrativeAreas: Array<AdministrativeArea>,
  /** If we support shipping to addresses in this country */
  shippingSupported: Scalars['Boolean'],
  /** If we support billing address in this country */
  billingSupported: Scalars['Boolean'],
};

export type CountryFilter = {
  shippingSupported?: Maybe<Scalars['Boolean']>,
  billingSupported?: Maybe<Scalars['Boolean']>,
};

export type CreateAdhocSellableFromEBayItemInput = {
  eBayItemId: Scalars['String'],
  categoryId: Scalars['CategoryId'],
};

export type CreateAdhocSellableFromEBayItemPayload = {
   __typename: 'CreateAdhocSellableFromEBayItemPayload',
  sellable: Sellable,
};

export type CreateBlankExpertApplicationInput = {
  userId: Scalars['UserId'],
  departmentId: Scalars['DepartmentId'],
  firstName: Scalars['String'],
  lastName: Scalars['String'],
};

export type CreateBlankExpertApplicationPayload = {
   __typename: 'CreateBlankExpertApplicationPayload',
  error?: Maybe<Scalars['String']>,
  application?: Maybe<ExpertApplication>,
};

export type CreateBusinessAccountInput = {
  merchantId?: Maybe<Scalars['MerchantId']>,
  name: Scalars['String'],
};

export type CreateBusinessAccountPayload = {
   __typename: 'CreateBusinessAccountPayload',
  businessAccount: BusinessAccount,
};

export type CreateBusinessUserInput = {
  departmentId: Scalars['DepartmentId'],
  userId: Scalars['UserId'],
  roles: Array<Scalars['String']>,
  teamId?: Maybe<Scalars['BusinessUserTeamId']>,
};

export type CreateBusinessUserPayload = {
   __typename: 'CreateBusinessUserPayload',
  errors?: Maybe<Array<Scalars['String']>>,
  businessUser?: Maybe<BusinessUser>,
};

export type CreateBusinessUserTeamInput = {
  departmentId: Scalars['DepartmentId'],
  name: Scalars['String'],
};

export type CreateBusinessUserTeamPayload = {
   __typename: 'CreateBusinessUserTeamPayload',
  errors?: Maybe<Array<Scalars['String']>>,
  businessUserTeam?: Maybe<BusinessUserTeam>,
};

export type CreateDealRequestInput = {
  /** To identify what kind of lead we want, we can also use path slug if that's easier */
  categoryId: Scalars['CategoryId'],
  /** These are all the current available params in create path flow input */
  charterLocation?: Maybe<Scalars['String']>,
  charterSpecificDates?: Maybe<Scalars['String']>,
  charterLocalDateRange?: Maybe<DateRangeInput>,
  diamondOrSetting?: Maybe<Scalars['String']>,
  durationRangeHours?: Maybe<LongRangeInput>,
  expertId?: Maybe<Scalars['BusinessUserId']>,
  numGuests?: Maybe<LongRangeInput>,
  partyOccasion?: Maybe<Scalars['String']>,
  priceRangeUSD?: Maybe<LongRangeInput>,
  timeZoneOffsetInMinutes?: Maybe<Scalars['Int']>,
};

export type CreateDealRequestPayload = {
   __typename: 'CreateDealRequestPayload',
  dealRequest?: Maybe<DealRequest>,
  lead?: Maybe<Lead>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type CreateDraftExpertProfileInput = {
  expertId: Scalars['BusinessUserId'],
};

export type CreateDraftGuestConversationSequenceInput = {
  name: Scalars['String'],
};

export type CreateDraftGuestConversationSequencePayload = {
   __typename: 'CreateDraftGuestConversationSequencePayload',
  sequence: GuestConversationSequence,
};

export type CreateDraftPromotionInput = {
  code: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  template?: Maybe<Scalars['Boolean']>,
  usageLimit?: Maybe<Scalars['Int']>,
  expiresAt?: Maybe<Scalars['Date']>,
};

export type CreateDraftPromotionPayload = {
   __typename: 'CreateDraftPromotionPayload',
  promotion: Promotion,
};

export type CreateExperimentInput = {
  name: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  backendOnly?: Maybe<Scalars['Boolean']>,
  treatments: Array<TreatmentDefinitionInput>,
  rules: Array<RuleDefinitionInput>,
};

export type CreateExperimentPayload = {
   __typename: 'CreateExperimentPayload',
  experiment?: Maybe<ExperimentDefinition>,
  errorMessage?: Maybe<Scalars['String']>,
  hasError: Scalars['Boolean'],
};

export type CreateExpertConsultationFeeOrderInput = {
  leadId: Scalars['LeadId'],
  price: MonetaryAmountInput,
};

export type CreateExpertConsultationFeeOrderPayload = {
   __typename: 'CreateExpertConsultationFeeOrderPayload',
  curatedOrder: SimpleCuratedOrder,
};

export type CreateExpertCuratedItemInput = {
  leadId: Scalars['LeadId'],
  sellableId: Scalars['SellableId'],
  priceOverride?: Maybe<MonetaryAmountInput>,
  tag?: Maybe<ExpertCuratedItemTagInput>,
  shouldAddToCartOnActive?: Maybe<Scalars['Boolean']>,
  isBuiltFromRecommendation?: Maybe<Scalars['Boolean']>,
  draftNote?: Maybe<Scalars['String']>,
  noteId?: Maybe<Scalars['ExpertCuratedItemNoteId']>,
  /** If this ExpertCuratedItem is being built from a suggested ExpertCuratedItem, the id of the original ExpertCuratedItem */
  sourceExpertCuratedItemId?: Maybe<Scalars['ExpertCuratedItemId']>,
  /** Relevance metadata passed in the SuggestedExpertCuratedItems listing */
  suggestExpertCuratedItemRelevanceMetadata?: Maybe<Scalars['String']>,
  /** 
 * If this expert curated item is being built from a Suggested alternative
   * sellable, the id of the SuggestedAlternativeSellable
 **/
  suggestedAlternativeSellableId?: Maybe<Scalars['SuggestedAlternativeSellableId']>,
  /** 
 * If this ExpertCuratedItem is being created from a recommendation, whether to auto fill this with the
   * most popular tag used with the underlying Sellable
 **/
  fillWithMostPopularTag?: Maybe<Scalars['Boolean']>,
  /** 
 * If this ExpertCuratedItem is being created from a recommendation, whether to auto fill this with the
   * most popular note used with the underlying Sellable
 **/
  fillWithMostPopularNote?: Maybe<Scalars['Boolean']>,
  fulfillmentNotes?: Maybe<ExpertCuratedItemFulfillmentNotesInput>,
};

export type CreateExpertCuratedItemPayload = {
   __typename: 'CreateExpertCuratedItemPayload',
  expertCuratedItem: ExpertCuratedItem,
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories,
};

export type CreateExpertCuratedOrderInput = {
  /** The parent sellable or child variant - this will discover the child or sibling variants automatically */
  sellableId: Scalars['SellableId'],
  leadId: Scalars['LeadId'],
  serviceStartsAt?: Maybe<Scalars['Date']>,
  availableForPurchaseDurationMinutes?: Maybe<Scalars['Int']>,
  minimumDepositPercent?: Maybe<Scalars['Int']>,
  prepaidIncidentalPercent?: Maybe<Scalars['Int']>,
  fullPaymentDueBeforeServiceStartDays?: Maybe<Scalars['Int']>,
  flightPlanId?: Maybe<Scalars['FlightPlanId']>,
  inPreview?: Maybe<Scalars['Boolean']>,
  expertNote?: Maybe<Scalars['String']>,
  custom?: Maybe<Scalars['Boolean']>,
};

export type CreateExpertCuratedOrderPayload = {
   __typename: 'CreateExpertCuratedOrderPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

export type CreateExpertFromApplicationInput = {
  applicationId: Scalars['ExpertApplicationId'],
};

export type CreateExpertFromApplicationPayload = {
   __typename: 'CreateExpertFromApplicationPayload',
  expert: BusinessUser,
};

export type CreateExpertProfilePayload = {
   __typename: 'CreateExpertProfilePayload',
  expertProfile?: Maybe<ExpertProfile>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type CreateFirebaseTokenInput = {
  messagingUserId: Scalars['AnyId'],
};

export type CreateFirebaseTokenPayload = {
   __typename: 'CreateFirebaseTokenPayload',
  identityToken: Scalars['String'],
};

export type CreateFlightPlanInput = {
  consumerId?: Maybe<Scalars['UserId']>,
  state: FlightPlanState,
  legs?: Maybe<Array<FlightPlanLegUpsertRequestInput>>,
};

export type CreateFlightPlanPayload = {
   __typename: 'CreateFlightPlanPayload',
  flightPlan?: Maybe<FlightPlan>,
  errorCode?: Maybe<FlightPlanEditErrorCode>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type CreateFulfillmentChannelInput = {
  type: FulfillmentChannelType,
  instructions: Scalars['String'],
  name: Scalars['String'],
  instructionsUrl?: Maybe<Scalars['String']>,
  marginPercent?: Maybe<Scalars['Int']>,
  expeditedShippingRates?: Maybe<MonetaryAmountInput>,
  standardDeliveryTime?: Maybe<Scalars['Int']>,
  expeditedDeliveryTime?: Maybe<Scalars['Int']>,
};

export type CreateFulfillmentChannelPayload = {
   __typename: 'CreateFulfillmentChannelPayload',
  fulfillmentChannel: FulfillmentChannel,
};

export type CreateLeadCampaignInput = {
  name: Scalars['String'],
};

export type CreateLeadCampaignPayload = {
   __typename: 'CreateLeadCampaignPayload',
  error?: Maybe<Scalars['String']>,
  campaign?: Maybe<LeadCampaign>,
};

export type CreateLeadCampaignTriggerInput = {
  id: Scalars['LeadCampaignId'],
};

export type CreateLeadNote = {
  leadId: Scalars['LeadId'],
  text: Scalars['String'],
  messageId?: Maybe<Scalars['String']>,
};

export type CreateLeadNotePayload = {
   __typename: 'CreateLeadNotePayload',
  note: SavedLeadNote,
};

export type CreateLeadSurgeInput = {
  categoryId: Scalars['CategoryId'],
  surgeFactor: Scalars['Float'],
};

export type CreateLeadSurgePayload = {
   __typename: 'CreateLeadSurgePayload',
  leadSurge?: Maybe<LeadSurge>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type CreateMediaInput = {
  url: Scalars['String'],
  persist?: Maybe<Scalars['Boolean']>,
};

export type CreateMediaPayload = {
   __typename: 'CreateMediaPayload',
  mediaFile?: Maybe<MediaFile>,
};

export type CreateMerchantInput = {
  name: Scalars['String'],
  email?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  address?: Maybe<PostalAddressInput>,
  reviewRating?: Maybe<Scalars['Int']>,
  googlePlaceId?: Maybe<Scalars['String']>,
  logoUrl?: Maybe<Scalars['String']>,
  socialProfileUrls?: Maybe<Array<Scalars['String']>>,
  longitude?: Maybe<Scalars['Float']>,
  latitude?: Maybe<Scalars['Float']>,
  shippingNotificationsEmail?: Maybe<Scalars['String']>,
  internal?: Maybe<Scalars['Boolean']>,
  estimatedMarginPercent?: Maybe<Scalars['Int']>,
  defaultCurrency?: Maybe<Scalars['String']>,
};

export type CreateMerchantPayload = {
   __typename: 'CreateMerchantPayload',
  merchant: Merchant,
  alreadyExists: Scalars['Boolean'],
};

export type CreateMerchantsPayload = {
   __typename: 'CreateMerchantsPayload',
  merchants?: Maybe<Array<CreateMerchantPayload>>,
};

export type CreateOfferForSelfCheckoutInput = {
  sellableId: Scalars['SellableId'],
};

export type CreateOfferFromSellableInput = {
  leadId?: Maybe<Scalars['LeadId']>,
  sellableId: Scalars['SellableId'],
  expertComments?: Maybe<Scalars['String']>,
  price?: Maybe<Scalars['Float']>,
  tax?: Maybe<Scalars['Float']>,
  shippingCost?: Maybe<Scalars['Float']>,
  freeAddOns?: Maybe<Array<Maybe<OfferAddOnInput>>>,
  productOfferTerms?: Maybe<ProductOfferTermsInput>,
  serviceOfferTerms?: Maybe<ServiceOfferTermsInput>,
};

export type CreateOfferInput = {
  leadId?: Maybe<Scalars['LeadId']>,
  merchantId?: Maybe<Scalars['MerchantId']>,
  price: Scalars['Float'],
  originalPrice?: Maybe<Scalars['Float']>,
  originalPriceSource?: Maybe<Scalars['String']>,
  tax?: Maybe<Scalars['Float']>,
  shippingCost?: Maybe<Scalars['Float']>,
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  imageUrls?: Maybe<Array<Scalars['String']>>,
  videoUrls?: Maybe<Array<Scalars['String']>>,
  expirationDate?: Maybe<Scalars['Date']>,
  comments?: Maybe<Scalars['String']>,
  offerType?: Maybe<BroadcastOfferType>,
  freeAddOns?: Maybe<Array<Maybe<OfferAddOnInput>>>,
  productOfferTerms?: Maybe<ProductOfferTermsInput>,
  serviceOfferTerms?: Maybe<ServiceOfferTermsInput>,
  merchantName?: Maybe<Scalars['String']>,
  merchantImageUrl?: Maybe<Scalars['String']>,
  publicOfferUrl?: Maybe<Scalars['String']>,
  brandId?: Maybe<Scalars['BrandId']>,
  privateOffer?: Maybe<Scalars['Boolean']>,
  dealTemplate?: Maybe<DealTemplateInput>,
  sellableId?: Maybe<Scalars['SellableId']>,
  merchantPostalAddress?: Maybe<PostalAddressInput>,
};

export type CreateOfferPayload = {
   __typename: 'CreateOfferPayload',
  error?: Maybe<Scalars['String']>,
  offer?: Maybe<BroadcastOffer>,
};

export type CreateOperatorsInput = {
  userIds: Array<Scalars['UserId']>,
  active: Scalars['Boolean'],
};

export type CreateOperatorsPayload = {
   __typename: 'CreateOperatorsPayload',
  operators?: Maybe<Array<Operator>>,
};

export type CreateOrderEscalationInput = {
  userId: Scalars['UserId'],
  orderId: Scalars['OrderId'],
  orderLineItemId?: Maybe<Scalars['OrderLineItemId']>,
  leadId?: Maybe<Scalars['LeadId']>,
  type: OrderEscalationType,
  reason?: Maybe<Scalars['String']>,
  dueDate?: Maybe<Scalars['Date']>,
  assignedToId?: Maybe<Scalars['OperatorId']>,
  priority?: Maybe<OrderEscalationPriority>,
};

export type CreateOrderEscalationsPayload = {
   __typename: 'CreateOrderEscalationsPayload',
  orderEscalation: OrderEscalation,
};

export type CreateOrderFromOfferInput = {
  id: Scalars['BroadcastOfferId'],
};

export type CreateOrderFromOfferPayload = {
   __typename: 'CreateOrderFromOfferPayload',
  order: Order,
};

export type CreatePasswordInput = {
  password: Scalars['String'],
};

export type CreatePasswordPayload = EncodedAuthenticationTokensPayload & {
   __typename: 'CreatePasswordPayload',
  success: Scalars['Boolean'],
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

/** 
 * pathSchemaId, pathSchemaSlug, or categorySlug must be specified to locate a path to create. The remaining input is
 * optional, and mostly provided as prefilled information into the path.
 **/
export type CreatePathFlowInput = {
  /** (Primary) If specified, the path will be created from a specific schema id */
  pathSchemaId?: Maybe<Scalars['PathSchemaId']>,
  /** (Secondary) If specified, the path will be created from a specific schema that has this unique slug */
  pathSchemaSlug?: Maybe<Scalars['String']>,
  /** 
 * (Tertiary) If specified, the path will be created through the following process:
   * 1) Assert the category slug is valid, and if so, locate a split experiment in the format of `{categorySlug}-path`.
   *    For example, for "skis" the experiment would be "skis-path".
   * 2) If the variation of the split experiment is not `control`, it is interpreted as a `pathSchemaSlug`, and will
   *    lookup the path by slug.
   * 3) In the case of #2 failing due to the split variation returning "control", this entire process from step 1 will
   *    be retried with the parent category (with the "skis" example, "winter-sports" will be tried next).
   * If there are any errors (including failure to discover) the category, split experiment (all fallback category
   * resolutions fail), or invalid path flow slug specified as the treatment for a split experiment, the path won't be
   * created and an error will be returned.
 **/
  categorySlug?: Maybe<Scalars['String']>,
  charterDurationType?: Maybe<Scalars['String']>,
  charterLocation?: Maybe<Scalars['String']>,
  charterSpecificDates?: Maybe<Scalars['String']>,
  charterLocalDateRange?: Maybe<DateRangeInput>,
  countryCode?: Maybe<Scalars['String']>,
  diamondShape?: Maybe<Scalars['String']>,
  diamondOrSetting?: Maybe<Scalars['String']>,
  durationRangeHours?: Maybe<LongRangeInput>,
  expertCategory?: Maybe<Scalars['String']>,
  expertId?: Maybe<Scalars['BusinessUserId']>,
  expertStarRating?: Maybe<Scalars['Int']>,
  facebookMessengerChecked?: Maybe<Scalars['String']>,
  facebookUserRef?: Maybe<Scalars['String']>,
  flightPlanId?: Maybe<Scalars['FlightPlanId']>,
  flightDepartureCity?: Maybe<Scalars['String']>,
  flightDepartureDate?: Maybe<DateRangeInput>,
  flightArrivalCity?: Maybe<Scalars['String']>,
  flightReturnDate?: Maybe<DateRangeInput>,
  genericRequestCategory?: Maybe<Scalars['String']>,
  jetPassengers?: Maybe<LongRangeInput>,
  jetTripType?: Maybe<Scalars['String']>,
  aircraftType?: Maybe<Scalars['String']>,
  charterCapacity?: Maybe<Scalars['Int']>,
  numGuests?: Maybe<LongRangeInput>,
  partyOccasion?: Maybe<Scalars['String']>,
  phoneNumber?: Maybe<Scalars['String']>,
  priceRangeUSD?: Maybe<LongRangeInput>,
  /** deprecated: ignored.  referrerId is fetched from cookie */
  referrerId?: Maybe<Scalars['UserId']>,
  referredByExpertId?: Maybe<Scalars['BusinessUserId']>,
  settingRingStyle?: Maybe<Scalars['String']>,
  shoppedWithUsBefore?: Maybe<Scalars['String']>,
  timeZoneOffsetInMinutes?: Maybe<Scalars['Int']>,
  viewedSellableIds?: Maybe<Array<Scalars['SellableId']>>,
  zipCode?: Maybe<Scalars['String']>,
  uniqueDeviceId?: Maybe<Scalars['String']>,
  applicationId?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  golfShoppingGoal?: Maybe<Scalars['String']>,
};

export type CreatePathFlowPayload = EncodedAuthenticationTokensPayload & {
   __typename: 'CreatePathFlowPayload',
  /** Either flow will be provided, or a list of validation errors will be provided. */
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
  /** If a new user is registered as part of this path flow page creation */
  newUserRegistered: Scalars['Boolean'],
  /** If a new deal request is created as part of this path flow page creation */
  newRequestCreated: Scalars['Boolean'],
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

export type CreatePaymentSourceInput = {
  paymentProcessorPlatformSourceId: Scalars['String'],
  type: PaymentProcessorType,
  usage?: Maybe<PaymentSourceUsage>,
  billingAddress?: Maybe<AddressInput>,
  isDefault?: Maybe<Scalars['Boolean']>,
};

export type CreatePaymentSourcePayload = {
   __typename: 'CreatePaymentSourcePayload',
  paymentSource: PaymentSource,
};

export type CreatePayStructureInput = {
  name: Scalars['String'],
  description: Scalars['String'],
  departmentId?: Maybe<Scalars['DepartmentId']>,
};

export type CreatePayStructurePayload = {
   __typename: 'CreatePayStructurePayload',
  error?: Maybe<Scalars['String']>,
  payStructure?: Maybe<PayStructure>,
};

export type CreatePayStructureRevisionInput = {
  payStructureId: Scalars['PayStructureId'],
};

export type CreatePendingAccessContactInput = {
  type: ContactType,
  value: Scalars['String'],
  interest: Scalars['String'],
};

export type CreatePendingAccessContactPayload = {
   __typename: 'CreatePendingAccessContactPayload',
  pendingAccessContact: PendingAccessContact,
};

export type CreateQuickReplyInput = {
  name: Scalars['String'],
  text: Scalars['String'],
  leadId?: Maybe<Scalars['LeadId']>,
};

export type CreateQuickReplyPayload = {
   __typename: 'CreateQuickReplyPayload',
  quickReply: QuickReply,
};

export type CreateQuickReplyWithLeadInput = {
  name: Scalars['String'],
  text: Scalars['String'],
  leadId: Scalars['LeadId'],
};

export type CreateQuickReplyWithoutLeadInput = {
  expertId: Scalars['BusinessUserId'],
  name: Scalars['String'],
  text: Scalars['String'],
};

export type CreateRawSellableSourceInput = {
  name: Scalars['String'],
  type: RawSellableSourceType,
  fulfillmentChannelId?: Maybe<Scalars['FulfillmentChannelId']>,
  spider?: Maybe<RawSellableSourceSpiderInput>,
  googleShoppingFeed?: Maybe<RawSellableSourceGoogleShoppingFeedInput>,
  googleShoppingSearch?: Maybe<RawSellableSourceGoogleShoppingSearchInput>,
  levelNineFeed?: Maybe<RawSellableSourceLevelNineFeedInput>,
  shopify?: Maybe<RawSellableSourceShopifyInput>,
};

export type CreateRawSellableSourcePayload = {
   __typename: 'CreateRawSellableSourcePayload',
  source?: Maybe<RawSellableSource>,
  hasError: Scalars['Boolean'],
  errors?: Maybe<Array<Scalars['String']>>,
};

export type CreateRawSellableStandardizationRuleInput = {
  name: Scalars['String'],
  sourceId?: Maybe<Scalars['RawSellableSourceId']>,
  priority: Scalars['Int'],
  condition: RawSellableStandardizationRuleConditionInput,
  actions: Array<RawSellableStandardizationActionInput>,
};

export type CreateRawSellableStandardizationRulePayload = {
   __typename: 'CreateRawSellableStandardizationRulePayload',
  rule?: Maybe<RawSellableStandardizationRule>,
  hasError: Scalars['Boolean'],
  errors?: Maybe<Array<Scalars['String']>>,
};

export type CreateRecommendedListDefinitionInput = {
  /** User friendly name for this recommended list definition */
  name: Scalars['String'],
  /** 
 * The title template that will be used to build the RecommendedList title shown to the consumer.
   * The template should use the freemarker style `${variable}` format for inserting any dynamic values in the resolved title.
   * For example: "Because you like ${attribute.brands}"
   * Note, the querable attributes from the title will be used as a hard filter in the RecommenedList result.
   * For example, if the title said "Because you like
   * ${attribute.brands.displayName}", then the result will only include
   * recommendations
   * that strictly match the brands
 **/
  titleTemplate: Scalars['String'],
  /** 
 * The subtitle template that will be used to build the RecommendedList's subtitle shown to the consumer
   * The template should use the freemarker style `${variable}` format for
   * inserting any dynamic values in the resolved subtitle.
   * This is mainly used to provide some additional context the recommended list
   * and for display purpose only with the resolved string.
 **/
  subTitleTemplate?: Maybe<Scalars['String']>,
  active: Scalars['Boolean'],
  /** 
 * The relative rank of the RecommendedList built using this definition compared to other RecommendedList
   * when the user sees a list of RecommendedList
 **/
  rank: Scalars['Int'],
  /** The categories for which this RecommendedListDefinition is being built. */
  categoryIds: Array<Scalars['CategoryId']>,
  /** The filtering facets to refine recommended list results */
  queryFacets: Array<RecommendedListFacetSelectionInput>,
  /** defaults to relevance based sorting */
  sortOptions: Array<RecommendedListSortOrderInput>,
};

export type CreateRecommendedListDefinitionPayload = {
   __typename: 'CreateRecommendedListDefinitionPayload',
  recommendedListDefinition: RecommendedListDefinition,
};

export type CreateReportInput = {
  title: Scalars['String'],
  /** Must be globally unique if specified */
  internalName?: Maybe<Scalars['String']>,
  query: Scalars['String'],
  columns?: Maybe<Array<ReportColumnInput>>,
  scope: ReportAccessScope,
  /** If specified, the columns from the schema are automatically added to the columns */
  schemaType?: Maybe<ReportSchemaType>,
};

export type CreateSavedExpertCuratedItemsInput = {
  name: Scalars['String'],
  /** Optional description for this curation */
  description?: Maybe<Scalars['String']>,
  /** Expert Curated Items being saved in this curation */
  expertCuratedItemIds: Array<Scalars['ExpertCuratedItemId']>,
  taggedRequestAttributes?: Maybe<Array<AttributeInput>>,
};

export type CreateSavedExpertCuratedItemsPayload = {
   __typename: 'CreateSavedExpertCuratedItemsPayload',
  savedExpertCuratedItems: SavedExpertCuratedItems,
};

export type CreateSchedulingDemandForecastInput = {
  typeId: Scalars['SchedulingTypeId'],
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  maximumShiftUnits: Scalars['BigDecimal'],
  createTestShiftSlots?: Maybe<Scalars['Boolean']>,
};

export type CreateSchedulingDemandForecastPayload = {
   __typename: 'CreateSchedulingDemandForecastPayload',
  error?: Maybe<Scalars['String']>,
  forecast?: Maybe<SchedulingDemandForecast>,
};

export type CreateSchedulingUserAvailabilityInput = {
  userId: Scalars['AnyId'],
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
};

export type CreateSchedulingUserAvailabilityPayload = {
   __typename: 'CreateSchedulingUserAvailabilityPayload',
  error?: Maybe<Scalars['String']>,
  availability?: Maybe<SchedulingUserAvailability>,
};

export type CreateSellableInput = {
  /** Title of the product or service */
  title: Scalars['String'],
  /** Plain text description */
  descriptionText?: Maybe<Scalars['String']>,
  /** 
 * Description in GitHub-flavored Markdown format
   * See https://github.github.com/gfm/
 **/
  descriptionMarkdown?: Maybe<Scalars['String']>,
  /** Categories this sellable is associated with */
  categoryIds: Array<Scalars['CategoryId']>,
  /** If this sellable is a product or service */
  type: SellableType,
  /** 
 * MSRP price of this sellable; omittied if not applicable/available. Note that this is not what the consumer pays for
   * the product on Deal.com; salePrice is the actual price paid for the product.
 **/
  originalPrice?: Maybe<MonetaryAmountInput>,
  /** Price we sell to the consumer for without tax */
  salePrice: MonetaryAmountInput,
  /** Standardized brand this sellable is associated with */
  brandId?: Maybe<Scalars['BrandId']>,
  /** Images for this sellable */
  imageIds?: Maybe<Array<Scalars['MediaId']>>,
  /** 
 * Merchant that provides this service sellable.
   * This is required for sellables of `type` == `SERVICE`, and is prohibited for `PRODUCT`.
 **/
  serviceProviderMerchantId?: Maybe<Scalars['MerchantId']>,
  /** Raw unstructured attributes; simple key value pairs. This will be displayed in the sellable specifications table. */
  rawAttributes?: Maybe<Array<RawAttributeInput>>,
  /** 
 * If this sellable is created ad-hoc for single use (e.g.: created for a single customer).
   * Ad-hoc sellables are not surfaced in search, and are primarily used for experts to sell items we don't have a
   * proper standardized sellable for, but have some means to fulfill.
 **/
  adHoc: Scalars['Boolean'],
};

export type CreateSellablePayload = {
   __typename: 'CreateSellablePayload',
  sellable: Sellable,
};

export type CreateSellableResearchLinkInput = {
  sellableId: Scalars['SellableId'],
  url: Scalars['String'],
};

export type CreateSellableResearchLinkPayload = {
   __typename: 'CreateSellableResearchLinkPayload',
  researchLink: SellableResearchLink,
};

export type CreateSellableTermsInput = {
  orderLineItemId: Scalars['OrderLineItemId'],
  type: SellableType,
  /** Required for Services */
  startAt?: Maybe<Scalars['Date']>,
};

export type CreateSellableTermsPayload = {
   __typename: 'CreateSellableTermsPayload',
  sellableTerms: SellableTerms,
};

export type CreateShiftInput = {
  userId: Scalars['AnyId'],
  shiftSlotId: Scalars['ShiftSlotId'],
};

export type CreateShiftPayload = {
   __typename: 'CreateShiftPayload',
  error?: Maybe<Scalars['String']>,
  shiftSlot?: Maybe<ShiftSlot>,
};

export type CreateSupportTaskActivity = SupportTaskActivity & {
   __typename: 'CreateSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
};

export type CreateTagInput = {
  type: TagType,
  name: Scalars['String'],
};

export type CreateTagPayload = {
   __typename: 'CreateTagPayload',
  errors?: Maybe<Array<Scalars['String']>>,
  tag?: Maybe<Tag>,
};

export type CreateTemplateFragmentInput = {
  name: Scalars['String'],
  title: Scalars['String'],
  description: Scalars['String'],
  type: TemplateFragmentType,
  nestedContentAllowed: Scalars['Boolean'],
};

export type CreateTemplateFragmentPayload = {
   __typename: 'CreateTemplateFragmentPayload',
  fragment?: Maybe<CommTemplateFragment>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type CreateTemplateInput = {
  title: Scalars['String'],
  typeId: Scalars['CommTemplateTypeId'],
  locale?: Maybe<Scalars['String']>,
  categoryId?: Maybe<Scalars['CategoryId']>,
  categoryType?: Maybe<CategoryType>,
  experimentKey?: Maybe<Scalars['String']>,
  treatments?: Maybe<Array<Scalars['String']>>,
  tagSyntax?: Maybe<TemplateTagSyntax>,
};

export type CreateTemplatePayload = {
   __typename: 'CreateTemplatePayload',
  multiLocaleTemplate?: Maybe<MultiLocaleTemplateSet>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type CreateTemplateTypeInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  parameterName: Scalars['String'],
  group: TemplateTypeGroup,
  unsubscribeTag?: Maybe<MessageUnsubscribeTag>,
  displayName: Scalars['String'],
  description: Scalars['String'],
  richCardType?: Maybe<MessageRichCardType>,
  optionalChannelSupported?: Maybe<Scalars['Boolean']>,
  requiredChannels?: Maybe<Array<ChannelType>>,
  dataModel: TemplateDataModelInput,
};

export type CreateTemplateTypePayload = {
   __typename: 'CreateTemplateTypePayload',
  error?: Maybe<Scalars['String']>,
  trigger?: Maybe<Trigger>,
  templateType?: Maybe<CommTemplateType>,
};

export type CreateTriggerInput = {
  name: Scalars['String'],
  groupName: Scalars['String'],
  description: Scalars['String'],
  eventName: Scalars['String'],
};

export type CreateTriggerNodeInput = {
  triggerId: Scalars['TriggerId'],
  type: TriggerNodeType,
  /** if null, the node will be insert as the first element */
  insertAfter?: Maybe<Scalars['TriggerNodeId']>,
  insertAsEdgeType: TriggerNodeEdgeType,
  actionName?: Maybe<Scalars['String']>,
};

export type CreateTriggerPayload = {
   __typename: 'CreateTriggerPayload',
  trigger: Trigger,
};

export type CreateUserInput = {
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  password?: Maybe<Scalars['String']>,
  roles?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type CreateUserPayload = {
   __typename: 'CreateUserPayload',
  user?: Maybe<User>,
  errorCode?: Maybe<UserEditErrorCode>,
  hasError: Scalars['Boolean'],
  errors: Array<Scalars['String']>,
};

export type CurationSummary = {
   __typename: 'CurationSummary',
  lastOfferSentAt?: Maybe<Scalars['Date']>,
  lastCuratedOrderSentAt?: Maybe<Scalars['Date']>,
  lastCuratedItemSentAt?: Maybe<Scalars['Date']>,
  lastOrderCompletedAt?: Maybe<Scalars['Date']>,
  lastCurationSentAt?: Maybe<Scalars['Date']>,
  lastSystemCuratedItemSentAt?: Maybe<Scalars['Date']>,
};


export type CustomerRequestExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'],
};

export type CustomerRequestExpertCuratedOrderPayload = {
   __typename: 'CustomerRequestExpertCuratedOrderPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};


/** ====== DatePathFlowQuestion */
export type DatePathFlowQuestion = PathFlowQuestion & {
   __typename: 'DatePathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  type: DatePathFlowQuestionType,
  /** If reloading a question answered by the user, this is their previous input */
  dateUserInput: SubmitDatePathFlowQuestionInputTypeCopy,
};


/** ====== DatePathFlowQuestion */
export type DatePathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export enum DatePathFlowQuestionType {
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME'
}

export type DateRange = {
   __typename: 'DateRange',
  from?: Maybe<Scalars['Date']>,
  to?: Maybe<Scalars['Date']>,
};

export type DateRangeFilter = {
   __typename: 'DateRangeFilter',
  /** the filter will be ignored if both minDateTime and maxDateTime are null */
  field: DateRangeFilterField,
  displayName: Scalars['String'],
  negativeFilter: Scalars['Boolean'],
  minDateTime?: Maybe<Scalars['Date']>,
  maxDateTime?: Maybe<Scalars['Date']>,
};

export enum DateRangeFilterField {
  LAST_PAID_DATE = 'LAST_PAID_DATE',
  CREATED_DATE = 'CREATED_DATE',
  LAST_ACTIVITY_DATE = 'LAST_ACTIVITY_DATE',
  ORDER_PAID_DATE = 'ORDER_PAID_DATE',
  STARTED_DATE = 'STARTED_DATE',
  COMPLETED_DATE = 'COMPLETED_DATE',
  DUE_DATE = 'DUE_DATE'
}

export type DateRangeFilterInput = {
  minDateTime?: Maybe<Scalars['Date']>,
  maxDateTime?: Maybe<Scalars['Date']>,
  negativeFilter: Scalars['Boolean'],
  field: DateRangeFilterField,
};

export type DateRangeInput = {
  from?: Maybe<Scalars['Date']>,
  to?: Maybe<Scalars['Date']>,
};

/** ====== DateRangePathFlowQuestion */
export type DateRangePathFlowQuestion = PathFlowQuestion & {
   __typename: 'DateRangePathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  startRequired: Scalars['Boolean'],
  endRequired: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  type: DateRangePathFlowQuestionType,
  /** If reloading a question answered by the user, this is their previous input */
  dateRangeUserInput: SubmitDateRangePathFlowQuestionInputTypeCopy,
};


/** ====== DateRangePathFlowQuestion */
export type DateRangePathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export enum DateRangePathFlowQuestionType {
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME'
}

export type DeactivateExpertInput = {
  id: Scalars['BusinessUserId'],
};

export type DeactivateExpertPayload = {
   __typename: 'DeactivateExpertPayload',
  error?: Maybe<Scalars['String']>,
  businessUser: BusinessUser,
};

export type DeactivateGuestConversationSequenceInput = {
  id: Scalars['GuestConversationSequenceId'],
};

export type DeactivateGuestConversationSequencePayload = {
   __typename: 'DeactivateGuestConversationSequencePayload',
  sequence: GuestConversationSequence,
};

export type DeactivateSellableInput = {
  id: Scalars['SellableId'],
  /** If all of the linked variations of the sellable should also be deactivated. Defaults to false. */
  variationHierarchy?: Maybe<Scalars['Boolean']>,
};

export type DeactivateSellablePayload = {
   __typename: 'DeactivateSellablePayload',
  updatedSellableCount: Scalars['Int'],
};

export type DeactivateSellablePriceSourceInput = {
  id: Scalars['SellablePriceSourceId'],
};

export type DeactivateSellablePriceSourcePayload = {
   __typename: 'DeactivateSellablePriceSourcePayload',
  sellablePriceSource: SellablePriceSource,
};

export type DeactivateTemplateFragmentInput = {
  id: Scalars['CommTemplateFragmentId'],
  notes?: Maybe<Scalars['String']>,
};

export type DeactivateTemplateInput = {
  id: Scalars['CommTemplateId'],
  notes?: Maybe<Scalars['String']>,
};

export type DeactivateTriggerInput = {
  triggerId: Scalars['TriggerId'],
  notes?: Maybe<Scalars['String']>,
};

export type DeactivateTriggerPayload = {
   __typename: 'DeactivateTriggerPayload',
  trigger: Trigger,
};

export type Deal = {
   __typename: 'Deal',
  id: Scalars['DealId'],
  category: Category,
  title: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  expiresAt?: Maybe<Scalars['Date']>,
  price: Money,
  originalPrice?: Maybe<Money>,
  originalPriceSource?: Maybe<Scalars['String']>,
  freeAddOns: Array<DealAddOn>,
  images: Array<MediaFile>,
  videos: Array<MediaFile>,
  terms: DealTerms,
  comments?: Maybe<Scalars['String']>,
  brand?: Maybe<Brand>,
  createdBy: DealCreatedByUnion,
  discount?: Maybe<Scalars['Float']>,
  interestedByViewer?: Maybe<Scalars['Boolean']>,
  state: DealState,
  sellable?: Maybe<Sellable>,
};

export type DealAddOn = {
   __typename: 'DealAddOn',
  title: Scalars['String'],
  retailPrice: Money,
};

export type DealCreatedByUnion = Operator | Merchant;


export type DealInventoryClaimedActivity = OrderActivityDetail & {
   __typename: 'DealInventoryClaimedActivity',
  type: OrderActivityDetailType,
  merchant: Merchant,
  fulfilledBy: Operator,
  fulfillmentOrder: FulfillmentOrder,
};

export type DealInventoryFulfillmentOrderCanceledActivity = OrderActivityDetail & {
   __typename: 'DealInventoryFulfillmentOrderCanceledActivity',
  type: OrderActivityDetailType,
  /** operator if known */
  canceledBy?: Maybe<Operator>,
  canceledAt: Scalars['Date'],
  fulfillmentOrder: FulfillmentOrder,
};

export type DealInventoryRawSellableSource = RawSellableSource & {
   __typename: 'DealInventoryRawSellableSource',
  id: Scalars['RawSellableSourceId'],
  name: Scalars['String'],
  type: RawSellableSourceType,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  state: RawSellableSourceState,
};

export type DealInventoryRequestCanceledActivity = OrderActivityDetail & {
   __typename: 'DealInventoryRequestCanceledActivity',
  type: OrderActivityDetailType,
  canceledBy: Operator,
};

export type DealInventoryRequestedActivity = OrderActivityDetail & {
   __typename: 'DealInventoryRequestedActivity',
  type: OrderActivityDetailType,
  fulfillmentCenter: FulfillmentCenter,
  merchant: Merchant,
  fulfilledBy: Operator,
  quantity?: Maybe<Scalars['Int']>,
  fulfillmentShipmentMethod?: Maybe<FulfillmentShipmentMethod>,
  sourceType: FulfillmentOrderSourceType,
};

export type DealInventoryRequestFailedActivity = OrderActivityDetail & {
   __typename: 'DealInventoryRequestFailedActivity',
  type: OrderActivityDetailType,
  merchant: Merchant,
  fulfilledBy: Operator,
  fulfillmentOrder?: Maybe<FulfillmentOrder>,
  failureCode?: Maybe<Scalars['String']>,
  failureReason?: Maybe<Scalars['String']>,
};

export type DealInventorySellablePriceSource = SellablePriceSource & {
   __typename: 'DealInventorySellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  bestOfferPrice?: Maybe<MonetaryAmount>,
  cost?: Maybe<MonetaryAmount>,
  expiresAt?: Maybe<Scalars['Date']>,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  rawSellableSource: RawSellableSource,
  sellableInventoryItem: SellableInventoryItem,
};

export type DealPaymentAccount = PaymentProcessorAccount & {
   __typename: 'DealPaymentAccount',
  id: Scalars['PaymentProcessorAccountId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  type: PaymentProcessorType,
  userId: Scalars['UserId'],
  paymentSources: Array<PaymentSource>,
};

export type DealPaymentSource = PaymentSource & {
   __typename: 'DealPaymentSource',
  id: Scalars['PaymentSourceId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  externalSourceId: Scalars['String'],
  type: PaymentProcessorType,
  usage: PaymentSourceUsage,
  status: PaymentSourceStatus,
  userId: Scalars['UserId'],
  billingAddress?: Maybe<Address>,
  paymentEntity: PaymentEntity,
  isDefault: Scalars['Boolean'],
};

export type DealRequest = {
   __typename: 'DealRequest',
  id: Scalars['DealRequestId'],
  createdAt: Scalars['Date'],
  requester: User,
  createdBy: User,
  updatedAt: Scalars['Date'],
  isActive: Scalars['Boolean'],
  formattedAttributes: Array<FormattedAttribute>,
  attributes: Array<Attribute>,
  inlineFormattedAttributes: Scalars['String'],
  formattedPrimaryAttributes: Array<FormattedAttribute>,
  category?: Maybe<Category>,
  zipCode?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  followUpPathFlow?: Maybe<PathFlow>,
  /** Sellables that were viewed by the user that resulted in this deal request being created */
  viewedSellables: Array<Sellable>,
};

export type DealRequestFilter = {
  requesterId: Scalars['UserId'],
};


export type DealSellablePriceSource = SellablePriceSource & {
   __typename: 'DealSellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  bestOfferPrice?: Maybe<MonetaryAmount>,
  cost?: Maybe<MonetaryAmount>,
  expiresAt?: Maybe<Scalars['Date']>,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
};

export enum DealState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type DealTemplateInput = {
  dealId: Scalars['DealId'],
  /** 
 * If this Offer is created by re-using an existing Deal Template and has
   * updates, whether to propogae them to existnig Deals.
 **/
  updateExistingDeal?: Maybe<Scalars['Boolean']>,
};

export type DealTerms = ProductDealTerms | ServiceDealTerms | EmptyDealTerms;

export enum DealTermsType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE'
}

export type DealUploadTaskPayload = {
   __typename: 'DealUploadTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numDealsCreated: Scalars['Int'],
  numDealsUpdated: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  googleSpreadsheetId: Scalars['String'],
};

export type DeclineVideoChatInput = {
  messagingUserId: Scalars['AnyId'],
  externalConversationId: Scalars['String'],
};

export type DeclineVideoChatPayload = {
   __typename: 'DeclineVideoChatPayload',
  success: Scalars['Boolean'],
};

export type DecoratedRecommendedListConnection = {
   __typename: 'DecoratedRecommendedListConnection',
  edges: Array<RecommendedListEdge>,
  facets: Array<RecommendedListDisplayFacet>,
  pageInfo: PageInfo,
};

export type DelegateExpertChangedActivity = LeadActivity & {
   __typename: 'DelegateExpertChangedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  previousDelegateExpert?: Maybe<BusinessUser>,
  currentDelegateExpert?: Maybe<BusinessUser>,
  performedBy: Identity,
};

export type DelegateLeadInput = {
  leadId: Scalars['LeadId'],
  /** When the delegate expert ID is not specified, it means undelegate */
  delegateExpertId?: Maybe<Scalars['BusinessUserId']>,
};

export type DelegateLeadSupportTaskActivity = SupportTaskActivity & {
   __typename: 'DelegateLeadSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  delegatedTo: BusinessUser,
};

export type DeleteAddressInput = {
  addressId: Scalars['AddressId'],
  userId: Scalars['UserId'],
};

export type DeleteAddressPayload = {
   __typename: 'DeleteAddressPayload',
  success?: Maybe<Scalars['Boolean']>,
  error?: Maybe<Scalars['String']>,
};

export type DeleteExpertCuratedLeadItineraryInput = {
  id: Scalars['LeadId'],
};

export type DeleteExpertCuratedLeadItineraryPayload = {
   __typename: 'DeleteExpertCuratedLeadItineraryPayload',
  /** If true, the item was successfully deleted. If false, it means there there was no item to delete. */
  deleted: Scalars['Boolean'],
};

export type DeletePaymentSourcePayload = {
   __typename: 'DeletePaymentSourcePayload',
  success?: Maybe<Scalars['Boolean']>,
  error?: Maybe<Scalars['String']>,
};

export type DeleteRecommendedListDefinitionIdPayload = {
   __typename: 'DeleteRecommendedListDefinitionIdPayload',
  success: Scalars['Boolean'],
};

export type DeleteSavedExpertCuratedItemsPayload = {
   __typename: 'DeleteSavedExpertCuratedItemsPayload',
  data?: Maybe<SavedExpertCuratedItems>,
  error?: Maybe<Scalars['String']>,
  hasError: Scalars['Boolean'],
};

export type DeleteSellableResearchLinkInput = {
  id: Scalars['SellableResearchLinkId'],
};

export type DeleteSellableResearchLinkPayload = {
   __typename: 'DeleteSellableResearchLinkPayload',
  success: Scalars['Boolean'],
};

export type Department = {
   __typename: 'Department',
  id: Scalars['DepartmentId'],
  slug: Scalars['String'],
  type: DepartmentType,
  displayName: Scalars['String'],
  topLevelCategories: Array<Category>,
  topLevelCategory: Category,
  acceptingRequests: Scalars['Boolean'],
  launched: Scalars['Boolean'],
  test: Scalars['Boolean'],
  /** 
 * Get sellable search facets associated with this department.
   * By default only brands of the all categories including children are returned as facets.
   * Additionally, it excludes out of stock sellables when building the facets.
 **/
  sellableSearchFacets: Array<DisplayFacetSelection>,
  mostRecentLeadForConsumer?: Maybe<Lead>,
  navigation: DepartmentNavigation,
  expertTeams: Array<BusinessUserTeam>,
  expertSpecialtyCategories: Array<Category>,
  emailCuratedBannerUrl: Scalars['String'],
  emailCuratedLogoUrl: Scalars['String'],
  consumerUrl: Scalars['String'],
  placeholderExpert: BusinessUser,
  /** The URL to start a path from a given department */
  pathUrl: Scalars['String'],
  consumerExpertReviewConnection: ConsumerExpertReviewConnection,
  reviewSummary: ReviewSummary,
};


export type DepartmentSellableSearchFacetsArgs = {
  query: CategorySellableSearchFacetQuery
};


export type DepartmentMostRecentLeadForConsumerArgs = {
  hasRequest?: Maybe<Scalars['Boolean']>
};


export type DepartmentConsumerExpertReviewConnectionArgs = {
  filter: ConsumerExpertReviewFilter,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type DepartmentNavigation = {
   __typename: 'DepartmentNavigation',
  /** Top most level items shown, usually displayed inline on the page */
  topLevelItems: Array<DepartmentNavigationTopLevelItem>,
};

export type DepartmentNavigationCategoryLink = {
   __typename: 'DepartmentNavigationCategoryLink',
  category: Category,
};

export type DepartmentNavigationCreatePathLink = {
   __typename: 'DepartmentNavigationCreatePathLink',
  pathSlug: Scalars['String'],
};

export type DepartmentNavigationExpertCommunityLink = {
   __typename: 'DepartmentNavigationExpertCommunityLink',
  departmentSlug: Scalars['String'],
};

export type DepartmentNavigationExpertSubSection = DepartmentNavigationSubSection & DepartmentNavigationResponsiveMixin & {
   __typename: 'DepartmentNavigationExpertSubSection',
  id: Scalars['String'],
  title: Scalars['String'],
  titleLink?: Maybe<DepartmentNavigationLink>,
  showIfFullSize: Scalars['Boolean'],
  showIfSmallSize: Scalars['Boolean'],
  smallSizeOptions: Array<DepartmentNavigationResponsiveSmallSizeOptions>,
  fullSizeOptions: Array<DepartmentNavigationResponsiveFullSizeOptions>,
  /** Find a recommended expert for this category */
  expertCategoryId: Scalars['CategoryId'],
};

export enum DepartmentNavigationLabelStyle {
  BOLD = 'BOLD'
}

export type DepartmentNavigationLink = DepartmentNavigationCategoryLink | DepartmentNavigationSearchLink | DepartmentNavigationCreatePathLink | DepartmentNavigationExpertCommunityLink;

export type DepartmentNavigationListSubSection = DepartmentNavigationSubSection & DepartmentNavigationResponsiveMixin & {
   __typename: 'DepartmentNavigationListSubSection',
  id: Scalars['String'],
  title: Scalars['String'],
  titleLink?: Maybe<DepartmentNavigationLink>,
  showIfFullSize: Scalars['Boolean'],
  showIfSmallSize: Scalars['Boolean'],
  smallSizeOptions: Array<DepartmentNavigationResponsiveSmallSizeOptions>,
  fullSizeOptions: Array<DepartmentNavigationResponsiveFullSizeOptions>,
  items: Array<DepartmentNavigationListSubSectionItem>,
};

export type DepartmentNavigationListSubSectionItem = {
   __typename: 'DepartmentNavigationListSubSectionItem',
  id: Scalars['String'],
  label: Scalars['String'],
  imagePath?: Maybe<Scalars['String']>,
  imageUrl?: Maybe<Scalars['String']>,
  link: DepartmentNavigationLink,
  labelStyles: Array<DepartmentNavigationLabelStyle>,
};

export enum DepartmentNavigationResponsiveFullSizeOptions {
  SHOW = 'SHOW'
}

export type DepartmentNavigationResponsiveMixin = {
  /** Options for showing this element for smaller screens (e.g.: mobile) */
  smallSizeOptions: Array<DepartmentNavigationResponsiveSmallSizeOptions>,
  /** Options for showing this element for full sized screens (e.g.: desktop) */
  fullSizeOptions: Array<DepartmentNavigationResponsiveFullSizeOptions>,
  /** If this element should be shown for smaller screens (e.g.: mobile) */
  showIfSmallSize: Scalars['Boolean'],
  /** If this element should be shown for full sized screens (e.g.: desktop) */
  showIfFullSize: Scalars['Boolean'],
};

export enum DepartmentNavigationResponsiveSmallSizeOptions {
  /** Show element in persistent element attached to the chrome. */
  SHOW_IN_PERSISTENT_HEADER = 'SHOW_IN_PERSISTENT_HEADER',
  /** Show element in flyout panel that expands from the side of the page */
  SHOW_IN_FLYOUT_PANEL = 'SHOW_IN_FLYOUT_PANEL'
}

export type DepartmentNavigationSearchLink = {
   __typename: 'DepartmentNavigationSearchLink',
  category: Category,
  facets: Array<FacetSelectionPayload>,
};

export type DepartmentNavigationSubSection = {
  id: Scalars['String'],
  title: Scalars['String'],
  titleLink?: Maybe<DepartmentNavigationLink>,
};

export type DepartmentNavigationTopLevelItem = DepartmentNavigationResponsiveMixin & {
   __typename: 'DepartmentNavigationTopLevelItem',
  id: Scalars['String'],
  showIfFullSize: Scalars['Boolean'],
  showIfSmallSize: Scalars['Boolean'],
  smallSizeOptions: Array<DepartmentNavigationResponsiveSmallSizeOptions>,
  fullSizeOptions: Array<DepartmentNavigationResponsiveFullSizeOptions>,
  label: Scalars['String'],
  labelLink?: Maybe<DepartmentNavigationLink>,
  imagePath?: Maybe<Scalars['String']>,
  imageUrl?: Maybe<Scalars['String']>,
  subSections: Array<DepartmentNavigationSubSection>,
};

/** 
 * Best effort enumeration of available departments for easy type safe comparisons.
 * There is no guarantee all departments will have a department type. The departments that are not assigned an
 * explicit type will be assigned `OTHER`.
 **/
export enum DepartmentType {
  CYCLING = 'CYCLING',
  CAMPING = 'CAMPING',
  CURATED_INTERNAL = 'CURATED_INTERNAL',
  GOLF = 'GOLF',
  JEWELRY = 'JEWELRY',
  JET_CHARTERS = 'JET_CHARTERS',
  OTHER = 'OTHER',
  WINTER_SPORTS = 'WINTER_SPORTS',
  YACHT_CHARTERS = 'YACHT_CHARTERS'
}

export type DevTools = {
   __typename: 'DevTools',
  idEncodeToExternal: Scalars['String'],
  idDecodeFromExternal: Scalars['String'],
  decodeId: IdCodecPayload,
  geocoding?: Maybe<GeocodingResponse>,
  frontendTask: FrontendTask,
  messageSummary: Array<Maybe<MessageSummary>>,
};


export type DevToolsIdEncodeToExternalArgs = {
  urn: Scalars['String']
};


export type DevToolsIdDecodeFromExternalArgs = {
  externalId: Scalars['String']
};


export type DevToolsDecodeIdArgs = {
  id: Scalars['String']
};


export type DevToolsGeocodingArgs = {
  address: Scalars['String']
};


export type DevToolsFrontendTaskArgs = {
  id: Scalars['FrontendTaskId']
};


export type DevToolsMessageSummaryArgs = {
  conversationId: Scalars['ConversationId']
};

export type DevToolsMutation = {
   __typename: 'DevToolsMutation',
  createDevData: Scalars['Boolean'],
  resetPaymentFailedOffer: BroadcastOffer,
  uploadMerchants: UploadMerchantsPayload,
  uploadSellables: UploadSellablesPayload,
  uploadSellablePrice: UploadSellablePricePayload,
  firePathStartedEvent: Scalars['Boolean'],
  uploadBrands: UploadBrandsPayload,
  createCheckoutStartedEvent: UserActivity,
  createViewSellableEvent: UserActivity,
  createVoiceCallEvent: UserActivity,
  syncFirebaseConversationParticpants: Scalars['Boolean'],
  syncLeadTeam: Lead,
};


export type DevToolsMutationResetPaymentFailedOfferArgs = {
  offerId: Scalars['BroadcastOfferId']
};


export type DevToolsMutationUploadMerchantsArgs = {
  googleSpreadsheetId: Scalars['String'],
  categorySlug: Scalars['String']
};


export type DevToolsMutationUploadSellablesArgs = {
  googleSpreadsheetId: Scalars['String'],
  categorySlug: Scalars['String'],
  rows?: Maybe<Scalars['Float']>
};


export type DevToolsMutationUploadSellablePriceArgs = {
  googleSpreadsheetId: Scalars['String'],
  categorySlug: Scalars['String']
};


export type DevToolsMutationFirePathStartedEventArgs = {
  pathFlowId: Scalars['PathFlowId'],
  userId: Scalars['UserId']
};


export type DevToolsMutationUploadBrandsArgs = {
  input: UploadBrandsInput
};


export type DevToolsMutationCreateCheckoutStartedEventArgs = {
  orderId: Scalars['OrderId'],
  userId: Scalars['UserId']
};


export type DevToolsMutationCreateViewSellableEventArgs = {
  sellableId: Scalars['SellableId'],
  userId: Scalars['UserId']
};


export type DevToolsMutationCreateVoiceCallEventArgs = {
  userId: Scalars['UserId'],
  expertId: Scalars['BusinessUserId'],
  userPhoneNumber: Scalars['String'],
  status: Scalars['String'],
  callId: Scalars['String']
};


export type DevToolsMutationSyncFirebaseConversationParticpantsArgs = {
  leadId: Scalars['LeadId']
};


export type DevToolsMutationSyncLeadTeamArgs = {
  leadId: Scalars['LeadId']
};

export type DisablePromotionInput = {
  id: Scalars['PromotionId'],
};

export type DisablePromotionPayload = {
   __typename: 'DisablePromotionPayload',
  promotion: Promotion,
};

export type DismissLeadSuggestedActionInput = {
  leadId: Scalars['LeadId'],
  type: SuggestedActionType,
};

export type DismissOrderMessagesInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>,
};

export type DismissOrderMessagesPayload = {
   __typename: 'DismissOrderMessagesPayload',
  order: Order,
};

export type DismissSuggestedSupportActionInput = {
  conversationId: Scalars['SupportConversationId'],
  action: SuggestedSupportAction,
};

export type DismissSupportTaskActivity = SupportTaskActivity & {
   __typename: 'DismissSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
};

export type DisplayFacet = {
  /** Name to display in the UI for this facet */
  displayName: Scalars['String'],
  /** Internal name that should be provided back to FacetSelection.name when selecting facet values */
  name: Scalars['String'],
  /** 
 * Alias for this facet if one exist. Aliases provide a semi user friendly name that can be used
   * in the urls for example.
 **/
  alias?: Maybe<Scalars['String']>,
};

/** 
 * A display facet selection encodes a top level Facet with selection for individual values.
 * This could either be a flattened list of Facet selections or a combination of multiple facets
 * The individual selections encodes all information needed to unique identify a bucket value.
 * Use case: Chrome/Navigation link for Categories and departments.
 **/
export type DisplayFacetSelection = {
   __typename: 'DisplayFacetSelection',
  /** internal name */
  name: Scalars['String'],
  /** Display name to use on UI */
  displayName: Scalars['String'],
  /** A list of individual selection that can be directly transformed as input RawFacetSelection for the search */
  selections: Array<FacetSelectionPayload>,
};

export type DueDateChangedActivity = TicketActivityDetail & {
   __typename: 'DueDateChangedActivity',
  type: TicketActivityType,
  oldDueDate: Scalars['Date'],
  newDueDate: Scalars['Date'],
};

export type Duration = {
   __typename: 'Duration',
  amount: Scalars['Long'],
  unit: DurationUnit,
};

export type DurationInput = {
  amount: Scalars['Long'],
  unit: DurationUnit,
};

export enum DurationUnit {
  NANOS = 'NANOS',
  MILLIS = 'MILLIS',
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS'
}

export type EBayItem = {
   __typename: 'EBayItem',
  id: Scalars['String'],
  title: Scalars['String'],
  shortDescription?: Maybe<Scalars['String']>,
  condition?: Maybe<Scalars['String']>,
  imageUrls: Array<Scalars['String']>,
  url: Scalars['String'],
  price: MonetaryAmount,
  specifications: Array<EBayItemSpecification>,
  group?: Maybe<EBayItemGroup>,
  quantity?: Maybe<Scalars['Int']>,
  isNew?: Maybe<Scalars['Boolean']>,
  outOfStock: Scalars['Boolean'],
};

export type EBayItemDimension = {
   __typename: 'EBayItemDimension',
  name: Scalars['String'],
  vectors: Array<EbayItemDimensionVector>,
};

export type EbayItemDimensionVector = {
   __typename: 'EbayItemDimensionVector',
  value: Scalars['String'],
  itemIds: Array<Scalars['String']>,
};

export type EBayItemGroup = {
   __typename: 'EBayItemGroup',
  id: Scalars['String'],
  dimensions: Array<EBayItemDimension>,
  items: Array<EBayItem>,
};

export type EBayItemSearchConnection = {
   __typename: 'EBayItemSearchConnection',
  facets: Array<DisplayFacet>,
  edges: Array<EBayItemSearchEdge>,
  pageInfo: PageInfo,
  count: Scalars['Int'],
};

export type EBayItemSearchEdge = {
   __typename: 'EBayItemSearchEdge',
  node: EBayItem,
  cursor: Scalars['String'],
};

export type EBayItemSearchQuery = {
  facets?: Maybe<Array<FacetSelection>>,
  categoryId?: Maybe<Scalars['CategoryId']>,
  keywords?: Maybe<Scalars['String']>,
  price?: Maybe<MonetaryAmountRangeInput>,
  /** 
 * If categoryId and/or keywords are not specified, the sellable's category as well as its title would be
   * used as the categoryId and/or keywords
 **/
  sellableId?: Maybe<Scalars['SellableId']>,
};

export type EBayItemSpecification = {
   __typename: 'EBayItemSpecification',
  /** Display name for the specification */
  name: Scalars['String'],
  /** Display text value for the specification */
  value: Scalars['String'],
};

export type EBaySellablePriceSource = SellablePriceSource & {
   __typename: 'EBaySellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  bestOfferPrice?: Maybe<MonetaryAmount>,
  cost?: Maybe<MonetaryAmount>,
  expiresAt?: Maybe<Scalars['Date']>,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  url: Scalars['String'],
  title: Scalars['String'],
};

export enum EditableUserSourceType {
  ORGANIC = 'ORGANIC',
  INVESTOR = 'INVESTOR'
}

export type EditorialReview = {
   __typename: 'EditorialReview',
  /** Brand associated with the editorial review site */
  brand: Brand,
  /** URL linking back to the specific review */
  url?: Maybe<Scalars['String']>,
  /** Short snippet extracted from the review to display */
  snippet?: Maybe<Scalars['String']>,
  /** Rating assigned to this review */
  rating?: Maybe<EditorialReviewRating>,
  /** The price the product was when the review was performed */
  testedAtPrice?: Maybe<MonetaryAmount>,
  /** The award the review gave this product/service */
  awardLabel?: Maybe<Scalars['String']>,
};

export type EditorialReviewRating = EditorialReviewRatingFiveStar;

export type EditorialReviewRatingFiveStar = {
   __typename: 'EditorialReviewRatingFiveStar',
  /** Between 0 and 5, inclusive */
  stars: Scalars['Int'],
};

export type EmailTemplate = ChannelTemplate & {
   __typename: 'EmailTemplate',
  channelType: ChannelType,
  subject: Scalars['String'],
  htmlBody: Scalars['String'],
  textBody: Scalars['String'],
};

export type EmailTemplateInput = {
  subject: Scalars['String'],
  htmlBody: Scalars['String'],
  textBody: Scalars['String'],
};

/** Re-usable by other questions types that embed text fields as well */
export type EmbeddedInputTextPathFlowQuestion = InputTextPathFlowQuestionMixin & {
   __typename: 'EmbeddedInputTextPathFlowQuestion',
  required: Scalars['Boolean'],
  inputTextValidations: Array<InputTextPathFlowQuestionValidation>,
  fieldType: InputTextPathFlowQuestionFieldType,
  placeholder?: Maybe<Scalars['String']>,
  questionSubText?: Maybe<TextViewModel>,
};

export type EmptyDealTerms = {
   __typename: 'EmptyDealTerms',
  type: DealTermsType,
};

export type EncodedAuthenticationTokens = {
   __typename: 'EncodedAuthenticationTokens',
  refreshToken: Scalars['String'],
  accessToken: Scalars['String'],
  sessionToken: Scalars['String'],
};

export type EncodedAuthenticationTokensPayload = {
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

export type EscalateLeadForDelegationSupportTaskActivity = SupportTaskActivity & {
   __typename: 'EscalateLeadForDelegationSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  escalation: LeadEscalation,
};

export type EscalateLeadForReassignmentSupportTaskActivity = SupportTaskActivity & {
   __typename: 'EscalateLeadForReassignmentSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  escalation: LeadEscalation,
};

export type EscalationClosedActivity = OrderActivityDetail & {
   __typename: 'EscalationClosedActivity',
  type: OrderActivityDetailType,
  closedBy: Operator,
  escalation: OrderEscalation,
};

export type EscalationFacetCountsPayload = {
   __typename: 'EscalationFacetCountsPayload',
  displayFacets: Array<DisplayFacet>,
};

export enum EscalationItemCondition {
  NEW = 'NEW',
  GOOD = 'GOOD',
  OKAY = 'OKAY'
}

export type EscalationItemInfo = {
   __typename: 'EscalationItemInfo',
  condition: EscalationItemCondition,
  customized: Scalars['Boolean'],
};

export type EscalationUser = User | Operator | BusinessUser;

/** Compute sales tax using one of these 3 location inputs. */
export type EstimatedTaxLocationInput = {
  /** Estimate sales tax using the address of the user */
  userId?: Maybe<Scalars['UserId']>,
  /** Estimate sales tax using this stored address */
  addressId?: Maybe<Scalars['AddressId']>,
  /** Estimate sales tax using the country and state. If only state is provided, the country will default to US */
  country?: Maybe<Scalars['String']>,
  /** Estimate sales tax using the country and state. If only state is provided, the country will default to US */
  state?: Maybe<Scalars['String']>,
};

export type ExperimentDefinition = {
   __typename: 'ExperimentDefinition',
  id: Scalars['ExperimentId'],
  name: Scalars['String'],
  description: Scalars['String'],
  seed: Scalars['Int'],
  backendOnly: Scalars['Boolean'],
  treatments: Array<TreatmentDefinition>,
  rules: Array<RuleDefinition>,
  version: Scalars['Int'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  state: ExperimentState,
  updatedById: Scalars['AnyId'],
  updatedBy: Identity,
};

export type ExperimentFilter = {
  states?: Maybe<Array<ExperimentState>>,
};


export enum ExperimentState {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export type ExperimentsUpdatedAfterPayload = {
   __typename: 'ExperimentsUpdatedAfterPayload',
  experiments: Array<ExperimentDefinition>,
};

export type ExpertApplication = {
   __typename: 'ExpertApplication',
  id: Scalars['ExpertApplicationId'],
  state: ExpertApplicationState,
  stateDisplayName: Scalars['String'],
  user: User,
  category: Category,
  attributes: Array<Attribute>,
  rejectReason?: Maybe<Scalars['String']>,
  createdAt: Scalars['Date'],
  submittedAt: Scalars['Date'],
  approvedAt?: Maybe<Scalars['Date']>,
  rejectedAt?: Maybe<Scalars['Date']>,
  approvedBy?: Maybe<ExpertApplicationApprover>,
  expertAccount?: Maybe<BusinessUser>,
  expertProfile?: Maybe<ExpertProfile>,
  department: Department,
  claimStatus?: Maybe<ExpertApplicationClaimStatus>,
  reviews: Array<ExpertApplicationReview>,
  conversation?: Maybe<Conversation>,
  notes: Array<ExpertApplicationNote>,
  pastTasks: Array<ExpertApplicationTaskStatus>,
  currentTasks: Array<ExpertApplicationTaskStatus>,
  futureTasks: Array<ExpertApplicationTaskStatus>,
  snooze?: Maybe<ExpertApplicationSnooze>,
  archived: Scalars['Boolean'],
  lastActivityTime: Scalars['Date'],
  referredByExpertId?: Maybe<Scalars['BusinessUserId']>,
};

export type ExpertApplicationApprover = BusinessUser | Operator;

export type ExpertApplicationClaimStatus = {
   __typename: 'ExpertApplicationClaimStatus',
  claimedAt: Scalars['Date'],
  claimedByTeam: BusinessUserTeam,
  claimedByExpert: BusinessUser,
};

export type ExpertApplicationEdge = {
   __typename: 'ExpertApplicationEdge',
  node: ExpertApplication,
  cursor: Scalars['String'],
};

export type ExpertApplicationFolder = {
   __typename: 'ExpertApplicationFolder',
  id: Scalars['ExpertApplicationFolderId'],
  slug: Scalars['String'],
  displayName: Scalars['String'],
  totalCount?: Maybe<Scalars['Int']>,
  unreadCount?: Maybe<Scalars['Int']>,
  countSubscriptionAvailable: Scalars['Boolean'],
};

export type ExpertApplicationFolderGroup = {
   __typename: 'ExpertApplicationFolderGroup',
  type: ExpertApplicationFolderType,
  folders: Array<ExpertApplicationFolder>,
  displayName: Scalars['String'],
};


export type ExpertApplicationFolderItemChange = {
   __typename: 'ExpertApplicationFolderItemChange',
  application: ExpertApplication,
  type: ExpertApplicationFolderItemChangeType,
};

export enum ExpertApplicationFolderItemChangeType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE'
}

export type ExpertApplicationFolderItemsPayload = {
   __typename: 'ExpertApplicationFolderItemsPayload',
  items: ExpertApplicationsConnection,
};

export enum ExpertApplicationFolderType {
  PIPELINE = 'PIPELINE',
  FOLDERS = 'FOLDERS'
}


export type ExpertApplicationNote = {
   __typename: 'ExpertApplicationNote',
  text: Scalars['String'],
  createdAt?: Maybe<Scalars['Date']>,
  createdBy: Operator,
};

export type ExpertApplicationQuery = {
  states: Array<ExpertApplicationState>,
};

export enum ExpertApplicationRating {
  YES = 'YES',
  NO = 'NO'
}

export type ExpertApplicationReview = {
   __typename: 'ExpertApplicationReview',
  reviewedAt: Scalars['Date'],
  reviewedBy: BusinessUser,
  rating: ExpertApplicationRating,
  reason?: Maybe<Scalars['String']>,
};

export type ExpertApplicationsConnection = {
   __typename: 'ExpertApplicationsConnection',
  facets: Array<DisplayFacet>,
  edges: Array<ExpertApplicationEdge>,
  pageInfo: PageInfo,
  count: Scalars['Int'],
};

export type ExpertApplicationSearchQueryInput = {
  keywords?: Maybe<Scalars['String']>,
  departmentId?: Maybe<Scalars['DepartmentId']>,
  facets?: Maybe<Array<FacetSelection>>,
  facetedSearch: Scalars['Boolean'],
};

export enum ExpertApplicationSearchSort {
  DEFAULT = 'DEFAULT',
  APPLICATION_SUBMITTED_AT = 'APPLICATION_SUBMITTED_AT'
}

export type ExpertApplicationSnooze = {
   __typename: 'ExpertApplicationSnooze',
  wakeupTime: Scalars['Date'],
  note?: Maybe<Scalars['String']>,
  message?: Maybe<Scalars['String']>,
  cancelMessageOnReply: Scalars['Boolean'],
};

export type ExpertApplicationsPagination = {
   __typename: 'ExpertApplicationsPagination',
  applications: Array<ExpertApplication>,
  count: Scalars['Long'],
};

export enum ExpertApplicationState {
  REJECTED = 'REJECTED',
  ONBOARDED = 'ONBOARDED',
  SCHEDULING = 'SCHEDULING',
  FINAL_EVALUATION = 'FINAL_EVALUATION',
  ONBOARDING = 'ONBOARDING',
  APPROVED = 'APPROVED',
  PENDING = 'PENDING'
}

export type ExpertApplicationSubscriptionChange = {
   __typename: 'ExpertApplicationSubscriptionChange',
  application: ExpertApplication,
  type: ExpertApplicationSubscriptionChangeType,
};

export enum ExpertApplicationSubscriptionChangeType {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

export enum ExpertApplicationTaskState {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  ERROR = 'ERROR',
  COMPLETED = 'COMPLETED'
}

export type ExpertApplicationTaskStatus = {
   __typename: 'ExpertApplicationTaskStatus',
  type: ExpertApplicationTaskType,
  displayName: Scalars['String'],
  automated: Scalars['Boolean'],
  state: ExpertApplicationTaskState,
  externalId?: Maybe<Scalars['String']>,
  updates: Array<ExpertApplicationTaskStatusUpdate>,
};

export type ExpertApplicationTaskStatusUpdate = {
   __typename: 'ExpertApplicationTaskStatusUpdate',
  status: Scalars['String'],
  updatedAt: Scalars['Date'],
};

export enum ExpertApplicationTaskType {
  CALL_APPLICANT = 'CALL_APPLICANT',
  APPROVE_PROFILE = 'APPROVE_PROFILE',
  SIGN_CONTRACT = 'SIGN_CONTRACT',
  SETUP_PAYROLL = 'SETUP_PAYROLL',
  COMPLETE_TRAINING = 'COMPLETE_TRAINING',
  SETUP_7SHIFT = 'SETUP_7SHIFT',
  SETUP_SLACK = 'SETUP_SLACK',
  COMPLETE_HOMEWORK = 'COMPLETE_HOMEWORK',
  WAIT_FOR_SCHEDULING = 'WAIT_FOR_SCHEDULING',
  ADD_AVAILABILITY = 'ADD_AVAILABILITY',
  SCHEDULE_SHIFT = 'SCHEDULE_SHIFT',
  COMPLETE_FIRST_SHIFT = 'COMPLETE_FIRST_SHIFT',
  PASS_RESPONSIVE_EVAL = 'PASS_RESPONSIVE_EVAL',
  PASS_SKILL_EVAL = 'PASS_SKILL_EVAL'
}

export type ExpertAttributeInput = {
  specialtyCategoryId?: Maybe<Scalars['CategoryId']>,
  acceptRequestMode?: Maybe<AcceptRequestMode>,
  newMessageNotificationMode?: Maybe<ExpertNewMessageNotificationMode>,
  maxActivationDurationInMinutes?: Maybe<Scalars['Int']>,
  assistExpert?: Maybe<Scalars['Boolean']>,
  workloadCapacity?: Maybe<Scalars['Float']>,
  broadcastLeadClaimDisabled?: Maybe<Scalars['Boolean']>,
};

export type ExpertCategoryTopRecommendedSellable = {
   __typename: 'ExpertCategoryTopRecommendedSellable',
  category: Category,
  displayTitle: Scalars['String'],
  topRecommendedSellables: Array<ExpertTopRecommendedSellable>,
};

export type ExpertCuratedActivityFeedItem = {
  id: Scalars['ExpertCuratedActivityFeedItemId'],
  occurredAt: Scalars['Date'],
  expert: BusinessUser,
};

export type ExpertCuratedActivityFeedItemConnection = {
   __typename: 'ExpertCuratedActivityFeedItemConnection',
  edges: Array<ExpertCuratedActivityFeedItemEdge>,
  pageInfo: PageInfo,
};

export type ExpertCuratedActivityFeedItemEdge = {
   __typename: 'ExpertCuratedActivityFeedItemEdge',
  node: ExpertCuratedActivityFeedItem,
  cursor: Scalars['String'],
};


export type ExpertCuratedActivityFeedOrderItem = ExpertCuratedActivityFeedItem & {
   __typename: 'ExpertCuratedActivityFeedOrderItem',
  id: Scalars['ExpertCuratedActivityFeedItemId'],
  occurredAt: Scalars['Date'],
  expert: BusinessUser,
  consumerFirstName: Scalars['String'],
  review?: Maybe<ConsumerExpertReview>,
  sellables: Array<ExpertCuratedActivityFeedOrderSellableItem>,
};

export type ExpertCuratedActivityFeedOrderSellableItem = {
   __typename: 'ExpertCuratedActivityFeedOrderSellableItem',
  sellable: Sellable,
  note?: Maybe<ExpertCuratedItemNote>,
};

export type ExpertCuratedItem = {
   __typename: 'ExpertCuratedItem',
  id: Scalars['ExpertCuratedItemId'],
  /** Date at which this expert curated item was created */
  createdAt: Scalars['Date'],
  /** The lead this curated item is associated with. */
  lead: Lead,
  /** User this curated item was created for; de-normalized from the `lead`. */
  createdFor: User,
  /** Expert that created this curated item */
  createdBy: BusinessUser,
  /** The first category of the sellable that's being recommended; de-normalized from the `sellable` */
  category: Category,
  /** The sellable that's being recommended as part of this curated item. */
  sellable: Sellable,
  /** 
 * If this curated item is added to the cart via the `addExpertCuratedItemToCart` mutation, this price will be used for
   * the item instead of the sellable's natural sale price.
 **/
  priceOverride?: Maybe<MonetaryAmount>,
  /** Date at which the price override would be invalid. */
  priceOverrideValidUntil?: Maybe<Scalars['Date']>,
  /** 
 * The sale price for this item; will use priceOverride if provided and valid, else fallback to the sellable bestOfferPrice
   * The sale price may be not available if it is out of stock
 **/
  salePrice?: Maybe<MonetaryAmount>,
  /** Tag for this curated item. */
  tag?: Maybe<ExpertCuratedItemTag>,
  /** 
 * If this curated item is in draft state.
   * Curated items in draft state are exclusively to be used by the expert to incrementally build up multiple
   * recommendations without it being viewable by the consumer. As such, drafts are never view-able by the consumer.
   * In order to remove the draft flag from all items associated with a lead, invoke the
   * `makeExpertCuratedItemDraftsActive` mutation.
 **/
  draft: Scalars['Boolean'],
  /** If this curated item is active (currently being considered, and displayed to the consumer by default). */
  active: Scalars['Boolean'],
  /** If present, represents that this item has been dismissed/removed. */
  removedState?: Maybe<ExpertCuratedItemRemovedState>,
  /** 
 * If set, this curated item will be added to the user associated with the lead's cart when this item is converted
   * from a draft to non draft and active state via `makeExpertCuratedItemDraftsActive`.
 **/
  shouldAddToCartOnActive: Scalars['Boolean'],
  /** The line item in the user's cart associated with this expert curated item. */
  lineItemInCart?: Maybe<OrderLineItem>,
  /** Custom expert notes associated with this item for the consumer */
  notes?: Maybe<Scalars['String']>,
  /** 
 * Custom expert notes associated with this item, that should be published when this item is activated.
   * When this note is activated, this draft note is transferred into a new `ExpertCuratedItemNote` that's set to the
   * `note` field, and this property is cleared. As such, this property is only valid for creating new notes on items
   * in draft state.
 **/
  draftNote?: Maybe<Scalars['String']>,
  /** Custom expert note associated with this item for the consumer */
  note?: Maybe<ExpertCuratedItemNote>,
  /** Expert only field to view a pending draft update for this record */
  pendingDraftUpdate?: Maybe<ExpertCuratedItem>,
  /** Previous item this item is replacing (if state is draft) / replaced (if state is not draft) */
  supersededItem?: Maybe<ExpertCuratedItem>,
  /** 
 * Indicates that the changes made to this item introduce no material changes to the item it's replacing
   * (referenced by `supersededItem`). If the item is activated in this state (via `makeExpertCuratedItemDraftsActive`),
   * this draft will be deleted with no modifications being made to the existing item.
 **/
  noChangesFromSupersededItem: Scalars['Boolean'],
  /** Indicates whether this ExpertCuratedItem was built from a system recommendation. */
  systemRecommended?: Maybe<Scalars['Boolean']>,
  /** various notes only visible by the expert and fulfillment team */
  fulfillmentNotes: ExpertCuratedItemFulfillmentNotes,
  /** 
 * Priced (including free) add-ons that are bundled together with this curated item. When added to the user's cart,
   * these customizations are also forcefully added as a grouped line item.
 **/
  customizations: Array<ExpertCuratedItemCustomization>,
  /** Rank of item in curated list */
  rank: Scalars['Long'],
};

export type ExpertCuratedItemActivation = {
   __typename: 'ExpertCuratedItemActivation',
  id: Scalars['ExpertCuratedItemActivationId'],
  activated: Array<ExpertCuratedItem>,
  removed: Array<ExpertCuratedItem>,
  items: Array<ExpertCuratedItem>,
  lead: Lead,
  activatedBy: BusinessUser,
  createdFor: User,
  previousActivation?: Maybe<ExpertCuratedItemActivation>,
  numItemsActivated: Scalars['Int'],
  numItemsRemoved: Scalars['Int'],
  createdAt: Scalars['Date'],
  createdBySystem: Scalars['Boolean'],
  /** used for trigger entity only to avoid unnecessary look up of Business User */
  activatedById: Scalars['BusinessUserId'],
};


export type ExpertCuratedItemActivationItemsArgs = {
  first?: Maybe<Scalars['Int']>
};


export type ExpertCuratedItemActivationsConnection = {
   __typename: 'ExpertCuratedItemActivationsConnection',
  edges: Array<ExpertCuratedItemActivationsEdge>,
  pageInfo: PageInfo,
};

export type ExpertCuratedItemActivationsEdge = {
   __typename: 'ExpertCuratedItemActivationsEdge',
  node: ExpertCuratedItemActivation,
  cursor: Scalars['String'],
};

export type ExpertCuratedItemCustomization = {
   __typename: 'ExpertCuratedItemCustomization',
  sellable: Sellable,
  createdAt: Scalars['Date'],
  title: Scalars['String'],
  price: MonetaryAmount,
};

export type ExpertCuratedItemFulfillmentNotes = {
   __typename: 'ExpertCuratedItemFulfillmentNotes',
  /** The reason why a custom priceOverride was set */
  priceOverrideReason?: Maybe<ExpertCuratedItemPriceOverrideReason>,
  /** If this curated item was sourced from a different site, the url of the product */
  externalProductUrl?: Maybe<Scalars['String']>,
  /** Additional notes for the fulfillment team (e.g.: special customer requests) */
  notes?: Maybe<Scalars['String']>,
};

export type ExpertCuratedItemFulfillmentNotesInput = {
  priceOverrideReasonType?: Maybe<ExpertCuratedItemPriceOverrideReasonType>,
  externalProductUrl?: Maybe<Scalars['String']>,
  notes?: Maybe<Scalars['String']>,
};

/** 
 * ExpertCuratedItemGroup is a container for ExpertCuratedItem's that were part of the curation recommended to a lead
 * It also includes other decorations like the request attributes of the lead to who this curation was recommended.
 **/
export type ExpertCuratedItemGroup = {
   __typename: 'ExpertCuratedItemGroup',
  expertCuratedItems: Array<ExpertCuratedItem>,
  modifiedAt: Scalars['Date'],
  /** a list of request attributes that can be used to tag this saved curation */
  suggestedTaggableRequestAttributes: Array<SuggestedExpertTaggableRequestAttribute>,
};


export type ExpertCuratedItemNote = {
   __typename: 'ExpertCuratedItemNote',
  id: Scalars['ExpertCuratedItemNoteId'],
  /** sellable variant this note is for */
  sellable: Sellable,
  /** the parent sellable of `sellable`, or `sellable` if it's already the parent */
  parentSellable: Sellable,
  /** expert that created this note */
  createdBy: BusinessUser,
  /** Note text */
  text: Scalars['String'],
  /** the amount of purchased orders that contain line items added from expert curated items containing this note */
  purchaseCount: Scalars['Int'],
  /** the amount of active (non draft, non-replaced) expert curated items that expectedReference this note */
  useCount: Scalars['Int'],
  /** Between 0 and 1 */
  purchaseRate: Scalars['Float'],
  /** If the note has been flagged by operator as "featurable" review */
  featured: Scalars['Boolean'],
  /** Id of note this note was orignally copied from */
  originatedFromId?: Maybe<Scalars['ExpertCuratedItemNoteId']>,
  /** Id for grouping together differnet versions of same note */
  historyId: Scalars['ExpertCuratedItemNoteHistoryId'],
  /** Id of note this note replace. Also note with previous versionNumber */
  supersededId?: Maybe<Scalars['ExpertCuratedItemNoteId']>,
  /** Bag of attributes associated with expert reviewing product */
  attributes: Array<Attribute>,
  /** version of note */
  versionNumber: Scalars['Int'],
  /** History of approval changes made to note by operator */
  approvalHistory: Array<ExpertCuratedItemNoteApprovalChange>,
  /** Changes requested by operator on note rejection */
  changesRequestedNote?: Maybe<Scalars['String']>,
  /** Current state of note */
  state: ExpertCuratedItemNoteState,
};

export type ExpertCuratedItemNoteApprovalChange = {
   __typename: 'ExpertCuratedItemNoteApprovalChange',
  occurredAt: Scalars['Date'],
  changedBy: Operator,
  changeType: ExpertCuratedItemNoteState,
  changeRequestedNotes?: Maybe<Scalars['String']>,
};



export enum ExpertCuratedItemNoteState {
  /** New note, never submitted with curation */
  DRAFT = 'DRAFT',
  /** Waiting to be reviewed by operator */
  PENDING = 'PENDING',
  /** Approved by operator */
  APPROVED = 'APPROVED',
  /** Rejected by operator */
  REJECTED = 'REJECTED',
  /** Deactiavted by operator or system. soft delete */
  DEACTIVATED = 'DEACTIVATED'
}

export type ExpertCuratedItemPriceOverrideReason = {
   __typename: 'ExpertCuratedItemPriceOverrideReason',
  reasonType: ExpertCuratedItemPriceOverrideReasonType,
  displayLabel: Scalars['String'],
  /** If `externalProductUrl` is required for this `reasonType` */
  externalProductUrlRequired: Scalars['Boolean'],
  /** If `notesRequired` is required for this `reasonType` */
  notesRequired: Scalars['Boolean'],
};

export enum ExpertCuratedItemPriceOverrideReasonType {
  PRICE_MATCH = 'PRICE_MATCH',
  SPECIAL_DISCOUNT = 'SPECIAL_DISCOUNT',
  OTHER = 'OTHER',
  SECRET_DEAL = 'SECRET_DEAL'
}

export type ExpertCuratedItemQueryByUserInput = {
  curatedForId: Scalars['UserId'],
  sellableId: Scalars['SellableId'],
};

export enum ExpertCuratedItemRankChangeType {
  INCREMENT = 'INCREMENT',
  DECREMENT = 'DECREMENT'
}

export type ExpertCuratedItemRemovedBy = User | BusinessUser;

export enum ExpertCuratedItemRemovedReason {
  /** Internal reason used when an item is replaced/updated */
  REPLACED = 'REPLACED',
  /** Should be provided by experts to indicate they removed the item (no further reason is required for them) */
  REMOVED_BY_EXPERT = 'REMOVED_BY_EXPERT',
  /** Default reason that should be used if the user isn't prompted for the remaining reasons */
  NOT_INTERESTED = 'NOT_INTERESTED',
  TOO_EXPENSIVE = 'TOO_EXPENSIVE',
  LOW_QUALITY = 'LOW_QUALITY',
  UGLY = 'UGLY',
  DONT_NEED = 'DONT_NEED',
  BOUGHT_ELSEWHERE = 'BOUGHT_ELSEWHERE',
  OTHER = 'OTHER'
}

export type ExpertCuratedItemRemovedState = {
   __typename: 'ExpertCuratedItemRemovedState',
  by?: Maybe<ExpertCuratedItemRemovedBy>,
  reason: ExpertCuratedItemRemovedReason,
  otherReason?: Maybe<Scalars['String']>,
};

export type ExpertCuratedItemsByCategories = {
   __typename: 'ExpertCuratedItemsByCategories',
  /** Note that this is primarily here to be used as a cache key, not as actual data */
  id: Scalars['LeadId'],
  /** If omitted, defaults to only including ACTIVE */
  categories: Array<ExpertCuratedItemsByCategory>,
  /** All business users that are responsible for the curations */
  experts: Array<BusinessUser>,
};


export type ExpertCuratedItemsByCategoriesCategoriesArgs = {
  filters?: Maybe<Array<ExpertCuratedItemStateFilter>>
};

export type ExpertCuratedItemsByCategory = {
   __typename: 'ExpertCuratedItemsByCategory',
  /** This is an opaque token to be used as a cache key for this grouping of data; it has no meaning else wise */
  id: Scalars['String'],
  category: Category,
  items: Array<ExpertCuratedItem>,
};


export type ExpertCuratedItemsByCategoryItemsArgs = {
  sort?: Maybe<ExpertCuratedItemSort>
};

export type ExpertCuratedItemsByCategoryChangedPayload = {
   __typename: 'ExpertCuratedItemsByCategoryChangedPayload',
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories,
};

export type ExpertCuratedItemsChangedPayload = {
   __typename: 'ExpertCuratedItemsChangedPayload',
  leadId: Scalars['LeadId'],
};

export type ExpertCuratedItemsForLeadPayload = {
   __typename: 'ExpertCuratedItemsForLeadPayload',
  id: Scalars['LeadId'],
  /** If filter is omitted, defaults to only including ACTIVE */
  items: Array<ExpertCuratedItem>,
  byCategories: ExpertCuratedItemsByCategories,
  activationsConnection: ExpertCuratedItemActivationsConnection,
};


export type ExpertCuratedItemsForLeadPayloadItemsArgs = {
  filters?: Maybe<Array<ExpertCuratedItemStateFilter>>,
  first?: Maybe<Scalars['Int']>,
  sort?: Maybe<ExpertCuratedItemSort>
};


export type ExpertCuratedItemsForLeadPayloadActivationsConnectionArgs = {
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};

export enum ExpertCuratedItemSort {
  /** Use the default sorting; this is the default, and should always be used in the consumer use case. */
  DEFAULT = 'DEFAULT',
  /** 
 * Sort only by createdAt which guarantees consistent sorting when the expert is modifying expert curated items
   * (e.g.: changing the tags, which typically changes sort order)
 **/
  CREATED_AT = 'CREATED_AT'
}

/** Basic filters based on state. When multiple filters are applied, they are OR-ed together. */
export enum ExpertCuratedItemStateFilter {
  /** Include items that are in draft state (only valid for experts) */
  DRAFT = 'DRAFT',
  /** Include items that are active (not in draft state, not removed) */
  ACTIVE = 'ACTIVE',
  /** Include items that are removed */
  REMOVED = 'REMOVED',
  /** Include items that not removed */
  NOT_REMOVED = 'NOT_REMOVED'
}

export type ExpertCuratedItemTag = {
   __typename: 'ExpertCuratedItemTag',
  type: ExpertCuratedItemTagType,
  /** Display Label */
  displayLabel: Scalars['String'],
};

export type ExpertCuratedItemTagInput = {
  type: ExpertCuratedItemTagType,
  /** Required for CUSTOM; natural defaults for EXPERT_PICK and BUDGET_PICK */
  displayLabel?: Maybe<Scalars['String']>,
};

export enum ExpertCuratedItemTagType {
  SPECIAL_OFFER = 'SPECIAL_OFFER',
  THE_ALTERNATIVE = 'THE_ALTERNATIVE',
  SALE_PRICE = 'SALE_PRICE',
  EXPERT_PICK = 'EXPERT_PICK',
  BUDGET_PICK = 'BUDGET_PICK',
  CUSTOM = 'CUSTOM',
  OTHER = 'OTHER'
}

export type ExpertCuratedLeadItinerary = {
   __typename: 'ExpertCuratedLeadItinerary',
  id: Scalars['LeadId'],
  contentfulVariation: Scalars['String'],
  /** 
 * Convienence resolver that's the equivalent of invoking `findContentByTemplate` with `contentfulVariation` as
   * the variation on the itinerary space, and "itineraryPage" template.
 **/
  contentfulObject?: Maybe<ContentObject>,
};

/** An order curated (created by) an expert */
export type ExpertCuratedOrder = {
   __typename: 'ExpertCuratedOrder',
  id: Scalars['ExpertCuratedOrderId'],
  createdAt: Scalars['Date'],
  /** The lead between the user and expert this curation was made for */
  lead: Lead,
  /** Expert that created this curation */
  curator: BusinessUser,
  /** Only for trigger entity to avoid unnecessary look up of BusinessUser */
  curatorId: Scalars['BusinessUserId'],
  /** The user this curated order is for */
  curatedFor: User,
  /** Order that was curated */
  order: Order,
  /** The date at which this order started to be available (entered ACTIVE) state */
  availableAt?: Maybe<Scalars['Date']>,
  /** if and when this curated order will expire */
  expiresAt?: Maybe<Scalars['Date']>,
  /** if `state` == `CLOSED`, this is the date it became closed (no longer available for purchase by the consumer) */
  closedAt?: Maybe<Scalars['Date']>,
  /** Reason the order was closed */
  closedReason?: Maybe<ExpertCuratedOrderClosedReason>,
  /** If and when this curated order was last viewed */
  viewedAt?: Maybe<Scalars['Date']>,
  /** Current state of the order */
  state: ExpertCuratedOrderState,
  /** The available variations for the order. The consumer can select between available variations. */
  variationOptions: Array<ExpertCuratedOrderVariationOption>,
  /** Extra line items that are part of the order, but aren't backed by `items`. e.g.: gratuity. Only for display. */
  readOnlyLineItems: Array<ExpertCuratedOrderLineItem>,
  /** Add-on items, where optional items can be unselected (removed from the final order) by the user */
  items: Array<ExpertCuratedOrderItem>,
  /** The total amount of time this order is set to be available for purchase by the consumer */
  availableForPurchaseDurationMinutes?: Maybe<Scalars['Int']>,
  /** The date the service is scheduled for the user */
  serviceStartAt?: Maybe<Scalars['Date']>,
  /** 
 * If specified, the percent (between 1 and 99) of the total order value (before taxes and promotions) that is required
   * as an initial deposit
 **/
  minimumDepositPercent?: Maybe<Scalars['Int']>,
  /** If specified, the percent (greater than 0) of the base order value (excluding tax, tips, gra) prepaid incidental */
  prepaidIncidentalPercent?: Maybe<Scalars['Int']>,
  /** When deposit is used, this is the days betfore `serviceStartAt` the remaining payment is due. */
  fullPaymentDueBeforeServiceStartDays?: Maybe<Scalars['Int']>,
  /** Derived payment due date from `fullPaymentDueBeforeServiceStartDays` */
  fullPaymentDueAt?: Maybe<Scalars['Date']>,
  consumerUrl: Scalars['String'],
  /** 
 * Custom service orders are unique in that the actual curated experience is not purchase-able, but rather only
   * additional `items` are. The sellable service is still used as a parent line item to identify
   * what the extra addons are for, and for taxing the new items correctly, but the actual price of the service isn't
   * added in (and similarly, gratuity and such aren't added). This allows experts to extend a curated order of
   * arbitrary content after extending an initial curated order.
 **/
  custom: Scalars['Boolean'],
  /** 
 * If the curated order is in preview state; in other words, view-able by the consumer, but not purchase-able.
   * Curated orders in preview state cannot be purchased, and as such have lighter data requirements (e.g.: no
   * service start time is required). This allows surfacing curated orders to the customer to discuss, without the
   * expert having to have all the inventory secured while just discussing options.
 **/
  inPreview: Scalars['Boolean'],
  /** Expert only field to view a pending draft update for this record */
  pendingDraftUpdate?: Maybe<ExpertCuratedOrder>,
  /** Previous expert curated order this order is replacing (if state is draft) / replaced (if state is not draft) */
  supersededOrder?: Maybe<ExpertCuratedOrder>,
  /** 
 * If this expert curated order has been replaced by an updated order, this is the latest active expert curated order.
   * for example, if curated order A was replaced by A1, and A1 was replaced by A2, and A2 is active, this property for A
   * and A1 would resolve to A2. If there is no active replacement order, this will return null.
 **/
  activeReplacementOrder?: Maybe<ExpertCuratedOrder>,
  /** The address which this service will be performed */
  serviceLocation?: Maybe<PostalAddress>,
  /** 
 * Based on the `serviceLocation` and service being offered, if we support automatic tax computation. If not, it's
   * expected the expert will manually enter the tax.
 **/
  taxWillBeAutomaticallyComputed: Scalars['Boolean'],
  /** For services that involve flight (e.g.: jet charters), the flight plan associated with this service. */
  flightPlan?: Maybe<FlightPlan>,
  defaultManualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustment>,
  category: Category,
  /** used for email template. */
  selectedVariationOption: ExpertCuratedOrderVariationOption,
  /** used for email template */
  variationOptionsWithPriceBreakdown: Array<ExpertCuratedOrderVariationOptionPriceBreakdown>,
  /** used for expert notes */
  expertNote?: Maybe<Scalars['String']>,
};


/** An order curated (created by) an expert */
export type ExpertCuratedOrderVariationOptionsWithPriceBreakdownArgs = {
  maxOptions?: Maybe<Scalars['Int']>
};

export type ExpertCuratedOrderActivationError = {
   __typename: 'ExpertCuratedOrderActivationError',
  expertCuratedOrder: ExpertCuratedOrder,
  errorMessage?: Maybe<Scalars['String']>,
};

export type ExpertCuratedOrderAddOn = {
   __typename: 'ExpertCuratedOrderAddOn',
  title: Scalars['String'],
  totalCost: MonetaryAmount,
};

export type ExpertCuratedOrderChangedPayload = {
   __typename: 'ExpertCuratedOrderChangedPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

export enum ExpertCuratedOrderClosedReason {
  MANUAL = 'MANUAL',
  REPLACED = 'REPLACED'
}


export type ExpertCuratedOrderItem = {
   __typename: 'ExpertCuratedOrderItem',
  id: Scalars['SellableId'],
  title: Scalars['String'],
  price: MonetaryAmount,
  sellable: Sellable,
  taxable: Scalars['Boolean'],
  optional: Scalars['Boolean'],
  selected: Scalars['Boolean'],
  manualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustment>,
};

/** References existing line items from the underlying order that aren't reified by this expert curated order */
export type ExpertCuratedOrderLineItem = {
   __typename: 'ExpertCuratedOrderLineItem',
  id: Scalars['OrderLineItemId'],
  title: Scalars['String'],
  price: MonetaryAmount,
  orderLineItem: OrderLineItem,
};

export type ExpertCuratedOrderListActivation = {
   __typename: 'ExpertCuratedOrderListActivation',
  id: Scalars['ExpertCuratedOrderListActivationId'],
  createdAt: Scalars['Date'],
  /** expert that activated these curated orders */
  activatedBy: BusinessUser,
  /** user these curated orders were created for; de-normalized from the lead */
  createdFor: User,
  /** the lead associated with this curated list activation */
  lead: Lead,
  /** expert curated orders that were just activated as part of this activation */
  activated: Array<ExpertCuratedOrder>,
  /** expert curated orders that were previously activated, and still active as part of this activation */
  existingActive: Array<ExpertCuratedOrder>,
  /** get all active curated orders as part of this activation */
  active: Array<ExpertCuratedOrder>,
  /** 
 * expert curated order ids that were previously activated, but closed (removed) due to being superseded by the orders
   * in `activated`.
 **/
  closed: Array<ExpertCuratedOrder>,
  consumerUrl: Scalars['String'],
  previousActivation?: Maybe<ExpertCuratedOrderListActivation>,
  /** used for trigger entity only to avoid unnecessary look up of Business User */
  activatedById: Scalars['BusinessUserId'],
};

export type ExpertCuratedOrderListActivationConnection = {
   __typename: 'ExpertCuratedOrderListActivationConnection',
  edges: Array<ExpertCuratedOrderListActivationEdge>,
  pageInfo: PageInfo,
};

export type ExpertCuratedOrderListActivationEdge = {
   __typename: 'ExpertCuratedOrderListActivationEdge',
  node: ExpertCuratedOrderListActivation,
  cursor: Scalars['String'],
};


export type ExpertCuratedOrderManualTaxAdjustment = {
   __typename: 'ExpertCuratedOrderManualTaxAdjustment',
  taxRate?: Maybe<Scalars['BigDecimal']>,
  amount?: Maybe<MonetaryAmount>,
  computedFromAmount?: Maybe<MonetaryAmount>,
};

export type ExpertCuratedOrderManualTaxAdjustmentInput = {
  taxRate?: Maybe<Scalars['BigDecimal']>,
  amount?: Maybe<MonetaryAmountInput>,
  computedFromAmount?: Maybe<MonetaryAmountInput>,
};

export enum ExpertCuratedOrderSelectErrorCode {
  /** 
 * Expert curated order is not in an active state. This may be due to the curated order being replaced, or manually
   * closed. If being replaced, {@link #getActiveReplacement()} will have the updated curated order.
 **/
  NOT_ACTIVE = 'NOT_ACTIVE'
}

export enum ExpertCuratedOrderServiceLocationErrorCode {
  /** An invalid address was supplied. */
  INVALID_ADDRESS = 'INVALID_ADDRESS'
}

export type ExpertCuratedOrdersForLeadConnection = {
   __typename: 'ExpertCuratedOrdersForLeadConnection',
  edges: Array<ExpertCuratedOrdersForLeadEdge>,
  pageInfo: PageInfo,
};

export type ExpertCuratedOrdersForLeadConnectionChangedPayload = {
   __typename: 'ExpertCuratedOrdersForLeadConnectionChangedPayload',
  connection: ExpertCuratedOrdersForLeadConnection,
};

export type ExpertCuratedOrdersForLeadEdge = {
   __typename: 'ExpertCuratedOrdersForLeadEdge',
  node: ExpertCuratedOrder,
  cursor: Scalars['String'],
};

export enum ExpertCuratedOrdersForLeadQueryCustomFilter {
  /** Show custom and not custom */
  INCLUDE = 'INCLUDE',
  /** Only show custom */
  ONLY = 'ONLY',
  /** Show no custom; only non custom */
  NONE = 'NONE'
}

export enum ExpertCuratedOrdersForLeadQueryDraftFilter {
  /** Show all drafts and non drafts */
  INCLUDE = 'INCLUDE',
  /** Show drafts that are newly created (not from replacing an existing curated order) and non drafts */
  INCLUDE_CREATED_DRAFT = 'INCLUDE_CREATED_DRAFT',
  /** Only show drafts (and no non drafts) */
  ONLY = 'ONLY',
  /** Show no drafts; only non drafts */
  NONE = 'NONE'
}

export type ExpertCuratedOrdersForLeadQueryInput = {
  leadId: Scalars['LeadId'],
  /** Defaults to `NONE` */
  draftFilter?: Maybe<ExpertCuratedOrdersForLeadQueryDraftFilter>,
  /** Defaults to `NONE` */
  customFilter?: Maybe<ExpertCuratedOrdersForLeadQueryCustomFilter>,
  /** Show curated orders that are in state EXPIRED or CLOSED, defaults to false */
  showClosed?: Maybe<Scalars['Boolean']>,
};

export enum ExpertCuratedOrderState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  EXPIRED = 'EXPIRED'
}

export type ExpertCuratedOrderVariationOption = {
   __typename: 'ExpertCuratedOrderVariationOption',
  sellable: Sellable,
  price: MonetaryAmount,
  enabled: Scalars['Boolean'],
  selected: Scalars['Boolean'],
  manualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustment>,
};

/** This is only used for curated order email template, where we want to list the order details for every variant. */
export type ExpertCuratedOrderVariationOptionPriceBreakdown = {
   __typename: 'ExpertCuratedOrderVariationOptionPriceBreakdown',
  option: ExpertCuratedOrderVariationOption,
  gratuity: MonetaryAmount,
  basePrice: MonetaryAmount,
  tax: MonetaryAmount,
  totalCost: MonetaryAmount,
  totalCostWithoutAddOns: MonetaryAmount,
  prepaidIncidental: MonetaryAmount,
  addOns: Array<ExpertCuratedOrderAddOn>,
};

export enum ExpertGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER'
}

export type ExpertLeadFolder = {
   __typename: 'ExpertLeadFolder',
  id: Scalars['ExpertLeadFolderId'],
  totalCount?: Maybe<Scalars['Int']>,
  revenue?: Maybe<MonetaryAmount>,
  slug: Scalars['String'],
  displayName: Scalars['String'],
};

export type ExpertLeadFolderGroup = {
   __typename: 'ExpertLeadFolderGroup',
  type: ExpertLeadFolderGroupType,
  displayName: Scalars['String'],
  folders: Array<ExpertLeadFolder>,
};

export enum ExpertLeadFolderGroupType {
  INBOX = 'INBOX',
  INBOX_ASSISTANT = 'INBOX_ASSISTANT',
  SALES_PIPELINE = 'SALES_PIPELINE',
  FOLDERS = 'FOLDERS'
}


export type ExpertLeadFolderItemChange = {
   __typename: 'ExpertLeadFolderItemChange',
  lead: Lead,
  type: ExpertLeadFolderItemChangeType,
};

export enum ExpertLeadFolderItemChangeType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE'
}

export enum ExpertNewMessageNotificationMode {
  NONE = 'NONE',
  ALWAYS = 'ALWAYS',
  WHEN_NOT_ACTIVATED = 'WHEN_NOT_ACTIVATED',
  WHEN_NOT_ONLINE = 'WHEN_NOT_ONLINE'
}

export type ExpertNoteStatsPagination = {
   __typename: 'ExpertNoteStatsPagination',
  sellableExpertNoteStats: Array<SellableExpertNoteStats>,
  count: Scalars['Int'],
};

export enum ExpertNoteStatsSort {
  /** Number of approved review */
  APPROVED = 'APPROVED',
  /** Number of pending review */
  PENDING = 'PENDING',
  /** Number of rejected review */
  REJECTED = 'REJECTED'
}

export type ExpertNotification = {
  type: ExpertNotificationType,
  occurredAt: Scalars['Date'],
};

export type ExpertNotificationLeadEscalation = ExpertNotification & {
   __typename: 'ExpertNotificationLeadEscalation',
  type: ExpertNotificationType,
  leadEscalation?: Maybe<LeadEscalation>,
  occurredAt: Scalars['Date'],
};

export type ExpertNotificationLeadSurge = ExpertNotification & {
   __typename: 'ExpertNotificationLeadSurge',
  type: ExpertNotificationType,
  leadSurge: LeadSurge,
  occurredAt: Scalars['Date'],
};

export type ExpertNotificationPresenceStatusChange = ExpertNotification & {
   __typename: 'ExpertNotificationPresenceStatusChange',
  type: ExpertNotificationType,
  expert: BusinessUser,
  previousStatus?: Maybe<ExpertPresenceStatus>,
  occurredAt: Scalars['Date'],
};

export type ExpertNotificationShiftEnded = ExpertNotification & {
   __typename: 'ExpertNotificationShiftEnded',
  type: ExpertNotificationType,
  expert: BusinessUser,
  occurredAt: Scalars['Date'],
  previousStatus: ExpertPresenceStatus,
};

export enum ExpertNotificationType {
  LEAD_ESCALATION = 'LEAD_ESCALATION',
  PRESENCE_STATUS_CHANGE = 'PRESENCE_STATUS_CHANGE',
  SHIFT_ENDED = 'SHIFT_ENDED',
  LEAD_SURGE = 'LEAD_SURGE'
}

export type ExpertPerformance = {
   __typename: 'ExpertPerformance',
  rating: ExpertPerformanceRating,
};

export enum ExpertPerformanceRating {
  NEW = 'NEW',
  PLATINUM = 'PLATINUM',
  GOLD = 'GOLD',
  SILVER = 'SILVER',
  BRONZE = 'BRONZE'
}

export type ExpertPerformanceStatistics = {
   __typename: 'ExpertPerformanceStatistics',
  expert: BusinessUser,
  category?: Maybe<Category>,
  sixtyDayStats: ExpertPerformanceStatisticsForInterval,
  threeSixtyFiveDayStats: ExpertPerformanceStatisticsForInterval,
  effectiveRevenuePerLead: MonetaryAmount,
};

export type ExpertPerformanceStatisticsFilter = {
  categoryId?: Maybe<Scalars['CategoryId']>,
  departmentId?: Maybe<Scalars['DepartmentId']>,
  teamId?: Maybe<Scalars['BusinessUserTeamId']>,
};

export type ExpertPerformanceStatisticsForInterval = {
   __typename: 'ExpertPerformanceStatisticsForInterval',
  shiftCount: Scalars['Int'],
  activeLeads: Scalars['Int'],
  directActiveLeads: Scalars['Int'],
  directQualityConversations: Scalars['Int'],
  activeLeadsWithPurchase: Scalars['Int'],
  directActiveLeadsWithPurchase: Scalars['Int'],
  totalBaseRevenueAmount: MonetaryAmount,
  totalTipAmount: MonetaryAmount,
  strictRevenuePerLead: MonetaryAmount,
  looseRevenuePerLead: MonetaryAmount,
  effectiveRevenuePerLead: MonetaryAmount,
  directLeadConversionRate: Scalars['BigDecimal'],
  directLeadQualityConversationRate: Scalars['BigDecimal'],
};

export type ExpertPerformanceStatisticsPayload = {
   __typename: 'ExpertPerformanceStatisticsPayload',
  rows: Array<ExpertPerformanceStatistics>,
  count: Scalars['Int'],
};

export type ExpertPresence = {
  status: ExpertPresenceStatus,
};

export type ExpertPresenceAway = ExpertPresence & {
   __typename: 'ExpertPresenceAway',
  status: ExpertPresenceStatus,
  startedAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  autoReply: AwayAutoReply,
};

export type ExpertPresenceOffShift = ExpertPresence & {
   __typename: 'ExpertPresenceOffShift',
  status: ExpertPresenceStatus,
};

export type ExpertPresenceOnCall = ExpertPresence & {
   __typename: 'ExpertPresenceOnCall',
  status: ExpertPresenceStatus,
  startedAt: Scalars['Date'],
  endsAt: Scalars['Date'],
};

export type ExpertPresenceOnShift = ExpertPresence & {
   __typename: 'ExpertPresenceOnShift',
  status: ExpertPresenceStatus,
  startedAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  acceptingNewLeads: Scalars['Boolean'],
};

export enum ExpertPresenceStatus {
  OFF_SHIFT = 'OFF_SHIFT',
  ON_SHIFT = 'ON_SHIFT',
  ON_CALL = 'ON_CALL',
  AWAY = 'AWAY'
}

export type ExpertPresenceStatusUpdateResponse = {
   __typename: 'ExpertPresenceStatusUpdateResponse',
  businessUser?: Maybe<BusinessUser>,
  error?: Maybe<Scalars['String']>,
};

export type ExpertProfile = {
   __typename: 'ExpertProfile',
  id: Scalars['ExpertProfileId'],
  user: User,
  headline: Scalars['String'],
  background: Scalars['String'],
  backgroundRichText?: Maybe<Scalars['String']>,
  location?: Maybe<Scalars['String']>,
  profilePhoto?: Maybe<MediaFile>,
  gallery: Array<MediaFileWithCaption>,
  recentArticles: Array<ExternalContent>,
  quotes: Array<Scalars['String']>,
  isDraft: Scalars['Boolean'],
  socialMediaUrls: Array<Scalars['String']>,
  socialMediaLinks: Array<SocialMediaLink>,
  highlights: Array<ProfileHighlight>,
  editableHighlightTypes: Array<ProfileHighlightType>,
  state: ExpertProfileState,
  businessUser: BusinessUser,
  submittedAt?: Maybe<Scalars['Date']>,
  publishedAt?: Maybe<Scalars['Date']>,
  changeRequestedAt?: Maybe<Scalars['Date']>,
  changeRequestNotes?: Maybe<Scalars['String']>,
  introductionVideoUrl?: Maybe<Scalars['String']>,
  introductionVideo?: Maybe<MediaFile>,
  introductionVideoLink?: Maybe<ExternalVideoLink>,
  socialMediaAccessTokens: Array<SocialMediaAccessToken>,
  currentGears: Array<Sellable>,
  favoriteBrands: Array<Brand>,
  gender?: Maybe<ExpertGender>,
  portraitVideo?: Maybe<MediaFile>,
  spotlightHeadline?: Maybe<Scalars['String']>,
};


export type ExpertProfileQuery = {
  states: Array<ExpertProfileState>,
};

export type ExpertProfileRequestChangesInput = {
  expertProfileId: Scalars['ExpertProfileId'],
  notes?: Maybe<Scalars['String']>,
};

export type ExpertProfilesPagination = {
   __typename: 'ExpertProfilesPagination',
  profiles: Array<ExpertProfile>,
  count: Scalars['Long'],
};

export enum ExpertProfileState {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  PUBLISHED = 'PUBLISHED'
}

export type ExpertRecommendationByLeastWorkloadRecord = ExpertRecommendationRecord & {
   __typename: 'ExpertRecommendationByLeastWorkloadRecord',
  id: Scalars['ExpertRecommendationId'],
  strategy: ExpertRecommendationStrategy,
  occurredAt: Scalars['Date'],
  consumer: User,
  assignedTo?: Maybe<BusinessUser>,
  resultingLead?: Maybe<Lead>,
  resultingLeadCreatedAt?: Maybe<Scalars['Date']>,
  primaryExperts: Array<BusinessUser>,
  backupExperts: Array<BusinessUser>,
  expertWorkloads: Array<ExpertWorkloadForRecommendation>,
  fallbackExpertUsed: Scalars['Boolean'],
};

export type ExpertRecommendationByPerformanceWeightCandidate = {
   __typename: 'ExpertRecommendationByPerformanceWeightCandidate',
  expert: BusinessUser,
  rating: ExpertPerformanceRating,
  externalMarketingBudget: MonetaryAmount,
  workload: Scalars['Float'],
  capacity: Scalars['Float'],
  acceptingNewLead: Scalars['Boolean'],
};

export type ExpertRecommendationByPerformanceWeightRecord = ExpertRecommendationRecord & {
   __typename: 'ExpertRecommendationByPerformanceWeightRecord',
  id: Scalars['ExpertRecommendationId'],
  strategy: ExpertRecommendationStrategy,
  occurredAt: Scalars['Date'],
  consumer: User,
  assignedTo?: Maybe<BusinessUser>,
  resultingLead?: Maybe<Lead>,
  resultingLeadCreatedAt?: Maybe<Scalars['Date']>,
  fallbackExpertUsed: Scalars['Boolean'],
  expertCandidates: Array<ExpertRecommendationByPerformanceWeightCandidate>,
  newRelationship: Scalars['Boolean'],
};


export type ExpertRecommendationRecord = {
  id: Scalars['ExpertRecommendationId'],
  strategy: ExpertRecommendationStrategy,
  occurredAt: Scalars['Date'],
  consumer: User,
  assignedTo?: Maybe<BusinessUser>,
  resultingLead?: Maybe<Lead>,
  resultingLeadCreatedAt?: Maybe<Scalars['Date']>,
};

export enum ExpertRecommendationStrategy {
  LEAST_WORKLOAD = 'LEAST_WORKLOAD',
  PERFORMANCE_WEIGHTED = 'PERFORMANCE_WEIGHTED'
}

export type ExpertReferral = {
   __typename: 'ExpertReferral',
  id: Scalars['ExpertReferralId'],
  expert: BusinessUser,
  referrer: User,
  note: Scalars['String'],
  referralUrl: Scalars['String'],
  fromExpert: Scalars['Boolean'],
  contactType: ContactType,
  contactValue: Scalars['String'],
};


export type ExpertSearchConnection = {
   __typename: 'ExpertSearchConnection',
  facets: Array<DisplayFacet>,
  edges: Array<ExpertSearchEdge>,
  pageInfo: PageInfo,
  count: Scalars['Int'],
};

export type ExpertSearchEdge = {
   __typename: 'ExpertSearchEdge',
  node: BusinessUser,
  cursor: Scalars['String'],
};

export type ExpertSearchQuery = {
  name?: Maybe<Scalars['String']>,
  keywords?: Maybe<Scalars['String']>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  departmentIds?: Maybe<Array<Scalars['DepartmentId']>>,
  facetedSearch: Scalars['Boolean'],
  facets?: Maybe<Array<FacetSelection>>,
  includePlaceHolderExpert?: Maybe<Scalars['Boolean']>,
  featuredOnly?: Maybe<Scalars['Boolean']>,
};

export enum ExpertSearchSort {
  DEFAULT = 'DEFAULT',
  PERFORMANCE = 'PERFORMANCE',
  FEATURED = 'FEATURED'
}

export type ExpertSellableRecommendationCount = {
   __typename: 'ExpertSellableRecommendationCount',
  expert: BusinessUser,
  timesRecommended: Scalars['Int'],
};

export type ExpertSellableRecommendationCountConnection = {
   __typename: 'ExpertSellableRecommendationCountConnection',
  pageInfo: PageInfo,
  /** The total number of experts recommending the sellable */
  total: Scalars['Int'],
  /** the number of experts in this page */
  count: Scalars['Int'],
  /** number of times this sellable was recommended by across all experts */
  timesRecommendedByAllExperts: Scalars['Int'],
  edges: Array<ExpertSellableRecommendationCountEdge>,
};

export type ExpertSellableRecommendationCountEdge = {
   __typename: 'ExpertSellableRecommendationCountEdge',
  cursor: Scalars['String'],
  node: ExpertSellableRecommendationCount,
};

export type ExpertStats = {
   __typename: 'ExpertStats',
  totalMessages: Scalars['Int'],
  totalLeads: Scalars['Int'],
  totalMessagesSent: Scalars['Int'],
  totalLeadsAsPrimaryExpert: Scalars['Int'],
  totalLeadsParticipated: Scalars['Int'],
  messageLastSentAt?: Maybe<Scalars['Date']>,
  averageRating?: Maybe<Scalars['Float']>,
  totalReviews: Scalars['Int'],
  topGoodQualities: Array<Scalars['String']>,
};

export type ExpertTipPercentage = {
   __typename: 'ExpertTipPercentage',
  expert: BusinessUser,
  /** Value between 1 and 100 */
  percentOfTip: Scalars['Int'],
};

export type ExpertTipPercentageInput = {
  expertId: Scalars['BusinessUserId'],
  /** Value between 1 and 100 */
  percentOfTip: Scalars['Int'],
};

export type ExpertTopRecommendedBrand = {
   __typename: 'ExpertTopRecommendedBrand',
  brand: Brand,
  timesRecommended?: Maybe<Scalars['Int']>,
};

export type ExpertTopRecommendedBrandsInput = {
  expertId: Scalars['BusinessUserId'],
  departmentId: Scalars['DepartmentId'],
  topN?: Maybe<Scalars['Int']>,
};

export type ExpertTopRecommendedBrandsPayload = {
   __typename: 'ExpertTopRecommendedBrandsPayload',
  topRecommendedBrands: Array<ExpertTopRecommendedBrand>,
};

export type ExpertTopRecommendedSellable = {
   __typename: 'ExpertTopRecommendedSellable',
  sellable: Sellable,
  timesRecommended?: Maybe<Scalars['Int']>,
};

export type ExpertTopRecommendedSellablesInput = {
  expertId: Scalars['BusinessUserId'],
  departmentId: Scalars['DepartmentId'],
  maxRecommendationsPerCategory?: Maybe<Scalars['Int']>,
  recommendedAfter?: Maybe<Scalars['Date']>,
};

export type ExpertTopRecommendedSellablesPayload = {
   __typename: 'ExpertTopRecommendedSellablesPayload',
  categoryTopRecommendedSellables: Array<ExpertCategoryTopRecommendedSellable>,
};

export type ExpertTypeaheadPayload = {
   __typename: 'ExpertTypeaheadPayload',
  experts: Array<BusinessUser>,
};

export type ExpertTypeaheadQuery = {
  prefixSearch: Scalars['String'],
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
};

export type ExpertWorkloadForRecommendation = {
   __typename: 'ExpertWorkloadForRecommendation',
  expert: BusinessUser,
  workload: Scalars['Float'],
  capacity: Scalars['Float'],
};

export type ExtendExpertCuratedItemExpirationInput = {
  id: Scalars['ExpertCuratedItemId'],
  /** When the top-level sellable is ad-hoc, to extend the expiration, a new sale price must be provided */
  salePrice?: Maybe<MonetaryAmountInput>,
};

export type ExtendExpertCuratedItemExpirationPayload = {
   __typename: 'ExtendExpertCuratedItemExpirationPayload',
  expertCuratedItem?: Maybe<ExpertCuratedItem>,
  error?: Maybe<Scalars['String']>,
  hasError: Scalars['Boolean'],
};

export type ExternalAdCampaign = {
   __typename: 'ExternalAdCampaign',
  id: Scalars['ExternalAdCampaignId'],
  name: Scalars['String'],
  adPlatform: ExternalAdPlatform,
  category: Category,
  externalId: Scalars['String'],
  status: ExternalAdStatus,
  /** 
 * The normalized budget allocated to this campaign. The value here means assuming the total budget is 100, what would
   * be the budget allocated for this campaign. For example, if the value is 30, and the total budget is 150, the actual
   * budget for this campaign is 45.
 **/
  normalizedBudget: Scalars['BigDecimal'],
  adGroups: Array<ExternalAdGroup>,
};


export type ExternalAdGroup = {
   __typename: 'ExternalAdGroup',
  id: Scalars['ExternalAdGroupId'],
  adCampaign: ExternalAdCampaign,
  name: Scalars['String'],
  adPlatform: ExternalAdPlatform,
  externalId: Scalars['String'],
  status: ExternalAdStatus,
  /** 
 * The normalized budget allocated to this ad group. The value here means assuming the total budget is 100, what would
   * be the budget allocated for this ad group. For example, if the value is 30, and the total budget is 150, the actual
   * budget for this ad group is 45.
 **/
  normalizedBudget?: Maybe<Scalars['BigDecimal']>,
  /** 
 * The campaign normalized budget allocated to this ad group. The value here means assuming the campaign budget is
   * 100, what would be the budget allocated for this ad group. This value is used to calculate the normalized budget.
 **/
  campaignNormalizedBudget?: Maybe<Scalars['BigDecimal']>,
};


export enum ExternalAdPlatform {
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE'
}

export enum ExternalAdStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  DELETED = 'DELETED'
}

export type ExternalContent = {
   __typename: 'ExternalContent',
  title: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  url: Scalars['String'],
  imageUrl?: Maybe<Scalars['String']>,
};

export type ExternalContentInput = {
  title: Scalars['String'],
  url: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  imageUrl?: Maybe<Scalars['String']>,
};

export type ExternalInventoryItemSource = {
  type: ExternalInventoryItemSourceType,
};

export enum ExternalInventoryItemSourceType {
  SHOPIFY = 'SHOPIFY'
}

export type ExternalProfile = {
  type: ExternalProfileType,
};

export enum ExternalProfileType {
  FACEBOOK_MESSENGER = 'FACEBOOK_MESSENGER',
  PIPL = 'PIPL'
}

export type ExternalVideo = {
   __typename: 'ExternalVideo',
  /** 
 * ID for the video. This can be extracted from the url, for example, url `https://www.youtube.com/watch?v=0tHH0BNH0Sc`
   * has an id of `0tHH0BNH0Sc`
 **/
  id: Scalars['String'],
  /** Video type */
  idType: ExternalVideoIdType,
  /** This is the url to view the video on the website for idType */
  destinationUrl: Scalars['String'],
};

export enum ExternalVideoIdType {
  YOUTUBE = 'YOUTUBE',
  VIMEO = 'VIMEO'
}

export type ExternalVideoLink = {
   __typename: 'ExternalVideoLink',
  smallUrl: Scalars['String'],
  mediumUrl: Scalars['String'],
  largeUrl: Scalars['String'],
  xLargeUrl: Scalars['String'],
};

export type ExternalVideoLinkInput = {
  smallUrl: Scalars['String'],
  mediumUrl: Scalars['String'],
  largeUrl: Scalars['String'],
  xLargeUrl: Scalars['String'],
};

export type FacebookMessengerPathFlowPageMetadata = PathFlowPageMetadata & {
   __typename: 'FacebookMessengerPathFlowPageMetadata',
  type: PathFlowPageMetadataType,
};

export type FacebookMessengerProfile = ExternalProfile & {
   __typename: 'FacebookMessengerProfile',
  id: Scalars['String'],
  type: ExternalProfileType,
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  avatarUrl?: Maybe<Scalars['String']>,
  locale?: Maybe<Scalars['String']>,
  timezone?: Maybe<Scalars['String']>,
  gender?: Maybe<Scalars['String']>,
};

export type FacebookTcpaComplianceMetadata = PathFlowPageMetadata & {
   __typename: 'FacebookTCPAComplianceMetadata',
  type: PathFlowPageMetadataType,
};

export type FacebookTemplate = ChannelTemplate & {
   __typename: 'FacebookTemplate',
  channelType: ChannelType,
  body: Scalars['String'],
};

export type FacebookTemplateInput = {
  body: Scalars['String'],
};

export type FacetImageMetadata = {
  type: FacetImageType,
};

export enum FacetImageType {
  /** Facets that are shown as Icons on the UI */
  ICON = 'ICON',
  /** BACKGROUND */
  BACKGROUND = 'BACKGROUND'
}

export type FacetSelection = {
  /** Internal name or alias for facet that's being selected, typically from DisplayFacet.name or DisplayFacet.alias */
  name: Scalars['String'],
  /** If this facet is a BucketedDisplayFacet, the `IndividualBucketedDisplayFacet.value`s that were selected. */
  bucketValues?: Maybe<Array<Scalars['String']>>,
  /** If this facet is a NumericRangeDisplayFacet, the unscaled lower bound that's being set. */
  lower?: Maybe<Scalars['Long']>,
  /** If this facet is a NumericRangeDisplayFacet, the unscaled upper bound that's being set. */
  upper?: Maybe<Scalars['Long']>,
  /** 
 * The scale `lower` and `upper` is in; `(value x 10 ^ (-scale))` should be used to compute the actual value.
   * Defaults to 0 (which makes unscaled value == scaled value).
 **/
  scale?: Maybe<Scalars['Int']>,
};

export type FacetSelectionPayload = {
   __typename: 'FacetSelectionPayload',
  name: Scalars['String'],
  displayName: Scalars['String'],
  alias?: Maybe<Scalars['String']>,
  bucketValues?: Maybe<Array<Scalars['String']>>,
  lower?: Maybe<Scalars['Long']>,
  upper?: Maybe<Scalars['Long']>,
  scale?: Maybe<Scalars['Int']>,
};

/** Featured rich content from various sites (e.g.: YouTube, Instagram, review sites, etc) */
export type FeaturedSellableContent = {
   __typename: 'FeaturedSellableContent',
  id: Scalars['SellableId'],
  /** ID portion of instagram url. */
  instagramPostIds: Array<Scalars['String']>,
  /** Relevant instagram hash tag */
  instagramHashTag?: Maybe<Scalars['String']>,
  /** Videos hosted by sites like YouTube */
  externalVideos: Array<ExternalVideo>,
  /** Brochure */
  brochureUrl?: Maybe<Scalars['String']>,
  /** Reviews */
  editorialReviews: Array<EditorialReview>,
};

export type FeaturedSellableContentUploadTaskPayload = {
   __typename: 'FeaturedSellableContentUploadTaskPayload',
  numEntriesProcessed: Scalars['Int'],
  numEntriesIgnored: Scalars['Int'],
  numEntriesCreated: Scalars['Int'],
  numEntriesUpdated: Scalars['Int'],
  errorEntries: Array<Scalars['String']>,
  mediaId: Scalars['MediaId'],
};

export type FieldUpdatedActivity = TicketActivityDetail & {
   __typename: 'FieldUpdatedActivity',
  type: TicketActivityType,
  fieldName: Scalars['String'],
  oldValue: Scalars['String'],
  newValue: Scalars['String'],
};

export type FindOrCreateReplacementExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'],
};

export type FindOrCreateReplacementExpertCuratedOrderPayload = {
   __typename: 'FindOrCreateReplacementExpertCuratedOrderPayload',
  /** The expert curated order that's being replaced */
  superseded: ExpertCuratedOrder,
  /** The found or newly created draft expert curated order that can be modified, and subsequently activated */
  draft: ExpertCuratedOrder,
};

export type FlightPlan = {
   __typename: 'FlightPlan',
  id: Scalars['FlightPlanId'],
  consumer?: Maybe<User>,
  state: FlightPlanState,
  legs: Array<FlightPlanLeg>,
};

export enum FlightPlanEditErrorCode {
  EMPTY_LEGS = 'EMPTY_LEGS',
  NO_SUCH_LEG = 'NO_SUCH_LEG',
  MISSING_AIRPORT = 'MISSING_AIRPORT',
  SAME_AIRPORT = 'SAME_AIRPORT',
  OVERLAPPING_LEGS = 'OVERLAPPING_LEGS',
  NOT_DRAFT = 'NOT_DRAFT'
}


export type FlightPlanLeg = {
   __typename: 'FlightPlanLeg',
  id: Scalars['FlightPlanLegId'],
  /** One or the other will be specified */
  departAt?: Maybe<Scalars['Date']>,
  departOn?: Maybe<Scalars['LocalDate']>,
  arriveAt?: Maybe<Scalars['Date']>,
  durationInMinutes?: Maybe<Scalars['Int']>,
  flightOperator?: Maybe<Scalars['String']>,
  /** Required for ACTIVE */
  departureAirport?: Maybe<Airport>,
  /** Required for ACTIVE */
  arrivalAirport?: Maybe<Airport>,
};


export type FlightPlanLegUpsertRequestInput = {
  id?: Maybe<Scalars['FlightPlanLegId']>,
  departAt?: Maybe<Scalars['Date']>,
  departOn?: Maybe<Scalars['LocalDate']>,
  durationInMinutes?: Maybe<Scalars['Int']>,
  flightOperator?: Maybe<Scalars['String']>,
  departureAirportId?: Maybe<Scalars['AirportId']>,
  arrivalAirportId?: Maybe<Scalars['AirportId']>,
};

export enum FlightPlanState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE'
}

export type FormattedAttribute = {
   __typename: 'FormattedAttribute',
  name: Scalars['String'],
  internalName: Scalars['String'],
  displayValue: Scalars['String'],
  displayHtml: Scalars['String'],
  displayHtmlValues: Array<Scalars['String']>,
};

export type FrontendTask = {
   __typename: 'FrontendTask',
  id: Scalars['FrontendTaskId'],
  status: FrontendTaskStatus,
  payload?: Maybe<TaskPayload>,
};


export enum FrontendTaskStatus {
  CREATED = 'CREATED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  ABORTED = 'ABORTED'
}

/** 
 * Fulfillment corresponds to the process shipment of 1 or more items. These items can be the same sku or different skus.
 * They can ship in different packages and have multiple tracking numbers, but they are all processed as
 * a single unit for purpose of order fulfillment.
 **/
export type Fulfillment = {
   __typename: 'Fulfillment',
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  status: FulfillmentStatusWithDisplayName,
  /** If the fulfillment was complete, the delivery date */
  deliveredAt?: Maybe<Scalars['Date']>,
  /** Esstimate date of delivery */
  estimatedDeliveryAt?: Maybe<Scalars['Date']>,
  /** If the shipment is in transit, the date of transit */
  inTransitAt?: Maybe<Scalars['Date']>,
  deliveryStatus?: Maybe<FulfillmentOrderDeliveryStatusWithDisplayName>,
  trackingUrls: Array<Scalars['String']>,
  /** Line items as part of the fulfillment. */
  lineItems: Array<FulfillmentLineItem>,
};

export type FulfillmentCenter = {
   __typename: 'FulfillmentCenter',
  id: Scalars['FulfillmentCenterId'],
  name: Scalars['String'],
  active: Scalars['Boolean'],
  /** External id of the fulfillment center if managed by third party managment tool like Shopify */
  externalLocationId?: Maybe<Scalars['String']>,
  serviceTypeWithDisplayName: FulfillmentServiceTypeWithDisplayName,
  serviceProviderWithDiplayName: FulfillmentServiceProviderWithDisplayName,
};

export type FulfillmentCenterConnection = {
   __typename: 'FulfillmentCenterConnection',
  pageInfo: PageInfo,
  edges: Array<FulfillmentCenterEdge>,
};

export type FulfillmentCenterEdge = {
   __typename: 'FulfillmentCenterEdge',
  cursor: Scalars['String'],
  node: FulfillmentCenter,
};


export type FulfillmentCentersQuery = {
  activeOnly: Scalars['Boolean'],
};

export type FulfillmentChannel = {
   __typename: 'FulfillmentChannel',
  id: Scalars['FulfillmentChannelId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  createdBy: FulfillmentChannelWriter,
  updatedBy: FulfillmentChannelWriter,
  type: FulfillmentChannelType,
  name: Scalars['String'],
  instructions: Scalars['String'],
  instructionUrl?: Maybe<Scalars['String']>,
  marginPercent?: Maybe<Scalars['Int']>,
  blacklisted: Scalars['Boolean'],
  shippingOptions: Array<ShippingOption>,
};

export type FulfillmentChannelEdge = {
   __typename: 'FulfillmentChannelEdge',
  node: FulfillmentChannel,
  cursor: Scalars['String'],
};


export type FulfillmentChannelQueryInput = {
  types?: Maybe<Array<FulfillmentChannelType>>,
};

export type FulfillmentChannelsConnection = {
   __typename: 'FulfillmentChannelsConnection',
  edges: Array<FulfillmentChannelEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export enum FulfillmentChannelType {
  WAREHOUSE = 'WAREHOUSE',
  MANUFACTURER = 'MANUFACTURER',
  RETAILER = 'RETAILER',
  GOOGLE_SHOPPING = 'GOOGLE_SHOPPING',
  AD_HOC = 'AD_HOC',
  OFFLINE_PARTNERS = 'OFFLINE_PARTNERS'
}

export type FulfillmentChannelWriter = Operator | SystemUser;

export type FulfillmentLineItem = {
   __typename: 'FulfillmentLineItem',
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  orderLineItem: OrderLineItem,
  status: FulfillmentStatusWithDisplayName,
  requestedQuantity: Scalars['Int'],
  fulfillableQuantity: Scalars['Int'],
  unfulfilledQuantity: Scalars['Int'],
};

export type FulfillmentOrder = {
   __typename: 'FulfillmentOrder',
  id: Scalars['FulfillmentOrderId'],
  createdBy: Operator,
  updatedBy: Operator,
  order: Order,
  fulfillmentCenter?: Maybe<FulfillmentCenter>,
  fulfillmentShipmentMethod?: Maybe<FulfillmentShipmentMethod>,
  fulfillmentOrderSource: FulfillmentOrderSource,
  fulfillments: Array<Fulfillment>,
  shipmentTracking?: Maybe<ShipmentTracking>,
  estimatedDeliveryAt?: Maybe<Scalars['Date']>,
  claimedByMerchant?: Maybe<Merchant>,
};

export enum FulfillmentOrderDeliveryStatus {
  ATTEMPTED_DELIVERY = 'ATTEMPTED_DELIVERY',
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  DELIVERED = 'DELIVERED',
  FAILURE = 'FAILURE',
  FULFILLED = 'FULFILLED',
  IN_TRANSIT = 'IN_TRANSIT',
  LABEL_PRINTED = 'LABEL_PRINTED',
  LABEL_PURCHASED = 'LABEL_PURCHASED',
  LABEL_VOIDED = 'LABEL_VOIDED',
  MARKED_AS_FULFILLED = 'MARKED_AS_FULFILLED',
  NOT_DELIVERED = 'NOT_DELIVERED',
  OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY',
  READY_FOR_PICKUP = 'READY_FOR_PICKUP',
  SUBMITTED = 'SUBMITTED'
}

export type FulfillmentOrderDeliveryStatusWithDisplayName = {
   __typename: 'FulfillmentOrderDeliveryStatusWithDisplayName',
  status: FulfillmentOrderDeliveryStatus,
  displayName: Scalars['String'],
};


export type FulfillmentOrderSource = {
  type: FulfillmentOrderSourceType,
};

export enum FulfillmentOrderSourceType {
  DEAL = 'DEAL',
  SHOPIFY = 'SHOPIFY',
  EXTERNAL_PARTNER = 'EXTERNAL_PARTNER'
}

export type FulfillmentProcessUpdatedActivity = OrderActivityDetail & {
   __typename: 'FulfillmentProcessUpdatedActivity',
  type: OrderActivityDetailType,
  fulfillmentChannel: FulfillmentChannel,
  performedBy: TicketUser,
  status: FulfillmentSuggestionStatus,
  note?: Maybe<Scalars['String']>,
};

export enum FulfillmentServiceProvider {
  DEAL = 'DEAL',
  UPS = 'UPS'
}

export type FulfillmentServiceProviderWithDisplayName = {
   __typename: 'FulfillmentServiceProviderWithDisplayName',
  serviceProvider: FulfillmentServiceProvider,
  displayName: Scalars['String'],
};

export enum FulfillmentServiceType {
  THIRD_PARTY_LOGISTICS = 'THIRD_PARTY_LOGISTICS',
  DEAL_WH = 'DEAL_WH'
}

export type FulfillmentServiceTypeWithDisplayName = {
   __typename: 'FulfillmentServiceTypeWithDisplayName',
  serviceType: FulfillmentServiceType,
  displayName: Scalars['String'],
};

export type FulfillmentShipmentMethod = {
   __typename: 'FulfillmentShipmentMethod',
  id: Scalars['FulfillmentShipmentMethodId'],
  name: Scalars['String'],
  active: Scalars['Boolean'],
  shippingCarrier: ShippingCarrier,
  /** Shipment cost */
  rate?: Maybe<MonetaryAmount>,
};

export type FulfillmentShipmentMethodConnection = {
   __typename: 'FulfillmentShipmentMethodConnection',
  pageInfo: PageInfo,
  edges: Array<FulfillmentShipmentMethodEdge>,
};

export type FulfillmentShipmentMethodEdge = {
   __typename: 'FulfillmentShipmentMethodEdge',
  cursor: Scalars['String'],
  node: FulfillmentShipmentMethod,
};


export type FulfillmentShipmentMethodQuery = {
  carrierId?: Maybe<Scalars['ShippingCarrierId']>,
};

export enum FulfillmentStatus {
  REQUESTED = 'REQUESTED',
  CANCELLED = 'CANCELLED',
  ERROR = 'ERROR',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  PENDING = 'PENDING',
  PARTIAL = 'PARTIAL',
  COMPLETED = 'COMPLETED'
}

export type FulfillmentStatusWithDisplayName = {
   __typename: 'FulfillmentStatusWithDisplayName',
  status: FulfillmentStatus,
  displayName: Scalars['String'],
};

export enum FulfillmentSuggestionStatus {
  PENDING = 'PENDING',
  FULFILLED = 'FULFILLED',
  SKIPPED = 'SKIPPED',
  UNAVAILABLE = 'UNAVAILABLE',
  PRICE_TOO_HIGH = 'PRICE_TOO_HIGH',
  SHIPPING_TOO_SLOW = 'SHIPPING_TOO_SLOW',
  FAILED = 'FAILED'
}

export type GenerateCollectPhoneNumberTextInPathInput = {
  pathFlowId: Scalars['PathFlowId'],
};

export type GenerateCollectPhoneNumberTextInPathPayload = {
   __typename: 'GenerateCollectPhoneNumberTextInPathPayload',
  toNumber: Scalars['String'],
  body: Scalars['String'],
};

export type GenerateTemplateDirectiveSnippetInput = {
  directiveName: Scalars['String'],
  variableName: Scalars['String'],
  parameters: Array<TemplateFragmentParameterValueInput>,
};

export type GenerateTemplateDirectiveSnippetPayload = {
   __typename: 'GenerateTemplateDirectiveSnippetPayload',
  errors: Array<Scalars['String']>,
  content?: Maybe<Scalars['String']>,
};

export type GenerateTemplateFragmentSnippetInput = {
  id: Scalars['CommTemplateFragmentId'],
  parameters: Array<TemplateFragmentParameterValueInput>,
};

export type GenerateTemplateFragmentSnippetPayload = {
   __typename: 'GenerateTemplateFragmentSnippetPayload',
  errors: Array<Scalars['String']>,
  importStatement?: Maybe<Scalars['String']>,
  content?: Maybe<Scalars['String']>,
};

export type GenericInfoBoxPageMetadata = PathFlowPageMetadata & {
   __typename: 'GenericInfoBoxPageMetadata',
  type: PathFlowPageMetadataType,
  body?: Maybe<TextViewModel>,
};

export type GenericModalPageMetadata = PathFlowPageMetadata & {
   __typename: 'GenericModalPageMetadata',
  type: PathFlowPageMetadataType,
  body?: Maybe<TextViewModel>,
  openCtaText?: Maybe<TextViewModel>,
};

export type GeocodingResponse = {
   __typename: 'GeocodingResponse',
  streetNumber?: Maybe<Scalars['String']>,
  street?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  postalCode?: Maybe<Scalars['String']>,
  formattedAddress?: Maybe<Scalars['String']>,
  placeId?: Maybe<Scalars['String']>,
  latitude?: Maybe<Scalars['Float']>,
  longitude?: Maybe<Scalars['Float']>,
};

export type GetOrCreateUserCartForExpertInput = {
  userId: Scalars['UserId'],
};

export type GetOrCreateUserCartForExpertPayload = {
   __typename: 'GetOrCreateUserCartForExpertPayload',
  order: Order,
};

export type GetReferralCodePayload = {
   __typename: 'GetReferralCodePayload',
  error?: Maybe<Scalars['String']>,
  referralCode?: Maybe<ReferralCode>,
};

export type GlobalStatsAggregateExpertReport = {
   __typename: 'GlobalStatsAggregateExpertReport',
  conversationsCountTotal: Scalars['Int'],
  conversationsCountThisWeek: Scalars['Int'],
  averageExpertRating: Scalars['Float'],
  reviewsCount: Scalars['Int'],
  curationsCountTotal: Scalars['Int'],
  curationsCountThisWeek: Scalars['Int'],
};

export type GoogleShoppingSellablePriceSource = SellablePriceSource & {
   __typename: 'GoogleShoppingSellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  bestOfferPrice?: Maybe<MonetaryAmount>,
  cost?: Maybe<MonetaryAmount>,
  expiresAt?: Maybe<Scalars['Date']>,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  googleProductId?: Maybe<Scalars['String']>,
  sellers: Array<SellablePriceSourceGoogleShoppingSeller>,
};

export type GuestConversation = {
   __typename: 'GuestConversation',
  expert: BusinessUser,
  version: Scalars['Int'],
  messages: Array<GuestConversationMessage>,
  signature: Scalars['String'],
};

export type GuestConversationInput = {
  expertId: Scalars['BusinessUserId'],
  version: Scalars['Int'],
  messages: Array<GuestConversationMessageInput>,
  signature: Scalars['String'],
};

export type GuestConversationMessage = {
   __typename: 'GuestConversationMessage',
  id: Scalars['String'],
  parts: Array<ConversationMessagePart>,
  sendBy: MessagingUser,
  sendAt: Scalars['Date'],
  typeAt?: Maybe<Scalars['Date']>,
};

export type GuestConversationMessageInput = {
  id: Scalars['String'],
  parts: Array<ConversationMessagePartInput>,
  sendBy: Scalars['AnyId'],
  sendAt: Scalars['Date'],
};

export type GuestConversationSequence = {
   __typename: 'GuestConversationSequence',
  id: Scalars['GuestConversationSequenceId'],
  name: Scalars['String'],
  state: GuestConversationSequenceState,
  messages: Array<GuestConversationSequenceMessage>,
};


export type GuestConversationSequenceMessage = {
   __typename: 'GuestConversationSequenceMessage',
  templateType: CommTemplateType,
  delay?: Maybe<Duration>,
  typingDuration?: Maybe<Duration>,
};

export type GuestConversationSequenceMessageInput = {
  templateTypeId: Scalars['CommTemplateTypeId'],
  delay?: Maybe<DurationInput>,
  typingDuration?: Maybe<DurationInput>,
};

export type GuestConversationSequenceQuery = {
  states?: Maybe<Array<GuestConversationSequenceState>>,
};

export enum GuestConversationSequenceState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum HandleType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE'
}

export type IconFacetImageMetadata = FacetImageMetadata & {
   __typename: 'IconFacetImageMetadata',
  type: FacetImageType,
  imageUrl: Scalars['String'],
};

export type IdCodecPayload = {
   __typename: 'IdCodecPayload',
  error?: Maybe<Scalars['String']>,
  externalId?: Maybe<Scalars['String']>,
  internalId?: Maybe<Scalars['String']>,
  idType?: Maybe<Scalars['String']>,
};

export type IdentifyEBayItemAsSellableInput = {
  sellableId: Scalars['SellableId'],
  eBayItemId: Scalars['String'],
};

export type IdentifyEBayItemAsSellablePayload = {
   __typename: 'IdentifyEBayItemAsSellablePayload',
  sellable: Sellable,
};

export type Identity = User | BusinessUser | Operator | SystemUser;

/** ====== IdPathFlowQuestion */
export type IdPathFlowQuestion = PathFlowQuestion & {
   __typename: 'IdPathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  type: IdPathFlowQuestionType,
  /** If reloading a question answered by the user, this is their previous input */
  idUserInput: SubmitIdPathFlowQuestionInputTypeCopy,
  /** Maximum amount of id values that are allowed for this question */
  maximumValues: Scalars['Int'],
};


/** ====== IdPathFlowQuestion */
export type IdPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export enum IdPathFlowQuestionType {
  MEDIA_ID_IMAGE_UPLOAD = 'MEDIA_ID_IMAGE_UPLOAD',
  EXPERT_ID_SELECTION = 'EXPERT_ID_SELECTION',
  PRODUCTS_TYPEAHEAD = 'PRODUCTS_TYPEAHEAD',
  FLIGHT_PLAN = 'FLIGHT_PLAN'
}

/** 
 * Notes:
 * - For lists that can be paginated, we're following the GraphQL Relay "Connection" model.
 *   This is where the "Node/Edges/Connections" convention comes from. Even though we're
 *   using Apollo, this is the most popular pagination model for GraphQL so it's beneficial
 *   for us to adopt. It's basically cursor based pagination; see the following links for
 *   more info:
 *   https://dev-blog.apollodata.com/explaining-graphql-connections-c48b7c3d6976
 *   https://facebook.github.io/relay/docs/graphql-connections.html
 *   https://facebook.github.io/relay/graphql/connections.htm
 * 
 * - Validation: All submits include an array of validation errors that can target the entire flow,
 *   a specific page, or a specific question. These are meant to be displayed to the user. The
 *   validation rules sent down by the server (e.g.: regex validation) is our best attempt at guiding
 *   the client to provide correct input, but it can't be guaranteed for all inputs (e.g.: server data
 *   is required for validation).
 * =============
 * Generic Types
 * =============
 * ====== Image View Model
 **/
export type ImageViewModel = PathImageViewModel;

export type ImportEntitiesInput = {
  file: Scalars['Upload'],
};

export type ImportEntitiesPayload = {
   __typename: 'ImportEntitiesPayload',
  templates: Array<MultiLocaleTemplateSet>,
  triggers: Array<Trigger>,
  templateTypes: Array<CommTemplateType>,
  templateFragments: Array<CommTemplateFragment>,
  leadCampaigns: Array<LeadCampaign>,
};

export type ImportRawSellableSourceInput = {
  environment: Scalars['String'],
  id: Scalars['RawSellableSourceId'],
};

export type ImportRawSellableSourcePayload = {
   __typename: 'ImportRawSellableSourcePayload',
  source?: Maybe<RawSellableSource>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type ImportRawSellableStandardizationRuleInput = {
  environment: Scalars['String'],
  id: Scalars['RawSellableStandardizationRuleId'],
};

export type ImportRawSellableStandardizationRulePayload = {
   __typename: 'ImportRawSellableStandardizationRulePayload',
  rule?: Maybe<RawSellableStandardizationRule>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type ImportRawSellableStandardizationRulesInput = {
  environment: Scalars['String'],
  query: RawSellableStandardizationRuleQuery,
};

export type ImportRawSellableStandardizationRulesPayload = {
   __typename: 'ImportRawSellableStandardizationRulesPayload',
  rules: Array<RawSellableStandardizationRule>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type InAppTemplate = ChannelTemplate & {
   __typename: 'InAppTemplate',
  channelType: ChannelType,
  body: Scalars['String'],
};

export type InAppTemplateInput = {
  body: Scalars['String'],
};

export type IndividualBucketedDisplayFacet = {
   __typename: 'IndividualBucketedDisplayFacet',
  /** Name to display in the UI for this facet bucket */
  displayName: Scalars['String'],
  /** Internal value that should be provided back to FacetSelection.bucketValues when selecting facet values */
  value: Scalars['String'],
  /** 
 * Facet count that should be displayed for this bucket. Depending on product requirements or the way facets
   * are computed, counts may not always be available
 **/
  count?: Maybe<Scalars['Long']>,
  /** Optional image associated with the Facet value. This is used in navigation style SERP pages. */
  imageMetadata?: Maybe<FacetImageMetadata>,
};

export type IndividualBucketedRangeDisplayFacet = {
   __typename: 'IndividualBucketedRangeDisplayFacet',
  /** Name to display in the UI for this facet bucket */
  displayName: Scalars['String'],
  /** 
 * Facet count that should be displayed for this bucket. Depending on product requirements or the way facets
   * are computed, counts may not always be available
 **/
  count?: Maybe<Scalars['Long']>,
  /** Type of numeric facet; currently used to change rendering styles */
  type: NumericRangeDisplayFacetType,
  /** unscaled lower bound */
  lower: Scalars['Long'],
  /** unscaled upper bound */
  upper: Scalars['Long'],
  /** 
 * if `upper` is capped (there are values beyond upper, but the result is truncated for ease of use, and querying for
   * the capped upper value will give all values beyond it)
 **/
  upperCapped: Scalars['Boolean'],
  /** The scale `lower` and `upper` is in; `(value x 10 ^ (-scale))` should be used to compute the actual value. */
  scale: Scalars['Int'],
  /** Computed decimal value of `lower` at `scale` */
  decimalLower: Scalars['BigDecimal'],
  /** Computed decimal value of `upper` at `scale` */
  decimalUpper: Scalars['BigDecimal'],
};

export type InitiateAffirmPaymentForOrderInput = {
  orderId: Scalars['OrderId'],
  paymentRedirectUrls: PaymentRedirectUrls,
};

export type InitiateAffirmPaymentForOrderPayload = {
   __typename: 'InitiateAffirmPaymentForOrderPayload',
  order: Order,
  /** The string representation of the JSON object to be passed to Affirm javascript SDK. */
  checkoutData: Scalars['String'],
};

export type InitiateAfterpayPaymentForOrderInput = {
  orderId: Scalars['OrderId'],
  paymentRedirectUrls: PaymentRedirectUrls,
};

export type InitiateAfterpayPaymentForOrderPayload = {
   __typename: 'InitiateAfterpayPaymentForOrderPayload',
  order: Order,
  /** 
 * This is a unique token that is used for 2 purposes:
   * 1. As part of the redirect request to Afterpay (on frontend)
   * 2. For uniquely capturing the payment after approval (on backend)
   * 
   * On approval from Afterpay, this same token is appended to the redirectConfirmUrl and should be sent as the
   * paymentProcessorPlatformSourceId field in the ChargeInfoInput object. Note, the Afterpay payments are single use only
 **/
  orderToken: Scalars['String'],
};

export type InitiateAuthenticationInput = {
  /** handle/handleType or handleId must be present */
  handle?: Maybe<Scalars['String']>,
  handleType?: Maybe<HandleType>,
  handleId?: Maybe<Scalars['AnyId']>,
  captcha: Scalars['String'],
};

export type InitiateAuthenticationPayload = {
   __typename: 'InitiateAuthenticationPayload',
  isValidHandle: Scalars['Boolean'],
  challengeType?: Maybe<ChallengeType>,
  session: Session,
};

export type InitiateDealInventoryFulfillmentInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
  /** The specific location to fulfill the order line item from. */
  fulfillmentCenterId: Scalars['FulfillmentCenterId'],
  /** 
 * An internal merchant (Deal or Curated) for reference
   * Note, internal merchants are merchants that represent one of the Merchant accounts we use to fulfill our own inventory
 **/
  merchantId: Scalars['MerchantId'],
  /** 
 * If unspecified, the quantity from the OrderLineItem is used.
   * This cannot be greater than the quantity set in the OrderLineItem
 **/
  quantity?: Maybe<Scalars['Int']>,
  /** Override the shipment method from Order to use for this fulfillment */
  fulfillmentShipmentMethodId?: Maybe<Scalars['FulfillmentShipmentMethodId']>,
  /** defaults to fulfilling via Shopify */
  fulfillmentSourceType?: Maybe<FulfillmentOrderSourceType>,
};

export type InitiateDealInventoryFulfillmentPayload = {
   __typename: 'InitiateDealInventoryFulfillmentPayload',
  order?: Maybe<Order>,
  error?: Maybe<Scalars['String']>,
};

export type InitiatePaypalPaymentForOfferConfirmation = {
   __typename: 'InitiatePaypalPaymentForOfferConfirmation',
  paymentId: Scalars['String'],
  authorizationUrl: Scalars['String'],
  price: MonetaryAmount,
  tax?: Maybe<MonetaryAmount>,
  shippingCost?: Maybe<MonetaryAmount>,
  tip?: Maybe<MonetaryAmount>,
};

export type InitiatePaypalPaymentForOfferInput = {
  tip?: Maybe<MonetaryAmountInput>,
  tax?: Maybe<MonetaryAmountInput>,
  shippingAddress?: Maybe<AddressInput>,
  offerId: Scalars['BroadcastOfferId'],
  paymentRedirectUrls?: Maybe<PaymentRedirectUrls>,
};

export type InitiatePaypalPaymentForOfferPayload = {
   __typename: 'InitiatePaypalPaymentForOfferPayload',
  result?: Maybe<InitiatePaypalPaymentForOfferConfirmation>,
  error?: Maybe<Scalars['String']>,
};

export type InitiatePaypalPaymentForOrderInput = {
  orderId: Scalars['OrderId'],
  paymentRedirectUrls?: Maybe<PaymentRedirectUrls>,
};

export type InitiatePaypalPaymentForOrderPayload = {
   __typename: 'InitiatePaypalPaymentForOrderPayload',
  order: Order,
  paymentId: Scalars['String'],
  authorizationUrl: Scalars['String'],
};

export type InitiateResetPasswordInput = {
  handle?: Maybe<Scalars['String']>,
  handleType?: Maybe<HandleType>,
};

export type InitiateResetPasswordPayload = {
   __typename: 'InitiateResetPasswordPayload',
  success: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type InitiateVerifyHandleInput = {
  handle: Scalars['String'],
  handleType: HandleType,
};

export type InitiateVerifyHandlePayload = {
   __typename: 'InitiateVerifyHandlePayload',
  success: Scalars['Boolean'],
};

export type InitiateWireTransferPaymentForOrderInput = {
  orderId: Scalars['OrderId'],
};

export type InitiateWireTransferPaymentForOrderPayload = {
   __typename: 'InitiateWireTransferPaymentForOrderPayload',
  order: Order,
  /** The payment source which guarantees that it has a WireTransferPaymentEntity. */
  paymentSource: PaymentSource,
};

export type InputTextPathFlowQuestion = PathFlowQuestion & InputTextPathFlowQuestionMixin & {
   __typename: 'InputTextPathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  inputTextValidations: Array<InputTextPathFlowQuestionValidation>,
  fieldType: InputTextPathFlowQuestionFieldType,
  placeholder?: Maybe<Scalars['String']>,
  inputTextUserInput: SubmitInputTextPathFlowQuestionInputTypeCopy,
};


export type InputTextPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export enum InputTextPathFlowQuestionFieldType {
  /** Typeahead for airports only */
  AIRPORT_TYPEAHEAD = 'AIRPORT_TYPEAHEAD',
  /** Single line "telephone" with SMS text context */
  SMS_TEXT = 'SMS_TEXT',
  /** Facebook user expectedReference */
  FACEBOOK_USER_REF = 'FACEBOOK_USER_REF',
  /** FCM Token */
  FCM_TOKEN = 'FCM_TOKEN',
  /** Single line text entry */
  INPUT_FIELD = 'INPUT_FIELD',
  /** Multi-line text area */
  TEXT_AREA = 'TEXT_AREA',
  /** Single line entry (numeric only) */
  NUMERIC = 'NUMERIC',
  /** Single line "telephone"-like entry (numeric only) */
  TELEPHONE = 'TELEPHONE',
  /** Single line "telephone" with its own submit action */
  TELEPHONE_SUBMIT = 'TELEPHONE_SUBMIT',
  /** Single line "email"-like entry (shows @ sign) */
  EMAIL = 'EMAIL',
  /** Text which is provided programmatically, thus should be hidden from the user */
  HIDDEN = 'HIDDEN'
}

export type InputTextPathFlowQuestionLengthValidation = InputTextPathFlowQuestionValidation & {
   __typename: 'InputTextPathFlowQuestionLengthValidation',
  type: InputTextPathFlowQuestionValidationType,
  minSize?: Maybe<Scalars['Int']>,
  maxSize?: Maybe<Scalars['Int']>,
};

/** ====== Input Text */
export type InputTextPathFlowQuestionMixin = {
  required: Scalars['Boolean'],
  inputTextValidations: Array<InputTextPathFlowQuestionValidation>,
  fieldType: InputTextPathFlowQuestionFieldType,
  placeholder?: Maybe<Scalars['String']>,
  questionSubText?: Maybe<TextViewModel>,
};

export type InputTextPathFlowQuestionNoArgValidation = InputTextPathFlowQuestionValidation & {
   __typename: 'InputTextPathFlowQuestionNoArgValidation',
  type: InputTextPathFlowQuestionValidationType,
};

export type InputTextPathFlowQuestionRegexValidation = InputTextPathFlowQuestionValidation & {
   __typename: 'InputTextPathFlowQuestionRegexValidation',
  type: InputTextPathFlowQuestionValidationType,
  regex: Scalars['String'],
  errorMessage: Scalars['String'],
};

export type InputTextPathFlowQuestionValidation = {
  type: InputTextPathFlowQuestionValidationType,
};

export enum InputTextPathFlowQuestionValidationType {
  LENGTH = 'LENGTH',
  REGEX = 'REGEX',
  PHONE_NUMBER = 'PHONE_NUMBER'
}

export type InstallmentPaymentEntity = PaymentEntity & {
   __typename: 'InstallmentPaymentEntity',
  paymentMethod: PaymentMethod,
  /** Payment token created and used during the approval process for this PaymentEntity */
  paymentToken: Scalars['String'],
};

export type InternalMessagingUser = {
   __typename: 'InternalMessagingUser',
  id: Scalars['AnyId'],
  displayName: Scalars['String'],
};

export type InterstitialPathFlowPageMetadata = PathFlowPageMetadata & {
   __typename: 'InterstitialPathFlowPageMetadata',
  type: PathFlowPageMetadataType,
  interstitialType: InterstitialPathFlowPageMetadataType,
  title?: Maybe<TextViewModel>,
  body?: Maybe<TextViewModel>,
};

export enum InterstitialPathFlowPageMetadataType {
  ALMOST_DONE = 'ALMOST_DONE',
  BROWSE_EXPERTS = 'BROWSE_EXPERTS',
  CALCULATING = 'CALCULATING',
  CONNECTING_TO_OPERATOR = 'CONNECTING_TO_OPERATOR',
  FINDING_MERCHANTS = 'FINDING_MERCHANTS',
  /** GENERIC_WITH_BUTTON interstitial uses a button to submit */
  GENERIC_WITH_BUTTON = 'GENERIC_WITH_BUTTON',
  /** GENERIC_WITH_TITLE interstitial that uses timer to submit */
  GENERIC_WITH_TITLE = 'GENERIC_WITH_TITLE',
  HIGH_SECURITY = 'HIGH_SECURITY',
  LOADING_QUESTIONS = 'LOADING_QUESTIONS',
  SNOWBOARD_INT_LEARN = 'SNOWBOARD_INT_LEARN',
  WELCOME = 'WELCOME',
  GIVE_US_A_SEC = 'GIVE_US_A_SEC',
  REQUEST_PUSH_NOTIFICATION_PERMISSION = 'REQUEST_PUSH_NOTIFICATION_PERMISSION',
  WHAT_HAPPENS_NEXT = 'WHAT_HAPPENS_NEXT'
}

export type InventoryTaskError = {
   __typename: 'InventoryTaskError',
  sheetTitle?: Maybe<Scalars['String']>,
  row: Scalars['Int'],
  message: Scalars['String'],
};

export type IpBasedUserData = {
   __typename: 'IpBasedUserData',
  companyName?: Maybe<Scalars['String']>,
  website?: Maybe<Scalars['String']>,
  countryName?: Maybe<Scalars['String']>,
  regionName?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
};

export type ItemCustomizingInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
  customizationNotes?: Maybe<Scalars['String']>,
};

export type ItemCustomizingPayload = {
   __typename: 'ItemCustomizingPayload',
  order: Order,
};

export type ItemFulfillmentSuggestion = {
   __typename: 'ItemFulfillmentSuggestion',
  status: FulfillmentSuggestionStatus,
  note?: Maybe<Scalars['String']>,
  fulfillmentChannel: FulfillmentChannel,
};

export type ItemHasCustomizationIssuesInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
  customizationNotes?: Maybe<Scalars['String']>,
};

export type ItemHasCustomizationIssuesPayload = {
   __typename: 'ItemHasCustomizationIssuesPayload',
  order: Order,
};

export type ItemReturnReceivedActivity = OrderActivityDetail & {
   __typename: 'ItemReturnReceivedActivity',
  type: OrderActivityDetailType,
  orderRefund?: Maybe<OrderRefund>,
};

export type ItemReturnRequestedActivity = OrderActivityDetail & {
   __typename: 'ItemReturnRequestedActivity',
  type: OrderActivityDetailType,
  requestedBy: Operator,
  escalation: OrderEscalation,
  orderRefund?: Maybe<OrderRefund>,
};

export type ItemReturnShippedActivity = OrderActivityDetail & {
   __typename: 'ItemReturnShippedActivity',
  type: OrderActivityDetailType,
  orderRefund?: Maybe<OrderRefund>,
};

export type JoinVideoChatInput = {
  messagingUserId: Scalars['AnyId'],
  externalConversationId: Scalars['String'],
};

export type JoinVideoChatPayload = {
   __typename: 'JoinVideoChatPayload',
  token: Scalars['String'],
};

export type Lead = {
   __typename: 'Lead',
  id: Scalars['LeadId'],
  consumer: User,
  /** 
 * The expert of the lead. If the lead is assigned to an expert, this is the same as primaryExpert. Otherwise,
   * this is a placeholder expert.
 **/
  expert: BusinessUser,
  /** The primary expert for the lead, if the lead is assigned to an expert */
  primaryExpert?: Maybe<BusinessUser>,
  delegateExpert?: Maybe<BusinessUser>,
  conversation: Conversation,
  labels: Array<LeadLabel>,
  starred: Scalars['Boolean'],
  notRepliedByConsumer: Scalars['Boolean'],
  neverReplied: Scalars['Boolean'],
  archived: Scalars['Boolean'],
  active: Scalars['Boolean'],
  snoozed: Scalars['Boolean'],
  latestRequest?: Maybe<DealRequest>,
  /** The related requests are sorted according to the creation time in ascending order */
  relatedRequests: Array<DealRequest>,
  snooze?: Maybe<LeadSnooze>,
  offers: Array<BroadcastOffer>,
  consumerConversationMetrics: ConversationMetrics,
  expertConversationMetrics: ConversationMetrics,
  dealbotConversationMetrics: ConversationMetrics,
  consumerUrl: Scalars['String'],
  expertUrl: Scalars['String'],
  expertUrlForAdmin: Scalars['String'],
  adminUrl: Scalars['String'],
  recommendationsUrl: Scalars['String'],
  consumerExpertReferralUrl: Scalars['String'],
  leadScore?: Maybe<Scalars['Float']>,
  consumerReview?: Maybe<ConsumerExpertReview>,
  expertTeam?: Maybe<BusinessUserTeam>,
  /** used for graphql-based trigger entity.  expose Id directly to avoid unnecessary joins */
  labelIds: Array<Scalars['LeadLabelId']>,
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>,
  expertId: Scalars['BusinessUserId'],
  delegateExpertId?: Maybe<Scalars['BusinessUserId']>,
  consumerId: Scalars['UserId'],
  lastMessageSentAt?: Maybe<Scalars['Date']>,
  consumerInitialAction?: Maybe<ConsumerInitialLeadAction>,
  pinnedMessages: Array<SavedLeadNote>,
  notes: Array<SavedLeadNote>,
  expertRecommendationRecord?: Maybe<ExpertRecommendationRecord>,
  lastActivityTime: Scalars['Date'],
  lastExpertMessageSentAt?: Maybe<Scalars['Date']>,
  lastExpertManualMessageSentAt?: Maybe<Scalars['Date']>,
  lastAssistantMessageSentAt?: Maybe<Scalars['Date']>,
  firstExpertManualMessageSentAt?: Maybe<Scalars['Date']>,
  lastManualMessageSenderType?: Maybe<LeadParticipantType>,
  expertMessageCount: Scalars['Int'],
  curationSummary: CurationSummary,
  surveySummary?: Maybe<SurveySummary>,
  phoneCallSummary: PhoneCallSummary,
  createdAt: Scalars['Date'],
  category?: Maybe<Category>,
  department?: Maybe<Department>,
  suggestedActions: Array<SuggestedAction>,
  openEscalation?: Maybe<LeadEscalation>,
  curationLastViewedAt?: Maybe<Scalars['Date']>,
  otherActiveLeadsInDepartment: Array<Lead>,
  intentLabels: Array<LeadIntentLabel>,
  expertsParticipated: Array<BusinessUser>,
  leadActivities: Array<LeadActivity>,
  supportTaskActivities: Array<SupportTaskActivity>,
  skiTripLead: Scalars['Boolean'],
};


export type LeadOpenEscalationArgs = {
  type: LeadEscalationType
};


export type LeadLeadActivitiesArgs = {
  occurredSince?: Maybe<Scalars['Date']>,
  occurredBefore?: Maybe<Scalars['Date']>,
  limit?: Maybe<Scalars['Int']>
};


export type LeadSupportTaskActivitiesArgs = {
  occurredSince?: Maybe<Scalars['Date']>,
  occurredBefore?: Maybe<Scalars['Date']>,
  limit?: Maybe<Scalars['Int']>
};

export type LeadActivity = {
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  performedBy: Identity,
};


export enum LeadActivityType {
  DELEGATE_EXPERT_CHANGED = 'DELEGATE_EXPERT_CHANGED',
  SNOOZE_CHANGED = 'SNOOZE_CHANGED',
  WOKE_UP_FROM_SNOOZE = 'WOKE_UP_FROM_SNOOZE',
  REASSIGNED = 'REASSIGNED',
  ARCHIVED = 'ARCHIVED',
  CONSUMER_FIRST_MESSAGE_SENT = 'CONSUMER_FIRST_MESSAGE_SENT',
  CONSUMER_CALLED = 'CONSUMER_CALLED',
  CONSUMER_PAYMENT_FAILED = 'CONSUMER_PAYMENT_FAILED',
  CONSUMER_PAYMENT_SUCCEEDED = 'CONSUMER_PAYMENT_SUCCEEDED',
  CONSUMER_ORDER_PAID = 'CONSUMER_ORDER_PAID',
  CONSUMER_REVIEW_ADDED = 'CONSUMER_REVIEW_ADDED',
  ESCALATION_STARTED = 'ESCALATION_STARTED',
  ESCALATION_CHANGED = 'ESCALATION_CHANGED',
  QUALITY_CONVERSATION_ESTABLISHED = 'QUALITY_CONVERSATION_ESTABLISHED',
  LEAD_CREATED = 'LEAD_CREATED',
  STOP_REQUESTED = 'STOP_REQUESTED'
}

export type LeadArchivedActivity = LeadActivity & {
   __typename: 'LeadArchivedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  performedBy: Identity,
};

export type LeadCampaign = {
   __typename: 'LeadCampaign',
  id: Scalars['LeadCampaignId'],
  name: Scalars['String'],
  minimumHoursSinceLastMessage: Scalars['Float'],
  minimumHoursSinceLastCampaign: Scalars['Float'],
  maximumRecipients: Scalars['Float'],
  facets: Array<FacetSelectionPayload>,
  decoratedFacets: Array<DisplayFacet>,
  state: LeadCampaignState,
  dateRangeFilters: Array<DateRangeFilter>,
  keywordsFilter?: Maybe<Scalars['String']>,
  trigger?: Maybe<Trigger>,
  totalDelivered: Scalars['Int'],
  lastDeliveryTime?: Maybe<Scalars['Date']>,
  firstDeliveryTime?: Maybe<Scalars['Date']>,
  totalTargetRecipients?: Maybe<Scalars['Int']>,
  deliveryHistory: Array<LeadCampaignDeliveryResult>,
  pendingDelivery?: Maybe<LeadCampaignDeliveryRequest>,
  recipientSortOrder: LeadCampaignRecipientSortOrder,
  triggerExecutionInterval: LeadCampaignTriggerExecutionInterval,
};

export type LeadCampaignDeliveryRequest = {
   __typename: 'LeadCampaignDeliveryRequest',
  batchSize: Scalars['Int'],
  scheduledAt: Scalars['Date'],
};

export type LeadCampaignDeliveryResult = {
   __typename: 'LeadCampaignDeliveryResult',
  totalDelivered: Scalars['Int'],
  startDeliveryTime: Scalars['Date'],
  endDeliveryTime: Scalars['Date'],
};

export type LeadCampaignFilter = {
  name?: Maybe<Scalars['String']>,
  state?: Maybe<LeadCampaignState>,
};



export enum LeadCampaignRecipientSortOrder {
  MOST_RECENT_ACTIVITY = 'MOST_RECENT_ACTIVITY',
  RANDOM = 'RANDOM'
}

export enum LeadCampaignState {
  DRAFT = 'DRAFT',
  PREPARING = 'PREPARING',
  PUBLISHED = 'PUBLISHED',
  DELIVERING = 'DELIVERING',
  DEACTIVATED = 'DEACTIVATED'
}

export enum LeadCampaignTriggerExecutionInterval {
  EMAIL = 'EMAIL',
  SMS_LONG_CODE = 'SMS_LONG_CODE',
  SMS_SHORT_CODE = 'SMS_SHORT_CODE'
}

export type LeadCreatedActivity = LeadActivity & {
   __typename: 'LeadCreatedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  performedBy: Identity,
};

export type LeadEscalation = {
   __typename: 'LeadEscalation',
  id: Scalars['LeadEscalationId'],
  createdAt: Scalars['Date'],
  type: LeadEscalationType,
  acceptAsLeadExpertRole: LeadExpertRole,
  level: LeadEscalationLevel,
  /** only used for trigger entity so that we skip looking up the business user */
  ownerId?: Maybe<Scalars['BusinessUserId']>,
  expertsNotifiedAt?: Maybe<Scalars['Date']>,
  teamNotifiedAt?: Maybe<Scalars['Date']>,
  supportNotifiedAt?: Maybe<Scalars['Date']>,
  closedAt?: Maybe<Scalars['Date']>,
  status: LeadEscalationStatus,
  lead: Lead,
  owner?: Maybe<BusinessUser>,
  onCallExpertCount: Scalars['Int'],
  expertEscalationUrl: Scalars['String'],
};

export type LeadEscalationChangedActivity = LeadActivity & {
   __typename: 'LeadEscalationChangedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  oldEscalation: LeadEscalation,
  newEscalation: LeadEscalation,
  closing: Scalars['Boolean'],
  escalatingUp: Scalars['Boolean'],
  escalatingToTeam: Scalars['Boolean'],
  performedBy: Identity,
};


export enum LeadEscalationLevel {
  NOT_STARTED = 'NOT_STARTED',
  ONLINE_TEAM_MEMBERS = 'ONLINE_TEAM_MEMBERS',
  ALL_TEAM_MEMBERS = 'ALL_TEAM_MEMBERS',
  SUPPORT = 'SUPPORT',
  ONLINE_EXPERTS = 'ONLINE_EXPERTS',
  ALL_EXPERTS = 'ALL_EXPERTS',
  ON_CALL_EXPERTS = 'ON_CALL_EXPERTS'
}

export type LeadEscalationStartedActivity = LeadActivity & {
   __typename: 'LeadEscalationStartedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  escalation: LeadEscalation,
  performedBy: Identity,
};

export enum LeadEscalationStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED'
}

export enum LeadEscalationType {
  CONSUMER_WAITING_RESPONSE = 'CONSUMER_WAITING_RESPONSE'
}

export enum LeadExpertRole {
  PRIMARY = 'PRIMARY',
  DELEGATE = 'DELEGATE'
}


/** Triggered when the leads predicted intent changes */
export type LeadIntentChange = {
   __typename: 'LeadIntentChange',
  lead: Lead,
  /** This returns the full copy of the new intent labels not just the diff */
  changedIntentLabels: Array<LeadIntentLabel>,
  changedAt: Scalars['Date'],
};

export enum LeadIntentLabel {
  /** Lead predicted to have a high intent for conversion. */
  HIGH_INTENT_FOR_CONVERSION = 'HIGH_INTENT_FOR_CONVERSION'
}

export type LeadLabel = {
   __typename: 'LeadLabel',
  id: Scalars['LeadLabelId'],
  name: Scalars['String'],
  internalId: Scalars['String'],
};



/** @deprecated(reason: "LeadPaymentSucceededActivity") */
export type LeadOrderPaidActivity = LeadActivity & {
   __typename: 'LeadOrderPaidActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  orderId: Scalars['OrderId'],
  total: MonetaryAmount,
  tip?: Maybe<MonetaryAmount>,
  performedBy: Identity,
};

export enum LeadParticipantType {
  EXPERT = 'EXPERT',
  DELEGATE_EXPERT = 'DELEGATE_EXPERT',
  CONSUMER = 'CONSUMER',
  ASSISTANT = 'ASSISTANT',
  DEAL_BOT = 'DEAL_BOT'
}

export type LeadPaymentFailedActivity = LeadActivity & {
   __typename: 'LeadPaymentFailedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  paymentActivityType: PaymentActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  orderId: Scalars['OrderId'],
  total: MonetaryAmount,
  amountPaid: MonetaryAmount,
  transactionAmount: MonetaryAmount,
  tip?: Maybe<MonetaryAmount>,
  paymentSource: Scalars['String'],
  paymentError: Scalars['String'],
  performedBy: Identity,
};

export type LeadPaymentSucceededActivity = LeadActivity & {
   __typename: 'LeadPaymentSucceededActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  paymentActivityType: PaymentActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  orderId: Scalars['OrderId'],
  total: MonetaryAmount,
  amountPaid: MonetaryAmount,
  transactionAmount: MonetaryAmount,
  fullPaymentDueAt?: Maybe<Scalars['Date']>,
  tip?: Maybe<MonetaryAmount>,
  performedBy: Identity,
};

export type LeadReassignedActivity = LeadActivity & {
   __typename: 'LeadReassignedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  currentExpert: BusinessUser,
  previousExpert: BusinessUser,
  performedBy: Identity,
};

export enum LeadReassignmentReason {
  EXPERT_DEACTIVATED = 'EXPERT_DEACTIVATED',
  ORDER_SUPPORT_ACTION = 'ORDER_SUPPORT_ACTION',
  ESCALATION_ACCEPTED = 'ESCALATION_ACCEPTED',
  SURGE_LEAD_CLAIMED = 'SURGE_LEAD_CLAIMED',
  OTHER = 'OTHER'
}

export type LeadSavedSearchContext = {
  expertId?: Maybe<Scalars['BusinessUserId']>,
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>,
};

export type LeadSearchConnection = {
   __typename: 'LeadSearchConnection',
  facets: Array<DisplayFacet>,
  edges: Array<LeadSearchEdge>,
  pageInfo: PageInfo,
  count?: Maybe<Scalars['Int']>,
};

export type LeadSearchEdge = {
   __typename: 'LeadSearchEdge',
  node: Lead,
  cursor: Scalars['String'],
};

export type LeadSearchQuery = {
  facetedSearch: Scalars['Boolean'],
  facets?: Maybe<Array<FacetSelection>>,
  expertId?: Maybe<Scalars['BusinessUserId']>,
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>,
  consumerId?: Maybe<Scalars['UserId']>,
  whitelistedFacets?: Maybe<Array<Scalars['String']>>,
  dateRangeFilters?: Maybe<Array<DateRangeFilterInput>>,
  keywords?: Maybe<Scalars['String']>,
};

export type LeadSnooze = {
   __typename: 'LeadSnooze',
  wakeupTime: Scalars['Date'],
  note?: Maybe<Scalars['String']>,
  message?: Maybe<Scalars['String']>,
  messageSentAt?: Maybe<Scalars['Date']>,
  editedAt?: Maybe<Scalars['Date']>,
  cancelMessageOnConsumerReply: Scalars['Boolean'],
};

export enum LeadSortOrder {
  ACTIVITY_DATE = 'ACTIVITY_DATE',
  CREATION_DATE = 'CREATION_DATE'
}

export type LeadStopRequestedActivity = LeadActivity & {
   __typename: 'LeadStopRequestedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  performedBy: Identity,
};

export type LeadSupportTask = SupportTask & {
   __typename: 'LeadSupportTask',
  id: Scalars['SupportTaskId'],
  type: SupportTaskType,
  state: SupportTaskState,
  url: Scalars['String'],
  dueAt: Scalars['Date'],
  assignedTo?: Maybe<Operator>,
  assignedAt?: Maybe<Scalars['Date']>,
  createdAt: Scalars['Date'],
  completedAt?: Maybe<Scalars['Date']>,
  lead: Lead,
  reason: LeadSupportTaskReason,
  reasonDescription: Scalars['String'],
};

export enum LeadSupportTaskReason {
  NEW_UNASSIGNED_LEAD = 'NEW_UNASSIGNED_LEAD',
  EXPERT_OUT_OF_SLA = 'EXPERT_OUT_OF_SLA',
  ESCALATION_FAILED = 'ESCALATION_FAILED',
  ESCALATION_FOR_DELEGATION_FAILED = 'ESCALATION_FOR_DELEGATION_FAILED',
  ESCALATION_FOR_REASSIGNMENT_FAILED = 'ESCALATION_FOR_REASSIGNMENT_FAILED',
  UNSNOOZED = 'UNSNOOZED',
  RESPONDED_TO_SUPPORT = 'RESPONDED_TO_SUPPORT',
  EVALUATE_CONVERSATION = 'EVALUATE_CONVERSATION',
  DEFAULT = 'DEFAULT'
}

export type LeadSurge = {
   __typename: 'LeadSurge',
  id: Scalars['LeadSurgeId'],
  category: Category,
  surgeFactor: Scalars['Float'],
  occurredAt: Scalars['Date'],
};


export type LineItemClaimTicket = TicketDetail & {
   __typename: 'LineItemClaimTicket',
  type: TicketType,
  consumerId: Scalars['UserId'],
  order: Order,
  orderLineItemId: Scalars['OrderLineItemId'],
  fulfillmentPlan?: Maybe<LineItemFulfillmentPlan>,
};

export type LineItemFulfillmentPlan = {
   __typename: 'LineItemFulfillmentPlan',
  suggestions: Array<ItemFulfillmentSuggestion>,
  allSuggestionsFailed: Scalars['Boolean'],
};

export type LineItemTrackingUpdateTicket = TicketDetail & {
   __typename: 'LineItemTrackingUpdateTicket',
  type: TicketType,
  consumerId: Scalars['UserId'],
  order: Order,
  orderLineItemId: Scalars['OrderLineItemId'],
};

/** ====== ListPathFlowQuestion */
export type ListPathFlowQuestion = PathFlowQuestion & {
   __typename: 'ListPathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  choices: Array<ListPathFlowQuestionChoice>,
  /** 
 * If present, render an additional "other" selection. Only applicable
   * for MULTI_SELECT_LIST and SINGLE_SELECT_LIST question types
 **/
  other?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  type: ListPathFlowQuestionType,
  renderStyle: ListPathFlowQuestionRenderStyle,
  /** If present and `type` supports multiple choices, the maximum amount of choices (inclusive) that's allowed */
  maxChoices?: Maybe<Scalars['Int']>,
  /** If reloading a question answered by the user, this is their previous input */
  listUserInput: SubmitListPathFlowQuestionInputTypeCopy,
};


/** ====== ListPathFlowQuestion */
export type ListPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export type ListPathFlowQuestionChoice = {
   __typename: 'ListPathFlowQuestionChoice',
  text?: Maybe<TextViewModel>,
  subText?: Maybe<TextViewModel>,
  /** Internal value to send back to the server if this item is selected */
  value: Scalars['String'],
  /** 
 * Primary image associated with the question. Typically a large image that takes the majority of the choice card, used
   * as an alternative to text/subText
 **/
  primaryImage?: Maybe<ImageViewModel>,
  /** Icon/sub-image associated with the question. Typically a small image used in conjunction with text/subText */
  iconImage?: Maybe<ImageViewModel>,
};

export enum ListPathFlowQuestionRenderStyle {
  /** 
 * The default/stock rendering style that is guaranteed to fit in with the rest of the components, and will have the
   * best support in combining different options that impact rendering. Unless a path with a specific UI treatment is
   * being tested, using DEFAULT is strongly recommended.
 **/
  DEFAULT = 'DEFAULT',
  /** If images should be rendered as full width (bleeds into edges of select container) */
  FULL_WIDTH_IMAGES = 'FULL_WIDTH_IMAGES',
  /** If text should be rendered as an overlay of the image in the background */
  OVERLAY_IMAGE = 'OVERLAY_IMAGE',
  /** Use a simpler radio style select that doesn't render the full cards */
  SIMPLE_RADIO = 'SIMPLE_RADIO'
}

export enum ListPathFlowQuestionType {
  SINGLE_SELECT_LIST = 'SINGLE_SELECT_LIST',
  MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
  DROP_DOWN = 'DROP_DOWN',
  MULTI_SELECT_PILLS = 'MULTI_SELECT_PILLS'
}



export enum LogicalOperator {
  AND = 'AND',
  OR = 'OR'
}


export type LongRangeInput = {
  from?: Maybe<Scalars['Long']>,
  to?: Maybe<Scalars['Long']>,
};

export enum LookupReferralCodeError {
  INVALID_CODE = 'INVALID_CODE'
}

export type LookupReferralCodePayload = {
   __typename: 'LookupReferralCodePayload',
  errorCode?: Maybe<LookupReferralCodeError>,
  referralCode?: Maybe<ReferralCode>,
};

export enum LtvType {
  LEAD = 'LEAD',
  REQUEST = 'REQUEST',
  RESPONSE = 'RESPONSE',
  VIEW_CURATIONS = 'VIEW_CURATIONS'
}

export type MakeExpertCuratedItemDraftsActiveInput = {
  leadId: Scalars['LeadId'],
};

export type MakeExpertCuratedItemDraftsActivePayload = {
   __typename: 'MakeExpertCuratedItemDraftsActivePayload',
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories,
  addedToCart: Array<ExpertCuratedItem>,
  activated: Array<ExpertCuratedItem>,
  removed: Array<ExpertCuratedItem>,
  errors: Array<Scalars['String']>,
};

export type MarkConversationReadInput = {
  conversationId: Scalars['ConversationId'],
};

export type MarkConversationReadPayload = {
   __typename: 'MarkConversationReadPayload',
  success: Scalars['Boolean'],
};

export type MarkPaymentFailedForOrderInput = {
  orderId: Scalars['OrderId'],
  /** The unique id or token on the external platform that was used for initiating the Payment Authorization process. */
  paymentProcessorPlatformSourceId: Scalars['String'],
  paymentProcessorType: PaymentProcessorType,
  /** Failure reason if any. */
  failureReason?: Maybe<Scalars['String']>,
};

export type MarkPaymentFailedForOrderPayload = {
   __typename: 'MarkPaymentFailedForOrderPayload',
  order: Order,
};

export type MarkPaymentPreApprovalFailedForOrderInput = {
  orderId: Scalars['OrderId'],
  /** The unique id or token on the external platform that was used for initiating the Payment Authorization process. */
  paymentProcessorPlatformSourceId: Scalars['String'],
  paymentProcessorType: PaymentProcessorType,
  /** Failure reason if any. */
  failureReason?: Maybe<Scalars['String']>,
};

export type MarkPaymentPreApprovalFailedForOrderPayload = {
   __typename: 'MarkPaymentPreApprovalFailedForOrderPayload',
  order: Order,
};

export type MaskedUserHandle = {
   __typename: 'MaskedUserHandle',
  id: Scalars['AnyId'],
  maskedHandle: Scalars['String'],
  handleType: HandleType,
};

export type MediaFile = {
   __typename: 'MediaFile',
  id: Scalars['MediaId'],
  url: Scalars['String'],
  mimeType: Scalars['String'],
  size: Scalars['Int'],
  persisted: Scalars['Boolean'],
  originalFileName?: Maybe<Scalars['String']>,
};

export type MediaFileWithCaption = {
   __typename: 'MediaFileWithCaption',
  mediaFile: MediaFile,
  caption?: Maybe<Scalars['String']>,
};


export type MediaRenderedContent = {
   __typename: 'MediaRenderedContent',
  medias: Array<MediaFile>,
};

export type MediaWithCaptionInput = {
  mediaId: Scalars['MediaId'],
  caption?: Maybe<Scalars['String']>,
};

export type Merchant = {
   __typename: 'Merchant',
  id: Scalars['MerchantId'],
  contacts: Array<Contact>,
  name: Scalars['String'],
  address?: Maybe<PostalAddress>,
  latitude?: Maybe<Scalars['Float']>,
  longitude?: Maybe<Scalars['Float']>,
  reviewRating?: Maybe<Scalars['Int']>,
  googlePlaceId?: Maybe<Scalars['String']>,
  logo?: Maybe<MediaFile>,
  website?: Maybe<Scalars['String']>,
  adHoc: Scalars['Boolean'],
  brands: Array<Brand>,
  categories: Array<Category>,
  onboarded: Scalars['Boolean'],
  shippingAvailable?: Maybe<Scalars['Boolean']>,
  priceRating?: Maybe<Scalars['Int']>,
  responseTimeInMinutes?: Maybe<Scalars['Int']>,
  responseRate?: Maybe<Scalars['Float']>,
  offerAcceptRate?: Maybe<Scalars['Float']>,
  businessAccount?: Maybe<BusinessAccount>,
  shippingNotificationsEmail?: Maybe<Scalars['String']>,
  /** 
 * Indicate whether this merchant corresponds to an internal deal merchant or refers to a placeholder indicating us.
   * For example, Curated UPS for fulfillment from our UPS 3PL facility.
 **/
  internal: Scalars['Boolean'],
  estimatedMarginPercent?: Maybe<Scalars['Int']>,
  defaultCurrency: Scalars['String'],
};

export type MerchantClaimedActivity = OrderActivityDetail & {
   __typename: 'MerchantClaimedActivity',
  type: OrderActivityDetailType,
  merchant: Merchant,
  quote?: Maybe<MonetaryAmount>,
  merchantOrderId?: Maybe<Scalars['String']>,
  claimedBy: Operator,
  tax?: Maybe<MonetaryAmount>,
  shippingCost?: Maybe<MonetaryAmount>,
};


export type MerchantRefundTicket = TicketDetail & {
   __typename: 'MerchantRefundTicket',
  type: TicketType,
  order: Order,
  orderRefund: OrderRefund,
};

export type MerchantRefundUpdatedActivity = OrderActivityDetail & {
   __typename: 'MerchantRefundUpdatedActivity',
  type: OrderActivityDetailType,
  amountRefunded: MonetaryAmount,
  orderRefund: OrderRefund,
  updatedByOperator?: Maybe<Operator>,
};

export type MerchantSearchQuery = {
  keywords?: Maybe<Scalars['String']>,
  onboarded?: Maybe<Scalars['Boolean']>,
  shippingAvailable?: Maybe<Scalars['Boolean']>,
  minResponseTimeInMinutes?: Maybe<Scalars['Int']>,
  minResponseRate?: Maybe<Scalars['Float']>,
  minOfferAcceptRate?: Maybe<Scalars['Float']>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  brandIds?: Maybe<Array<Scalars['BrandId']>>,
  priceRatings?: Maybe<Array<Scalars['Int']>>,
  contactTypes?: Maybe<Array<ContactType>>,
  minReviewRating?: Maybe<Scalars['Int']>,
};

export type MerchantSearchResult = {
   __typename: 'MerchantSearchResult',
  totalCount: Scalars['Long'],
  merchants: Array<Merchant>,
};

export type MerchantSuggestionResult = {
   __typename: 'MerchantSuggestionResult',
  merchants: Array<Merchant>,
};

export type MerchantUploadTaskPayload = {
   __typename: 'MerchantUploadTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numMerchantsCreated: Scalars['Int'],
  numMerchantsUpdated: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  geocodingErrorCount: Scalars['Int'],
  numDuplicateRows: Scalars['Int'],
  googleSpreadsheetId: Scalars['String'],
};

export type MergeStandardizedSellableGroupInput = {
  mergeFrom: Scalars['StandardizedSellableGroupId'],
  mergeInto: Scalars['StandardizedSellableGroupId'],
};

export type MergeStandardizedSellableGroupPayload = {
   __typename: 'MergeStandardizedSellableGroupPayload',
  mergedGroup: StandardizedSellableGroup,
};

export type MergeTriggerWaitEdgesInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  edgeTypeToKeep: TriggerNodeEdgeType,
};

export type Message = {
   __typename: 'Message',
  id: Scalars['String'],
  sentAt: Scalars['Date'],
  sender: MessagingUser,
  body: MessageBody,
};

export type MessageBody = {
   __typename: 'MessageBody',
  summary: MessageSummary,
};

export enum MessageBodyType {
  TEXT = 'TEXT',
  FILE = 'FILE',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  MULTI_MEDIA = 'MULTI_MEDIA',
  OFFER = 'OFFER',
  DEAL = 'DEAL',
  VIDEO_CHAT_REQUESTED = 'VIDEO_CHAT_REQUESTED',
  VIDEO_CHAT_DECLINED = 'VIDEO_CHAT_DECLINED',
  OTHER = 'OTHER'
}

export enum MessageRichCardType {
  ONBOARDING_REQUEST_CONFIRMATION = 'ONBOARDING_REQUEST_CONFIRMATION',
  ONBOARDING_HOW_CURATED_WORKS = 'ONBOARDING_HOW_CURATED_WORKS',
  ONBOARDING_EXPERT_JOINED = 'ONBOARDING_EXPERT_JOINED',
  NEW_CUSTOM_CURATED_ORDER = 'NEW_CUSTOM_CURATED_ORDER',
  NEW_BOOKABLE_CURATED_ORDER = 'NEW_BOOKABLE_CURATED_ORDER',
  NEW_EXPERT_CURATED_ORDER_LIST = 'NEW_EXPERT_CURATED_ORDER_LIST',
  CONSUMER_INTERESTED_IN_CURATED_ORDER = 'CONSUMER_INTERESTED_IN_CURATED_ORDER',
  NEW_EXPERT_CURATED_ITEMS = 'NEW_EXPERT_CURATED_ITEMS',
  NEW_SYSTEM_CURATED_ITEMS = 'NEW_SYSTEM_CURATED_ITEMS',
  UPDATED_EXPERT_CURATED_ITEMS = 'UPDATED_EXPERT_CURATED_ITEMS',
  FEEDBACK_REQUEST_FROM_EXPERT = 'FEEDBACK_REQUEST_FROM_EXPERT',
  REFERRAL_REQUEST_FROM_EXPERT = 'REFERRAL_REQUEST_FROM_EXPERT',
  SYSTEM_CURATED_ITEM_SURVEY = 'SYSTEM_CURATED_ITEM_SURVEY',
  SIMPLE_CURATED_ORDER = 'SIMPLE_CURATED_ORDER',
  CONTACT_COLLECTION_REQUEST = 'CONTACT_COLLECTION_REQUEST',
  GUEST_CHAT_CREATE_REQUEST = 'GUEST_CHAT_CREATE_REQUEST',
  PAYMENT_VERIFICATION_REQUEST = 'PAYMENT_VERIFICATION_REQUEST',
  EXPERT_AWAY_AUTO_REPLY = 'EXPERT_AWAY_AUTO_REPLY',
  SELLABLE_REQUESTED = 'SELLABLE_REQUESTED',
  SELLABLE_PRICE_MATCH_REQUESTED = 'SELLABLE_PRICE_MATCH_REQUESTED'
}

export type MessageSummary = {
   __typename: 'MessageSummary',
  text?: Maybe<Scalars['String']>,
  type: MessageBodyType,
};

export enum MessageUnsubscribeTag {
  CURATION = 'CURATION',
  ONBOARDING = 'ONBOARDING',
  MESSAGE_NOTIFICATION = 'MESSAGE_NOTIFICATION',
  POST_PURCHASE = 'POST_PURCHASE',
  ABANDONED_ORDER = 'ABANDONED_ORDER',
  PATH_ONBOARDING = 'PATH_ONBOARDING',
  REFERRAL = 'REFERRAL',
  LEAD_CAMPAIGN = 'LEAD_CAMPAIGN'
}

export enum MessagingChannelType {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
  FACEBOOK = 'FACEBOOK',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION'
}

export type MessagingUser = {
   __typename: 'MessagingUser',
  id: Scalars['AnyId'],
  externalId?: Maybe<Scalars['String']>,
  displayName: Scalars['String'],
  internalMessagingUser: Scalars['Boolean'],
  avatar?: Maybe<MediaFile>,
  profile: MessagingUserProfile,
  preferredMessagingChannels: Array<MessagingChannelType>,
  notificationChannels: Array<MessagingChannelType>,
  type: MessagingUserType,
};

export type MessagingUserProfile = User | Merchant | Operator | BusinessUser | InternalMessagingUser | OnboardingSpecialistUser | SupportMessagingUser;

export enum MessagingUserType {
  USER = 'USER',
  MERCHANT = 'MERCHANT',
  BUSINESS_USER = 'BUSINESS_USER',
  OPERATOR = 'OPERATOR',
  DEAL_BOT = 'DEAL_BOT',
  ONBOARDING_SPECIALIST = 'ONBOARDING_SPECIALIST',
  SUPPORT = 'SUPPORT'
}

export type MonetaryAmount = {
   __typename: 'MonetaryAmount',
  amount: Scalars['BigDecimal'],
  currency: Scalars['CurrencyUnit'],
};


export type MonetaryAmountAmountArgs = {
  denominationType?: Maybe<MonetaryAmountDenominationType>
};

export enum MonetaryAmountDenominationType {
  /** Return amount in the default denomination (e.g.: dollars and cents, e.g.: "12.34" for $12.34 */
  DEFAULT = 'DEFAULT',
  /** Return amount in the smallest denomination for the given currency (e.g.: "1234" for $12.34) */
  SMALLEST = 'SMALLEST'
}

export type MonetaryAmountInput = {
  amount: Scalars['BigDecimal'],
  currency: Scalars['String'],
};

export type MonetaryAmountRangeInput = {
  lower?: Maybe<Scalars['BigDecimal']>,
  upper?: Maybe<Scalars['BigDecimal']>,
  currency: Scalars['CurrencyUnit'],
};

export type MonetaryAmountWithTax = {
   __typename: 'MonetaryAmountWithTax',
  /** The amount without tax */
  price: MonetaryAmount,
  /** The amount with tax added in */
  priceWithTax: MonetaryAmount,
  /** The amount of tax added */
  tax: MonetaryAmount,
  /** If tax is added (non-zero tax) */
  isTaxed: Scalars['Boolean'],
};

export type Money = {
   __typename: 'Money',
  amount: Scalars['Float'],
  currency: Scalars['String'],
};

export type MonitorVideoChatInput = {
  externalConversationId: Scalars['String'],
};

export type MonitorVideoChatPayload = {
   __typename: 'MonitorVideoChatPayload',
  token: Scalars['String'],
};

export type MultiChannelFulfillmentRequestInput = {
  ticketId: Scalars['TicketId'],
  merchantId: Scalars['MerchantId'],
  quantity?: Maybe<Scalars['Int']>,
  fulfillmentCenterId?: Maybe<Scalars['FulfillmentCenterId']>,
  fulfillmentShipmentMethodId?: Maybe<Scalars['FulfillmentShipmentMethodId']>,
  fulfillmentChannelId: Scalars['FulfillmentChannelId'],
  merchantQuote?: Maybe<MonetaryAmountInput>,
  merchantOrderId?: Maybe<Scalars['String']>,
  merchantEta?: Maybe<Scalars['Date']>,
  merchantMaxEta?: Maybe<Scalars['Date']>,
  merchantTax?: Maybe<MonetaryAmountInput>,
  merchantShippingCost?: Maybe<MonetaryAmountInput>,
};

export type MultiLocaleTemplateSet = {
   __typename: 'MultiLocaleTemplateSet',
  id: Scalars['CommTemplateId'],
  title: Scalars['String'],
  active: Scalars['Boolean'],
  state: TemplateState,
  historyId: Scalars['CommTemplateVersionHistoryId'],
  versionNumber: Scalars['Int'],
  singleLocaleSets: Array<SingleLocaleTemplateSet>,
  category?: Maybe<Category>,
  updatedAt: Scalars['Date'],
  experimentKey?: Maybe<Scalars['String']>,
  categoryType?: Maybe<CategoryType>,
  treatments?: Maybe<Array<Scalars['String']>>,
  templateType: CommTemplateType,
  tagSyntax: TemplateTagSyntax,
  emailFromAddress?: Maybe<Scalars['String']>,
  allowedEmailFromAddresses: Array<Scalars['String']>,
  pendingDraft?: Maybe<MultiLocaleTemplateSet>,
  changes: Array<TemplateChange>,
};

export type Mutation = {
   __typename: 'Mutation',
  addAddress: AddAddresssPayload,
  updateAddressPreferences: UpdateAddressPreferencesPayload,
  deleteAddress: DeleteAddressPayload,
  initiateAuthentication: InitiateAuthenticationPayload,
  initiateResetPassword: InitiateResetPasswordPayload,
  initiateVerifyHandle: InitiateVerifyHandlePayload,
  authenticate: AuthenticationResultPayload,
  authenticateByExternalOAuthToken: AuthenticateByExternalOAuthTokenPayload,
  logout: Scalars['Boolean'],
  createPassword: CreatePasswordPayload,
  resetPassword: ResetPasswordPayload,
  changePassword: ChangePasswordPayload,
  verifyResetPasswordChallenge: VerifyResetPasswordChallengePayload,
  verifyHandleChallenge: VerifyHandleChallengePayload,
  refreshAccessToken: RefreshAccessTokenPayload,
  createCommTemplate: CreateTemplatePayload,
  updateCommTemplate: UpdateTemplatePayload,
  copyCommTemplate: CreateTemplatePayload,
  publishCommTemplate: UpdateTemplatePayload,
  deactivateCommTemplate: UpdateTemplatePayload,
  newCommTemplateVersion: CreateTemplatePayload,
  updateChannelTemplate: UpdateTemplatePayload,
  removeChannelTemplate: UpdateTemplatePayload,
  addChannelTemplate: UpdateTemplatePayload,
  sendTemplateTestMessage: SendTemplateTestMessagePayload,
  createCommTemplateType: CreateTemplateTypePayload,
  copyCommTemplateType: CopyTemplateTypePayload,
  updateCommTemplateType: UpdateTemplateTypePayload,
  createCommTemplateFragment: CreateTemplateFragmentPayload,
  updateCommTemplateFragment: UpdateTemplateFragmentPayload,
  copyCommTemplateFragment: CopyTemplateFragmentPayload,
  publishCommTemplateFragment: UpdateTemplateFragmentPayload,
  deactivateCommTemplateFragment: UpdateTemplateFragmentPayload,
  newCommTemplateFragmentVersion: CreateTemplateFragmentPayload,
  generateTemplateFragmentSnippet: GenerateTemplateFragmentSnippetPayload,
  generateTemplateDirectiveSnippet: GenerateTemplateDirectiveSnippetPayload,
  createDealRequest: CreateDealRequestPayload,
  createUser: CreateUserPayload,
  createOperators: CreateOperatorsPayload,
  updateOperator: UpdateOperatorPayload,
  updateUserProfile: UpdateUserProfilePayload,
  createMerchant: CreateMerchantPayload,
  createMerchants: CreateMerchantsPayload,
  updateMerchant: UpdateMerchantPayload,
  registerCustomer: RegisterCustomerPayload,
  createPendingAccessContact: CreatePendingAccessContactPayload,
  verifyPendingAccessContact: VerifyPendingAccessContactPayload,
  assumeOperatorIdentity: AssumeOperatorIdentityPayload,
  releaseOperatorIdentity: ReleaseOperatorIdentityPayload,
  assumeConsumerIdentity: AssumeConsumerIdentityPayload,
  releaseConsumerIdentity: ReleaseConsumerIdentityPayload,
  generateMyLoginToken?: Maybe<Scalars['String']>,
  updateUserSource: UpdateUserSourcePayload,
  claimConsumerReferral: ClaimConsumerReferralUserSourcePayload,
  createBusinessUser: CreateBusinessUserPayload,
  updateBusinessUser: UpdateBusinessUserPayload,
  updateBusinessUserVanityId: UpdateBusinessUserPayload,
  assumeBusinessUserIdentity: AssumeBusinessUserIdentityPayload,
  releaseBusinessUserIdentity: ReleaseBusinessUserIdentityPayload,
  setAcceptingNewRequests: ExpertPresenceStatusUpdateResponse,
  setExpertOnCall: ExpertPresenceStatusUpdateResponse,
  startOnCallShift: ExpertPresenceStatusUpdateResponse,
  startExpertShift: ExpertPresenceStatusUpdateResponse,
  setExpertOffShift: ExpertPresenceStatusUpdateResponse,
  setExpertAwayAutoReply: SetExpertAwayAutoReplyPayload,
  createBusinessAccount: CreateBusinessAccountPayload,
  createBusinessUserTeam: CreateBusinessUserTeamPayload,
  deactivateExpert: DeactivateExpertPayload,
  activateExpert: ActivateExpertPayload,
  setExpertTeamLead: SetExpertTeamLeadPayload,
  devTools?: Maybe<DevToolsMutation>,
  createFirebaseToken: CreateFirebaseTokenPayload,
  registerFirebaseCloudMessagingToken: RegisterFirebaseCloudMessagingTokenPayload,
  registerWebPushSubscription: RegisterWebPushSubscriptionPayload,
  unregisterWebPushSubscription: UnregisterWebPushSubscriptionPayload,
  unregisterFirebaseCloudMessagingToken: UnregisterFirebaseCloudMessagingTokenPayload,
  updatePreferredMessagingChannels: UpdatePreferredMessagingChannelsPayload,
  setPreferredMessagingChannel: SetPreferredMessagingChannelPayload,
  updateNotificationChannels: UpdateNotificationChannelsPayload,
  joinVideoChat: JoinVideoChatPayload,
  declineVideoChat: DeclineVideoChatPayload,
  monitorVideoChat: MonitorVideoChatPayload,
  bridgePhoneCall: BridgePhoneCallPayload,
  bridgeLeadPhoneCall: BridgePhoneCallPayload,
  bridgeExpertApplicationPhoneCall: BridgePhoneCallPayload,
  markConversationRead: MarkConversationReadPayload,
  generateCollectPhoneNumberTextInPath: GenerateCollectPhoneNumberTextInPathPayload,
  addBlacklistChannelAddress: AddBlacklistChannelAddressPayload,
  upgradeGuestConversation: UpgradeGuestConversationPayload,
  createDraftGuestConversationSequence: CreateDraftGuestConversationSequencePayload,
  addGuestConversationSequenceMessage: AddGuestConversationSequenceMessagePayload,
  updateGuestConversationSequence: UpdateGuestConversationSequencePayload,
  activateGuestConversationSequence: ActivateGuestConversationSequencePayload,
  deactivateGuestConversationSequence: DeactivateGuestConversationSequencePayload,
  startGuestConversation: StartGuestConversationPayload,
  createPathFlow: CreatePathFlowPayload,
  submitPathFlowPage: SubmitPathFlowPagePayload,
  reenterPathFlowPage: ReenterPathFlowPagePayload,
  reenterPathFlowPageBySlugs: ReenterPathFlowPagePayload,
  submitListPathFlowQuestion: SubmitListPathFlowQuestionPayload,
  submitUserContactPathFlowQuestion: SubmitUserContactPathFlowQuestionPayload,
  submitNumericPathFlowQuestion: SubmitNumericPathFlowQuestionPayload,
  submitOAuthEmailPathFlowQuestion: SubmitOAuthEmailPathFlowQuestionPayload,
  submitInputTextPathFlowQuestion: SubmitInputTextPathFlowQuestionPayload,
  submitIdPathFlowQuestion: SubmitIdPathFlowQuestionPayload,
  submitDatePathFlowQuestion: SubmitDatePathFlowQuestionPayload,
  submitDateRangePathFlowQuestion: SubmitDateRangePathFlowQuestionPayload,
  placeOrderForOffer: PlaceOrderForOfferPayload,
  initiatePaypalPaymentForOffer: InitiatePaypalPaymentForOfferPayload,
  /** Order fulfillment related mutations */
  addOperatorNote: UpdateOrderPayload,
  addReturnShipmentTracking: UpdateOrderPayload,
  addShipmentTracking: UpdateOrderPayload,
  assignFulfillmentOperator: UpdateOrderPayload,
  claimOrderLineItem: ClaimOrderLineItemPayload,
  orderLineItemUnavailable: UpdateOrderPayload,
  orderLineItemReceived: OrderLineItemReceivedPayload,
  removeShipmentTracking: UpdateOrderPayload,
  removeReturnShipmentTracking: UpdateOrderPayload,
  updateShippingMethod: UpdateShippingMethodPayload,
  updateOrderShippingAddress: UpdateOrderShippingAddressPayload,
  updatePreClaimedOrderShippingAddress: UpdateOrderShippingAddressPayload,
  createPaymentSource: CreatePaymentSourcePayload,
  updatePaymentSource: UpdatePaymentSourcePayload,
  deletePaymentSource: DeletePaymentSourcePayload,
  payForOrder: PayForOrderPayload,
  addTipToOrder: AddTipToOrderPayload,
  removeTipFromOrder: RemoveTipFromOrderPayload,
  submitOrder: SubmitOrderPayload,
  cancelSubmittedOrder: CancelSubmittedOrderPayload,
  initiatePaypalPaymentForOrder: InitiatePaypalPaymentForOrderPayload,
  /** 
 * The Afterpay payment process starts by generating a unique order token for the Order. This is done on the backend
   * that also sets up the AfterpayPaymentProcessorAccount for the user if it
   * doesn't exist and registers the PaymentRedirectUrls
   * with Afterpay
   * On successful creation, the user is redirected to Afterpay with the orderToken
   * received in response passed as a parameter to Afterpay
   * The user goes through the loan/payment plan process on Afterpay and may be approved or declined.
   * If the user is approved, then the payment should be captured and the process is completed using the payForOrder api,
   * with the paymentProcessorPlatformSourceId set as the orderToken here.
   * If the users is declined or the process fails for any reason, then call the markPaymentDeclinedForOrder to capture
   * this state in the backend
 **/
  initiateAfterpayPaymentForOrder: InitiateAfterpayPaymentForOrderPayload,
  /** 
 * The Affirm payment process starts by the frontend passing a JSON checkout object to Affirm. This is done on the
   * backend which generates the checkout JSON object from the Order and the given PaymentRedirectUrls. The JSON object is
   * passed back to frontend as a JSON string. Once the frontend calls Affirm Javascript SDK to open the modal and the user
   * gets approved, a checkout_token is received. The checkout_token is used to
   * authorize and capture the payment via payForOrder api.
   * The paymentProcessorPlatformSourceId is the checkout_token.
 **/
  initiateAffirmPaymentForOrder: InitiateAffirmPaymentForOrderPayload,
  /** 
 * Some payment processors return the authorization response of a succes, approval, failure via means of redirection
   * to our website with additonal params. These processors may not support async webhook events so use this api to
   * notify the backend of any such changes.
   * This is a best effort approach as we run the risk of a user closing the browser before such a the request
   * was initiated. Fortunately, the order/payment doesn't go through.
 **/
  markPaymentPreApprovalFailedForOrder: MarkPaymentPreApprovalFailedForOrderPayload,
  /** Deprecate */
  markPaymentFailedForOrder: MarkPaymentFailedForOrderPayload,
  /** 
 * For payments that go through the multiple steps with the initiatePayment APIs, its possible that the user might
   * abandon a payment flow mid way. Most of the processors will return and redirect the consumer back to our
   * site with canceled state.
   * The frontend should use this api to inform the server of this canceled state. This is necessary to put the order
   * in the correct state to allow use of other payment methods.
 **/
  cancelPaymentRequestForOrder: CancelPaymentRequestForOrderPayload,
  syncOrder: SyncOrderPayload,
  addItemsToOrder: AddItemsToOrderPayload,
  removeItemsFromOrder: RemoveItemsFromOrderPayload,
  updateQuantityForOrder: UpdateQuantityForOrderPayload,
  addPromotionToOrder: AddPromotionToOrderPayload,
  dismissOrderMessages: DismissOrderMessagesPayload,
  /** 
 * Expert API to retrieve the user's cart, or create it if it doesn't exist.
   * This API should **never** be invoked when trying to fetch the current user's cart; prefer `syncOrder`.
   * This is primarily for experts to fetch a user's cart (or create if it doesn't exist). This is useful for the expert
   * to view the cart of a user, and eventually add items to the user's cart through `addExpertCuratedItemsToCart`
 **/
  getOrCreateUserCartForExpert: GetOrCreateUserCartForExpertPayload,
  /** 
 * Create a new promotion in draft state. After customizing the promotion, use `activatePromotion` to shift it to
   * ACTIVE state so it's available for consumers to use.
 **/
  createPromotion: CreateDraftPromotionPayload,
  /** 
 * Activate a promotion in `DRAFT` state. Note that if there is an existing active promotion with the
   * same promotion code, this API will automatically disable that promotion. Use the `activePromotionByCode` query
   * to discover existing active promotions and prompt the user if one exists before creating this one.
 **/
  activatePromotion: ActivatePromotionPayload,
  /** 
 * Disable an existing promotion. Users that just added this item to their cart before disabling will still have a
   * short grace period (1 hour) to use the promotion to minimize the chance of disrupting their checkout flow.
 **/
  disablePromotion: DisablePromotionPayload,
  /** 
 * Create a new promotion in `DRAFT` state which will be a copy of the promotion referenced by the input id. Some
   * state will be reset, for example, if the expiration date is in the past, it'll be removed. usageCount will be
   * reset as well.
 **/
  copyPromotion: CopyPromotionPayload,
  /** 
 * Conditionally update fields of a promotion in `DRAFT` state. This includes everything except for `rules` and
   * `actions`, which are taken care of by the targeted APIs like `upsertRuleIntoPromotion`, `removeRuleFromPromotion`,
   * and `reorderRulesInPromotion`
 **/
  updatePromotion: UpdatePromotionPayload,
  /** 
 * Add a rule to a promotion in `DRAFT` state, or if an existing `PromotionRuleReferenceId` is referenced, replace the
   * contents of that rule with the incoming payload.
 **/
  upsertRuleIntoPromotion: UpsertRuleIntoPromotionPayload,
  /** Remove a rule from a promotion in `DRAFT` state. */
  removeRuleFromPromotion: RemoveRuleFromPromotionPayload,
  /** 
 * Re-order the rules for a promotion in `DRAFT` state. It's assumed all rule expectedReference ids in the promotion are
   * present in this list, potentially re-ordered.
 **/
  reorderRulesInPromotion: ReorderRulesInPromotionPayload,
  /** 
 * Add a action to a promotion in `DRAFT` state, or if an existing `PromotionActionReferenceId` is referenced, replace
   * the contents of that action with the incoming payload.
 **/
  upsertActionIntoPromotion: UpsertActionIntoPromotionPayload,
  /** Remove a action from a promotion in `DRAFT` state. */
  removeActionFromPromotion: RemoveActionFromPromotionPayload,
  /** 
 * Re-order the actions for a promotion in `DRAFT` state. It's assumed all action expectedReference ids in the promotion are
   * present in this list, potentially re-ordered.
 **/
  reorderActionsInPromotion: ReorderActionsInPromotionPayload,
  /** 
 * The ACH/wire transfer payment process starts by assigning a unique bank account for the user. This bank account
   * is reused across multiple orders. This is done on the backend by calling Stripe API to create the ACH credit transfer
   * payment source. This source is associated with the StripeAccount for that user.
 **/
  initiateWireTransferPaymentForOrder: InitiateWireTransferPaymentForOrderPayload,
  updateOrderState: UpdateOrderStatePayload,
  updateOrderExpertContributions: UpdateOrderExpertContributionsPayload,
  /** 
 * puts an order line item in CUSTOMIZING state, an intermediate state between CLAIMED and PENDING_SHIPPING where the
   * merchant does checks/customizations to get the item ready for shipping
 **/
  updateOrderLineItemStateToCustomizing: ItemCustomizingPayload,
  /** indicates problems with the item during CUSTOMIZING state, will put the item back into CLAIMED state */
  markCustomizationIssuesForOrderLineItem: ItemHasCustomizationIssuesPayload,
  /** unclaim an order line item and puts it back into READY_TO_CLAIM state */
  unclaimOrderLineItem: UpdateOrderPayload,
  /** 
 * Initiates the fulfillment process from our own inventory.
   * Note, this request starts the fulfillment process and remains in pending state for some amount of time to
   * allow for handling cancellations or updates on our side.
   * In addition, this request may fail due to us not having inventory during the time of order. As such, this request
   * doesn't guarantee fulfillment
 **/
  initiateDealInventoryFulfillment: InitiateDealInventoryFulfillmentPayload,
  requestItemReturn: UpdateOrderPayload,
  syncItemShippingStatus: UpdateOrderPayload,
  verifyPaymentTransaction: VerifyPaymentTransactionPayload,
  createTag: CreateTagPayload,
  removeTag: RemoveTagPayload,
  uploadMerchants: UploadMerchantsPayload,
  uploadSellables: UploadSellablesPayload,
  uploadSellablePrice: UploadSellablePricePayload,
  uploadFeaturedSellableContent: UploadFeaturedSellableContentPayload,
  uploadBrands: UploadBrandsPayload,
  uploadSellableUpdates: UploadSellableUpdatesPayload,
  uploadSellableDeactivations: UploadSellableDeactivationsPayload,
  uploadSellableInventory: UploadSellableInventoryPayload,
  createMerchantOffer: CreateOfferPayload,
  createFreeFormOffer: CreateOfferPayload,
  createOfferFromSellable: CreateOfferPayload,
  createOfferForSelfCheckout: CreateOfferPayload,
  totalCostForOffer: TotalCostForOfferPayload,
  createOrderFromOffer: CreateOrderFromOfferPayload,
  addOfferToCart: AddOfferToCartPayload,
  uploadMedia: UploadMediaPayload,
  createMedia: CreateMediaPayload,
  persistMedia: PersistMediaPayload,
  createDraftExpertProfile: CreateExpertProfilePayload,
  submitExpertProfile: UpdateExpertProfilePayload,
  approveExpertProfile: UpdateExpertProfilePayload,
  requestChangesOnExpertProfile: UpdateExpertProfilePayload,
  updateExpertProfile: UpdateExpertProfilePayload,
  startExpertRating: StartExpertRatingPayload,
  startExpertRatingPath: StartExpertRatingPayload,
  updateConsumerExpertReview: UpdateConsumerExpertReviewPayload,
  deleteConsumerExpertReview: Scalars['Boolean'],
  addExpertProfileHighlight: UpdateExpertProfilePayload,
  removeExpertProfileHighlight: UpdateExpertProfilePayload,
  createBlankExpertApplication: CreateBlankExpertApplicationPayload,
  approveExpertApplication: ApproveExpertApplicationPayload,
  rejectExpertApplication: RejectExpertApplicationPayload,
  setExpertApplicationArchived: UpdateExpertApplicationPayload,
  setExpertApplicationSnooze: UpdateExpertApplicationPayload,
  cancelExpertApplicationSnooze: UpdateExpertApplicationPayload,
  requestConsumerReviewByExpert: RequestConsumerExpertReviewPayload,
  requestReferralByExpert: RequestReferralByExpertPayload,
  sendExpertReferral: SendExpertReferralPayload,
  createExpertFromApplication: CreateExpertFromApplicationPayload,
  addExpertApplicationReview: AddExpertApplicationReviewPayload,
  updateExpertApplicationTaskStatus: UpdateExpertApplicationTaskStatusPayload,
  setExpertApplicationTaskCompleted: SetExpertApplicationTaskCompletedPayload,
  rerunExpertApplicationTask: RerunExpertApplicationTaskPayload,
  startExpertApplicationConversation: ExpertApplication,
  addExpertApplicationNote: UpdateExpertApplicationPayload,
  saveSavedSellable: SaveSavedSellablePayload,
  unsaveSavedSellable: UnsaveSavedSellablePayload,
  createSellable: CreateSellablePayload,
  updateSellable: UpdateSellablePayload,
  deactivateSellable: DeactivateSellablePayload,
  createSellableTerms: CreateSellableTermsPayload,
  requestSellable: RequestSellablePayload,
  updateAdHocSellablePrice: UpdateAdHocSellablePricePayload,
  deactivateSellablePriceSource: DeactivateSellablePriceSourcePayload,
  refreshSellablePriceSource: RefreshSellablePriceSourcePayload,
  saveConsumerSellableReaction: SaveConsumerSellableReactionPayload,
  createSellableResearchLink: CreateSellableResearchLinkPayload,
  deleteSellableResearchLink: DeleteSellableResearchLinkPayload,
  requestSellablePriceMatch: RequestSellablePriceMatchPayload,
  startExpertConsumerConversation: StartExpertConsumerConversationPayload,
  setLeadSnooze: UpdateLeadPayload,
  cancelLeadSnooze: UpdateLeadPayload,
  setLeadStar: UpdateLeadPayload,
  setLeadArchived: UpdateLeadPayload,
  setLeadDoNotCall: UpdateLeadPayload,
  dismissLeadSuggestedAction: UpdateLeadPayload,
  delegateLead: UpdateLeadPayload,
  reassignLead: UpdateLeadPayload,
  setConsumerInitialLeadAction: SetConsumerInitialLeadActionPayload,
  createQuickReplyWithLead: CreateQuickReplyPayload,
  createQuickReplyWithoutLead: CreateQuickReplyPayload,
  createQuickReply: CreateQuickReplyPayload,
  updateQuickReply: UpdateQuickReplyPayload,
  deleteQuickReply: Scalars['Boolean'],
  createLeadNote: CreateLeadNotePayload,
  updateLeadNote: UpdateLeadNotePayload,
  deleteLeadNote: Scalars['Boolean'],
  addUserInfoForLead: AddUserInfoForLeadPayload,
  acceptLeadEscalation: AcceptEscalationResult,
  startLeadEscalation: StartLeadEscalationPayload,
  reportPredictedLifeTimeValueToPlatform: ReportPredictedLifeTimeValuePayload,
  createLeadSurge: CreateLeadSurgePayload,
  createLeadCampaign: CreateLeadCampaignPayload,
  copyLeadCampaign: CreateLeadCampaignPayload,
  updateLeadCampaign: UpdateLeadCampaignPayload,
  deactivateLeadCampaign: UpdateLeadCampaignPayload,
  activateLeadCampaign: UpdateLeadCampaignPayload,
  createLeadCampaignTrigger: UpdateLeadCampaignPayload,
  scheduleLeadCampaign: UpdateLeadCampaignPayload,
  cancelScheduledLeadCampaign: UpdateLeadCampaignPayload,
  createReport: UpdateReportPayload,
  updateReport: UpdateReportPayload,
  addReportSchedule: UpdateReportPayload,
  removeReportSchedule: UpdateReportPayload,
  /** 
 * Add expert curated itemt to cart.
   * This is intended to be invoked by consumers to add the expert curated item to cart. Note that this special mutation
   * is required since it'll allow the consumer to add items with price overrides, where the consumer typically can't
   * add items to cart and override the price themselves.
 **/
  addExpertCuratedItemToCart: AddExpertCuratedItemToCartPayload,
  /** 
 * Create new expert curated item in draft state. `makeExpertCuratedItemDraftsActive` must be used to convert to
   * activate/submit the drafts into an active state.
 **/
  createExpertCuratedItem: CreateExpertCuratedItemPayload,
  /** 
 * This is intended to allow bulk duplicating data from existing ExpertCuratedItem's as new ExpertCuratedItem's
   * recommended to a new lead based on recommendations of similar ExpertCuratedItem's
 **/
  copyFromExpertCuratedItems: CopyFromExpertCuratedItemsPayload,
  /** Update an existing expert curated item */
  updateExpertCuratedItem: UpdateExpertCuratedItemPayload,
  /** Remove an existing expert curated item */
  removeExpertCuratedItem: RemoveExpertCuratedItemPayload,
  /** Make all drafts associated with the lead active, and invoke relevant actions */
  makeExpertCuratedItemDraftsActive: MakeExpertCuratedItemDraftsActivePayload,
  /** 
 * Expert API to create a curated recommended order in draft mode that's backed by an actual `Order`. This expert
   * initializes it self from the provided sellable, copying over variations and prices, and starts off in a draft
   * mode where further alterations can be made. (see mutations like `updateExpertCuratedOrderVariationOptions`).
   * This is typically used for recommending services, as they typically involve more than one sellable
 **/
  createExpertCuratedOrder: CreateExpertCuratedOrderPayload,
  /** 
 * Expert API to change the availability or price of the variations. Note that additional variations that don't
   * exist on the sellable cannot be added!
 **/
  updateExpertCuratedOrderVariationOptions: UpdateExpertCuratedOrderVariationOptionsPayload,
  /** Expert API to insert or update an add-on item */
  upsertItemsInExpertCuratedOrder: UpsertItemsInExpertCuratedOrderPayload,
  /** Expert API to remove an add-on item */
  removeItemsFromExpertCuratedOrder: RemoveItemsFromExpertCuratedOrderPayload,
  /** 
 * Expert API to make a created expert curated order a bookable one. It will bringing it out of draft mode into ACTIVE state.
   * It requires the curated order to be not in the preview mode and verifies that
   * all required fields like date are all specified
   * once a curated order is active, the terms, variations, or items can't be modified by the expert. It can only be
   * closed, different options can be selected between by the consumer, or a replacement curated order can be made via
   * `findOrCreateReplacementExpertCuratedOrder`. By activating an order, a rich card will be sent to the client as well.
 **/
  activateExpertCuratedOrderAsBookable: ActivateExpertCuratedOrderAsBookablePayload,
  /** Expert API to send a notification to the customer about a particular curated order */
  notifyCustomerExpertCuratedOrder: NotifyCustomerExpertCuratedOrderPayload,
  /** Consumer API to send a notification to the expert that they're interested in a curated order */
  customerRequestExpertCuratedOrder: CustomerRequestExpertCuratedOrderPayload,
  /** Close out the expert curated order, effectively expiring it making it unpurchase-able by the user */
  closeExpertCuratedOrder: CloseExpertCuratedOrderPayload,
  /** Expert API to update terms (service start date, etc) */
  updateExpertCuratedOrderTerms: UpdateExpertCuratedOrderTermsPayload,
  /** 
 * Consumer API to toggle between available variations. Only applicable if the expert curated order is active,
   * and the order hasn't been purchased yet.
 **/
  selectExpertCuratedOrderVariationOption: SelectExpertCuratedOrderVariationOptionPayload,
  /** 
 * Consumer API to disable (remove) optional add-ons they're not interested in. Only applicable if the expert curated
   * order is active, and the order hasn't been purchased yet.
 **/
  selectExpertCuratedOrderItems: SelectExpertCuratedOrderItemsPayload,
  /** 
 * Expert API to override the service location that was originally derived from the sellable service merchant's address.
   * This new address will be used across the board for this expert curated order; displaying to the consumer, computing
   * tax, etc.
 **/
  updateServiceLocationExpertCuratedOrder: UpdateServiceLocationExpertCuratedOrderPayload,
  /** 
 * Expert API to activate all pending draft curated orders associated with a lead. This is similar to
   * `activateExpertCuratedOrder`, except that this activates multiple curated orders, resulting an a activation list
   * object summarizing the result (the curated orders that were activated, closed, etc). This also sends a custom
   * rich card to the client displaying the activation list (summary of all the curated orders).
 **/
  activateExpertCuratedOrdersForLead: ActivateExpertCuratedOrdersForLeadPayload,
  /** 
 * Accept ExpertCuratedOrderId, setup superseded chain and make as draft.
   * Activation of this will disable previous supersededId
 **/
  findOrCreateReplacementExpertCuratedOrder: FindOrCreateReplacementExpertCuratedOrderPayload,
  /** Expert API to copy `items` from one curated order to another; convienence API to quickly copy addons. */
  copyItemsFromExpertCuratedOrder: CopyItemsFromExpertCuratedOrderPayload,
  /** Expert API to set the contentful itinerary to show on the expert curated orders list page for the lead */
  upsertExpertCuratedLeadItinerary: UpsertExpertCuratedLeadItineraryPayload,
  /** Expert API to delete the contentful itinerary to show on the expert curated orders list page for the lead */
  deleteExpertCuratedLeadItinerary: DeleteExpertCuratedLeadItineraryPayload,
  createSavedExpertCuratedItems: CreateSavedExpertCuratedItemsPayload,
  updateSavedExpertCuratedItems: UpdateSavedExpertCuratedItemsPayload,
  deleteSavedExpertCuratedItems: DeleteSavedExpertCuratedItemsPayload,
  createExpertConsultationFeeOrder: CreateExpertConsultationFeeOrderPayload,
  extendExpertCuratedItemExpiration: ExtendExpertCuratedItemExpirationPayload,
  /** 
 * This api is used to record the reviews for the Suggested Alternative recommendations for a sellable.
   * Note the suggestions are saved temporarily in the database and expires after 3 days. Adding a review for a
   * suggestion after the expiry period will result in an error.
   * Once a review is added, the suggestion are not expired and the review answers can be changed in future too.
 **/
  saveReviewForSuggestedAlternativeSellable: SaveReviewForSuggestedAlternativeSellablePayload,
  /** Only allowed to create RecommndedListDefinition of RecommendedListType.CUSTOM. */
  createRecommendedListDefinition: CreateRecommendedListDefinitionPayload,
  /** 
 * Update Mutation supports partial updates, most of the fields in the UpdateRecommendedListDefinitionInput are optional
   * and if they input is missing those field values it will retain the corresponding old values.
   * System default recommendedListDefinition don't allow updating their type, query facets and sorting.
 **/
  updateRecommendedListDefinition: UpdateRecommendedListDefinitionPayload,
  deleteRecommendedListDefinition: DeleteRecommendedListDefinitionIdPayload,
  createTrigger: CreateTriggerPayload,
  updateTrigger: UpdateTriggerPayload,
  createTriggerNode: UpdateTriggerPayload,
  removeTriggerNode: UpdateTriggerPayload,
  updateTriggerFilter: UpdateTriggerPayload,
  updateTriggerDelay: UpdateTriggerPayload,
  updateTriggerAction: UpdateTriggerPayload,
  updateTriggerBranch: UpdateTriggerPayload,
  swapTriggerBranchEdges: UpdateTriggerPayload,
  updateTriggerWait: UpdateTriggerPayload,
  swapTriggerWaitEdges: UpdateTriggerPayload,
  splitTriggerWaitEdges: UpdateTriggerPayload,
  mergeTriggerWaitEdges: UpdateTriggerPayload,
  updateTriggerEdge: UpdateTriggerPayload,
  removeTriggerEdge: UpdateTriggerPayload,
  publishTrigger: PublishTriggerPayload,
  deactivateTrigger: DeactivateTriggerPayload,
  archiveTrigger: ArchiveTriggerPayload,
  newTriggerVersion: NewTriggerVersionPayload,
  importEntities: ImportEntitiesPayload,
  testTriggerExecution: TestTriggerExecutionPayload,
  shortenUrl?: Maybe<ShortenUrlPayload>,
  createAdhocSellableFromEBayItem: CreateAdhocSellableFromEBayItemPayload,
  identifyEBayItemAsSellable: IdentifyEBayItemAsSellablePayload,
  updateConfig: UpdateConfigPayload,
  resetConfig: ResetConfigPayload,
  syncExternalAdCampaigns: SyncExternalAdCampaignsPayload,
  updateExternalAdCampaign: UpdateExternalAdCampaignPayload,
  updateExternalAdGroup: UpdateExternalAdGroupPayload,
  applyExternalAdBudget: ApplyExternalAdBudgetPayload,
  startSystemCuratedItemSurvey: StartSystemCuratedItemSurveyPayload,
  terminateSystemCuratedItemSurvey: TerminateSystemCuratedItemSurveyPayload,
  createFlightPlan: CreateFlightPlanPayload,
  activateFlightPlan: ActivateFlightPlanPayload,
  copyFlightPlanAsDraft: CopyFlightPlanAsDraftPayload,
  upsertLegsIntoFlightPlan: UpsertLegsIntoFlightPlanPayload,
  removeLegsFromFlightPlan: RemoveLegsFromFlightPlanPayload,
  assignSupportTask: AssignSupportTaskPayload,
  completeSupportTaskNoActionNeeded: CompleteSupportTaskNoActionNeededPayload,
  completeSupportTaskSnooze: CompleteSupportTaskSnoozePayload,
  completeLeadSupportTaskAssignLeadActions: CompleteLeadSupportTaskAssignLeadActionsPayload,
  completeLeadSupportTaskDelegateLead: CompleteLeadSupportTaskDelegateLeadPayload,
  completeLeadSupportTaskReassignLead: CompleteLeadSupportTaskReassignLeadPayload,
  completeLeadSupportTaskEscalateToTeamForDelegation: CompleteLeadSupportTaskEscalateToTeamForDelegationPayload,
  completeLeadSupportTaskEscalateForReassignment: CompleteLeadSupportTaskEscalateForReassignmentPayload,
  completeLeadSupportTaskRequestOrderSupport: CompleteLeadSupportTaskRequestOrderSupportPayload,
  addSupportToLeadConversation: AddSupportToLeadConversationPayload,
  removeSupportFromLeadConversation: RemoveSupportFromLeadConversationPayload,
  createOrderEscalation: CreateOrderEscalationsPayload,
  assignOrderEscalation: UpdateOrderEscalationPayload,
  startOrderEscalation: UpdateOrderEscalationPayload,
  completeOrderEscalation: UpdateOrderEscalationPayload,
  addEscalationNote: UpdateOrderEscalationPayload,
  setEscalationPriority: UpdateOrderEscalationPayload,
  startSupportConversation: UpdateSupportConversationPayload,
  addOrderEscalationLabel: UpdateOrderEscalationPayload,
  removeOrderEscalationLabel: UpdateOrderEscalationPayload,
  dismissSuggestedSupportAction: UpdateSupportConversationPayload,
  updateSellableInventoryItem: SellableInventoryItemUpdatePayload,
  syncShopifyInventoryItem: SyncShopifyInventoryPayload,
  createPayStructure: CreatePayStructurePayload,
  createPayStructureRevision: UpdatePayStructureRevisionPayload,
  updatePayStructureRevision: UpdatePayStructureRevisionPayload,
  activatePayStructureRevision: UpdatePayStructureRevisionPayload,
  approvePayout: UpdatePayoutPayload,
  bulkApprovePayouts: BulkUpdatePayoutPayload,
  resendPayout: UpdatePayoutPayload,
  recomputePayout: UpdatePayoutPayload,
  addManualAdjustmentPayLineItem: UpdatePayoutPayload,
  createRawSellableSource: CreateRawSellableSourcePayload,
  updateRawSellableSource: UpdateRawSellableSourcePayload,
  createRawSellableStandardizationRule: CreateRawSellableStandardizationRulePayload,
  updateRawSellableStandardizationRule: UpdateRawSellableStandardizationRulePayload,
  mergeStandardizedSellableGroup: MergeStandardizedSellableGroupPayload,
  startStandardizedSellableGroupIngestion: StartStandardizedSellableGroupIngestionPayload,
  startRawSellableSourceIngestion: StartRawSellableSourceIngestionPayload,
  acceptStandardizedSellableGroupCandidate: AcceptStandardizedSellableGroupCandidatePayload,
  rejectStandardizedSellableGroupCandidate: RejectStandardizedSellableGroupCandidatePayload,
  startRawSellableStandardization: StartRawSellableStandardizationPayload,
  startStandardizationSellableMatching: StartStandardizationSellableMatchingPayload,
  importRawSellableSource: ImportRawSellableSourcePayload,
  importRawSellableStandardizationRule: ImportRawSellableStandardizationRulePayload,
  importRawSellableStandardizationRules: ImportRawSellableStandardizationRulesPayload,
  createSchedulingDemandForecast: CreateSchedulingDemandForecastPayload,
  updateSchedulingDemandForecast: UpdateSchedulingDemandForecastPayload,
  removeSchedulingDemandForecast: RemoveSchedulingDemandForecastPayload,
  createSchedulingUserAvailability: CreateSchedulingUserAvailabilityPayload,
  removeSchedulingUserAvailability: RemoveSchedulingUserAvailabilityPayload,
  claimShift: UpdateShiftPayload,
  cancelShift: UpdateShiftPayload,
  createShift: CreateShiftPayload,
  updateSchedulingUserProfile: UpdateSchedulingUserPayload,
  copySchedulingDemandForecastToNextPeriod: CopySchedulingDemandForecastPayload,
  overwriteShiftSlot: OverwriteShiftSlotPayload,
  runShiftAssignments: RunShiftAssignmentsPayload,
  updateSchedulingUserRoles: UpdateSchedulingUserPayload,
  updateSchedulingType: UpdateSchedulingTypePayload,
  acceptSurgeShift: AcceptSurgeShiftPayload,
  findOrCreateChannel: CreateFulfillmentChannelPayload,
  updateFulfillmentInstructions: UpdateFulfillmentChannelPayload,
  claimLineItemByChannel: UpdateFulfillmentTicketPayload,
  skipFulfillmentChannel: UpdateFulfillmentTicketPayload,
  assignOrderLineItem: UpdateFulfillmentTicketPayload,
  setFulfillmentChannelBlacklisted: UpdateFulfillmentChannelPayload,
  updateFulfillmentChannel: UpdateFulfillmentChannelPayload,
  verifyOrder: UpdateOrderPayload,
  requestRefund: UpdateOrderRefundPayload,
  rejectRefundRequest: UpdateOrderRefundPayload,
  setRefundSucceeded: UpdateOrderRefundPayload,
  setRefundFailed: UpdateOrderRefundPayload,
  adjustRequestedRefundAmount: UpdateOrderRefundPayload,
  cancelOrderRefund: UpdateOrderRefundPayload,
  addOrderReturnShipmentTracking: UpdateOrderRefundPayload,
  removeOrderReturnShipmentTracking: UpdateOrderRefundPayload,
  syncOrderReturnShipmentTracking: UpdateOrderRefundPayload,
  updateMerchantRefund: UpdateOrderRefundPayload,
  updateProductReturnDestination: UpdateFulfillmentTicketPayload,
  confirmReturnLabelSent: UpdateFulfillmentTicketPayload,
  checkedOnReturnLabelFromMerchant: UpdateFulfillmentTicketPayload,
  assignTicket: UpdateTicketPayload,
  unassignTicket: UpdateTicketPayload,
  setTicketBlocked: UpdateTicketPayload,
  setTicketDueDate: UpdateTicketPayload,
  setTicketAsWontComplete: UpdateTicketPayload,
  setTicketPriority: UpdateTicketPayload,
  updateTicketDescription: UpdateTicketPayload,
  addCommentToTicket: UpdateTicketPayload,
  resolveTicket: UpdateTicketPayload,
  closeTicket: UpdateTicketPayload,
  pickupTicket: UpdateTicketPayload,
  shareReferralCodeViaEmail: ReferralCodeSharePayload,
  createExperiment: CreateExperimentPayload,
  updateExperiment: UpdateExperimentPayload,
  archiveExperiment: ArchiveExperimentPayload,
  unarchiveExperiment: UnarchiveExperimentPayload,
  tagSkiTripLead: TagSkiTripLeadPayload,
  tagSkiTripExpert: TagSkiTripExpertPayload,
};


export type MutationAddAddressArgs = {
  input: AddAddressInput
};


export type MutationUpdateAddressPreferencesArgs = {
  input: UpdateAddressPreferencesInput
};


export type MutationDeleteAddressArgs = {
  input: DeleteAddressInput
};


export type MutationInitiateAuthenticationArgs = {
  input: InitiateAuthenticationInput
};


export type MutationInitiateResetPasswordArgs = {
  input: InitiateResetPasswordInput
};


export type MutationInitiateVerifyHandleArgs = {
  input: InitiateVerifyHandleInput
};


export type MutationAuthenticateArgs = {
  input: AuthenticationInput
};


export type MutationAuthenticateByExternalOAuthTokenArgs = {
  input: AuthenticateByExternalOAuthTokenInput
};


export type MutationCreatePasswordArgs = {
  input: CreatePasswordInput
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput
};


export type MutationVerifyResetPasswordChallengeArgs = {
  input: VerifyResetPasswordChallengeInput
};


export type MutationVerifyHandleChallengeArgs = {
  input: VerifyHandleChallengeInput
};


export type MutationRefreshAccessTokenArgs = {
  input: RefreshAccessTokenInput
};


export type MutationCreateCommTemplateArgs = {
  input: CreateTemplateInput
};


export type MutationUpdateCommTemplateArgs = {
  input: UpdateTemplateInput
};


export type MutationCopyCommTemplateArgs = {
  input: CopyTemplateInput
};


export type MutationPublishCommTemplateArgs = {
  input: PublishTemplateInput
};


export type MutationDeactivateCommTemplateArgs = {
  input: DeactivateTemplateInput
};


export type MutationNewCommTemplateVersionArgs = {
  input: NewTemplateVersionInput
};


export type MutationUpdateChannelTemplateArgs = {
  input: UpdateChannelTemplateInput
};


export type MutationRemoveChannelTemplateArgs = {
  input: RemoveChannelTemplateInput
};


export type MutationAddChannelTemplateArgs = {
  input: AddChannelTemplateInput
};


export type MutationSendTemplateTestMessageArgs = {
  input: SendTemplateTestMessageInput
};


export type MutationCreateCommTemplateTypeArgs = {
  input: CreateTemplateTypeInput
};


export type MutationCopyCommTemplateTypeArgs = {
  input: CopyTemplateTypeInput
};


export type MutationUpdateCommTemplateTypeArgs = {
  input: UpdateTemplateTypeInput
};


export type MutationCreateCommTemplateFragmentArgs = {
  input: CreateTemplateFragmentInput
};


export type MutationUpdateCommTemplateFragmentArgs = {
  input: UpdateTemplateFragmentInput
};


export type MutationCopyCommTemplateFragmentArgs = {
  input: CopyTemplateFragmentInput
};


export type MutationPublishCommTemplateFragmentArgs = {
  input: PublishTemplateFragmentInput
};


export type MutationDeactivateCommTemplateFragmentArgs = {
  input: DeactivateTemplateFragmentInput
};


export type MutationNewCommTemplateFragmentVersionArgs = {
  input: NewTemplateFragmentVersionInput
};


export type MutationGenerateTemplateFragmentSnippetArgs = {
  input: GenerateTemplateFragmentSnippetInput
};


export type MutationGenerateTemplateDirectiveSnippetArgs = {
  input: GenerateTemplateDirectiveSnippetInput
};


export type MutationCreateDealRequestArgs = {
  input: CreateDealRequestInput
};


export type MutationCreateUserArgs = {
  input: CreateUserInput
};


export type MutationCreateOperatorsArgs = {
  input: CreateOperatorsInput
};


export type MutationUpdateOperatorArgs = {
  input: UpdateOperatorInput
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput
};


export type MutationCreateMerchantArgs = {
  input: CreateMerchantInput
};


export type MutationCreateMerchantsArgs = {
  input: Array<CreateMerchantInput>
};


export type MutationUpdateMerchantArgs = {
  input: UpdateMerchantInput
};


export type MutationRegisterCustomerArgs = {
  input: RegisterCustomerInput
};


export type MutationCreatePendingAccessContactArgs = {
  input: CreatePendingAccessContactInput
};


export type MutationVerifyPendingAccessContactArgs = {
  input: VerifyPendingAccessContactInput
};


export type MutationAssumeOperatorIdentityArgs = {
  input: AssumeOperatorIdentityInput
};


export type MutationAssumeConsumerIdentityArgs = {
  input: AssumeConsumerIdentityInput
};


export type MutationUpdateUserSourceArgs = {
  input: UpdateUserSourceInput
};


export type MutationClaimConsumerReferralArgs = {
  input: ClaimConsumerReferralUserSourceInput
};


export type MutationCreateBusinessUserArgs = {
  input: CreateBusinessUserInput
};


export type MutationUpdateBusinessUserArgs = {
  input: UpdateBusinessUserInput
};


export type MutationUpdateBusinessUserVanityIdArgs = {
  input: UpdateBusinessUserVanityIdInput
};


export type MutationAssumeBusinessUserIdentityArgs = {
  input: AssumeBusinessUserIdentityInput
};


export type MutationSetAcceptingNewRequestsArgs = {
  input?: Maybe<SetAcceptingNewRequestsInput>
};


export type MutationSetExpertOnCallArgs = {
  input: SetExpertOnCallInput
};


export type MutationStartOnCallShiftArgs = {
  input: StartOnCallShiftInput
};


export type MutationStartExpertShiftArgs = {
  input: StartExpertShiftInput
};


export type MutationSetExpertOffShiftArgs = {
  input?: Maybe<SetExpertOffShiftInput>
};


export type MutationSetExpertAwayAutoReplyArgs = {
  input?: Maybe<SetExpertAwayAutoReplyInput>
};


export type MutationCreateBusinessAccountArgs = {
  input: CreateBusinessAccountInput
};


export type MutationCreateBusinessUserTeamArgs = {
  input: CreateBusinessUserTeamInput
};


export type MutationDeactivateExpertArgs = {
  input: DeactivateExpertInput
};


export type MutationActivateExpertArgs = {
  input: ActivateExpertInput
};


export type MutationSetExpertTeamLeadArgs = {
  input: SetExpertTeamLeadInput
};


export type MutationCreateFirebaseTokenArgs = {
  input: CreateFirebaseTokenInput
};


export type MutationRegisterFirebaseCloudMessagingTokenArgs = {
  input: RegisterFirebaseCloudMessagingTokenInput
};


export type MutationRegisterWebPushSubscriptionArgs = {
  input: RegisterWebPushSubscriptionInput
};


export type MutationUnregisterWebPushSubscriptionArgs = {
  input: UnregisterWebPushSubscriptionInput
};


export type MutationUnregisterFirebaseCloudMessagingTokenArgs = {
  input: UnregisterFirebaseCloudMessagingTokenInput
};


export type MutationUpdatePreferredMessagingChannelsArgs = {
  input: UpdatePreferredMessagingChannelsInput
};


export type MutationSetPreferredMessagingChannelArgs = {
  input: SetPreferredMessagingChannelInput
};


export type MutationUpdateNotificationChannelsArgs = {
  input: UpdateNotificationChannelsInput
};


export type MutationJoinVideoChatArgs = {
  input: JoinVideoChatInput
};


export type MutationDeclineVideoChatArgs = {
  input: DeclineVideoChatInput
};


export type MutationMonitorVideoChatArgs = {
  input: MonitorVideoChatInput
};


export type MutationBridgePhoneCallArgs = {
  input: BridgePhoneCallInput
};


export type MutationBridgeLeadPhoneCallArgs = {
  input: BridgeLeadPhoneCallInput
};


export type MutationBridgeExpertApplicationPhoneCallArgs = {
  input: BridgeExpertApplicantPhoneCallInput
};


export type MutationMarkConversationReadArgs = {
  input: MarkConversationReadInput
};


export type MutationGenerateCollectPhoneNumberTextInPathArgs = {
  input: GenerateCollectPhoneNumberTextInPathInput
};


export type MutationAddBlacklistChannelAddressArgs = {
  input: AddBlacklistChannelAddressInput
};


export type MutationUpgradeGuestConversationArgs = {
  input: UpgradeGuestConversationInput
};


export type MutationCreateDraftGuestConversationSequenceArgs = {
  input: CreateDraftGuestConversationSequenceInput
};


export type MutationAddGuestConversationSequenceMessageArgs = {
  input: AddGuestConversationSequenceMessageInput
};


export type MutationUpdateGuestConversationSequenceArgs = {
  input: UpdateGuestConversationSequenceInput
};


export type MutationActivateGuestConversationSequenceArgs = {
  input: ActivateGuestConversationSequenceInput
};


export type MutationDeactivateGuestConversationSequenceArgs = {
  input: DeactivateGuestConversationSequenceInput
};


export type MutationStartGuestConversationArgs = {
  input: StartGuestConversationInput
};


export type MutationCreatePathFlowArgs = {
  input: CreatePathFlowInput
};


export type MutationSubmitPathFlowPageArgs = {
  input: SubmitPathFlowPageInput
};


export type MutationReenterPathFlowPageArgs = {
  input: ReenterPathFlowPageInput
};


export type MutationReenterPathFlowPageBySlugsArgs = {
  input: ReenterPathFlowPageBySlugsInput
};


export type MutationSubmitListPathFlowQuestionArgs = {
  input: SubmitListPathFlowQuestionInput
};


export type MutationSubmitUserContactPathFlowQuestionArgs = {
  input: SubmitUserContactPathFlowQuestionInput
};


export type MutationSubmitNumericPathFlowQuestionArgs = {
  input: SubmitNumericPathFlowQuestionInput
};


export type MutationSubmitOAuthEmailPathFlowQuestionArgs = {
  input: SubmitOAuthEmailPathFlowQuestionInput
};


export type MutationSubmitInputTextPathFlowQuestionArgs = {
  input: SubmitInputTextPathFlowQuestionInput
};


export type MutationSubmitIdPathFlowQuestionArgs = {
  input: SubmitIdPathFlowQuestionInput
};


export type MutationSubmitDatePathFlowQuestionArgs = {
  input: SubmitDatePathFlowQuestionInput
};


export type MutationSubmitDateRangePathFlowQuestionArgs = {
  input: SubmitDateRangePathFlowQuestionInput
};


export type MutationPlaceOrderForOfferArgs = {
  input: PlaceOrderForOfferInput
};


export type MutationInitiatePaypalPaymentForOfferArgs = {
  input: InitiatePaypalPaymentForOfferInput
};


export type MutationAddOperatorNoteArgs = {
  input: AddOperatorNoteInput
};


export type MutationAddReturnShipmentTrackingArgs = {
  input: ShipmentTrackingInput
};


export type MutationAddShipmentTrackingArgs = {
  input: ShipmentTrackingInput
};


export type MutationAssignFulfillmentOperatorArgs = {
  input: AssignFulfillmentOperatorInput
};


export type MutationClaimOrderLineItemArgs = {
  input: ClaimOrderLineItemInput
};


export type MutationOrderLineItemUnavailableArgs = {
  input: OrderLineItemUnavailableInput
};


export type MutationOrderLineItemReceivedArgs = {
  input: OrderLineItemReceivedInput
};


export type MutationRemoveShipmentTrackingArgs = {
  input: RemoveShipmentTrackingInput
};


export type MutationRemoveReturnShipmentTrackingArgs = {
  input: RemoveShipmentTrackingInput
};


export type MutationUpdateShippingMethodArgs = {
  input: UpdateShippingMethodInput
};


export type MutationUpdateOrderShippingAddressArgs = {
  input: UpdateOrderShippingAddressInput
};


export type MutationUpdatePreClaimedOrderShippingAddressArgs = {
  input: UpdateOrderShippingAddressInput
};


export type MutationCreatePaymentSourceArgs = {
  input: CreatePaymentSourceInput
};


export type MutationUpdatePaymentSourceArgs = {
  input: UpdatePaymentSourceInput
};


export type MutationDeletePaymentSourceArgs = {
  id: Scalars['PaymentSourceId']
};


export type MutationPayForOrderArgs = {
  input: PayForOrderInput
};


export type MutationAddTipToOrderArgs = {
  input: AddTipToOrderInput
};


export type MutationRemoveTipFromOrderArgs = {
  input: RemoveTipFromOrderInput
};


export type MutationSubmitOrderArgs = {
  input: SubmitOrderInput
};


export type MutationCancelSubmittedOrderArgs = {
  input: CancelSubmittedOrderInput
};


export type MutationInitiatePaypalPaymentForOrderArgs = {
  input: InitiatePaypalPaymentForOrderInput
};


export type MutationInitiateAfterpayPaymentForOrderArgs = {
  input: InitiateAfterpayPaymentForOrderInput
};


export type MutationInitiateAffirmPaymentForOrderArgs = {
  input: InitiateAffirmPaymentForOrderInput
};


export type MutationMarkPaymentPreApprovalFailedForOrderArgs = {
  input: MarkPaymentPreApprovalFailedForOrderInput
};


export type MutationMarkPaymentFailedForOrderArgs = {
  input: MarkPaymentFailedForOrderInput
};


export type MutationCancelPaymentRequestForOrderArgs = {
  input: CancelPaymentRequestForOrderInput
};


export type MutationSyncOrderArgs = {
  input: SyncOrderInput
};


export type MutationAddItemsToOrderArgs = {
  input: AddItemsToOrderInput
};


export type MutationRemoveItemsFromOrderArgs = {
  input: RemoveItemsFromOrderInput
};


export type MutationUpdateQuantityForOrderArgs = {
  input: UpdateQuantityForOrderInput
};


export type MutationAddPromotionToOrderArgs = {
  input?: Maybe<AddPromotionToOrderInput>
};


export type MutationDismissOrderMessagesArgs = {
  input: DismissOrderMessagesInput
};


export type MutationGetOrCreateUserCartForExpertArgs = {
  input: GetOrCreateUserCartForExpertInput
};


export type MutationCreatePromotionArgs = {
  input: CreateDraftPromotionInput
};


export type MutationActivatePromotionArgs = {
  input?: Maybe<ActivatePromotionInput>
};


export type MutationDisablePromotionArgs = {
  input: DisablePromotionInput
};


export type MutationCopyPromotionArgs = {
  input: CopyPromotionInput
};


export type MutationUpdatePromotionArgs = {
  input: UpdatePromotionInput
};


export type MutationUpsertRuleIntoPromotionArgs = {
  input: UpsertRuleIntoPromotionInput
};


export type MutationRemoveRuleFromPromotionArgs = {
  input: RemoveRuleFromPromotionInput
};


export type MutationReorderRulesInPromotionArgs = {
  input: ReorderRulesInPromotionInput
};


export type MutationUpsertActionIntoPromotionArgs = {
  input: UpsertActionIntoPromotionInput
};


export type MutationRemoveActionFromPromotionArgs = {
  input: RemoveActionFromPromotionInput
};


export type MutationReorderActionsInPromotionArgs = {
  input: ReorderActionsInPromotionInput
};


export type MutationInitiateWireTransferPaymentForOrderArgs = {
  input: InitiateWireTransferPaymentForOrderInput
};


export type MutationUpdateOrderStateArgs = {
  input: UpdateOrderStateInput
};


export type MutationUpdateOrderExpertContributionsArgs = {
  input: UpdateOrderExpertContributionsInput
};


export type MutationUpdateOrderLineItemStateToCustomizingArgs = {
  input: ItemCustomizingInput
};


export type MutationMarkCustomizationIssuesForOrderLineItemArgs = {
  input: ItemHasCustomizationIssuesInput
};


export type MutationUnclaimOrderLineItemArgs = {
  input: OrderLineItemUnclaimInput
};


export type MutationInitiateDealInventoryFulfillmentArgs = {
  input: InitiateDealInventoryFulfillmentInput
};


export type MutationRequestItemReturnArgs = {
  input: OrderLineItemReturnRequestInput
};


export type MutationSyncItemShippingStatusArgs = {
  input: SyncItemShippingStatusInput
};


export type MutationVerifyPaymentTransactionArgs = {
  input: VerifyPaymentTransactionInput
};


export type MutationCreateTagArgs = {
  input: CreateTagInput
};


export type MutationRemoveTagArgs = {
  input: RemoveTagInput
};


export type MutationUploadMerchantsArgs = {
  input: UploadMerchantsInput
};


export type MutationUploadSellablesArgs = {
  input: UploadSellablesInput
};


export type MutationUploadSellablePriceArgs = {
  input: UploadSellablePriceInput
};


export type MutationUploadFeaturedSellableContentArgs = {
  input: UploadFeaturedSellableContentInput
};


export type MutationUploadBrandsArgs = {
  input: UploadBrandsInput
};


export type MutationUploadSellableUpdatesArgs = {
  input: UploadSellableUpdatesInput
};


export type MutationUploadSellableDeactivationsArgs = {
  input: UploadSellableDeactivationsInput
};


export type MutationUploadSellableInventoryArgs = {
  input: UploadSellableInventoryInput
};


export type MutationCreateMerchantOfferArgs = {
  input: CreateOfferInput
};


export type MutationCreateFreeFormOfferArgs = {
  input: CreateOfferInput
};


export type MutationCreateOfferFromSellableArgs = {
  input: CreateOfferFromSellableInput
};


export type MutationCreateOfferForSelfCheckoutArgs = {
  input: CreateOfferForSelfCheckoutInput
};


export type MutationTotalCostForOfferArgs = {
  input: TotalCostForOfferInput
};


export type MutationCreateOrderFromOfferArgs = {
  input: CreateOrderFromOfferInput
};


export type MutationAddOfferToCartArgs = {
  input: AddOfferToCartInput
};


export type MutationUploadMediaArgs = {
  input: UploadMediaInput
};


export type MutationCreateMediaArgs = {
  input: CreateMediaInput
};


export type MutationPersistMediaArgs = {
  input: PersistMediaInput
};


export type MutationCreateDraftExpertProfileArgs = {
  input: CreateDraftExpertProfileInput
};


export type MutationSubmitExpertProfileArgs = {
  id: Scalars['ExpertProfileId']
};


export type MutationApproveExpertProfileArgs = {
  id: Scalars['ExpertProfileId']
};


export type MutationRequestChangesOnExpertProfileArgs = {
  input: ExpertProfileRequestChangesInput
};


export type MutationUpdateExpertProfileArgs = {
  input: UpdateExpertProfileInput
};


export type MutationStartExpertRatingArgs = {
  expertId: Scalars['BusinessUserId']
};


export type MutationStartExpertRatingPathArgs = {
  input: StartExpertRatingInput
};


export type MutationUpdateConsumerExpertReviewArgs = {
  input: UpdateConsumerExpertReviewInput
};


export type MutationDeleteConsumerExpertReviewArgs = {
  id: Scalars['ConsumerExpertReviewId']
};


export type MutationAddExpertProfileHighlightArgs = {
  input: AddProfileHighlightInput
};


export type MutationRemoveExpertProfileHighlightArgs = {
  input: RemoveProfileHighlightInput
};


export type MutationCreateBlankExpertApplicationArgs = {
  input: CreateBlankExpertApplicationInput
};


export type MutationApproveExpertApplicationArgs = {
  input: ApproveExpertApplicationInput
};


export type MutationRejectExpertApplicationArgs = {
  input: RejectExpertApplicationInput
};


export type MutationSetExpertApplicationArchivedArgs = {
  input: SetExpertApplicationArchivedInput
};


export type MutationSetExpertApplicationSnoozeArgs = {
  input: SetExpertApplicationSnoozeInput
};


export type MutationCancelExpertApplicationSnoozeArgs = {
  input: CancelExpertApplicationSnoozeInput
};


export type MutationRequestConsumerReviewByExpertArgs = {
  input: RequestConsumerExpertReviewInput
};


export type MutationRequestReferralByExpertArgs = {
  input: RequestReferralByExpertInput
};


export type MutationSendExpertReferralArgs = {
  input: SendExpertReferralInput
};


export type MutationCreateExpertFromApplicationArgs = {
  input: CreateExpertFromApplicationInput
};


export type MutationAddExpertApplicationReviewArgs = {
  input: AddExpertApplicationReviewInput
};


export type MutationUpdateExpertApplicationTaskStatusArgs = {
  input: UpdateExpertApplicationTaskStatusInput
};


export type MutationSetExpertApplicationTaskCompletedArgs = {
  input: SetExpertApplicationTaskCompletedInput
};


export type MutationRerunExpertApplicationTaskArgs = {
  input: RerunExpertApplicationTaskInput
};


export type MutationStartExpertApplicationConversationArgs = {
  applicationId: Scalars['ExpertApplicationId']
};


export type MutationAddExpertApplicationNoteArgs = {
  input: AddExpertApplicationNoteInput
};


export type MutationSaveSavedSellableArgs = {
  input: SaveSavedSellableInput
};


export type MutationUnsaveSavedSellableArgs = {
  input: UnsaveSavedSellableInput
};


export type MutationCreateSellableArgs = {
  input: CreateSellableInput
};


export type MutationUpdateSellableArgs = {
  input: UpdateSellableInput
};


export type MutationDeactivateSellableArgs = {
  input: DeactivateSellableInput
};


export type MutationCreateSellableTermsArgs = {
  input: CreateSellableTermsInput
};


export type MutationRequestSellableArgs = {
  input: RequestSellableInput
};


export type MutationUpdateAdHocSellablePriceArgs = {
  input: UpdateAdHocSellablePriceInput
};


export type MutationDeactivateSellablePriceSourceArgs = {
  input: DeactivateSellablePriceSourceInput
};


export type MutationRefreshSellablePriceSourceArgs = {
  input: RefreshSellablePriceSourceInput
};


export type MutationSaveConsumerSellableReactionArgs = {
  input: SaveConsumerSellableReactionInput
};


export type MutationCreateSellableResearchLinkArgs = {
  input: CreateSellableResearchLinkInput
};


export type MutationDeleteSellableResearchLinkArgs = {
  input: DeleteSellableResearchLinkInput
};


export type MutationRequestSellablePriceMatchArgs = {
  input: RequestSellablePriceMatchInput
};


export type MutationStartExpertConsumerConversationArgs = {
  input: StartExpertConsumerConversationInput
};


export type MutationSetLeadSnoozeArgs = {
  input: SetLeadSnoozeInput
};


export type MutationCancelLeadSnoozeArgs = {
  input: CancelLeadSnoozeInput
};


export type MutationSetLeadStarArgs = {
  input: SetLeadStarInput
};


export type MutationSetLeadArchivedArgs = {
  input: SetLeadArchivedInput
};


export type MutationSetLeadDoNotCallArgs = {
  input: SetLeadDoNotCallInput
};


export type MutationDismissLeadSuggestedActionArgs = {
  input: DismissLeadSuggestedActionInput
};


export type MutationDelegateLeadArgs = {
  input: DelegateLeadInput
};


export type MutationReassignLeadArgs = {
  input: ReassignLeadInput
};


export type MutationSetConsumerInitialLeadActionArgs = {
  input: SetConsumerInitialLeadActionInput
};


export type MutationCreateQuickReplyWithLeadArgs = {
  input: CreateQuickReplyWithLeadInput
};


export type MutationCreateQuickReplyWithoutLeadArgs = {
  input: CreateQuickReplyWithoutLeadInput
};


export type MutationCreateQuickReplyArgs = {
  input: CreateQuickReplyInput
};


export type MutationUpdateQuickReplyArgs = {
  input: UpdateQuickReplyInput
};


export type MutationDeleteQuickReplyArgs = {
  id: Scalars['QuickReplyId']
};


export type MutationCreateLeadNoteArgs = {
  input: CreateLeadNote
};


export type MutationUpdateLeadNoteArgs = {
  input: UpdateLeadNoteInput
};


export type MutationDeleteLeadNoteArgs = {
  id: Scalars['LeadNoteId']
};


export type MutationAddUserInfoForLeadArgs = {
  input: AddUserInfoForLeadInput
};


export type MutationAcceptLeadEscalationArgs = {
  input: AcceptEscalationInput
};


export type MutationStartLeadEscalationArgs = {
  input: StartLeadEscalationInput
};


export type MutationReportPredictedLifeTimeValueToPlatformArgs = {
  input: ReportPredictedLifeTimeValueInput
};


export type MutationCreateLeadSurgeArgs = {
  input: CreateLeadSurgeInput
};


export type MutationCreateLeadCampaignArgs = {
  input: CreateLeadCampaignInput
};


export type MutationCopyLeadCampaignArgs = {
  input: CopyLeadCampaignInput
};


export type MutationUpdateLeadCampaignArgs = {
  input: UpdateLeadCampaignInput
};


export type MutationDeactivateLeadCampaignArgs = {
  id: Scalars['LeadCampaignId']
};


export type MutationActivateLeadCampaignArgs = {
  id: Scalars['LeadCampaignId']
};


export type MutationCreateLeadCampaignTriggerArgs = {
  input: CreateLeadCampaignTriggerInput
};


export type MutationScheduleLeadCampaignArgs = {
  input: ScheduleLeadCampaignInput
};


export type MutationCancelScheduledLeadCampaignArgs = {
  input: CancelScheduledLeadCampaignInput
};


export type MutationCreateReportArgs = {
  input: CreateReportInput
};


export type MutationUpdateReportArgs = {
  input: UpdateReportInput
};


export type MutationAddReportScheduleArgs = {
  input: AddScheduleReportInput
};


export type MutationRemoveReportScheduleArgs = {
  input: RemoveScheduleReportInput
};


export type MutationAddExpertCuratedItemToCartArgs = {
  input: AddExpertCuratedItemToCartInput
};


export type MutationCreateExpertCuratedItemArgs = {
  input: CreateExpertCuratedItemInput
};


export type MutationCopyFromExpertCuratedItemsArgs = {
  input: CopyFromExpertCuratedItemsInput
};


export type MutationUpdateExpertCuratedItemArgs = {
  input: UpdateExpertCuratedItemInput
};


export type MutationRemoveExpertCuratedItemArgs = {
  input: RemoveExpertCuratedItemInput
};


export type MutationMakeExpertCuratedItemDraftsActiveArgs = {
  input: MakeExpertCuratedItemDraftsActiveInput
};


export type MutationCreateExpertCuratedOrderArgs = {
  input: CreateExpertCuratedOrderInput
};


export type MutationUpdateExpertCuratedOrderVariationOptionsArgs = {
  input: UpdateExpertCuratedOrderVariationOptionsInput
};


export type MutationUpsertItemsInExpertCuratedOrderArgs = {
  input: UpsertItemsInExpertCuratedOrderInput
};


export type MutationRemoveItemsFromExpertCuratedOrderArgs = {
  input: RemoveItemsFromExpertCuratedOrderInput
};


export type MutationActivateExpertCuratedOrderAsBookableArgs = {
  input: ActivateExpertCuratedOrderAsBookableInput
};


export type MutationNotifyCustomerExpertCuratedOrderArgs = {
  input: NotifyCustomerExpertCuratedOrderInput
};


export type MutationCustomerRequestExpertCuratedOrderArgs = {
  input: CustomerRequestExpertCuratedOrderInput
};


export type MutationCloseExpertCuratedOrderArgs = {
  input: CloseExpertCuratedOrderInput
};


export type MutationUpdateExpertCuratedOrderTermsArgs = {
  input: UpdateExpertCuratedOrderTermsInput
};


export type MutationSelectExpertCuratedOrderVariationOptionArgs = {
  input: SelectExpertCuratedOrderVariationOptionInput
};


export type MutationSelectExpertCuratedOrderItemsArgs = {
  input: SelectExpertCuratedOrderItemsInput
};


export type MutationUpdateServiceLocationExpertCuratedOrderArgs = {
  input: UpdateServiceLocationExpertCuratedOrderInput
};


export type MutationActivateExpertCuratedOrdersForLeadArgs = {
  input: ActivateExpertCuratedOrdersForLeadInput
};


export type MutationFindOrCreateReplacementExpertCuratedOrderArgs = {
  input: FindOrCreateReplacementExpertCuratedOrderInput
};


export type MutationCopyItemsFromExpertCuratedOrderArgs = {
  input: CopyItemsFromExpertCuratedOrderInput
};


export type MutationUpsertExpertCuratedLeadItineraryArgs = {
  input: UpsertExpertCuratedLeadItineraryInput
};


export type MutationDeleteExpertCuratedLeadItineraryArgs = {
  input: DeleteExpertCuratedLeadItineraryInput
};


export type MutationCreateSavedExpertCuratedItemsArgs = {
  input: CreateSavedExpertCuratedItemsInput
};


export type MutationUpdateSavedExpertCuratedItemsArgs = {
  input: UpdateSavedExpertCuratedItemsInput
};


export type MutationDeleteSavedExpertCuratedItemsArgs = {
  id: Scalars['SavedExpertCuratedItemsId']
};


export type MutationCreateExpertConsultationFeeOrderArgs = {
  input: CreateExpertConsultationFeeOrderInput
};


export type MutationExtendExpertCuratedItemExpirationArgs = {
  input: ExtendExpertCuratedItemExpirationInput
};


export type MutationSaveReviewForSuggestedAlternativeSellableArgs = {
  input: SaveReviewForSuggestedAlternativeSellableInput
};


export type MutationCreateRecommendedListDefinitionArgs = {
  input: CreateRecommendedListDefinitionInput
};


export type MutationUpdateRecommendedListDefinitionArgs = {
  input: UpdateRecommendedListDefinitionInput
};


export type MutationDeleteRecommendedListDefinitionArgs = {
  id: Scalars['RecommendedListDefinitionId']
};


export type MutationCreateTriggerArgs = {
  input: CreateTriggerInput
};


export type MutationUpdateTriggerArgs = {
  input: UpdateTriggerInput
};


export type MutationCreateTriggerNodeArgs = {
  input: CreateTriggerNodeInput
};


export type MutationRemoveTriggerNodeArgs = {
  input: RemoveTriggerNodeInput
};


export type MutationUpdateTriggerFilterArgs = {
  input: UpdateTriggerFilterInput
};


export type MutationUpdateTriggerDelayArgs = {
  input: UpdateTriggerDelayInput
};


export type MutationUpdateTriggerActionArgs = {
  input: UpdateTriggerActionInput
};


export type MutationUpdateTriggerBranchArgs = {
  input: UpdateTriggerBranchInput
};


export type MutationSwapTriggerBranchEdgesArgs = {
  input: SwapTriggerBranchEdgesInput
};


export type MutationUpdateTriggerWaitArgs = {
  input: UpdateTriggerWaitInput
};


export type MutationSwapTriggerWaitEdgesArgs = {
  input: SwapTriggerWaitEdgesInput
};


export type MutationSplitTriggerWaitEdgesArgs = {
  input: SplitTriggerWaitEdgesInput
};


export type MutationMergeTriggerWaitEdgesArgs = {
  input: MergeTriggerWaitEdgesInput
};


export type MutationUpdateTriggerEdgeArgs = {
  input: UpdateTriggerEdgeInput
};


export type MutationRemoveTriggerEdgeArgs = {
  input: RemoveTriggerEdgeInput
};


export type MutationPublishTriggerArgs = {
  input: PublishTriggerInput
};


export type MutationDeactivateTriggerArgs = {
  input: DeactivateTriggerInput
};


export type MutationArchiveTriggerArgs = {
  input: ArchiveTriggerInput
};


export type MutationNewTriggerVersionArgs = {
  input: NewTriggerVersionInput
};


export type MutationImportEntitiesArgs = {
  input: ImportEntitiesInput
};


export type MutationTestTriggerExecutionArgs = {
  input: TestTriggerExecutionInput
};


export type MutationShortenUrlArgs = {
  input?: Maybe<ShortenUrlInput>
};


export type MutationCreateAdhocSellableFromEBayItemArgs = {
  input: CreateAdhocSellableFromEBayItemInput
};


export type MutationIdentifyEBayItemAsSellableArgs = {
  input: IdentifyEBayItemAsSellableInput
};


export type MutationUpdateConfigArgs = {
  input: UpdateConfigInput
};


export type MutationResetConfigArgs = {
  input: ResetConfigInput
};


export type MutationSyncExternalAdCampaignsArgs = {
  input: SyncExternalAdCampaignsInput
};


export type MutationUpdateExternalAdCampaignArgs = {
  input: UpdateExternalAdCampaignInput
};


export type MutationUpdateExternalAdGroupArgs = {
  input: UpdateExternalAdGroupInput
};


export type MutationApplyExternalAdBudgetArgs = {
  input: ApplyExternalAdBudgetInput
};


export type MutationStartSystemCuratedItemSurveyArgs = {
  id: Scalars['SystemCuratedItemSurveyId']
};


export type MutationTerminateSystemCuratedItemSurveyArgs = {
  input: TerminateSystemCuratedItemSurveyInput
};


export type MutationCreateFlightPlanArgs = {
  input: CreateFlightPlanInput
};


export type MutationActivateFlightPlanArgs = {
  input: ActivateFlightPlanInput
};


export type MutationCopyFlightPlanAsDraftArgs = {
  input: CopyFlightPlanAsDraftInput
};


export type MutationUpsertLegsIntoFlightPlanArgs = {
  input: UpsertLegsIntoFlightPlanInput
};


export type MutationRemoveLegsFromFlightPlanArgs = {
  input: RemoveLegsFromFlightPlanInput
};


export type MutationAssignSupportTaskArgs = {
  input: AssignSupportTaskInput
};


export type MutationCompleteSupportTaskNoActionNeededArgs = {
  input: CompleteSupportTaskNoActionNeededInput
};


export type MutationCompleteSupportTaskSnoozeArgs = {
  input: CompleteSupportTaskSnoozeInput
};


export type MutationCompleteLeadSupportTaskAssignLeadActionsArgs = {
  input: CompleteLeadSupportTaskAssignLeadActionsInput
};


export type MutationCompleteLeadSupportTaskDelegateLeadArgs = {
  input: CompleteLeadSupportTaskDelegateLeadInput
};


export type MutationCompleteLeadSupportTaskReassignLeadArgs = {
  input: CompleteLeadSupportTaskReassignLeadInput
};


export type MutationCompleteLeadSupportTaskEscalateToTeamForDelegationArgs = {
  input: CompleteLeadSupportTaskEscalateToTeamForDelegationInput
};


export type MutationCompleteLeadSupportTaskEscalateForReassignmentArgs = {
  input: CompleteLeadSupportTaskEscalateForReassignmentInput
};


export type MutationCompleteLeadSupportTaskRequestOrderSupportArgs = {
  input: CompleteLeadSupportTaskRequestOrderSupportInput
};


export type MutationAddSupportToLeadConversationArgs = {
  input: AddSupportToLeadConversationInput
};


export type MutationRemoveSupportFromLeadConversationArgs = {
  input: RemoveSupportFromLeadConversationInput
};


export type MutationCreateOrderEscalationArgs = {
  input: CreateOrderEscalationInput
};


export type MutationAssignOrderEscalationArgs = {
  input: AssignEscalationInput
};


export type MutationStartOrderEscalationArgs = {
  input: StartEscalationInput
};


export type MutationCompleteOrderEscalationArgs = {
  input: CompleteEscalationInput
};


export type MutationAddEscalationNoteArgs = {
  input: AddEscalationOperatorNoteInput
};


export type MutationSetEscalationPriorityArgs = {
  input: SetEscalationPriorityInput
};


export type MutationStartSupportConversationArgs = {
  input: StartSupportConversationInput
};


export type MutationAddOrderEscalationLabelArgs = {
  input: AddEscalationLabelInput
};


export type MutationRemoveOrderEscalationLabelArgs = {
  input: RemoveEscalationLabelInput
};


export type MutationDismissSuggestedSupportActionArgs = {
  input: DismissSuggestedSupportActionInput
};


export type MutationUpdateSellableInventoryItemArgs = {
  input: SellableInventoryItemUpdateInput
};


export type MutationSyncShopifyInventoryItemArgs = {
  input: Scalars['SellableInventoryItemId']
};


export type MutationCreatePayStructureArgs = {
  input: CreatePayStructureInput
};


export type MutationCreatePayStructureRevisionArgs = {
  input: CreatePayStructureRevisionInput
};


export type MutationUpdatePayStructureRevisionArgs = {
  input: UpdatePayStructureRevisionInput
};


export type MutationActivatePayStructureRevisionArgs = {
  input: ActivatePayStructureRevisionInput
};


export type MutationApprovePayoutArgs = {
  id: Scalars['PayoutId']
};


export type MutationBulkApprovePayoutsArgs = {
  ids: Array<Scalars['PayoutId']>
};


export type MutationResendPayoutArgs = {
  id: Scalars['PayoutId']
};


export type MutationRecomputePayoutArgs = {
  id: Scalars['PayoutId']
};


export type MutationAddManualAdjustmentPayLineItemArgs = {
  input: AddManualAdjustmentPayLineItemInput
};


export type MutationCreateRawSellableSourceArgs = {
  input: CreateRawSellableSourceInput
};


export type MutationUpdateRawSellableSourceArgs = {
  input: UpdateRawSellableSourceInput
};


export type MutationCreateRawSellableStandardizationRuleArgs = {
  input: CreateRawSellableStandardizationRuleInput
};


export type MutationUpdateRawSellableStandardizationRuleArgs = {
  input: UpdateRawSellableStandardizationRuleInput
};


export type MutationMergeStandardizedSellableGroupArgs = {
  input: MergeStandardizedSellableGroupInput
};


export type MutationStartStandardizedSellableGroupIngestionArgs = {
  input: StartStandardizedSellableGroupIngestionInput
};


export type MutationStartRawSellableSourceIngestionArgs = {
  input: StartRawSellableSourceIngestionInput
};


export type MutationAcceptStandardizedSellableGroupCandidateArgs = {
  input: AcceptStandardizedSellableGroupCandidateInput
};


export type MutationRejectStandardizedSellableGroupCandidateArgs = {
  input: RejectStandardizedSellableGroupCandidateInput
};


export type MutationStartRawSellableStandardizationArgs = {
  input: StartRawSellableStandardizationInput
};


export type MutationStartStandardizationSellableMatchingArgs = {
  input: StartStandardizationSellableMatchingInput
};


export type MutationImportRawSellableSourceArgs = {
  input: ImportRawSellableSourceInput
};


export type MutationImportRawSellableStandardizationRuleArgs = {
  input: ImportRawSellableStandardizationRuleInput
};


export type MutationImportRawSellableStandardizationRulesArgs = {
  input: ImportRawSellableStandardizationRulesInput
};


export type MutationCreateSchedulingDemandForecastArgs = {
  input: CreateSchedulingDemandForecastInput
};


export type MutationUpdateSchedulingDemandForecastArgs = {
  input: UpdateSchedulingDemandForecastInput
};


export type MutationRemoveSchedulingDemandForecastArgs = {
  id: Scalars['SchedulingDemandForecastId']
};


export type MutationCreateSchedulingUserAvailabilityArgs = {
  input: CreateSchedulingUserAvailabilityInput
};


export type MutationRemoveSchedulingUserAvailabilityArgs = {
  id: Scalars['SchedulingUserAvailabilityId']
};


export type MutationClaimShiftArgs = {
  input: UpdateShiftInput
};


export type MutationCancelShiftArgs = {
  input: UpdateShiftInput
};


export type MutationCreateShiftArgs = {
  input: CreateShiftInput
};


export type MutationUpdateSchedulingUserProfileArgs = {
  input: UpdateSchedulingUserProfileInput
};


export type MutationCopySchedulingDemandForecastToNextPeriodArgs = {
  input: CopySchedulingDemandForecastInput
};


export type MutationOverwriteShiftSlotArgs = {
  input: OverwriteShiftSlotInput
};


export type MutationRunShiftAssignmentsArgs = {
  input: RunShiftAssignmentsInput
};


export type MutationUpdateSchedulingUserRolesArgs = {
  input: UpdateSchedulingUserRolesInput
};


export type MutationUpdateSchedulingTypeArgs = {
  input: UpdateSchedulingTypeInput
};


export type MutationAcceptSurgeShiftArgs = {
  input: AcceptSurgeShiftInput
};


export type MutationFindOrCreateChannelArgs = {
  input?: Maybe<CreateFulfillmentChannelInput>
};


export type MutationUpdateFulfillmentInstructionsArgs = {
  input: UpdateFulfillmentInstructionsInput
};


export type MutationClaimLineItemByChannelArgs = {
  input?: Maybe<MultiChannelFulfillmentRequestInput>
};


export type MutationSkipFulfillmentChannelArgs = {
  input?: Maybe<SkipFulfillmentChannelInput>
};


export type MutationAssignOrderLineItemArgs = {
  input?: Maybe<AssignOrderLineItemInput>
};


export type MutationSetFulfillmentChannelBlacklistedArgs = {
  input?: Maybe<UpdateFulfillmentChannelBlacklistInput>
};


export type MutationUpdateFulfillmentChannelArgs = {
  input?: Maybe<UpdateFulfillmentChannelMetadataInput>
};


export type MutationVerifyOrderArgs = {
  input?: Maybe<VerifyOrderInput>
};


export type MutationRequestRefundArgs = {
  input?: Maybe<RequestOrderRefundInput>
};


export type MutationRejectRefundRequestArgs = {
  input?: Maybe<OrderRefundRejectedInput>
};


export type MutationSetRefundSucceededArgs = {
  input?: Maybe<OrderRefundSuccessInput>
};


export type MutationSetRefundFailedArgs = {
  input?: Maybe<OrderRefundFailedInput>
};


export type MutationAdjustRequestedRefundAmountArgs = {
  input?: Maybe<AdjustRequestedRefundAmountInput>
};


export type MutationCancelOrderRefundArgs = {
  input?: Maybe<CancelOrderRefundInput>
};


export type MutationAddOrderReturnShipmentTrackingArgs = {
  input?: Maybe<AddOrderReturnShipmentTrackingInput>
};


export type MutationRemoveOrderReturnShipmentTrackingArgs = {
  input?: Maybe<RemoveOrderReturnShipmentTrackingInput>
};


export type MutationSyncOrderReturnShipmentTrackingArgs = {
  input?: Maybe<SyncOrderReturnShipmentTrackingInput>
};


export type MutationUpdateMerchantRefundArgs = {
  input?: Maybe<UpdateMerchantRefundInput>
};


export type MutationUpdateProductReturnDestinationArgs = {
  input?: Maybe<UpdateProductReturnDestinationInput>
};


export type MutationConfirmReturnLabelSentArgs = {
  input?: Maybe<ConfirmReturnShippingLabelSentInput>
};


export type MutationCheckedOnReturnLabelFromMerchantArgs = {
  input?: Maybe<CheckedOnReturnLabelFromMerchantInput>
};


export type MutationAssignTicketArgs = {
  input: AssignTicketInput
};


export type MutationUnassignTicketArgs = {
  input: UnassignTicketInput
};


export type MutationSetTicketBlockedArgs = {
  input: SetTicketBlockedInput
};


export type MutationSetTicketDueDateArgs = {
  input: SetTicketDueDateInput
};


export type MutationSetTicketAsWontCompleteArgs = {
  input: SetWontCompleteInput
};


export type MutationSetTicketPriorityArgs = {
  input: SetPriorityInput
};


export type MutationUpdateTicketDescriptionArgs = {
  input: UpdateDescriptionInput
};


export type MutationAddCommentToTicketArgs = {
  input: AddCommentInput
};


export type MutationResolveTicketArgs = {
  input: ResolveTicketInput
};


export type MutationCloseTicketArgs = {
  input: CloseTicketInput
};


export type MutationPickupTicketArgs = {
  input: PickupTicketInput
};


export type MutationShareReferralCodeViaEmailArgs = {
  input: ReferralCodeShareInput
};


export type MutationCreateExperimentArgs = {
  input: CreateExperimentInput
};


export type MutationUpdateExperimentArgs = {
  input: UpdateExperimentInput
};


export type MutationArchiveExperimentArgs = {
  input: ArchiveExperimentInput
};


export type MutationUnarchiveExperimentArgs = {
  input: UnarchiveExperimentInput
};


export type MutationTagSkiTripLeadArgs = {
  input: TagSkiTripLeadInput
};


export type MutationTagSkiTripExpertArgs = {
  input: TagSkiTripExpertInput
};

export type Myself = {
   __typename: 'Myself',
  id: Scalars['AnyId'],
  user: User,
  operator?: Maybe<Operator>,
  businessUser?: Maybe<BusinessUser>,
  realUser: User,
  hasPassword: Scalars['Boolean'],
  /** 
 * Fetching this property will insert data into the database. It is technically a mutation, but due to
   * the restriction of Apollo SSR (no mutation executed) and our requirement to do 301 redirect, we need to make
   * this a query
 **/
  loginToken: Scalars['String'],
};

export type NewOrderEscalationNotification = {
   __typename: 'NewOrderEscalationNotification',
  newEscalationCount: Scalars['Long'],
};

export type NewTemplateFragmentVersionInput = {
  id: Scalars['CommTemplateFragmentId'],
  notes?: Maybe<Scalars['String']>,
};

export type NewTemplateVersionInput = {
  id: Scalars['CommTemplateId'],
};

export type NewTriggerVersionInput = {
  triggerId: Scalars['TriggerId'],
};

export type NewTriggerVersionPayload = {
   __typename: 'NewTriggerVersionPayload',
  trigger?: Maybe<Trigger>,
  error?: Maybe<Scalars['String']>,
};

export type NoReturnsAcceptedReturnPolicy = ReturnPolicy & {
   __typename: 'NoReturnsAcceptedReturnPolicy',
  type: ReturnPolicyType,
};

export type NotifyCustomerExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'],
};

export type NotifyCustomerExpertCuratedOrderPayload = {
   __typename: 'NotifyCustomerExpertCuratedOrderPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

/** ====== NumericPathFlowQuestion */
export type NumericPathFlowQuestion = PathFlowQuestion & {
   __typename: 'NumericPathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  valueType: NumericPathFlowQuestionValueType,
  displayType?: Maybe<NumericPathFlowQuestionDisplayType>,
  placeholder?: Maybe<Scalars['String']>,
  /** If reloading a question answered by the user, this is their previous input */
  numericUserInput: SubmitNumericPathFlowQuestionInputTypeCopy,
  unitLabel?: Maybe<Scalars['String']>,
  unit?: Maybe<NumericPathFlowQuestionUnitType>,
};


/** ====== NumericPathFlowQuestion */
export type NumericPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export enum NumericPathFlowQuestionDisplayType {
  HEIGHT_IN_INCHES = 'HEIGHT_IN_INCHES',
  STAR_RATING = 'STAR_RATING'
}

export enum NumericPathFlowQuestionUnitType {
  INCHES = 'INCHES',
  FEET = 'FEET',
  POUNDS = 'POUNDS',
  CENTIMETERS = 'CENTIMETERS',
  KILOGRAMS = 'KILOGRAMS',
  DOLLARS = 'DOLLARS'
}

export enum NumericPathFlowQuestionValueType {
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL'
}

/** Display facet for a min/max range */
export type NumericRangeDisplayFacet = DisplayFacet & {
   __typename: 'NumericRangeDisplayFacet',
  /** Name to display in the UI for this facet */
  displayName: Scalars['String'],
  /** Internal name that should be provided back to FacetSelection.name when selecting facet values */
  name: Scalars['String'],
  /** 
 * Alias for this facet if one exist. Aliases provide a semi user friendly name that can be used
   * in the urls for example.
 **/
  alias?: Maybe<Scalars['String']>,
  /** Type of numeric facet; currently used to change rendering styles */
  type: NumericRangeDisplayFacetType,
  /** unscaled lower bound */
  lower: Scalars['Long'],
  /** unscaled upper bound */
  upper: Scalars['Long'],
  /** 
 * if `upper` is capped (there are values beyond upper, but the result is truncated for ease of use, and querying for
   * the capped upper value will give all values beyond it)
 **/
  upperCapped: Scalars['Boolean'],
  /** The scale `lower` and `upper` is in; `(value x 10 ^ (-scale))` should be used to compute the actual value. */
  scale: Scalars['Int'],
  /** Computed decimal value of `lower` at `scale` */
  decimalLower: Scalars['BigDecimal'],
  /** Computed decimal value of `upper` at `scale` */
  decimalUpper: Scalars['BigDecimal'],
};

export enum NumericRangeDisplayFacetType {
  /** Render the number as is */
  DEFAULT = 'DEFAULT',
  /** Render the number (represented in cents) as USD currency */
  USD_CURRENCY = 'USD_CURRENCY'
}

/** ====== OAuthEmailPathFlowQuestion */
export type OAuthEmailPathFlowQuestion = PathFlowQuestion & {
   __typename: 'OAuthEmailPathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  firstName?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  lastName?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  email?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  googleIdToken?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  facebookUserAccessToken?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  skipFirstName?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  skipLastName?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  /** If reloading a question answered by the user, this is their previous input */
  oAuthEmailUserInput: SubmitOAuthEmailPathFlowQuestionInputTypeCopy,
};


/** ====== OAuthEmailPathFlowQuestion */
export type OAuthEmailPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export enum OAuthType {
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE'
}

export type OfferAddOn = {
   __typename: 'OfferAddOn',
  title: Scalars['String'],
  retailPrice: Money,
};

export type OfferAddOnInput = {
  title: Scalars['String'],
  retailPrice: Scalars['Float'],
};

export enum OfferState {
  INITIAL = 'INITIAL',
  GENERATED = 'GENERATED',
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
  WITHDRAWN = 'WITHDRAWN'
}

export type OfferTerms = ProductOfferTerms | ServiceOfferTerms;

export type OnboardingSpecialistUser = {
   __typename: 'OnboardingSpecialistUser',
  id: Scalars['AnyId'],
  displayName: Scalars['String'],
};

export type OpenGraphData = {
   __typename: 'OpenGraphData',
  url: Scalars['String'],
  properties: Array<OpenGraphProperty>,
};

export type OpenGraphProperty = {
   __typename: 'OpenGraphProperty',
  name: Scalars['String'],
  value: Scalars['String'],
};

export type Operator = {
   __typename: 'Operator',
  id: Scalars['OperatorId'],
  user: User,
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  phoneNumber?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  active: Scalars['Boolean'],
  isAdmin: Scalars['Boolean'],
  permissions: Array<OperatorPermission>,
  roles: Array<OperatorRole>,
  messagingUser: MessagingUser,
  onboardingSpecialistMessagingUserId: Scalars['AnyId'],
  supportMessagingUserId: Scalars['AnyId'],
};

export type OperatorAssignedActivity = OrderActivityDetail & {
   __typename: 'OperatorAssignedActivity',
  type: OrderActivityDetailType,
  assigned: Operator,
};


/** 
 * =============
 * Ops UI permission
 * =============
 **/
export enum OperatorPermission {
  UI_OPS_MANAGE_CATALOG = 'UI_OPS_MANAGE_CATALOG',
  UI_OPS_MANAGE_LEADS = 'UI_OPS_MANAGE_LEADS',
  UI_OPS_MANAGE_CONSUMERS = 'UI_OPS_MANAGE_CONSUMERS',
  UI_OPS_MANAGE_MERCHANTS = 'UI_OPS_MANAGE_MERCHANTS',
  UI_OPS_MANAGE_EXPERTS = 'UI_OPS_MANAGE_EXPERTS',
  UI_OPS_DEVTOOLS = 'UI_OPS_DEVTOOLS',
  UI_OPS_MANAGE_ALL_ORDERS = 'UI_OPS_MANAGE_ALL_ORDERS',
  UI_OPS_MANAGE_PAYROLL = 'UI_OPS_MANAGE_PAYROLL',
  UI_OPS_MANAGE_ASSIGNED_ORDERS = 'UI_OPS_MANAGE_ASSIGNED_ORDERS',
  UI_OPS_RESEARCH_ORDER_FULFILLMENT = 'UI_OPS_RESEARCH_ORDER_FULFILLMENT',
  UI_OPS_FULFILL_ORDERS = 'UI_OPS_FULFILL_ORDERS',
  UI_OPS_TEST_TRIGGER = 'UI_OPS_TEST_TRIGGER',
  UI_OPS_ASSISTANT = 'UI_OPS_ASSISTANT',
  UI_OPS_MANAGE_ORDERS_ASSIGNED_TO_SELF = 'UI_OPS_MANAGE_ORDERS_ASSIGNED_TO_SELF',
  UI_OPS_ORDER_SUPPORT_EXPERIMENT = 'UI_OPS_ORDER_SUPPORT_EXPERIMENT'
}

export type OperatorQuery = {
  userIds?: Maybe<Array<Scalars['UserId']>>,
  includeInactive?: Maybe<Scalars['Boolean']>,
  name?: Maybe<Scalars['String']>,
};

export enum OperatorRole {
  CATALOG_MANAGER = 'CATALOG_MANAGER',
  ONBOARDING_SPECIALIST = 'ONBOARDING_SPECIALIST',
  LEAD_SUPPORT = 'LEAD_SUPPORT',
  ORDER_SUPPORT = 'ORDER_SUPPORT',
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  FULFILLMENT_AGENT = 'FULFILLMENT_AGENT',
  PAYROLL_MANAGER = 'PAYROLL_MANAGER',
  CONTENT_MARKETING_MANAGER = 'CONTENT_MARKETING_MANAGER',
  ORDER_SUPPORT_LEAD = 'ORDER_SUPPORT_LEAD',
  ORDER_PAYMENT_MANAGER = 'ORDER_PAYMENT_MANAGER',
  ORDER_SUPPORT_EXPERIMENT = 'ORDER_SUPPORT_EXPERIMENT'
}

export type Order = {
   __typename: 'Order',
  id: Scalars['OrderId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  paidAt?: Maybe<Scalars['Date']>,
  version: Scalars['Int'],
  /** used for trigger entity.  only need userId, not the user object */
  userId: Scalars['UserId'],
  user: User,
  state: OrderState,
  description: Scalars['String'],
  /** all non tax, shipment, and tip costs */
  price: MonetaryAmount,
  tax: MonetaryAmount,
  discount: MonetaryAmount,
  shippingCost: MonetaryAmount,
  /** amount of tip for the expert, if applicable */
  tip?: Maybe<MonetaryAmount>,
  /** total cost including all line items and adjustments; reflects what the customer should be charged */
  totalCost: MonetaryAmount,
  /** total cost, excluding tax */
  totalCostBeforeTax: MonetaryAmount,
  shippingAddress?: Maybe<Address>,
  shipmentTrackings?: Maybe<Array<ShipmentTracking>>,
  /** De-normalized shipping method for the order, derived from the line items */
  shippingMethod?: Maybe<ShippingMethod>,
  /** 
 * Rough estimate of when the entire order will be delivered to the customer; takes `shippingMethod` and `paidAt` into
   * account
 **/
  estimatedToArriveAt?: Maybe<Scalars['Date']>,
  merchantEmbursementId?: Maybe<Scalars['String']>,
  internalNotes?: Maybe<Scalars['String']>,
  attachments: Array<MediaFile>,
  transactions?: Maybe<Array<Transaction>>,
  transaction: Transaction,
  offer?: Maybe<BroadcastOffer>,
  title: Scalars['String'],
  /** 
 * topLevelOnly: if true, will only return line items where parent is null.  All line items under a parent
   * will be exluded.  default is false.
 **/
  lineItems: Array<OrderLineItem>,
  /** Messages associated with this order line item */
  messages: Array<OrderMessage>,
  fulfillmentState: OrderFulfillmentState,
  /** 
 * If the order can be charged. For `OrderChargeableUseCase.CHECKOUT`, it checks if it's safe to proceed to checkout.
   * For OrderChargeableUseCase.PURCHASE`, it checks if `payForOrder` is safe to invoke. Everything except for
   * `OrderChargeableStatus.CAN_CHARGE` is an error state.
 **/
  chargeableStatus: OrderChargeableStatus,
  /** 
 * If the order requires a shipping address
   * Note that this flag simply indicates if the order contains things which are shipped. If a shipping address is
   * required and one is provided, this will continue to be `true`.
 **/
  requiresShippingAddress: Scalars['Boolean'],
  /** 
 * If this order has a limited lifespan, and must be purchased before this time. If this time elapses, it will be
   * reflected in the `chargeableStatus` property as `EXPIRED`
 **/
  expiresAt?: Maybe<Scalars['Date']>,
  /** If this order was curated by an expert, the expert that curated it */
  curatedBy?: Maybe<BusinessUser>,
  /** If this order was curated by an expert, the lead this order was curated for */
  lead?: Maybe<Lead>,
  /** Amount of items being ordered; should be used to display badge counts for how many items the order/cart contains. */
  itemsCount: Scalars['Int'],
  /** 
 * Sum of all costs that map to these cost components
   * `TAX_ADJUSTMENTS` and `DISCOUNT_ADJUSTMENTS` only include tax and discounts for other included cost components. For
   * example, if `[SHIPMENT, TAX_ADJUSTMENTS]` are provided, the total cost will be the shipment, plus the tax **ONLY**
   * for the shipment - not the `CORE` (sellables, etc). The same holds true for `CostComponent#DISCOUNT_ADJUSTMENTS`.
   * This also means that if only `TAX_ADJUSTMENTS` is provided, this will always compute a zero monetary amount.
   * To only get tax or discounts, use the `tax` or `discount` properties, respectively.
 **/
  totalCostOnlyIncluding: MonetaryAmount,
  /** 
 * Sum of all costs except for line items that map to these cost components
   * This contract is similar to `totalCostOnlyIncluding`, but inverted to exclude cost instead of include.
 **/
  totalCostExcluding: MonetaryAmount,
  /** 
 * All the leads that have contributed to curation for this order.
   * This includes ExpertCuratedItem, ExpertCuratedOrder and BroadcastOffer
 **/
  associatedLeads: Array<Lead>,
  consumerReceiptUrl: Scalars['String'],
  consumerUrl: Scalars['String'],
  adminUrl: Scalars['String'],
  /** 
 * This id can be used for order receipt.  It is more friendly then the base64 encoded order.id.  This is only available
   *  for PostCart order, ie. order state is not  CREATED or CART
 **/
  consumerFriendlyId?: Maybe<Scalars['String']>,
  /** Primary image to display when previewing this order. */
  primaryImage?: Maybe<MediaFile>,
  /** Last time this order was viewed on the view cart page by the order owner (userId) */
  cartLastViewedAt?: Maybe<Scalars['Date']>,
  /** Emburse cardIds */
  emburseCardIds: Array<Scalars['String']>,
  lastCheckedOutAt?: Maybe<Scalars['Date']>,
  primaryLeadForFollowup?: Maybe<Lead>,
  categoryType: CategoryType,
  /** 
 * Provides a list of Payment processor to use for the payment of this Order.
   * This list is derived from restrictions some Processors have on the amount of transaction on the Orders.
   * Note, this list may change as the OrderLineItems are added or removed.
 **/
  supportedPaymentProviders: Array<PaymentProcessorType>,
  /** 
 * Provides a list of payment methods and its payment processor to use for the payment of this Order.
   * This list is derived from restrictions some Processors have on the amount of transaction on the Orders.
   * Note, this list may change as the OrderLineItems are added or removed.
 **/
  supportedPaymentMethods: Array<SupportedPaymentMethod>,
  /** 
 * This not so great name for timestamp captures the time instant when certain activity occurs.
   * This is equal to the createdAt date when the Order is first created and then update timestamp as the user attempts
   * to place the order. The timestamp is updated for both successful and failed payment attempts, including retries.
 **/
  sortTimestamp: Scalars['Date'],
  /** The paid amount of this order. */
  paidAmount: MonetaryAmount,
  /** When deposit is allowed, the remaining balance for deposit. If deposit is already paid, should be 0 */
  remainingDepositBalance?: Maybe<MonetaryAmount>,
  /** 
 * The remaining balance of this order. If an order is unpaid, it should be the same as totalCost.
   * If there is a partial payment, or deposit, this would be the remaining amount in order to be fully paid.
 **/
  remainingBalance: MonetaryAmount,
  /** If deposit is allowed */
  depositAllowed: Scalars['Boolean'],
  /** When deposit is allowed, this would be the minimum amount to be paid as a deposit */
  minimumDeposit?: Maybe<MonetaryAmount>,
  /** This is the due date for the full payment, regardless if deposit is allowed or not */
  fullPaymentDueAt?: Maybe<Scalars['Date']>,
  depositPaidAt?: Maybe<Scalars['Date']>,
  paidInFullAt?: Maybe<Scalars['Date']>,
  submittedAt?: Maybe<Scalars['Date']>,
  /** The payment source to be charged automatically if allow (i.e. the payment source is chargeable with sufficient funds) */
  chargingPaymentSource?: Maybe<PaymentSource>,
  /** 
 * All scheduled payments that are scheduled or canceled. Executed scheduled payments are excluded, and should be
   * available as transactions
 **/
  scheduledPayments: Array<ScheduledPayment>,
  scheduledPayment: ScheduledPayment,
  /** 
 * All promotions added to this order, including those that may not be actively applied
   * (e.g.: promotion rule may not apply to current items in cart, or one of the promotions gives a greater discount
   * over another).
 **/
  promotionEntries: Array<OrderPromotionEntry>,
  /** 
 * The currently applied promotion, if any. This is simply the `applied` entry in `promotionEntries`, which there can
   * be at most one (only one promotion active at a time)
 **/
  appliedPromotionEntry?: Maybe<OrderPromotionEntry>,
  /** The operator assigned to this order for fulfillment purposes */
  fulfillmentOperator?: Maybe<Operator>,
  /** Notes from operator about the order */
  operatorNotes: Array<OrderOperatorNote>,
  /** A flag indicating if this order is urgent and should be prioritized for fulfillment */
  isUrgent: Scalars['Boolean'],
  /** If this order contains a service, the address which this service will be performed */
  serviceLocation?: Maybe<PostalAddress>,
  /** This is only used for as trigger entity. */
  activity?: Maybe<OrderActivity>,
  /** This is only used for as trigger entity so that we can filter out order events on simple curated order */
  simpleCuratedOrder?: Maybe<SimpleCuratedOrder>,
  /** Labels indicating an order's derived state, such as unclaimed orders, and orders that need to be tracked */
  labels: Array<OrderLabel>,
  /** Distinct Departments the order's sellables belong to */
  departments: Array<Department>,
  /** The experts who helped the customer with this order */
  expertContributions: Array<OrderExpertContribution>,
  /** Escalations associated with the order */
  escalations: Array<OrderEscalation>,
  /** post cart activities associated with the order */
  postCartActivities: Array<PostCartOrderActivity>,
  /** tickets associated with the order */
  tickets: Array<Ticket>,
  /** Due date for product claiming, calculated as paidAt + fulfillment SLA (24 hours) */
  productClaimDueAt?: Maybe<Scalars['Date']>,
  paymentVerificationMethod?: Maybe<PaymentVerificationMethod>,
  refunds: Array<OrderRefund>,
  tipMethod: TipMethod,
  shippingAddressEditable: Scalars['Boolean'],
};


export type OrderTransactionArgs = {
  transactionId: Scalars['TransactionId']
};


export type OrderLineItemsArgs = {
  topLevelOnly?: Maybe<Scalars['Boolean']>
};


export type OrderChargeableStatusArgs = {
  useCase: OrderChargeableUseCase
};


export type OrderTotalCostOnlyIncludingArgs = {
  costComponents: Array<OrderCostComponent>
};


export type OrderTotalCostExcludingArgs = {
  costComponents: Array<OrderCostComponent>
};


export type OrderScheduledPaymentArgs = {
  id: Scalars['ScheduledPaymentId']
};


export type OrderEscalationsArgs = {
  sources?: Maybe<Array<OrderEscalationSource>>
};


export type OrderPostCartActivitiesArgs = {
  limit?: Maybe<Scalars['Int']>
};


export type OrderTicketsArgs = {
  ticketType?: Maybe<TicketType>
};


export type OrderRefundsArgs = {
  status?: Maybe<OrderRefundStatus>
};

export type OrderActivity = {
   __typename: 'OrderActivity',
  lastPreSubmitAction: OrderPreSubmitAction,
  lastPreSubmitActionOccurredAt: Scalars['Date'],
};

export type OrderActivityDetail = {
  type: OrderActivityDetailType,
};

export enum OrderActivityDetailType {
  OPERATOR_ASSIGNED = 'OPERATOR_ASSIGNED',
  MERCHANT_CLAIMED = 'MERCHANT_CLAIMED',
  TRACKING_UPDATED = 'TRACKING_UPDATED',
  TRACKING_REMOVED = 'TRACKING_REMOVED',
  ORDER_ESCALATED = 'ORDER_ESCALATED',
  ITEM_SHIPPED = 'ITEM_SHIPPED',
  ESCALATION_CLOSED = 'ESCALATION_CLOSED',
  DEAL_INVENTORY_REQUESTED = 'DEAL_INVENTORY_REQUESTED',
  DEAL_INVENTORY_REQUEST_FAILED = 'DEAL_INVENTORY_REQUEST_FAILED',
  DEAL_INVENTORY_REQUEST_CANCELED = 'DEAL_INVENTORY_REQUEST_CANCELED',
  DEAL_INVENTORY_CLAIMED = 'DEAL_INVENTORY_CLAIMED',
  DEAL_INVENTORY_FULFILLMENT_ORDER_CANCELED = 'DEAL_INVENTORY_FULFILLMENT_ORDER_CANCELED',
  ITEM_RETURN_REQUESTED = 'ITEM_RETURN_REQUESTED',
  RETURN_SHIPMENT_TRACKING_UPDATED = 'RETURN_SHIPMENT_TRACKING_UPDATED',
  ITEM_RETURN_SHIPPED = 'ITEM_RETURN_SHIPPED',
  ITEM_RETURN_RECEIVED = 'ITEM_RETURN_RECEIVED',
  RETURN_SHIPMENT_TRACKING_REMOVED = 'RETURN_SHIPMENT_TRACKING_REMOVED',
  FULFILLMENT_PROCESS_UPDATED = 'FULFILLMENT_PROCESS_UPDATED',
  ITEM_RECEIVED = 'ITEM_RECEIVED',
  ITEM_ORDER_VERIFICATION = 'ITEM_ORDER_VERIFICATION',
  REFUND_REQUESTED = 'REFUND_REQUESTED',
  REFUND_STATE_UPDATED = 'REFUND_STATE_UPDATED',
  REFUND_AMOUNT_ADJUSTED = 'REFUND_AMOUNT_ADJUSTED',
  ORDER_ADDRESS_CHANGED = 'ORDER_ADDRESS_CHANGED',
  EXPERT_CONTRIBUTION_CHANGED = 'EXPERT_CONTRIBUTION_CHANGED',
  RETURN_DESTINATION_CHANGED = 'RETURN_DESTINATION_CHANGED',
  MERCHANT_REFUND_UPDATED = 'MERCHANT_REFUND_UPDATED',
  CONFIRMED_RETURN_LABEL_SENT = 'CONFIRMED_RETURN_LABEL_SENT'
}

export type OrderAddressChangedActivity = OrderActivityDetail & {
   __typename: 'OrderAddressChangedActivity',
  type: OrderActivityDetailType,
  changedBy: Operator,
  previousAddress: Address,
  currentAddress: Address,
};

/** Compare against the total of core line items (sellables, base price, ad hoc) */
export type OrderAmountPromotionRuleReference = PromotionRuleReference & {
   __typename: 'OrderAmountPromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
  operator: PromotionRuleComparisonOperator,
  /** Right hand side amount, in respect to `operator`. Left hand side is the actual aggregated cost of line items. */
  rightOperandAmount: MonetaryAmount,
};

/** See `OrderAmountPromotionRuleReference` for documentation */
export type OrderAmountPromotionRuleReferenceInput = {
  operator: PromotionRuleComparisonOperator,
  rightOperandAmount: MonetaryAmountInput,
};

export type OrderChargeableStatus = {
   __typename: 'OrderChargeableStatus',
  type: OrderChargeableStatusType,
  /** Optional message for failure (non `CAN_CHARGE` types) that provides more context to the user why they can't buy */
  message?: Maybe<Scalars['String']>,
};

export enum OrderChargeableStatusType {
  /** The order can be charged */
  CAN_CHARGE = 'CAN_CHARGE',
  /** The order has already been charged. */
  ALREADY_CHARGED = 'ALREADY_CHARGED',
  /** The order is empty. */
  EMPTY = 'EMPTY',
  /** The order requires a shipping address, but none was provided. Not relevant for OrderChargeableUseCase.CHECKOUT */
  NO_SHIPPING_ADDRESS = 'NO_SHIPPING_ADDRESS',
  /** 
 * The order requires a service address, but none was set by the expert. Orders should never reach the customer in
   * this state as the address should be set by the expert beforehand.
 **/
  NO_SERVICE_LOCATION = 'NO_SERVICE_LOCATION',
  /** The order is expired; the user must reach out to the expert to renew the order. */
  EXPIRED = 'EXPIRED',
  /** 
 * The order requires a minimum amount (e.g.: Orders shipped to Australia need to have at least $125 in the cart)
   * Use the `message` property on `OrderChargeableStatus` to display a message containing the exact amount the user
   * needs.
 **/
  BELOW_MINIMUM_AMOUNT = 'BELOW_MINIMUM_AMOUNT',
  /** 
 * The order is in a preview state (only available for viewing); the user must reach out to the expert to receive
   * a new purchase-able order.
 **/
  IN_PREVIEW = 'IN_PREVIEW'
}

export enum OrderChargeableUseCase {
  /** Checking if the checkout process can be started */
  CHECKOUT = 'CHECKOUT',
  /** Checking if the order can be purchased (payment provided to stripe/paypal/etc, and order charged) */
  PURCHASE = 'PURCHASE'
}

export enum OrderCostComponent {
  /** Includes the price for AD_HOC, SELLABLE, and BASE_PRICE source types (the core price of what's being purchased) */
  CORE = 'CORE',
  /** Tip paid to Deal.com experts */
  EXPERT_TIP = 'EXPERT_TIP',
  /** Fixed gratuity (e.g.: mandatory crew gratuity for charters) */
  GRATUITY = 'GRATUITY',
  /** Prepaid incidental charges (e.g.: advanced provisional allowance for yacht charters) */
  PREPAID_INCIDENTAL = 'PREPAID_INCIDENTAL',
  /** Shipping */
  SHIPMENT = 'SHIPMENT',
  /** Tax */
  TAX_ADJUSTMENTS = 'TAX_ADJUSTMENTS',
  /** Discounts through promotions */
  DISCOUNT_ADJUSTMENTS = 'DISCOUNT_ADJUSTMENTS',
  /** Refunds */
  REFUNDS = 'REFUNDS'
}

export type OrderEscalatedActivity = OrderActivityDetail & {
   __typename: 'OrderEscalatedActivity',
  type: OrderActivityDetailType,
  escalation: OrderEscalation,
};

export type OrderEscalation = {
   __typename: 'OrderEscalation',
  id: Scalars['OrderEscalationId'],
  version: Scalars['Int'],
  updatedAt: Scalars['Date'],
  createdAt: Scalars['Date'],
  userId: Scalars['UserId'],
  orderId: Scalars['OrderId'],
  leadId?: Maybe<Scalars['LeadId']>,
  orderLineItemId?: Maybe<Scalars['OrderLineItemId']>,
  assignedToId?: Maybe<Scalars['OperatorId']>,
  reason?: Maybe<Scalars['String']>,
  startedAt?: Maybe<Scalars['Date']>,
  completedAt?: Maybe<Scalars['Date']>,
  dueDate?: Maybe<Scalars['Date']>,
  status: OrderEscalationStatus,
  type: OrderEscalationType,
  escalatedById: Scalars['AnyId'],
  user: User,
  assignedTo?: Maybe<Operator>,
  order: Order,
  priority: OrderEscalationPriority,
  operatorNotes: Array<OrderOperatorNote>,
  mediaAttachments: Array<OrderEscalationAttachment>,
  consumerFriendlyId?: Maybe<Scalars['String']>,
  supportConversation?: Maybe<SupportConversation>,
  escalatedBy: EscalationUser,
  labels: Array<OrderEscalationLabel>,
  source: OrderEscalationSource,
  returnReason?: Maybe<OrderRefundReason>,
  escalatedItemInfo?: Maybe<EscalationItemInfo>,
};

export type OrderEscalationAttachment = {
   __typename: 'OrderEscalationAttachment',
  uploadedBy: Scalars['AnyId'],
  createdAt: Scalars['Date'],
  title?: Maybe<Scalars['String']>,
  attachmentMediaId: Scalars['MediaId'],
};

export type OrderEscalationConnection = {
   __typename: 'OrderEscalationConnection',
  facets: Array<DisplayFacet>,
  edges: Array<OrderEscalationEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export type OrderEscalationEdge = {
   __typename: 'OrderEscalationEdge',
  node: OrderEscalation,
  cursor: Scalars['String'],
};


export enum OrderEscalationLabel {
  NEED_CONSUMER_INPUT = 'NEED_CONSUMER_INPUT',
  NEED_MERCHANT_INPUT = 'NEED_MERCHANT_INPUT'
}

export enum OrderEscalationPriority {
  HIGH = 'HIGH',
  NORMAL = 'NORMAL'
}

export type OrderEscalationSearchInput = {
  orderIds?: Maybe<Array<Scalars['String']>>,
  userIds?: Maybe<Array<Scalars['UserId']>>,
  operatorIds?: Maybe<Array<Scalars['OperatorId']>>,
  facets?: Maybe<Array<FacetSelection>>,
  facetedSearch?: Maybe<Scalars['Boolean']>,
  dateRangeFilters?: Maybe<Array<DateRangeFilterInput>>,
  statuses?: Maybe<Array<OrderEscalationStatus>>,
  consumerFriendlyId?: Maybe<Scalars['String']>,
  departmentIds?: Maybe<Array<Scalars['DepartmentId']>>,
  sources?: Maybe<Array<OrderEscalationSource>>,
  includeUnassigned?: Maybe<Scalars['Boolean']>,
};

export enum OrderEscalationSearchSort {
  CREATED_AT = 'CREATED_AT',
  STATUS = 'STATUS',
  ORDER_ID = 'ORDER_ID',
  USER_ID = 'USER_ID',
  PAID_AT = 'PAID_AT'
}

export enum OrderEscalationSource {
  CONSUMER = 'CONSUMER',
  EXPERT = 'EXPERT',
  OPERATIONS = 'OPERATIONS'
}

export enum OrderEscalationStatus {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED'
}

export enum OrderEscalationType {
  ITEM_UNAVAILABLE = 'ITEM_UNAVAILABLE',
  MISSING_SPECS = 'MISSING_SPECS',
  ORDER_ADJUSTMENT = 'ORDER_ADJUSTMENT',
  CANCELLATION = 'CANCELLATION',
  RETURN = 'RETURN',
  EXCHANGE = 'EXCHANGE',
  MISSING_ITEM = 'MISSING_ITEM',
  TRACKING_INQUIRY = 'TRACKING_INQUIRY',
  ORDER_INFORMATION = 'ORDER_INFORMATION',
  OTHER = 'OTHER'
}

export type OrderExpertContribution = {
   __typename: 'OrderExpertContribution',
  expert: BusinessUser,
  lead: Lead,
  contributionScore: Scalars['Int'],
};

export type OrderExpertContributionChangedActivity = OrderActivityDetail & {
   __typename: 'OrderExpertContributionChangedActivity',
  type: OrderActivityDetailType,
  existingContributions: Array<OrderExpertContribution>,
  updatedContributions: Array<OrderExpertContribution>,
  existingTips: Array<Maybe<OrderLineItemExpertTipSourceExpertAmount>>,
  updatedTips: Array<Maybe<OrderLineItemExpertTipSourceExpertAmount>>,
};

export type OrderExpertContributionInput = {
  expertId: Scalars['BusinessUserId'],
  leadId: Scalars['LeadId'],
  contributionScore: Scalars['Int'],
};

export enum OrderFulfillmentState {
  NEW = 'NEW',
  CLAIMED = 'CLAIMED',
  READY = 'READY',
  FULFILLED = 'FULFILLED'
}


export type OrderItemReceivedActivity = OrderActivityDetail & {
   __typename: 'OrderItemReceivedActivity',
  type: OrderActivityDetailType,
};

export type OrderItemShippedActivity = OrderActivityDetail & {
   __typename: 'OrderItemShippedActivity',
  type: OrderActivityDetailType,
};

export enum OrderLabel {
  UNCLAIMED = 'UNCLAIMED',
  TRACKING_NEEDED = 'TRACKING_NEEDED',
  TRACKING_OVERDUE = 'TRACKING_OVERDUE'
}

export type OrderLineItem = {
   __typename: 'OrderLineItem',
  id: Scalars['OrderLineItemId'],
  title: Scalars['String'],
  /** 
 * The entity which this line item is derived/synced with. Note that changes in a line item's source price
   * (e.g.: changing a sellable's price) will be bubbled down to to the order line's unitPrice each time the
   * order is modified, or the `syncOrder` mutation is called.
 **/
  source: OrderLineItemSource,
  /** the base price of one unit; does not include adjustments (tax, promotions, etc) */
  unitPrice: MonetaryAmount,
  /** quantity of items; can only be greater than one for sellable sources. */
  quantity: Scalars['Int'],
  /** the base price for `quantity` items; does not include adjustments (tax, promotions, etc) */
  price: MonetaryAmount,
  /** the final price of this item, excluding tax adjustments, but including other adjustments such as promotions. */
  totalBeforeTax: MonetaryAmount,
  /** Messages associated with this order line item */
  messages: Array<OrderMessage>,
  /** 
 * If this order line item is a child line item, this will be the parent line item this line item is a child of.
   * If null, this line item is a parent (top level) line item.
 **/
  parentId?: Maybe<Scalars['OrderLineItemId']>,
  /** This is the child -> parent relationship of the `parentId` relationship, provided for convenience. */
  childIds: Array<Scalars['OrderLineItemId']>,
  children: Array<OrderLineItem>,
  /** 
 * If this order line item is a grouping order line item. This flag should be used to determine if child line items
   * can expectedReference this line item as a parent. Note that all line items can't have children blindly added - parents
   * need to be explicitly made into groups (groups dictate pricing policies of children, along with taxation), so
   * prefer using this over inferring if this is a group from non-empty `childIds`.
 **/
  isGroup: Scalars['Boolean'],
  /** Metadata about this grouping, if isGroup == true */
  groupDefinition?: Maybe<OrderLineItemGroupDefinition>,
  /** 
 * If this order line item is required. Note that this will only be true for child line items that are required within
   * their parent line item. Forcefully removing this line item will remove the parent line item, and any other
   * sibling/child line items of that parent.
 **/
  required: Scalars['Boolean'],
  /** Terms specific to the user's purchase of the sellable (e.g.: start time for a charter) */
  terms?: Maybe<SellableTerms>,
  /** The state of the order line item */
  state: OrderLineItemState,
  /** Shipment tracking associated with this order */
  shipmentTracking?: Maybe<ShipmentTracking>,
  /** Return shipment tracking associated with this order */
  returnShipmentTracking?: Maybe<ShipmentTracking>,
  /** Shipping method used for this line item, if applicable */
  shippingMethod?: Maybe<ShippingMethod>,
  /** Id of the merchant who claimed that item */
  claimedByMerchant?: Maybe<Merchant>,
  /** Price quote from the merchant who claimed that item */
  claimedByMerchantQuote?: Maybe<MonetaryAmount>,
  /** Order identifier for the order placed with the merchant (merchant specific) */
  claimedByMerchantOrderId?: Maybe<Scalars['String']>,
  /** The parent order that contains this line item */
  order: Order,
  /** The expert curated item this line item was added from, if any */
  expertCuratedItem?: Maybe<ExpertCuratedItem>,
  /** ETA for the item from the merchant */
  etaFromMerchant?: Maybe<Scalars['Date']>,
  /** Notes on the item from merchant or vendor during customization phase. */
  customizationNotes?: Maybe<Scalars['String']>,
  /** Max ETA for the item from the merchant, if merchant chose to enter a date range for the eta */
  maxEtaFromMerchant?: Maybe<Scalars['Date']>,
  /** Email alias for the line item used to place order with merchants */
  emailForFulfillment: Scalars['String'],
  /** Item specific notes */
  notes: Array<OrderOperatorNote>,
  fulfillmentOrderSourceType?: Maybe<FulfillmentOrderSourceType>,
  /** If fulfilled by Deal inventory, the corresponding fulfillment order */
  fulfillmentOrder?: Maybe<FulfillmentOrder>,
  merchantTax?: Maybe<MonetaryAmount>,
  merchantShippingCost?: Maybe<MonetaryAmount>,
  eligibleForReturn: Scalars['Boolean'],
  eligibleForCancellation: Scalars['Boolean'],
  requestedReturn?: Maybe<OrderRefund>,
};

export type OrderLineItemAdHocSource = OrderLineItemSource & {
   __typename: 'OrderLineItemAdHocSource',
  type: OrderLineItemSourceType,
};

export type OrderLineItemBasePriceSource = OrderLineItemSource & {
   __typename: 'OrderLineItemBasePriceSource',
  type: OrderLineItemSourceType,
};

export type OrderLineItemExpertTipSource = OrderLineItemSource & {
   __typename: 'OrderLineItemExpertTipSource',
  type: OrderLineItemSourceType,
  amount: MonetaryAmount,
  expertAmounts: Array<OrderLineItemExpertTipSourceExpertAmount>,
};

export type OrderLineItemExpertTipSourceExpertAmount = {
   __typename: 'OrderLineItemExpertTipSourceExpertAmount',
  expert: BusinessUser,
  amount: MonetaryAmount,
};

export type OrderLineItemGratuitySource = OrderLineItemSource & {
   __typename: 'OrderLineItemGratuitySource',
  type: OrderLineItemSourceType,
  percentage: Scalars['Int'],
};

export type OrderLineItemGroupDefinition = {
   __typename: 'OrderLineItemGroupDefinition',
  /** Defines how price is computed for this grouped line item and its children */
  priceStrategy: OrderLineItemGroupPriceStrategy,
  /** Defines how tax is computed for this grouped line item and its children */
  taxStrategy: OrderLineItemGroupTaxStrategy,
};

export enum OrderLineItemGroupPriceStrategy {
  /** This line item has no price, and is strictly added as a grouping line item with the children having prices. */
  IGNORE_SELF_DEFAULT_CHILDREN = 'IGNORE_SELF_DEFAULT_CHILDREN',
  /** This line item has a price, with the child line item prices being ignored / not respected. */
  ONLY_SELF_IGNORE_CHILDREN = 'ONLY_SELF_IGNORE_CHILDREN'
}

export enum OrderLineItemGroupTaxStrategy {
  /** All line items will retain their default tax calculation. */
  DEFAULT = 'DEFAULT',
  /** 
 * All line items that are children of the current line item will use the current line item's tax calculation.
   * This is useful when the grouping parent line item is a service (e.g.: charters) that are taxed using the service
   * location - not the shipping address. This strategy will use that same calculation (service location) for all child
   * line items (e.g.: ensure that add-on food line item is taxed like the charter).
 **/
  PROPAGATE_SELF_TO_CHILDREN = 'PROPAGATE_SELF_TO_CHILDREN'
}


export type OrderLineItemPrepaidIncidentalSource = OrderLineItemSource & {
   __typename: 'OrderLineItemPrepaidIncidentalSource',
  type: OrderLineItemSourceType,
  percentage: Scalars['Int'],
};

export type OrderLineItemReceivedInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
};

export type OrderLineItemReceivedPayload = {
   __typename: 'OrderLineItemReceivedPayload',
  order: Order,
};

export type OrderLineItemRefundSource = OrderLineItemSource & {
   __typename: 'OrderLineItemRefundSource',
  type: OrderLineItemSourceType,
};

export type OrderLineItemReturnRequestInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
  orderEscalationId: Scalars['OrderEscalationId'],
};

export type OrderLineItemSellableSource = OrderLineItemSource & {
   __typename: 'OrderLineItemSellableSource',
  type: OrderLineItemSourceType,
  sellable: Sellable,
  overridePrice?: Maybe<MonetaryAmount>,
};

export type OrderLineItemShipmentSource = OrderLineItemSource & {
   __typename: 'OrderLineItemShipmentSource',
  type: OrderLineItemSourceType,
  amount: MonetaryAmount,
};

export type OrderLineItemSource = {
  type: OrderLineItemSourceType,
};

export enum OrderLineItemSourceType {
  /** No additional metadata; ad-hoc line item */
  AD_HOC = 'AD_HOC',
  /** Line item is linked to a sellable */
  SELLABLE = 'SELLABLE',
  /** Line item is a child line item, indicating the base price of the parent (primarily used for services) */
  BASE_PRICE = 'BASE_PRICE',
  /** Line item represents a tip to Deal.com experts */
  EXPERT_TIP = 'EXPERT_TIP',
  /** Fixed gratuity */
  GRATUITY = 'GRATUITY',
  /** Prepaid incidental charges */
  PREPAID_INCIDENTAL = 'PREPAID_INCIDENTAL',
  /** Shipment cost line item */
  SHIPMENT = 'SHIPMENT',
  /** Refund for one or more items in the order */
  REFUND = 'REFUND'
}

export enum OrderLineItemState {
  PENDING_CLAIM = 'PENDING_CLAIM',
  CLAIMED = 'CLAIMED',
  NEW = 'NEW',
  PAID = 'PAID',
  READY_TO_CLAIM = 'READY_TO_CLAIM',
  PENDING_SHIPPING = 'PENDING_SHIPPING',
  READY = 'READY',
  RECEIVED = 'RECEIVED',
  RETURN_PENDING_SHIPPING = 'RETURN_PENDING_SHIPPING',
  RETURN_REQUESTED = 'RETURN_REQUESTED',
  RETURN_RECEIVED = 'RETURN_RECEIVED',
  RETURN_SHIPPED = 'RETURN_SHIPPED',
  SHIPPED = 'SHIPPED',
  UNAVAILABLE = 'UNAVAILABLE',
  CUSTOMIZING = 'CUSTOMIZING'
}

export type OrderLineItemUnavailableInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
};

export type OrderLineItemUnclaimInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
};

export type OrderMessage = {
   __typename: 'OrderMessage',
  dismissible: Scalars['Boolean'],
  message: Scalars['String'],
};

export type OrderOperatorNote = {
   __typename: 'OrderOperatorNote',
  operator: Operator,
  createdAt: Scalars['Date'],
  title?: Maybe<Scalars['String']>,
  note: Scalars['String'],
};

export enum OrderPreSubmitAction {
  CHECKOUT_STARTED = 'CHECKOUT_STARTED',
  ADD_TO_CART = 'ADD_TO_CART',
  PAYMENT_INFO_ENTERED = 'PAYMENT_INFO_ENTERED'
}

export type OrderPromotionEntry = {
   __typename: 'OrderPromotionEntry',
  promotion: Promotion,
  addedAt: Scalars['Date'],
  /** 
 * If this promotion is applied to the order. Note that there will be at most one promotion entry for a given order
   * that has this set to `true`.
 **/
  applied: Scalars['Boolean'],
  /** The total discount this promotion provides to the order */
  discount: MonetaryAmount,
};

export type OrderQuery = {
  userId?: Maybe<Scalars['UserId']>,
  /** If omitted, this will default to all states except for CREATED and CART */
  states?: Maybe<Array<OrderState>>,
  fulfillmentStates?: Maybe<Array<OrderFulfillmentState>>,
  orderLineItemStates?: Maybe<Array<OrderLineItemState>>,
  /** this can be either consumerFriendlyId or order external id */
  orderId?: Maybe<Scalars['String']>,
  fulfillmentOperatorIds?: Maybe<Array<Scalars['OperatorId']>>,
  ordersWithNoFulfillmentOperatorOnly?: Maybe<Scalars['Boolean']>,
  userQuery?: Maybe<Scalars['String']>,
  facetedSearch?: Maybe<Scalars['Boolean']>,
  facets?: Maybe<Array<FacetSelection>>,
  dateRangeFilters?: Maybe<Array<DateRangeFilterInput>>,
  shippingAddresseeName?: Maybe<Scalars['String']>,
  keywords?: Maybe<Scalars['String']>,
  departmentIds?: Maybe<Array<Scalars['DepartmentId']>>,
  includeUnassignedOrders?: Maybe<Scalars['Boolean']>,
  categoryType?: Maybe<CategoryType>,
};

export type OrderRefund = {
   __typename: 'OrderRefund',
  id: Scalars['OrderRefundId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  order: Order,
  consumer: User,
  lineItemIds: Array<Scalars['OrderLineItemId']>,
  escalation?: Maybe<OrderEscalation>,
  requestedByOperator?: Maybe<Operator>,
  processedBy?: Maybe<Operator>,
  reason: OrderRefundReason,
  status: OrderRefundStatus,
  amountRequested: MonetaryAmount,
  originalTransactionId: Scalars['TransactionId'],
  comment?: Maybe<Scalars['String']>,
  returnNeeded: Scalars['Boolean'],
  merchantRefundNeeded: Scalars['Boolean'],
  merchantRefundedAmount?: Maybe<MonetaryAmount>,
  merchantRefundNote?: Maybe<Scalars['String']>,
  returnShipmentTracking?: Maybe<ShipmentTracking>,
};

export type OrderRefundEdge = {
   __typename: 'OrderRefundEdge',
  node: OrderRefund,
  cursor: Scalars['String'],
};

export type OrderRefundFailedInput = {
  orderRefundId: Scalars['OrderRefundId'],
};


export type OrderRefundQueryInput = {
  statuses?: Maybe<Array<OrderRefundStatus>>,
  originalTransactionIds?: Maybe<Array<Scalars['TransactionId']>>,
  requestDateRange?: Maybe<DateRangeInput>,
};

export enum OrderRefundReason {
  DIDNT_LIKE = 'DIDNT_LIKE',
  NOT_EXPECTED = 'NOT_EXPECTED',
  WRONG_ITEM = 'WRONG_ITEM',
  BAD_DESCRIPTION = 'BAD_DESCRIPTION',
  DEFECTIVE = 'DEFECTIVE',
  DAMAGED_IN_SHIPPING = 'DAMAGED_IN_SHIPPING',
  NEVER_ARRIVED = 'NEVER_ARRIVED',
  ARRIVED_LATE = 'ARRIVED_LATE',
  UNAPPROVED = 'UNAPPROVED',
  BAD_WEATHER = 'BAD_WEATHER',
  EQUIPMENT_MALFUNCTION = 'EQUIPMENT_MALFUNCTION',
  WRONG_AMOUNT = 'WRONG_AMOUNT',
  WRONG_SIZE = 'WRONG_SIZE',
  WRONG_COLOR = 'WRONG_COLOR',
  DAMAGED_SHIPPING_BOX_OK = 'DAMAGED_SHIPPING_BOX_OK',
  DAMAGED_SHIPPING_BOX_DAMAGED = 'DAMAGED_SHIPPING_BOX_DAMAGED',
  UNAVAILABLE_INVENTORY = 'UNAVAILABLE_INVENTORY',
  REPLACED_INVENTORY = 'REPLACED_INVENTORY',
  LOST_DURING_SHIPPING = 'LOST_DURING_SHIPPING',
  UNABLE_TO_EXPEDITE_SHIPPING = 'UNABLE_TO_EXPEDITE_SHIPPING',
  PRICE_MATCH = 'PRICE_MATCH',
  CUSTOMER_REQUEST = 'CUSTOMER_REQUEST'
}

export type OrderRefundRejectedInput = {
  orderRefundId: Scalars['OrderRefundId'],
};

export type OrderRefundsConnection = {
   __typename: 'OrderRefundsConnection',
  edges: Array<OrderRefundEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export type OrderRefundsPagination = {
   __typename: 'OrderRefundsPagination',
  orderRefunds: Array<OrderRefund>,
  count: Scalars['Long'],
};

export enum OrderRefundStatus {
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED'
}

export type OrderRefundSuccessInput = {
  orderRefundId: Scalars['OrderRefundId'],
};

export type OrderRefundWithError = {
   __typename: 'OrderRefundWithError',
  orderRefund?: Maybe<OrderRefund>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type OrdersConnection = {
   __typename: 'OrdersConnection',
  facets: Array<DisplayFacet>,
  edges: Array<OrdersEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export enum OrderSearchSort {
  PAID_AT = 'PAID_AT',
  CREATED_AT = 'CREATED_AT',
  EFFECTIVE_ORDER_DATE = 'EFFECTIVE_ORDER_DATE',
  EFFECTIVE_ORDER_DATE_ASC = 'EFFECTIVE_ORDER_DATE_ASC'
}

export type OrdersEdge = {
   __typename: 'OrdersEdge',
  node: Order,
  cursor: Scalars['String'],
};

export type OrderShippingCost = {
   __typename: 'OrderShippingCost',
  shippingMethodCosts: Array<ShippingMethodCost>,
};

/** Can specify either addressId, country/state, or none */
export type OrderShippingCostAddressInput = {
  addressId?: Maybe<Scalars['AddressId']>,
  country?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
};

export enum OrderState {
  CART = 'CART',
  CREATED = 'CREATED',
  SUBMITTED = 'SUBMITTED',
  CONSUMER_PAYMENT_PENDING = 'CONSUMER_PAYMENT_PENDING',
  CONSUMER_PAYMENT_IN_REVIEW = 'CONSUMER_PAYMENT_IN_REVIEW',
  CONSUMER_PAYMENT_COMPLETED = 'CONSUMER_PAYMENT_COMPLETED',
  CONSUMER_PAYMENT_FAILED = 'CONSUMER_PAYMENT_FAILED',
  CONSUMER_PAYMENT_PARTIAL = 'CONSUMER_PAYMENT_PARTIAL',
  CONSUMER_OVERPAID = 'CONSUMER_OVERPAID',
  CONSUMER_PAYMENT_REFUNDED = 'CONSUMER_PAYMENT_REFUNDED',
  CONSUMER_PAYMENT_CANCELED = 'CONSUMER_PAYMENT_CANCELED'
}

export type OrderSupportTask = SupportTask & {
   __typename: 'OrderSupportTask',
  id: Scalars['SupportTaskId'],
  type: SupportTaskType,
  state: SupportTaskState,
  url: Scalars['String'],
  dueAt: Scalars['Date'],
  assignedTo?: Maybe<Operator>,
  assignedAt?: Maybe<Scalars['Date']>,
  completedAt?: Maybe<Scalars['Date']>,
  consumer: User,
  note: Scalars['String'],
  order?: Maybe<Order>,
  lead?: Maybe<Lead>,
};

export type OrderVerificationActivity = OrderActivityDetail & {
   __typename: 'OrderVerificationActivity',
  type: OrderActivityDetailType,
  verifiedBy: Operator,
  successful: Scalars['Boolean'],
};

export type OrderVerificationTicket = TicketDetail & {
   __typename: 'OrderVerificationTicket',
  type: TicketType,
  consumerId: Scalars['UserId'],
  order: Order,
  orderLineItemId: Scalars['OrderLineItemId'],
};

export type OverwriteShiftSlotInput = {
  shiftSlotId: Scalars['ShiftSlotId'],
  shiftUnitsRequired?: Maybe<Scalars['BigDecimal']>,
  claimedByIdToAdd?: Maybe<Scalars['AnyId']>,
  claimedByIdToRemove?: Maybe<Scalars['AnyId']>,
};

export type OverwriteShiftSlotPayload = {
   __typename: 'OverwriteShiftSlotPayload',
  shiftSlot?: Maybe<ShiftSlot>,
  error?: Maybe<Scalars['String']>,
};

/** Generic pagination information. We can put things like count/total in here as well */
export type PageInfo = {
   __typename: 'PageInfo',
  hasNextPage: Scalars['Boolean'],
  hasPreviousPage: Scalars['Boolean'],
  startCursor?: Maybe<Scalars['String']>,
  endCursor?: Maybe<Scalars['String']>,
};

export type ParsedPhoneNumber = {
   __typename: 'ParsedPhoneNumber',
  /** e.g. +1 for US/Canada, +44 for UK */
  countryCode: Scalars['String'],
  /** e.g. US, CA, UK */
  regionCode: Scalars['String'],
  /** e.g. 4151234567 for a US number +14151234567 */
  nationalNumber: Scalars['String'],
};

export type PartitionDefinition = {
   __typename: 'PartitionDefinition',
  treatmentValue: Scalars['String'],
  /** The percentage allocated to this partition. 60 means 60% */
  percentage: Scalars['Int'],
};

export type PartitionDefinitionInput = {
  treatmentValue: Scalars['String'],
  percentage: Scalars['Int'],
};

export type PartnerFulfillmentOrderSource = FulfillmentOrderSource & {
   __typename: 'PartnerFulfillmentOrderSource',
  type: FulfillmentOrderSourceType,
  /** order id from partner merchant */
  merchantOrderId?: Maybe<Scalars['String']>,
  estimatedDeliveryAt?: Maybe<Scalars['Date']>,
  maxEstimatedDeliveryAt?: Maybe<Scalars['Date']>,
  tax?: Maybe<MonetaryAmount>,
  shippingCost?: Maybe<MonetaryAmount>,
  quote?: Maybe<MonetaryAmount>,
};

/** 
 * =============================
 * Path Schema, Flow, & Question
 * =============================
 **/
export type PathFlow = {
   __typename: 'PathFlow',
  id: Scalars['PathFlowId'],
  /** Displayable title for the path flow; will be used to eventually derive the request name as well */
  title?: Maybe<TextViewModel>,
  /** Once the user completes the flow, this will be true and no further modifications to the flow are possible */
  completed: Scalars['Boolean'],
  /** When completed=true, this will signify the action that should be performed. */
  onComplete?: Maybe<PathFlowOnComplete>,
  /** 
 * When completed=true, there will be a generated Request from this path as well.
   * NOTE: Request schema included in this file; included separately
   * Unique slug for this path flow variant to add to the URL. .e.g.: "watches", "watches-sf", "massages", ...
 **/
  slug: Scalars['String'],
  /** Styling that should be applied when rendering the path flow */
  theme: PathFlowTheme,
  /** The category this path is associated with */
  category?: Maybe<Category>,
  /** 
 * Server understands client (e.g.: react native with shipped code) - client will only recieve question types they understand
   * You'll get the sequence of static pages until you hit the first dynamic branching step. You can either
   * 1) Go through each step you have cached and as you select, submit the mutation to save and optimistically
   *    show the next screen (if you have it)
   * 2) Each mutation you do returns the updated PathFlow. You'll need to depend on this if there is a branching step
   *    (PathFlowPage.requiresServerSyncAfterSubmit=true), or you don't have the next step cached.
   * Pagination follows GraphQL Relay Connections standard; first = 1 will get you one page. after accepts the "cursor" field
   * from Edge types and will give results after that cursor.
 **/
  pagesConnection: PathFlowPagesConnection,
  /** The user who created this path flow */
  createdBy?: Maybe<User>,
};


/** 
 * =============================
 * Path Schema, Flow, & Question
 * =============================
 **/
export type PathFlowPagesConnectionArgs = {
  first?: Maybe<Scalars['Int']>,
  after?: Maybe<Scalars['String']>
};

export type PathFlowBySlugPayload = {
   __typename: 'PathFlowBySlugPayload',
  flow?: Maybe<PathFlow>,
};


export type PathFlowOnComplete = PathFlowOnCompleteBroadcast | PathFlowOnCompleteLead | PathFlowOnCompleteNewPath | PathFlowOnCompleteDealRequest | PathFlowOnCompleteExpertReview | PathFlowOnCompleteRedirectOnly | PathFlowOnCompleteRedirectWithUpsert | PathFlowOnCompleteExpertApplication;

/** 
 * On complete of a path flow, a conversation is generated
 * DEPRECATED: Use PathFlowOnCompleteLead
 **/
export type PathFlowOnCompleteBroadcast = {
   __typename: 'PathFlowOnCompleteBroadcast',
  /** Location the client should navigate */
  location: PathFlowOnCompleteRedirectLocation,
  /** Actual conversation that was created */
  conversation: Conversation,
};

export type PathFlowOnCompleteDealRequest = {
   __typename: 'PathFlowOnCompleteDealRequest',
  dealRequest: DealRequest,
  location: PathFlowOnCompleteRedirectLocation,
};

export type PathFlowOnCompleteExpertApplication = {
   __typename: 'PathFlowOnCompleteExpertApplication',
  application: ExpertApplication,
  location: PathFlowOnCompleteRedirectLocation,
};

export type PathFlowOnCompleteExpertReview = {
   __typename: 'PathFlowOnCompleteExpertReview',
  review: ConsumerExpertReview,
  location: PathFlowOnCompleteRedirectLocation,
};

export type PathFlowOnCompleteLead = {
   __typename: 'PathFlowOnCompleteLead',
  /** Location the client should navigate */
  location: PathFlowOnCompleteRedirectLocation,
  /** The new lead that was created, or existing lead that was re-used */
  lead: Lead,
  /** Conversation for the lead */
  conversation: Conversation,
};

/** On complete of a path flow, a new path is generated that should be navigated to */
export type PathFlowOnCompleteNewPath = {
   __typename: 'PathFlowOnCompleteNewPath',
  /** New path flow that was generated that the client should navigate to and start */
  flow: PathFlow,
};

export enum PathFlowOnCompleteRedirectLocation {
  /** Reload the current page, this is used for paths that happen in-place */
  RELOAD_CURRENT_PAGE = 'RELOAD_CURRENT_PAGE',
  /** Expert profile page with selection screen. Only valid for paths completed with a lead. */
  EXPERT_PROFILE = 'EXPERT_PROFILE',
  /** Default inbox page */
  INBOX = 'INBOX',
  /** Redirect to login page */
  LOGIN = 'LOGIN',
  /** Redirect to the completion page after an application is submitted */
  APPLY_FINISH = 'APPLY_FINISH',
  /** Redirect to selected department page */
  DEPARTMENT_PAGE = 'DEPARTMENT_PAGE',
  /** Redirect to selected category page */
  CATEGORY = 'CATEGORY',
  /** 
 * For golf experiment only, a redirect that will take the user back into
   * the path system to add their phone number
 **/
  PHONE_COLLECTION_PATH = 'PHONE_COLLECTION_PATH'
}

/** 
 * On complete of a path flow, the user should be navigated to the specified location.
 * This on complete type is typically used when the path flow isn't relevant, and we
 * want to direct the user to do something else (e.g.: already has an account - login).
 **/
export type PathFlowOnCompleteRedirectOnly = {
   __typename: 'PathFlowOnCompleteRedirectOnly',
  /** Location the client should navigate */
  location: PathFlowOnCompleteRedirectLocation,
};

/** 
 * This is the same as the PathFlowOnCompleteRedirectOnly, but the client needs to be able to
 * discern when a lead is coming from an upsert or just a vanilla redirect
 **/
export type PathFlowOnCompleteRedirectWithUpsert = {
   __typename: 'PathFlowOnCompleteRedirectWithUpsert',
  /** Location the client should navigate */
  location: PathFlowOnCompleteRedirectLocation,
};

export type PathFlowPage = {
   __typename: 'PathFlowPage',
  id: Scalars['PathFlowPageId'],
  /** Parent PathFlow this page is a part of */
  flow: PathFlow,
  /** Additional metadata that can be used to customize behavior or rendering of this page */
  metadata: Array<PathFlowPageMetadata>,
  /** 
 * Unique identifier for this flow "type". you can pick this up from the client and do any customizations as required.
   * String may be something like: "dial_size". Not to be exposed in the ui/url, only for internal use
 **/
  internalName: Scalars['String'],
  /** Display text for page */
  title?: Maybe<TextViewModel>,
  /** Top level image for page */
  titleImage?: Maybe<ImageViewModel>,
  /** Interstitial text for the page. If present, there will be no quesetions on the page. */
  interstitialText?: Maybe<TextViewModel>,
  /** Questions to display on this page. If non-empty, there will be no interstitial text */
  questions: Array<PathFlowQuestion>,
  /** 
 * Notifications to display at the top of the page (e.g.: contextual tool tip)
   * Crappy name since we'll probably deprecate this for a richer model which can use the proper "notification" name
 **/
  notificationTexts: Array<TextViewModel>,
  /** 
 * Unique slug for this page within the parent path flow which should be added to the URL. .e.g.: "flexibility", "distance"
   * Note that when assembling the url, the parent path flow page slug should be used as the preceeding path component. So:
   * http://www.deal.com/request/{pathFlow.slug}/{pathFlowPage.slug}
 **/
  slug: Scalars['String'],
  /** 
 * Questions from this and previous pages must be submitted before proceeding
   * This may be true due to enforced input validation. e.g.: question doesn't
   * introduce branching, but does special server side validation.
   * This also may be true due to conditional skip targets. e.g..: question does
   * introduce branching, and dynamically selects next page.
 **/
  requiresServerSyncAfterSubmit: Scalars['Boolean'],
  /** 
 * How close are we to completing this flow. Will be a value from 0 to 100, inclusive
   * Note: Since flows can branch, this number is not guaranteed to progress in a linear fashion
 **/
  completionPercentage: Scalars['Int'],
  /** If the user completed this page by submitting it and/or all associated questions on the page */
  completed: Scalars['Boolean'],
  /** submit button text to use when submitting a non-empty response. If empty, should fallback to client default */
  submitButtonText?: Maybe<TextViewModel>,
  /** 
 * submit button text to use when all questions are optional, and none of them are filled out. If empty, should
   * fallback to client default.
 **/
  skipButtonText?: Maybe<TextViewModel>,
};


export type PathFlowPageMetadata = {
  type: PathFlowPageMetadataType,
};

export enum PathFlowPageMetadataType {
  INTERSTITIAL = 'INTERSTITIAL',
  CUSTOM = 'CUSTOM',
  /** Below are deprecated */
  LOADING_QUESTIONS = 'LOADING_QUESTIONS',
  CONNECTING_TO_OPERATOR = 'CONNECTING_TO_OPERATOR',
  FINDING_MERCHANTS = 'FINDING_MERCHANTS',
  HIGH_SECURITY = 'HIGH_SECURITY',
  WELCOME = 'WELCOME'
}

export type PathFlowPagePayload = {
   __typename: 'PathFlowPagePayload',
  page?: Maybe<PathFlowPage>,
};

export type PathFlowPagesConnection = {
   __typename: 'PathFlowPagesConnection',
  edges: Array<PathFlowPagesEdge>,
  pageInfo?: Maybe<PageInfo>,
};

export type PathFlowPagesEdge = {
   __typename: 'PathFlowPagesEdge',
  node: PathFlowPage,
  cursor: Scalars['String'],
};

export type PathFlowPayload = {
   __typename: 'PathFlowPayload',
  flow?: Maybe<PathFlow>,
};

export type PathFlowQuestion = {
  /** 
 * Similar to parent's PathFlowPage.internalName, unique identifier for a question within a page.
   * String may be something like: "products.watches.dial_size.diameter"
   * Not to be exposed in the ui/url, only for internal use like customizing UI widget
 **/
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  /** An icon that's placed immediately above the question input */
  inputIconImage?: Maybe<ImageViewModel>,
  /** A label that's placed immediately above the question input; should be placed after the icon if inputIconImage is present */
  inputLabel?: Maybe<TextViewModel>,
  /** All of the attributes that have been entered in the path so far */
  attributes: Array<Attribute>,
  /** Pull out a particular attribute value by name */
  attribute?: Maybe<Attribute>,
};


export type PathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export type PathFlowTheme = {
   __typename: 'PathFlowTheme',
  type: PathFlowThemeType,
};

export enum PathFlowThemeType {
  DEFAULT = 'DEFAULT',
  SNOWBOARD = 'SNOWBOARD',
  CHAT_LIKE = 'CHAT_LIKE'
}

/** Denotes an image or icon that's dynamically resolved within the client app */
export type PathImageViewModel = {
   __typename: 'PathImageViewModel',
  imagePath: Scalars['String'],
  imageUrl: Scalars['String'],
};


/** ====== Path validation errors */
export type PathValidationError = {
   __typename: 'PathValidationError',
  /** Which page the error is the associated with */
  pageName?: Maybe<Scalars['String']>,
  /** Which question on the above page the error is associated with. If this is not null, pageId will also be not null. */
  questionName?: Maybe<Scalars['String']>,
  /** Additional "tags" that act something like an error-code, except that a single message may have many tags */
  tags?: Maybe<Array<PathValidationErrorTag>>,
  /** Text describing the validation error which should be displayed to the user */
  message?: Maybe<TextViewModel>,
};

export enum PathValidationErrorTag {
  /** If this error is produced, the client must have the user login, or change the contact information being used to proceed */
  REQUIRES_LOGIN_TO_PROCEED = 'REQUIRES_LOGIN_TO_PROCEED',
  /** Indicates an internal error, typically surfaced if the API is misused, or some type of developer/administrative error. */
  INTERNAL = 'INTERNAL'
}

export type PayComponentCommissionRule = PayComponentRule & {
   __typename: 'PayComponentCommissionRule',
  type: PayComponentType,
  rate: Scalars['BigDecimal'],
};

export type PayComponentCommissionRuleInput = {
  rate: Scalars['BigDecimal'],
};

export type PayComponentCommissionSummary = PayComponentSummary & {
   __typename: 'PayComponentCommissionSummary',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
  basisAmount: MonetaryAmount,
};

export type PayComponentFirstShiftsGuaranteedRule = PayComponentRule & {
   __typename: 'PayComponentFirstShiftsGuaranteedRule',
  type: PayComponentType,
  amount: MonetaryAmount,
  shifts: Scalars['Int'],
};

export type PayComponentFirstShiftsGuaranteedRuleInput = {
  amount: MonetaryAmountInput,
  shifts: Scalars['Int'],
};

export type PayComponentFirstShiftsGuaranteedSummary = PayComponentSummary & {
   __typename: 'PayComponentFirstShiftsGuaranteedSummary',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
};

export type PayComponentHourlyOnCallRule = PayComponentRule & {
   __typename: 'PayComponentHourlyOnCallRule',
  type: PayComponentType,
  hourlyPayAmount: MonetaryAmount,
};

export type PayComponentHourlyOnCallRuleInput = {
  hourlyPayAmount: MonetaryAmountInput,
};

export type PayComponentHourlyOnCallSummary = PayComponentSummary & {
   __typename: 'PayComponentHourlyOnCallSummary',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
  minutes: Scalars['Int'],
};

export type PayComponentManualAdjustmentSummary = PayComponentSummary & {
   __typename: 'PayComponentManualAdjustmentSummary',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
};

export type PayComponentQualityConversationRule = PayComponentRule & {
   __typename: 'PayComponentQualityConversationRule',
  type: PayComponentType,
  amountPerConversation: MonetaryAmount,
};

export type PayComponentQualityConversationRuleInput = {
  amountPerConversation: MonetaryAmountInput,
};

export type PayComponentQualityConversationSummary = PayComponentSummary & {
   __typename: 'PayComponentQualityConversationSummary',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
};

export type PayComponentReferralFirstOrderRule = PayComponentRule & {
   __typename: 'PayComponentReferralFirstOrderRule',
  type: PayComponentType,
  feeToExpert: MonetaryAmount,
  minimumOrderAmount: MonetaryAmount,
};

export type PayComponentReferralFirstOrderRuleInput = {
  feeToExpert: MonetaryAmountInput,
  minimumOrderAmount: MonetaryAmountInput,
};

export type PayComponentReferralFirstOrderSummary = PayComponentSummary & {
   __typename: 'PayComponentReferralFirstOrderSummary',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
};

export type PayComponentRule = {
  type: PayComponentType,
};

export type PayComponentRuleInput = {
  commission?: Maybe<PayComponentCommissionRuleInput>,
  tip?: Maybe<PayComponentTipRuleInput>,
  hourlyOnCall?: Maybe<PayComponentHourlyOnCallRuleInput>,
  shiftsGuaranteed?: Maybe<PayComponentFirstShiftsGuaranteedRuleInput>,
  qualityConversation?: Maybe<PayComponentQualityConversationRuleInput>,
  referralFirstOrder?: Maybe<PayComponentReferralFirstOrderRuleInput>,
  type: PayComponentType,
};

export type PayComponentSummary = {
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
};

export type PayComponentTipRule = PayComponentRule & {
   __typename: 'PayComponentTipRule',
  type: PayComponentType,
};

export type PayComponentTipRuleInput = {
  enabled: Scalars['Boolean'],
};

export type PayComponentTipSummary = PayComponentSummary & {
   __typename: 'PayComponentTipSummary',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
};

export enum PayComponentType {
  COMMISSION = 'COMMISSION',
  QUALITY_CONVERSATION = 'QUALITY_CONVERSATION',
  TIP = 'TIP',
  FIRST_SHIFTS_GUARANTEED_PAY = 'FIRST_SHIFTS_GUARANTEED_PAY',
  HOURLY_ON_CALL = 'HOURLY_ON_CALL',
  MANUAL_ADJUSTMENT = 'MANUAL_ADJUSTMENT',
  REFERRAL_FIRST_ORDER = 'REFERRAL_FIRST_ORDER'
}

export type PayForOrderInput = {
  orderId: Scalars['OrderId'],
  chargeInfos: Array<ChargeInfoInput>,
};

export type PayForOrderPayload = {
   __typename: 'PayForOrderPayload',
  order?: Maybe<Order>,
  /** string explaining reason for failure if any */
  error?: Maybe<Scalars['String']>,
};

export type PayLineItem = {
   __typename: 'PayLineItem',
  id: Scalars['PayLineItemId'],
  postedAt: Scalars['Date'],
  payStructureRevision?: Maybe<PayStructureRevision>,
  payee: BusinessUser,
  payout: Payout,
  source: PayLineItemSource,
  notes?: Maybe<Scalars['String']>,
};

export type PayLineItemCommissionSource = PayLineItemSource & {
   __typename: 'PayLineItemCommissionSource',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  orderId: Scalars['OrderId'],
  basisAmount: MonetaryAmount,
  contributionPercent: Scalars['Int'],
  rule: PayComponentCommissionRule,
  order: Order,
  orderDetails: PayLineItemOrderDetails,
};

export type PayLineItemFirstShiftsGuaranteedSource = PayLineItemSource & {
   __typename: 'PayLineItemFirstShiftsGuaranteedSource',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  rule: PayComponentFirstShiftsGuaranteedRule,
};

export type PayLineItemHourlyOnCallSource = PayLineItemSource & {
   __typename: 'PayLineItemHourlyOnCallSource',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  durationInMinutes: Scalars['Int'],
  rule: PayComponentHourlyOnCallRule,
};


export type PayLineItemLeadDetails = {
   __typename: 'PayLineItemLeadDetails',
  consumer: User,
  leadId: Scalars['LeadId'],
};

export type PayLineItemManualAdjustmentSource = PayLineItemSource & {
   __typename: 'PayLineItemManualAdjustmentSource',
  type: PayComponentType,
  payAmount: MonetaryAmount,
};

export type PayLineItemOrderDetails = {
   __typename: 'PayLineItemOrderDetails',
  consumer: User,
  totalAmount: MonetaryAmount,
  orderTitle: Scalars['String'],
  orderNumber?: Maybe<Scalars['String']>,
};

export type PayLineItemQualityConversationSource = PayLineItemSource & {
   __typename: 'PayLineItemQualityConversationSource',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  rule: PayComponentQualityConversationRule,
  leadId: Scalars['LeadId'],
  lead: Lead,
  leadDetails: PayLineItemLeadDetails,
};

export type PayLineItemReferralFirstOrderSource = PayLineItemSource & {
   __typename: 'PayLineItemReferralFirstOrderSource',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  rule: PayComponentReferralFirstOrderRule,
  orderId: Scalars['OrderId'],
  order: Order,
  orderDetails: PayLineItemOrderDetails,
};

export enum PayLineItemSortField {
  PAY_COMPONENT_TYPE = 'PAY_COMPONENT_TYPE',
  POSTED_AT = 'POSTED_AT',
  AMOUNT = 'AMOUNT'
}

export type PayLineItemSortInput = {
  field: PayLineItemSortField,
  ascending: Scalars['Boolean'],
};

export type PayLineItemSource = {
  type: PayComponentType,
  payAmount: MonetaryAmount,
};

export type PayLineItemsPagination = {
   __typename: 'PayLineItemsPagination',
  count: Scalars['Long'],
  lineItems: Array<PayLineItem>,
};

export type PayLineItemTipSource = PayLineItemSource & {
   __typename: 'PayLineItemTipSource',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  rule: PayComponentTipRule,
  orderId: Scalars['OrderId'],
  order: Order,
  orderDetails: PayLineItemOrderDetails,
};

export type Payment3DSecure = PaymentEntity & {
   __typename: 'Payment3DSecure',
  paymentMethod: PaymentMethod,
  threeDSecureSourceId: Scalars['String'],
  authenticated: Scalars['Boolean'],
};

export enum PaymentActivityType {
  FULL_PAYMENT = 'FULL_PAYMENT',
  DEPOSIT = 'DEPOSIT',
  REMAINING_BALANCE = 'REMAINING_BALANCE'
}

/** 
 * Only saving minimal non PII information to avoid PCI compliance
 * https://www.pcisecuritystandards.org/pdfs/pci_fs_data_storage.pdf
 **/
export type PaymentCard = PaymentEntity & {
   __typename: 'PaymentCard',
  paymentMethod: PaymentMethod,
  last4: Scalars['String'],
  /** Ex: Visa, Mastercard etc */
  brand?: Maybe<Scalars['String']>,
  /** 2 digit number representing the card’s expiration month. */
  expiryMonth?: Maybe<Scalars['Int']>,
  /** 4 digit number representing the card’s expiration year. */
  expiryYear?: Maybe<Scalars['Int']>,
  addressZipCheckStatus?: Maybe<CardFieldValidationStatus>,
  cvcCheckStatus?: Maybe<CardFieldValidationStatus>,
  cardFundingType?: Maybe<CardFundingType>,
  country?: Maybe<Scalars['String']>,
  threeDSecureVerificationRequired?: Maybe<Scalars['Boolean']>,
  threeDSecureVerification?: Maybe<ThreeDSecureVerification>,
};

/** The payment entity represents the asset associated the payment method used for the transaction */
export type PaymentEntity = {
  paymentMethod: PaymentMethod,
};

export enum PaymentMethod {
  CARD = 'CARD',
  PAYPAL = 'PAYPAL',
  THREE_D_SECURE = 'THREE_D_SECURE',
  APPLE_PAY = 'APPLE_PAY',
  ANDROID_PAY = 'ANDROID_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  PAY_BY_INSTALLMENT = 'PAY_BY_INSTALLMENT',
  WIRE_TRANSFER = 'WIRE_TRANSFER',
  BANK_CHECK = 'BANK_CHECK'
}

export type PaymentProcessorAccount = {
  id: Scalars['PaymentProcessorAccountId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  type: PaymentProcessorType,
  userId: Scalars['UserId'],
  paymentSources?: Maybe<Array<PaymentSource>>,
};


export enum PaymentProcessorType {
  STRIPE = 'STRIPE',
  PAYPAL = 'PAYPAL',
  AFTERPAY = 'AFTERPAY',
  AFFIRM = 'AFFIRM',
  DEAL = 'DEAL'
}

export type PaymentRedirectUrls = {
  /** Url Path without the scheme and domain where the payer will be redirected to after approving the payment */
  paymentApprovedReturnUrlPath: Scalars['String'],
  /** Url Path without the scheme and domain where the payer will be redirected to after canceling the payment */
  paymentCanceledReturnUrlPath: Scalars['String'],
};

/** Abstraction for payment sources like Stripe, Paypal, ACH etc. */
export type PaymentSource = {
  id: Scalars['PaymentSourceId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  externalSourceId: Scalars['String'],
  type: PaymentProcessorType,
  usage: PaymentSourceUsage,
  status: PaymentSourceStatus,
  userId: Scalars['UserId'],
  billingAddress?: Maybe<Address>,
  paymentEntity: PaymentEntity,
  isDefault: Scalars['Boolean'],
};


export enum PaymentSourceStatus {
  /** indicates the source is archived, for ex: on expiry, account closure, deleting previously saved card */
  ARCHIVED = 'ARCHIVED',
  CANCELED = 'CANCELED',
  /** Only chargeable Source can be used to create a charge */
  CHARGEABLE = 'CHARGEABLE',
  /** This indicates an older Source that is now detached from the user. */
  CONSUMED = 'CONSUMED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

/** 
 * Whether this source should be reusable or not. Some source types may or may not be reusable by construction,
 * while other may leave the option at creation. If an incompatible value is passed, an error will be returned.
 **/
export enum PaymentSourceUsage {
  REUSABLE = 'REUSABLE',
  SINGLE_USE = 'SINGLE_USE'
}

export enum PaymentVerificationMethod {
  CODE = 'CODE',
  AMOUNT = 'AMOUNT'
}

export type Payout = {
   __typename: 'Payout',
  id: Scalars['PayoutId'],
  state: PayoutState,
  period: PayPeriod,
  payee: BusinessUser,
  department: Department,
  totalAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
  components: Array<PayComponentSummary>,
  lastComputedAt?: Maybe<Scalars['Date']>,
};

export type PayoutFilters = {
  state?: Maybe<PayoutState>,
  expertId?: Maybe<Scalars['BusinessUserId']>,
  departmentId?: Maybe<Scalars['DepartmentId']>,
  payDate?: Maybe<Scalars['Date']>,
};


export type PayoutRollupSummary = {
   __typename: 'PayoutRollupSummary',
  payoutCount: Scalars['Int'],
  totalAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
  components: Array<PayComponentSummary>,
};

export enum PayoutSortField {
  POSTED_AT = 'POSTED_AT',
  TOTAL_AMOUNT = 'TOTAL_AMOUNT',
  COMMISSION_AMOUNT = 'COMMISSION_AMOUNT',
  QUALITY_CONVERSATION_AMOUNT = 'QUALITY_CONVERSATION_AMOUNT',
  TIP_AMOUNT = 'TIP_AMOUNT',
  FIRST_SHIFTS_GUARANTEED_PAY_AMOUNT = 'FIRST_SHIFTS_GUARANTEED_PAY_AMOUNT',
  HOURLY_ON_CALL_AMOUNT = 'HOURLY_ON_CALL_AMOUNT',
  MANUAL_ADJUSTMENT_AMOUNT = 'MANUAL_ADJUSTMENT_AMOUNT'
}

export type PayoutSortInput = {
  field: PayoutSortField,
  ascending: Scalars['Boolean'],
};

export type PayoutsPagination = {
   __typename: 'PayoutsPagination',
  payouts: Array<Payout>,
  rollupSummary: PayoutRollupSummary,
};

export enum PayoutState {
  CREATED = 'CREATED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  ERROR = 'ERROR',
  PAID = 'PAID',
  ARCHIVED = 'ARCHIVED'
}

export type PaypalAccount = PaymentProcessorAccount & {
   __typename: 'PaypalAccount',
  id: Scalars['PaymentProcessorAccountId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  type: PaymentProcessorType,
  userId: Scalars['UserId'],
  paymentSources?: Maybe<Array<PaymentSource>>,
  externalAccountId?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
};

export type PaypalPaymentEntity = PaymentEntity & {
   __typename: 'PaypalPaymentEntity',
  paymentMethod: PaymentMethod,
  payerId: Scalars['String'],
};

export type PaypalPaymentSource = PaymentSource & {
   __typename: 'PaypalPaymentSource',
  id: Scalars['PaymentSourceId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  externalSourceId: Scalars['String'],
  type: PaymentProcessorType,
  usage: PaymentSourceUsage,
  status: PaymentSourceStatus,
  userId: Scalars['UserId'],
  billingAddress?: Maybe<Address>,
  paymentEntity: PaymentEntity,
  isDefault: Scalars['Boolean'],
  /** PayPal specific attributes */
  paymentId: Scalars['String'],
};

export type PayPeriod = {
   __typename: 'PayPeriod',
  startInclusive: Scalars['Date'],
  endInclusive: Scalars['Date'],
};

export type PayStructure = {
   __typename: 'PayStructure',
  id: Scalars['PayStructureId'],
  department: Department,
  name: Scalars['String'],
  description: Scalars['String'],
  isDefault: Scalars['Boolean'],
  revisions: Array<PayStructureRevision>,
};

export type PayStructureFilters = {
  name?: Maybe<Scalars['String']>,
  departmentId?: Maybe<Scalars['DepartmentId']>,
  defaultOnly?: Maybe<Scalars['Boolean']>,
};


export type PayStructureRevision = {
   __typename: 'PayStructureRevision',
  id: Scalars['PayStructureRevisionId'],
  payStructure: PayStructure,
  createdAt: Scalars['Date'],
  effectiveAt?: Maybe<Scalars['Date']>,
  state: PayStructureRevisionState,
  components: Array<PayComponentRule>,
};


export enum PayStructureRevisionState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  DEACTIVATED = 'DEACTIVATED'
}

export type PayStructuresPagination = {
   __typename: 'PayStructuresPagination',
  payStructures: Array<PayStructure>,
  count: Scalars['Long'],
};

export type PendingAccessContact = {
   __typename: 'PendingAccessContact',
  id: Scalars['PendingAccessContactId'],
  contact: Contact,
  interest: Scalars['String'],
  verificationUrl: Scalars['String'],
  user?: Maybe<User>,
};


/** Percent off individual line items that meet the `Promotion.rules` criteria */
export type PercentOffLineItemsPromotionActionReference = PromotionActionReference & {
   __typename: 'PercentOffLineItemsPromotionActionReference',
  id: Scalars['PromotionActionReferenceId'],
  type: PromotionActionType,
  /** Between 1 and 100 */
  percentOff: Scalars['Int'],
  /** 
 * If present and percent off provides a discount greater than this maximum, this fixed amount is instead applied
   * proportionally to the line items that meet the `Promotion.rules` criteria (the same semantics as AmountOff).
 **/
  maximumAmountOff?: Maybe<MonetaryAmount>,
};

/** See `PercentOffLineItemsPromotionActionReference` for documentation */
export type PercentOffLineItemsPromotionActionReferenceInput = {
  percentOff: Scalars['Int'],
  maximumAmountOff?: Maybe<MonetaryAmountInput>,
};

/** 
 * =============
 * this is used in biz-app, we should migrate to BusinessUserPermission
 * =============
 **/
export enum Permission {
  UI_OVERWRITE_SELLABLE_PRICE = 'UI_OVERWRITE_SELLABLE_PRICE',
  UI_ON_CALL_EXPERT = 'UI_ON_CALL_EXPERT',
  UI_ACCEPT_NEW_LEAD = 'UI_ACCEPT_NEW_LEAD'
}

export type PersistMediaInput = {
  id: Scalars['MediaId'],
};

export type PersistMediaPayload = {
   __typename: 'PersistMediaPayload',
  mediaFile?: Maybe<MediaFile>,
};

export type PhoneCallSummary = {
   __typename: 'PhoneCallSummary',
  consumerLastCalledAt?: Maybe<Scalars['Date']>,
  consumerCallCount: Scalars['Int'],
};

export type PhoneExplanationModalMetadata = PathFlowPageMetadata & {
   __typename: 'PhoneExplanationModalMetadata',
  type: PathFlowPageMetadataType,
};

export type PickupTicketInput = {
  ticketId: Scalars['TicketId'],
};

export type PiplAddress = {
   __typename: 'PiplAddress',
  streetNumber?: Maybe<Scalars['String']>,
  apartment?: Maybe<Scalars['String']>,
  street?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  countryCode?: Maybe<Scalars['String']>,
  zipCode?: Maybe<Scalars['String']>,
  postOfficeBox?: Maybe<Scalars['String']>,
};

export type PiplEducation = {
   __typename: 'PiplEducation',
  degree?: Maybe<Scalars['String']>,
  school?: Maybe<Scalars['String']>,
  duration?: Maybe<DateRange>,
};

export type PiplName = {
   __typename: 'PiplName',
  firstName?: Maybe<Scalars['String']>,
  middleName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  suffix?: Maybe<Scalars['String']>,
  prefix?: Maybe<Scalars['String']>,
  fullName?: Maybe<Scalars['String']>,
};

export type PiplPosition = {
   __typename: 'PiplPosition',
  title?: Maybe<Scalars['String']>,
  company?: Maybe<Scalars['String']>,
  industry?: Maybe<Scalars['String']>,
  duration?: Maybe<DateRange>,
};

export type PiplProfile = ExternalProfile & {
   __typename: 'PiplProfile',
  id: Scalars['String'],
  type: ExternalProfileType,
  names: Array<PiplName>,
  emails: Array<Scalars['String']>,
  phoneNumbers: Array<Scalars['String']>,
  gender?: Maybe<Scalars['String']>,
  addresses: Array<PiplAddress>,
  links: Array<Scalars['String']>,
  imageUrls: Array<Scalars['String']>,
  dateOfBirth?: Maybe<DateRange>,
  positions: Array<PiplPosition>,
  educations: Array<PiplEducation>,
};

export type PixelFiredEvent = {
   __typename: 'PixelFiredEvent',
  adPlatform: Scalars['String'],
  firedAt: Scalars['Date'],
};

export type PlaceOrderForOfferInput = {
  offerId: Scalars['BroadcastOfferId'],
  chargeInfos: Array<ChargeInfoInput>,
  tip?: Maybe<MonetaryAmountInput>,
  shippingAddress?: Maybe<AddressInput>,
  /** @deprecated moved to ChargeInfoInput */
  billingAddress?: Maybe<AddressInput>,
  serviceConfirmedTime?: Maybe<Scalars['Date']>,
};

export type PlaceOrderForOfferPayload = {
   __typename: 'PlaceOrderForOfferPayload',
  offer?: Maybe<BroadcastOffer>,
  /** string explaining reason for failure if any */
  error?: Maybe<Scalars['String']>,
};

export type PopularExpertCuratedItem = {
   __typename: 'PopularExpertCuratedItem',
  sellable: Sellable,
  recommendedForSellable: Sellable,
  category: Category,
  timesRecommended?: Maybe<Scalars['Int']>,
  popularTag?: Maybe<ExpertCuratedItemTag>,
};

export type PopularExpertCuratedItemConnection = {
   __typename: 'PopularExpertCuratedItemConnection',
  edges: Array<PopularExpertCuratedItemEdge>,
  pageInfo: PageInfo,
};

export type PopularExpertCuratedItemEdge = {
   __typename: 'PopularExpertCuratedItemEdge',
  node: PopularExpertCuratedItem,
  cursor: Scalars['String'],
};

export type PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource = SystemCuratedItemSource & {
   __typename: 'PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource',
  type?: Maybe<SystemCuratedItemType>,
  expertCuratedItem: ExpertCuratedItem,
  dealRequest: DealRequest,
};

export type PopularExpertCuratedItemQueryInput = {
  /** @deprecated use sellableIds */
  sellableId?: Maybe<Scalars['SellableId']>,
  /** TODO: Make sellableIds required after deprecating sellableId */
  sellableIds?: Maybe<Array<Scalars['SellableId']>>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  includeCuratedItemTag?: Maybe<Scalars['Boolean']>,
  filters?: Maybe<Array<SuggestedSellableFilter>>,
};

/** 
 * PostalAddress was used for embedding address data in the User and Merchant objects but unless absolutely needed
 * prefer the Address object, which allows reusability
 **/
export type PostalAddress = AddressFields & {
   __typename: 'PostalAddress',
  addresseeName?: Maybe<Scalars['String']>,
  businessName?: Maybe<Scalars['String']>,
  line1?: Maybe<Scalars['String']>,
  line2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  countryDetails?: Maybe<Country>,
  postalCode: Scalars['String'],
  phoneNumber?: Maybe<Scalars['String']>,
  parsedPhoneNumber?: Maybe<ParsedPhoneNumber>,
  displayTitle?: Maybe<Scalars['String']>,
};


/** 
 * PostalAddress was used for embedding address data in the User and Merchant objects but unless absolutely needed
 * prefer the Address object, which allows reusability
 **/
export type PostalAddressDisplayTitleArgs = {
  displayType?: Maybe<PostalAddressLocationDisplayType>
};

export type PostalAddressInput = {
  addresseeName?: Maybe<Scalars['String']>,
  businessName?: Maybe<Scalars['String']>,
  line1?: Maybe<Scalars['String']>,
  line2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  country: Scalars['String'],
  postalCode: Scalars['String'],
  phoneNumber?: Maybe<Scalars['String']>,
};

export enum PostalAddressLocationDisplayType {
  CITY_STATE = 'CITY_STATE'
}

export type PostCartOrderActivity = {
   __typename: 'PostCartOrderActivity',
  id: Scalars['PostCartOrderActivityId'],
  updatedAt: Scalars['Date'],
  createdAt: Scalars['Date'],
  orderId: Scalars['OrderId'],
  orderLineItemId?: Maybe<Scalars['OrderLineItemId']>,
  occurredAt: Scalars['Date'],
  detail: OrderActivityDetail,
};


export type PredictedLifeTimeValue = {
   __typename: 'PredictedLifeTimeValue',
  id: Scalars['PredictedLifeTimeValueId'],
  userId: Scalars['UserId'],
  ltvType: LtvType,
  pLTV: MonetaryAmount,
  pixelFiredEvents: Array<PixelFiredEvent>,
};


export enum PresenceStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION',
  SMS = 'SMS'
}

export enum ProductCondition {
  NEW = 'NEW',
  EXCELLENT = 'EXCELLENT',
  GOOD = 'GOOD',
  FAIR = 'FAIR'
}

export type ProductDealTerms = {
   __typename: 'ProductDealTerms',
  type: DealTermsType,
  condition: ProductCondition,
  returnPolicy: ReturnPolicy,
  shippingPolicy: ShippingPolicy,
  pickupAvailable: Scalars['Boolean'],
};

export type ProductOfferTerms = {
   __typename: 'ProductOfferTerms',
  condition: ProductCondition,
  shippingCost?: Maybe<Money>,
  returnPolicy?: Maybe<ReturnPolicy>,
  shippingAvailable: Scalars['Boolean'],
  pickupAvailable: Scalars['Boolean'],
};

export type ProductOfferTermsInput = {
  condition: ProductCondition,
  shippingCost?: Maybe<Scalars['Float']>,
  shippingAvailable: Scalars['Boolean'],
  pickupAvailable: Scalars['Boolean'],
  returnPolicyType?: Maybe<ReturnPolicyType>,
  refundMethod?: Maybe<ReturnRefundMethod>,
  returnWithinDays?: Maybe<Scalars['Int']>,
  returnShippingPaidBy?: Maybe<ReturnShippingPaidBy>,
};

export enum ProductReturnDestination {
  WAREHOUSE = 'WAREHOUSE',
  MERCHANT = 'MERCHANT',
  OFFICE = 'OFFICE'
}

export type ProductReturnTicket = TicketDetail & {
   __typename: 'ProductReturnTicket',
  type: TicketType,
  order: Order,
  orderRefund: OrderRefund,
  merchant?: Maybe<Merchant>,
  returnDestination: ProductReturnDestination,
  shippingLabelSentToConsumerAt?: Maybe<Scalars['Date']>,
  lastCheckedLabelFromMerchantAt?: Maybe<Scalars['Date']>,
};

export type ProfileHighlight = {
   __typename: 'ProfileHighlight',
  type: ProfileHighlightType,
  value: Scalars['String'],
  secondaryValue: Scalars['String'],
};

export enum ProfileHighlightIconType {
  BEER = 'BEER',
  CAKE = 'CAKE',
  CALENDAR = 'CALENDAR',
  CHAT = 'CHAT',
  CHECK = 'CHECK',
  COCKTAIL = 'COCKTAIL',
  DRINK = 'DRINK',
  GOLF_CLUB = 'GOLF_CLUB',
  GOLF_CLUB_SET = 'GOLF_CLUB_SET',
  GOLF_COURSE = 'GOLF_COURSE',
  HEART = 'HEART',
  LOCATION = 'LOCATION',
  DIPLOMA = 'DIPLOMA',
  SKIER = 'SKIER',
  SNOWBOARDER = 'SNOWBOARDER',
  MOUNTAIN = 'MOUNTAIN',
  SNOWFLAKE = 'SNOWFLAKE',
  SMILE = 'SMILE',
  STAR = 'STAR'
}

export type ProfileHighlightInput = {
  typeId: Scalars['ProfileHighlightTypeId'],
  value: Scalars['String'],
  secondaryValue?: Maybe<Scalars['String']>,
};

export enum ProfileHighlightSource {
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}

export type ProfileHighlightType = {
   __typename: 'ProfileHighlightType',
  id: Scalars['ProfileHighlightTypeId'],
  displayName: Scalars['String'],
  icon: ProfileHighlightIconType,
  source: ProfileHighlightSource,
  valueType: ProfileHighlightValueType,
  enumerationValues?: Maybe<Array<Scalars['String']>>,
  placeHolderForValue?: Maybe<Scalars['String']>,
  placeHolderForSecondaryValue?: Maybe<Scalars['String']>,
  secondaryValueRequired: Scalars['Boolean'],
};


export enum ProfileHighlightValueType {
  TEXT = 'TEXT',
  ENUMERATION = 'ENUMERATION',
  DATE = 'DATE'
}

export type Promotion = {
   __typename: 'Promotion',
  id: Scalars['PromotionId'],
  createdAt: Scalars['Date'],
  createdBy: PromotionCreator,
  /** The time at which the promotion entered `ACTIVE` state */
  activatedAt?: Maybe<Scalars['Date']>,
  /** Promotion the operator copied to create this promotion, if any */
  copiedFrom?: Maybe<Promotion>,
  /** If `state==DISABLED`, information about why/when/who. */
  disabled?: Maybe<PromotionDisabled>,
  /** De-normalized flag, the same as `state==ACTIVE` */
  active: Scalars['Boolean'],
  state: PromotionState,
  /** 
 * Promotion code used by consumers to expectedReference the promotion.
   * There is a unique constraint where there can only be one active promotion that uses this code. Many disabled
   * promotions can expectedReference this code (can be viewed as a log of promotion history).
   * While this code is stored and displayed as case sensitive, searching for this code, as well as the unique index
   * for active promotion codes, are both **case insensitive**. So while this can store and display case sensitive
   * values like "BigGolfSale", searching for "biggolfsale" or "BIGGOLFSALE" will locate the same document, and
   * similarly, multiple active codes that only vary by case are not allowed.
 **/
  code: Scalars['String'],
  /** Description of this promotion */
  description: Scalars['String'],
  /** 
 * Rules run in sequence, filtering down line items in the order that are eligible for the promotion. For example,
   * the 3 rules:
   * - Line item amount over $500
   * - Sellables in Golf category
   * - Line item amount over $100
   * Means, apply the promotion if the order has over $500 of value, and has sellables in the golf category, and those
   * sellables in the golf category are worth at least $100.
   * If all rules are evaluated and all line items are filtered out, the promotion will not be applied to the order.
 **/
  rules: Array<PromotionRuleReference>,
  /** 
 * Actions to the remaining line items that aren't filtered. These are processed in order, using the result of the
   * previous promotion. For example, if there's a 5% off action, and then a 10% off action, the 5% will be taken off,
   * and then the 10% will be computed from the 5% off amount - not the original total.
 **/
  actions: Array<PromotionActionReference>,
  /** If set, this promotion will be automatically disabled when usages meet or exceeds this limit. */
  usageLimit?: Maybe<Scalars['Int']>,
  /** The amount of paid orders that had this promotion code applied */
  usages: Scalars['Int'],
  /** If set, the date this promotion will disable its self */
  expiresAt?: Maybe<Scalars['Date']>,
  /** Indicates this is a template promotion that is used to create other promotions. */
  template: Scalars['Boolean'],
  /** Indicates this promotion is automatically generated, typically from a template, and not manually created. */
  autoGenerated: Scalars['Boolean'],
};

export type PromotionActionReference = {
  id: Scalars['PromotionActionReferenceId'],
  type: PromotionActionType,
};


/** Exploded union of `PromotionActionReference` types; exactly one must be non null */
export type PromotionActionReferenceInput = {
  percentOffLineItems?: Maybe<PercentOffLineItemsPromotionActionReferenceInput>,
  amountOffOrder?: Maybe<AmountOffOrderPromotionActionReferenceInput>,
};

export enum PromotionActionType {
  PERCENT_OFF_LINE_ITEMS = 'PERCENT_OFF_LINE_ITEMS',
  AMOUNT_OFF_ORDER = 'AMOUNT_OFF_ORDER'
}

export type PromotionCreator = Operator | User;

export type PromotionDisabled = {
   __typename: 'PromotionDisabled',
  /** If null, disabled by the system (will be the case for expired and reached usage limit) */
  by?: Maybe<Operator>,
  at: Scalars['Date'],
  reason: PromotionDisabledReason,
};

export enum PromotionDisabledReason {
  MANUAL = 'MANUAL',
  REPLACED = 'REPLACED',
  EXPIRED = 'EXPIRED',
  REACHED_USAGE_LIMIT = 'REACHED_USAGE_LIMIT'
}

export type PromotionEdge = {
   __typename: 'PromotionEdge',
  node: Promotion,
  cursor: Scalars['String'],
};


export enum PromotionQueryFlagType {
  /** Surface items including items with this flag set */
  INCLUDE = 'INCLUDE',
  /** Only surface items with this flag set */
  ONLY = 'ONLY',
  /** Exclude items with this flag set */
  NONE = 'NONE'
}

export type PromotionQueryInput = {
  createdById?: Maybe<Scalars['AnyId']>,
  /** Defaults to `[ACTIVE]` */
  states?: Maybe<Array<PromotionState>>,
  /** 
 * Case insensitive search for a specific promotion code.
   * If `states=[ACTIVE]` (the default), this will return exactly 0 or 1 entries since there can be at most 1 active
   * promotion for a given code. If searching disabled or draft, you'll also retrieve the previous promotions that used
   * this same code.
 **/
  promotionCode?: Maybe<Scalars['String']>,
  /** Defaults to `INCLUDE` */
  template?: Maybe<PromotionQueryFlagType>,
  /** Defaults to `NONE` */
  autoGenerated?: Maybe<PromotionQueryFlagType>,
  source?: Maybe<PromotionSourceQueryInput>,
  createdForId?: Maybe<Scalars['UserId']>,
};

export enum PromotionRuleComparisonOperator {
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  EQUAL = 'EQUAL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL'
}

export enum PromotionRuleFilterStrategy {
  /** 
 * Filtering reduces the scope of the promotion actions. For example, if the rule is to `FILTER` for sellables in
   * the snowboard category, a subsequent promotion action to take 10% off will only take 10% off of the sellables
   * in the snowboard category - not other items in the cart. If no line items fall into the filter criteria, the
   * promotion will not be applied to the order.
 **/
  FILTER = 'FILTER',
  /** 
 * Excluding forces the promotion to not be the order if any of its criteria are met. For example, if the rule is
   * to `EXCLUDE` sellable X, any order with sellable X will not be eligible for the promotion.
 **/
  EXCLUDE = 'EXCLUDE'
}

export type PromotionRuleReference = {
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
};


/** 
 * Exploded union of `PromotionRuleReference` types; exactly one must be non null
 * See `PromotionRuleReference` sub-types for documentation
 **/
export type PromotionRuleReferenceInput = {
  orderAmount?: Maybe<OrderAmountPromotionRuleReferenceInput>,
  sellableFilter?: Maybe<SellableFilterPromotionRuleReferenceInput>,
  sellableCategoryFilter?: Maybe<SellableCategoryFilterPromotionRuleReferenceInput>,
  sellableBrandFilter?: Maybe<SellableBrandFilterPromotionRuleReferenceInput>,
  sellableAttributeFilter?: Maybe<SellableAttributeFilterPromotionRuleReferenceInput>,
  purchaseOrderCount?: Maybe<PurchasedOrderCountPromotionRuleReferenceInput>,
  userUsageLimit?: Maybe<UserUsageLimitPromotionRuleReferenceInput>,
};

export enum PromotionRuleType {
  ORDER_AMOUNT = 'ORDER_AMOUNT',
  SELLABLE_FILTER = 'SELLABLE_FILTER',
  SELLABLE_CATEGORY_FILTER = 'SELLABLE_CATEGORY_FILTER',
  SELLABLE_BRAND_FILTER = 'SELLABLE_BRAND_FILTER',
  SELLABLE_ATTRIBUTE_FILTER = 'SELLABLE_ATTRIBUTE_FILTER',
  PURCHASED_ORDER_COUNT = 'PURCHASED_ORDER_COUNT',
  USER_USAGE_LIMIT = 'USER_USAGE_LIMIT'
}

export type PromotionsConnection = {
   __typename: 'PromotionsConnection',
  edges: Array<PromotionEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export type PromotionSourceQueryInput = {
  type: PromotionSourceType,
};

export enum PromotionSourceType {
  REFERRER = 'REFERRER',
  REFEREE = 'REFEREE'
}

export type PromotionsPagination = {
   __typename: 'PromotionsPagination',
  promotions: Array<Promotion>,
  count: Scalars['Long'],
};

export enum PromotionState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED'
}

export type PublishTemplateFragmentInput = {
  id: Scalars['CommTemplateFragmentId'],
  notes?: Maybe<Scalars['String']>,
};

export type PublishTemplateInput = {
  id: Scalars['CommTemplateId'],
  notes?: Maybe<Scalars['String']>,
};

export type PublishTriggerInput = {
  triggerId: Scalars['TriggerId'],
  notes?: Maybe<Scalars['String']>,
};

export type PublishTriggerPayload = {
   __typename: 'PublishTriggerPayload',
  errors: Array<Scalars['String']>,
  trigger: Trigger,
};

/** Compare against the total amount of purchased orders made by the user */
export type PurchasedOrderCountPromotionRuleReference = PromotionRuleReference & {
   __typename: 'PurchasedOrderCountPromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
  operator: PromotionRuleComparisonOperator,
  /** Right hand side amount, in respect to `operator`. Left hand side is the purchase count. */
  rightOperandCount: Scalars['Int'],
};

/** See `PurchasedOrderCountPromotionRuleReference` for documentation */
export type PurchasedOrderCountPromotionRuleReferenceInput = {
  operator: PromotionRuleComparisonOperator,
  rightOperandCount: Scalars['Int'],
};

export type PushNotificationTemplate = ChannelTemplate & {
   __typename: 'PushNotificationTemplate',
  channelType: ChannelType,
  title: Scalars['String'],
  body: Scalars['String'],
};

export type PushNotificationTemplateInput = {
  title: Scalars['String'],
  body: Scalars['String'],
};

export type QualityConversationEstablishedActivity = LeadActivity & {
   __typename: 'QualityConversationEstablishedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  performedBy: Identity,
};

export type Query = {
   __typename: 'Query',
  health: Scalars['String'],
  savedAddresses: Array<Address>,
  /** 
 * categoryIds: Retrieve attributes associated with these categories
   * entityType: Entity type of typed urn we want attribute data for. This influences what types of validations are provided.
   * includeChildCategories: If true, attributes associated with sub-categories of categoryIds are also retrieved. For
   *   example, if the "Services" category is specified, this would also return attributes for specific services like
   *   massage and nails.
   * includeParentCategories: If true, attributes associated with super-categories of categoryIds are also retrieved.
   *   For example, if the "Massages" is specified, this would also return attributes bound to the general "Services"
   *   attribute.
   * first: Retrieve the first N categories in the filter criteria. See Relay Connection spec for more information.
   * after: Retrieve categories after a AttributeSchemasByCategoryEdge.cursor value. Used for pagination.
   *   See Relay Connection spec for more information.
 **/
  attributeSchemasByCategories?: Maybe<AttributeSchemasByCategoriesConnection>,
  /** Retrieve attribute schemas by name */
  attributeSchemasByName: Array<AttributeSchema>,
  session: Session,
  maskedHandle: MaskedUserHandle,
  maskedHandlesByLoginToken: Array<MaskedUserHandle>,
  /** 
 * categoryTypes: Retrieve categories only under these master category types
   * first: Retrieve the first N categories in the filter criteria. See Relay Connection spec for more information.
   * after: Retrieve categories after a AttributeSchemasByCategoryEdge.cursor value. Used for pagination.
   *   See Relay Connection spec for more information.
 **/
  categories: CategoriesConnection,
  topLevelCategories: Array<Category>,
  category: Category,
  categoryBySlug?: Maybe<Category>,
  allPathCategories: Array<Category>,
  /** 
 * Finds the first category in the hierarchy tree of the Category identified by specified slug, if present.
   * The category tree is traversed parents first and then children
 **/
  departments: Array<Department>,
  departmentsForNavigation: Array<Department>,
  department: Department,
  departmentBySlug?: Maybe<Department>,
  commTemplate: MultiLocaleTemplateSet,
  commTemplates: Array<MultiLocaleTemplateSet>,
  commTemplateVersionHistory: Array<MultiLocaleTemplateSet>,
  commTemplateTypes?: Maybe<Array<CommTemplateType>>,
  commTemplateType: CommTemplateType,
  renderCommTemplate: RenderCommTemplatePayload,
  commTemplateDataModel: CommTemplateDataModelPayload,
  commTemplateFragment: CommTemplateFragment,
  commTemplateFragments: Array<CommTemplateFragment>,
  commTemplateFragmentVersionHistory: Array<CommTemplateFragment>,
  commTemplateDirectives: Array<CommTemplateDirective>,
  dealRequest?: Maybe<DealRequest>,
  findDealRequests: Array<DealRequest>,
  me?: Maybe<Myself>,
  findContact?: Maybe<Contact>,
  user: User,
  userByContact?: Maybe<User>,
  usersByContact: Array<User>,
  merchant: Merchant,
  suggestMerchants: MerchantSuggestionResult,
  searchMerchants: MerchantSearchResult,
  searchUsers: UserSearchResult,
  operators: Array<Operator>,
  pendingAccessContact: PendingAccessContact,
  awayAutoReply: AwayAutoReply,
  businessUser: BusinessUser,
  businessUsers: Array<Maybe<BusinessUser>>,
  experts: Array<BusinessUser>,
  businessAccount: BusinessAccount,
  businessAccounts: Array<BusinessAccount>,
  businessUserTeam: BusinessUserTeam,
  devTools?: Maybe<DevTools>,
  conversation: Conversation,
  conversationByExternalId?: Maybe<Conversation>,
  activeVideoChatConversations: Array<Conversation>,
  messagingUsers: Array<MessagingUser>,
  callActivityConnection: CallActivityConnection,
  guestConversationSequence: GuestConversationSequence,
  findGuestConversationSequences: Array<GuestConversationSequence>,
  pathFlow: PathFlowPayload,
  pathFlowPage: PathFlowPagePayload,
  pathFlowBySlug: PathFlowBySlugPayload,
  pathFlowPageBySlugs: PathFlowPagePayload,
  shippingCarriers: Array<ShippingCarrier>,
  paymentSources: Array<Maybe<PaymentSource>>,
  order: Order,
  orderLineItem: OrderLineItem,
  transaction: Transaction,
  findOrders: Array<Order>,
  ordersConnection: OrdersConnection,
  paymentSource: PaymentSource,
  reusablePaymentSources: Array<PaymentSource>,
  /** 
 * If this returns an empty array, it means the recommendation is to not prompt the user to tip since we weren't able
   * to locate a relevant expert that aided the owner of the order. If more than one `ExpertTipPercentage` is returned,
   * it's guaranteed that all `ExpertTipPercentage.percentOfTip` add up to 100. The user can be shown all of the experts
   * returned by this API.
   * Ultimately, the result of this is intended to be used as an input to the `addTipToOrder` mutation. Users of this API
   * are free to modify the percent distribution, or even select different experts for tip distribution.
 **/
  recommendTipPercentagesForOrder: Array<ExpertTipPercentage>,
  promotion: Promotion,
  promotionsConnection: PromotionsConnection,
  promotionsPagination: PromotionsPagination,
  /** 
 * Case insensitive search for a active promotion with promotion code `code`.
   * Convienence API that's equivalent to querying `promotionsConnection` for `state=[ACTIVE]` and this `code`
 **/
  activePromotionByCode?: Maybe<Promotion>,
  /** 
 * Get all shipping costs for a given order. A custom address can be specified to compute shipping cost via
   * `orderShippingCostAddress`, or it can be omitted to compute all shipping cost options for the current order shipping
   * address. A `null` return value means the order doesn't require any shipping.
 **/
  orderShippingCost?: Maybe<OrderShippingCost>,
  tags: Array<Tag>,
  frontendTask: FrontendTask,
  broadcastOffer: BroadcastOffer,
  mediaFile: MediaFile,
  mediaFiles: Array<MediaFile>,
  openGraphData?: Maybe<OpenGraphData>,
  findExpert?: Maybe<BusinessUser>,
  expertProfile: ExpertProfile,
  recommendExpert?: Maybe<BusinessUser>,
  recommendExpert2: RecommendExpertPayload,
  recommendExpertForRequest: RecommendExpertPayload,
  recommendExpertsForPathFlow: Array<RecommendedExpert>,
  recommendExpertsForDepartment: Array<RecommendedExpert>,
  consumerExpertReview: ConsumerExpertReview,
  consumerExpertReviewConnection: ConsumerExpertReviewConnection,
  expertApplication: ExpertApplication,
  expertApplicationsPagination: ExpertApplicationsPagination,
  expertApplicationsConnection: ExpertApplicationsConnection,
  expertApplicationsPendingReview: ExpertApplicationsConnection,
  expertApplicationsPendingApproval: ExpertApplicationsConnection,
  expertApplicationsPendingActivation: ExpertApplicationsConnection,
  expertProfilesPagination: ExpertProfilesPagination,
  expertSearchConnection: ExpertSearchConnection,
  expertApplicationFolderGroups: Array<ExpertApplicationFolderGroup>,
  expertApplicationFolderItems: ExpertApplicationFolderItemsPayload,
  expertTypeahead: ExpertTypeaheadPayload,
  aggregateExpertReport: AggregateExpertReport,
  expertReferral: ExpertReferral,
  expertPerformanceStatistics: ExpertPerformanceStatisticsPayload,
  deal: Deal,
  brands: BrandConnection,
  savedSellable: SavedSellable,
  savedSellablesConnection: SavedSellablesConnection,
  sellable: Sellable,
  findSellable?: Maybe<Sellable>,
  sellables: Array<Sellable>,
  searchSellables: SellableSearchConnection,
  sellableTypeahead: SellableTypeaheadPayload,
  similarSellables: SimilarSellablePayload,
  /** 
 * Use this API to identify find mapping of the supplied SellableSearchFacetsQuery to corresponding facets shown in the
   * sellable search results.
   * This useful for cases where the facets internal representation is unknown to the caller but wants to create
   * a preselected facet input to the sellable search api.
   * Note this only provides a transformation, currently no facets are discovered.
 **/
  sellableSearchFacets: SellableSearchFacetsPayload,
  consumerSellableReactions: ConsumerSellableReactionConnection,
  sellableResearchLink: SellableResearchLink,
  sellableResearchLinks: Array<SellableResearchLink>,
  findSellableResearchLinks: Array<SellableResearchLink>,
  lead?: Maybe<Lead>,
  batchGetLeads: Array<Lead>,
  leadLabels: Array<LeadLabel>,
  leads: LeadSearchConnection,
  findExistingLead?: Maybe<Lead>,
  quickReply: QuickReply,
  quickReplies: Array<QuickReply>,
  expertLeadFolderGroups: Array<ExpertLeadFolderGroup>,
  expertLeadFolderItems: LeadSearchConnection,
  leadEscalation: LeadEscalation,
  predictedLifeTimeValues: Array<PredictedLifeTimeValue>,
  leadSurge: LeadSurge,
  leadCampaign: LeadCampaign,
  leadCampaignRecipient: CampaignRecipient,
  leadCampaigns: Array<LeadCampaign>,
  leadCampaignTargetLeads: Array<Lead>,
  savedSearch: SavedSearch,
  savedSearches: Array<SavedSearch>,
  runSavedSearch: SavedSearchResultConnection,
  runLeadSavedSearch: LeadSearchConnection,
  /** 
 * Find the content object by the template and variation. When preview parameter
   * is null, by default it is for published content
 **/
  findContentByTemplate?: Maybe<ContentObject>,
  /** 
 * For backwards compatibility, if filter is entirely omitted, will default to
   * shippingSupported == true, billingSupported == true
 **/
  countries: Array<Country>,
  country: Country,
  airport: Airport,
  airportTypeahead: AirportTypeaheadPayload,
  report: Report,
  allReports: Array<Report>,
  reportResult: ReportResultPayload,
  expertCuratedItem: ExpertCuratedItem,
  expertCuratedItems: Array<ExpertCuratedItem>,
  expertCuratedItemsForLead: ExpertCuratedItemsForLeadPayload,
  expertCuratedItemActivation: ExpertCuratedItemActivation,
  expertCuratedOrder: ExpertCuratedOrder,
  expertCuratedOrders: Array<ExpertCuratedOrder>,
  expertCuratedOrdersForLeadConnection: ExpertCuratedOrdersForLeadConnection,
  expertCuratedOrderListActivation: ExpertCuratedOrderListActivation,
  expertCuratedOrderListActivations: Array<ExpertCuratedOrderListActivation>,
  expertCuratedOrderListActivationsForLead: ExpertCuratedOrderListActivationConnection,
  expertCuratedLeadItinerary?: Maybe<ExpertCuratedLeadItinerary>,
  /** Get all available curated item tags that can be used, with their display labels */
  defaultExpertCuratedItemTags: Array<ExpertCuratedItemTag>,
  /** Get all available curated item price override reasons that can be used */
  expertCuratedItemPriceOverrideReasons: Array<ExpertCuratedItemPriceOverrideReason>,
  popularExpertCuratedItemsForSellable: PopularExpertCuratedItemConnection,
  /** Get suggested notes for a sellable */
  suggestExpertCuratedItemNotes: SuggestExpertCuratedItemNotesConnection,
  /** Recommendation and search style API to get ExpertCuratedItems recommended by other experts for similar lead */
  suggestExpertCuratedItemsForLead: SuggestExpertCuratedItemsForLeadConnection,
  /** 
 * Recommendation api that suggest similar sellables for the specified query.
   * The recommendations can be a mix of items that were sent as curations to other users or recommendations of sellables
   * based on similarity with other Sellables in our system.
   * This api also deprecates the popularExpertCuratedItemsForSellable api and
   * provides a single unified view for similar sellables
 **/
  suggestedAlternativeSellables: SuggestedAlternativeSellableConnection,
  /** Admin api to search for all SuggestedAlternativeSellable */
  searchSuggestedAlternativeSellables: SuggestedAlternativeSellableConnection,
  departmentExpertCuratedActivityFeed: ExpertCuratedActivityFeedItemConnection,
  expertExpertCuratedActivityFeed: ExpertCuratedActivityFeedItemConnection,
  expertTopRecommendedSellables: ExpertTopRecommendedSellablesPayload,
  expertTopRecommendedBrands: ExpertTopRecommendedBrandsPayload,
  searchRecentExpertCuratedItemGroups: RecentExpertCuratedItemGroupConnection,
  searchSavedExpertCuratedItems: SavedExpertCuratedItemsConnection,
  simpleCuratedOrder: SimpleCuratedOrder,
  expertCuratedItemsForUser: Array<ExpertCuratedItem>,
  searchExpertCuratedItemNotes?: Maybe<SearchExpertCuratedItemNotesPayload>,
  getExpertNoteStatsPagination: ExpertNoteStatsPagination,
  recommendedListsForCategory: RecommendedListConnection,
  recommendedLists: RecommendedListConnection,
  recommendedListDefinition: RecommendedListDefinition,
  recommendedListDefinitions: RecommendedListDefinitionConnection,
  triggerEntities: Array<TriggerEntityMeta>,
  triggerActions: Array<TriggerActionMeta>,
  triggerEvents: Array<TriggerEventMeta>,
  trigger: Trigger,
  triggers: Array<Trigger>,
  validateTrigger: ValidateTriggerPayload,
  triggerVersionHistory: Array<Trigger>,
  eBayItem: EBayItem,
  searchEBayItems: EBayItemSearchConnection,
  matchSellableForEBayItem?: Maybe<Sellable>,
  config: Config,
  configs: Array<Config>,
  configDomains: Array<ConfigDomain>,
  externalAdCampaign: ExternalAdCampaign,
  externalAdCampaignsByCategory: Array<ExternalAdCampaign>,
  externalAdGroup: ExternalAdGroup,
  systemCuratedItemSurvey: SystemCuratedItemSurvey,
  flightPlan: FlightPlan,
  supportTask?: Maybe<SupportTask>,
  supportTasks: Array<SupportTask>,
  findSupportTasks: SupportTasksConnection,
  findSupportTasksForOperatorFolder: SupportTasksConnection,
  supportTaskFoldersForOperator: Array<SupportTaskFolder>,
  orderEscalation: OrderEscalation,
  orderEscalations: OrderEscalationConnection,
  supportConversation?: Maybe<SupportConversation>,
  supportConversationById: SupportConversation,
  supportConversationsConnection: SupportConversationsConnection,
  sellableInventory: SellableInventoryItem,
  payStructure: PayStructure,
  payStructuresPagination: PayStructuresPagination,
  payStructureRevision: PayStructureRevision,
  payoutsPagination: PayoutsPagination,
  payLineItemsPagination: PayLineItemsPagination,
  payout: Payout,
  payPeriods: Array<PayPeriod>,
  rawSellableSource: RawSellableSource,
  exportRawSellableSource: BsonObject,
  rawSellable: RawSellable,
  standardizedSellable: StandardizedSellable,
  standardizedSellableGroup: StandardizedSellableGroup,
  rawSellableStandardizationRule: RawSellableStandardizationRule,
  exportRawSellableStandardizationRule: BsonObject,
  findRawSellables: Array<RawSellable>,
  findRawSellableSources: Array<RawSellableSource>,
  findRawSellableStandardizationRules: Array<RawSellableStandardizationRule>,
  exportRawSellableStandardizationRules: Array<BsonObject>,
  findStandardizedSellables: Array<StandardizedSellable>,
  findStandardizedSellableGroups: Array<StandardizedSellableGroup>,
  rawSellableStandardizationMeta: RawSellableStandardizationMeta,
  findStandardizedSellableGroupCandidates: Array<StandardizedSellableGroupCandidate>,
  fulfillmentCenters: FulfillmentCenterConnection,
  fulfillmentShipmentMethods: FulfillmentShipmentMethodConnection,
  schedulingTypes: Array<SchedulingType>,
  schedulingDepartments: Array<SchedulingDepartment>,
  schedulingType: SchedulingType,
  schedulingUser: SchedulingUser,
  schedulingDemandForecast: SchedulingDemandForecast,
  schedulingDemandForecastDailyView: Array<SchedulingDemandForecastDailyView>,
  schedulingUserAvailability: SchedulingUserAvailability,
  schedulingUserAvailabilityDailyView: Array<SchedulingUserAvailabilityDailyView>,
  shift: Shift,
  shiftDailyView: Array<ShiftDailyView>,
  shiftTeamDailyView: Array<ShiftTeamDailyView>,
  shiftTimeIntervalDailyView: Array<ShiftTimeIntervalDailyView>,
  shiftSlotUserDailyView: Array<ShiftSlotUserDailyView>,
  shiftSlotDailyView: Array<ShiftSlotDailyView>,
  getFulfillmentChannel: FulfillmentChannel,
  findFulfillmentChannels: FulfillmentChannelsConnection,
  getOrderRefund: OrderRefund,
  orderRefundsConnection: OrderRefundsConnection,
  orderRefundsPagination: OrderRefundsPagination,
  ticket: Ticket,
  ticketsConnection: TicketsConnection,
  ticketsPagination: TicketsPagination,
  searchTickets: TicketSearchConnection,
  lookupReferralCode: LookupReferralCodePayload,
  potentialConsumerReferralSources: Array<ReferralCode>,
  expertDirectReferralCode: GetReferralCodePayload,
  referralCodeShare: ReferralCodeShare,
  experimentsUpdatedAfter: ExperimentsUpdatedAfterPayload,
  experiment: ExperimentDefinition,
  experiments: Array<ExperimentDefinition>,
  findExperiments: Array<ExperimentDefinition>,
  bookingsConnection: BookingsConnection,
};


export type QueryAttributeSchemasByCategoriesArgs = {
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  entityType?: Maybe<Scalars['String']>,
  includeChildCategories?: Maybe<Scalars['Boolean']>,
  includeParentCategories?: Maybe<Scalars['Boolean']>,
  first?: Maybe<Scalars['Int']>,
  after?: Maybe<Scalars['String']>
};


export type QueryAttributeSchemasByNameArgs = {
  attributeSchemaNames: Array<Scalars['String']>,
  entityType?: Maybe<Scalars['String']>
};


export type QueryMaskedHandleArgs = {
  id: Scalars['AnyId']
};


export type QueryMaskedHandlesByLoginTokenArgs = {
  loginToken: Scalars['String']
};


export type QueryCategoriesArgs = {
  categoryTypes?: Maybe<Array<Maybe<CategoryType>>>,
  first?: Maybe<Scalars['Int']>,
  after?: Maybe<Scalars['String']>
};


export type QueryCategoryArgs = {
  categoryId: Scalars['CategoryId']
};


export type QueryCategoryBySlugArgs = {
  slug: Scalars['String']
};


export type QueryDepartmentArgs = {
  id: Scalars['DepartmentId']
};


export type QueryDepartmentBySlugArgs = {
  slug: Scalars['String']
};


export type QueryCommTemplateArgs = {
  id: Scalars['CommTemplateId']
};


export type QueryCommTemplatesArgs = {
  filter: CommTemplateFilter
};


export type QueryCommTemplateVersionHistoryArgs = {
  historyId: Scalars['CommTemplateVersionHistoryId']
};


export type QueryCommTemplateTypesArgs = {
  filter?: Maybe<CommTemplateTypeFilter>
};


export type QueryCommTemplateTypeArgs = {
  id: Scalars['CommTemplateTypeId']
};


export type QueryRenderCommTemplateArgs = {
  input: RenderCommTemplateInput
};


export type QueryCommTemplateDataModelArgs = {
  input: CommTemplateDataModelInput
};


export type QueryCommTemplateFragmentArgs = {
  id: Scalars['CommTemplateFragmentId']
};


export type QueryCommTemplateFragmentsArgs = {
  filter: CommTemplateFragmentFilter
};


export type QueryCommTemplateFragmentVersionHistoryArgs = {
  historyId: Scalars['CommTemplateFragmentVersionHistoryId']
};


export type QueryDealRequestArgs = {
  id: Scalars['DealRequestId']
};


export type QueryFindDealRequestsArgs = {
  filters: DealRequestFilter
};


export type QueryFindContactArgs = {
  contactId: Scalars['ContactId']
};


export type QueryUserArgs = {
  userId: Scalars['UserId']
};


export type QueryUserByContactArgs = {
  type: ContactType,
  value: Scalars['String']
};


export type QueryUsersByContactArgs = {
  contacts?: Maybe<Array<Scalars['String']>>
};


export type QueryMerchantArgs = {
  id: Scalars['MerchantId']
};


export type QuerySuggestMerchantsArgs = {
  name: Scalars['String'],
  categoryId?: Maybe<Scalars['CategoryId']>
};


export type QuerySearchMerchantsArgs = {
  query: MerchantSearchQuery,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QuerySearchUsersArgs = {
  query: UserSearchQuery,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryOperatorsArgs = {
  query: OperatorQuery
};


export type QueryPendingAccessContactArgs = {
  id: Scalars['PendingAccessContactId']
};


export type QueryAwayAutoReplyArgs = {
  id: Scalars['AwayAutoReplyId']
};


export type QueryBusinessUserArgs = {
  id: Scalars['BusinessUserId']
};


export type QueryBusinessUsersArgs = {
  ids: Array<Scalars['BusinessUserId']>
};


export type QueryExpertsArgs = {
  includeInactive: Scalars['Boolean']
};


export type QueryBusinessAccountArgs = {
  id: Scalars['BusinessAccountId']
};


export type QueryBusinessUserTeamArgs = {
  id: Scalars['BusinessUserTeamId']
};


export type QueryConversationArgs = {
  id: Scalars['ConversationId']
};


export type QueryConversationByExternalIdArgs = {
  externalId: Scalars['String']
};


export type QueryMessagingUsersArgs = {
  ids: Array<Scalars['AnyId']>
};


export type QueryCallActivityConnectionArgs = {
  input?: Maybe<CallActivityFilterInput>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryGuestConversationSequenceArgs = {
  id: Scalars['GuestConversationSequenceId']
};


export type QueryFindGuestConversationSequencesArgs = {
  query: GuestConversationSequenceQuery
};


export type QueryPathFlowArgs = {
  id: Scalars['PathFlowId']
};


export type QueryPathFlowPageArgs = {
  id: Scalars['PathFlowId'],
  pageSlug: Scalars['String']
};


export type QueryPathFlowBySlugArgs = {
  pathFlowSlug: Scalars['String']
};


export type QueryPathFlowPageBySlugsArgs = {
  pathFlowSlug: Scalars['String'],
  pathFlowPageSlug: Scalars['String']
};


export type QueryShippingCarriersArgs = {
  includeInternal?: Maybe<Scalars['Boolean']>
};


export type QueryOrderArgs = {
  id: Scalars['OrderId']
};


export type QueryOrderLineItemArgs = {
  id: Scalars['OrderLineItemId']
};


export type QueryTransactionArgs = {
  id: Scalars['TransactionId']
};


export type QueryFindOrdersArgs = {
  state?: Maybe<OrderState>,
  fulfillmentState?: Maybe<OrderFulfillmentState>,
  orderLineItemState?: Maybe<OrderLineItemState>,
  userId?: Maybe<Scalars['UserId']>
};


export type QueryOrdersConnectionArgs = {
  query?: Maybe<OrderQuery>,
  sort?: Maybe<OrderSearchSort>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryPaymentSourceArgs = {
  id: Scalars['PaymentSourceId']
};


export type QueryReusablePaymentSourcesArgs = {
  paymentMethod?: Maybe<PaymentMethod>
};


export type QueryRecommendTipPercentagesForOrderArgs = {
  id: Scalars['OrderId']
};


export type QueryPromotionArgs = {
  id: Scalars['PromotionId']
};


export type QueryPromotionsConnectionArgs = {
  query?: Maybe<PromotionQueryInput>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>
};


export type QueryPromotionsPaginationArgs = {
  query?: Maybe<PromotionQueryInput>,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryActivePromotionByCodeArgs = {
  code?: Maybe<Scalars['String']>
};


export type QueryOrderShippingCostArgs = {
  id: Scalars['OrderId'],
  orderShippingCostAddress?: Maybe<OrderShippingCostAddressInput>
};


export type QueryTagsArgs = {
  type: TagType
};


export type QueryFrontendTaskArgs = {
  id: Scalars['FrontendTaskId']
};


export type QueryBroadcastOfferArgs = {
  id: Scalars['BroadcastOfferId']
};


export type QueryMediaFileArgs = {
  id: Scalars['MediaId']
};


export type QueryMediaFilesArgs = {
  ids: Array<Scalars['MediaId']>
};


export type QueryOpenGraphDataArgs = {
  url: Scalars['String']
};


export type QueryFindExpertArgs = {
  vanityIdOrId: Scalars['String']
};


export type QueryExpertProfileArgs = {
  id: Scalars['ExpertProfileId']
};


export type QueryRecommendExpertArgs = {
  consumerId: Scalars['UserId'],
  categoryId: Scalars['CategoryId']
};


export type QueryRecommendExpert2Args = {
  consumerId: Scalars['UserId'],
  categoryId: Scalars['CategoryId']
};


export type QueryRecommendExpertForRequestArgs = {
  requestId: Scalars['DealRequestId']
};


export type QueryRecommendExpertsForPathFlowArgs = {
  pathFlowId: Scalars['PathFlowId'],
  limit?: Maybe<Scalars['Int']>
};


export type QueryRecommendExpertsForDepartmentArgs = {
  departmentId: Scalars['DepartmentId'],
  limit?: Maybe<Scalars['Int']>
};


export type QueryConsumerExpertReviewArgs = {
  id: Scalars['ConsumerExpertReviewId']
};


export type QueryConsumerExpertReviewConnectionArgs = {
  query: ConsumerReviewSearchQuery,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>,
  sortBy?: ConsumerReviewSearchSort
};


export type QueryExpertApplicationArgs = {
  id: Scalars['ExpertApplicationId']
};


export type QueryExpertApplicationsPaginationArgs = {
  query?: Maybe<ExpertApplicationQuery>,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryExpertApplicationsConnectionArgs = {
  query?: Maybe<ExpertApplicationSearchQueryInput>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>,
  sortBy?: Maybe<ExpertApplicationSearchSort>,
  sortDescending?: Maybe<Scalars['Boolean']>
};


export type QueryExpertApplicationsPendingReviewArgs = {
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryExpertApplicationsPendingApprovalArgs = {
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>,
  reviewedOnly?: Maybe<Scalars['Boolean']>
};


export type QueryExpertApplicationsPendingActivationArgs = {
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryExpertProfilesPaginationArgs = {
  query?: Maybe<ExpertProfileQuery>,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryExpertSearchConnectionArgs = {
  query?: Maybe<ExpertSearchQuery>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>,
  sortBy?: Maybe<ExpertSearchSort>
};


export type QueryExpertApplicationFolderItemsArgs = {
  departmentId?: Maybe<Scalars['DepartmentId']>,
  approvedById?: Maybe<Scalars['OperatorId']>,
  folderSlug: Scalars['String'],
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryExpertTypeaheadArgs = {
  query?: Maybe<ExpertTypeaheadQuery>,
  first?: Maybe<Scalars['Int']>
};


export type QueryExpertReferralArgs = {
  id: Scalars['ExpertReferralId']
};


export type QueryExpertPerformanceStatisticsArgs = {
  filter: ExpertPerformanceStatisticsFilter,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryDealArgs = {
  id: Scalars['DealId']
};


export type QueryBrandsArgs = {
  activeOnly?: Maybe<Scalars['Boolean']>,
  first?: Maybe<Scalars['Int']>,
  after?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>
};


export type QuerySavedSellableArgs = {
  id: Scalars['SavedSellableId']
};


export type QuerySavedSellablesConnectionArgs = {
  query: SavedSellableQueryInput,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>
};


export type QuerySellableArgs = {
  id: Scalars['SellableId']
};


export type QueryFindSellableArgs = {
  friendlyIdOrId: Scalars['String']
};


export type QuerySellablesArgs = {
  ids: Array<Scalars['SellableId']>
};


export type QuerySearchSellablesArgs = {
  query?: Maybe<SellableSearchQuery>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>,
  sortBy?: Maybe<SellableSort>,
  order?: Maybe<SortOrder>
};


export type QuerySellableTypeaheadArgs = {
  query?: Maybe<SellableTypeaheadQuery>,
  first?: Maybe<Scalars['Int']>
};


export type QuerySimilarSellablesArgs = {
  id: Scalars['SellableId'],
  topN?: Maybe<Scalars['Int']>,
  leadId?: Maybe<Scalars['LeadId']>,
  filters?: Maybe<Array<SuggestedSellableFilter>>
};


export type QuerySellableSearchFacetsArgs = {
  query: SellableSearchFacetsQuery
};


export type QueryConsumerSellableReactionsArgs = {
  query?: Maybe<ConsumerSellableReactionsQuery>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QuerySellableResearchLinkArgs = {
  id: Scalars['SellableResearchLinkId']
};


export type QuerySellableResearchLinksArgs = {
  ids: Array<Scalars['SellableResearchLinkId']>
};


export type QueryFindSellableResearchLinksArgs = {
  input: SellableResearchLinkFilter
};


export type QueryLeadArgs = {
  id: Scalars['LeadId']
};


export type QueryBatchGetLeadsArgs = {
  ids: Array<Scalars['LeadId']>
};


export type QueryLeadsArgs = {
  query: LeadSearchQuery,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryFindExistingLeadArgs = {
  consumerId: Scalars['UserId'],
  expertId: Scalars['BusinessUserId']
};


export type QueryQuickReplyArgs = {
  id: Scalars['QuickReplyId']
};


export type QueryQuickRepliesArgs = {
  query: QuickReplyQuery
};


export type QueryExpertLeadFolderGroupsArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>,
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>
};


export type QueryExpertLeadFolderItemsArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>,
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>,
  folderName: Scalars['String'],
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryLeadEscalationArgs = {
  id: Scalars['LeadEscalationId']
};


export type QueryPredictedLifeTimeValuesArgs = {
  id: Scalars['UserId'],
  ltvType?: Maybe<LtvType>,
  adPlatform?: Maybe<Scalars['String']>
};


export type QueryLeadSurgeArgs = {
  id: Scalars['LeadSurgeId']
};


export type QueryLeadCampaignArgs = {
  id: Scalars['LeadCampaignId']
};


export type QueryLeadCampaignRecipientArgs = {
  id: Scalars['LeadCampaignRecipientId']
};


export type QueryLeadCampaignsArgs = {
  input: LeadCampaignFilter
};


export type QueryLeadCampaignTargetLeadsArgs = {
  campaignId: Scalars['LeadCampaignId']
};


export type QuerySavedSearchArgs = {
  id: Scalars['SavedSearchId']
};


export type QuerySavedSearchesArgs = {
  groupName: Scalars['String'],
  entityName: Scalars['String']
};


export type QueryRunSavedSearchArgs = {
  id: Scalars['SavedSearchId'],
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryRunLeadSavedSearchArgs = {
  id: Scalars['SavedSearchId'],
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>,
  context: LeadSavedSearchContext
};


export type QueryFindContentByTemplateArgs = {
  space?: Maybe<Scalars['String']>,
  template: Scalars['String'],
  variation: Scalars['String'],
  preview?: Maybe<Scalars['Boolean']>
};


export type QueryCountriesArgs = {
  filter?: Maybe<CountryFilter>
};


export type QueryCountryArgs = {
  countryCode: Scalars['String']
};


export type QueryAirportArgs = {
  airport: Scalars['AirportId']
};


export type QueryAirportTypeaheadArgs = {
  query?: Maybe<AirportTypeaheadQuery>,
  first?: Maybe<Scalars['Int']>
};


export type QueryReportArgs = {
  id: Scalars['ReportId']
};


export type QueryReportResultArgs = {
  query: ReportResultQuery
};


export type QueryExpertCuratedItemArgs = {
  id: Scalars['ExpertCuratedItemId']
};


export type QueryExpertCuratedItemsArgs = {
  ids: Array<Scalars['ExpertCuratedItemId']>
};


export type QueryExpertCuratedItemsForLeadArgs = {
  leadId: Scalars['LeadId']
};


export type QueryExpertCuratedItemActivationArgs = {
  id: Scalars['ExpertCuratedItemActivationId']
};


export type QueryExpertCuratedOrderArgs = {
  id: Scalars['ExpertCuratedOrderId']
};


export type QueryExpertCuratedOrdersArgs = {
  ids: Array<Scalars['ExpertCuratedOrderId']>
};


export type QueryExpertCuratedOrdersForLeadConnectionArgs = {
  query: ExpertCuratedOrdersForLeadQueryInput,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryExpertCuratedOrderListActivationArgs = {
  id: Scalars['ExpertCuratedOrderListActivationId']
};


export type QueryExpertCuratedOrderListActivationsArgs = {
  ids: Array<Scalars['ExpertCuratedOrderListActivationId']>
};


export type QueryExpertCuratedOrderListActivationsForLeadArgs = {
  leadId: Scalars['LeadId'],
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryExpertCuratedLeadItineraryArgs = {
  leadId: Scalars['LeadId']
};


export type QueryPopularExpertCuratedItemsForSellableArgs = {
  query: PopularExpertCuratedItemQueryInput,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QuerySuggestExpertCuratedItemNotesArgs = {
  query: SuggestExpertCuratedItemNotesQueryInput,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  sort?: Maybe<SuggestExpertCuratedItemNotesSort>
};


export type QuerySuggestExpertCuratedItemsForLeadArgs = {
  query: SuggestExpertCuratedItemsForLeadQueryInput,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QuerySuggestedAlternativeSellablesArgs = {
  input: SuggestedAlternativeSellableInput,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QuerySearchSuggestedAlternativeSellablesArgs = {
  input: SuggestedAlternativeSellableSearchInput,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryDepartmentExpertCuratedActivityFeedArgs = {
  id: Scalars['DepartmentId'],
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>
};


export type QueryExpertExpertCuratedActivityFeedArgs = {
  id: Scalars['BusinessUserId'],
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>
};


export type QueryExpertTopRecommendedSellablesArgs = {
  query: ExpertTopRecommendedSellablesInput
};


export type QueryExpertTopRecommendedBrandsArgs = {
  query: ExpertTopRecommendedBrandsInput
};


export type QuerySearchRecentExpertCuratedItemGroupsArgs = {
  filter: RecentExpertCuratedItemGroupSearchFilter,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QuerySearchSavedExpertCuratedItemsArgs = {
  filter: SavedExpertCuratedItemsSearchFilter,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QuerySimpleCuratedOrderArgs = {
  id: Scalars['SimpleCuratedOrderId']
};


export type QueryExpertCuratedItemsForUserArgs = {
  input: ExpertCuratedItemQueryByUserInput,
  size?: Maybe<Scalars['Int']>
};


export type QuerySearchExpertCuratedItemNotesArgs = {
  query: SearchExpertCuratedItemNotesQuery,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryGetExpertNoteStatsPaginationArgs = {
  sort: ExpertNoteStatsSort,
  sortOrder?: Maybe<SortOrder>,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryRecommendedListsForCategoryArgs = {
  categorySlug: Scalars['String'],
  types?: Maybe<Array<RecommendedListType>>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryRecommendedListsArgs = {
  query: RecommendedListsQuery,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryRecommendedListDefinitionArgs = {
  id: Scalars['RecommendedListDefinitionId']
};


export type QueryRecommendedListDefinitionsArgs = {
  query?: Maybe<RecommendedListDefintionQuery>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryTriggerArgs = {
  id: Scalars['TriggerId']
};


export type QueryTriggersArgs = {
  input: TriggerQuery
};


export type QueryValidateTriggerArgs = {
  input: ValidateTriggerInput
};


export type QueryTriggerVersionHistoryArgs = {
  historyId: Scalars['TriggerVersionHistoryId']
};


export type QueryEBayItemArgs = {
  itemId: Scalars['String']
};


export type QuerySearchEBayItemsArgs = {
  query?: Maybe<EBayItemSearchQuery>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>
};


export type QueryMatchSellableForEBayItemArgs = {
  itemId: Scalars['String']
};


export type QueryConfigArgs = {
  domain: Scalars['String'],
  key: Scalars['String']
};


export type QueryConfigsArgs = {
  domain: Scalars['String']
};


export type QueryExternalAdCampaignArgs = {
  id: Scalars['ExternalAdCampaignId']
};


export type QueryExternalAdCampaignsByCategoryArgs = {
  categoryId: Scalars['CategoryId']
};


export type QueryExternalAdGroupArgs = {
  id: Scalars['ExternalAdGroupId']
};


export type QuerySystemCuratedItemSurveyArgs = {
  id: Scalars['SystemCuratedItemSurveyId']
};


export type QueryFlightPlanArgs = {
  id: Scalars['FlightPlanId']
};


export type QuerySupportTaskArgs = {
  id: Scalars['SupportTaskId']
};


export type QuerySupportTasksArgs = {
  ids: Array<Scalars['SupportTaskId']>
};


export type QueryFindSupportTasksArgs = {
  query: SupportTaskQuery,
  sortOrder?: Maybe<SortOrder>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryFindSupportTasksForOperatorFolderArgs = {
  operatorId: Scalars['OperatorId'],
  supportTaskType: SupportTaskType,
  folderSlug: Scalars['String'],
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QuerySupportTaskFoldersForOperatorArgs = {
  operatorId: Scalars['OperatorId'],
  supportTaskType: SupportTaskType
};


export type QueryOrderEscalationArgs = {
  input: Scalars['OrderEscalationId']
};


export type QueryOrderEscalationsArgs = {
  query: OrderEscalationSearchInput,
  sort?: Maybe<OrderEscalationSearchSort>,
  sortOrder?: Maybe<SortOrder>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QuerySupportConversationArgs = {
  consumerId: Scalars['UserId']
};


export type QuerySupportConversationByIdArgs = {
  id: Scalars['SupportConversationId']
};


export type QuerySupportConversationsConnectionArgs = {
  query: SupportConversationQueryInput,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QuerySellableInventoryArgs = {
  id: Scalars['SellableInventoryItemId']
};


export type QueryPayStructureArgs = {
  id: Scalars['PayStructureId']
};


export type QueryPayStructuresPaginationArgs = {
  filters: PayStructureFilters,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryPayStructureRevisionArgs = {
  id: Scalars['PayStructureRevisionId']
};


export type QueryPayoutsPaginationArgs = {
  filters: PayoutFilters,
  sort?: Maybe<PayoutSortInput>,
  fetchRollupSummary?: Maybe<Scalars['Boolean']>,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryPayLineItemsPaginationArgs = {
  payoutId: Scalars['PayoutId'],
  sort?: Maybe<PayLineItemSortInput>,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryPayoutArgs = {
  id: Scalars['PayoutId']
};


export type QueryRawSellableSourceArgs = {
  id: Scalars['RawSellableSourceId']
};


export type QueryExportRawSellableSourceArgs = {
  id: Scalars['RawSellableSourceId']
};


export type QueryRawSellableArgs = {
  id: Scalars['RawSellableId']
};


export type QueryStandardizedSellableArgs = {
  id: Scalars['StandardizedSellableId']
};


export type QueryStandardizedSellableGroupArgs = {
  id: Scalars['StandardizedSellableGroupId']
};


export type QueryRawSellableStandardizationRuleArgs = {
  id: Scalars['RawSellableStandardizationRuleId']
};


export type QueryExportRawSellableStandardizationRuleArgs = {
  id: Scalars['RawSellableStandardizationRuleId']
};


export type QueryFindRawSellablesArgs = {
  query: RawSellableQuery
};


export type QueryFindRawSellableSourcesArgs = {
  query: RawSellableSourceQuery
};


export type QueryFindRawSellableStandardizationRulesArgs = {
  query: RawSellableStandardizationRuleQuery
};


export type QueryExportRawSellableStandardizationRulesArgs = {
  query: RawSellableStandardizationRuleQuery
};


export type QueryFindStandardizedSellablesArgs = {
  query: StandardizedSellableQuery
};


export type QueryFindStandardizedSellableGroupsArgs = {
  query: StandardizedSellableGroupQuery,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryFindStandardizedSellableGroupCandidatesArgs = {
  query: StandardizedSellableGroupCandidateQuery,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryFulfillmentCentersArgs = {
  query: FulfillmentCentersQuery,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryFulfillmentShipmentMethodsArgs = {
  query: FulfillmentShipmentMethodQuery,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QuerySchedulingTypesArgs = {
  activeOnly: Scalars['Boolean']
};


export type QuerySchedulingDepartmentsArgs = {
  activeOnly: Scalars['Boolean']
};


export type QuerySchedulingTypeArgs = {
  id: Scalars['SchedulingTypeId']
};


export type QuerySchedulingUserArgs = {
  id: Scalars['AnyId']
};


export type QuerySchedulingDemandForecastArgs = {
  id: Scalars['SchedulingDemandForecastId']
};


export type QuerySchedulingDemandForecastDailyViewArgs = {
  input: SchedulingDemandForecastDailyViewFilter
};


export type QuerySchedulingUserAvailabilityArgs = {
  id: Scalars['SchedulingUserAvailabilityId']
};


export type QuerySchedulingUserAvailabilityDailyViewArgs = {
  input: SchedulingUserAvailabilityDailyViewFilter
};


export type QueryShiftArgs = {
  id: Scalars['ShiftId']
};


export type QueryShiftDailyViewArgs = {
  input: ShiftDailyViewFilter
};


export type QueryShiftTeamDailyViewArgs = {
  input: ShiftTeamDailyViewFilter
};


export type QueryShiftTimeIntervalDailyViewArgs = {
  input: ShiftTimeIntervalDailyViewFilter
};


export type QueryShiftSlotUserDailyViewArgs = {
  input: ShiftSlotUserDailyViewFilter
};


export type QueryShiftSlotDailyViewArgs = {
  input: ShiftSlotDailyViewFilter
};


export type QueryGetFulfillmentChannelArgs = {
  channelId: Scalars['FulfillmentChannelId']
};


export type QueryFindFulfillmentChannelsArgs = {
  query: FulfillmentChannelQueryInput,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryGetOrderRefundArgs = {
  id: Scalars['OrderRefundId']
};


export type QueryOrderRefundsConnectionArgs = {
  input: OrderRefundQueryInput,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryOrderRefundsPaginationArgs = {
  input: OrderRefundQueryInput,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryTicketArgs = {
  input: Scalars['TicketId']
};


export type QueryTicketsConnectionArgs = {
  input: TicketQueryInput,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryTicketsPaginationArgs = {
  input: TicketQueryInput,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QuerySearchTicketsArgs = {
  input: TicketSearchQueryInput,
  sort?: Maybe<TicketSearchSort>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryLookupReferralCodeArgs = {
  code: Scalars['String']
};


export type QueryPotentialConsumerReferralSourcesArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>
};


export type QueryExpertDirectReferralCodeArgs = {
  expertId: Scalars['BusinessUserId']
};


export type QueryReferralCodeShareArgs = {
  id: Scalars['ReferralCodeShareId']
};


export type QueryExperimentsUpdatedAfterArgs = {
  updatedAfter?: Maybe<Scalars['Date']>,
  excludeBackendOnly?: Maybe<Scalars['Boolean']>
};


export type QueryExperimentArgs = {
  id: Scalars['ExperimentId']
};


export type QueryExperimentsArgs = {
  ids: Array<Scalars['ExperimentId']>
};


export type QueryFindExperimentsArgs = {
  filter: ExperimentFilter
};


export type QueryBookingsConnectionArgs = {
  query?: Maybe<BookingSearchQueryInput>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>,
  sortBy?: Maybe<BookingSearchSort>,
  sortDescending?: Maybe<Scalars['Boolean']>
};

export type QuickReply = {
   __typename: 'QuickReply',
  id: Scalars['QuickReplyId'],
  name: Scalars['String'],
  text: Scalars['String'],
  expert: BusinessUser,
  lead?: Maybe<Lead>,
};


export type QuickReplyQuery = {
  expertId?: Maybe<Scalars['BusinessUserId']>,
};

export type RatingContactPageMetadata = PathFlowPageMetadata & {
   __typename: 'RatingContactPageMetadata',
  type: PathFlowPageMetadataType,
};

export type RawAttribute = {
   __typename: 'RawAttribute',
  name: Scalars['String'],
  value: Scalars['String'],
};

export type RawAttributeInput = {
  name: Scalars['String'],
  value: Scalars['String'],
};

export type RawSellable = {
   __typename: 'RawSellable',
  id: Scalars['RawSellableId'],
  title: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  imageUrls: Array<Scalars['String']>,
  attributes: Array<RawSellableAttribute>,
  titleVariationDimension: Scalars['Boolean'],
  gtin?: Maybe<Scalars['String']>,
  mpn?: Maybe<Scalars['String']>,
  brand?: Maybe<Scalars['String']>,
  originalPrice?: Maybe<MonetaryAmount>,
  salePrice?: Maybe<MonetaryAmount>,
  source: RawSellableSource,
  sourceUniqueKey: Scalars['String'],
  sourceReference: Scalars['String'],
  variationGroupReference?: Maybe<Scalars['String']>,
  state: RawSellableState,
};

export type RawSellableAttribute = {
   __typename: 'RawSellableAttribute',
  name: Scalars['String'],
  value: Scalars['String'],
  variationDimension: Scalars['Boolean'],
};

export enum RawSellableAttributeValuePatternFlag {
  UNIX_LINES = 'UNIX_LINES',
  CASE_INSENSITIVE = 'CASE_INSENSITIVE',
  COMMENTS = 'COMMENTS',
  MULTILINE = 'MULTILINE',
  LITERAL = 'LITERAL',
  DOTALL = 'DOTALL',
  UNICODE_CASE = 'UNICODE_CASE',
  CANON_EQ = 'CANON_EQ',
  UNICODE_CHARACTER_CLASS = 'UNICODE_CHARACTER_CLASS'
}

export type RawSellableFeedSellablePriceSource = SellablePriceSource & {
   __typename: 'RawSellableFeedSellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  bestOfferPrice?: Maybe<MonetaryAmount>,
  cost?: Maybe<MonetaryAmount>,
  expiresAt?: Maybe<Scalars['Date']>,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  url: Scalars['String'],
  name: Scalars['String'],
  rawSellableSource: RawSellableFeedSource,
};

export type RawSellableFeedSource = RawSellableGoogleShoppingFeedSource | RawSellableLevelNineFeedSource;

export type RawSellableGoogleProductSellablePriceSource = SellablePriceSource & {
   __typename: 'RawSellableGoogleProductSellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  bestOfferPrice?: Maybe<MonetaryAmount>,
  cost?: Maybe<MonetaryAmount>,
  expiresAt?: Maybe<Scalars['Date']>,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  googleProductId: Scalars['String'],
  name: Scalars['String'],
  rawSellableSource: RawSellableGoogleShoppingSearchSource,
};

export type RawSellableGoogleShoppingFeedSource = RawSellableSource & {
   __typename: 'RawSellableGoogleShoppingFeedSource',
  id: Scalars['RawSellableSourceId'],
  name: Scalars['String'],
  type: RawSellableSourceType,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  state: RawSellableSourceState,
  feedUrls: Array<Scalars['String']>,
  username?: Maybe<Scalars['String']>,
  password?: Maybe<Scalars['String']>,
  priceRefreshInterval: Duration,
};

export type RawSellableGoogleShoppingSearchSource = RawSellableSource & {
   __typename: 'RawSellableGoogleShoppingSearchSource',
  id: Scalars['RawSellableSourceId'],
  name: Scalars['String'],
  type: RawSellableSourceType,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  state: RawSellableSourceState,
  merchantId: Scalars['String'],
  merchantName: Scalars['String'],
  categoryIds: Array<Scalars['String']>,
  priceRefreshInterval: Duration,
};


export type RawSellableLevelNineFeedSource = RawSellableSource & {
   __typename: 'RawSellableLevelNineFeedSource',
  id: Scalars['RawSellableSourceId'],
  name: Scalars['String'],
  type: RawSellableSourceType,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  state: RawSellableSourceState,
  feedUrl: Scalars['String'],
  priceRefreshInterval: Duration,
};

export type RawSellableQuery = {
  sourceIds?: Maybe<Array<Scalars['RawSellableSourceId']>>,
  sourceReferences?: Maybe<Array<RawSellableSourceReferenceInput>>,
  sourceKeys?: Maybe<Array<RawSellableSourceLookupKeyInput>>,
  states?: Maybe<Array<RawSellableState>>,
};

export type RawSellableScraperSellablePriceSource = SellablePriceSource & {
   __typename: 'RawSellableScraperSellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  bestOfferPrice?: Maybe<MonetaryAmount>,
  cost?: Maybe<MonetaryAmount>,
  expiresAt?: Maybe<Scalars['Date']>,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  url: Scalars['String'],
  name: Scalars['String'],
  rawSellableSource: RawSellableScraperSource,
};

export type RawSellableScraperSource = RawSellableSource & {
   __typename: 'RawSellableScraperSource',
  id: Scalars['RawSellableSourceId'],
  name: Scalars['String'],
  type: RawSellableSourceType,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  state: RawSellableSourceState,
  spider: RawSellableSourceSpider,
  priceRefreshInterval: Duration,
};

export type RawSellableShopifySellablePriceSource = SellablePriceSource & {
   __typename: 'RawSellableShopifySellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  bestOfferPrice?: Maybe<MonetaryAmount>,
  cost?: Maybe<MonetaryAmount>,
  expiresAt?: Maybe<Scalars['Date']>,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  productId: Scalars['String'],
  productVariantId: Scalars['String'],
  name: Scalars['String'],
  rawSellableSource: RawSellableShopifySource,
};

export type RawSellableShopifySource = RawSellableSource & {
   __typename: 'RawSellableShopifySource',
  id: Scalars['RawSellableSourceId'],
  name: Scalars['String'],
  type: RawSellableSourceType,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  state: RawSellableSourceState,
  shopName: Scalars['String'],
  apiKey: Scalars['String'],
  collectionId?: Maybe<Scalars['String']>,
  priceRefreshInterval: Duration,
};

export type RawSellableSource = {
  id: Scalars['RawSellableSourceId'],
  name: Scalars['String'],
  type: RawSellableSourceType,
  state: RawSellableSourceState,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
};

export type RawSellableSourceGoogleShoppingFeedInput = {
  feedUrls: Array<Scalars['String']>,
  username?: Maybe<Scalars['String']>,
  passord?: Maybe<Scalars['String']>,
  priceRefreshInterval: DurationInput,
};

export type RawSellableSourceGoogleShoppingSearchInput = {
  merchantId: Scalars['String'],
  merchantName: Scalars['String'],
  categoryIds: Array<Scalars['String']>,
  priceRefreshInterval: DurationInput,
};


export type RawSellableSourceLevelNineFeedInput = {
  feedUrl: Scalars['String'],
  priceRefreshInterval: DurationInput,
};

export type RawSellableSourceLookupKeyInput = {
  sourceId: Scalars['RawSellableSourceId'],
  uniqueKey: Scalars['String'],
};

export type RawSellableSourceQuery = {
  states?: Maybe<Array<RawSellableSourceState>>,
  types?: Maybe<Array<RawSellableSourceType>>,
};

export type RawSellableSourceReferenceInput = {
  sourceId: Scalars['RawSellableSourceId'],
  reference: Scalars['String'],
};

export type RawSellableSourceScrapinghubSpider = RawSellableSourceSpider & {
   __typename: 'RawSellableSourceScrapinghubSpider',
  spider: Scalars['String'],
  priceSpider: Scalars['String'],
  projectId: Scalars['String'],
  arguments: Array<RawSellableSourceScrapinghubSpiderArgument>,
  type: ScrapingJobType,
};

export type RawSellableSourceScrapinghubSpiderArgument = {
   __typename: 'RawSellableSourceScrapinghubSpiderArgument',
  key: Scalars['String'],
  value: Scalars['String'],
};

export type RawSellableSourceScrapinghubSpiderArgumentInput = {
  key: Scalars['String'],
  value: Scalars['String'],
};

export type RawSellableSourceScrapinghubSpiderInput = {
  spider: Scalars['String'],
  priceSpider: Scalars['String'],
  projectId: Scalars['String'],
  arguments: Array<RawSellableSourceScrapinghubSpiderArgumentInput>,
};

export type RawSellableSourceShopifyInput = {
  shopName: Scalars['String'],
  apiKey: Scalars['String'],
  collectionId?: Maybe<Scalars['String']>,
  priceRefreshInterval: DurationInput,
};

export type RawSellableSourceSpider = {
  type: ScrapingJobType,
};

export type RawSellableSourceSpiderInput = {
  priceRefreshInterval: DurationInput,
  scrapinghubSpider: RawSellableSourceScrapinghubSpiderInput,
};

export enum RawSellableSourceState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum RawSellableSourceType {
  SCRAPER = 'SCRAPER',
  DEAL_INVENTORY = 'DEAL_INVENTORY',
  GOOGLE_SHOPPING_FEED = 'GOOGLE_SHOPPING_FEED',
  GOOGLE_SHOPPING_SEARCH = 'GOOGLE_SHOPPING_SEARCH',
  LEVEL9_FEED = 'LEVEL9_FEED',
  SHOPIFY = 'SHOPIFY'
}

export type RawSellableStandardizationAction = {
  type: RawSellableStandardizationActionType,
};

export type RawSellableStandardizationActionInput = {
  type: RawSellableStandardizationActionType,
  copyAttributeValue?: Maybe<RawSellableStandardizationCopyAttributeValueActionInput>,
  removeAttribute?: Maybe<RawSellableStandardizationRemoveAttributeActionInput>,
  renameAttribute?: Maybe<RawSellableStandardizationRenameAttributeActionInput>,
  replaceAttributeValue?: Maybe<RawSellableStandardizationReplaceAttributeValueActionInput>,
  setAttributeValue?: Maybe<RawSellableStandardizationSetAttributeValueActionInput>,
  setCategory?: Maybe<RawSellableStandardizationSetCategoryActionInput>,
  setTitle?: Maybe<RawSellableStandardizationSetTitleActionInput>,
  setVariationGroupReference?: Maybe<RawSellableStandardizationSetVariationGroupReferenceActionInput>,
  setBrand?: Maybe<RawSellableStandardizationSetBrandActionInput>,
  setMpn?: Maybe<RawSellableStandardizationSetMpnActionInput>,
  setAttributeVariationDimension?: Maybe<RawSellableStandardizationSetAttributeVariationDimensionActionInput>,
  setDescription?: Maybe<RawSellableStandardizationSetDescriptionActionInput>,
};

export enum RawSellableStandardizationActionType {
  SET_CATEGORY = 'SET_CATEGORY',
  SET_ATTRIBUTE_VALUE = 'SET_ATTRIBUTE_VALUE',
  COPY_ATTRIBUTE_VALUE = 'COPY_ATTRIBUTE_VALUE',
  REMOVE_ATTRIBUTE = 'REMOVE_ATTRIBUTE',
  REPLACE_ATTRIBUTE_VALUE = 'REPLACE_ATTRIBUTE_VALUE',
  MARK_OUT_OF_STOCK = 'MARK_OUT_OF_STOCK',
  DEACTIVATE = 'DEACTIVATE',
  HIDE_FROM_CONSUMER_SEARCH = 'HIDE_FROM_CONSUMER_SEARCH',
  SET_TITLE = 'SET_TITLE',
  SET_VARIATION_GROUP_REFERENCE = 'SET_VARIATION_GROUP_REFERENCE',
  SET_BRAND = 'SET_BRAND',
  SET_MPN = 'SET_MPN',
  SET_ATTRIBUTE_VARIATION_DIMENSION = 'SET_ATTRIBUTE_VARIATION_DIMENSION',
  SET_DESCRIPTION = 'SET_DESCRIPTION',
  RENAME_ATTRIBUTE = 'RENAME_ATTRIBUTE',
  MARK_NONE_VARIANT = 'MARK_NONE_VARIANT'
}

export type RawSellableStandardizationAttributeValueFieldMeta = RawSellableStandardizationFieldMeta & {
   __typename: 'RawSellableStandardizationAttributeValueFieldMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  attributeName: Scalars['String'],
  type: RawSellableStandardizationRuleFieldType,
  idType?: Maybe<Scalars['String']>,
  supportedOperators: Array<RawSellableStandardizationRuleFieldOperator>,
};

export type RawSellableStandardizationAttributeVariationDimensionFieldMeta = RawSellableStandardizationFieldMeta & {
   __typename: 'RawSellableStandardizationAttributeVariationDimensionFieldMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  attributeName: Scalars['String'],
  type: RawSellableStandardizationRuleFieldType,
  idType?: Maybe<Scalars['String']>,
  supportedOperators: Array<RawSellableStandardizationRuleFieldOperator>,
};

export type RawSellableStandardizationCopyAttributeValueAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationCopyAttributeValueAction',
  type: RawSellableStandardizationActionType,
  sourceAttributeName: Scalars['String'],
  targetAttributeName: Scalars['String'],
  reference: Scalars['Boolean'],
};

export type RawSellableStandardizationCopyAttributeValueActionInput = {
  sourceAttributeName: Scalars['String'],
  targetAttributeName: Scalars['String'],
  reference: Scalars['Boolean'],
};

export type RawSellableStandardizationDeactivateAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationDeactivateAction',
  type: RawSellableStandardizationActionType,
};

export type RawSellableStandardizationFieldMeta = {
  name: Scalars['String'],
  displayName: Scalars['String'],
  type: RawSellableStandardizationRuleFieldType,
  idType?: Maybe<Scalars['String']>,
  supportedOperators: Array<RawSellableStandardizationRuleFieldOperator>,
};

export type RawSellableStandardizationHideFromConsumerSearchAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationHideFromConsumerSearchAction',
  type: RawSellableStandardizationActionType,
};

export type RawSellableStandardizationMarkNoneVariantAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationMarkNoneVariantAction',
  type: RawSellableStandardizationActionType,
};

export type RawSellableStandardizationMarkOutOfStockAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationMarkOutOfStockAction',
  type: RawSellableStandardizationActionType,
};

export type RawSellableStandardizationMeta = {
   __typename: 'RawSellableStandardizationMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  fields: Array<RawSellableStandardizationFieldMeta>,
  attributeValueField?: Maybe<RawSellableStandardizationFieldMeta>,
  attributeVariationDimensionField?: Maybe<RawSellableStandardizationFieldMeta>,
};


export type RawSellableStandardizationMetaFieldsArgs = {
  names?: Maybe<Array<Scalars['String']>>
};


export type RawSellableStandardizationMetaAttributeValueFieldArgs = {
  attributeName: Scalars['String']
};


export type RawSellableStandardizationMetaAttributeVariationDimensionFieldArgs = {
  attributeName: Scalars['String']
};

export type RawSellableStandardizationPredefinedFieldMeta = RawSellableStandardizationFieldMeta & {
   __typename: 'RawSellableStandardizationPredefinedFieldMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  type: RawSellableStandardizationRuleFieldType,
  idType?: Maybe<Scalars['String']>,
  supportedOperators: Array<RawSellableStandardizationRuleFieldOperator>,
};

export type RawSellableStandardizationRemoveAttributeAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationRemoveAttributeAction',
  type: RawSellableStandardizationActionType,
  attributeName: Scalars['String'],
};

export type RawSellableStandardizationRemoveAttributeActionInput = {
  attributeName: Scalars['String'],
};

export type RawSellableStandardizationRenameAttributeAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationRenameAttributeAction',
  type: RawSellableStandardizationActionType,
  sourceAttributeName: Scalars['String'],
  targetAttributeName: Scalars['String'],
};

export type RawSellableStandardizationRenameAttributeActionInput = {
  sourceAttributeName: Scalars['String'],
  targetAttributeName: Scalars['String'],
};

export type RawSellableStandardizationReplaceAttributeValueAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationReplaceAttributeValueAction',
  type: RawSellableStandardizationActionType,
  attributeName: Scalars['String'],
  attributeValuePattern: Scalars['String'],
  attributeValuePatternFlags: Array<RawSellableAttributeValuePatternFlag>,
  attributeValueReplacement: Scalars['String'],
};

export type RawSellableStandardizationReplaceAttributeValueActionInput = {
  attributeName: Scalars['String'],
  attributeValuePattern: Scalars['String'],
  attributeValuePatternFlags: Array<RawSellableAttributeValuePatternFlag>,
  attributeValueReplacement: Scalars['String'],
};

export type RawSellableStandardizationRule = {
   __typename: 'RawSellableStandardizationRule',
  id: Scalars['RawSellableStandardizationRuleId'],
  name: Scalars['String'],
  source?: Maybe<RawSellableSource>,
  priority: Scalars['Int'],
  condition: RawSellableStandardizationRuleCondition,
  actions: Array<RawSellableStandardizationAction>,
  state: RawSellableStandardizationRuleState,
  meta: RawSellableStandardizationMeta,
};

export type RawSellableStandardizationRuleBinaryCondition = RawSellableStandardizationRuleCondition & {
   __typename: 'RawSellableStandardizationRuleBinaryCondition',
  type: RawSellableStandardizationRuleConditionType,
  leftOperand: RawSellableStandardizationRuleParameter,
  rightOperand: RawSellableStandardizationRuleParameter,
  binaryOperator: RawSellableStandardizationRuleFieldOperator,
};

export type RawSellableStandardizationRuleBinaryConditionInput = {
  leftOperand: RawSellableStandardizationRuleParameterInput,
  rightOperand: RawSellableStandardizationRuleParameterInput,
  binaryOperator: Scalars['String'],
};

export type RawSellableStandardizationRuleCondition = {
  type: RawSellableStandardizationRuleConditionType,
};

export type RawSellableStandardizationRuleConditionInput = {
  binaryCondition?: Maybe<RawSellableStandardizationRuleBinaryConditionInput>,
  logicalCondition?: Maybe<RawSellableStandardizationRuleLogicalConditionInput>,
  constantCondition?: Maybe<RawSellableStandardizationRuleConstantConditionInput>,
};

export enum RawSellableStandardizationRuleConditionType {
  LOGICAL = 'LOGICAL',
  BINARY = 'BINARY',
  CONSTANT = 'CONSTANT'
}

export type RawSellableStandardizationRuleConstantCondition = RawSellableStandardizationRuleCondition & {
   __typename: 'RawSellableStandardizationRuleConstantCondition',
  type: RawSellableStandardizationRuleConditionType,
  result: Scalars['Boolean'],
};

export type RawSellableStandardizationRuleConstantConditionInput = {
  result: Scalars['Boolean'],
};

export type RawSellableStandardizationRuleEntityFieldReference = RawSellableStandardizationRuleParameter & {
   __typename: 'RawSellableStandardizationRuleEntityFieldReference',
  type: RawSellableStandardizationRuleParameterType,
  field: Scalars['String'],
};

export type RawSellableStandardizationRuleFieldOperator = {
   __typename: 'RawSellableStandardizationRuleFieldOperator',
  name: Scalars['String'],
  displayName: Scalars['String'],
  leftOperandType: RawSellableStandardizationRuleFieldType,
  rightOperandType: RawSellableStandardizationRuleFieldType,
};

export enum RawSellableStandardizationRuleFieldType {
  BOOLEAN = 'BOOLEAN',
  STRING = 'STRING',
  STRING_LIST = 'STRING_LIST',
  ID = 'ID',
  ID_LIST = 'ID_LIST'
}


export type RawSellableStandardizationRuleLiteralBooleanValue = RawSellableStandardizationRuleParameter & {
   __typename: 'RawSellableStandardizationRuleLiteralBooleanValue',
  type: RawSellableStandardizationRuleParameterType,
  booleanValue: Scalars['Boolean'],
};

export type RawSellableStandardizationRuleLiteralIdListValue = RawSellableStandardizationRuleParameter & {
   __typename: 'RawSellableStandardizationRuleLiteralIdListValue',
  type: RawSellableStandardizationRuleParameterType,
  idListValue: Array<Scalars['AnyId']>,
};

export type RawSellableStandardizationRuleLiteralIdValue = RawSellableStandardizationRuleParameter & {
   __typename: 'RawSellableStandardizationRuleLiteralIdValue',
  type: RawSellableStandardizationRuleParameterType,
  idValue: Scalars['AnyId'],
};

export type RawSellableStandardizationRuleLiteralStringListValue = RawSellableStandardizationRuleParameter & {
   __typename: 'RawSellableStandardizationRuleLiteralStringListValue',
  type: RawSellableStandardizationRuleParameterType,
  stringListValue: Array<Scalars['String']>,
};

export type RawSellableStandardizationRuleLiteralStringValue = RawSellableStandardizationRuleParameter & {
   __typename: 'RawSellableStandardizationRuleLiteralStringValue',
  type: RawSellableStandardizationRuleParameterType,
  stringValue: Scalars['String'],
};

export type RawSellableStandardizationRuleLogicalCondition = RawSellableStandardizationRuleCondition & {
   __typename: 'RawSellableStandardizationRuleLogicalCondition',
  type: RawSellableStandardizationRuleConditionType,
  conditions: Array<RawSellableStandardizationRuleCondition>,
  logicalOperator: LogicalOperator,
};

export type RawSellableStandardizationRuleLogicalConditionInput = {
  logicalOperator: LogicalOperator,
  conditions: Array<RawSellableStandardizationRuleConditionInput>,
};

export type RawSellableStandardizationRuleParameter = {
  type: RawSellableStandardizationRuleParameterType,
};

export type RawSellableStandardizationRuleParameterInput = {
  fieldName?: Maybe<Scalars['String']>,
  stringValue?: Maybe<Scalars['String']>,
  stringListValue?: Maybe<Array<Scalars['String']>>,
  booleanValue?: Maybe<Scalars['Boolean']>,
  idValue?: Maybe<Scalars['AnyId']>,
  idListValue?: Maybe<Array<Scalars['AnyId']>>,
};

export enum RawSellableStandardizationRuleParameterType {
  ENTITY_FIELD = 'ENTITY_FIELD',
  LITERAL_VALUE = 'LITERAL_VALUE'
}

export type RawSellableStandardizationRuleQuery = {
  states?: Maybe<Array<RawSellableStandardizationRuleState>>,
  sourceIds?: Maybe<Array<Scalars['RawSellableSourceId']>>,
  modifiedSince?: Maybe<Scalars['Date']>,
};

export enum RawSellableStandardizationRuleState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type RawSellableStandardizationSetAttributeValueAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationSetAttributeValueAction',
  type: RawSellableStandardizationActionType,
  attributeName: Scalars['String'],
  attributeValueTemplate: Scalars['String'],
};

export type RawSellableStandardizationSetAttributeValueActionInput = {
  attributeName: Scalars['String'],
  attributeValueTemplate: Scalars['String'],
};

export type RawSellableStandardizationSetAttributeVariationDimensionAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationSetAttributeVariationDimensionAction',
  type: RawSellableStandardizationActionType,
  attributeName: Scalars['String'],
  variationDimension: Scalars['Boolean'],
};

export type RawSellableStandardizationSetAttributeVariationDimensionActionInput = {
  attributeName: Scalars['String'],
  variationDimension: Scalars['Boolean'],
};

export type RawSellableStandardizationSetBrandAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationSetBrandAction',
  type: RawSellableStandardizationActionType,
  valueTemplate: Scalars['String'],
};

export type RawSellableStandardizationSetBrandActionInput = {
  valueTemplate: Scalars['String'],
};

export type RawSellableStandardizationSetCategoryAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationSetCategoryAction',
  type: RawSellableStandardizationActionType,
  category: Category,
};

export type RawSellableStandardizationSetCategoryActionInput = {
  categoryId: Scalars['CategoryId'],
};

export type RawSellableStandardizationSetDescriptionAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationSetDescriptionAction',
  type: RawSellableStandardizationActionType,
  valueTemplate: Scalars['String'],
};

export type RawSellableStandardizationSetDescriptionActionInput = {
  valueTemplate: Scalars['String'],
};

export type RawSellableStandardizationSetMpnAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationSetMpnAction',
  type: RawSellableStandardizationActionType,
  valueTemplate: Scalars['String'],
};

export type RawSellableStandardizationSetMpnActionInput = {
  valueTemplate: Scalars['String'],
};

export type RawSellableStandardizationSetTitleAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationSetTitleAction',
  type: RawSellableStandardizationActionType,
  valueTemplate: Scalars['String'],
};

export type RawSellableStandardizationSetTitleActionInput = {
  valueTemplate: Scalars['String'],
};

export type RawSellableStandardizationSetVariationGroupReferenceAction = RawSellableStandardizationAction & {
   __typename: 'RawSellableStandardizationSetVariationGroupReferenceAction',
  type: RawSellableStandardizationActionType,
  valueTemplate: Scalars['String'],
};

export type RawSellableStandardizationSetVariationGroupReferenceActionInput = {
  valueTemplate: Scalars['String'],
};

export enum RawSellableState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type RawSellableVariationGroupInput = {
  sourceId: Scalars['RawSellableSourceId'],
  variationGroupReference: Scalars['String'],
};

export type ReassignLeadInput = {
  leadId: Scalars['LeadId'],
  reassignedToExpertId: Scalars['BusinessUserId'],
  reason: LeadReassignmentReason,
};

export type ReassignLeadSupportTaskActivity = SupportTaskActivity & {
   __typename: 'ReassignLeadSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  reassignedTo: BusinessUser,
};

export type RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource = SystemCuratedItemSource & {
   __typename: 'RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource',
  type?: Maybe<SystemCuratedItemType>,
  expertCuratedItem: ExpertCuratedItem,
  dealRequest: DealRequest,
};

export type RecentExpertCuratedItemGroupConnection = {
   __typename: 'RecentExpertCuratedItemGroupConnection',
  edges: Array<RecentExpertCuratedItemGroupEdge>,
  pageInfo: PageInfo,
  facets: Array<DisplayFacet>,
  count: Scalars['Int'],
};

export type RecentExpertCuratedItemGroupEdge = {
   __typename: 'RecentExpertCuratedItemGroupEdge',
  node: ExpertCuratedItemGroup,
  cursor: Scalars['String'],
};

export type RecentExpertCuratedItemGroupSearchFilter = {
  facets?: Maybe<Array<FacetSelection>>,
};

export type RecommendedExpert = {
   __typename: 'RecommendedExpert',
  expert: BusinessUser,
  existingLead?: Maybe<Lead>,
};

/** 
 * A RecommendedList corresponds to a list of Sellables that are grouped together based on a combination of
 * Attributes and properties from a Sellable that match the Users intent.
 * For example, Carbon fiber Bike under $2000
 **/
export type RecommendedList = {
   __typename: 'RecommendedList',
  /** 
 * The RecommendedListDefinition used to build this RecommendedList
   * All recommendation lists should have a corresponding RecommendedListDefinition but this may be filtered based
   * on requesters Permission levels.
 **/
  recommendedListDefinition?: Maybe<RecommendedListDefinition>,
  /** 
 * the display name is dynamically generated using the matched Attributes of Sellables in the list and the users intent
   * If this is RecommendedList is built using a corresponding RecommendedListDefinition then this is the resolved title
 **/
  displayName: Scalars['String'],
  subTitle?: Maybe<Scalars['String']>,
  /** A list of Sellables belonging to this RecommendedList */
  sellables: Array<Sellable>,
  /** The top level RecommendedListType for this RecommendedList */
  type?: Maybe<RecommendedListType>,
};

/** 
 * The RecommendedLists are a list of Sellable items categorized into different RecommendedList, each with its corresponding
 * RecommendedListDefinition.
 * 
 * The RecommendedList is identified from the users intent for a Category specified in the request. Each individual
 * list edge is generated dynamically using a combination of attributes in the user's request in a path.
 * There is a default ordering for the edges returned in the response, listed as follows:
 * 1. Top recommendation based on a combination of user attributes
 * 2. Top level category Attribute Function type + Price combination. For ex: Road bikes under $2000.
 * 3. Top level category Function type + Brand combination. For ex: Specialized bikes
 * 4. The next section will contain lists of itmes belonging to Sub-categories or Accessories. For ex: Bike Helmets, Bike Shoes
 * 5. Any custom RecommendedListDefinition based Recommended List.
 * 
 * The above default order can be changed by updating the rank property of the corresponding RecommendedListDefinition.
 * 
 * Note, that based on the user's intent we may have 0 or more lists of a specific type. For example, if the user didn't
 * specify the brand preference, then we will skip the recommended list for brand type.
 * Also, note that a Sellable may belong to one or more RecommendedList's based on the list generation Criteria.
 * 
 * The total items in each RecommendedList are restricted to 10 items if present and minimum of 3
 **/
export type RecommendedListConnection = {
   __typename: 'RecommendedListConnection',
  edges: Array<RecommendedListEdge>,
  pageInfo: PageInfo,
};

export type RecommendedListDefinition = {
   __typename: 'RecommendedListDefinition',
  id: Scalars['RecommendedListDefinitionId'],
  /** User friendly name for this recommended list definition */
  name?: Maybe<Scalars['String']>,
  /** 
 * The title template that will be used to build the RecommendedList title shown to the consumer.
   * The template should use the freemarker style `${variable}` format for inserting any dynamic values in the resolved title.
   * For example: "Because you like ${attribute.brands}"
   * Note, the querable attributes from the title will be used as a hard filter in the RecommenedList result.
   * For example, if the title said "Because you like
   * ${attribute.brands.displayName}", then the result will only include
   * recommendations
   * that strictly match the brands
 **/
  titleTemplate: Scalars['String'],
  /** 
 * The subtitle template that will be used to build the RecommendedList's subtitle shown to the consumer
   * The template should use the freemarker style `${variable}` format for
   * inserting any dynamic values in the resolved subtitle.
   * This is mainly used to provide some additional context the recommended list
   * and for display purpose only with the resolved string.
 **/
  subTitleTemplate?: Maybe<Scalars['String']>,
  active: Scalars['Boolean'],
  /** The category for which this RecommendedListDefinition is being built. */
  categoryIds: Array<Scalars['CategoryId']>,
  /** The categories for which this RecommendedListDefinition is being built. */
  categories: Array<Category>,
  /** 
 * The relative rank of the RecommendedList built using this definition compared to other RecommendedList
   * when the user sees a list of RecommendedList
 **/
  rank: Scalars['Int'],
  recommendedListType: RecommendedListType,
  /** The filtering facets to refine recommended list results */
  queryFacets?: Maybe<Array<RecommendedListDisplayFacet>>,
  /** defaults to relevance based sorting */
  sortOptions?: Maybe<Array<RecommendedListSortOrder>>,
  /** The system auto generated RecommendedLists can't be edited, only their ranking can be changed. */
  queryFiltersAndSortingEditable: Scalars['Boolean'],
  /** A expectedReference User whose request Attributes to use for building the preview results */
  previewResults: DecoratedRecommendedListConnection,
};


export type RecommendedListDefinitionPreviewResultsArgs = {
  asViewedByUser: Scalars['UserId'],
  forParentCategoryId: Scalars['CategoryId'],
  maxFacetTerms?: Maybe<Scalars['Int']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};

export type RecommendedListDefinitionConnection = {
   __typename: 'RecommendedListDefinitionConnection',
  edges: Array<RecommendedListDefinitionEdge>,
  pageInfo: PageInfo,
};

export type RecommendedListDefinitionEdge = {
   __typename: 'RecommendedListDefinitionEdge',
  node: RecommendedListDefinition,
  cursor: Scalars['String'],
};


export type RecommendedListDefintionQuery = {
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  recurseToChildCategories?: Maybe<Scalars['Boolean']>,
};

export type RecommendedListDisplayFacet = {
   __typename: 'RecommendedListDisplayFacet',
  facet?: Maybe<DisplayFacet>,
  useUserPreference: Scalars['Boolean'],
};

export type RecommendedListEdge = {
   __typename: 'RecommendedListEdge',
  node: RecommendedList,
  cursor: Scalars['String'],
};

export type RecommendedListFacetSelectionInput = {
  facetSelection: FacetSelection,
  useUserPreference: Scalars['Boolean'],
};

export type RecommendedListSortOrder = {
   __typename: 'RecommendedListSortOrder',
  sellableSortBy: SellableSort,
  order: SortOrder,
};

export type RecommendedListSortOrderInput = {
  sellableSortBy: SellableSort,
  order: SortOrder,
};

export type RecommendedListsQuery = {
  /** Fetch recommended list for a specific category only */
  categorySlug?: Maybe<Scalars['String']>,
  /** Recommendations include sellables from all categories within the department */
  departmentSlug?: Maybe<Scalars['String']>,
  /** 
 * Recommendation types to be used for building the RecommendedList. This includes some pre defined types and a custom
   * type. Use RecommendedListType.CUSTOM to get all RecommendedList built using definitions in the Recommendation list builder
   * To filter further to specific RecommendedListDefinition specify the RecommendedListDefinitionId
 **/
  types?: Maybe<Array<RecommendedListType>>,
  /** To restrict recommended list to a specific RecommendedListDefinition only. This overrides types specified above. */
  recommendedListDefinitionId?: Maybe<Scalars['RecommendedListDefinitionId']>,
};

export enum RecommendedListType {
  /** 
 * Recommendation list built using  a combination of multiple user Attributes learnt from
   * the Path Deal request. More specifically, it uses Gender, Price, Brand, Primary Attributes and other secondary
   * attributes to build this request.
   * The list built only if brand and primary attributes are present in the users request
   * Accessories are explicitly excluded
 **/
  MY_TOP_LIST = 'MY_TOP_LIST',
  /** This is similar to TOP LIST but enforces a strict matching of user request attributes. */
  STRICT_MY_TOP_LIST = 'STRICT_MY_TOP_LIST',
  /** 
 * Recommendation list built using price and primary attributes from users path request attributes
   * Each primary attribute has a separate list
   * The list built only if primary attributes are present in the users request
   * Accessories are explicitly excluded
 **/
  PRICE_AND_PRIMARY_ATTRIBUTES = 'PRICE_AND_PRIMARY_ATTRIBUTES',
  /** 
 * Recommendation list built using brands and primary attributes from users path request attributes
   * Each brand has a separate list
   * The list built only if brand attributes are present in the users request
   * Accessories are explicitly excluded
 **/
  BRAND_AND_PRIMARY_ATTRIBUTES = 'BRAND_AND_PRIMARY_ATTRIBUTES',
  /** 
 * Recommendation list built using accessories selected by the user in the path request
   * Each Accessory has a separate list
 **/
  ACCESSORIES = 'ACCESSORIES',
  /** Recommended list built using curated lists that were recommended to similar users */
  CURATED_LIST_TO_SIMILAR_USERS = 'CURATED_LIST_TO_SIMILAR_USERS',
  /** 
 * This recommendation list is used to build a digest of recommendations based on user intent from the deal request
   * The relevancy favors most recent sellables and also favors sellables with price within users budget
   * that has changed recently.
 **/
  PRICE_SENSITIVE_INTENT_BASED_DIGEST = 'PRICE_SENSITIVE_INTENT_BASED_DIGEST',
  /** the recommended list built from a custom list defined by the operator or expert */
  CUSTOM = 'CUSTOM'
}

export type RecommendExpertPayload = {
   __typename: 'RecommendExpertPayload',
  expert?: Maybe<BusinessUser>,
  existingLead?: Maybe<Lead>,
};

export type ReenterPathFlowPageBySlugsInput = {
  pathFlowSlug: Scalars['String'],
  pathFlowPageSlug: Scalars['String'],
};

export type ReenterPathFlowPageInput = {
  pathFlowId: Scalars['PathFlowId'],
  pathFlowPageSlug: Scalars['String'],
};

export type ReenterPathFlowPagePayload = {
   __typename: 'ReenterPathFlowPagePayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type ReferralCode = {
   __typename: 'ReferralCode',
  id: Scalars['ReferralCodeId'],
  code: Scalars['String'],
  source: ReferralSource,
  shortenedUrl: Scalars['String'],
  urlWithoutTracking: Scalars['String'],
};


export type ReferralCodeShortenedUrlArgs = {
  medium: ReferralMedium,
  sourceKey: Scalars['String']
};


export type ReferralCodeShare = {
   __typename: 'ReferralCodeShare',
  id: Scalars['ReferralCodeShareId'],
  referralCode: ReferralCode,
  note?: Maybe<Scalars['String']>,
  contact: Scalars['String'],
  contactType: ContactType,
  shareCount: Scalars['Int'],
  lastSharedAt: Scalars['Date'],
};


export type ReferralCodeShareInput = {
  referralCodeId: Scalars['ReferralCodeId'],
  emails: Array<Scalars['String']>,
  note?: Maybe<Scalars['String']>,
};

export type ReferralCodeSharePayload = {
   __typename: 'ReferralCodeSharePayload',
  shareCount: Scalars['Int'],
  errors: Array<Scalars['String']>,
};

export enum ReferralMedium {
  EMAIL = 'EMAIL',
  FACEBOOK = 'FACEBOOK',
  LINK = 'LINK'
}

export type ReferralSource = {
  type: ReferralType,
};

export type ReferralSourceConsumerGeneric = ReferralSource & {
   __typename: 'ReferralSourceConsumerGeneric',
  type: ReferralType,
  user: User,
  expertsToRefer: Array<BusinessUser>,
};

export type ReferralSourceConsumerToExpert = ReferralSource & {
   __typename: 'ReferralSourceConsumerToExpert',
  type: ReferralType,
  user: User,
  referredToExpert: BusinessUser,
};

export type ReferralSourceExpertDirect = ReferralSource & {
   __typename: 'ReferralSourceExpertDirect',
  type: ReferralType,
  referredByExpert: BusinessUser,
};

export enum ReferralType {
  CONSUMER_GENERIC = 'CONSUMER_GENERIC',
  CONSUMER_TO_EXPERT = 'CONSUMER_TO_EXPERT',
  EXPERT_DIRECT = 'EXPERT_DIRECT'
}

export type RefreshAccessTokenInput = {
  refreshToken?: Maybe<Scalars['String']>,
};

export type RefreshAccessTokenPayload = EncodedAuthenticationTokensPayload & {
   __typename: 'RefreshAccessTokenPayload',
  result: AuthenticationResult,
  message?: Maybe<Scalars['String']>,
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

export type RefreshSellablePriceSourceInput = {
  id: Scalars['SellablePriceSourceId'],
};

export type RefreshSellablePriceSourcePayload = {
   __typename: 'RefreshSellablePriceSourcePayload',
  sellablePriceSource: SellablePriceSource,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type RefundAmountAdjustedActivity = OrderActivityDetail & {
   __typename: 'RefundAmountAdjustedActivity',
  type: OrderActivityDetailType,
  previousAmount: MonetaryAmount,
  newAmount: MonetaryAmount,
  orderRefund: OrderRefund,
  adjustedBy: Operator,
};

export type RefundRequestedActivity = OrderActivityDetail & {
   __typename: 'RefundRequestedActivity',
  type: OrderActivityDetailType,
  requestedByOperator?: Maybe<Operator>,
  orderRefund: OrderRefund,
  requestedAmount: MonetaryAmount,
};

export type RefundStatusUpdateActivity = OrderActivityDetail & {
   __typename: 'RefundStatusUpdateActivity',
  type: OrderActivityDetailType,
  previousState: Scalars['String'],
  newState: Scalars['String'],
  orderRefund: OrderRefund,
  updatedByOperator?: Maybe<Operator>,
};

export enum RegisterCustomerErrorCode {
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER',
  INVALID_EMAIL_ADDRESS = 'INVALID_EMAIL_ADDRESS'
}

export type RegisterCustomerInput = {
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  password?: Maybe<Scalars['String']>,
  externalOAuthType?: Maybe<OAuthType>,
  externalOAuthToken?: Maybe<Scalars['String']>,
  referralCodeId?: Maybe<Scalars['ReferralCodeId']>,
};

export type RegisterCustomerPayload = {
   __typename: 'RegisterCustomerPayload',
  user?: Maybe<User>,
  errors?: Maybe<Array<Scalars['String']>>,
  errorCodes: Array<RegisterCustomerErrorCode>,
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
  claimReferralPromotionResult?: Maybe<ClaimPromotionPayload>,
};

export type RegisterFirebaseCloudMessagingTokenInput = {
  messagingUserId: Scalars['AnyId'],
  fcmToken: Scalars['String'],
  deviceUniqueId?: Maybe<Scalars['String']>,
  applicationId?: Maybe<Scalars['String']>,
};

export type RegisterFirebaseCloudMessagingTokenPayload = {
   __typename: 'RegisterFirebaseCloudMessagingTokenPayload',
  registered?: Maybe<Scalars['Boolean']>,
};

export type RegisterWebPushSubscriptionInput = {
  messagingUserId: Scalars['AnyId'],
  subscription: Scalars['String'],
};

export type RegisterWebPushSubscriptionPayload = {
   __typename: 'RegisterWebPushSubscriptionPayload',
  registered: Scalars['Boolean'],
};

export type RejectExpertApplicationInput = {
  applicationId: Scalars['ExpertApplicationId'],
  reason: Scalars['String'],
};

export type RejectExpertApplicationPayload = {
   __typename: 'RejectExpertApplicationPayload',
  application: ExpertApplication,
};

export type RejectStandardizedSellableGroupCandidateInput = {
  id: Scalars['StandardizedSellableGroupCandidateId'],
};

export type RejectStandardizedSellableGroupCandidatePayload = {
   __typename: 'RejectStandardizedSellableGroupCandidatePayload',
  candidate: StandardizedSellableGroupCandidate,
};

export type ReleaseBusinessUserIdentityPayload = EncodedAuthenticationTokensPayload & {
   __typename: 'ReleaseBusinessUserIdentityPayload',
  myself?: Maybe<Myself>,
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

export type ReleaseConsumerIdentityPayload = EncodedAuthenticationTokensPayload & {
   __typename: 'ReleaseConsumerIdentityPayload',
  user?: Maybe<User>,
  myself?: Maybe<Myself>,
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

export type ReleaseOperatorIdentityPayload = EncodedAuthenticationTokensPayload & {
   __typename: 'ReleaseOperatorIdentityPayload',
  operator?: Maybe<Operator>,
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

export type RemoveActionFromPromotionInput = {
  id: Scalars['PromotionId'],
  referenceId: Scalars['PromotionActionReferenceId'],
};

export type RemoveActionFromPromotionPayload = {
   __typename: 'RemoveActionFromPromotionPayload',
  promotion: Promotion,
};

export type RemoveChannelTemplateInput = {
  templateId: Scalars['CommTemplateId'],
  channelType: ChannelType,
};

export type RemoveEscalationLabelInput = {
  escalationId: Scalars['OrderEscalationId'],
  escalationLabel: OrderEscalationLabel,
};

export type RemoveExpertCuratedItemInput = {
  id: Scalars['ExpertCuratedItemId'],
  reason: ExpertCuratedItemRemovedReason,
  otherReason?: Maybe<Scalars['String']>,
  /** Defaults to false; only experts can set this to true. Note that if a draft is being removed, it gets hard deleted. */
  shouldCopyUpdateIntoNewDraft?: Maybe<Scalars['Boolean']>,
};

export type RemoveExpertCuratedItemPayload = {
   __typename: 'RemoveExpertCuratedItemPayload',
  /** 
 * The entity that as ultimately modified; may be a new/existing draft that's staged to replace the targeted curated
   * item
 **/
  updated: ExpertCuratedItem,
  /** 
 * The entity that was targeted for update being staged to be removed once `updated` is activated (converted to non
   * draft status)
 **/
  superseded?: Maybe<ExpertCuratedItem>,
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories,
};

export type RemoveItemsFromExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'],
  sellableIds: Array<Scalars['SellableId']>,
};

export type RemoveItemsFromExpertCuratedOrderPayload = {
   __typename: 'RemoveItemsFromExpertCuratedOrderPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

export type RemoveItemsFromOrderInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>,
  lineItemIds: Array<Scalars['OrderLineItemId']>,
};

export type RemoveItemsFromOrderPayload = {
   __typename: 'RemoveItemsFromOrderPayload',
  order: Order,
};

export type RemoveLegsFromFlightPlanInput = {
  id: Scalars['FlightPlanId'],
  legIdsToRemove: Array<Scalars['FlightPlanLegId']>,
};

export type RemoveLegsFromFlightPlanPayload = {
   __typename: 'RemoveLegsFromFlightPlanPayload',
  flightPlan: FlightPlan,
  errorCode?: Maybe<FlightPlanEditErrorCode>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type RemoveOrderReturnShipmentTrackingInput = {
  orderRefundId: Scalars['OrderRefundId'],
};

export type RemoveProfileHighlightInput = {
  expertProfileId: Scalars['ExpertProfileId'],
  typeId: Scalars['ProfileHighlightTypeId'],
};

export type RemoveRuleFromPromotionInput = {
  id: Scalars['PromotionId'],
  referenceId: Scalars['PromotionRuleReferenceId'],
};

export type RemoveRuleFromPromotionPayload = {
   __typename: 'RemoveRuleFromPromotionPayload',
  promotion: Promotion,
};

export type RemoveScheduleReportInput = {
  reportId: Scalars['ReportId'],
};

export type RemoveSchedulingDemandForecastPayload = {
   __typename: 'RemoveSchedulingDemandForecastPayload',
  /** If true, the item was successfully deleted. If false, it means there there was no item to delete. */
  deleted: Scalars['Boolean'],
};

export type RemoveSchedulingUserAvailabilityPayload = {
   __typename: 'RemoveSchedulingUserAvailabilityPayload',
  /** If true, the item was successfully deleted. If false, it means there there was no item to delete. */
  deleted: Scalars['Boolean'],
};

export type RemoveShipmentTrackingInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
};

export type RemoveSupportFromLeadConversationInput = {
  leadId: Scalars['LeadId'],
};

export type RemoveSupportFromLeadConversationPayload = {
   __typename: 'RemoveSupportFromLeadConversationPayload',
  success: Scalars['Boolean'],
  lead?: Maybe<Lead>,
};

export type RemoveTagInput = {
  id: Scalars['TagId'],
};

export type RemoveTagPayload = {
   __typename: 'RemoveTagPayload',
  success?: Maybe<Scalars['Boolean']>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type RemoveTipFromOrderInput = {
  id: Scalars['OrderId'],
};

export type RemoveTipFromOrderPayload = {
   __typename: 'RemoveTipFromOrderPayload',
  order: Order,
};

export type RemoveTriggerEdgeInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  edgeType: TriggerNodeEdgeType,
};

export type RemoveTriggerNodeInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  edgeTypeToKeep: TriggerNodeEdgeType,
};

export type RenderCommTemplateInput = {
  templateId: Scalars['CommTemplateId'],
  variables: Array<RenderCommTemplateVariableInput>,
};

export type RenderCommTemplatePayload = {
   __typename: 'RenderCommTemplatePayload',
  contents?: Maybe<Array<RenderedChannelContent>>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type RenderCommTemplateVariableInput = {
  name: Scalars['String'],
  /** @deprecated Broken out into type specific properties (`idValue`, `stringValue`) */
  value?: Maybe<Scalars['AnyId']>,
  idValue?: Maybe<Scalars['AnyId']>,
  stringValue?: Maybe<Scalars['String']>,
};

export type RenderedChannelContent = {
  channelType: ChannelType,
};

export type RenderedContent = MediaRenderedContent | TextRenderedContent;

export type RenderedEmailContent = RenderedChannelContent & {
   __typename: 'RenderedEmailContent',
  channelType: ChannelType,
  subject: Scalars['String'],
  htmlBody: Scalars['String'],
  textBody: Scalars['String'],
  medias: Array<MediaFile>,
};

export type RenderedFacebookContent = RenderedChannelContent & {
   __typename: 'RenderedFacebookContent',
  channelType: ChannelType,
  content: Scalars['String'],
  medias: Array<MediaFile>,
};

export type RenderedInAppContent = RenderedChannelContent & {
   __typename: 'RenderedInAppContent',
  channelType: ChannelType,
  content: Scalars['String'],
  contents: Array<RenderedContent>,
};

export type RenderedPushNotificationContent = RenderedChannelContent & {
   __typename: 'RenderedPushNotificationContent',
  channelType: ChannelType,
  title: Scalars['String'],
  body: Scalars['String'],
  threadId?: Maybe<Scalars['String']>,
  medias: Array<MediaFile>,
};

export type RenderedSlackContent = RenderedChannelContent & {
   __typename: 'RenderedSlackContent',
  channelType: ChannelType,
  content: Scalars['String'],
};

export type RenderedSmsContent = RenderedChannelContent & {
   __typename: 'RenderedSmsContent',
  channelType: ChannelType,
  content: Scalars['String'],
  medias: Array<MediaFile>,
};

export type ReorderActionsInPromotionInput = {
  id: Scalars['PromotionId'],
  newReferenceIdOrder: Array<Scalars['PromotionActionReferenceId']>,
};

export type ReorderActionsInPromotionPayload = {
   __typename: 'ReorderActionsInPromotionPayload',
  promotion: Promotion,
};

export type ReorderRulesInPromotionInput = {
  id: Scalars['PromotionId'],
  newReferenceIdOrder: Array<Scalars['PromotionRuleReferenceId']>,
};

export type ReorderRulesInPromotionPayload = {
   __typename: 'ReorderRulesInPromotionPayload',
  promotion: Promotion,
};

export type Report = {
   __typename: 'Report',
  id: Scalars['ReportId'],
  title: Scalars['String'],
  /** Must be globally unique if specified */
  internalName?: Maybe<Scalars['String']>,
  columns: Array<ReportColumn>,
  refreshIntervalInMinutes?: Maybe<Scalars['Int']>,
  lastGeneratedAt?: Maybe<Scalars['Date']>,
  scope: ReportAccessScope,
  schemaType?: Maybe<ReportSchemaType>,
};

export enum ReportAccessScope {
  BUSINESS_USER = 'BUSINESS_USER',
  TEAM = 'TEAM',
  DEPARTMENT = 'DEPARTMENT',
  GLOBAL = 'GLOBAL'
}

export type ReportColumn = {
   __typename: 'ReportColumn',
  title: Scalars['String'],
  description: Scalars['String'],
  name: Scalars['String'],
  type: ReportColumnValueType,
  format: ReportColumnFormat,
  filterOnly: Scalars['Boolean'],
};

export enum ReportColumnFormat {
  NONE = 'NONE',
  PERCENTAGE = 'PERCENTAGE',
  CURRENCY = 'CURRENCY'
}

export type ReportColumnInput = {
  name: Scalars['String'],
  title: Scalars['String'],
  type: ReportColumnValueType,
};

export type ReportColumnValue = {
   __typename: 'ReportColumnValue',
  stringValue?: Maybe<Scalars['String']>,
  integerValue?: Maybe<Scalars['Int']>,
  doubleValue?: Maybe<Scalars['Float']>,
  type: ReportColumnValueType,
};

export enum ReportColumnValueType {
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  DOUBLE = 'DOUBLE'
}


export type ReportPredictedLifeTimeValueInput = {
  userId: Scalars['UserId'],
  ltvType: LtvType,
  adPlatform: Scalars['String'],
};

export type ReportPredictedLifeTimeValuePayload = {
   __typename: 'ReportPredictedLifeTimeValuePayload',
  predictedLifeTimeValues: Array<PredictedLifeTimeValue>,
};

export type ReportResultPayload = {
   __typename: 'ReportResultPayload',
  error?: Maybe<Scalars['String']>,
  report?: Maybe<Report>,
  rows: Array<ReportResultRow>,
};

export type ReportResultQuery = {
  reportName?: Maybe<Scalars['String']>,
  reportId?: Maybe<Scalars['ReportId']>,
};

export type ReportResultRow = {
   __typename: 'ReportResultRow',
  values: Array<ReportColumnValue>,
};

export enum ReportSchemaType {
  /** The total amount of conversations, and the amount of new conversations in the last week. */
  CONVERSATIONS_COUNT = 'CONVERSATIONS_COUNT',
  /** Stats about expert ratings; total rating count, and average rating score. */
  EXPERT_RATING_STATS = 'EXPERT_RATING_STATS',
  /** The total amount of curations, and the amount of new curations in the last week. */
  CURATIONS_COUNT = 'CURATIONS_COUNT',
  /** Most popular brands recommended by experts, grouped by category */
  RECOMMENDED_BY_EXPERTS_CAT_BRAND_STATS = 'RECOMMENDED_BY_EXPERTS_CAT_BRAND_STATS',
  /** 
 * Most popular brands recommended by experts, grouped and rolled up by category
   * linked to department (e.g.: winter sports, golf, etc)
 **/
  RECOMMENDED_BY_EXPERTS_DEPT_CAT_BRAND_STATS = 'RECOMMENDED_BY_EXPERTS_DEPT_CAT_BRAND_STATS'
}

export type RequestConsumerExpertReviewInput = {
  leadId: Scalars['LeadId'],
};

export type RequestConsumerExpertReviewPayload = {
   __typename: 'RequestConsumerExpertReviewPayload',
  success: Scalars['Boolean'],
};

export type RequestOrderRefundInput = {
  orderId: Scalars['OrderId'],
  consumerId: Scalars['UserId'],
  lineItemIds?: Maybe<Array<Scalars['OrderLineItemId']>>,
  orderEscalationId?: Maybe<Scalars['OrderEscalationId']>,
  refundReason: OrderRefundReason,
  amountRequested: MonetaryAmountInput,
  originalTransactionId: Scalars['TransactionId'],
  comment?: Maybe<Scalars['String']>,
  returnNeeded?: Maybe<Scalars['Boolean']>,
  merchantRefundNeeded?: Maybe<Scalars['Boolean']>,
};

export type RequestOrderSupportForLeadSupportTaskActivity = SupportTaskActivity & {
   __typename: 'RequestOrderSupportForLeadSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
};

export type RequestReferralByExpertInput = {
  leadId: Scalars['LeadId'],
  expertId: Scalars['BusinessUserId'],
};

export type RequestReferralByExpertPayload = {
   __typename: 'RequestReferralByExpertPayload',
  success: Scalars['Boolean'],
};

export type RequestSellableInput = {
  expertId: Scalars['BusinessUserId'],
  sellableId: Scalars['SellableId'],
};

export type RequestSellablePayload = {
   __typename: 'RequestSellablePayload',
  error?: Maybe<Scalars['String']>,
  lead?: Maybe<Lead>,
};

export type RequestSellablePriceMatchInput = {
  expertId: Scalars['BusinessUserId'],
  sellableId: Scalars['SellableId'],
};

export type RequestSellablePriceMatchPayload = {
   __typename: 'RequestSellablePriceMatchPayload',
  error?: Maybe<Scalars['String']>,
  lead?: Maybe<Lead>,
};

export type RerunExpertApplicationTaskInput = {
  applicationId: Scalars['ExpertApplicationId'],
  task: ExpertApplicationTaskType,
};

export type RerunExpertApplicationTaskPayload = {
   __typename: 'RerunExpertApplicationTaskPayload',
  success: Scalars['Boolean'],
};

export type ResetConfigInput = {
  domain: Scalars['String'],
  key: Scalars['String'],
};

export type ResetConfigPayload = {
   __typename: 'ResetConfigPayload',
  config: Config,
};

export type ResetPasswordInput = {
  handle?: Maybe<Scalars['String']>,
  handleType?: Maybe<HandleType>,
  challenge?: Maybe<Scalars['String']>,
  newPassword: Scalars['String'],
};

export type ResetPasswordPayload = EncodedAuthenticationTokensPayload & {
   __typename: 'ResetPasswordPayload',
  result: AuthenticationResult,
  user?: Maybe<User>,
  message?: Maybe<Scalars['String']>,
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

export type ResolveTicketInput = {
  ticketId: Scalars['TicketId'],
};

export type ReturnDestinationChangedActivity = OrderActivityDetail & {
   __typename: 'ReturnDestinationChangedActivity',
  type: OrderActivityDetailType,
  previousDestination: Scalars['String'],
  newDestination: Scalars['String'],
  orderRefund: OrderRefund,
  changedByOperator?: Maybe<Operator>,
};

export type ReturnPolicy = {
  type: ReturnPolicyType,
};

export enum ReturnPolicyType {
  NO_RETURNS_ACCEPTED = 'NO_RETURNS_ACCEPTED',
  STANDARD = 'STANDARD'
}

export enum ReturnRefundMethod {
  ORIGINAL_PAYMENT = 'ORIGINAL_PAYMENT',
  STORE_CREDIT = 'STORE_CREDIT'
}

export type ReturnShipmentTrackingRemovedActivity = OrderActivityDetail & {
   __typename: 'ReturnShipmentTrackingRemovedActivity',
  type: OrderActivityDetailType,
  removedBy?: Maybe<Operator>,
  orderRefund?: Maybe<OrderRefund>,
};

export type ReturnShipmentTrackingUpdatedActivity = OrderActivityDetail & {
   __typename: 'ReturnShipmentTrackingUpdatedActivity',
  type: OrderActivityDetailType,
  shippingCarrier: ShippingCarrier,
  trackingNumber: Scalars['String'],
  updatedBy?: Maybe<Operator>,
  orderRefund?: Maybe<OrderRefund>,
};

export enum ReturnShippingPaidBy {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  MERCHANT = 'MERCHANT',
  CUSTOMER = 'CUSTOMER'
}

export type ReviewFooterPageMetadata = PathFlowPageMetadata & {
   __typename: 'ReviewFooterPageMetadata',
  type: PathFlowPageMetadataType,
};

export type ReviewSummary = {
   __typename: 'ReviewSummary',
  averageRating?: Maybe<Scalars['Float']>,
  totalReviews: Scalars['Int'],
  summaryByRating: Array<ReviewSummaryByRating>,
};

export type ReviewSummaryByRating = {
   __typename: 'ReviewSummaryByRating',
  rating: Scalars['Int'],
  count: Scalars['Int'],
};

export type RuleDefinition = {
   __typename: 'RuleDefinition',
  condition: ConditionDefinition,
  partitions: Array<PartitionDefinition>,
};

export type RuleDefinitionInput = {
  condition: ConditionDefinitionInput,
  partitions: Array<PartitionDefinitionInput>,
};

export type RunShiftAssignmentsInput = {
  sourceRangeStart: Scalars['Date'],
  sourceRangeEnd: Scalars['Date'],
  schedulingTypeId: Scalars['SchedulingTypeId'],
  assignmentMode: ShiftAssignmentMode,
};

export type RunShiftAssignmentsPayload = {
   __typename: 'RunShiftAssignmentsPayload',
  updateShiftSlotCount: Scalars['Int'],
};

export type SaveConsumerSellableReactionInput = {
  rating: ConsumerSellableReactionRating,
  reasons?: Maybe<Array<ConsumerSellableReactionReason>>,
  additionalReason?: Maybe<Scalars['String']>,
  /** The sellable being reviewed */
  sellableId: Scalars['SellableId'],
  /** 
 * Since the sellable can be shown in multiple context like different types of recommended list, search results or
   * in auto curations. This field provides the source of the recommendation if one exists
   * If this is review for an ExpertCuratedItem the id of the corresponding item
   * If this is a review for sellable seen in a recommended list the id of the corresponding RecommendedListDefinition
 **/
  recommendationSource?: Maybe<ConsumerSellableReactionRecommendationSourceInput>,
  /** Logical Component on the UI that triggered this reaction */
  reactionSource?: Maybe<ConsumerSellableReactionSource>,
};

export type SaveConsumerSellableReactionPayload = {
   __typename: 'SaveConsumerSellableReactionPayload',
  consumerSellableReaction?: Maybe<ConsumerSellableReaction>,
  error?: Maybe<Scalars['String']>,
};

/** 
 * SavedExpertCuratedItems is a container for ExpertCuratedItem's that were saved for future reference by an expert.
 * Although, this may have been originally created for a lead, it is not tied to a lead and such this information
 * is not persisted.
 * There is however some metadata about request attributes of the original lead to who this curation was sent, which
 * is mainly used for tagging and searching theis curation.
 **/
export type SavedExpertCuratedItems = {
   __typename: 'SavedExpertCuratedItems',
  id: Scalars['SavedExpertCuratedItemsId'],
  name: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  active: Scalars['Boolean'],
  expertCuratedItems: Array<ExpertCuratedItem>,
  /** a list of request attributes tagged and associated with this curation */
  taggedRequestAttributes: Array<Attribute>,
  /** a list of request attributes that can be used to tag this saved curation */
  suggestedTaggableRequestAttributes: Array<SuggestedExpertTaggableRequestAttribute>,
};

export type SavedExpertCuratedItemsConnection = {
   __typename: 'SavedExpertCuratedItemsConnection',
  edges: Array<SavedExpertCuratedItemsEdge>,
  pageInfo: PageInfo,
  facets: Array<DisplayFacet>,
  count: Scalars['Int'],
};

export type SavedExpertCuratedItemsEdge = {
   __typename: 'SavedExpertCuratedItemsEdge',
  node: SavedExpertCuratedItems,
  cursor: Scalars['String'],
};


export type SavedExpertCuratedItemsSearchFilter = {
  /** 
 * keywords for search
   * currently only supports the name of the saved curation and sellable title
 **/
  keywords?: Maybe<Scalars['String']>,
  facets?: Maybe<Array<FacetSelection>>,
};

export type SavedLeadNote = {
   __typename: 'SavedLeadNote',
  id: Scalars['LeadNoteId'],
  lead: Lead,
  text: Scalars['String'],
  messageId?: Maybe<Scalars['String']>,
};

export type SavedSearch = {
   __typename: 'SavedSearch',
  id: Scalars['SavedSearchId'],
  title: Scalars['String'],
  entityName: Scalars['String'],
  count: Scalars['Int'],
};


export type SavedSearchResultConnection = LeadSearchConnection;

export type SavedSellable = {
   __typename: 'SavedSellable',
  id: Scalars['SavedSellableId'],
  sellable: Sellable,
  saved: Scalars['Boolean'],
  savedAt: Scalars['Date'],
  savedReason?: Maybe<SavedSellableReason>,
  savedReasonDisplay?: Maybe<Scalars['String']>,
  unsavedAt?: Maybe<Scalars['Date']>,
  unsavedReason?: Maybe<UnsavedSellableReason>,
  unsavedReasonDisplay?: Maybe<Scalars['String']>,
};

export type SavedSellableEdge = {
   __typename: 'SavedSellableEdge',
  node: SavedSellable,
  cursor: Scalars['String'],
};


export type SavedSellableQueryInput = {
  /** Defaults to the logged in user */
  userId?: Maybe<Scalars['UserId']>,
};

export enum SavedSellableReason {
  PRICE = 'PRICE',
  STYLE = 'STYLE',
  HIGH_QUALITY = 'HIGH_QUALITY',
  BRAND = 'BRAND',
  FEATURES = 'FEATURES'
}

export type SavedSellablesConnection = {
   __typename: 'SavedSellablesConnection',
  edges: Array<SavedSellableEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export type SaveReviewForSuggestedAlternativeSellableInput = {
  suggestedAlternativeSellableId: Scalars['SuggestedAlternativeSellableId'],
  isSuggestionGood: SuggestedSellableReviewAnswer,
};

export type SaveReviewForSuggestedAlternativeSellablePayload = {
   __typename: 'SaveReviewForSuggestedAlternativeSellablePayload',
  data?: Maybe<SuggestedAlternativeSellable>,
  error?: Maybe<Scalars['String']>,
  hasError: Scalars['Boolean'],
};

export type SaveSavedSellableInput = {
  sellableId: Scalars['SellableId'],
  reason?: Maybe<SavedSellableReason>,
};

export type SaveSavedSellablePayload = {
   __typename: 'SaveSavedSellablePayload',
  savedSellable: SavedSellable,
};

export type ScheduledPayment = {
   __typename: 'ScheduledPayment',
  id: Scalars['ScheduledPaymentId'],
  amount: MonetaryAmount,
  payAt: Scalars['Date'],
  state: ScheduledPaymentState,
  order: Order,
  paymentSource: PaymentSource,
  remindedAt?: Maybe<Scalars['Date']>,
};


export enum ScheduledPaymentState {
  SCHEDULED = 'SCHEDULED',
  EXECUTED = 'EXECUTED',
  CANCELED = 'CANCELED'
}

export type ScheduleLeadCampaignInput = {
  id: Scalars['LeadCampaignId'],
  batchSize: Scalars['Int'],
  scheduledAt: Scalars['Date'],
};

export type SchedulingDemandForecast = {
   __typename: 'SchedulingDemandForecast',
  id: Scalars['SchedulingDemandForecastId'],
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  maximumShiftUnits: Scalars['BigDecimal'],
  type: SchedulingType,
  locked: Scalars['Boolean'],
};

export type SchedulingDemandForecastDailyView = {
   __typename: 'SchedulingDemandForecastDailyView',
  date: Scalars['LocalDate'],
  orderedList: Array<SchedulingDemandForecast>,
  zoneId: Scalars['String'],
};

export type SchedulingDemandForecastDailyViewFilter = {
  zoneId: Scalars['String'],
  startDateInclusive: Scalars['LocalDate'],
  endDateExclusive: Scalars['LocalDate'],
  typeId: Scalars['SchedulingTypeId'],
};


export type SchedulingDepartment = {
   __typename: 'SchedulingDepartment',
  id: Scalars['SchedulingDepartmentId'],
  displayName: Scalars['String'],
  autoAssignmentEnabled: Scalars['Boolean'],
  autoAdjustUserSettingsEnabled: Scalars['Boolean'],
  schedulingTypes: Array<SchedulingType>,
  active: Scalars['Boolean'],
};


export type SchedulingPeriod = {
   __typename: 'SchedulingPeriod',
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  availabilityOpensAt: Scalars['Date'],
  availabilityFreezesAt: Scalars['Date'],
  reservedShiftsClaimStartsAt: Scalars['Date'],
  openShiftsClaimStartsAt: Scalars['Date'],
  expertShiftCalendarUrl: Scalars['String'],
};

export type SchedulingType = {
   __typename: 'SchedulingType',
  id: Scalars['SchedulingTypeId'],
  name: Scalars['String'],
  role: SchedulingUserRole,
  workHourStartsAt: Scalars['LocalTime'],
  workHourEndsAt: Scalars['LocalTime'],
  shiftDuration: Duration,
  active: Scalars['Boolean'],
  allSettings: Array<SchedulingUserSettings>,
};


export type SchedulingUser = {
   __typename: 'SchedulingUser',
  id: Scalars['AnyId'],
  active: Scalars['Boolean'],
  profiles: Array<SchedulingUserProfile>,
  identity: SchedulingUserIdentity,
  nextSchedulingPeriod?: Maybe<SchedulingPeriod>,
};

export type SchedulingUserAvailability = {
   __typename: 'SchedulingUserAvailability',
  id: Scalars['SchedulingUserAvailabilityId'],
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  user: SchedulingUser,
  locked: Scalars['Boolean'],
};

export type SchedulingUserAvailabilityDailyView = {
   __typename: 'SchedulingUserAvailabilityDailyView',
  date: Scalars['LocalDate'],
  orderedList: Array<SchedulingUserAvailability>,
  zoneId: Scalars['String'],
};

export type SchedulingUserAvailabilityDailyViewFilter = {
  zoneId: Scalars['String'],
  startDateInclusive: Scalars['LocalDate'],
  endDateExclusive: Scalars['LocalDate'],
  userId: Scalars['AnyId'],
};


export type SchedulingUserIdentity = Operator | BusinessUser;

export type SchedulingUserProfile = {
   __typename: 'SchedulingUserProfile',
  type: SchedulingType,
  shiftUnits: Scalars['BigDecimal'],
  shiftUnitsDefault: Scalars['BigDecimal'],
  shiftUnitsOverride?: Maybe<Scalars['BigDecimal']>,
  maximumShifts: Scalars['Int'],
  maximumShiftsDefault: Scalars['Int'],
  maximumShiftsOverride?: Maybe<Scalars['Int']>,
  weeklyMaximumShifts: Scalars['Int'],
  weeklyMaximumShiftsDefault: Scalars['Int'],
  weeklyMaximumShiftsOverride?: Maybe<Scalars['Int']>,
  dailyMaximumShifts: Scalars['Int'],
  dailyMaximumShiftsDefault: Scalars['Int'],
  dailyMaximumShiftsOverride?: Maybe<Scalars['Int']>,
  priority: Scalars['Int'],
  priorityDefault: Scalars['Int'],
  priorityOverride?: Maybe<Scalars['Int']>,
};

export enum SchedulingUserRole {
  EXPERT = 'EXPERT',
  ON_CALL_EXPERT = 'ON_CALL_EXPERT',
  CHARTER_EXPERT = 'CHARTER_EXPERT',
  ENTRY_EXPERT = 'ENTRY_EXPERT'
}

export type SchedulingUserSettings = {
   __typename: 'SchedulingUserSettings',
  name: Scalars['String'],
  shiftUnits: Scalars['BigDecimal'],
  priority: Scalars['Int'],
  weeklyMaximumShifts: Scalars['Int'],
  dailyMaximumShifts: Scalars['Int'],
};

export type SchedulingUserSettingsInput = {
  name: Scalars['String'],
  shiftUnits: Scalars['BigDecimal'],
  priority: Scalars['Int'],
  weeklyMaximumShifts: Scalars['Int'],
  dailyMaximumShifts: Scalars['Int'],
};

export enum ScrapingJobType {
  SCRAPINGHUB = 'SCRAPINGHUB'
}

export type ScrapingSellablePriceSource = SellablePriceSource & {
   __typename: 'ScrapingSellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  bestOfferPrice?: Maybe<MonetaryAmount>,
  cost?: Maybe<MonetaryAmount>,
  expiresAt?: Maybe<Scalars['Date']>,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  url: Scalars['String'],
  spider: ScrapingSellablePriceSourceSpider,
};

export enum ScrapingSellablePriceSourceSpider {
  EVO = 'EVO',
  PROGOLFYAKIMA = 'PROGOLFYAKIMA',
  JENSONUSA = 'JENSONUSA',
  BIKEBLING = 'BIKEBLING',
  CHAINREACTIONCYCLES = 'CHAINREACTIONCYCLES',
  CAMBRIABIKE = 'CAMBRIABIKE'
}

export type SearchExpertCuratedItemNotesPayload = {
   __typename: 'SearchExpertCuratedItemNotesPayload',
  expertCuratedItemNotes: Array<ExpertCuratedItemNote>,
};

export type SearchExpertCuratedItemNotesQuery = {
  states: Array<ExpertCuratedItemNoteState>,
  sellableIds: Array<Scalars['SellableId']>,
};

export type SelectExpertCuratedOrderItemInput = {
  id: Scalars['SellableId'],
  selected: Scalars['Boolean'],
};

export type SelectExpertCuratedOrderItemsInput = {
  id: Scalars['ExpertCuratedOrderId'],
  items: Array<SelectExpertCuratedOrderItemInput>,
};

export type SelectExpertCuratedOrderItemsPayload = {
   __typename: 'SelectExpertCuratedOrderItemsPayload',
  expertCuratedOrder: ExpertCuratedOrder,
  errorCode?: Maybe<ExpertCuratedOrderSelectErrorCode>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
  /** 
 * If errorCode is NOT_ACTIVE and this is present, it means this is the latest active update which replaces
   * `expertCuratedOrder`.
 **/
  activeReplacement?: Maybe<ExpertCuratedOrder>,
};

export type SelectExpertCuratedOrderVariationOptionInput = {
  id: Scalars['ExpertCuratedOrderId'],
  sellableId: Scalars['SellableId'],
};

export type SelectExpertCuratedOrderVariationOptionPayload = {
   __typename: 'SelectExpertCuratedOrderVariationOptionPayload',
  expertCuratedOrder: ExpertCuratedOrder,
  errorCode?: Maybe<ExpertCuratedOrderSelectErrorCode>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
  /** 
 * If errorCode is NOT_ACTIVE and this is present, it means this is the latest active update which replaces
   * `expertCuratedOrder`.
 **/
  activeReplacement?: Maybe<ExpertCuratedOrder>,
};

export type Sellable = {
   __typename: 'Sellable',
  id: Scalars['SellableId'],
  /** Case-insensitive ID */
  googleId: Scalars['String'],
  /** 
 * The ID in the google shopping feed for this sellable
   * If the sellable has GTIN or MPN, this is the same as googleId. Otherwise, it is the parent sellable's googleId
 **/
  feedId: Scalars['String'],
  /** Title of the product or service */
  title: Scalars['String'],
  /** Plain text description */
  descriptionText?: Maybe<Scalars['String']>,
  /** 
 * Description in GitHub-flavored Markdown format
   * See https://github.github.com/gfm/
 **/
  descriptionMarkdown?: Maybe<Scalars['String']>,
  /** categories this sellable is associated with */
  categories: Array<Category>,
  /** if this sellable is a product or service */
  type: SellableType,
  /** 
 * MSRP price of this sellable; omittied if not applicable/available. Note that this is not what the consumer pays for
   * the product on Deal.com; salePrice is the actual price paid for the product.
 **/
  originalPrice?: Maybe<MonetaryAmount>,
  price?: Maybe<MonetaryAmount>,
  /** default price we advertise to consumer without tax; omitted if not applicable/available (usually for parent sellable) */
  salePrice?: Maybe<MonetaryAmount>,
  /** the overridden price if set. */
  salePriceOverride?: Maybe<MonetaryAmount>,
  /** 
 * the minimum sale price if set. the actual salePrice must equal or be higher than this price. note that
   * bestOfferPrice may be less than this price.
 **/
  minimumSalePrice?: Maybe<MonetaryAmount>,
  /** the best price we sell to consumer which is not publically shown; omitted if not applicable/available */
  bestOfferPrice?: Maybe<MonetaryAmount>,
  /** the overridden best offer price */
  bestOfferPriceOverride?: Maybe<MonetaryAmount>,
  /** the price source of the sale price. for legacy sale price, this source may not exist, even though salePrice exists */
  salePriceSource?: Maybe<SellablePriceSource>,
  /** 
 * The amount of savings `salePrice` offers over `originalPrice`; null if there are no savings, or there is no
   * `originalPrice`
 **/
  savingsAmountFromOriginaPrice?: Maybe<MonetaryAmount>,
  savingsAmountFromOriginalPrice?: Maybe<MonetaryAmount>,
  /** Percent savings for `savingsAmountFromOriginaPrice` */
  savingsPercentFromOriginalPrice?: Maybe<Scalars['Float']>,
  /** 
 * Default price we sell to the consumer for with estimated tax. If no input is provided, the user's address associated
   * with their account will be used. If no address is found/provided, or there is no sale price, this field will be null.
 **/
  salePriceWithEstimatedTax?: Maybe<MonetaryAmountWithTax>,
  brand?: Maybe<Brand>,
  images: Array<MediaFile>,
  /** 
 * Subset of ids in `images` that are sample/backfill images, and not indicative of the exact product or service the
   * customer is receiving.
 **/
  sampleImageIds: Array<Scalars['MediaId']>,
  active: Scalars['Boolean'],
  /** The parent sellable if this is a child variant */
  parent?: Maybe<Sellable>,
  /** If this sellable is a variant */
  variant: Scalars['Boolean'],
  /** Computed n-dimension matrix of all of the child variants of this product (e.g.: color, size, etc variations) */
  variationMatrix?: Maybe<VariationMatrix>,
  /** Get formatted components that make up this sellable's unique variant (e.g.: red color, Medium size, etc) */
  variants: Array<SellableFormattedVariant>,
  /** Specifications table */
  specifications: Array<SellableSpecification>,
  /** Get all standardized attributes for this sellable. Note that this will be a subset of specifications. */
  attributes: Array<Attribute>,
  /** Get a specific standardized attribute. */
  attribute?: Maybe<Attribute>,
  /** If this sellable is in the user's cart */
  inCart: Scalars['Boolean'],
  /** Unique sources this sellable is associated with. */
  sources: Array<SellableSource>,
  /** If this sellable type is a service, the location at which this service is provided */
  serviceLocation?: Maybe<SellableServiceLocation>,
  /** 
 * If this sellable is created ad-hoc for single use (e.g.: created for a single customer).
   * Ad-hoc sellables are not surfaced in search, and are primarily used for experts to sell items we don't have a
   * proper standardized sellable for, but have some means to fulfill.
 **/
  adHoc: Scalars['Boolean'],
  consumerUrl: Scalars['String'],
  /** 
 * Retrieve expert curated items associated with the specified lead and this sellable, or any of it's variations.
   * If leadId is null, this property will return an empty list. This is to simplify client side queries so the same
   * query can be used for UIs that require and don't require this property
 **/
  expertCuratedItemsForLead: Array<ExpertCuratedItem>,
  /** List of features this product/service has */
  features: Array<Scalars['String']>,
  /** Featured rich content from various sites (e.g.: YouTube, Instagram, review sites, etc) */
  featuredContent?: Maybe<FeaturedSellableContent>,
  /** Metrics about this sellable, like page views, purchase count etc. */
  metrics?: Maybe<SellableMetrics>,
  /** If the current user has saved (or subsequently unsaved) this sellable */
  savedSellable?: Maybe<SavedSellable>,
  /** 
 * If this particular sellable is out of stock. If this is the parent sellable that is not sellable, it will always
   * be out of stock since it is not sellable in its self.
 **/
  outOfStock: Scalars['Boolean'],
  /** The date and time when the sellable will not be purchasable. */
  expireAt?: Maybe<Scalars['Date']>,
  /** 
 * If part of a variation, checks if all child/sibling variants are out of stock. If not in a variation, this is
   * identical to `outOfStock`
 **/
  areAllVariantsOutOfStock: Scalars['Boolean'],
  department?: Maybe<Department>,
  /** All price sources */
  priceSources: Array<SellablePriceSource>,
  /** 
 * Note that this slug is for SEO purposes to put in the url, and is NOT globally unique. The friendlyId should be
   * added to the URL as a unique identifier
 **/
  slug: Scalars['String'],
  /** 
 * Alternative unique identifier that's shorter than `id`, and more SEO friendly. If not present, it means this
   * sellable is not intended to be discovered via search (e.g.: ad hoc sellables).
 **/
  friendlyId?: Maybe<Scalars['String']>,
  /** A flag indicating if this sellable is in short supply */
  inShortSupply: Scalars['Boolean'],
  /** 
 * Best-effort search on recent active expert curated items an expert extended to the current user that match this
   * exact sellable, or a variant of this sellable
 **/
  recentExpertCuratedItem?: Maybe<ExpertCuratedItem>,
  /** 
 * Returns Sellable reactions in context of the viewer. For Consumer, it returns the reactions given by the user to
   * this specific sellable, while in context of Expert, this returns the
   * ConsumerSellableReaction's given by all users to this expert
 **/
  consumerSellableReactions: ConsumerSellableReactionConnection,
  /** url to html page providing 360 view of the product, currently used for diamonds */
  dynamic360ViewUrl?: Maybe<Scalars['String']>,
  /** GIA cert url for diamonds */
  certificateUrl?: Maybe<Scalars['String']>,
  /** 
 * List of experts who have recommended this sellable
   * Order by expert who has given the most recommendations, total arbitarily limited to 100.
 **/
  recommendedByExperts: Array<ExpertSellableRecommendationCount>,
  recommendingExperts: ExpertSellableRecommendationCountConnection,
  /** 
 * badges associated with a specific sellable
   * If the sellable is a parent sellable, the badges of all variants rollup to the parent
 **/
  badges: Array<SellableBadgeWithDisplayName>,
  /** used in email template so that we don't need to fetch the first from images list in freemarker templates. */
  primaryImage?: Maybe<MediaFile>,
  /** other online sellers price for price comparison */
  otherOnlineRetailers: Array<SellableOnlineRetailer>,
  /** stats for expert curated item notes associated with this sellable */
  sellableExpertNoteStats: SellableExpertNoteStats,
};


export type SellableSalePriceWithEstimatedTaxArgs = {
  input?: Maybe<EstimatedTaxLocationInput>
};


export type SellableAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};


export type SellableExpertCuratedItemsForLeadArgs = {
  leadId?: Maybe<Scalars['LeadId']>,
  filters?: Maybe<Array<ExpertCuratedItemStateFilter>>,
  sort?: Maybe<ExpertCuratedItemSort>
};


export type SellableConsumerSellableReactionsArgs = {
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type SellableRecommendingExpertsArgs = {
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};

export type SellableAttributeFilterPromotionRuleReference = PromotionRuleReference & {
   __typename: 'SellableAttributeFilterPromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
  attributes: Array<Attribute>,
  rawAttributes: Array<RawAttribute>,
  comparison: SellableAttributePromotionRuleReferenceComparison,
  strategy: PromotionRuleFilterStrategy,
};

/** See `SellableAttributeFilterPromotionRuleReference` for documentation */
export type SellableAttributeFilterPromotionRuleReferenceInput = {
  attributes?: Maybe<Array<AttributeInput>>,
  rawAttributes?: Maybe<Array<RawAttributeInput>>,
  comparison: SellableAttributePromotionRuleReferenceComparison,
  strategy: PromotionRuleFilterStrategy,
};

export enum SellableAttributePromotionRuleReferenceComparison {
  EQUAL = 'EQUAL',
  NOT_EQUAL = 'NOT_EQUAL'
}

export enum SellableBadge {
  /** Used for items in our warehouse to indicate gurantees on delivery estimates. */
  SHIPPED_BY_CURATED = 'SHIPPED_BY_CURATED',
  /** Used for items drop-shipped by manufacturer */
  SHIPPED_BY_MANUFACTURER = 'SHIPPED_BY_MANUFACTURER',
  /** Used for items whose Sale price is manually overridden and is lower than any of the known price sources */
  SECRET_DEAL = 'SECRET_DEAL'
}

export type SellableBadgeWithDisplayName = {
   __typename: 'SellableBadgeWithDisplayName',
  badge: SellableBadge,
  displayName: Scalars['String'],
};

export type SellableBrandFilterPromotionRuleReference = PromotionRuleReference & {
   __typename: 'SellableBrandFilterPromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
  brands: Array<Brand>,
  strategy: PromotionRuleFilterStrategy,
};

/** See `SellableBrandFilterPromotionRuleReference` for documentation */
export type SellableBrandFilterPromotionRuleReferenceInput = {
  brandIds: Array<Scalars['BrandId']>,
  strategy: PromotionRuleFilterStrategy,
};

/** Filter or exclude (depending on `strategy`) line item sellables that match `categories` */
export type SellableCategoryFilterPromotionRuleReference = PromotionRuleReference & {
   __typename: 'SellableCategoryFilterPromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
  categories: Array<Category>,
  strategy: PromotionRuleFilterStrategy,
  /** If children, parents, or both of `categories` should also be included during the filtering/excluding evaluation */
  traversalOptions: Array<SellableCategoryFilterPromotionRuleReferenceTraversalOption>,
};

/** See `SellableCategoryFilterPromotionRuleReference` for documentation */
export type SellableCategoryFilterPromotionRuleReferenceInput = {
  categoryIds: Array<Scalars['CategoryId']>,
  strategy: PromotionRuleFilterStrategy,
  traversalOptions: Array<SellableCategoryFilterPromotionRuleReferenceTraversalOption>,
};

export enum SellableCategoryFilterPromotionRuleReferenceTraversalOption {
  INCLUDE_PARENTS = 'INCLUDE_PARENTS',
  INCLUDE_CHILDREN = 'INCLUDE_CHILDREN'
}

export type SellableDeactivationTaskPayload = {
   __typename: 'SellableDeactivationTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  numSellableDisabled: Scalars['Int'],
  errors: Array<SellableTaskError>,
  googleSpreadsheetId: Scalars['String'],
  deactivateVariations: Scalars['Boolean'],
};

export type SellableExpertNoteStats = {
   __typename: 'SellableExpertNoteStats',
  draftCount: Scalars['Int'],
  pendingCount: Scalars['Int'],
  approvedCount: Scalars['Int'],
  rejectedCount: Scalars['Int'],
  deactivatedCount: Scalars['Int'],
  sellable: Sellable,
};

/** Filter or exclude (depending on `strategy`) line items that match `sellables`, or their parents match `sellables` */
export type SellableFilterPromotionRuleReference = PromotionRuleReference & {
   __typename: 'SellableFilterPromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
  sellables: Array<Sellable>,
  strategy: PromotionRuleFilterStrategy,
};

/** See `SellableFilterPromotionRuleReference` for documentation */
export type SellableFilterPromotionRuleReferenceInput = {
  sellableIds: Array<Scalars['SellableId']>,
  strategy: PromotionRuleFilterStrategy,
};

export type SellableFormattedVariant = {
   __typename: 'SellableFormattedVariant',
  /** Internal name for this variant; not intended to be displayed in the UI */
  name: Scalars['String'],
  /** 
 * Display name for this variant.
   * This may be something like "Color", "Length", where it effectively serves as a title. Note that this display name is
   * not required. For example, if there is only one dimension, and that's a title dimension, the grouping may not be
   * titled. For title dimensions, the display name may be the shortened product title, e.g.: "Red Special Edition",
   * "Anniversary Edition", "Game of the year bundle".
 **/
  displayName?: Maybe<Scalars['String']>,
  /** Internal value; not to be displayed in the UI. Expect this to be things like "RED", "123", "WOMAN", etc. */
  value: Scalars['String'],
  /** 
 * Display value formatted as sanitized HTML. To match with the value property examples, expect this to be things like
   * "Red", "123cm", "Woman", etc.
 **/
  displayValueHtml: Scalars['String'],
};


export type SellableInventoryItem = {
   __typename: 'SellableInventoryItem',
  id: Scalars['SellableInventoryItemId'],
  category: Category,
  dealSku: Scalars['String'],
  /** External inventory source if managed by a third party management tool */
  externalInventoryItemSource?: Maybe<ExternalInventoryItemSource>,
  gtin?: Maybe<Scalars['String']>,
  mpn?: Maybe<Scalars['String']>,
  attributes: Array<Attribute>,
  rawAttributes: Array<RawAttribute>,
  variationAttributes: Array<Scalars['String']>,
  /** 
 * The total available quantity to sell across all fulfillment centers
   * This will take into account any orders that are yet to be fulfilled but are scheduled to be fulfilled
 **/
  totalAvailableToOrder: Scalars['Int'],
  /** Availability to order by fulfillment center */
  orderAvailabilityByFulfillmentCenter: Array<AvailabilityByFulfillmentCenter>,
  inventoryItemLevels: Array<SellableInventoryItemLevel>,
  cost?: Maybe<MonetaryAmount>,
  msrp?: Maybe<MonetaryAmount>,
  salePrice?: Maybe<MonetaryAmount>,
  map?: Maybe<MonetaryAmount>,
  title?: Maybe<Scalars['String']>,
  descriptionText?: Maybe<Scalars['String']>,
  descriptionHtml?: Maybe<Scalars['String']>,
  /** A list of purchase order information associated with the inventory item */
  purchaseOrders: Array<SellableInventoryItemPurchaseOrder>,
};


export type SellableInventoryItemLevel = {
   __typename: 'SellableInventoryItemLevel',
  /** Details of fulfillment center where this inventory is located */
  fulfillmentCenter: FulfillmentCenter,
  /** time when the inventory level was updated */
  updatedAt: Scalars['Date'],
  /** current quantity of items available at this Fulfillment Center */
  availableAtFulfillmentCenter: Scalars['Int'],
  /** current number of items in transit to this Fulfillment Center */
  inTransitShippedToFulfillmentCenter: Scalars['Int'],
};

export type SellableInventoryItemLevelUpdateInput = {
  fulfillmentCenterId: Scalars['FulfillmentCenterId'],
  totalShippedToFulfillmentCenter?: Maybe<Scalars['Int']>,
  availableAtFulfillmentCenter?: Maybe<Scalars['Int']>,
};

export type SellableInventoryItemPurchaseOrder = {
   __typename: 'SellableInventoryItemPurchaseOrder',
  purchasedAt: Scalars['Date'],
  estimatedAvailableAt: Scalars['Date'],
  fulfillmentCenter: FulfillmentCenter,
  quantity: Scalars['Int'],
};

export type SellableInventoryItemUpdateInput = {
  id: Scalars['SellableInventoryItemId'],
  gtin?: Maybe<Scalars['String']>,
  /** manufacture part number */
  mpn?: Maybe<Scalars['String']>,
  /** 
 * Updates to inventory level are allowed as a backup in case of synchronization or data integrity issues
   * The values act as overrides so use them carefully
 **/
  inventoryLevels?: Maybe<Array<SellableInventoryItemLevelUpdateInput>>,
  /** The purchase price of the sellable per unit */
  cost?: Maybe<MonetaryAmountInput>,
  /** The msp of the sellable */
  msrp?: Maybe<MonetaryAmountInput>,
};

export type SellableInventoryItemUpdatePayload = {
   __typename: 'SellableInventoryItemUpdatePayload',
  data?: Maybe<SellableInventoryItem>,
  error?: Maybe<Scalars['String']>,
  hasError: Scalars['Boolean'],
};

export type SellableInventoryUploadTaskPayload = {
   __typename: 'SellableInventoryUploadTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  numInventoryItemsCreated: Scalars['Int'],
  numInventoryItemsUpdated: Scalars['Int'],
  errors: Array<InventoryTaskError>,
  googleSpreadsheetId: Scalars['String'],
  /** Whether the upload process allowed multiple tabs. */
  multiTabUpload: Scalars['Boolean'],
  /** This flag indicates it was used to process data for partner inventory data. */
  partnerInventory: Scalars['Boolean'],
  /** The file to be uploaded on UPS when this new inventory ships */
  upsShipmentUploadFile?: Maybe<MediaFile>,
};

export type SellableMetrics = {
   __typename: 'SellableMetrics',
  /** 
 * Uniqueness here means all PVs by the same user on the same parent Sellable in
   * the hourly window is considered a single event
 **/
  totalUniqueInPastHour?: Maybe<Scalars['Long']>,
  totalUniquePVsInPastHour?: Maybe<Scalars['Int']>,
  /** 
 * Uniqueness here means all PVs by the same user on the same parent Sellable in
   * the day long window is considered a single event
 **/
  totalUniqueInPastDay?: Maybe<Scalars['Long']>,
  totalUniquePVsInPastDay?: Maybe<Scalars['Int']>,
  /** 
 * Uniqueness here means all PVs by the same user on the same parent Sellable in
   * the week long window is considered a single event
 **/
  totalUniqueInPastWeek?: Maybe<Scalars['Long']>,
  totalUniquePVsInPastWeek?: Maybe<Scalars['Int']>,
  /** total number of purchases in the past day across all users */
  totalPurchasesInPast24Hours?: Maybe<Scalars['Long']>,
  totalPurchasesInLast24Hours?: Maybe<Scalars['Int']>,
  /** total number of purchases in the past 30 days across all users */
  totalPurchasesInPast30Days?: Maybe<Scalars['Long']>,
  totalPurchasesInLast30Days?: Maybe<Scalars['Int']>,
  timesRecommendedByExpert?: Maybe<Scalars['Int']>,
};

export type SellableOnlineRetailer = {
   __typename: 'SellableOnlineRetailer',
  name: Scalars['String'],
  salePrice: MonetaryAmount,
  freeShipping: Scalars['Boolean'],
};

export type SellablePriceSource = {
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  bestOfferPrice?: Maybe<MonetaryAmount>,
  cost?: Maybe<MonetaryAmount>,
  expiresAt?: Maybe<Scalars['Date']>,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
};

export type SellablePriceSourceGoogleShoppingSeller = {
   __typename: 'SellablePriceSourceGoogleShoppingSeller',
  name: Scalars['String'],
  salePrice: MonetaryAmount,
  freeShipping: Scalars['Boolean'],
};


export enum SellablePriceSourceType {
  DEAL = 'DEAL',
  AMAZON = 'AMAZON',
  EBAY = 'EBAY',
  SCRAPING = 'SCRAPING',
  YADAV = 'YADAV',
  RAW_SELLABLE_SCRAPER = 'RAW_SELLABLE_SCRAPER',
  RAW_SELLABLE_FEED = 'RAW_SELLABLE_FEED',
  RAW_SELLABLE_GOOGLE_PRODUCT = 'RAW_SELLABLE_GOOGLE_PRODUCT',
  RAW_SELLABLE_SHOPIFY = 'RAW_SELLABLE_SHOPIFY',
  DEAL_INVENTORY = 'DEAL_INVENTORY',
  GOOGLE_SHOPPING = 'GOOGLE_SHOPPING'
}

export type SellablePriceUploadTaskPayload = {
   __typename: 'SellablePriceUploadTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  numSellableUpdated: Scalars['Int'],
  numSellableCreated: Scalars['Int'],
  numSellableDisabled: Scalars['Int'],
  errorRows: Array<Scalars['Int']>,
  errors: Array<SellableTaskError>,
  googleSpreadsheetId: Scalars['String'],
};

export type SellableResearchLink = {
   __typename: 'SellableResearchLink',
  id: Scalars['SellableResearchLinkId'],
  createdAt: Scalars['Date'],
  active: Scalars['Boolean'],
  createdBy: BusinessUser,
  sellable: Sellable,
  url: Scalars['String'],
};

export type SellableResearchLinkFilter = {
  sellableId?: Maybe<Scalars['SellableId']>,
  parentSellableId?: Maybe<Scalars['SellableId']>,
  createdById?: Maybe<Scalars['BusinessUserId']>,
};


export type SellableSearchConnection = {
   __typename: 'SellableSearchConnection',
  facets: Array<DisplayFacet>,
  edges: Array<SellableSearchEdge>,
  pageInfo: PageInfo,
  count: Scalars['Int'],
  /** Additional metadata that could describe the associated results */
  pageMetadata?: Maybe<SellableSearchResultPageMetadata>,
};

export type SellableSearchEdge = {
   __typename: 'SellableSearchEdge',
  node: Sellable,
  cursor: Scalars['String'],
};

export type SellableSearchFacetsPayload = {
   __typename: 'SellableSearchFacetsPayload',
  facets: Array<FacetSelectionPayload>,
};

export type SellableSearchFacetsQuery = {
  /** hack - this is mainly used to provide a facet selection mapping from the external brand ids to internal brand ids */
  brandIds?: Maybe<Array<Scalars['BrandId']>>,
};

export enum SellableSearchFacetsQueryFilter {
  /** 
 * Returns facets that have attributes that are marked as PRIMARY in the specific category.
   * In case there are multiple PRIMARY attributes in a Category, it returns the first one after category specific
   * custom sorting, to provide deterministic behavior.
 **/
  FIRST_PRIMARY_ATTRIBUTE_ONLY = 'FIRST_PRIMARY_ATTRIBUTE_ONLY',
  /** All facets with PRIMARY attributes are returned, ordered by category specific sorting. */
  ALL_PRIMARY_ATTRIBUTES = 'ALL_PRIMARY_ATTRIBUTES',
  /** 
 * Returns facets that have attributes that are marked as SECONDARY in the specific category.
   * In case there are multiple SECONDARY attributes in a Category, it returns the first one after category specific
   * custom sorting, to provide deterministic behavior.
 **/
  FIRST_SECONDARY_ATTRIBUTE_ONLY = 'FIRST_SECONDARY_ATTRIBUTE_ONLY',
  /** All facets with SECONDARY attributes are returned, ordered by category specific sorting. */
  ALL_SECONDARY_ATTRIBUTES = 'ALL_SECONDARY_ATTRIBUTES',
  /** Returns brand facets for the specific category */
  INCLUDE_BRANDS = 'INCLUDE_BRANDS',
  /** Excludes out of stock sellables while building the facets */
  EXCLUDE_OUT_OF_STOCK = 'EXCLUDE_OUT_OF_STOCK',
  /** Include gender facet */
  INCLUDE_GENDER = 'INCLUDE_GENDER',
  /** Include Sale price facet as a range */
  INCLUDE_SALE_PRICE_RANGE = 'INCLUDE_SALE_PRICE_RANGE',
  /** Only includes sellables that have discounts */
  INCLUDE_DISCOUNTED_ONLY = 'INCLUDE_DISCOUNTED_ONLY'
}

export enum SellableSearchFilter {
  /** 
 * Returns sellables that have discounts only
   * In addition if the sorting is by relevancy, it boosts the sellables that have their price updated recently
   * higher in the result set.
 **/
  DISCOUNTED = 'DISCOUNTED',
  /** Exclude out of stock sellables */
  EXCLUDE_OUT_OF_STOCK = 'EXCLUDE_OUT_OF_STOCK',
  /** Only show sellables that are in stock in Deal warehouse */
  SHIPPED_BY_CURATED = 'SHIPPED_BY_CURATED',
  /** Only show sellables that are drop-shipped by manufacturer */
  SHIPPED_BY_MANUFACTURER = 'SHIPPED_BY_MANUFACTURER',
  /** 
 * Only show sellables with a deal.
   * A sellable is considered to have a Secret deal if its salePriceOverride is lower than the salePrice of all known sources
 **/
  SECRET_DEAL = 'SECRET_DEAL'
}

export type SellableSearchQuery = {
  facets?: Maybe<Array<FacetSelection>>,
  title?: Maybe<Scalars['String']>,
  keywords?: Maybe<Scalars['String']>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  categorySlugs?: Maybe<Array<Scalars['String']>>,
  /** The department Id or slug is internally expanded to include all children categories within the department */
  departmentId?: Maybe<Scalars['DepartmentId']>,
  departmentSlug?: Maybe<Scalars['String']>,
  brandIds?: Maybe<Array<Scalars['BrandId']>>,
  /** If omitted, defaults to CONSUMER_SEARCH */
  sellableSearchUseCase?: Maybe<SellableSearchUseCase>,
  /** Admin/Expert search queries can pass the UserId to see the results that the specified consumer will see. */
  impersonatingUserId?: Maybe<Scalars['UserId']>,
  /** To restrict the search results to a specific SellableType */
  type?: Maybe<SellableType>,
  /** Top N facet terms to be returned per facet. */
  maxFacetTerms?: Maybe<Scalars['Int']>,
  /** 
 * Explicit query filters that are applied to the search results. These provide special query conditions
   * that are different than facets or categories for example.
   * In case of multiple SellableSearchFilters, all input SellableSearchFilters are ANDed
 **/
  filters?: Maybe<Array<SellableSearchFilter>>,
};

export type SellableSearchResultPageMetadata = {
   __typename: 'SellableSearchResultPageMetadata',
  featuredFacets: Array<DisplayFacet>,
  /** 
 * The page title is generated using following rules, that are applied in order:
   * 1. The title is generated based on the Facet Selection input instead of the Facet results.
   * 2. A selected facets value is used only if there is a single selection. This is enforced to keep the title
   *    as clean and simple as possible, instead of adding comma separated values of facet selections.
   * 3. Presence of Brand or Destination is used to imply if the request is for products or services.
   *    If Brand is present it is assumed it is a product category, similarly if destination is present it is
   *    assumed to be a service.
   * 5. Gender applies only to product categories
   * 6. Appends feature facet value if there is a single featured facet with single selection
   * 7. Category names are appended if the category is present. This has 2 forms: Singular or Plural name and the choice
   *    depends on a few factors.
   *    a. If SellableSearchFilters are supplied, it uses the Singular Category name and decorates the title with filter
   *       specific suffix. For ex: Deals for SellableSearchFilter#DISCOUNTED
   *    b. Otherwise, use Plural Category name.
 **/
  pageTitle: Scalars['String'],
  /** 
 * Description about the page.
   * for now this is basically title with the Curated value prop appended
 **/
  pageDescription: Scalars['String'],
  /** An optional image associated with the page title. */
  pageTitleImage?: Maybe<MediaFile>,
};

export enum SellableSearchUseCase {
  CONSUMER_SEARCH = 'CONSUMER_SEARCH',
  EXPERT_SEARCH = 'EXPERT_SEARCH',
  IMPERSONATE_CONSUMER = 'IMPERSONATE_CONSUMER',
  OPS_SEARCH = 'OPS_SEARCH',
  /** This use case for consumer does not take the user intent into account and is basically a simple brand search query */
  CONSUMER_HOME_PAGE_BY_BRANDS = 'CONSUMER_HOME_PAGE_BY_BRANDS'
}

export type SellableServiceLocation = {
   __typename: 'SellableServiceLocation',
  displayTitle?: Maybe<Scalars['String']>,
};


export type SellableServiceLocationDisplayTitleArgs = {
  displayType?: Maybe<SellableServiceLocationDisplayType>
};

export enum SellableServiceLocationDisplayType {
  CITY_STATE = 'CITY_STATE'
}

export enum SellableSort {
  /** Average sale price is calculated as (min + max)/2 for all variations */
  AVG_SALE_PRICE = 'AVG_SALE_PRICE',
  /** Best offer price is our secret deal price and should only be shown to the experts. */
  BEST_OFFER_PRICE = 'BEST_OFFER_PRICE',
  /** Savings = actual price - sale price */
  MAX_PRICE_SAVINGS = 'MAX_PRICE_SAVINGS',
  /** Percent savings = (actual price - sale price)/actual price */
  MAX_PRICE_PERCENT_SAVINGS = 'MAX_PRICE_PERCENT_SAVINGS',
  /** Defined as the unique page views in the last 7 days */
  POPULARITY = 'POPULARITY',
  /** Defined as the number of purchases in the last 30 days */
  BEST_SELLER = 'BEST_SELLER',
  /** Relevance score computed from sellables that match users intent */
  RELEVANCE = 'RELEVANCE',
  /** sort by times recommended by expert */
  MOST_RECOMMENDED_BY_EXPERTS = 'MOST_RECOMMENDED_BY_EXPERTS',
  /** This is the fastest way to get results if ordering is not important */
  INDEX_ORDER = 'INDEX_ORDER',
  /** An stable way to paginate across all indexed documents */
  DOC_ID_ORDER = 'DOC_ID_ORDER'
}

export type SellableSource = {
  type: SellableSourceType,
};

export type SellableSourceExternalId = SellableSource & {
   __typename: 'SellableSourceExternalId',
  type: SellableSourceType,
  externalId: Scalars['String'],
  externalIdType: SellableSourceExternalIdType,
};

export enum SellableSourceExternalIdType {
  YADAV_DIAMOND = 'YADAV_DIAMOND',
  YADAV_SETTING = 'YADAV_SETTING'
}

export type SellableSourceStandardizedSellableGroup = SellableSource & {
   __typename: 'SellableSourceStandardizedSellableGroup',
  type: SellableSourceType,
  standardizedSellableGroup: StandardizedSellableGroup,
};

export enum SellableSourceType {
  URL = 'URL',
  EXTERNAL_ID = 'EXTERNAL_ID',
  STANDARDIZED_SELLABLE_GROUP = 'STANDARDIZED_SELLABLE_GROUP'
}

export type SellableSourceUrl = SellableSource & {
   __typename: 'SellableSourceUrl',
  type: SellableSourceType,
  url: Scalars['String'],
};

export type SellableSpecification = {
   __typename: 'SellableSpecification',
  /** 
 * Internal unique name that can be used as a unique key for referencing this specification entry.
   * This name is human readable and consistent to match the underlying data source (e.g.: attribute:fooBar), so UI
   * treatments can be created if these keys are hard coded and checked against.
 **/
  key?: Maybe<Scalars['String']>,
  /** Display name for the specification */
  name: Scalars['String'],
  /** Display HTML value for the specification */
  valueHtml: Scalars['String'],
};

export type SellableTaskError = {
   __typename: 'SellableTaskError',
  row: Scalars['Int'],
  message: Scalars['String'],
};

export type SellableTerms = {
  id: Scalars['SellableTermsId'],
  createdFor: User,
  createdByExpert?: Maybe<BusinessUser>,
  orderLineItemId: Scalars['OrderLineItemId'],
  order: Order,
  type: SellableType,
};


export enum SellableType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE'
}

export type SellableTypeaheadHit = {
   __typename: 'SellableTypeaheadHit',
  id: Scalars['SellableId'],
  /** The matched text string in the indexed keywords */
  text: Scalars['String'],
  /** The sellable title */
  title: Scalars['String'],
  /** The Brand name associated with this Sellable if present */
  brandName?: Maybe<Scalars['String']>,
  /** 
 * Image url if present for this Sellable. Typically, Sellables will have multiple images but this returns only one
   * since its usage is restricted to the typeahead
 **/
  imageUrl?: Maybe<Scalars['String']>,
  /** For maximum typeahead performance, don't resolve this sellable property */
  sellable: Sellable,
};

export type SellableTypeaheadPayload = {
   __typename: 'SellableTypeaheadPayload',
  hits: Array<SellableTypeaheadHit>,
};

export type SellableTypeaheadQuery = {
  prefixSearch?: Maybe<Scalars['String']>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  categorySlugs?: Maybe<Array<Scalars['String']>>,
  /** The department Id or slug is internally expanded to include all children categories within the department */
  departmentId?: Maybe<Scalars['DepartmentId']>,
  departmentSlug?: Maybe<Scalars['String']>,
  /** If omitted, defaults to CONSUMER_SEARCH */
  sellableSearchUseCase?: Maybe<SellableSearchUseCase>,
};

export type SellableUpdateTaskPayload = {
   __typename: 'SellableUpdateTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  numSellableUpdated: Scalars['Int'],
  numSellableSkipped: Scalars['Int'],
  errors: Array<SellableTaskError>,
  googleSpreadsheetId: Scalars['String'],
};

export type SellableUploadTaskPayload = {
   __typename: 'SellableUploadTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  numSellableUpdated: Scalars['Int'],
  numSellableCreated: Scalars['Int'],
  numSellableDisabled: Scalars['Int'],
  numSellableVariationFilteredOut: Scalars['Int'],
  errorRows: Array<Scalars['Int']>,
  errors: Array<SellableTaskError>,
  googleSpreadsheetId: Scalars['String'],
};

export type SendExpertReferralInput = {
  expertId: Scalars['BusinessUserId'],
  referrerId: Scalars['UserId'],
  emails: Array<Scalars['String']>,
  note: Scalars['String'],
};

export type SendExpertReferralPayload = {
   __typename: 'SendExpertReferralPayload',
  expertReferral?: Maybe<ExpertReferral>,
  errors: Array<Scalars['String']>,
};

export type SendTemplateTestMessageInput = {
  templateId: Scalars['CommTemplateId'],
  variables: Array<RenderCommTemplateVariableInput>,
  channelType: ChannelType,
  contact: Scalars['String'],
};

export type SendTemplateTestMessagePayload = {
   __typename: 'SendTemplateTestMessagePayload',
  success: Scalars['Boolean'],
  error?: Maybe<Scalars['String']>,
};

export type ServiceDealTerms = {
   __typename: 'ServiceDealTerms',
  type: DealTermsType,
  additionalDetails?: Maybe<Scalars['String']>,
};

export type ServiceOfferTerms = {
   __typename: 'ServiceOfferTerms',
  dateTimes?: Maybe<Array<Scalars['Date']>>,
  confirmedTime?: Maybe<Scalars['Date']>,
  additionalDetails?: Maybe<Scalars['String']>,
  termDocuments: Array<MediaFile>,
};

export type ServiceOfferTermsInput = {
  dateTimes?: Maybe<Array<Scalars['Date']>>,
  additionalDetails?: Maybe<Scalars['String']>,
  termDocuments?: Maybe<Array<Scalars['MediaId']>>,
};

export type ServiceSellableTerms = SellableTerms & {
   __typename: 'ServiceSellableTerms',
  id: Scalars['SellableTermsId'],
  createdFor: User,
  createdByExpert?: Maybe<BusinessUser>,
  orderLineItemId: Scalars['OrderLineItemId'],
  order: Order,
  type: SellableType,
  startAt: Scalars['Date'],
};

export type Session = {
   __typename: 'Session',
  id: Scalars['SessionId'],
  token: Scalars['String'],
  experimentUserId: Scalars['AnyId'],
  authenticationMethod?: Maybe<AuthenticationMethod>,
  authenticationState: AuthenticationSessionState,
};


export type SetAcceptingNewRequestsInput = {
  id: Scalars['BusinessUserId'],
  accept: Scalars['Boolean'],
};

export type SetConsumerInitialLeadActionInput = {
  leadId: Scalars['LeadId'],
  action: ConsumerInitialLeadAction,
};

export type SetConsumerInitialLeadActionPayload = {
   __typename: 'SetConsumerInitialLeadActionPayload',
  lead?: Maybe<Lead>,
};

export type SetEscalationPriorityInput = {
  escalationId: Scalars['OrderEscalationId'],
  priority: OrderEscalationPriority,
};

export type SetExpertApplicationArchivedInput = {
  applicationId: Scalars['ExpertApplicationId'],
  archived: Scalars['Boolean'],
};

export type SetExpertApplicationSnoozeInput = {
  applicationId: Scalars['ExpertApplicationId'],
  wakeupTime: Scalars['Date'],
  note?: Maybe<Scalars['String']>,
  message?: Maybe<Scalars['String']>,
  cancelMessageOnReply?: Maybe<Scalars['Boolean']>,
};

export type SetExpertApplicationTaskCompletedInput = {
  applicationId: Scalars['ExpertApplicationId'],
  task: ExpertApplicationTaskType,
};

export type SetExpertApplicationTaskCompletedPayload = {
   __typename: 'SetExpertApplicationTaskCompletedPayload',
  error?: Maybe<Scalars['String']>,
  application: ExpertApplication,
};

export type SetExpertAwayAutoReplyInput = {
  expertId: Scalars['BusinessUserId'],
  effectiveFrom?: Maybe<Scalars['Date']>,
  effectiveUntil: Scalars['Date'],
  message: Scalars['String'],
};

export type SetExpertAwayAutoReplyPayload = {
   __typename: 'SetExpertAwayAutoReplyPayload',
  businessUser?: Maybe<BusinessUser>,
  error?: Maybe<Scalars['String']>,
};

export type SetExpertOffShiftInput = {
  id: Scalars['BusinessUserId'],
};

export type SetExpertOnCallInput = {
  id: Scalars['BusinessUserId'],
  onCall: Scalars['Boolean'],
};

export type SetExpertTeamLeadInput = {
  id: Scalars['BusinessUserId'],
  teamLead: Scalars['Boolean'],
};

export type SetExpertTeamLeadPayload = {
   __typename: 'SetExpertTeamLeadPayload',
  businessUser?: Maybe<BusinessUser>,
  error?: Maybe<Scalars['String']>,
};

export type SetLeadArchivedInput = {
  leadId: Scalars['LeadId'],
  archived: Scalars['Boolean'],
};

export type SetLeadDoNotCallInput = {
  leadId: Scalars['LeadId'],
  doNotCall: Scalars['Boolean'],
};

export type SetLeadSnoozeInput = {
  leadId: Scalars['LeadId'],
  wakeupTime: Scalars['Date'],
  note?: Maybe<Scalars['String']>,
  message?: Maybe<Scalars['String']>,
  cancelMessageOnConsumerReply?: Maybe<Scalars['Boolean']>,
};

export type SetLeadStarInput = {
  leadId: Scalars['LeadId'],
  starred: Scalars['Boolean'],
};

export type SetPreferredMessagingChannelInput = {
  messagingUserId: Scalars['AnyId'],
  preferredMessagingChannel: MessagingChannelType,
};

export type SetPreferredMessagingChannelPayload = {
   __typename: 'SetPreferredMessagingChannelPayload',
  messagingUser: MessagingUser,
};

export type SetPriorityInput = {
  ticketId: Scalars['TicketId'],
  priority: TicketPriority,
};

export type SetTicketBlockedInput = {
  ticketId: Scalars['TicketId'],
  note: Scalars['String'],
};

export type SetTicketDueDateInput = {
  ticketId: Scalars['TicketId'],
  dueDate: Scalars['Date'],
};

export type SetWontCompleteInput = {
  ticketId: Scalars['TicketId'],
  note: Scalars['String'],
  workflowFailureResolution?: Maybe<WorkflowFailureResolution>,
};

export type Shift = {
   __typename: 'Shift',
  id: Scalars['ShiftId'],
  shiftSlot?: Maybe<ShiftSlot>,
  leadSurge?: Maybe<LeadSurge>,
  type: SchedulingType,
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  user: SchedulingUser,
  active: Scalars['Boolean'],
};

export enum ShiftAssignmentMode {
  CLAIM = 'CLAIM',
  RESERVE = 'RESERVE',
  NONE = 'NONE'
}

export type ShiftDailyView = {
   __typename: 'ShiftDailyView',
  date: Scalars['LocalDate'],
  orderedList: Array<Shift>,
  zoneId: Scalars['String'],
};

export type ShiftDailyViewFilter = {
  zoneId: Scalars['String'],
  startDateInclusive: Scalars['LocalDate'],
  endDateExclusive: Scalars['LocalDate'],
  userId: Scalars['AnyId'],
};


export type ShiftSlot = {
   __typename: 'ShiftSlot',
  id?: Maybe<Scalars['ShiftSlotId']>,
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  shiftUnitsRequired: Scalars['BigDecimal'],
  shiftUnitsAvailable: Scalars['BigDecimal'],
  shiftUnitsClaimed: Scalars['BigDecimal'],
  state: ShiftSlotState,
  type: SchedulingType,
  availableUsers: Array<SchedulingUser>,
  assignedUsers: Array<SchedulingUser>,
  claimedByUsers: Array<SchedulingUser>,
  availableUsersIdentity: Array<SchedulingUserIdentity>,
  assignedUsersIdentity: Array<SchedulingUserIdentity>,
  claimedByUsersIdentity: Array<SchedulingUserIdentity>,
};

export type ShiftSlotDailyView = {
   __typename: 'ShiftSlotDailyView',
  date: Scalars['LocalDate'],
  orderedList: Array<ShiftSlot>,
  zoneId: Scalars['String'],
};

export type ShiftSlotDailyViewFilter = {
  zoneId: Scalars['String'],
  startDateInclusive: Scalars['LocalDate'],
  endDateExclusive: Scalars['LocalDate'],
  typeId: Scalars['SchedulingTypeId'],
};


export enum ShiftSlotState {
  SHIFTS_RESERVED = 'SHIFTS_RESERVED',
  SHIFTS_OPEN = 'SHIFTS_OPEN'
}

export type ShiftSlotUserDailyView = {
   __typename: 'ShiftSlotUserDailyView',
  date: Scalars['LocalDate'],
  orderedList: Array<ShiftSlotUserView>,
  zoneId: Scalars['String'],
};

export type ShiftSlotUserDailyViewFilter = {
  zoneId: Scalars['String'],
  startDateInclusive: Scalars['LocalDate'],
  endDateExclusive: Scalars['LocalDate'],
  userId: Scalars['AnyId'],
};

export type ShiftSlotUserView = {
   __typename: 'ShiftSlotUserView',
  id: Scalars['ShiftSlotUserViewId'],
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  availability?: Maybe<SchedulingUserAvailability>,
  claimedSlots: Array<ShiftSlot>,
  claimableSlots: Array<ShiftSlot>,
};


export type ShiftTeamDailyView = {
   __typename: 'ShiftTeamDailyView',
  date: Scalars['LocalDate'],
  orderedList: Array<ShiftTeamView>,
  zoneId: Scalars['String'],
};

export type ShiftTeamDailyViewFilter = {
  zoneId: Scalars['String'],
  startDateInclusive: Scalars['LocalDate'],
  endDateExclusive: Scalars['LocalDate'],
  teamId: Scalars['BusinessUserTeamId'],
  teamMemberId?: Maybe<Scalars['BusinessUserId']>,
};

export type ShiftTeamView = {
   __typename: 'ShiftTeamView',
  /** This is an opaque token to be used as a cache key for this grouping of data; it has no meaning else wise */
  id: Scalars['String'],
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  shifts: Array<Shift>,
};

export type ShiftTimeInterval = {
   __typename: 'ShiftTimeInterval',
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
};

export type ShiftTimeIntervalDailyView = {
   __typename: 'ShiftTimeIntervalDailyView',
  date: Scalars['LocalDate'],
  orderedList: Array<ShiftTimeInterval>,
  zoneId: Scalars['String'],
};

export type ShiftTimeIntervalDailyViewFilter = {
  zoneId: Scalars['String'],
  startDateInclusive: Scalars['LocalDate'],
  endDateExclusive: Scalars['LocalDate'],
  userId: Scalars['AnyId'],
};

export type ShipmentTracking = {
   __typename: 'ShipmentTracking',
  trackingNumber: Scalars['String'],
  shippingCarrier: ShippingCarrier,
  status: ShippingStatus,
  estimatedDeliveryTime?: Maybe<Scalars['Date']>,
  trackingUrl?: Maybe<Scalars['String']>,
};

export type ShipmentTrackingInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
  shippingCarrierId: Scalars['ShippingCarrierId'],
  trackingNumber: Scalars['String'],
};

export type ShipmentTrackingRemovedActivity = OrderActivityDetail & {
   __typename: 'ShipmentTrackingRemovedActivity',
  type: OrderActivityDetailType,
  removedBy?: Maybe<Operator>,
};

export type ShipmentTrackingUpdatedActivity = OrderActivityDetail & {
   __typename: 'ShipmentTrackingUpdatedActivity',
  type: OrderActivityDetailType,
  shippingCarrier: ShippingCarrier,
  trackingNumber: Scalars['String'],
  updatedBy?: Maybe<Operator>,
};

export type ShippingCarrier = {
   __typename: 'ShippingCarrier',
  id: Scalars['ShippingCarrierId'],
  code: Scalars['String'],
  displayName: Scalars['String'],
};


export enum ShippingMethod {
  /** Standard ground (default) */
  STANDARD = 'STANDARD',
  /** Expedited shipping */
  EXPEDITED = 'EXPEDITED'
}

export type ShippingMethodCost = {
   __typename: 'ShippingMethodCost',
  shippingMethod: ShippingMethod,
  cost: MonetaryAmount,
  /** 
 * Rough estimate of when the entire order will be delivered to the customer using this shipping method. If the order
   * isn't purchased yet, this will use the current time to compute the estimation.
 **/
  estimatedToArriveAt: Scalars['Date'],
};

export type ShippingOption = {
   __typename: 'ShippingOption',
  shippingMethod: ShippingMethod,
  estimatedDeliveryTime: Scalars['Int'],
  cost?: Maybe<MonetaryAmount>,
};

export enum ShippingPolicy {
  NO_SHIPPING = 'NO_SHIPPING',
  FREE_SHIPPING = 'FREE_SHIPPING',
  PAID_BY_CUSTOMER = 'PAID_BY_CUSTOMER'
}

export enum ShippingStatus {
  UNKNOWN = 'UNKNOWN',
  IN_TRANSIT = 'IN_TRANSIT',
  DELIVERED = 'DELIVERED',
  FAILURE = 'FAILURE',
  RETURNED = 'RETURNED'
}

export type ShopifyExternalInventoryItemSource = ExternalInventoryItemSource & {
   __typename: 'ShopifyExternalInventoryItemSource',
  type: ExternalInventoryItemSourceType,
  productId: Scalars['String'],
  productVariantId: Scalars['String'],
  inventoryItemId: Scalars['String'],
};

export type ShopifyFulfillmentOrderSource = FulfillmentOrderSource & {
   __typename: 'ShopifyFulfillmentOrderSource',
  type: FulfillmentOrderSourceType,
  /** draft order id on Shopify */
  draftOrderId: Scalars['String'],
  /** 
 * Shopify Order id, if the order was completed successfully.
   * when this value is present it indicates the start of the fulfillment process.
 **/
  orderId?: Maybe<Scalars['String']>,
};

export type ShortenUrlInput = {
  url: Scalars['String'],
  preferredDomain?: Maybe<Scalars['String']>,
};

export type ShortenUrlPayload = {
   __typename: 'ShortenUrlPayload',
  url: Scalars['String'],
};

export type SimilarSellablePayload = {
   __typename: 'SimilarSellablePayload',
  sellables?: Maybe<Array<Sellable>>,
};

export type SimpleCuratedOrder = {
   __typename: 'SimpleCuratedOrder',
  id: Scalars['SimpleCuratedOrderId'],
  curator: BusinessUser,
  curatedFor: User,
  order: Order,
  lead: Lead,
  type: SimpleCuratedOrderType,
  /** Expose id fields for trigger entity */
  curatorId: Scalars['BusinessUserId'],
  curatedForId: Scalars['UserId'],
  leadId: Scalars['LeadId'],
  orderId: Scalars['OrderId'],
};


export enum SimpleCuratedOrderType {
  EXPERT_CONSULTATION_FEE = 'EXPERT_CONSULTATION_FEE'
}

export type SingleCategoryGroupedBrandStatsAggregateExpertReport = {
   __typename: 'SingleCategoryGroupedBrandStatsAggregateExpertReport',
  id: Scalars['CategoryId'],
  category: Category,
  categoryStats: Array<BrandStatsAggregateExpertReport>,
};


export type SingleCategoryGroupedBrandStatsAggregateExpertReportCategoryStatsArgs = {
  limit?: Maybe<Scalars['Int']>
};

export type SingleLocaleTemplateSet = {
   __typename: 'SingleLocaleTemplateSet',
  locale: Scalars['String'],
  templates: Array<ChannelTemplate>,
};

export type SkipFulfillmentChannelInput = {
  ticketId: Scalars['TicketId'],
  fulfillmentChannelId: Scalars['FulfillmentChannelId'],
  status: FulfillmentSuggestionStatus,
  note?: Maybe<Scalars['String']>,
};

export type SlackTemplate = ChannelTemplate & {
   __typename: 'SlackTemplate',
  channelType: ChannelType,
  body: Scalars['String'],
};

export type SlackTemplateInput = {
  body: Scalars['String'],
};

export type SmsTemplate = ChannelTemplate & {
   __typename: 'SmsTemplate',
  channelType: ChannelType,
  body: Scalars['String'],
};

export type SmsTemplateInput = {
  body: Scalars['String'],
};

export type SnoozeChangedActivity = LeadActivity & {
   __typename: 'SnoozeChangedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  oldSnooze?: Maybe<LeadSnooze>,
  newSnooze?: Maybe<LeadSnooze>,
  performedBy: Identity,
};

export type SnoozeSupportTaskActivity = SupportTaskActivity & {
   __typename: 'SnoozeSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  wakeAt: Scalars['Date'],
};

export type SocialMediaAccessToken = {
   __typename: 'SocialMediaAccessToken',
  socialMediaType: SocialMediaType,
  accessToken: Scalars['String'],
};

export type SocialMediaAccessTokenInput = {
  socialMediaType: SocialMediaType,
  accessToken: Scalars['String'],
};

export type SocialMediaLink = {
   __typename: 'SocialMediaLink',
  socialMediaType: SocialMediaType,
  url: Scalars['String'],
};

export enum SocialMediaType {
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  LINKEDIN = 'LINKEDIN',
  INSTAGRAM = 'INSTAGRAM',
  PINTEREST = 'PINTEREST',
  YOUTUBE = 'YOUTUBE',
  STRAVA = 'STRAVA'
}

/** Common ordering context, each query should define its specific sortable fields as enums. */
export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type SplitTriggerWaitEdgesInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
};

export type StandardizedSellable = {
   __typename: 'StandardizedSellable',
  id: Scalars['StandardizedSellableId'],
  rawSellable: RawSellable,
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  imageUrls: Array<Scalars['String']>,
  attributes: Array<Attribute>,
  rawAttributes: Array<RawAttribute>,
  attributeVariationDimensions: Array<Scalars['String']>,
  brand?: Maybe<Brand>,
  category: Category,
  titleVariationDimension: Scalars['Boolean'],
  gtin?: Maybe<Scalars['String']>,
  mpn?: Maybe<Scalars['String']>,
  originalPrice?: Maybe<MonetaryAmount>,
  salePrice?: Maybe<MonetaryAmount>,
  state: StandardizedSellableState,
};

export type StandardizedSellableGroup = {
   __typename: 'StandardizedSellableGroup',
  id: Scalars['StandardizedSellableGroupId'],
  standardizedSellableScores: Array<StandardizedSellableScore>,
  state: StandardizedSellableGroupState,
  mergedInto?: Maybe<StandardizedSellableGroup>,
};

export type StandardizedSellableGroupCandidate = {
   __typename: 'StandardizedSellableGroupCandidate',
  id: Scalars['StandardizedSellableGroupCandidateId'],
  candidateStandardizedSellable: StandardizedSellable,
  group: StandardizedSellableGroup,
  state: StandardizedSellableGroupCandidateState,
  category: Category,
  brand?: Maybe<Brand>,
  reviewedBy?: Maybe<Identity>,
};


export type StandardizedSellableGroupCandidateQuery = {
  candidateIds?: Maybe<Array<Scalars['StandardizedSellableId']>>,
  groupIds?: Maybe<Array<Scalars['StandardizedSellableGroupId']>>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  brandIds?: Maybe<Array<Scalars['BrandId']>>,
  states?: Maybe<Array<StandardizedSellableGroupCandidateState>>,
};

export enum StandardizedSellableGroupCandidateState {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED'
}


export type StandardizedSellableGroupQuery = {
  states?: Maybe<Array<StandardizedSellableGroupState>>,
  standardizedSellableIds?: Maybe<Array<Scalars['StandardizedSellableId']>>,
  dirty?: Maybe<Scalars['Boolean']>,
};

export enum StandardizedSellableGroupState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}


export type StandardizedSellableQuery = {
  rawSellableIds?: Maybe<Array<Scalars['RawSellableId']>>,
  sourceIds?: Maybe<Array<Scalars['RawSellableSourceId']>>,
  variationGroups?: Maybe<Array<RawSellableVariationGroupInput>>,
  states?: Maybe<Array<StandardizedSellableState>>,
};

export type StandardizedSellableScore = {
   __typename: 'StandardizedSellableScore',
  standardizedSellable: StandardizedSellable,
  score: Scalars['Float'],
};

export enum StandardizedSellableState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type StandardReturnPolicy = ReturnPolicy & {
   __typename: 'StandardReturnPolicy',
  type: ReturnPolicyType,
  returnWithinDays: Scalars['Int'],
  returnShippingPaidBy: ReturnShippingPaidBy,
  refundMethod: ReturnRefundMethod,
};

export type StartEscalationInput = {
  escalationId: Scalars['OrderEscalationId'],
  assignedToId?: Maybe<Scalars['OperatorId']>,
};

export type StartExpertConsumerConversationInput = {
  consumerId: Scalars['UserId'],
  expertId: Scalars['BusinessUserId'],
  requestId?: Maybe<Scalars['DealRequestId']>,
  setActive?: Maybe<Scalars['Boolean']>,
};

export type StartExpertConsumerConversationPayload = {
   __typename: 'StartExpertConsumerConversationPayload',
  lead?: Maybe<Lead>,
  conversation?: Maybe<Conversation>,
  error?: Maybe<Scalars['String']>,
};

export type StartExpertRatingInput = {
  expertId: Scalars['BusinessUserId'],
  expertStartRating?: Maybe<Scalars['Int']>,
};

export type StartExpertRatingPayload = {
   __typename: 'StartExpertRatingPayload',
  expert: BusinessUser,
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type StartExpertShiftInput = {
  id: Scalars['BusinessUserId'],
};

export type StartGuestConversationInput = {
  expertId: Scalars['BusinessUserId'],
};

export type StartGuestConversationPayload = {
   __typename: 'StartGuestConversationPayload',
  conversation: GuestConversation,
};

export type StartLeadEscalationInput = {
  type: LeadEscalationType,
  acceptAsLeadExpertRole: LeadExpertRole,
  leadId: Scalars['LeadId'],
};

export type StartLeadEscalationPayload = {
   __typename: 'StartLeadEscalationPayload',
  escalation: LeadEscalation,
};

export type StartOnCallActivity = BusinessUserActivity & {
   __typename: 'StartOnCallActivity',
  id: Scalars['BusinessUserActivityId'],
  type: BusinessUserActivityType,
  occurredAt: Scalars['Date'],
};

export type StartOnCallShiftInput = {
  id: Scalars['BusinessUserId'],
};

export type StartRawSellableSourceIngestionInput = {
  sourceId: Scalars['RawSellableSourceId'],
};

export type StartRawSellableSourceIngestionPayload = {
   __typename: 'StartRawSellableSourceIngestionPayload',
  hasError: Scalars['Boolean'],
  errors?: Maybe<Array<Scalars['String']>>,
};

export type StartRawSellableStandardizationInput = {
  query: RawSellableQuery,
};

export type StartRawSellableStandardizationPayload = {
   __typename: 'StartRawSellableStandardizationPayload',
  count: Scalars['Long'],
};

export type StartReceivingLeadsActivity = BusinessUserActivity & {
   __typename: 'StartReceivingLeadsActivity',
  id: Scalars['BusinessUserActivityId'],
  type: BusinessUserActivityType,
  occurredAt: Scalars['Date'],
};

export type StartStandardizationSellableMatchingInput = {
  query: StandardizedSellableQuery,
};

export type StartStandardizationSellableMatchingPayload = {
   __typename: 'StartStandardizationSellableMatchingPayload',
  count: Scalars['Long'],
};

export type StartStandardizedSellableGroupIngestionInput = {
  query: StandardizedSellableGroupQuery,
};

export type StartStandardizedSellableGroupIngestionPayload = {
   __typename: 'StartStandardizedSellableGroupIngestionPayload',
  hasError: Scalars['Boolean'],
  errors?: Maybe<Array<Scalars['String']>>,
};

export type StartSupportConversationInput = {
  consumerId: Scalars['UserId'],
};

export type StartSystemCuratedItemSurveyPayload = {
   __typename: 'StartSystemCuratedItemSurveyPayload',
  data?: Maybe<SystemCuratedItemSurvey>,
  error?: Maybe<Scalars['String']>,
};

export type StopOnCallActivity = BusinessUserActivity & {
   __typename: 'StopOnCallActivity',
  id: Scalars['BusinessUserActivityId'],
  type: BusinessUserActivityType,
  occurredAt: Scalars['Date'],
};

export type StopReceivingLeadsActivity = BusinessUserActivity & {
   __typename: 'StopReceivingLeadsActivity',
  id: Scalars['BusinessUserActivityId'],
  type: BusinessUserActivityType,
  occurredAt: Scalars['Date'],
};

export enum StringFieldType {
  EMAIL_ADDRESS = 'EMAIL_ADDRESS',
  DURATION = 'DURATION'
}

export type StripeAccount = PaymentProcessorAccount & {
   __typename: 'StripeAccount',
  id: Scalars['PaymentProcessorAccountId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  type: PaymentProcessorType,
  userId: Scalars['UserId'],
  paymentSources?: Maybe<Array<PaymentSource>>,
  externalAccountId?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
};

export type StripeAddress = {
   __typename: 'StripeAddress',
  line1?: Maybe<Scalars['String']>,
  line2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  postalCode: Scalars['String'],
};

export enum StripeAuthenticationFlow {
  REDIRECT = 'redirect',
  RECEIVER = 'receiver',
  CODE_VERIFICATION = 'code_verification',
  NONE = 'none'
}

export type StripeCodeVerification = {
   __typename: 'StripeCodeVerification',
  /** The number of attempts remaining to authenticate the source object with a verification code. */
  attemptsRemaining?: Maybe<Scalars['Int']>,
  status?: Maybe<StripeCodeVerificationStatus>,
};

export enum StripeCodeVerificationStatus {
  PENDING = 'pending',
  AWAITING_VERIFICATION = 'awaiting_verification',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed'
}

export type StripeOwner = {
   __typename: 'StripeOwner',
  address?: Maybe<StripeAddress>,
  email?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  verifiedAddress?: Maybe<StripeAddress>,
  verifiedEmail?: Maybe<Scalars['String']>,
  verifiedName?: Maybe<Scalars['String']>,
  verifiedPhone?: Maybe<Scalars['String']>,
};

export type StripePaymentSource = PaymentSource & {
   __typename: 'StripePaymentSource',
  id: Scalars['PaymentSourceId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  externalSourceId: Scalars['String'],
  type: PaymentProcessorType,
  usage: PaymentSourceUsage,
  status: PaymentSourceStatus,
  userId: Scalars['UserId'],
  billingAddress?: Maybe<Address>,
  paymentEntity: PaymentEntity,
  isDefault: Scalars['Boolean'],
  /** 
 * Stripe specific attributes
   * The client secret of the source. Used for client-side retrieval using a publishable key.
 **/
  clientSecret?: Maybe<Scalars['String']>,
  authenticationFlow?: Maybe<StripeAuthenticationFlow>,
  codeVerification?: Maybe<StripeCodeVerification>,
  /** Flag indicating whether the object exists in live mode or test mode. */
  liveMode?: Maybe<Scalars['Boolean']>,
  owner?: Maybe<StripeOwner>,
};

export type SubjectIdInConditionDefinition = ConditionDefinition & {
   __typename: 'SubjectIdInConditionDefinition',
  type: ConditionType,
  subjectIds: Array<Scalars['String']>,
};

export type SubjectIdInConditionDefinitionInput = {
  subjectIds: Array<Scalars['String']>,
};

export type SubmitDatePathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  value?: Maybe<Scalars['Date']>,
};

export type SubmitDatePathFlowQuestionInputTypeCopy = {
   __typename: 'SubmitDatePathFlowQuestionInputTypeCopy',
  value?: Maybe<Scalars['Date']>,
};

export type SubmitDatePathFlowQuestionPayload = {
   __typename: 'SubmitDatePathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type SubmitDateRangePathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  startValue?: Maybe<Scalars['Date']>,
  endValue?: Maybe<Scalars['Date']>,
};

export type SubmitDateRangePathFlowQuestionInputTypeCopy = {
   __typename: 'SubmitDateRangePathFlowQuestionInputTypeCopy',
  startValue?: Maybe<Scalars['Date']>,
  endValue?: Maybe<Scalars['Date']>,
};

export type SubmitDateRangePathFlowQuestionPayload = {
   __typename: 'SubmitDateRangePathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type SubmitIdPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  value?: Maybe<Array<Scalars['AnyId']>>,
};

export type SubmitIdPathFlowQuestionInputTypeCopy = {
   __typename: 'SubmitIdPathFlowQuestionInputTypeCopy',
  value: Array<Scalars['AnyId']>,
};

export type SubmitIdPathFlowQuestionPayload = {
   __typename: 'SubmitIdPathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type SubmitInputTextPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  value?: Maybe<Scalars['String']>,
};

/** Identical to SubmitInputTextPathFlowQuestionInput used to include in output schemas */
export type SubmitInputTextPathFlowQuestionInputTypeCopy = {
   __typename: 'SubmitInputTextPathFlowQuestionInputTypeCopy',
  /** Same fields as SubmitInputTextPathFlowQuestionInput */
  value?: Maybe<Scalars['String']>,
};

export type SubmitInputTextPathFlowQuestionPayload = {
   __typename: 'SubmitInputTextPathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type SubmitListPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  /** 
 * If values were selected, specify them here.
   * Note that this is called value and not values to be consistent with other question inputs
 **/
  value?: Maybe<Array<Scalars['String']>>,
  /** 
 * If other was filled out, specify the input here.
   * Note that values and other are mutually exclusive - only one should be filled out.
 **/
  other?: Maybe<Scalars['String']>,
};

/** Identical to SubmitListPathFlowQuestionInput used to include in output schemas */
export type SubmitListPathFlowQuestionInputTypeCopy = {
   __typename: 'SubmitListPathFlowQuestionInputTypeCopy',
  /** 
 * If values were selected, specify them here.
   * Note that this is called value and not values to be consistent with other question inputs
 **/
  value?: Maybe<Array<Scalars['String']>>,
  /** 
 * If other was filled out, specify the input here.
   * Note that values and other are mutually exclusive - only one should be filled out.
 **/
  other?: Maybe<Scalars['String']>,
};

export type SubmitListPathFlowQuestionPayload = {
   __typename: 'SubmitListPathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type SubmitNumericPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  value?: Maybe<Scalars['Int']>,
};

export type SubmitNumericPathFlowQuestionInputTypeCopy = {
   __typename: 'SubmitNumericPathFlowQuestionInputTypeCopy',
  value?: Maybe<Scalars['Int']>,
  decimalValue?: Maybe<Scalars['BigDecimal']>,
};

export type SubmitNumericPathFlowQuestionPayload = {
   __typename: 'SubmitNumericPathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type SubmitOAuthEmailPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  email: Scalars['String'],
  googleIdToken?: Maybe<Scalars['String']>,
  facebookUserAccessToken?: Maybe<Scalars['String']>,
  skipFirstName?: Maybe<Scalars['String']>,
  skipLastName?: Maybe<Scalars['String']>,
};

export type SubmitOAuthEmailPathFlowQuestionInputTypeCopy = {
   __typename: 'SubmitOAuthEmailPathFlowQuestionInputTypeCopy',
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  googleIdToken?: Maybe<Scalars['String']>,
  facebookUserAccessToken?: Maybe<Scalars['String']>,
  skipFirstName?: Maybe<Scalars['String']>,
  skipLastName?: Maybe<Scalars['String']>,
};

export type SubmitOAuthEmailPathFlowQuestionPayload = {
   __typename: 'SubmitOAuthEmailPathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type SubmitOrderInput = {
  orderId: Scalars['OrderId'],
  paymentSourceId: Scalars['PaymentSourceId'],
};

export type SubmitOrderPayload = {
   __typename: 'SubmitOrderPayload',
  order: Order,
};

export type SubmitPathFlowPageInput = {
  pathFlowId: Scalars['PathFlowId'],
  pageName: Scalars['String'],
};

export type SubmitPathFlowPagePayload = EncodedAuthenticationTokensPayload & {
   __typename: 'SubmitPathFlowPagePayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
  /** If a new user is registered as part of this path flow page submit */
  newUserRegistered: Scalars['Boolean'],
  /** If a new deal request is created as part of this path flow page submit */
  newRequestCreated: Scalars['Boolean'],
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};

export type SubmitUserContactPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  phoneNumber: Scalars['String'],
};

export type SubmitUserContactPathFlowQuestionInputTypeCopy = {
   __typename: 'SubmitUserContactPathFlowQuestionInputTypeCopy',
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  phoneNumber?: Maybe<Scalars['String']>,
};

export type SubmitUserContactPathFlowQuestionPayload = {
   __typename: 'SubmitUserContactPathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type Subscription = {
   __typename: 'Subscription',
  /** 
 * Updates when the user's order in CART status has line items that change (item added, removed, or quantity changes),
   * or the cart is replaced (user purchases previous cart and a new cart is generated). Intended for use cases like
   * keeping the items in cart badge updated.
   * If `userId` is omitted, it will use the current viewer (assumed to be a user)
 **/
  userCartLineItemsChanged: Order,
  expertApplicationsPendingReviewChanged: ExpertApplicationSubscriptionChange,
  expertApplicationsPendingReviewCountChanged: Scalars['Int'],
  expertApplicationsPendingApprovalChanged: ExpertApplicationSubscriptionChange,
  expertApplicationsPendingActivationChanged: ExpertApplicationSubscriptionChange,
  expertApplicationFolderChanged: ExpertApplicationFolder,
  expertApplicationFolderItemChanged: ExpertApplicationFolderItemChange,
  expertNotification: ExpertNotification,
  expertLeadFolderChanged: ExpertLeadFolder,
  expertLeadFolderItemChanged: ExpertLeadFolderItemChange,
  leadEscalationChanged: LeadEscalation,
  expertLeadIntentChanged: LeadIntentChange,
  leadChanged: Lead,
  heartbeat: Scalars['Boolean'],
  /** 
 * Consumer API; subscription version of the read query `expertCuratedOrder` that broadcasts changes to the curated
   * order, except for changes while the curated order is in draft state.
 **/
  expertCuratedOrderChanged: ExpertCuratedOrderChangedPayload,
  /** 
 * Consumer API; subscription version of the read query `expertCuratedOrdersForLeadConnection` that broadcasts changes
   * when any curated order associated with the queried lead changes state, except for curated orders in draft state.
 **/
  expertCuratedOrdersForLeadConnectionChanged: ExpertCuratedOrdersForLeadConnectionChangedPayload,
  /** 
 * Subscription that emits changes when a expert curated item is modified (excluding draft modifications/creations),
   * and when the consumer's active cart is modified. This makes it possible to get an up to date view on both the
   * active curated items (e.g.: pick up changes if the consumer dismisses an item), as well as cart updates the user
   * makes (allows experts to dynamically refresh the `lineItemInCart` property).
 **/
  expertCuratedItemsByCategoryChanged: ExpertCuratedItemsByCategoryChangedPayload,
  expertCuratedItemsChanged: ExpertCuratedItemsChangedPayload,
  leadActivityOccurred: LeadActivity,
  supportTaskOperatorFolderChanged: SupportTaskFolderEvent,
  supportTaskOperatorFolderListChanged: SupportTaskListEvent,
  newEscalationCount: NewOrderEscalationNotification,
  escalationFacetCounts: EscalationFacetCountsPayload,
  orderEscalationCreated: OrderEscalation,
  supportConversationsCount: SupportConversationCountNotification,
};


export type SubscriptionUserCartLineItemsChangedArgs = {
  userId?: Maybe<Scalars['UserId']>
};


export type SubscriptionExpertApplicationsPendingApprovalChangedArgs = {
  reviewedOnly?: Maybe<Scalars['Boolean']>
};


export type SubscriptionExpertApplicationFolderChangedArgs = {
  departmentId?: Maybe<Scalars['DepartmentId']>,
  approvedById?: Maybe<Scalars['OperatorId']>
};


export type SubscriptionExpertApplicationFolderItemChangedArgs = {
  departmentId?: Maybe<Scalars['DepartmentId']>,
  approvedById?: Maybe<Scalars['OperatorId']>,
  folderSlug: Scalars['String']
};


export type SubscriptionExpertNotificationArgs = {
  expertId: Scalars['BusinessUserId']
};


export type SubscriptionExpertLeadFolderChangedArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>,
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>
};


export type SubscriptionExpertLeadFolderItemChangedArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>,
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>,
  folderSlug: Scalars['String']
};


export type SubscriptionLeadEscalationChangedArgs = {
  id: Scalars['LeadEscalationId']
};


export type SubscriptionExpertLeadIntentChangedArgs = {
  expertId: Scalars['BusinessUserId']
};


export type SubscriptionLeadChangedArgs = {
  leadId: Scalars['LeadId']
};


export type SubscriptionExpertCuratedOrderChangedArgs = {
  id: Scalars['ExpertCuratedOrderId']
};


export type SubscriptionExpertCuratedOrdersForLeadConnectionChangedArgs = {
  query: ExpertCuratedOrdersForLeadQueryInput,
  first?: Maybe<Scalars['Int']>
};


export type SubscriptionExpertCuratedItemsByCategoryChangedArgs = {
  leadId: Scalars['LeadId']
};


export type SubscriptionExpertCuratedItemsChangedArgs = {
  leadId: Scalars['LeadId']
};


export type SubscriptionLeadActivityOccurredArgs = {
  expertId: Scalars['BusinessUserId'],
  types: Array<LeadActivityType>,
  teamActivityTypes?: Maybe<Array<LeadActivityType>>
};


export type SubscriptionSupportTaskOperatorFolderChangedArgs = {
  operatorId: Scalars['OperatorId'],
  supportTaskType: SupportTaskType
};


export type SubscriptionSupportTaskOperatorFolderListChangedArgs = {
  operatorId: Scalars['OperatorId'],
  supportTaskType: SupportTaskType,
  folderSlug: Scalars['String']
};


export type SubscriptionEscalationFacetCountsArgs = {
  searchQuery: OrderEscalationSearchInput,
  facetNames: Array<Maybe<Scalars['String']>>
};


export type SubscriptionSupportConversationsCountArgs = {
  query?: Maybe<SupportConversationQueryInput>
};

export type SuggestedAction = {
   __typename: 'SuggestedAction',
  type: SuggestedActionType,
  headline: Scalars['String'],
  reason: Scalars['String'],
  suggestedMessage?: Maybe<Scalars['String']>,
};

export enum SuggestedActionType {
  SEND_INITIAL_RESPONSE = 'SEND_INITIAL_RESPONSE',
  RESPOND_TO_NEW_MESSAGE = 'RESPOND_TO_NEW_MESSAGE',
  FOLLOW_UP = 'FOLLOW_UP',
  SNOOZE = 'SNOOZE',
  STAR = 'STAR',
  ARCHIVE = 'ARCHIVE',
  REQUEST_EXPERT_REVIEW = 'REQUEST_EXPERT_REVIEW',
  REQUEST_EXPERT_REFERRAL = 'REQUEST_EXPERT_REFERRAL',
  SEND_CURATION = 'SEND_CURATION',
  CLASSIFY_ARCHIVED_LEAD = 'CLASSIFY_ARCHIVED_LEAD',
  REVIEW_SURVEY = 'REVIEW_SURVEY',
  FULFILL_PROMISE = 'FULFILL_PROMISE',
  CURATION_VIEWED_FOLLOW_UP = 'CURATION_VIEWED_FOLLOW_UP',
  SELLABLE_VIEWED_FOLLOW_UP = 'SELLABLE_VIEWED_FOLLOW_UP',
  PRODUCT_ADDED_TO_CART_FOLLOW_UP = 'PRODUCT_ADDED_TO_CART_FOLLOW_UP'
}

export type SuggestedAlternativeSellable = {
   __typename: 'SuggestedAlternativeSellable',
  id: Scalars['SuggestedAlternativeSellableId'],
  originalSellable: Sellable,
  suggestedSellable: Sellable,
  /** Lead for whom this suggestion was made */
  lead: Lead,
  mostPopularTag?: Maybe<ExpertCuratedItemTag>,
  /** review details if this item has been reviewed by an expert */
  expertReview?: Maybe<SuggestedSellableExpertReview>,
};

export type SuggestedAlternativeSellableConnection = {
   __typename: 'SuggestedAlternativeSellableConnection',
  pageInfo: PageInfo,
  edges: Array<SuggestedAlternativeSellableEdge>,
};

export type SuggestedAlternativeSellableEdge = {
   __typename: 'SuggestedAlternativeSellableEdge',
  cursor: Scalars['String'],
  node: SuggestedAlternativeSellable,
};


export type SuggestedAlternativeSellableInput = {
  /** Sellables for which suggestions are being requested. */
  sellableIds: Array<Scalars['SellableId']>,
  /** if set and there are curations for the sellable with tags, return the most popular tag */
  includeCuratedItemTag?: Maybe<Scalars['Boolean']>,
  /** Explicit filters for the results. */
  filters: Array<SuggestedSellableFilter>,
  /** lead for whom the recommendations will be created */
  leadId: Scalars['LeadId'],
};

export type SuggestedAlternativeSellableSearchInput = {
  /** Sellables for which suggestions are being requested. */
  sellableIds: Array<Scalars['SellableId']>,
  /** Any Explicit filters for the results. */
  filters: Array<SuggestedSellableFilter>,
};

export type SuggestedExpertCuratedItems = {
   __typename: 'SuggestedExpertCuratedItems',
  /** The suggested ExpertCuratedItem */
  expertCuratedItems: Array<ExpertCuratedItem>,
  /** Attributes that were common between the requested user and the user to whom these ExpertCuratedItem's were recommended. */
  commonUserRequestAttributes: Array<FormattedAttribute>,
  /** Relevance Metadata for reconciling when a new ExpertCuratedItem is created from the suggested expertCuratedItems above. */
  relevanceMetadata?: Maybe<Scalars['String']>,
  /** The lead to who these ExpertCuratedItem's were recommended. */
  sourceLead?: Maybe<Lead>,
  /** a list of request attributes that can be used to tag this saved curation */
  suggestedTaggableRequestAttributes: Array<SuggestedExpertTaggableRequestAttribute>,
  /** Rank of this Lead in the group of other similar leads */
  rank?: Maybe<Scalars['Int']>,
  /** How closely this lead matches the query lead */
  matchPercent?: Maybe<Scalars['Float']>,
};

/** 
 * SuggestedExpertTaggableRequestAttribute consist of all values of the Attribute that are marked AttributeFunction,TAGGABLE
 * during the schema definition.
 * The values are further flagged if they were selected by the lead in the request, which can be used on the UI
 * to auto tag the curation.
 **/
export type SuggestedExpertTaggableRequestAttribute = {
   __typename: 'SuggestedExpertTaggableRequestAttribute',
  attributeSchema: AttributeSchema,
  values: Array<SuggestedExpertTaggableRequestAttributeValue>,
};

export type SuggestedExpertTaggableRequestAttributeValue = {
   __typename: 'SuggestedExpertTaggableRequestAttributeValue',
  attributeValue: AttributeValue,
  displayValue: Scalars['String'],
  selectedByLead: Scalars['Boolean'],
};

export type SuggestedSellableExpertReview = {
   __typename: 'SuggestedSellableExpertReview',
  isSuggestionGood: SuggestedSellableReviewAnswerWithDisplayName,
  expert: BusinessUser,
};

export enum SuggestedSellableFilter {
  /** Whether to exclude out of stock sellables */
  EXCLUDE_OUT_OF_STOCK = 'EXCLUDE_OUT_OF_STOCK',
  /** Only show sellables that are in stock in Deal warehouse */
  SHIPPED_BY_CURATED = 'SHIPPED_BY_CURATED',
  /** Only show sellables that are drop-shipped by manufacturer */
  SHIPPED_BY_MANUFACTURER = 'SHIPPED_BY_MANUFACTURER',
  /** 
 * Only show sellables with a deal, a sellable is considered to have a Secret deal if its salePriceOverride is
   * lower than the salePrice of all known sources
 **/
  SECRET_DEAL = 'SECRET_DEAL'
}

export enum SuggestedSellableReviewAnswer {
  YES = 'YES',
  NOT_SURE = 'NOT_SURE',
  NO = 'NO'
}

export type SuggestedSellableReviewAnswerWithDisplayName = {
   __typename: 'SuggestedSellableReviewAnswerWithDisplayName',
  answer: SuggestedSellableReviewAnswer,
  displayName: Scalars['String'],
};

export enum SuggestedSupportAction {
  SUPPORT_RESPONSE_NEEDED = 'SUPPORT_RESPONSE_NEEDED'
}

export type SuggestExpertCuratedItemNotesConnection = {
   __typename: 'SuggestExpertCuratedItemNotesConnection',
  edges: Array<SuggestExpertCuratedItemNotesEdge>,
  pageInfo: PageInfo,
};

export type SuggestExpertCuratedItemNotesEdge = {
   __typename: 'SuggestExpertCuratedItemNotesEdge',
  node: ExpertCuratedItemNote,
  cursor: Scalars['String'],
};

export type SuggestExpertCuratedItemNotesQueryInput = {
  /** Suggested notes will be given for the parent of this sellable (or this sellable directly if it's already the parent) */
  sellableId: Scalars['SellableId'],
};

export enum SuggestExpertCuratedItemNotesSort {
  /** Sort by purchase rate, usage count, note length */
  DEFAULT = 'DEFAULT',
  /** Sort by usage count, note length */
  USAGES = 'USAGES'
}

export type SuggestExpertCuratedItemsForLeadConnection = {
   __typename: 'SuggestExpertCuratedItemsForLeadConnection',
  facets: Array<DisplayFacet>,
  edges: Array<SuggestExpertCuratedItemsForLeadEdge>,
  pageInfo: PageInfo,
  count: Scalars['Int'],
};

export type SuggestExpertCuratedItemsForLeadEdge = {
   __typename: 'SuggestExpertCuratedItemsForLeadEdge',
  node: SuggestedExpertCuratedItems,
  cursor: Scalars['String'],
};

export type SuggestExpertCuratedItemsForLeadQueryInput = {
  /** Facets to filter search result */
  facets?: Maybe<Array<FacetSelection>>,
  /** The category for which the expert curated item is being searched. */
  categoryId: Scalars['CategoryId'],
  /** The lead for whom the ExpertCuratedItems are being searched for. */
  searchingForLead: Scalars['LeadId'],
  /** Top N facet terms to be returned per facet. */
  maxFacetTerms?: Maybe<Scalars['Int']>,
  /** 
 * Explicit query filters that are applied to the results. These provide special query conditions
   * that are different than facets or categories for example.
   * In case of multiple SuggestedExpertCuratedItemFilter, all input SellableSearchFilters are ANDed
   * Note, this currently explicitly excludes out of stock sellables from recommendations
 **/
  filters?: Maybe<Array<SuggestedSellableFilter>>,
};

export type SuggestLeadActionsSupportTaskActivity = SupportTaskActivity & {
   __typename: 'SuggestLeadActionsSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  suggestedActions: Array<SuggestedActionType>,
};

export type SummarizedAddSellableUserActivity = SummarizedUserActivity & {
   __typename: 'SummarizedAddSellableUserActivity',
  sellable: Sellable,
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
};

export type SummarizedCheckoutStartedUserActivity = SummarizedUserActivity & {
   __typename: 'SummarizedCheckoutStartedUserActivity',
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
};

export type SummarizedPaymentInfoEnteredUserActivity = SummarizedUserActivity & {
   __typename: 'SummarizedPaymentInfoEnteredUserActivity',
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
};

export type SummarizedRemoveSellableUserActivity = SummarizedUserActivity & {
   __typename: 'SummarizedRemoveSellableUserActivity',
  sellable: Sellable,
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
};

export type SummarizedSavedSellableUserActivity = SummarizedUserActivity & {
   __typename: 'SummarizedSavedSellableUserActivity',
  sellable: Sellable,
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
  saved: Scalars['Boolean'],
  reason?: Maybe<Scalars['String']>,
};

export type SummarizedUnSavedSellableUserActivity = SummarizedUserActivity & {
   __typename: 'SummarizedUnSavedSellableUserActivity',
  sellable: Sellable,
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
  reason?: Maybe<Scalars['String']>,
};

export type SummarizedUserActivity = {
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
};

export type SummarizedViewCartUserActivity = SummarizedUserActivity & {
   __typename: 'SummarizedViewCartUserActivity',
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
};

export type SummarizedViewCuratedListUserActivity = SummarizedUserActivity & {
   __typename: 'SummarizedViewCuratedListUserActivity',
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
  lead: Lead,
};

export type SummarizedViewSellableUserActivity = SummarizedUserActivity & {
   __typename: 'SummarizedViewSellableUserActivity',
  sellable: Sellable,
  count: Scalars['Int'],
  lastViewedAt: Scalars['Date'],
  lastViewEndedAt?: Maybe<Scalars['Date']>,
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
};

export type SupportConversation = {
   __typename: 'SupportConversation',
  id: Scalars['SupportConversationId'],
  version: Scalars['Int'],
  updatedAt: Scalars['Date'],
  createdAt: Scalars['Date'],
  conversationId: Scalars['ConversationId'],
  consumerId: Scalars['UserId'],
  conversation: Conversation,
  supportLastMessagedAt?: Maybe<Scalars['Date']>,
  consumerLastMessagedAt?: Maybe<Scalars['Date']>,
  suggestedActions: Array<SuggestedSupportAction>,
  consumerUnreadCount: Scalars['Int'],
  consumer: User,
  escalations: Array<OrderEscalation>,
};

export type SupportConversationCountNotification = {
   __typename: 'SupportConversationCountNotification',
  conversationsCount: Scalars['Long'],
};

export type SupportConversationEdge = {
   __typename: 'SupportConversationEdge',
  node: SupportConversation,
  cursor: Scalars['String'],
};


export type SupportConversationQueryInput = {
  consumerLastMessagedAfter?: Maybe<Scalars['Date']>,
  needResponse?: Maybe<Scalars['Boolean']>,
  mustHaveConsumerActivity?: Maybe<Scalars['Boolean']>,
};

export type SupportConversationsConnection = {
   __typename: 'SupportConversationsConnection',
  edges: Array<SupportConversationEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export type SupportedPaymentMethod = {
   __typename: 'SupportedPaymentMethod',
  paymentMethod: PaymentMethod,
  paymentProvider: PaymentProcessorType,
};

export type SupportMessagingUser = {
   __typename: 'SupportMessagingUser',
  id: Scalars['AnyId'],
  displayName: Scalars['String'],
};

export type SupportTask = {
  id: Scalars['SupportTaskId'],
  type: SupportTaskType,
  state: SupportTaskState,
  url: Scalars['String'],
  dueAt: Scalars['Date'],
  assignedTo?: Maybe<Operator>,
  assignedAt?: Maybe<Scalars['Date']>,
  completedAt?: Maybe<Scalars['Date']>,
};

export enum SupportTaskAction {
  CREATE_TASK = 'CREATE_TASK',
  ASSIGN = 'ASSIGN',
  UNASSIGN = 'UNASSIGN',
  DISMISS = 'DISMISS',
  DELEGATE_LEAD = 'DELEGATE_LEAD',
  REASSIGN_LEAD = 'REASSIGN_LEAD',
  SUGGEST_LEAD_ACTIONS = 'SUGGEST_LEAD_ACTIONS',
  ESCALATE_LEAD_FOR_DELEGATION = 'ESCALATE_LEAD_FOR_DELEGATION',
  ESCALATE_LEAD_FOR_REASSIGNMENT = 'ESCALATE_LEAD_FOR_REASSIGNMENT',
  REQUEST_ORDER_SUPPORT_FOR_LEAD = 'REQUEST_ORDER_SUPPORT_FOR_LEAD',
  SNOOZE = 'SNOOZE',
  UNSNOOZE = 'UNSNOOZE'
}

export type SupportTaskActivity = {
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
};


export type SupportTaskActor = Operator | SystemUser;

export type SupportTaskAssignedToQuery = {
  assigneeIds: Array<Scalars['OperatorId']>,
  includeUnassigned?: Maybe<Scalars['Boolean']>,
};

export type SupportTaskFolder = {
   __typename: 'SupportTaskFolder',
  id: Scalars['SupportTaskFolderId'],
  slug: Scalars['String'],
  displayName: Scalars['String'],
  badgeCount?: Maybe<Scalars['Int']>,
};

export type SupportTaskFolderEvent = {
   __typename: 'SupportTaskFolderEvent',
  folder: SupportTaskFolder,
};



export type SupportTaskListEvent = {
   __typename: 'SupportTaskListEvent',
  supportTask: SupportTask,
  type: SupportTaskListEventType,
};

export enum SupportTaskListEventType {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

export type SupportTaskQuery = {
  types?: Maybe<Array<SupportTaskType>>,
  states?: Maybe<Array<SupportTaskState>>,
  dueAtRange?: Maybe<DateRangeInput>,
  assignedTo?: Maybe<SupportTaskAssignedToQuery>,
};

export type SupportTasksConnection = {
   __typename: 'SupportTasksConnection',
  edges: Array<SupportTasksEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export type SupportTasksEdge = {
   __typename: 'SupportTasksEdge',
  node: SupportTask,
  cursor: Scalars['String'],
};

export enum SupportTaskState {
  PENDING = 'PENDING',
  ASSIGNED = 'ASSIGNED',
  COMPLETED = 'COMPLETED'
}

export enum SupportTaskType {
  LEAD = 'LEAD',
  ORDER = 'ORDER'
}

export type SurveySummary = {
   __typename: 'SurveySummary',
  lastSystemCuratedItemSurvey: SystemCuratedItemSurvey,
  lastSystemCuratedItemSurveySentAt: Scalars['Date'],
};

export type SwapTriggerBranchEdgesInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
};

export type SwapTriggerWaitEdgesInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
};

export type SyncExternalAdCampaignsInput = {
  categoryId: Scalars['CategoryId'],
};

export type SyncExternalAdCampaignsPayload = {
   __typename: 'SyncExternalAdCampaignsPayload',
  adCampaigns: Array<ExternalAdCampaign>,
};

export type SyncItemShippingStatusInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
  isReturn?: Maybe<Scalars['Boolean']>,
  fulfillmentOrderId?: Maybe<Scalars['FulfillmentOrderId']>,
};

export type SyncOrderInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>,
  useCase: CartSyncUseCase,
};

export type SyncOrderPayload = {
   __typename: 'SyncOrderPayload',
  order: Order,
};

export type SyncOrderReturnShipmentTrackingInput = {
  orderRefundId: Scalars['OrderRefundId'],
};

export type SyncShopifyInventoryPayload = {
   __typename: 'SyncShopifyInventoryPayload',
  data?: Maybe<SellableInventoryItem>,
  error?: Maybe<Scalars['String']>,
  hasError: Scalars['Boolean'],
};

export enum SystemCuratedConsumerSellableReactionRating {
  SKIP = 'SKIP',
  DISLIKE = 'DISLIKE',
  LIKE = 'LIKE',
  LOVE = 'LOVE'
}

export type SystemCuratedItem = {
   __typename: 'SystemCuratedItem',
  id: Scalars['SystemCuratedItemId'],
  type: SystemCuratedItemType,
  sellable: Sellable,
  category: Category,
  systemCuratedItemSource: SystemCuratedItemSource,
};


export type SystemCuratedItemSource = {
  type?: Maybe<SystemCuratedItemType>,
};

export type SystemCuratedItemSurvey = {
   __typename: 'SystemCuratedItemSurvey',
  id: Scalars['SystemCuratedItemSurveyId'],
  systemCuratedItems: Array<SystemCuratedItem>,
  ended: Scalars['Boolean'],
  startedAt?: Maybe<Scalars['Date']>,
  endedAt?: Maybe<Scalars['Date']>,
  terminationReason?: Maybe<SystemCuratedItemSurveyTerminationReason>,
  stats?: Maybe<SystemCuratedItemSurveyStats>,
  /** skipped all questions */
  skippedAll?: Maybe<Scalars['Boolean']>,
  /** answered some question before early termination */
  answeredSome?: Maybe<Scalars['Boolean']>,
  /** all questions answered, inclusive of skips */
  answeredAll?: Maybe<Scalars['Boolean']>,
};


export type SystemCuratedItemSurveyStats = {
   __typename: 'SystemCuratedItemSurveyStats',
  ratingStats: Array<ConsumerSellableReactionRatingStats>,
};

export enum SystemCuratedItemSurveyTerminationReason {
  SKIPPED = 'SKIPPED',
  TERMINATED_EARLY = 'TERMINATED_EARLY',
  REVIEWED_ALL = 'REVIEWED_ALL'
}

export enum SystemCuratedItemType {
  EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER = 'EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER',
  EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER_RANKED_BY_TIMES_RECOMMENDED = 'EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER_RANKED_BY_TIMES_RECOMMENDED',
  TOP_RECOMMENDATIONS_BASED_ON_DEAL_REQUEST = 'TOP_RECOMMENDATIONS_BASED_ON_DEAL_REQUEST',
  SIMILAR_USER_AND_TOP_RECOMMENDATIONS_GLOBALLY_RANKED = 'SIMILAR_USER_AND_TOP_RECOMMENDATIONS_GLOBALLY_RANKED'
}


export type SystemUser = {
   __typename: 'SystemUser',
  id: Scalars['SystemId'],
};

export type Tag = {
   __typename: 'Tag',
  id: Scalars['TagId'],
  type: TagType,
  name: Scalars['String'],
};


export type TagSkiTripExpertInput = {
  expertId: Scalars['BusinessUserId'],
  skiTripExpert: Scalars['Boolean'],
};

export type TagSkiTripExpertPayload = {
   __typename: 'TagSkiTripExpertPayload',
  expert: BusinessUser,
};

export type TagSkiTripLeadInput = {
  leadId: Scalars['LeadId'],
  skiTripLead: Scalars['Boolean'],
};

export type TagSkiTripLeadPayload = {
   __typename: 'TagSkiTripLeadPayload',
  lead: Lead,
};

export enum TagType {
  BROADCAST_LEAD_QUALITY = 'BROADCAST_LEAD_QUALITY',
  BROADCAST_CONVERSION_STRATEGY = 'BROADCAST_CONVERSION_STRATEGY',
  BROADCAST_TRUST_STRATEGY = 'BROADCAST_TRUST_STRATEGY',
  REMINDER_TASK_TYPE = 'REMINDER_TASK_TYPE'
}

export type TaskPayload = MerchantUploadTaskPayload | DealUploadTaskPayload | SellableUploadTaskPayload | SellablePriceUploadTaskPayload | BrandUploadTaskPayload | FeaturedSellableContentUploadTaskPayload | SellableUpdateTaskPayload | SellableDeactivationTaskPayload | SellableInventoryUploadTaskPayload;

export type TemplateChange = {
   __typename: 'TemplateChange',
  occurredAt: Scalars['Date'],
  notes?: Maybe<Scalars['String']>,
  type: TemplateChangeType,
  changedBy?: Maybe<Operator>,
};

export enum TemplateChangeType {
  CREATED = 'CREATED',
  PUBLISHED = 'PUBLISHED',
  DEACTIVATED = 'DEACTIVATED',
  IMPORTED = 'IMPORTED'
}

export type TemplateCustomQueryDataModel = TemplateDataModel & {
   __typename: 'TemplateCustomQueryDataModel',
  type: TemplateDataModelType,
};

export type TemplateDataModel = {
  type: TemplateDataModelType,
};

export type TemplateDataModelInput = {
  queryName: Scalars['String'],
  categoryType?: Maybe<TriggerParameterInput>,
  category?: Maybe<TriggerParameterInput>,
  variables: Array<TemplateNamedQueryVariableInput>,
};

export enum TemplateDataModelType {
  DATA_OBJECT = 'DATA_OBJECT',
  CUSTOM_QUERY = 'CUSTOM_QUERY',
  NAMED_QUERIES = 'NAMED_QUERIES'
}

export type TemplateFragmentParameter = {
   __typename: 'TemplateFragmentParameter',
  name: Scalars['String'],
  displayName: Scalars['String'],
  type: TemplateFragmentParameterType,
  enumValues: Array<Scalars['String']>,
  required: Scalars['Boolean'],
};

export type TemplateFragmentParameterInput = {
  name: Scalars['String'],
  type: TemplateFragmentParameterType,
  displayName: Scalars['String'],
  enumValues: Array<Scalars['String']>,
  required: Scalars['Boolean'],
};

export enum TemplateFragmentParameterType {
  TEXT = 'TEXT',
  BOOLEAN = 'BOOLEAN',
  OBJECT = 'OBJECT',
  IMAGE_URL = 'IMAGE_URL',
  ACTION_URL = 'ACTION_URL',
  ENUMERATION = 'ENUMERATION'
}

export type TemplateFragmentParameterValueInput = {
  name: Scalars['String'],
  stringValue?: Maybe<Scalars['String']>,
  booleanValue?: Maybe<Scalars['Boolean']>,
  reference?: Maybe<Scalars['String']>,
};

export enum TemplateFragmentType {
  BLOCK = 'BLOCK',
  HEADER = 'HEADER',
  FOOTER = 'FOOTER',
  BANNER = 'BANNER',
  MODULE = 'MODULE',
  PAGE_WRAPPER = 'PAGE_WRAPPER',
  NONE = 'NONE'
}

export type TemplateNamedQuery = {
   __typename: 'TemplateNamedQuery',
  queryName: Scalars['String'],
  variables: Array<TemplateNamedQueryVariable>,
};

export type TemplateNamedQueryDataModel = TemplateDataModel & {
   __typename: 'TemplateNamedQueryDataModel',
  type: TemplateDataModelType,
  categoryType?: Maybe<TriggerParameter>,
  categoryId?: Maybe<TriggerParameter>,
  query: TemplateNamedQuery,
};

export type TemplateNamedQueryMeta = {
   __typename: 'TemplateNamedQueryMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  query: Scalars['String'],
  variables: Array<TemplateNamedQueryVariableMeta>,
};

export type TemplateNamedQueryVariable = {
   __typename: 'TemplateNamedQueryVariable',
  name: Scalars['String'],
  value: TriggerParameter,
};

export type TemplateNamedQueryVariableInput = {
  name: Scalars['String'],
  value: TriggerParameterInput,
};

export type TemplateNamedQueryVariableMeta = {
   __typename: 'TemplateNamedQueryVariableMeta',
  name: Scalars['String'],
  type: Scalars['String'],
};

export type TemplateObjectTemplateDataModel = TemplateDataModel & {
   __typename: 'TemplateObjectTemplateDataModel',
  type: TemplateDataModelType,
};

export enum TemplateState {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  DEACTIVATED = 'DEACTIVATED'
}

export enum TemplateTagSyntax {
  DEFAULT = 'DEFAULT',
  ALTERNATIVE = 'ALTERNATIVE'
}

export enum TemplateTypeGroup {
  ONBOARDING = 'ONBOARDING',
  NURTURING = 'NURTURING',
  FEEDBACK = 'FEEDBACK',
  CURATION = 'CURATION',
  EXPERT_ONBOARDING = 'EXPERT_ONBOARDING',
  MESSAGE_ROUTING = 'MESSAGE_ROUTING',
  EXPERT_NOTIFICATION = 'EXPERT_NOTIFICATION',
  POST_PURCHASE = 'POST_PURCHASE',
  CONSUMER_REQUEST = 'CONSUMER_REQUEST',
  CAMPAIGN = 'CAMPAIGN',
  ABANDONED_CART = 'ABANDONED_CART',
  ABANDONED_CHECKOUT = 'ABANDONED_CHECKOUT',
  PATH_DROPOFF = 'PATH_DROPOFF',
  FULFILLMENT = 'FULFILLMENT',
  REFERRAL = 'REFERRAL'
}

export type TerminateSystemCuratedItemSurveyInput = {
  id: Scalars['SystemCuratedItemSurveyId'],
  reason: SystemCuratedItemSurveyTerminationReason,
};

export type TerminateSystemCuratedItemSurveyPayload = {
   __typename: 'TerminateSystemCuratedItemSurveyPayload',
  data?: Maybe<SystemCuratedItemSurvey>,
  error?: Maybe<Scalars['String']>,
};

export type TermsAndConditionsPathFlowPageMetadata = PathFlowPageMetadata & {
   __typename: 'TermsAndConditionsPathFlowPageMetadata',
  type: PathFlowPageMetadataType,
};

export type TermsPrivacyMedicalPathFlowPageMetadata = PathFlowPageMetadata & {
   __typename: 'TermsPrivacyMedicalPathFlowPageMetadata',
  type: PathFlowPageMetadataType,
};

export type TestTriggerEventParameterInput = {
  name: Scalars['String'],
  idValue?: Maybe<Scalars['AnyId']>,
  stringValue?: Maybe<Scalars['String']>,
};

export type TestTriggerExecutionInput = {
  triggerId: Scalars['TriggerId'],
  eventParameters: Array<TestTriggerEventParameterInput>,
};

export type TestTriggerExecutionPayload = {
   __typename: 'TestTriggerExecutionPayload',
  success: Scalars['Boolean'],
  error?: Maybe<Scalars['String']>,
};

export type TextRenderedContent = {
   __typename: 'TextRenderedContent',
  text: Scalars['String'],
  link?: Maybe<Scalars['String']>,
};

/** ====== Text View Model */
export type TextViewModel = AttributedHtmlTextViewModel;

export enum ThreeDSecureVerification {
  /** 3D Secure is required, and the process must be completed for a charge to be successful. */
  REQUIRED = 'REQUIRED',
  /** 
 * 3D Secure is recommended. The process is not required, but it is highly recommended and
   * has minimal impact to your conversion rate.
 **/
  RECOMMENDED = 'RECOMMENDED',
  /** 
 * 3D Secure is optional. The process is neither required nor recommended, but it can be performed to
   * help reduce the likelihood of fraud.
 **/
  OPTIONAL = 'OPTIONAL',
  /** 3D Secure is not supported on this card. Proceed with a regular card payment instead. */
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type Ticket = {
   __typename: 'Ticket',
  id: Scalars['TicketId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  assignedTo?: Maybe<TicketUser>,
  description?: Maybe<Scalars['String']>,
  dueAt: Scalars['Date'],
  status: TicketStatus,
  comments: Array<TicketComment>,
  priority: TicketPriority,
  detail: TicketDetail,
  activities: Array<TicketActivity>,
  workflowType: WorkflowType,
};


export type TicketActivitiesArgs = {
  limit?: Maybe<Scalars['Int']>
};

export type TicketActivity = {
   __typename: 'TicketActivity',
  id: Scalars['TicketActivityId'],
  occurredAt: Scalars['Date'],
  author: TicketAuthor,
  detail: TicketActivityDetail,
};

export type TicketActivityDetail = {
  type: TicketActivityType,
};


export enum TicketActivityType {
  TICKET_ASSIGNED = 'TICKET_ASSIGNED',
  TICKET_UNASSIGNED = 'TICKET_UNASSIGNED',
  DUE_DATE_CHANGED = 'DUE_DATE_CHANGED',
  FIELD_UPDATED = 'FIELD_UPDATED'
}

export type TicketAssignedActivity = TicketActivityDetail & {
   __typename: 'TicketAssignedActivity',
  type: TicketActivityType,
  previousAssignee?: Maybe<TicketUser>,
  newAssignee: TicketUser,
};

export type TicketAuthor = SystemUser | Operator;

export type TicketComment = {
   __typename: 'TicketComment',
  author: TicketAuthor,
  createdAt: Scalars['Date'],
  note: Scalars['String'],
};

export type TicketDetail = {
  type: TicketType,
};

export type TicketEdge = {
   __typename: 'TicketEdge',
  node: Ticket,
  cursor: Scalars['String'],
};


export enum TicketPriority {
  NORMAL = 'NORMAL',
  HIGH = 'HIGH'
}

export type TicketQueryInput = {
  orderIds?: Maybe<Array<Scalars['String']>>,
  orderLineItemIds?: Maybe<Array<Scalars['String']>>,
  ticketTypes?: Maybe<Array<TicketType>>,
  ticketStatuses?: Maybe<Array<TicketStatus>>,
  assignedToIds?: Maybe<Array<Scalars['AnyId']>>,
  includeUnassigned?: Maybe<Scalars['Boolean']>,
  dueDateRange?: Maybe<DateRangeInput>,
};

export type TicketsConnection = {
   __typename: 'TicketsConnection',
  edges: Array<TicketEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export type TicketSearchConnection = {
   __typename: 'TicketSearchConnection',
  edges: Array<TicketEdge>,
  pageInfo: PageInfo,
  facets: Array<DisplayFacet>,
  count: Scalars['Long'],
};

export type TicketSearchQueryInput = {
  keywords?: Maybe<Scalars['String']>,
  ticketTypes?: Maybe<Array<TicketType>>,
  ticketStatuses?: Maybe<Array<TicketStatus>>,
  assignedToOperatorIds?: Maybe<Array<Scalars['OperatorId']>>,
  includeUnassigned?: Maybe<Scalars['Boolean']>,
  dateRangeFilters?: Maybe<Array<DateRangeFilterInput>>,
  facets?: Maybe<Array<FacetSelection>>,
  facetedSearch?: Maybe<Scalars['Boolean']>,
  ticketPriorities?: Maybe<Array<TicketPriority>>,
};

export enum TicketSearchSort {
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT',
  DUE_AT = 'DUE_AT'
}

export type TicketsPagination = {
   __typename: 'TicketsPagination',
  tickets: Array<Ticket>,
  count: Scalars['Long'],
};

export enum TicketStatus {
  NEW = 'NEW',
  ASSIGNED = 'ASSIGNED',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED',
  BLOCKED = 'BLOCKED',
  CLOSED = 'CLOSED',
  WONT_COMPLETE = 'WONT_COMPLETE'
}

export enum TicketType {
  LINE_ITEM_CLAIM = 'LINE_ITEM_CLAIM',
  UPDATE_TRACKING_INFO = 'UPDATE_TRACKING_INFO',
  ORDER_VERIFICATION = 'ORDER_VERIFICATION',
  PRODUCT_RETURN = 'PRODUCT_RETURN',
  CONSUMER_REFUND = 'CONSUMER_REFUND',
  MERCHANT_REFUND = 'MERCHANT_REFUND'
}

export type TicketUnassignedActivity = TicketActivityDetail & {
   __typename: 'TicketUnassignedActivity',
  type: TicketActivityType,
};

export type TicketUser = Operator;


export type TipMethod = {
  type: TipMethodType,
};

export type TipMethodFixedAmount = TipMethod & {
   __typename: 'TipMethodFixedAmount',
  type: TipMethodType,
  options: Array<MonetaryAmount>,
  customAmountAllowed: Scalars['Boolean'],
};

export type TipMethodPercentOfAmount = TipMethod & {
   __typename: 'TipMethodPercentOfAmount',
  type: TipMethodType,
  options: Array<TipMethodPercentOption>,
};

export type TipMethodPercentOption = {
   __typename: 'TipMethodPercentOption',
  rate: Scalars['BigDecimal'],
  minimumAmount: MonetaryAmount,
  maximumAmount: MonetaryAmount,
};

export enum TipMethodType {
  PERCENT_OF_AMOUNT = 'PERCENT_OF_AMOUNT',
  FIXED_AMOUNT = 'FIXED_AMOUNT'
}

export type TopRecommendationAndSimilarUserSystemCuratedItemSource = SystemCuratedItemSource & {
   __typename: 'TopRecommendationAndSimilarUserSystemCuratedItemSource',
  type?: Maybe<SystemCuratedItemType>,
  recentExpertCuratedItemFromSimilarUserSource?: Maybe<RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource>,
  topRecommendedListSystemCuratedItemSource?: Maybe<TopRecommendedListSystemCuratedItemSource>,
};

export type TopRecommendedListSystemCuratedItemSource = SystemCuratedItemSource & {
   __typename: 'TopRecommendedListSystemCuratedItemSource',
  type?: Maybe<SystemCuratedItemType>,
  recommendedListDefinition: RecommendedListDefinition,
  dealRequest: DealRequest,
};

export type TotalCostForOfferInput = {
  id: Scalars['BroadcastOfferId'],
  address?: Maybe<AddressInput>,
  tip?: Maybe<MonetaryAmountInput>,
};

export type TotalCostForOfferPayload = {
   __typename: 'TotalCostForOfferPayload',
  address?: Maybe<Address>,
  price: MonetaryAmount,
  tax: MonetaryAmount,
  shippingCost: MonetaryAmount,
  totalCost: MonetaryAmount,
  tip?: Maybe<MonetaryAmount>,
};

export type Transaction = {
   __typename: 'Transaction',
  id: Scalars['TransactionId'],
  createdAt: Scalars['Date'],
  updatedAt?: Maybe<Scalars['Date']>,
  orderId: Scalars['OrderId'],
  order: Order,
  status: TransactionStatus,
  type: TransactionType,
  request: TransactionRequest,
  response?: Maybe<TransactionResponse>,
};


export type TransactionRequest = {
   __typename: 'TransactionRequest',
  chargeAmount: MonetaryAmount,
  statementDescriptor: Scalars['String'],
  fullDescription?: Maybe<Scalars['String']>,
  paymentSourceType: PaymentProcessorType,
  paymentProcessorPlatformSourceId: Scalars['String'],
  paymentSourceUsage: PaymentSourceUsage,
};

export type TransactionResponse = {
   __typename: 'TransactionResponse',
  paymentProcessorTransactionId?: Maybe<Scalars['String']>,
  paymentSource?: Maybe<PaymentSource>,
  errorMessage?: Maybe<Scalars['String']>,
  userFriendlyErrorMessage?: Maybe<Scalars['String']>,
  sourceAccount?: Maybe<PaymentProcessorAccount>,
  destinationAccount?: Maybe<PaymentProcessorAccount>,
  /** 
 * Statement descriptor is a protected field and only accessible to the admin.
   * this statement descriptor can be different from one in TransactionRequest and is specific to the PaymentProcessor.
   * It may be truncated or have additional metadata addded to it.
 **/
  statementDescriptor?: Maybe<Scalars['String']>,
  /** the updating operator if this transaction was manually updated */
  updatedBy?: Maybe<Operator>,
  paymentVerificationMethod?: Maybe<PaymentVerificationMethod>,
};

export enum TransactionStatus {
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  IN_REVIEW = 'IN_REVIEW',
  FAILURE = 'FAILURE',
  REFUNDED = 'REFUNDED',
  OFFLINE = 'OFFLINE'
}

export enum TransactionType {
  CUSTOMER = 'CUSTOMER',
  MERCHANT = 'MERCHANT'
}

export type TreatmentDefinition = {
   __typename: 'TreatmentDefinition',
  value: Scalars['String'],
  description: Scalars['String'],
};

export type TreatmentDefinitionInput = {
  value: Scalars['String'],
  description?: Maybe<Scalars['String']>,
};

export type Trigger = {
   __typename: 'Trigger',
  id: Scalars['TriggerId'],
  name: Scalars['String'],
  groupName: Scalars['String'],
  description: Scalars['String'],
  triggeredBy: TriggerEventMeta,
  entityMeta: TriggerEntityMeta,
  supportedActions: Array<TriggerActionMeta>,
  waitableEvents: Array<TriggerEventMeta>,
  nodes: Array<TriggerNode>,
  state: TriggerState,
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  namedQueries: Array<TemplateNamedQueryMeta>,
  campaign?: Maybe<Campaign>,
  superseded?: Maybe<Trigger>,
  pendingDraft?: Maybe<Trigger>,
  versionNumber: Scalars['Int'],
  historyId?: Maybe<Scalars['TriggerVersionHistoryId']>,
  changes: Array<TriggerChange>,
};

export type TriggerAction = TriggerNode & {
   __typename: 'TriggerAction',
  id: Scalars['TriggerNodeId'],
  type: TriggerNodeType,
  name: Scalars['String'],
  parameters: Array<TriggerActionParameter>,
  nextNodeId?: Maybe<Scalars['TriggerNodeId']>,
  templateType?: Maybe<CommTemplateType>,
};

export type TriggerActionMeta = {
   __typename: 'TriggerActionMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  parameters: Array<TriggerParameterMeta>,
  internal: Scalars['Boolean'],
};

export type TriggerActionParameter = {
   __typename: 'TriggerActionParameter',
  name: Scalars['String'],
  value: TriggerParameter,
};

export type TriggerActionParameterInput = {
  name: Scalars['String'],
  parameter: TriggerParameterInput,
};

export type TriggerBinaryCondition = TriggerCondition & {
   __typename: 'TriggerBinaryCondition',
  type: TriggerConditionType,
  leftOperand: TriggerParameter,
  rightOperand: TriggerParameter,
  binaryOperator: TriggerFieldOperator,
};

export type TriggerBinaryConditionInput = {
  leftOperand: TriggerParameterInput,
  rightOperand: TriggerParameterInput,
  binaryOperator: Scalars['String'],
};

export type TriggerBranch = TriggerNode & {
   __typename: 'TriggerBranch',
  id: Scalars['TriggerNodeId'],
  type: TriggerNodeType,
  condition?: Maybe<TriggerCondition>,
  nodeIdIfTrue?: Maybe<Scalars['TriggerNodeId']>,
  nodeIdIfFalse?: Maybe<Scalars['TriggerNodeId']>,
};

export type TriggerChange = {
   __typename: 'TriggerChange',
  occurredAt: Scalars['Date'],
  notes?: Maybe<Scalars['String']>,
  type: TriggerChangeType,
  changedBy?: Maybe<Operator>,
};

export enum TriggerChangeType {
  CREATED = 'CREATED',
  PUBLISHED = 'PUBLISHED',
  DEACTIVATED = 'DEACTIVATED',
  ARCHIVED = 'ARCHIVED',
  IMPORTED = 'IMPORTED'
}

export type TriggerCondition = {
  type: TriggerConditionType,
};

export type TriggerConditionInput = {
  logicalCondition?: Maybe<TriggerLogicalConditionInput>,
  binaryCondition?: Maybe<TriggerBinaryConditionInput>,
  experimentCondition?: Maybe<TriggerExperimentConditionInput>,
};

export enum TriggerConditionType {
  LOGICAL = 'LOGICAL',
  BINARY = 'BINARY',
  EXPERIMENT = 'EXPERIMENT'
}

export type TriggerDelay = TriggerNode & {
   __typename: 'TriggerDelay',
  id: Scalars['TriggerNodeId'],
  type: TriggerNodeType,
  interval: TriggerDelayInterval,
  nextNodeId?: Maybe<Scalars['TriggerNodeId']>,
};

export type TriggerDelayDynamicInterval = TriggerDelayInterval & {
   __typename: 'TriggerDelayDynamicInterval',
  type: TriggerDelayIntervalType,
  timeParameter: TriggerParameter,
  before: Scalars['Boolean'],
  timeDifference: TriggerDuration,
};

export type TriggerDelayDynamicIntervalInput = {
  timeDifference: TriggerDurationInput,
  before: Scalars['Boolean'],
  timeParameter: TriggerParameterInput,
};

export type TriggerDelayFixedInterval = TriggerDelayInterval & {
   __typename: 'TriggerDelayFixedInterval',
  type: TriggerDelayIntervalType,
  minimalWaitTime: TriggerDuration,
  waitUntilLocalTime?: Maybe<TriggerLocalTimeRange>,
};

export type TriggerDelayFixedIntervalInput = {
  minimalWaitTime: TriggerDurationInput,
  waitUtilLocalTime?: Maybe<TriggerLocalTimeRangeInput>,
};

export type TriggerDelayInterval = {
  type: TriggerDelayIntervalType,
};

export type TriggerDelayIntervalTreatment = {
   __typename: 'TriggerDelayIntervalTreatment',
  treatments: Array<Scalars['String']>,
  interval: TriggerDelayFixedInterval,
};

export type TriggerDelayIntervalTreatmentInput = {
  treatments: Array<Scalars['String']>,
  fixedInterval: TriggerDelayFixedIntervalInput,
};

export enum TriggerDelayIntervalType {
  FIXED = 'FIXED',
  DYNAMIC = 'DYNAMIC',
  WITH_EXPERIMENT = 'WITH_EXPERIMENT'
}

export type TriggerDelayWithExperiment = TriggerDelayInterval & {
   __typename: 'TriggerDelayWithExperiment',
  type: TriggerDelayIntervalType,
  experiment: Scalars['String'],
  key: TriggerParameter,
  intervals: Array<TriggerDelayIntervalTreatment>,
};

export type TriggerDelayWithExperimentInput = {
  experiment: Scalars['String'],
  key: TriggerParameterInput,
  intervals: Array<TriggerDelayIntervalTreatmentInput>,
};

export type TriggerDuration = {
   __typename: 'TriggerDuration',
  unit: TriggerDurationUnit,
  amount: Scalars['Int'],
};

export type TriggerDurationInput = {
  unit: TriggerDurationUnit,
  amount: Scalars['Int'],
};

export enum TriggerDurationUnit {
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS'
}

/** fields exists on an trigger entity */
export type TriggerEntityFieldMeta = {
   __typename: 'TriggerEntityFieldMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  type: TriggerFieldType,
  idType?: Maybe<Scalars['String']>,
  enumValues?: Maybe<Array<Scalars['String']>>,
  experimentKey: Scalars['Boolean'],
  immutableField: Scalars['Boolean'],
  supportedOperators: Array<TriggerFieldOperator>,
  stringFieldType?: Maybe<StringFieldType>,
};

export type TriggerEntityFieldReference = {
   __typename: 'TriggerEntityFieldReference',
  type: TriggerParameterType,
  field: Scalars['String'],
};

/** Entities we can create trigger on, like User, Lead, Order and etc */
export type TriggerEntityMeta = {
   __typename: 'TriggerEntityMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  fields: Array<TriggerEntityFieldMeta>,
};

export type TriggerEventMeta = {
   __typename: 'TriggerEventMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  parameters: Array<TriggerParameterMeta>,
  entityId: TriggerParameterMeta,
  waitable: Scalars['Boolean'],
  groupName: Scalars['String'],
};

export type TriggerEventParameterReference = {
   __typename: 'TriggerEventParameterReference',
  type: TriggerParameterType,
  parameterName: Scalars['String'],
};

export type TriggerExperimentCondition = TriggerCondition & {
   __typename: 'TriggerExperimentCondition',
  type: TriggerConditionType,
  key: TriggerParameter,
  experiment: Scalars['String'],
  treatments: Array<Scalars['String']>,
};

export type TriggerExperimentConditionInput = {
  experiment: Scalars['String'],
  treatments: Array<Scalars['String']>,
  key: TriggerParameterInput,
};

/** 
 * operator supported for each trigger field type
 * for example, equals, greater_than
 **/
export type TriggerFieldOperator = {
   __typename: 'TriggerFieldOperator',
  name: Scalars['String'],
  displayName: Scalars['String'],
  leftOperandType: TriggerFieldType,
  rightOperandType: TriggerFieldType,
};

/** 
 * =============================
 * Trigger metadata.
 * =============================
 **/
export enum TriggerFieldType {
  BOOLEAN = 'BOOLEAN',
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL',
  STRING = 'STRING',
  STRING_LIST = 'STRING_LIST',
  DATE = 'DATE',
  ID = 'ID',
  ID_LIST = 'ID_LIST'
}

export type TriggerFilter = TriggerNode & {
   __typename: 'TriggerFilter',
  id: Scalars['TriggerNodeId'],
  type: TriggerNodeType,
  condition?: Maybe<TriggerCondition>,
  nextNodeId?: Maybe<Scalars['TriggerNodeId']>,
};


export type TriggerLiteralBooleanValue = {
   __typename: 'TriggerLiteralBooleanValue',
  type: TriggerParameterType,
  booleanValue: Scalars['Boolean'],
};

export type TriggerLiteralDateValue = {
   __typename: 'TriggerLiteralDateValue',
  type: TriggerParameterType,
  dateValue: Scalars['Date'],
};

export type TriggerLiteralDecimalValue = {
   __typename: 'TriggerLiteralDecimalValue',
  type: TriggerParameterType,
  decimalValue: Scalars['BigDecimal'],
};

export type TriggerLiteralIdListValue = {
   __typename: 'TriggerLiteralIdListValue',
  type: TriggerParameterType,
  idListValue: Array<Scalars['AnyId']>,
};

export type TriggerLiteralIdValue = {
   __typename: 'TriggerLiteralIdValue',
  type: TriggerParameterType,
  idValue: Scalars['AnyId'],
};

export type TriggerLiteralIntegerValue = {
   __typename: 'TriggerLiteralIntegerValue',
  type: TriggerParameterType,
  integerValue: Scalars['Int'],
};

export type TriggerLiteralStringListValue = {
   __typename: 'TriggerLiteralStringListValue',
  type: TriggerParameterType,
  stringListValue: Array<Scalars['String']>,
};

export type TriggerLiteralStringValue = {
   __typename: 'TriggerLiteralStringValue',
  type: TriggerParameterType,
  stringValue: Scalars['String'],
};

export type TriggerLiteralValue = TriggerLiteralBooleanValue | TriggerLiteralIntegerValue | TriggerLiteralDecimalValue | TriggerLiteralStringValue | TriggerLiteralStringListValue | TriggerLiteralDateValue | TriggerLiteralIdValue | TriggerLiteralIdListValue;

export type TriggerLocalTime = {
   __typename: 'TriggerLocalTime',
  /** 0-23 */
  hour: Scalars['Int'],
  minute: Scalars['Int'],
};

export type TriggerLocalTimeInput = {
  /** 0-23 */
  hour: Scalars['Int'],
  minute: Scalars['Int'],
};

export type TriggerLocalTimeRange = {
   __typename: 'TriggerLocalTimeRange',
  beginTime: TriggerLocalTime,
  endTime?: Maybe<TriggerLocalTime>,
  timeZone: TriggerParameter,
};

export type TriggerLocalTimeRangeInput = {
  beginTime: TriggerLocalTimeInput,
  endTime?: Maybe<TriggerLocalTimeInput>,
  timeZone: TriggerParameterInput,
};

export type TriggerLogicalCondition = TriggerCondition & {
   __typename: 'TriggerLogicalCondition',
  type: TriggerConditionType,
  conditions: Array<TriggerCondition>,
  logicalOperator: LogicalOperator,
};

export type TriggerLogicalConditionInput = {
  conditions: Array<TriggerConditionInput>,
  logicalOperator: LogicalOperator,
};

export type TriggerNode = {
  id: Scalars['TriggerNodeId'],
  type: TriggerNodeType,
};

export enum TriggerNodeEdgeType {
  NEXT = 'NEXT',
  TRUE = 'TRUE',
  FALSE = 'FALSE'
}


export enum TriggerNodeType {
  DELAY = 'DELAY',
  FILTER = 'FILTER',
  BRANCH = 'BRANCH',
  ACTION = 'ACTION',
  WAIT = 'WAIT'
}

export type TriggerParameter = TriggerEntityFieldReference | TriggerEventParameterReference | TriggerLiteralBooleanValue | TriggerLiteralIntegerValue | TriggerLiteralDecimalValue | TriggerLiteralStringValue | TriggerLiteralStringListValue | TriggerLiteralDateValue | TriggerLiteralIdValue | TriggerLiteralIdListValue;

export type TriggerParameterInput = {
  type: TriggerParameterType,
  fieldName?: Maybe<Scalars['String']>,
  eventParameter?: Maybe<Scalars['String']>,
  booleanValue?: Maybe<Scalars['Boolean']>,
  stringValue?: Maybe<Scalars['String']>,
  integerValue?: Maybe<Scalars['Int']>,
  decimalValue?: Maybe<Scalars['BigDecimal']>,
  dateValue?: Maybe<Scalars['Date']>,
  idValue?: Maybe<Scalars['AnyId']>,
  stringListValue?: Maybe<Array<Scalars['String']>>,
  idListValue?: Maybe<Array<Scalars['AnyId']>>,
};

export type TriggerParameterMeta = {
   __typename: 'TriggerParameterMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  type: TriggerFieldType,
  idType?: Maybe<Scalars['String']>,
  enumValues?: Maybe<Array<Scalars['String']>>,
  supportedOperators: Array<TriggerFieldOperator>,
  /** only applicable to TriggerActionMeta, N/A for TriggerEventMeta */
  required: Scalars['Boolean'],
  deprecated: Scalars['Boolean'],
  defaultValue?: Maybe<TriggerLiteralValue>,
  stringFieldType?: Maybe<StringFieldType>,
};

export enum TriggerParameterType {
  ENTITY_FIELD = 'ENTITY_FIELD',
  EVENT_PARAMETER = 'EVENT_PARAMETER',
  LITERAL_VALUE = 'LITERAL_VALUE'
}

export type TriggerQuery = {
  eventName?: Maybe<Scalars['String']>,
  state?: Maybe<TriggerState>,
};

/** 
 * =============================
 * Trigger instance
 * =============================
 **/
export enum TriggerState {
  DRAFT = 'DRAFT',
  TEST = 'TEST',
  PUBLISHED = 'PUBLISHED',
  DEACTIVATED = 'DEACTIVATED',
  ARCHIVED = 'ARCHIVED'
}


export type TriggerWait = TriggerNode & {
   __typename: 'TriggerWait',
  id: Scalars['TriggerNodeId'],
  type: TriggerNodeType,
  eventName?: Maybe<Scalars['String']>,
  eventEntityId?: Maybe<TriggerParameter>,
  maxWaitTime: TriggerDuration,
  nodeIdIfTrue?: Maybe<Scalars['TriggerNodeId']>,
  nodeIdIfFalse?: Maybe<Scalars['TriggerNodeId']>,
};

export type UnarchiveExperimentInput = {
  id: Scalars['ExperimentId'],
};

export type UnarchiveExperimentPayload = {
   __typename: 'UnarchiveExperimentPayload',
  experiment: ExperimentDefinition,
  errorMessage?: Maybe<Scalars['String']>,
  hasError: Scalars['Boolean'],
};

export type UnassignSupportTaskActivity = SupportTaskActivity & {
   __typename: 'UnassignSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
};

export type UnassignTicketInput = {
  ticketId: Scalars['TicketId'],
};

export type UnregisterFirebaseCloudMessagingTokenInput = {
  fcmToken: Scalars['String'],
};

export type UnregisterFirebaseCloudMessagingTokenPayload = {
   __typename: 'UnregisterFirebaseCloudMessagingTokenPayload',
  unregistered?: Maybe<Scalars['Boolean']>,
};

export type UnregisterWebPushSubscriptionInput = {
  subscription: Scalars['String'],
};

export type UnregisterWebPushSubscriptionPayload = {
   __typename: 'UnregisterWebPushSubscriptionPayload',
  unregistered: Scalars['Boolean'],
};

export enum UnsavedSellableReason {
  NOT_INTERESTED = 'NOT_INTERESTED',
  TOO_EXPENSIVE = 'TOO_EXPENSIVE',
  LOW_QUALITY = 'LOW_QUALITY',
  UGLY = 'UGLY',
  DONT_NEED = 'DONT_NEED',
  BOUGHT_ELSEWHERE = 'BOUGHT_ELSEWHERE'
}

export type UnsaveSavedSellableInput = {
  sellableId: Scalars['SellableId'],
  reason?: Maybe<UnsavedSellableReason>,
};

export type UnsaveSavedSellablePayload = {
   __typename: 'UnsaveSavedSellablePayload',
  savedSellable: SavedSellable,
};

export type UnsnoozeSupportTaskActivity = SupportTaskActivity & {
   __typename: 'UnsnoozeSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  snoozedSupportTask: SupportTask,
};

/** Updates only supports minimal field updates, the core address fields are immutable */
export type UpdateAddressPreferencesInput = {
  addressId: Scalars['AddressId'],
  userId: Scalars['UserId'],
  userFriendlyName?: Maybe<Scalars['String']>,
  isDefault?: Maybe<Scalars['Boolean']>,
};

export type UpdateAddressPreferencesPayload = {
   __typename: 'UpdateAddressPreferencesPayload',
  updatedAddress?: Maybe<Address>,
  error?: Maybe<Scalars['String']>,
};

export type UpdateAdHocSellablePriceInput = {
  sellableId: Scalars['SellableId'],
  salePrice?: Maybe<MonetaryAmountInput>,
};

export type UpdateAdHocSellablePricePayload = {
   __typename: 'UpdateAdHocSellablePricePayload',
  sellable?: Maybe<Sellable>,
  error?: Maybe<Scalars['String']>,
};

export type UpdateBusinessUserInput = {
  id: Scalars['BusinessUserId'],
  departmentId?: Maybe<Scalars['DepartmentId']>,
  phone?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  avatarUrl?: Maybe<Scalars['String']>,
  expertAttributes?: Maybe<ExpertAttributeInput>,
  teamId?: Maybe<Scalars['BusinessUserTeamId']>,
  payStructureId?: Maybe<Scalars['PayStructureId']>,
  featured?: Maybe<Scalars['Boolean']>,
  spotlightExpert?: Maybe<Scalars['Boolean']>,
  timeZone?: Maybe<Scalars['String']>,
};

export type UpdateBusinessUserPayload = {
   __typename: 'UpdateBusinessUserPayload',
  errors?: Maybe<Array<Scalars['String']>>,
  businessUser?: Maybe<BusinessUser>,
};

export type UpdateBusinessUserVanityIdInput = {
  id: Scalars['BusinessUserId'],
};

export type UpdateChannelTemplateInput = {
  templateId: Scalars['CommTemplateId'],
  channelType: ChannelType,
  emailTemplate?: Maybe<EmailTemplateInput>,
  smsTemplate?: Maybe<SmsTemplateInput>,
  inAppTemplate?: Maybe<InAppTemplateInput>,
  pushNotificationTemplate?: Maybe<PushNotificationTemplateInput>,
  slackTemplate?: Maybe<SlackTemplateInput>,
  facebookTemplate?: Maybe<FacebookTemplateInput>,
};

export type UpdateConfigInput = {
  domain: Scalars['String'],
  key: Scalars['String'],
  value: Scalars['String'],
};

export type UpdateConfigPayload = {
   __typename: 'UpdateConfigPayload',
  config?: Maybe<Config>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type UpdateConsumerExpertReviewInput = {
  id: Scalars['ConsumerExpertReviewId'],
  active?: Maybe<Scalars['Boolean']>,
  rating?: Maybe<Scalars['Int']>,
  headline?: Maybe<Scalars['String']>,
  comments?: Maybe<Scalars['String']>,
  goodQualities?: Maybe<Array<Scalars['String']>>,
  featured?: Maybe<Scalars['Boolean']>,
  spotlight?: Maybe<Scalars['Boolean']>,
};

export type UpdateConsumerExpertReviewPayload = {
   __typename: 'UpdateConsumerExpertReviewPayload',
  review: ConsumerExpertReview,
};

export type UpdateDescriptionInput = {
  ticketId: Scalars['TicketId'],
  description: Scalars['String'],
};

export type UpdateExperimentInput = {
  id: Scalars['ExperimentId'],
  description?: Maybe<Scalars['String']>,
  backendOnly?: Maybe<Scalars['Boolean']>,
  treatments?: Maybe<Array<TreatmentDefinitionInput>>,
  rules?: Maybe<Array<RuleDefinitionInput>>,
};

export type UpdateExperimentPayload = {
   __typename: 'UpdateExperimentPayload',
  experiment: ExperimentDefinition,
  errorMessage?: Maybe<Scalars['String']>,
  hasError: Scalars['Boolean'],
};

export type UpdateExpertApplicationPayload = {
   __typename: 'UpdateExpertApplicationPayload',
  application: ExpertApplication,
};

export type UpdateExpertApplicationTaskStatusInput = {
  applicationId: Scalars['ExpertApplicationId'],
  task: ExpertApplicationTaskType,
  status: Scalars['String'],
  externalId?: Maybe<Scalars['String']>,
};

export type UpdateExpertApplicationTaskStatusPayload = {
   __typename: 'UpdateExpertApplicationTaskStatusPayload',
  application: ExpertApplication,
};

export type UpdateExpertCuratedItemCustomizationInput = {
  id: Scalars['SellableId'],
  title?: Maybe<Scalars['String']>,
  price?: Maybe<MonetaryAmountInput>,
};

export type UpdateExpertCuratedItemInput = {
  id: Scalars['ExpertCuratedItemId'],
  sellableId?: Maybe<Scalars['SellableId']>,
  priceOverride?: Maybe<MonetaryAmountInput>,
  tag?: Maybe<ExpertCuratedItemTagInput>,
  shouldAddToCartOnActive?: Maybe<Scalars['Boolean']>,
  isBuiltFromRecommendation?: Maybe<Scalars['Boolean']>,
  draftNote?: Maybe<Scalars['String']>,
  noteId?: Maybe<Scalars['ExpertCuratedItemNoteId']>,
  fulfillmentNotes?: Maybe<ExpertCuratedItemFulfillmentNotesInput>,
  /** add or update customizations, matching on `SellableId` to determine if it's an insert or update */
  upsertCustomizations?: Maybe<Array<UpdateExpertCuratedItemCustomizationInput>>,
  /** remove customizations for matching `SellableId`s */
  removeCustomizations?: Maybe<Array<Scalars['SellableId']>>,
  /** Whehter to move item up or down in list */
  rankChange?: Maybe<ExpertCuratedItemRankChangeType>,
};

export type UpdateExpertCuratedItemPayload = {
   __typename: 'UpdateExpertCuratedItemPayload',
  /** 
 * The entity that as ultimately modified; may be a new/existing draft that's staged to replace the targeted curated
   * item
 **/
  updated: ExpertCuratedItem,
  /** 
 * The entity that was targeted for update being staged to be removed once `updated` is activated (converted to non
   * draft status)
 **/
  superseded?: Maybe<ExpertCuratedItem>,
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories,
};

export type UpdateExpertCuratedOrderTermsInput = {
  id: Scalars['ExpertCuratedOrderId'],
  serviceStartsAt?: Maybe<Scalars['Date']>,
  availableForPurchaseDurationMinutes?: Maybe<Scalars['Int']>,
  minimumDepositPercent?: Maybe<Scalars['Int']>,
  prepaidIncidentalPercent?: Maybe<Scalars['Int']>,
  fullPaymentDueBeforeServiceStartDays?: Maybe<Scalars['Int']>,
  flightPlanId?: Maybe<Scalars['FlightPlanId']>,
  defaultManualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustmentInput>,
  inPreview?: Maybe<Scalars['Boolean']>,
  expertNote?: Maybe<Scalars['String']>,
};

export type UpdateExpertCuratedOrderTermsPayload = {
   __typename: 'UpdateExpertCuratedOrderTermsPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

export type UpdateExpertCuratedOrderVariationOptionInput = {
  id: Scalars['SellableId'],
  price?: Maybe<MonetaryAmountInput>,
  enabled?: Maybe<Scalars['Boolean']>,
  selected?: Maybe<Scalars['Boolean']>,
  manualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustmentInput>,
};

export type UpdateExpertCuratedOrderVariationOptionsInput = {
  id: Scalars['ExpertCuratedOrderId'],
  options: Array<UpdateExpertCuratedOrderVariationOptionInput>,
};

export type UpdateExpertCuratedOrderVariationOptionsPayload = {
   __typename: 'UpdateExpertCuratedOrderVariationOptionsPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

export type UpdateExpertProfileInput = {
  expertProfileId: Scalars['ExpertProfileId'],
  displayName?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  profilePhotoId?: Maybe<Scalars['MediaId']>,
  headline?: Maybe<Scalars['String']>,
  background?: Maybe<Scalars['String']>,
  backgroundRichText?: Maybe<Scalars['String']>,
  quotes?: Maybe<Array<Scalars['String']>>,
  socialMediaUrls?: Maybe<Array<Scalars['String']>>,
  gallery?: Maybe<Array<MediaWithCaptionInput>>,
  recentArticles?: Maybe<Array<ExternalContentInput>>,
  highlights?: Maybe<Array<ProfileHighlightInput>>,
  introductionVideoUrl?: Maybe<Scalars['String']>,
  socialMediaAccessTokens?: Maybe<Array<SocialMediaAccessTokenInput>>,
  currentGearIds?: Maybe<Array<Scalars['SellableId']>>,
  favoriteBrandIds?: Maybe<Array<Scalars['BrandId']>>,
  gender?: Maybe<ExpertGender>,
  portraitVideoId?: Maybe<Scalars['MediaId']>,
  introductionVideoId?: Maybe<Scalars['MediaId']>,
  introductionVideo?: Maybe<ExternalVideoLinkInput>,
  spotlightHeadline?: Maybe<Scalars['String']>,
};

export type UpdateExpertProfilePayload = {
   __typename: 'UpdateExpertProfilePayload',
  expertProfile?: Maybe<ExpertProfile>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type UpdateExternalAdCampaignInput = {
  adCampaignId: Scalars['ExternalAdCampaignId'],
  status: ExternalAdStatus,
  normalizedBudget: Scalars['BigDecimal'],
};

export type UpdateExternalAdCampaignPayload = {
   __typename: 'UpdateExternalAdCampaignPayload',
  adCampaign: ExternalAdCampaign,
};

export type UpdateExternalAdGroupInput = {
  adGroupId: Scalars['ExternalAdGroupId'],
  status: ExternalAdStatus,
  normalizedBudget?: Maybe<Scalars['BigDecimal']>,
  campaignNormalizedBudget?: Maybe<Scalars['BigDecimal']>,
};

export type UpdateExternalAdGroupPayload = {
   __typename: 'UpdateExternalAdGroupPayload',
  adGroup: ExternalAdGroup,
};

export type UpdateFulfillmentChannelBlacklistInput = {
  id: Scalars['FulfillmentChannelId'],
  blacklisted: Scalars['Boolean'],
};

export type UpdateFulfillmentChannelMetadataInput = {
  id: Scalars['FulfillmentChannelId'],
  name: Scalars['String'],
  marginPercent?: Maybe<Scalars['Int']>,
  expeditedShippingRates?: Maybe<MonetaryAmountInput>,
  standardDeliveryTime?: Maybe<Scalars['Int']>,
  expeditedDeliveryTime?: Maybe<Scalars['Int']>,
};

export type UpdateFulfillmentChannelPayload = {
   __typename: 'UpdateFulfillmentChannelPayload',
  fulfillmentChannel: FulfillmentChannel,
};

export type UpdateFulfillmentInstructionsInput = {
  id: Scalars['FulfillmentChannelId'],
  instructions: Scalars['String'],
};

export type UpdateFulfillmentTicketPayload = {
   __typename: 'UpdateFulfillmentTicketPayload',
  ticket: Ticket,
};

export type UpdateGuestConversationSequenceInput = {
  id: Scalars['GuestConversationSequenceId'],
  name: Scalars['String'],
  messages: Array<GuestConversationSequenceMessageInput>,
};

export type UpdateGuestConversationSequencePayload = {
   __typename: 'UpdateGuestConversationSequencePayload',
  sequence: GuestConversationSequence,
};

export type UpdateLeadCampaignInput = {
  id: Scalars['LeadCampaignId'],
  name?: Maybe<Scalars['String']>,
  facets?: Maybe<Array<FacetSelection>>,
  minimumHoursSinceLastMessage?: Maybe<Scalars['Int']>,
  minimumHoursSinceLastCampaign?: Maybe<Scalars['Int']>,
  maximumRecipients?: Maybe<Scalars['Int']>,
  dateRangeFilters?: Maybe<Array<DateRangeFilterInput>>,
  keywordsFilter?: Maybe<Scalars['String']>,
  recipientSortOrder?: Maybe<LeadCampaignRecipientSortOrder>,
  triggerExecutionInterval?: Maybe<LeadCampaignTriggerExecutionInterval>,
};

export type UpdateLeadCampaignPayload = {
   __typename: 'UpdateLeadCampaignPayload',
  error?: Maybe<Scalars['String']>,
  campaign?: Maybe<LeadCampaign>,
};

export type UpdateLeadNoteInput = {
  id: Scalars['LeadNoteId'],
  text: Scalars['String'],
};

export type UpdateLeadNotePayload = {
   __typename: 'UpdateLeadNotePayload',
  note: SavedLeadNote,
};

export type UpdateLeadPayload = {
   __typename: 'UpdateLeadPayload',
  lead: Lead,
};

export type UpdateMerchantInput = {
  id: Scalars['MerchantId'],
  /** Name cannot be unset; it must either be omitted, or set with a non-null value */
  name?: Maybe<Scalars['String']>,
  website?: Maybe<Scalars['String']>,
  address?: Maybe<PostalAddressInput>,
  logoUrl?: Maybe<Scalars['String']>,
  shippingNotificationsEmail?: Maybe<Scalars['String']>,
  internal?: Maybe<Scalars['Boolean']>,
  estimatedMarginPercent?: Maybe<Scalars['Int']>,
  defaultCurrency?: Maybe<Scalars['String']>,
};

export type UpdateMerchantPayload = {
   __typename: 'UpdateMerchantPayload',
  merchant: Merchant,
};

export type UpdateMerchantRefundInput = {
  orderRefundId: Scalars['OrderRefundId'],
  refundedAmount: MonetaryAmountInput,
  refundNote?: Maybe<Scalars['String']>,
};

export type UpdateNotificationChannelsInput = {
  messagingUserId: Scalars['AnyId'],
  notificationChannels: Array<MessagingChannelType>,
};

export type UpdateNotificationChannelsPayload = {
   __typename: 'UpdateNotificationChannelsPayload',
  messagingUser?: Maybe<MessagingUser>,
};

export type UpdateOperatorInput = {
  operatorId: Scalars['OperatorId'],
  active: Scalars['Boolean'],
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  roles: Array<OperatorRole>,
  /** @deprecated Use roles */
  isAdmin?: Maybe<Scalars['Boolean']>,
};

export type UpdateOperatorPayload = {
   __typename: 'UpdateOperatorPayload',
  operator?: Maybe<Operator>,
};

export type UpdateOrderEscalationPayload = {
   __typename: 'UpdateOrderEscalationPayload',
  orderEscalation: OrderEscalation,
};

export type UpdateOrderExpertContributionsInput = {
  orderId: Scalars['OrderId'],
  contributions: Array<OrderExpertContributionInput>,
  updateTips?: Maybe<Scalars['Boolean']>,
};

export type UpdateOrderExpertContributionsPayload = {
   __typename: 'UpdateOrderExpertContributionsPayload',
  order: Order,
};

export type UpdateOrderPayload = {
   __typename: 'UpdateOrderPayload',
  order?: Maybe<Order>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type UpdateOrderRefundPayload = {
   __typename: 'UpdateOrderRefundPayload',
  orderRefund: OrderRefundWithError,
};

export type UpdateOrderShippingAddressInput = {
  orderId: Scalars['OrderId'],
  shippingAddress?: Maybe<AddressInput>,
};

export type UpdateOrderShippingAddressPayload = {
   __typename: 'UpdateOrderShippingAddressPayload',
  order: Order,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type UpdateOrderStateInput = {
  orderId: Scalars['OrderId'],
  newOrderState: OrderState,
};

export type UpdateOrderStatePayload = {
   __typename: 'UpdateOrderStatePayload',
  order?: Maybe<Order>,
  error?: Maybe<Scalars['String']>,
};

export type UpdatePaymentSourceInput = {
  id: Scalars['PaymentSourceId'],
  billingAddress: AddressInput,
  isDefault?: Maybe<Scalars['Boolean']>,
};

export type UpdatePaymentSourcePayload = {
   __typename: 'UpdatePaymentSourcePayload',
  paymentSource: PaymentSource,
};

export type UpdatePayoutPayload = {
   __typename: 'UpdatePayoutPayload',
  payout?: Maybe<Payout>,
  error?: Maybe<Scalars['String']>,
};

export type UpdatePayStructureRevisionInput = {
  id: Scalars['PayStructureRevisionId'],
  components: Array<PayComponentRuleInput>,
};

export type UpdatePayStructureRevisionPayload = {
   __typename: 'UpdatePayStructureRevisionPayload',
  revision?: Maybe<PayStructureRevision>,
  error?: Maybe<Scalars['String']>,
};

export type UpdatePreferredMessagingChannelsInput = {
  messagingUserId: Scalars['AnyId'],
  preferredMessagingChannels: Array<MessagingChannelType>,
};

export type UpdatePreferredMessagingChannelsPayload = {
   __typename: 'UpdatePreferredMessagingChannelsPayload',
  messagingUser?: Maybe<MessagingUser>,
};

export type UpdateProductReturnDestinationInput = {
  ticketId: Scalars['TicketId'],
  destination: ProductReturnDestination,
  note: Scalars['String'],
};

export type UpdatePromotionInput = {
  id: Scalars['PromotionId'],
  /** If omitted, this field won't be modified. */
  code?: Maybe<Scalars['String']>,
  /** If omitted, this field won't be modified. */
  description?: Maybe<Scalars['String']>,
  /** If omitted, this field won't be modified. */
  template?: Maybe<Scalars['Boolean']>,
  /** If omitted, this field won't be modified. If set to null, usageLimit will be removed. */
  usageLimit?: Maybe<Scalars['Int']>,
  /** If omitted, this field won't be modified. If set to null, expiresAt will be removed. */
  expiresAt?: Maybe<Scalars['Date']>,
};

export type UpdatePromotionPayload = {
   __typename: 'UpdatePromotionPayload',
  promotion: Promotion,
};

export type UpdateQuantityForOrderInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>,
  lineItems: Array<UpdateQuantityForOrderLineItemInput>,
};

export type UpdateQuantityForOrderLineItemInput = {
  id: Scalars['OrderLineItemId'],
  quantity: Scalars['Int'],
};

export type UpdateQuantityForOrderPayload = {
   __typename: 'UpdateQuantityForOrderPayload',
  order: Order,
};

export type UpdateQuickReplyInput = {
  id: Scalars['QuickReplyId'],
  name: Scalars['String'],
  text: Scalars['String'],
};

export type UpdateQuickReplyPayload = {
   __typename: 'UpdateQuickReplyPayload',
  quickReply: QuickReply,
};

export type UpdateRawSellableSourceInput = {
  id: Scalars['RawSellableSourceId'],
  name: Scalars['String'],
  state: RawSellableSourceState,
  fulfillmentChannelId?: Maybe<Scalars['FulfillmentChannelId']>,
  spider?: Maybe<RawSellableSourceSpiderInput>,
  googleShoppingFeed?: Maybe<RawSellableSourceGoogleShoppingFeedInput>,
  googleShoppingSearch?: Maybe<RawSellableSourceGoogleShoppingSearchInput>,
  levelNineFeed?: Maybe<RawSellableSourceLevelNineFeedInput>,
  shopify?: Maybe<RawSellableSourceShopifyInput>,
};

export type UpdateRawSellableSourcePayload = {
   __typename: 'UpdateRawSellableSourcePayload',
  source?: Maybe<RawSellableSource>,
  hasError: Scalars['Boolean'],
  errors?: Maybe<Array<Scalars['String']>>,
};

export type UpdateRawSellableStandardizationRuleInput = {
  id: Scalars['RawSellableStandardizationRuleId'],
  name: Scalars['String'],
  sourceId?: Maybe<Scalars['RawSellableSourceId']>,
  priority: Scalars['Int'],
  condition: RawSellableStandardizationRuleConditionInput,
  actions: Array<RawSellableStandardizationActionInput>,
  state: RawSellableStandardizationRuleState,
};

export type UpdateRawSellableStandardizationRulePayload = {
   __typename: 'UpdateRawSellableStandardizationRulePayload',
  rule?: Maybe<RawSellableStandardizationRule>,
  hasError: Scalars['Boolean'],
  errors?: Maybe<Array<Scalars['String']>>,
};

export type UpdateRecommendedListDefinitionInput = {
  id: Scalars['RecommendedListDefinitionId'],
  /** User friendly name for this recommended list definition */
  name?: Maybe<Scalars['String']>,
  /** 
 * The title template that will be used to build the RecommendedList title shown to the consumer.
   * The template should use the freemarker style `${variable}` format for inserting any dynamic values in the resolved title.
   * For example: "Because you like ${attribute.brands}"
   * Note, the querable attributes from the title will be used as a hard filter in the RecommenedList result.
   * For example, if the title said "Because you like
   * ${attribute.brands.displayName}", then the result will only include
   * recommendations
   * that strictly match the brands
 **/
  titleTemplate?: Maybe<Scalars['String']>,
  /** 
 * The subtitle template that will be used to build the RecommendedList's subtitle shown to the consumer
   * The template should use the freemarker style `${variable}` format for
   * inserting any dynamic values in the resolved subtitle.
   * This is mainly used to provide some additional context the recommended list
   * and for display purpose only with the resolved string.
 **/
  subTitleTemplate?: Maybe<Scalars['String']>,
  active?: Maybe<Scalars['Boolean']>,
  /** 
 * The relative rank of the RecommendedList built using this definition compared to other RecommendedList
   * when the user sees a list of RecommendedList
 **/
  rank?: Maybe<Scalars['Int']>,
  /** The categories for which this RecommendedListDefinition is being built. */
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  /** The filtering facets to refine recommended list results */
  queryFacets?: Maybe<Array<RecommendedListFacetSelectionInput>>,
  /** defaults to relevance based sorting */
  sortOptions?: Maybe<Array<RecommendedListSortOrderInput>>,
};

export type UpdateRecommendedListDefinitionPayload = {
   __typename: 'UpdateRecommendedListDefinitionPayload',
  recommendedListDefinition: RecommendedListDefinition,
};

export type UpdateReportInput = {
  reportId: Scalars['ReportId'],
  title: Scalars['String'],
  /** Must be globally unique if specified */
  internalName?: Maybe<Scalars['String']>,
  query: Scalars['String'],
  columns: Array<ReportColumnInput>,
  scope: ReportAccessScope,
  /** If specified, the columns from the schema are automatically added to the columns */
  schemaType?: Maybe<ReportSchemaType>,
};

export type UpdateReportPayload = {
   __typename: 'UpdateReportPayload',
  report: Report,
  errors?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type UpdateSavedExpertCuratedItemsInput = {
  id: Scalars['SavedExpertCuratedItemsId'],
  name?: Maybe<Scalars['String']>,
  /** Optional description for this curation */
  description?: Maybe<Scalars['String']>,
  taggedRequestAttributes?: Maybe<Array<AttributeInput>>,
};

export type UpdateSavedExpertCuratedItemsPayload = {
   __typename: 'UpdateSavedExpertCuratedItemsPayload',
  data?: Maybe<SavedExpertCuratedItems>,
  error?: Maybe<Scalars['String']>,
  hasError: Scalars['Boolean'],
};

export type UpdateSchedulingDemandForecastInput = {
  id: Scalars['SchedulingDemandForecastId'],
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  maximumShiftUnits: Scalars['BigDecimal'],
};

export type UpdateSchedulingDemandForecastPayload = {
   __typename: 'UpdateSchedulingDemandForecastPayload',
  error?: Maybe<Scalars['String']>,
  forecast?: Maybe<SchedulingDemandForecast>,
};

export type UpdateSchedulingTypeInput = {
  schedulingTypeId: Scalars['SchedulingTypeId'],
  settings: Array<SchedulingUserSettingsInput>,
};

export type UpdateSchedulingTypePayload = {
   __typename: 'UpdateSchedulingTypePayload',
  error?: Maybe<Scalars['String']>,
  schedulingType?: Maybe<SchedulingType>,
};

export type UpdateSchedulingUserPayload = {
   __typename: 'UpdateSchedulingUserPayload',
  schedulingUser?: Maybe<SchedulingUser>,
  error?: Maybe<Scalars['String']>,
};

export type UpdateSchedulingUserProfileInput = {
  userId: Scalars['AnyId'],
  schedulingTypeId: Scalars['SchedulingTypeId'],
  weeklyMaxShiftsOverride?: Maybe<Scalars['Int']>,
  dailyMaxShiftsOverride?: Maybe<Scalars['Int']>,
  priorityOverride?: Maybe<Scalars['Int']>,
  shiftUnitsOverride?: Maybe<Scalars['Int']>,
};

export type UpdateSchedulingUserRolesInput = {
  schedulingUserId: Scalars['AnyId'],
  roles: Array<SchedulingUserRole>,
};

export type UpdateSellableInput = {
  id: Scalars['SellableId'],
  /** strike out price of this sellable */
  originalPrice?: Maybe<MonetaryAmountInput>,
  /** default price we sell to consumer */
  salePrice?: Maybe<MonetaryAmountInput>,
  /** best offer price we sell to consumer which is not publically shown */
  bestOfferPrice?: Maybe<MonetaryAmountInput>,
  /** title */
  title?: Maybe<Scalars['String']>,
  /** description in markdown format */
  descriptionMarkdown?: Maybe<Scalars['String']>,
  /** images */
  imageIds?: Maybe<Array<Scalars['MediaId']>>,
  /** external videos */
  externalVideoUrls?: Maybe<Array<Scalars['String']>>,
  /** brochure */
  brochureUrl?: Maybe<Scalars['String']>,
  /** if the update should be applied to all other variants in the group */
  allVariants?: Maybe<Scalars['Boolean']>,
};

export type UpdateSellablePayload = {
   __typename: 'UpdateSellablePayload',
  sellable: Sellable,
  errorMessage?: Maybe<Scalars['String']>,
  hasError: Scalars['Boolean'],
};

/** `address` or `rawAddress` is required */
export type UpdateServiceLocationExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'],
  address?: Maybe<PostalAddressInput>,
  /** 
 * If entered, this will be geolocated and standardized into a `PostalAddress`. On geolocation failure, the
   * payload will have an appropriate errorCode and message.
 **/
  rawAddress?: Maybe<Scalars['String']>,
};

export type UpdateServiceLocationExpertCuratedOrderPayload = {
   __typename: 'UpdateServiceLocationExpertCuratedOrderPayload',
  expertCuratedOrder: ExpertCuratedOrder,
  errorCode?: Maybe<ExpertCuratedOrderServiceLocationErrorCode>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type UpdateShiftInput = {
  shiftSlotId: Scalars['ShiftSlotId'],
};

export type UpdateShiftPayload = {
   __typename: 'UpdateShiftPayload',
  error?: Maybe<Scalars['String']>,
  shiftSlotUserView?: Maybe<ShiftSlotUserView>,
};

export type UpdateShippingMethodInput = {
  orderId: Scalars['OrderId'],
  shippingMethod: ShippingMethod,
};

export type UpdateShippingMethodPayload = {
   __typename: 'UpdateShippingMethodPayload',
  order: Order,
};

export type UpdateSupportConversationPayload = {
   __typename: 'UpdateSupportConversationPayload',
  supportConversation: SupportConversation,
};

export type UpdateTemplateFragmentInput = {
  id: Scalars['CommTemplateFragmentId'],
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  content?: Maybe<Scalars['String']>,
  type?: Maybe<TemplateFragmentType>,
  nestedContentAllowed?: Maybe<Scalars['Boolean']>,
  nestedContentExample?: Maybe<Scalars['String']>,
  parameters?: Maybe<Array<Maybe<TemplateFragmentParameterInput>>>,
};

export type UpdateTemplateFragmentPayload = {
   __typename: 'UpdateTemplateFragmentPayload',
  fragment?: Maybe<CommTemplateFragment>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type UpdateTemplateInput = {
  templateId: Scalars['CommTemplateId'],
  title?: Maybe<Scalars['String']>,
  categoryId?: Maybe<Scalars['CategoryId']>,
  categoryType?: Maybe<CategoryType>,
  experimentKey?: Maybe<Scalars['String']>,
  treatments?: Maybe<Array<Scalars['String']>>,
  tagSyntax?: Maybe<TemplateTagSyntax>,
  emailFromAddress?: Maybe<Scalars['String']>,
};

export type UpdateTemplatePayload = {
   __typename: 'UpdateTemplatePayload',
  multiLocaleTemplate?: Maybe<MultiLocaleTemplateSet>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type UpdateTemplateTypeInput = {
  templateTypeId: Scalars['CommTemplateTypeId'],
  group: TemplateTypeGroup,
  unsubscribeTag?: Maybe<MessageUnsubscribeTag>,
  displayName: Scalars['String'],
  description: Scalars['String'],
  richCardType?: Maybe<MessageRichCardType>,
  dataModel: TemplateDataModelInput,
};

export type UpdateTemplateTypePayload = {
   __typename: 'UpdateTemplateTypePayload',
  error?: Maybe<Scalars['String']>,
  templateType?: Maybe<CommTemplateType>,
};

export type UpdateTicketPayload = {
   __typename: 'UpdateTicketPayload',
  ticket: Ticket,
};

export type UpdateTriggerActionInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  actionName: Scalars['String'],
  parameters: Array<TriggerActionParameterInput>,
};

export type UpdateTriggerBranchInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  condition: TriggerConditionInput,
};

export type UpdateTriggerDelayInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  fixedInterval?: Maybe<TriggerDelayFixedIntervalInput>,
  delayWithExperiment?: Maybe<TriggerDelayWithExperimentInput>,
  dynamicInterval?: Maybe<TriggerDelayDynamicIntervalInput>,
};

export type UpdateTriggerEdgeInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  edgeType: TriggerNodeEdgeType,
  nextNodeId: Scalars['TriggerNodeId'],
};

export type UpdateTriggerFilterInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  condition: TriggerConditionInput,
};

export type UpdateTriggerInput = {
  triggerId: Scalars['TriggerId'],
  name: Scalars['String'],
  groupName: Scalars['String'],
  description: Scalars['String'],
};

export type UpdateTriggerPayload = {
   __typename: 'UpdateTriggerPayload',
  trigger: Trigger,
};

export type UpdateTriggerWaitInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  eventName: Scalars['String'],
  eventEntityId: TriggerParameterInput,
  maxWaitTime: TriggerDurationInput,
};

export type UpdateUserProfileInput = {
  userId?: Maybe<Scalars['UserId']>,
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  address?: Maybe<PostalAddressInput>,
  /** @deprecated use address */
  addressLine1?: Maybe<Scalars['String']>,
  /** @deprecated use address */
  addressLine2?: Maybe<Scalars['String']>,
  /** @deprecated use address */
  city?: Maybe<Scalars['String']>,
  /** @deprecated use address */
  state?: Maybe<Scalars['String']>,
  /** @deprecated use address */
  postalCode?: Maybe<Scalars['String']>,
  /** @deprecated use address */
  country?: Maybe<Scalars['String']>,
};

export type UpdateUserProfilePayload = {
   __typename: 'UpdateUserProfilePayload',
  user: User,
  errorCode?: Maybe<UserEditErrorCode>,
  hasError: Scalars['Boolean'],
  errors: Array<Scalars['String']>,
};

export type UpdateUserSourceInput = {
  userId: Scalars['UserId'],
  type: EditableUserSourceType,
};

export type UpdateUserSourcePayload = {
   __typename: 'UpdateUserSourcePayload',
  user: User,
  errorCode?: Maybe<UserEditErrorCode>,
  hasError: Scalars['Boolean'],
  errors: Array<Scalars['String']>,
};

export enum UpdateUserSourceToConsumerReferralErrorCode {
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  REFERRER_NOT_FOUND = 'REFERRER_NOT_FOUND'
}

export type UpdateUserSourceToConsumerReferralResult = {
   __typename: 'UpdateUserSourceToConsumerReferralResult',
  consumer: User,
  hasError: Scalars['Boolean'],
  errorCode?: Maybe<UpdateUserSourceToConsumerReferralErrorCode>,
  errorMessage?: Maybe<Scalars['String']>,
};

export type UpgradeGuestConversationInput = {
  conversation: GuestConversationInput,
};

export type UpgradeGuestConversationPayload = EncodedAuthenticationTokensPayload & {
   __typename: 'UpgradeGuestConversationPayload',
  me: Myself,
  lead: Lead,
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>,
};


export type UploadBrandsInput = {
  googleSpreadsheetId: Scalars['String'],
};

export type UploadBrandsPayload = {
   __typename: 'UploadBrandsPayload',
  task?: Maybe<FrontendTask>,
};

export type UploadFeaturedSellableContentInput = {
  mediaId: Scalars['MediaId'],
};

export type UploadFeaturedSellableContentPayload = {
   __typename: 'UploadFeaturedSellableContentPayload',
  task?: Maybe<FrontendTask>,
};

export type UploadMediaInput = {
  file: Scalars['Upload'],
  persist?: Maybe<Scalars['Boolean']>,
  mimeType?: Maybe<Scalars['String']>,
};

export type UploadMediaPayload = {
   __typename: 'UploadMediaPayload',
  mediaFile?: Maybe<MediaFile>,
};

export type UploadMerchantsInput = {
  googleSpreadsheetId: Scalars['String'],
  categoryId: Scalars['CategoryId'],
};

export type UploadMerchantsPayload = {
   __typename: 'UploadMerchantsPayload',
  task?: Maybe<FrontendTask>,
};

export type UploadSellableDeactivationsInput = {
  googleSpreadsheetId: Scalars['String'],
  deactivateVariations?: Maybe<Scalars['Boolean']>,
};

export type UploadSellableDeactivationsPayload = {
   __typename: 'UploadSellableDeactivationsPayload',
  task?: Maybe<FrontendTask>,
};

export type UploadSellableInventoryInput = {
  googleSpreadsheetId: Scalars['String'],
  categoryId: Scalars['CategoryId'],
  fulfillmentCenterId?: Maybe<Scalars['FulfillmentCenterId']>,
  /** UPS sheet download is not generated for multiple tab uploads */
  multiTabUpload?: Maybe<Scalars['Boolean']>,
  /** 
 * Partner inventory like dropshipped products are managed on a different shopify instance.
   * They are also not saved in our database during import as a SellableInventoryItem
 **/
  partnerInventory?: Maybe<Scalars['Boolean']>,
};

export type UploadSellableInventoryPayload = {
   __typename: 'UploadSellableInventoryPayload',
  task?: Maybe<FrontendTask>,
};

export type UploadSellablePriceInput = {
  googleSpreadsheetId: Scalars['String'],
  /** this field is deprecated and ignored */
  categoryId?: Maybe<Scalars['CategoryId']>,
};

export type UploadSellablePricePayload = {
   __typename: 'UploadSellablePricePayload',
  task?: Maybe<FrontendTask>,
};

export type UploadSellablesInput = {
  googleSpreadsheetId: Scalars['String'],
  filterGoogleSpreadsheetId?: Maybe<Scalars['String']>,
  categoryId: Scalars['CategoryId'],
};

export type UploadSellablesPayload = {
   __typename: 'UploadSellablesPayload',
  task?: Maybe<FrontendTask>,
};

export type UploadSellableUpdatesInput = {
  googleSpreadsheetId: Scalars['String'],
};

export type UploadSellableUpdatesPayload = {
   __typename: 'UploadSellableUpdatesPayload',
  task?: Maybe<FrontendTask>,
};

export type UpsertActionIntoPromotionInput = {
  id: Scalars['PromotionId'],
  /** If specified, the existing action with this same expectedReference id will be updated */
  referenceId?: Maybe<Scalars['PromotionActionReferenceId']>,
  action: PromotionActionReferenceInput,
};

export type UpsertActionIntoPromotionPayload = {
   __typename: 'UpsertActionIntoPromotionPayload',
  promotion: Promotion,
};

export type UpsertExpertCuratedLeadItineraryInput = {
  id: Scalars['LeadId'],
  contentfulVariation: Scalars['String'],
};

export type UpsertExpertCuratedLeadItineraryPayload = {
   __typename: 'UpsertExpertCuratedLeadItineraryPayload',
  expertCuratedLeadItinerary: ExpertCuratedLeadItinerary,
};

export type UpsertItemInExpertCuratedOrderInput = {
  id: Scalars['SellableId'],
  title?: Maybe<Scalars['String']>,
  price?: Maybe<MonetaryAmountInput>,
  /** Defaults to true */
  taxable?: Maybe<Scalars['Boolean']>,
  /** Defaults to true */
  optional?: Maybe<Scalars['Boolean']>,
  manualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustmentInput>,
};

export type UpsertItemsInExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'],
  items: Array<UpsertItemInExpertCuratedOrderInput>,
};

export type UpsertItemsInExpertCuratedOrderPayload = {
   __typename: 'UpsertItemsInExpertCuratedOrderPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

export type UpsertLegsIntoFlightPlanInput = {
  id: Scalars['FlightPlanId'],
  legs: Array<FlightPlanLegUpsertRequestInput>,
};

export type UpsertLegsIntoFlightPlanPayload = {
   __typename: 'UpsertLegsIntoFlightPlanPayload',
  flightPlan: FlightPlan,
  errorCode?: Maybe<FlightPlanEditErrorCode>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type UpsertRuleIntoPromotionInput = {
  id: Scalars['PromotionId'],
  /** If specified, the existing rule with this same expectedReference id will be updated */
  referenceId?: Maybe<Scalars['PromotionRuleReferenceId']>,
  rule: PromotionRuleReferenceInput,
};

export type UpsertRuleIntoPromotionPayload = {
   __typename: 'UpsertRuleIntoPromotionPayload',
  promotion: Promotion,
};

export type User = {
   __typename: 'User',
  /** 
 * This needs to AnyId instead of UserId since it is used with other identity objects such as BusinessUser
   * in a few union type.  Graphql will complain if the same field return different types
 **/
  id: Scalars['AnyId'],
  firstName?: Maybe<Scalars['String']>,
  /** AUTH | Only current user and operator */
  lastName?: Maybe<Scalars['String']>,
  /** AUTH | Only current user and operator */
  contacts: Array<Contact>,
  /** AUTH | Only current user */
  roles: Array<Scalars['String']>,
  /** AUTH | Only current user */
  messagingUserId: Scalars['AnyId'],
  messagingUser: MessagingUser,
  /** AUTH | Only current user, merchant, or operator */
  profilePhoto?: Maybe<MediaFile>,
  /** AUTH | Only current user, operator.  address saved on the user profile. */
  address?: Maybe<PostalAddress>,
  /** AUTH | Only current user, operator.  addressed saved for payment */
  savedAddresses: Array<Address>,
  /** AUTH | Only current user, operator */
  assignedOperatorSeat?: Maybe<Operator>,
  assignedBusinessUsers: Array<BusinessUser>,
  externalProfiles: Array<ExternalProfile>,
  presence: PresenceStatus,
  anonymous: Scalars['Boolean'],
  pathUrl: Scalars['String'],
  browseUrl: Scalars['String'],
  recentCompletedPathIds: Array<Scalars['PathFlowId']>,
  recentIncompletePathIds: Array<Scalars['PathFlowId']>,
  firstCompletedRequest?: Maybe<DealRequest>,
  mostRecentRequest?: Maybe<DealRequest>,
  /** most recent lead sorted by activity time or creation date */
  mostRecentLead?: Maybe<Lead>,
  zoneId: Scalars['String'],
  /** 
 * use hasPhoneNumber instead of phoneNumber to check if the user has phone number
   * since phoneNumber can be null if the viewer doesn't have  permission
 **/
  hasPhoneNumber: Scalars['Boolean'],
  /** 
 * use hasEmail instead of email to check if the user has phone number
   * since email can be null if the viewer doesn't have  permission
 **/
  hasEmail: Scalars['Boolean'],
  phoneNumber?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  facebookMessengerId?: Maybe<Scalars['String']>,
  referredBy?: Maybe<User>,
  vip: Scalars['Boolean'],
  organic: Scalars['Boolean'],
  referral: Scalars['Boolean'],
  orders: Array<Order>,
  source?: Maybe<UserSource>,
  ipBasedData?: Maybe<IpBasedUserData>,
  adminUrl: Scalars['String'],
  /** Globally unique referral code */
  referralCode?: Maybe<Scalars['String']>,
  experimentUserId: Scalars['AnyId'],
  isAllowedToRefer: Scalars['Boolean'],
  sourceHistory: Array<UserSource>,
  consumerExpertReviewConnection: ConsumerExpertReviewConnection,
  expertReviews: Array<ConsumerExpertReview>,
  viewSellableActivities: Array<ViewSellableUserActivity>,
  summarizedViewSellableActivities: Array<SummarizedViewSellableUserActivity>,
  summarizedActivities: Array<SummarizedUserActivity>,
  userJourneyStages: Array<UserJourneyStage>,
  referredByReferralCode?: Maybe<ReferralCode>,
};


export type UserExternalProfilesArgs = {
  type?: Maybe<ExternalProfileType>,
  premium?: Maybe<Scalars['Boolean']>
};


export type UserPathUrlArgs = {
  pathFlowId: Scalars['PathFlowId']
};


export type UserBrowseUrlArgs = {
  pathFlowId: Scalars['PathFlowId']
};


export type UserMostRecentLeadArgs = {
  sortBy?: Maybe<LeadSortOrder>
};


export type UserConsumerExpertReviewConnectionArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type UserExpertReviewsArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>
};


export type UserViewSellableActivitiesArgs = {
  categoryId?: Maybe<Scalars['CategoryId']>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  occurredSince?: Maybe<Scalars['Date']>,
  limit?: Maybe<Scalars['Int']>
};


export type UserSummarizedViewSellableActivitiesArgs = {
  categoryId?: Maybe<Scalars['CategoryId']>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  occurredSince?: Maybe<Scalars['Date']>,
  limit?: Maybe<Scalars['Int']>
};


export type UserSummarizedActivitiesArgs = {
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  leadIds?: Maybe<Array<Scalars['LeadId']>>,
  occurredSince?: Maybe<Scalars['Date']>,
  occurredBefore?: Maybe<Scalars['Date']>,
  limit?: Maybe<Scalars['Int']>
};

export type UserActivity = {
  id: Scalars['UserActivityId'],
  userId: Scalars['UserId'],
  type: UserActivityType,
  occurredAt: Scalars['Date'],
};


export enum UserActivityType {
  ADD_SELLABLE = 'ADD_SELLABLE',
  CHECKOUT_STARTED = 'CHECKOUT_STARTED',
  COMPLETE_ORDER = 'COMPLETE_ORDER',
  CURATED_LIST_VIEWED = 'CURATED_LIST_VIEWED',
  PAYMENT_INFO_ENTERED = 'PAYMENT_INFO_ENTERED',
  REMOVE_SELLABLE = 'REMOVE_SELLABLE',
  SEARCH_SELLABLES = 'SEARCH_SELLABLES',
  VIEW_CART = 'VIEW_CART',
  VIEW_SELLABLE = 'VIEW_SELLABLE',
  VOICE_CALL = 'VOICE_CALL',
  SAVED_SELLABLE = 'SAVED_SELLABLE',
  UNSAVED_SELLABLE = 'UNSAVED_SELLABLE'
}

/** ====== UserContactPathFlowQuestion */
export type UserContactPathFlowQuestion = PathFlowQuestion & {
   __typename: 'UserContactPathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  firstName?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  lastName?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  phoneNumber?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  /** If reloading a question answered by the user, this is their previous input */
  userContactUserInput: SubmitUserContactPathFlowQuestionInputTypeCopy,
};


/** ====== UserContactPathFlowQuestion */
export type UserContactPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export enum UserEditErrorCode {
  FIRST_NAME_REQUIRED = 'FIRST_NAME_REQUIRED',
  INVALID_CONTACT = 'INVALID_CONTACT'
}


export type UserJourneyLeadStage = UserJourneyStage & {
   __typename: 'UserJourneyLeadStage',
  type: UserJourneyStageType,
  leadStageStatus: UserJourneyLeadStageStatus,
  lead: Lead,
};

export enum UserJourneyLeadStageStatus {
  NO_CURATION = 'NO_CURATION',
  CURATION_READY = 'CURATION_READY',
  OLD_CURATION = 'OLD_CURATION'
}

export type UserJourneyNewStage = UserJourneyStage & {
   __typename: 'UserJourneyNewStage',
  type: UserJourneyStageType,
};

export type UserJourneyOrderStage = UserJourneyStage & {
   __typename: 'UserJourneyOrderStage',
  type: UserJourneyStageType,
  orderStageStatus: UserJourneyOrderStageStatus,
  order: Order,
};

export enum UserJourneyOrderStageStatus {
  PLACED = 'PLACED',
  IN_TRANSIT = 'IN_TRANSIT',
  DELIVERED = 'DELIVERED'
}

export type UserJourneyStage = {
  type: UserJourneyStageType,
};

export enum UserJourneyStageType {
  NEW = 'NEW',
  LEAD = 'LEAD',
  ORDER = 'ORDER'
}

export type UserSearchQuery = {
  keywords?: Maybe<Scalars['String']>,
};

export type UserSearchResult = {
   __typename: 'UserSearchResult',
  totalCount: Scalars['Long'],
  users: Array<User>,
};

export type UserSource = {
   __typename: 'UserSource',
  type: UserSourceType,
  initialUrl?: Maybe<Scalars['String']>,
  referrerUrl?: Maybe<Scalars['String']>,
  attributes: Array<UserSourceAttribute>,
  landingPageKey?: Maybe<Scalars['String']>,
  /** 
 * ONLY to be used for the campaign side as a means of marking the department at the time of the user's registration.
   * This is not a reliable means of deriving the user's first or last touch attribution.
 **/
  registrationDepartment?: Maybe<Department>,
  referralCode?: Maybe<ReferralCode>,
  occurredAt?: Maybe<Scalars['Date']>,
};

export type UserSourceAttribute = {
   __typename: 'UserSourceAttribute',
  name: Scalars['String'],
  value: Scalars['String'],
};

export enum UserSourceType {
  ADS = 'ADS',
  REFERRAL = 'REFERRAL',
  EXPERT_REFERRAL = 'EXPERT_REFERRAL',
  PHONE_CALL = 'PHONE_CALL',
  SMS = 'SMS',
  EMAIL = 'EMAIL',
  INVESTOR = 'INVESTOR',
  PARTNER = 'PARTNER',
  ORGANIC = 'ORGANIC'
}

/** Limit the amount of times a user can use a given promotion */
export type UserUsageLimitPromotionRuleReference = PromotionRuleReference & {
   __typename: 'UserUsageLimitPromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
  /** The maximum amount of times the user can utilize this promotion. */
  limit: Scalars['Int'],
};

/** See `UserUsageLimitPromotionRuleReference` for documentation */
export type UserUsageLimitPromotionRuleReferenceInput = {
  limit: Scalars['Int'],
};

export type ValidateTriggerInput = {
  triggerId: Scalars['TriggerId'],
};

export type ValidateTriggerPayload = {
   __typename: 'ValidateTriggerPayload',
  errors: Array<Scalars['String']>,
};

/** 
 * A matrix of related sellables.
 * 
 * There are three hierarchies to this data structure; this variation matrix, the set of dimensions it contains, and
 * vectors for each dimension. Rather than defining these in abstract terms, lets work off of a simple example sellable.
 * 
 * Lets assume there's a parent sellable for "Nike T-Shirt", and it can vary on color (red, blue) and size (small,
 * medium, large). To understand the vocabulary used here, envision a matrix with two axis, "Color" on X, and "Size" on
 * Y. Each column will be marked with a color (red or blue), and each row will be marked with a size (small, medium, or
 * large). Each cell is a unique sellable variant (e.g.: Large Red Nike T-Shirt).
 * 
 * This is how the above concept is represented with the variation matrix data structures:
 * 
 * - VariationMatrix: This class which represents the entire matrix. This only contains variations, so in our example
 *   this will contain "Medium Red" and "Small Blue" T-Shirts, but doesn't contain the top level "Nike T-Shirt" sellable.
 * - VariationMatrixDimension: A dimension (axis) which a sellable can vary. In our example, there
 *   will be two dimensions; Size and Color. These are the axis on our matrix.
 * - VariationMatrixVector: For each of the dimensions, there will be a vector (a row or column) in the matrix that
 *   represents a unique value for that dimension. For example, if the dimension is "Color", a Vector may be labled with
 *   "red". Note that this is not a "cell" of a matrix which would represent a single SellableId (like "Medium Red"), this
 *   represents the entire column/row. So for the "red" vector, it will contain three SellableIds: "Small red", "Medium
 *   red", and "Large red". See following sections for how to use this data.
 * 
 * To allow for seamless client UIs that don't require network communication when flipping between variants, API calls
 * are not required to compute what variants are applicable as variants or selected, or to get the final sellable id
 * after all variants are selected. Instead, two things are provided:
 * 
 * 
 * - All of the related SellableIds that are part of this variation matrix (via sellables property). This is guaranteed
 *   to contain all variations, so it's possible to pre-load these sellables to provide a seamless UI that show details of
 *   sellables as variants are selected / moused over without going back to the network.
 * - For each vector (e.g.: color red), the SellableIds that match that criteria (via VariationMatrixVector.sellableIds).
 * 
 * To compute what sellables (if any) are applicable, take the intersection of the SellableIds for each selected vector
 * in each dimension (there should only be one selected vector per dimension). This computation will result in zero or
 * one SellableIds - zero if there are no sellables for that variation combination, or one which will be the sellable for
 * that variation combination.
 **/
export type VariationMatrix = {
   __typename: 'VariationMatrix',
  /** 
 * Dimensions for this variation matrix; a dimension is something like "color", "size", "gender", etc.
   * Each dimension will contain at least one vector
 **/
  dimensions: Array<VariationMatrixDimension>,
  /** All of the sellable ids that are inside of this variation matrix, excluding the parent sellable. */
  sellables: Array<Sellable>,
  /** The price range across all the sellables in the variation matrix. */
  priceRange?: Maybe<VariationMatrixPriceRange>,
  /** The preferred sellable variant to show by default */
  defaultVariant: Sellable,
  /** 
 * Variant that has the maximum delta between original price (MSRP) and sale price. If none of the variants provide
   * savings over MSRP, this will be the cheapest variant
 **/
  maximumSavingsVariant: Sellable,
  /** 
 * The maximum delta between original price (MSRP) and sale price across all variations. If none of the variants
   * provide savings over MSRP, this will be null.
 **/
  maximumSavingsAmount?: Maybe<MonetaryAmount>,
  /** 
 * The maximum percent savings between original price (MSRP) and sale price across all variations. If none of the
   * variants provide savings over MSRP, this will be null.
 **/
  maximumSavingsPercent?: Maybe<Scalars['Float']>,
  /** All out of stock sellables that are inside of this variation matrix. */
  outOfStockSellables: Array<Sellable>,
};

/** Dimensions represent categories of things that are varied on, like color, size, gender, etc. */
export type VariationMatrixDimension = {
   __typename: 'VariationMatrixDimension',
  /** Internal name for this variation matrix dimension; not intended to be displayed in the UI */
  name: Scalars['String'],
  /** 
 * Display name for this dimension.
   * This may be something like "Color", "Length", where it effectively serves as a title for the vectors within this
   * dimension. Note that this display name is not required. For example, if there is only one dimension, and that's a
   * title dimension, the grouping may not be titled. For title dimensions, each vector may be the shortened product
   * title, e.g.: "Red Special Edition", "Anniversary Edition", "Game of the year bundle".
 **/
  displayName?: Maybe<Scalars['String']>,
  /** 
 * Vectors (unique options) within this dimension.
   * 
   * If this dimension is color, vectors will represent concrete values like "Red", "Blue", "Black", etc.
 **/
  vectors: Array<VariationMatrixVector>,
};

export type VariationMatrixPriceRange = {
   __typename: 'VariationMatrixPriceRange',
  min: MonetaryAmount,
  max: MonetaryAmount,
};

/** 
 * A unique option within a dimension.
 * For example, if this vector is contained inside of the "color" dimension, this may represent the color "red".
 **/
export type VariationMatrixVector = {
   __typename: 'VariationMatrixVector',
  /** Internal value for this vector; not to be displayed in the UI. Expect this to be things like "RED", "123", "WOMAN", etc. */
  value: Scalars['String'],
  /** 
 * Display value formatted as sanitized HTML. To match with the value property examples, expect this to be things like
   * "Red", "123cm", "Woman", etc.
 **/
  displayValueHtml: Scalars['String'],
  /** 
 * All of the sellable ids (subset of VariationMatrix.sellables) that fall into this vector.
   * See the docs associated with VariationMatrix to see how these SellableIds should be used.
 **/
  sellableIds: Array<Scalars['SellableId']>,
};

export type VerifyHandleChallengeInput = {
  /** handle/handleType or handleId must be present */
  handle?: Maybe<Scalars['String']>,
  handleType?: Maybe<HandleType>,
  handleId?: Maybe<Scalars['AnyId']>,
  challenge: Scalars['String'],
};

export type VerifyHandleChallengePayload = {
   __typename: 'VerifyHandleChallengePayload',
  success: Scalars['Boolean'],
  message?: Maybe<Scalars['String']>,
};

export type VerifyOrderInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
  note: Scalars['String'],
  verificationSuccessful: Scalars['Boolean'],
};

export type VerifyPaymentTransactionInput = {
  orderId: Scalars['OrderId'],
  transactionId: Scalars['TransactionId'],
  code?: Maybe<Scalars['String']>,
  amount?: Maybe<MonetaryAmountInput>,
};

export type VerifyPaymentTransactionPayload = {
   __typename: 'VerifyPaymentTransactionPayload',
  order: Order,
  verified: Scalars['Boolean'],
  error?: Maybe<Scalars['String']>,
};

export enum VerifyPendingAccessContactErrorCode {
  INVALID_TOKEN = 'INVALID_TOKEN'
}

export type VerifyPendingAccessContactInput = {
  id: Scalars['PendingAccessContactId'],
  token: Scalars['String'],
};

export type VerifyPendingAccessContactPayload = {
   __typename: 'VerifyPendingAccessContactPayload',
  pendingAccessContact?: Maybe<PendingAccessContact>,
  hasError: Scalars['Boolean'],
  errorCode?: Maybe<VerifyPendingAccessContactErrorCode>,
  errorMessage?: Maybe<Scalars['String']>,
};

export type VerifyResetPasswordChallengeInput = {
  handle?: Maybe<Scalars['String']>,
  handleType?: Maybe<HandleType>,
  challenge: Scalars['String'],
};

export type VerifyResetPasswordChallengePayload = {
   __typename: 'VerifyResetPasswordChallengePayload',
  success: Scalars['Boolean'],
  message?: Maybe<Scalars['String']>,
  session: Session,
};

export type ViewSellableUserActivity = UserActivity & {
   __typename: 'ViewSellableUserActivity',
  id: Scalars['UserActivityId'],
  userId: Scalars['UserId'],
  type: UserActivityType,
  occurredAt: Scalars['Date'],
  endedAt?: Maybe<Scalars['Date']>,
  sellable: Sellable,
};

export type VoiceCallUserActivity = UserActivity & {
   __typename: 'VoiceCallUserActivity',
  id: Scalars['UserActivityId'],
  userId: Scalars['UserId'],
  type: UserActivityType,
  expertId: Scalars['BusinessUserId'],
  userPhoneNumber: Scalars['String'],
  status: Scalars['String'],
  callId: Scalars['String'],
  occurredAt: Scalars['Date'],
};

export type WireTransferPaymentEntity = PaymentEntity & {
   __typename: 'WireTransferPaymentEntity',
  paymentMethod: PaymentMethod,
  accountNumber: Scalars['String'],
  bankName: Scalars['String'],
  routingNumber: Scalars['String'],
  swiftCode: Scalars['String'],
  beneficiaryName: Scalars['String'],
  beneficiaryAddress: WireTransferPaymentEntityBeneficiaryAddress,
  chargeableAmount: MonetaryAmount,
};

export type WireTransferPaymentEntityBeneficiaryAddress = {
   __typename: 'WireTransferPaymentEntityBeneficiaryAddress',
  line1: Scalars['String'],
  line2?: Maybe<Scalars['String']>,
  city: Scalars['String'],
  state: Scalars['String'],
  country: Scalars['String'],
  postalCode: Scalars['String'],
};

export type WokeUpFromSnoozeActivity = LeadActivity & {
   __typename: 'WokeUpFromSnoozeActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  snooze: LeadSnooze,
  performedBy: Identity,
};

export enum WorkflowFailureResolution {
  RETRY_WORKFLOW = 'RETRY_WORKFLOW',
  AUTO_ESCALATE = 'AUTO_ESCALATE',
  MANUAL_ESCALATE = 'MANUAL_ESCALATE'
}

export enum WorkflowType {
  BASIC = 'BASIC',
  FULFILLMENT = 'FULFILLMENT'
}

export type YadavSellablePriceSource = SellablePriceSource & {
   __typename: 'YadavSellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  bestOfferPrice?: Maybe<MonetaryAmount>,
  cost?: Maybe<MonetaryAmount>,
  expiresAt?: Maybe<Scalars['Date']>,
  fulfillmentChannel?: Maybe<FulfillmentChannel>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  externalId: Scalars['String'],
  certificateUrl?: Maybe<Scalars['String']>,
};

export type AuthenticateMutationVariables = {
  input: AuthenticationInput
};


export type AuthenticateMutation = (
  { __typename: 'Mutation' }
  & { authenticate: (
    { __typename: 'AuthenticationResultPayload' }
    & Pick<AuthenticationResultPayload, 'result' | 'message'>
    & { user: Maybe<(
      { __typename: 'User' }
      & AuthenticatedUserFragment
    )> }
  ) }
);

export type AuthenticationSessionStateQueryVariables = {};


export type AuthenticationSessionStateQuery = (
  { __typename: 'Query' }
  & { session: (
    { __typename: 'Session' }
    & AuthenticationStateFragment
  ) }
);

export type AuthenticationStateFragment = (
  { __typename: 'Session' }
  & Pick<Session, 'id' | 'authenticationMethod'>
  & { authenticationState: (
    { __typename: 'AuthenticationSessionState' }
    & Pick<AuthenticationSessionState, 'handle' | 'handleId' | 'loginChallengeType' | 'resetPasswordChallengeVerified'>
  ) }
);

export type FindContactQueryVariables = {
  contactId: Scalars['ContactId']
};


export type FindContactQuery = (
  { __typename: 'Query' }
  & { findContact: Maybe<(
    { __typename: 'Contact' }
    & Pick<Contact, 'id' | 'type' | 'value' | 'verified'>
  )> }
);

export type InitiateAuthenticationMutationVariables = {
  input: InitiateAuthenticationInput
};


export type InitiateAuthenticationMutation = (
  { __typename: 'Mutation' }
  & { initiateAuthentication: (
    { __typename: 'InitiateAuthenticationPayload' }
    & Pick<InitiateAuthenticationPayload, 'isValidHandle' | 'challengeType'>
    & { session: (
      { __typename: 'Session' }
      & AuthenticationStateFragment
    ) }
  ) }
);

export type InitiateResetPasswordMutationVariables = {
  input: InitiateResetPasswordInput
};


export type InitiateResetPasswordMutation = (
  { __typename: 'Mutation' }
  & { initiateResetPassword: (
    { __typename: 'InitiateResetPasswordPayload' }
    & Pick<InitiateResetPasswordPayload, 'success' | 'errorMessage'>
  ) }
);

export type LogoutMutationVariables = {};


export type LogoutMutation = (
  { __typename: 'Mutation' }
  & Pick<Mutation, 'logout'>
);

export type ResetPasswordMutationVariables = {
  input: ResetPasswordInput
};


export type ResetPasswordMutation = (
  { __typename: 'Mutation' }
  & { resetPassword: (
    { __typename: 'ResetPasswordPayload' }
    & Pick<ResetPasswordPayload, 'result' | 'message'>
    & { user: Maybe<(
      { __typename: 'User' }
      & AuthenticatedUserFragment
    )> }
  ) }
);

export type SessionAuthenticationStateQueryVariables = {};


export type SessionAuthenticationStateQuery = (
  { __typename: 'Query' }
  & { session: (
    { __typename: 'Session' }
    & Pick<Session, 'id' | 'authenticationMethod'>
    & { authenticationState: (
      { __typename: 'AuthenticationSessionState' }
      & Pick<AuthenticationSessionState, 'handle' | 'handleId' | 'loginChallengeType' | 'resetPasswordChallengeVerified'>
    ) }
  ) }
);

export type ExpertPhoneNumberBySlugQueryVariables = {
  slug: Scalars['String']
};


export type ExpertPhoneNumberBySlugQuery = (
  { __typename: 'Query' }
  & { categoryBySlug: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id'>
    & { recommendExpertForConsumer: (
      { __typename: 'RecommendExpertPayload' }
      & { expert: Maybe<(
        { __typename: 'BusinessUser' }
        & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
        & { assignedPhone: BusinessUser['assignedAddress'] }
        & { expertProfile: Maybe<(
          { __typename: 'ExpertProfile' }
          & Pick<ExpertProfile, 'id'>
          & { profilePhoto: Maybe<(
            { __typename: 'MediaFile' }
            & Pick<MediaFile, 'id' | 'url'>
          )> }
        )> }
      )> }
    ) }
  )> }
);

export type CategoryBreadcrumbFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'>
);

export type ChatExpertQueryVariables = {
  businessUserId: Scalars['BusinessUserId']
};


export type ChatExpertQuery = (
  { __typename: 'Query' }
  & { businessUser: (
    { __typename: 'BusinessUser' }
    & ChatWidgetExpertFragment
  ) }
);

export type ChatExpertByDepartmentQueryVariables = {
  id: Scalars['DepartmentId']
};


export type ChatExpertByDepartmentQuery = (
  { __typename: 'Query' }
  & { department: (
    { __typename: 'Department' }
    & Pick<Department, 'id'>
    & { topLevelCategory: (
      { __typename: 'Category' }
      & Pick<Category, 'id'>
      & { recommendExpertForConsumer: (
        { __typename: 'RecommendExpertPayload' }
        & { expert: Maybe<(
          { __typename: 'BusinessUser' }
          & ChatWidgetExpertFragment
        )>, existingLead: Maybe<(
          { __typename: 'Lead' }
          & Pick<Lead, 'id'>
          & { conversation: (
            { __typename: 'Conversation' }
            & Pick<Conversation, 'id' | 'externalId'>
          ) }
        )> }
      ) }
    ) }
  ) }
);

export type UserLoginTokenQueryVariables = {};


export type UserLoginTokenQuery = (
  { __typename: 'Query' }
  & { me: Maybe<(
    { __typename: 'Myself' }
    & Pick<Myself, 'id' | 'loginToken'>
  )> }
);

export type HeroCuratedExpertFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
  & { expertAttributes: (
    { __typename: 'BusinessUserExpertAttributes' }
    & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>
  ), expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
  )> }
);

export type HeroCuratedItemsLeadFragment = (
  { __typename: 'Lead' }
  & Pick<Lead, 'id'>
  & { conversation: (
    { __typename: 'Conversation' }
    & Pick<Conversation, 'id'>
  ), expert: (
    { __typename: 'BusinessUser' }
    & HeroCuratedExpertFragment
  ), consumerConversationMetrics: (
    { __typename: 'ConversationMetrics' }
    & Pick<ConversationMetrics, 'messageCount'>
  ), expertConversationMetrics: (
    { __typename: 'ConversationMetrics' }
    & Pick<ConversationMetrics, 'messageCount'>
  ), department: Maybe<(
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'type'>
  )> }
);

export type HeroExpertCuratedItemImageFragment = (
  { __typename: 'ExpertCuratedItem' }
  & Pick<ExpertCuratedItem, 'id'>
  & { category: (
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'singularDisplayName'>
  ), note: Maybe<(
    { __typename: 'ExpertCuratedItemNote' }
    & Pick<ExpertCuratedItemNote, 'id'>
  )>, sellable: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id' | 'title'>
    & { images: Array<(
      { __typename: 'MediaFile' }
      & Pick<MediaFile, 'id' | 'url'>
    )> }
  ) }
);

export type CuratedItemsForLeadQueryVariables = {
  leadId: Scalars['LeadId']
};


export type CuratedItemsForLeadQuery = (
  { __typename: 'Query' }
  & { expertCuratedItemsForLead: (
    { __typename: 'ExpertCuratedItemsForLeadPayload' }
    & Pick<ExpertCuratedItemsForLeadPayload, 'id'>
    & { items: Array<(
      { __typename: 'ExpertCuratedItem' }
      & HeroExpertCuratedItemImageFragment
    )> }
  ), lead: Maybe<(
    { __typename: 'Lead' }
    & HeroCuratedItemsLeadFragment
  )>, expertCuratedOrdersForLeadConnection: (
    { __typename: 'ExpertCuratedOrdersForLeadConnection' }
    & { edges: Array<(
      { __typename: 'ExpertCuratedOrdersForLeadEdge' }
      & { node: (
        { __typename: 'ExpertCuratedOrder' }
        & ExpertCuratedOrderFragment
      ) }
    )> }
  ) }
);

export type DepartmentExpertReviewFragment = (
  { __typename: 'ConsumerExpertReview' }
  & Pick<ConsumerExpertReview, 'id' | 'comments' | 'goodQualities' | 'headline' | 'rating' | 'reviewedAt'>
  & { consumer: (
    { __typename: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName'>
  ), expert: (
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
    & { expertProfile: Maybe<(
      { __typename: 'ExpertProfile' }
      & Pick<ExpertProfile, 'id'>
      & { profilePhoto: Maybe<(
        { __typename: 'MediaFile' }
        & MediaFileFragment
      )> }
    )> }
  ) }
);

export type DepartmentDetailedReviewsQueryVariables = {
  departmentId: Scalars['DepartmentId']
};


export type DepartmentDetailedReviewsQuery = (
  { __typename: 'Query' }
  & { department: (
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'displayName' | 'slug'>
    & { reviewSummary: (
      { __typename: 'ReviewSummary' }
      & Pick<ReviewSummary, 'averageRating' | 'totalReviews'>
    ), consumerExpertReviewConnection: (
      { __typename: 'ConsumerExpertReviewConnection' }
      & { edges: Array<(
        { __typename: 'ConsumerExpertReviewEdge' }
        & { node: (
          { __typename: 'ConsumerExpertReview' }
          & DepartmentExpertReviewFragment
        ) }
      )> }
    ) }
  ) }
);

export type PathCategoryFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id' | 'slug'>
  & { parents: Array<(
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'slug'>
  )> }
);

export type EngagementChannelCategoryFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id' | 'slug'>
  & { department: Maybe<(
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'type' | 'slug' | 'acceptingRequests' | 'launched'>
  )>, contentAssets: (
    { __typename: 'CategoryContentAssets' }
    & { fixedBarDesktop: Maybe<(
      { __typename: 'ContentAsset' }
      & Pick<ContentAsset, 'imageUrl'>
    )>, callout: Maybe<(
      { __typename: 'ContentAsset' }
      & Pick<ContentAsset, 'imageUrl'>
    )>, fullPageTakeover: Maybe<(
      { __typename: 'ContentAsset' }
      & Pick<ContentAsset, 'imageUrl'>
    )> }
  ), ancestorWithPath: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'slug'>
  )> }
  & PathCategoryFragment
);

export type EngagementChannelCategoryAssetsQueryVariables = {
  categoryId: Scalars['CategoryId']
};


export type EngagementChannelCategoryAssetsQuery = (
  { __typename: 'Query' }
  & { category: (
    { __typename: 'Category' }
    & EngagementChannelCategoryFragment
  ) }
);

export type PathSlugForCategoryQueryVariables = {
  slug: Scalars['String']
};


export type PathSlugForCategoryQuery = (
  { __typename: 'Query' }
  & { categoryBySlug: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'slug'>
    & { ancestorWithPath: Maybe<(
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'slug'>
    )> }
  )> }
);

export type SellableForModalFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id' | 'title'>
  & { images: Array<(
    { __typename: 'MediaFile' }
    & MediaFileFragment
  )> }
  & SellablePricingWithDefaultVariantFragment
);

export type SellableForModalQueryVariables = {
  friendlyIdOrId: Scalars['String']
};


export type SellableForModalQuery = (
  { __typename: 'Query' }
  & { findSellable: Maybe<(
    { __typename: 'Sellable' }
    & SellableForModalFragment
  )> }
);

export type CategoryModalFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id' | 'slug' | 'pluralDisplayName' | 'singularDisplayName'>
  & { ancestorWithPath: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'slug'>
  )> }
);

export type SellableBrandCategoryQueryVariables = {
  friendlyIdOrId: Scalars['String']
};


export type SellableBrandCategoryQuery = (
  { __typename: 'Query' }
  & { findSellable: Maybe<(
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id'>
    & { brand: Maybe<(
      { __typename: 'Brand' }
      & BrandFragment
    )>, categories: Array<(
      { __typename: 'Category' }
      & CategoryModalFragment
    )> }
  )> }
);

export type AddItemsToOrderMutationVariables = {
  input: AddItemsToOrderInput
};


export type AddItemsToOrderMutation = (
  { __typename: 'Mutation' }
  & { addItemsToOrder: (
    { __typename: 'AddItemsToOrderPayload' }
    & { order: (
      { __typename: 'Order' }
      & Pick<Order, 'id'>
    ) }
  ) }
);

export type ExpertByCategoryQueryVariables = {
  categoryId: Scalars['CategoryId']
};


export type ExpertByCategoryQuery = (
  { __typename: 'Query' }
  & { category: (
    { __typename: 'Category' }
    & Pick<Category, 'id'>
    & { ancestorWithPath: Maybe<(
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'name' | 'slug' | 'startPathUrl'>
      & { contentAssets: (
        { __typename: 'CategoryContentAssets' }
        & { bannerImages: Array<(
          { __typename: 'ContentAsset' }
          & Pick<ContentAsset, 'imageUrl'>
        )> }
      ), department: Maybe<(
        { __typename: 'Department' }
        & Pick<Department, 'id' | 'slug'>
      )> }
    )>, recommendExpertForConsumer: (
      { __typename: 'RecommendExpertPayload' }
      & { expert: Maybe<(
        { __typename: 'BusinessUser' }
        & ChatWidgetExpertFragment
      )> }
    ) }
  ) }
);

export type ExperienceByExpertCuratedOrderQueryVariables = {
  id: Scalars['ExpertCuratedOrderId']
};


export type ExperienceByExpertCuratedOrderQuery = (
  { __typename: 'Query' }
  & { expertCuratedOrder: (
    { __typename: 'ExpertCuratedOrder' }
    & ExpertCuratedOrderFragment
  ) }
);

export type ExperienceAttributeFragment = (
  { __typename: 'Attribute' }
  & { formatted: Maybe<(
    { __typename: 'FormattedAttribute' }
    & Pick<FormattedAttribute, 'name' | 'displayHtml'>
  )> }
);

export type ExperienceDetailsFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id'>
  & { charterLocation: Maybe<(
    { __typename: 'Attribute' }
    & ExperienceAttributeFragment
  )>, charterLengthFeet: Maybe<(
    { __typename: 'Attribute' }
    & ExperienceAttributeFragment
  )>, charterCabins: Maybe<(
    { __typename: 'Attribute' }
    & ExperienceAttributeFragment
  )>, charterCapacity: Maybe<(
    { __typename: 'Attribute' }
    & ExperienceAttributeFragment
  )>, charterAmenities: Maybe<(
    { __typename: 'Attribute' }
    & ExperienceAttributeFragment
  )>, categories: Array<(
    { __typename: 'Category' }
    & Pick<Category, 'id'>
  )>, department: Maybe<(
    { __typename: 'Department' }
    & Pick<Department, 'id'>
    & { mostRecentLeadForConsumer: Maybe<(
      { __typename: 'Lead' }
      & Pick<Lead, 'id'>
    )> }
  )> }
  & SellableDetailsFragment
  & SellablePricingWithDefaultVariantFragment
  & TrackableSellableFragment
);

export type ExperienceByFriendlyIdOrIdQueryVariables = {
  friendlyIdOrId: Scalars['String']
};


export type ExperienceByFriendlyIdOrIdQuery = (
  { __typename: 'Query' }
  & { findSellable: Maybe<(
    { __typename: 'Sellable' }
    & ExperienceDetailsFragment
  )> }
);

export type RequestSellableMutationVariables = {
  input: RequestSellableInput
};


export type RequestSellableMutation = (
  { __typename: 'Mutation' }
  & { requestSellable: (
    { __typename: 'RequestSellablePayload' }
    & Pick<RequestSellablePayload, 'error'>
    & { lead: Maybe<(
      { __typename: 'Lead' }
      & Pick<Lead, 'id'>
      & { conversation: (
        { __typename: 'Conversation' }
        & Pick<Conversation, 'id' | 'externalId'>
      ) }
    )> }
  ) }
);

export type ExpertPhoneNumberQueryVariables = {
  slug: Scalars['String']
};


export type ExpertPhoneNumberQuery = (
  { __typename: 'Query' }
  & { categoryBySlug: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id'>
    & { recommendExpertForConsumer: (
      { __typename: 'RecommendExpertPayload' }
      & { expert: Maybe<(
        { __typename: 'BusinessUser' }
        & Pick<BusinessUser, 'id'>
        & { assignedPhone: BusinessUser['assignedAddress'] }
      )> }
    ) }
  )> }
);

export type RatesTableQueryVariables = {
  id: Scalars['SellableId']
};


export type RatesTableQuery = (
  { __typename: 'Query' }
  & { sellable: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id'>
    & { variationMatrix: Maybe<(
      { __typename: 'VariationMatrix' }
      & VariationMatrixFragment
    )> }
  ) }
);

export type RatesTableSellableQueryVariables = {
  ids: Array<Scalars['SellableId']>
};


export type RatesTableSellableQuery = (
  { __typename: 'Query' }
  & { sellables: Array<(
    { __typename: 'Sellable' }
    & SellablePricingWithDefaultVariantFragment
  )> }
);

export type SelectExperienceVariationOptionMutationVariables = {
  input: SelectExpertCuratedOrderVariationOptionInput
};


export type SelectExperienceVariationOptionMutation = (
  { __typename: 'Mutation' }
  & { selectExpertCuratedOrderVariationOption: (
    { __typename: 'SelectExpertCuratedOrderVariationOptionPayload' }
    & { expertCuratedOrder: (
      { __typename: 'ExpertCuratedOrder' }
      & ExpertCuratedOrderFragment
    ) }
  ) }
);

export type DurationSelectorFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id'>
  & { originalPrice: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, salePrice: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, variants: Array<(
    { __typename: 'SellableFormattedVariant' }
    & Pick<SellableFormattedVariant, 'value'>
  )>, variationMatrix: Maybe<(
    { __typename: 'VariationMatrix' }
    & VariationMatrixFragment
  )> }
);

export type DurationSelectorQueryVariables = {
  id: Scalars['SellableId']
};


export type DurationSelectorQuery = (
  { __typename: 'Query' }
  & { sellable: (
    { __typename: 'Sellable' }
    & DurationSelectorFragment
  ) }
);

export type RecommendedExpertForRequestQueryVariables = {
  consumerId: Scalars['UserId'],
  categoryId: Scalars['CategoryId']
};


export type RecommendedExpertForRequestQuery = (
  { __typename: 'Query' }
  & { recommendExpert2: (
    { __typename: 'RecommendExpertPayload' }
    & { expert: Maybe<(
      { __typename: 'BusinessUser' }
      & Pick<BusinessUser, 'id'>
    )> }
  ) }
);

export type FindExpertCalloutQueryVariables = {
  vanityIdOrId: Scalars['String']
};


export type FindExpertCalloutQuery = (
  { __typename: 'Query' }
  & { findExpert: Maybe<(
    { __typename: 'BusinessUser' }
    & ProductExpertCardFragment
  )> }
);

export type ExpertDepartmentFragment = (
  { __typename: 'Department' }
  & Pick<Department, 'id' | 'type'>
);

export type ProductExpertCardFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'active' | 'vanityId' | 'displayName' | 'shortName'>
  & { department: (
    { __typename: 'Department' }
    & ExpertDepartmentFragment
  ), expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id' | 'headline' | 'location' | 'background'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
  )>, expertAttributes: (
    { __typename: 'BusinessUserExpertAttributes' }
    & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>
  ), expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & Pick<ExpertStats, 'averageRating' | 'totalMessagesSent' | 'totalReviews' | 'totalLeadsAsPrimaryExpert'>
  )> }
);

export type ProductRecommendedExpertCalloutQueryVariables = {
  consumerId: Scalars['UserId'],
  categoryId: Scalars['CategoryId']
};


export type ProductRecommendedExpertCalloutQuery = (
  { __typename: 'Query' }
  & { recommendExpert2: (
    { __typename: 'RecommendExpertPayload' }
    & { existingLead: Maybe<(
      { __typename: 'Lead' }
      & Pick<Lead, 'id'>
      & { conversation: (
        { __typename: 'Conversation' }
        & Pick<Conversation, 'id' | 'externalId'>
      ) }
    )>, expert: Maybe<(
      { __typename: 'BusinessUser' }
      & ProductExpertCardFragment
    )> }
  ) }
);

export type ExpertForChatButtonQueryVariables = {
  vanityIdOrId: Scalars['String']
};


export type ExpertForChatButtonQuery = (
  { __typename: 'Query' }
  & { findExpert: Maybe<(
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'active'>
    & { expertAttributes: (
      { __typename: 'BusinessUserExpertAttributes' }
      & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>
    ) }
  )> }
);

export type ExpertFooterUserReviewsQueryVariables = {
  userId: Scalars['UserId'],
  expertId?: Maybe<Scalars['BusinessUserId']>
};


export type ExpertFooterUserReviewsQuery = (
  { __typename: 'Query' }
  & { user: (
    { __typename: 'User' }
    & Pick<User, 'id'>
    & { consumerExpertReviewConnection: (
      { __typename: 'ConsumerExpertReviewConnection' }
      & { edges: Array<(
        { __typename: 'ConsumerExpertReviewEdge' }
        & { node: (
          { __typename: 'ConsumerExpertReview' }
          & Pick<ConsumerExpertReview, 'id'>
          & { expert: (
            { __typename: 'BusinessUser' }
            & Pick<BusinessUser, 'id'>
          ) }
        ) }
      )> }
    ) }
  ) }
);

export type ExpertProfilePhotoCarouselFragment = (
  { __typename: 'ExpertProfile' }
  & Pick<ExpertProfile, 'id'>
  & { profilePhoto: Maybe<(
    { __typename: 'MediaFile' }
    & MediaFileFragment
  )>, gallery: Array<(
    { __typename: 'MediaFileWithCaption' }
    & Pick<MediaFileWithCaption, 'caption'>
    & { mediaFile: (
      { __typename: 'MediaFile' }
      & MediaFileFragment
    ) }
  )> }
);

export type BusinessUserToShareFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
  & { expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
  )>, expertAttributes: (
    { __typename: 'BusinessUserExpertAttributes' }
    & { category: (
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'singularDisplayName'>
    ) }
  ) }
);

export type BusinessUserToShareQueryVariables = {
  id: Scalars['BusinessUserId']
};


export type BusinessUserToShareQuery = (
  { __typename: 'Query' }
  & { businessUser: (
    { __typename: 'BusinessUser' }
    & BusinessUserToShareFragment
  ) }
);

export type RecommendingExpertsFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
  & { expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
  )>, expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & Pick<ExpertStats, 'averageRating' | 'totalReviews'>
  )> }
);

export type FeaturedReviewFragment = (
  { __typename: 'ConsumerExpertReview' }
  & Pick<ConsumerExpertReview, 'id' | 'rating' | 'headline' | 'comments' | 'consumerName' | 'reviewedAt'>
  & { expert: (
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'vanityId' | 'profileUrl' | 'displayName' | 'shortName'>
    & { department: (
      { __typename: 'Department' }
      & Pick<Department, 'id' | 'type'>
    ), expertProfile: Maybe<(
      { __typename: 'ExpertProfile' }
      & Pick<ExpertProfile, 'id'>
      & { profilePhoto: Maybe<(
        { __typename: 'MediaFile' }
        & MediaFileFragment
      )> }
    )> }
  ) }
);

export type FeaturedReviewsQueryVariables = {
  query: ConsumerReviewSearchQuery,
  after?: Maybe<Scalars['String']>
};


export type FeaturedReviewsQuery = (
  { __typename: 'Query' }
  & { consumerExpertReviewConnection: (
    { __typename: 'ConsumerExpertReviewConnection' }
    & Pick<ConsumerExpertReviewConnection, 'count'>
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & PageInfoFragment
    ), facets: Array<(
      { __typename: 'BucketedDisplayFacet' }
      & Pick<BucketedDisplayFacet, 'displayName' | 'alias' | 'name'>
    ) | (
      { __typename: 'BucketedRangeDisplayFacet' }
      & Pick<BucketedRangeDisplayFacet, 'displayName' | 'alias' | 'name'>
    ) | (
      { __typename: 'NumericRangeDisplayFacet' }
      & Pick<NumericRangeDisplayFacet, 'displayName' | 'alias' | 'name'>
    )>, edges: Array<(
      { __typename: 'ConsumerExpertReviewEdge' }
      & Pick<ConsumerExpertReviewEdge, 'cursor'>
      & { node: (
        { __typename: 'ConsumerExpertReview' }
        & FeaturedReviewFragment
      ) }
    )> }
  ) }
);

export type NavInactiveDepartmentFragment = (
  { __typename: 'Department' }
  & Pick<Department, 'id' | 'type' | 'slug' | 'displayName' | 'acceptingRequests' | 'launched'>
  & { topLevelCategory: (
    { __typename: 'Category' }
    & Pick<Category, 'id'>
  ) }
);

export type NavDepartmentsQueryVariables = {};


export type NavDepartmentsQuery = (
  { __typename: 'Query' }
  & { departmentsForNavigation: Array<(
    { __typename: 'Department' }
    & NavInactiveDepartmentFragment
  )> }
);

export type FacetSelectionPayloadFragment = (
  { __typename: 'FacetSelectionPayload' }
  & Pick<FacetSelectionPayload, 'name' | 'alias' | 'displayName' | 'bucketValues' | 'lower' | 'upper'>
);

type DepartmentNavigationResponsiveMixinDepartmentNavigationTopLevelItemFragment = (
  { __typename: 'DepartmentNavigationTopLevelItem' }
  & Pick<DepartmentNavigationTopLevelItem, 'showIfSmallSize' | 'showIfFullSize' | 'smallSizeOptions' | 'fullSizeOptions'>
);

type DepartmentNavigationResponsiveMixinDepartmentNavigationExpertSubSectionFragment = (
  { __typename: 'DepartmentNavigationExpertSubSection' }
  & Pick<DepartmentNavigationExpertSubSection, 'showIfSmallSize' | 'showIfFullSize' | 'smallSizeOptions' | 'fullSizeOptions'>
);

type DepartmentNavigationResponsiveMixinDepartmentNavigationListSubSectionFragment = (
  { __typename: 'DepartmentNavigationListSubSection' }
  & Pick<DepartmentNavigationListSubSection, 'showIfSmallSize' | 'showIfFullSize' | 'smallSizeOptions' | 'fullSizeOptions'>
);

export type DepartmentNavigationResponsiveMixinFragment = DepartmentNavigationResponsiveMixinDepartmentNavigationTopLevelItemFragment | DepartmentNavigationResponsiveMixinDepartmentNavigationExpertSubSectionFragment | DepartmentNavigationResponsiveMixinDepartmentNavigationListSubSectionFragment;

type DepartmentNavigationLinkDepartmentNavigationCategoryLinkFragment = (
  { __typename: 'DepartmentNavigationCategoryLink' }
  & { category: (
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'slug'>
  ) }
);

type DepartmentNavigationLinkDepartmentNavigationSearchLinkFragment = (
  { __typename: 'DepartmentNavigationSearchLink' }
  & { category: (
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'slug'>
  ), facets: Array<(
    { __typename: 'FacetSelectionPayload' }
    & FacetSelectionPayloadFragment
  )> }
);

type DepartmentNavigationLinkDepartmentNavigationCreatePathLinkFragment = (
  { __typename: 'DepartmentNavigationCreatePathLink' }
  & Pick<DepartmentNavigationCreatePathLink, 'pathSlug'>
);

type DepartmentNavigationLinkDepartmentNavigationExpertCommunityLinkFragment = (
  { __typename: 'DepartmentNavigationExpertCommunityLink' }
  & Pick<DepartmentNavigationExpertCommunityLink, 'departmentSlug'>
);

export type DepartmentNavigationLinkFragment = DepartmentNavigationLinkDepartmentNavigationCategoryLinkFragment | DepartmentNavigationLinkDepartmentNavigationSearchLinkFragment | DepartmentNavigationLinkDepartmentNavigationCreatePathLinkFragment | DepartmentNavigationLinkDepartmentNavigationExpertCommunityLinkFragment;

type DepartmentNavigationSubSectionDepartmentNavigationExpertSubSectionFragment = (
  { __typename: 'DepartmentNavigationExpertSubSection' }
  & Pick<DepartmentNavigationExpertSubSection, 'id' | 'title'>
  & { titleLink: Maybe<(
    { __typename: 'DepartmentNavigationCategoryLink' }
    & DepartmentNavigationLinkDepartmentNavigationCategoryLinkFragment
  ) | (
    { __typename: 'DepartmentNavigationSearchLink' }
    & DepartmentNavigationLinkDepartmentNavigationSearchLinkFragment
  ) | (
    { __typename: 'DepartmentNavigationCreatePathLink' }
    & DepartmentNavigationLinkDepartmentNavigationCreatePathLinkFragment
  ) | (
    { __typename: 'DepartmentNavigationExpertCommunityLink' }
    & DepartmentNavigationLinkDepartmentNavigationExpertCommunityLinkFragment
  )> }
  & DepartmentNavigationResponsiveMixinDepartmentNavigationExpertSubSectionFragment
);

type DepartmentNavigationSubSectionDepartmentNavigationListSubSectionFragment = (
  { __typename: 'DepartmentNavigationListSubSection' }
  & Pick<DepartmentNavigationListSubSection, 'id' | 'title'>
  & { titleLink: Maybe<(
    { __typename: 'DepartmentNavigationCategoryLink' }
    & DepartmentNavigationLinkDepartmentNavigationCategoryLinkFragment
  ) | (
    { __typename: 'DepartmentNavigationSearchLink' }
    & DepartmentNavigationLinkDepartmentNavigationSearchLinkFragment
  ) | (
    { __typename: 'DepartmentNavigationCreatePathLink' }
    & DepartmentNavigationLinkDepartmentNavigationCreatePathLinkFragment
  ) | (
    { __typename: 'DepartmentNavigationExpertCommunityLink' }
    & DepartmentNavigationLinkDepartmentNavigationExpertCommunityLinkFragment
  )> }
  & DepartmentNavigationListSubSectionFragment
  & DepartmentNavigationResponsiveMixinDepartmentNavigationListSubSectionFragment
);

export type DepartmentNavigationSubSectionFragment = DepartmentNavigationSubSectionDepartmentNavigationExpertSubSectionFragment | DepartmentNavigationSubSectionDepartmentNavigationListSubSectionFragment;

export type DepartmentNavigationListSubSectionFragment = (
  { __typename: 'DepartmentNavigationListSubSection' }
  & Pick<DepartmentNavigationListSubSection, 'id' | 'title'>
  & { titleLink: Maybe<(
    { __typename: 'DepartmentNavigationCategoryLink' }
    & DepartmentNavigationLinkDepartmentNavigationCategoryLinkFragment
  ) | (
    { __typename: 'DepartmentNavigationSearchLink' }
    & DepartmentNavigationLinkDepartmentNavigationSearchLinkFragment
  ) | (
    { __typename: 'DepartmentNavigationCreatePathLink' }
    & DepartmentNavigationLinkDepartmentNavigationCreatePathLinkFragment
  ) | (
    { __typename: 'DepartmentNavigationExpertCommunityLink' }
    & DepartmentNavigationLinkDepartmentNavigationExpertCommunityLinkFragment
  )>, items: Array<(
    { __typename: 'DepartmentNavigationListSubSectionItem' }
    & Pick<DepartmentNavigationListSubSectionItem, 'id' | 'label' | 'labelStyles' | 'imagePath' | 'imageUrl'>
    & { link: (
      { __typename: 'DepartmentNavigationCategoryLink' }
      & DepartmentNavigationLinkDepartmentNavigationCategoryLinkFragment
    ) | (
      { __typename: 'DepartmentNavigationSearchLink' }
      & DepartmentNavigationLinkDepartmentNavigationSearchLinkFragment
    ) | (
      { __typename: 'DepartmentNavigationCreatePathLink' }
      & DepartmentNavigationLinkDepartmentNavigationCreatePathLinkFragment
    ) | (
      { __typename: 'DepartmentNavigationExpertCommunityLink' }
      & DepartmentNavigationLinkDepartmentNavigationExpertCommunityLinkFragment
    ) }
  )> }
);

export type DepartmentNavigationTopLevelItemFragment = (
  { __typename: 'DepartmentNavigationTopLevelItem' }
  & Pick<DepartmentNavigationTopLevelItem, 'id' | 'label'>
  & { labelLink: Maybe<(
    { __typename: 'DepartmentNavigationCategoryLink' }
    & DepartmentNavigationLinkDepartmentNavigationCategoryLinkFragment
  ) | (
    { __typename: 'DepartmentNavigationSearchLink' }
    & DepartmentNavigationLinkDepartmentNavigationSearchLinkFragment
  ) | (
    { __typename: 'DepartmentNavigationCreatePathLink' }
    & DepartmentNavigationLinkDepartmentNavigationCreatePathLinkFragment
  ) | (
    { __typename: 'DepartmentNavigationExpertCommunityLink' }
    & DepartmentNavigationLinkDepartmentNavigationExpertCommunityLinkFragment
  )>, subSections: Array<(
    { __typename: 'DepartmentNavigationExpertSubSection' }
    & DepartmentNavigationSubSectionDepartmentNavigationExpertSubSectionFragment
  ) | (
    { __typename: 'DepartmentNavigationListSubSection' }
    & DepartmentNavigationSubSectionDepartmentNavigationListSubSectionFragment
  )> }
  & DepartmentNavigationResponsiveMixinDepartmentNavigationTopLevelItemFragment
);

export type NavActiveDepartmentFragment = (
  { __typename: 'Department' }
  & Pick<Department, 'id' | 'type' | 'slug' | 'displayName' | 'launched' | 'acceptingRequests'>
  & { navigation: (
    { __typename: 'DepartmentNavigation' }
    & { topLevelItems: Array<(
      { __typename: 'DepartmentNavigationTopLevelItem' }
      & DepartmentNavigationTopLevelItemFragment
    )> }
  ), topLevelCategories: Array<(
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'slug'>
  )> }
);

export type NavHierarchyQueryVariables = {
  activeDepartmentId: Scalars['DepartmentId']
};


export type NavHierarchyQuery = (
  { __typename: 'Query' }
  & { activeDepartment: (
    { __typename: 'Department' }
    & NavActiveDepartmentFragment
  ) }
);

export type SellableKeywordTypeaheadResultFragment = (
  { __typename: 'SellableTypeaheadHit' }
  & Pick<SellableTypeaheadHit, 'id' | 'text' | 'title' | 'brandName'>
  & { sellable: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type'>
  ) }
);

export type SellableKeywordTypeaheadQueryVariables = {
  query: SellableTypeaheadQuery,
  first?: Maybe<Scalars['Int']>
};


export type SellableKeywordTypeaheadQuery = (
  { __typename: 'Query' }
  & { sellableTypeahead: (
    { __typename: 'SellableTypeaheadPayload' }
    & { hits: Array<(
      { __typename: 'SellableTypeaheadHit' }
      & SellableKeywordTypeaheadResultFragment
    )> }
  ) }
);

export type ReleaseConsumerIdentityMutationVariables = {};


export type ReleaseConsumerIdentityMutation = (
  { __typename: 'Mutation' }
  & { releaseConsumerIdentity: (
    { __typename: 'ReleaseConsumerIdentityPayload' }
    & { user: Maybe<(
      { __typename: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName'>
    )> }
  ) }
);

export type SubSectionExpertQueryVariables = {
  departmentId: Scalars['DepartmentId']
};


export type SubSectionExpertQuery = (
  { __typename: 'Query' }
  & { recommendExpertsForDepartment: Array<(
    { __typename: 'RecommendedExpert' }
    & { expert: (
      { __typename: 'BusinessUser' }
      & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
      & { expertStats: Maybe<(
        { __typename: 'ExpertStats' }
        & Pick<ExpertStats, 'averageRating' | 'totalMessagesSent'>
      )>, expertProfile: Maybe<(
        { __typename: 'ExpertProfile' }
        & Pick<ExpertProfile, 'id' | 'headline'>
        & { profilePhoto: Maybe<(
          { __typename: 'MediaFile' }
          & Pick<MediaFile, 'id' | 'url'>
        )> }
      )> }
    ), existingLead: Maybe<(
      { __typename: 'Lead' }
      & Pick<Lead, 'id'>
      & { conversation: (
        { __typename: 'Conversation' }
        & Pick<Conversation, 'id'>
      ) }
    )> }
  )> }
);

export type HeartbeatSubscriptionVariables = {};


export type HeartbeatSubscription = (
  { __typename: 'Subscription' }
  & Pick<Subscription, 'heartbeat'>
);

export type SaveConsumerSellableReactionMutationVariables = {
  input: SaveConsumerSellableReactionInput
};


export type SaveConsumerSellableReactionMutation = (
  { __typename: 'Mutation' }
  & { saveConsumerSellableReaction: (
    { __typename: 'SaveConsumerSellableReactionPayload' }
    & Pick<SaveConsumerSellableReactionPayload, 'error'>
    & { consumerSellableReaction: Maybe<(
      { __typename: 'ConsumerSellableReaction' }
      & Pick<ConsumerSellableReaction, 'id' | 'additionalReason' | 'systemRecommended'>
      & { reasonsWithDisplayName: Array<(
        { __typename: 'ConsumerSellableReactionReasonWithDisplayName' }
        & Pick<ConsumerSellableReactionReasonWithDisplayName, 'reason' | 'displayName'>
      )>, ratingWithDisplayName: (
        { __typename: 'ConsumerSellableReactionRatingWithDisplayName' }
        & Pick<ConsumerSellableReactionRatingWithDisplayName, 'rating' | 'displayName'>
      ), sellable: (
        { __typename: 'Sellable' }
        & Pick<Sellable, 'id'>
      ), recommendedBy: Maybe<(
        { __typename: 'BusinessUser' }
        & Pick<BusinessUser, 'id'>
      )> }
    )> }
  ) }
);

export type StartSystemCuratedItemSurveyMutationVariables = {
  id: Scalars['SystemCuratedItemSurveyId']
};


export type StartSystemCuratedItemSurveyMutation = (
  { __typename: 'Mutation' }
  & { startSystemCuratedItemSurvey: (
    { __typename: 'StartSystemCuratedItemSurveyPayload' }
    & Pick<StartSystemCuratedItemSurveyPayload, 'error'>
    & { data: Maybe<(
      { __typename: 'SystemCuratedItemSurvey' }
      & Pick<SystemCuratedItemSurvey, 'id' | 'startedAt'>
    )> }
  ) }
);

type SystemCuratedItemSourcePopularExpertCuratedItemFromSimilarUserSystemCuratedItemSourceFragment = (
  { __typename: 'PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource' }
  & Pick<PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource, 'type'>
  & { expertCuratedItem: (
    { __typename: 'ExpertCuratedItem' }
    & Pick<ExpertCuratedItem, 'id'>
  ) }
);

type SystemCuratedItemSourceRecentExpertCuratedItemFromSimilarUserSystemCuratedItemSourceFragment = (
  { __typename: 'RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource' }
  & Pick<RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource, 'type'>
  & { expertCuratedItem: (
    { __typename: 'ExpertCuratedItem' }
    & Pick<ExpertCuratedItem, 'id'>
  ) }
);

type SystemCuratedItemSourceTopRecommendationAndSimilarUserSystemCuratedItemSourceFragment = (
  { __typename: 'TopRecommendationAndSimilarUserSystemCuratedItemSource' }
  & Pick<TopRecommendationAndSimilarUserSystemCuratedItemSource, 'type'>
  & { recentExpertCuratedItemFromSimilarUserSource: Maybe<(
    { __typename: 'RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource' }
    & Pick<RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource, 'type'>
    & { expertCuratedItem: (
      { __typename: 'ExpertCuratedItem' }
      & Pick<ExpertCuratedItem, 'id'>
    ) }
  )>, topRecommendedListSystemCuratedItemSource: Maybe<(
    { __typename: 'TopRecommendedListSystemCuratedItemSource' }
    & Pick<TopRecommendedListSystemCuratedItemSource, 'type'>
    & { recommendedListDefinition: (
      { __typename: 'RecommendedListDefinition' }
      & Pick<RecommendedListDefinition, 'id'>
    ) }
  )> }
);

type SystemCuratedItemSourceTopRecommendedListSystemCuratedItemSourceFragment = (
  { __typename: 'TopRecommendedListSystemCuratedItemSource' }
  & Pick<TopRecommendedListSystemCuratedItemSource, 'type'>
  & { recommendedListDefinition: (
    { __typename: 'RecommendedListDefinition' }
    & Pick<RecommendedListDefinition, 'id'>
  ) }
);

export type SystemCuratedItemSourceFragment = SystemCuratedItemSourcePopularExpertCuratedItemFromSimilarUserSystemCuratedItemSourceFragment | SystemCuratedItemSourceRecentExpertCuratedItemFromSimilarUserSystemCuratedItemSourceFragment | SystemCuratedItemSourceTopRecommendationAndSimilarUserSystemCuratedItemSourceFragment | SystemCuratedItemSourceTopRecommendedListSystemCuratedItemSourceFragment;

export type SystemCuratedItemFragment = (
  { __typename: 'SystemCuratedItem' }
  & Pick<SystemCuratedItem, 'id' | 'type'>
  & { sellable: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type' | 'title'>
    & { images: Array<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
    & TrackableSellableFragment
    & SellablePricingWithDefaultVariantFragment
  ), category: (
    { __typename: 'Category' }
    & Pick<Category, 'id'>
  ), systemCuratedItemSource: (
    { __typename: 'PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource' }
    & SystemCuratedItemSourcePopularExpertCuratedItemFromSimilarUserSystemCuratedItemSourceFragment
  ) | (
    { __typename: 'RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource' }
    & SystemCuratedItemSourceRecentExpertCuratedItemFromSimilarUserSystemCuratedItemSourceFragment
  ) | (
    { __typename: 'TopRecommendationAndSimilarUserSystemCuratedItemSource' }
    & SystemCuratedItemSourceTopRecommendationAndSimilarUserSystemCuratedItemSourceFragment
  ) | (
    { __typename: 'TopRecommendedListSystemCuratedItemSource' }
    & SystemCuratedItemSourceTopRecommendedListSystemCuratedItemSourceFragment
  ) }
);

export type SystemCuratedItemSurveyQueryVariables = {
  id: Scalars['SystemCuratedItemSurveyId']
};


export type SystemCuratedItemSurveyQuery = (
  { __typename: 'Query' }
  & { systemCuratedItemSurvey: (
    { __typename: 'SystemCuratedItemSurvey' }
    & Pick<SystemCuratedItemSurvey, 'id' | 'ended' | 'terminationReason'>
    & { systemCuratedItems: Array<(
      { __typename: 'SystemCuratedItem' }
      & SystemCuratedItemFragment
    )>, stats: Maybe<(
      { __typename: 'SystemCuratedItemSurveyStats' }
      & SystemCuratedItemSurveyStatsFragment
    )> }
  ) }
);

export type SystemCuratedItemSurveyStatsFragment = (
  { __typename: 'SystemCuratedItemSurveyStats' }
  & { ratingStats: Array<(
    { __typename: 'ConsumerSellableReactionRatingStats' }
    & Pick<ConsumerSellableReactionRatingStats, 'rating' | 'count'>
  )> }
);

export type TerminateSystemCuratedItemSurveyMutationVariables = {
  input: TerminateSystemCuratedItemSurveyInput
};


export type TerminateSystemCuratedItemSurveyMutation = (
  { __typename: 'Mutation' }
  & { terminateSystemCuratedItemSurvey: (
    { __typename: 'TerminateSystemCuratedItemSurveyPayload' }
    & Pick<TerminateSystemCuratedItemSurveyPayload, 'error'>
    & { data: Maybe<(
      { __typename: 'SystemCuratedItemSurvey' }
      & Pick<SystemCuratedItemSurvey, 'id' | 'ended' | 'terminationReason'>
      & { systemCuratedItems: Array<(
        { __typename: 'SystemCuratedItem' }
        & SystemCuratedItemFragment
      )>, stats: Maybe<(
        { __typename: 'SystemCuratedItemSurveyStats' }
        & SystemCuratedItemSurveyStatsFragment
      )> }
    )> }
  ) }
);

export type AuthenticateByExternalOAuthTokenMutationVariables = {
  input: AuthenticateByExternalOAuthTokenInput
};


export type AuthenticateByExternalOAuthTokenMutation = (
  { __typename: 'Mutation' }
  & { authenticateByExternalOAuthToken: (
    { __typename: 'AuthenticateByExternalOAuthTokenPayload' }
    & Pick<AuthenticateByExternalOAuthTokenPayload, 'result' | 'message'>
    & { user: Maybe<(
      { __typename: 'User' }
      & AuthenticatedUserFragment
    )> }
  ) }
);

export type RegisterCustomerMutationVariables = {
  input: RegisterCustomerInput
};


export type RegisterCustomerMutation = (
  { __typename: 'Mutation' }
  & { registerCustomer: (
    { __typename: 'RegisterCustomerPayload' }
    & Pick<RegisterCustomerPayload, 'errors'>
    & { user: Maybe<(
      { __typename: 'User' }
      & AuthenticatedUserFragment
    )> }
  ) }
);

export type RoryReviewFragment = (
  { __typename: 'ConsumerExpertReview' }
  & Pick<ConsumerExpertReview, 'id' | 'comments' | 'reviewedAt' | 'rating' | 'consumerName' | 'consumerLocation'>
);

export type RoryReviewsQueryVariables = {
  departmentId: Scalars['DepartmentId']
};


export type RoryReviewsQuery = (
  { __typename: 'Query' }
  & { department: (
    { __typename: 'Department' }
    & Pick<Department, 'id'>
    & { reviewSummary: (
      { __typename: 'ReviewSummary' }
      & Pick<ReviewSummary, 'averageRating' | 'totalReviews'>
    ), consumerExpertReviewConnection: (
      { __typename: 'ConsumerExpertReviewConnection' }
      & { edges: Array<(
        { __typename: 'ConsumerExpertReviewEdge' }
        & { node: (
          { __typename: 'ConsumerExpertReview' }
          & RoryReviewFragment
        ) }
      )> }
    ) }
  ) }
);

export type DatePathFlowQuestionFragment = (
  { __typename: 'DatePathFlowQuestion' }
  & { dateUserInput: (
    { __typename: 'SubmitDatePathFlowQuestionInputTypeCopy' }
    & Pick<SubmitDatePathFlowQuestionInputTypeCopy, 'value'>
  ) }
);

export type DateRangePathFlowQuestionFragment = (
  { __typename: 'DateRangePathFlowQuestion' }
  & Pick<DateRangePathFlowQuestion, 'endRequired' | 'startRequired'>
  & { dateRangeUserInput: (
    { __typename: 'SubmitDateRangePathFlowQuestionInputTypeCopy' }
    & Pick<SubmitDateRangePathFlowQuestionInputTypeCopy, 'startValue' | 'endValue'>
  ) }
);

export type ExpertProfileDetailFragment = (
  { __typename: 'ExpertProfile' }
  & Pick<ExpertProfile, 'id' | 'headline' | 'background' | 'quotes' | 'socialMediaUrls'>
  & { businessUser: (
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
  ), profilePhoto: Maybe<(
    { __typename: 'MediaFile' }
    & MediaFileFragment
  )> }
);

export type GenericInfoBoxPageMetadataFragment = (
  { __typename: 'GenericInfoBoxPageMetadata' }
  & Pick<GenericInfoBoxPageMetadata, 'type'>
  & { body: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )> }
);

export type GenericModalPageMetadataFragment = (
  { __typename: 'GenericModalPageMetadata' }
  & Pick<GenericModalPageMetadata, 'type'>
  & { body: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, openCtaText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )> }
);

export type IdPathFlowQuestionFragment = (
  { __typename: 'IdPathFlowQuestion' }
  & { idType: IdPathFlowQuestion['type'] }
  & { idUserInput: (
    { __typename: 'SubmitIdPathFlowQuestionInputTypeCopy' }
    & Pick<SubmitIdPathFlowQuestionInputTypeCopy, 'value'>
  ) }
);

export type ImageViewModelFragment = (
  { __typename: 'PathImageViewModel' }
  & Pick<PathImageViewModel, 'imageUrl' | 'imagePath'>
);

export type InputTextPathFlowQuestionFragment = (
  { __typename: 'InputTextPathFlowQuestion' }
  & { countryCodeAttribute: Maybe<(
    { __typename: 'Attribute' }
    & { values: Array<{ __typename: 'AttributeValueInteger' } | { __typename: 'AttributeValueIntegerRange' } | { __typename: 'AttributeValueDecimal' } | { __typename: 'AttributeValueDecimalRange' } | { __typename: 'AttributeValueText' } | (
      { __typename: 'AttributeValueEnumeration' }
      & Pick<AttributeValueEnumeration, 'enumerationValue' | 'enumerationValueDescription'>
    ) | { __typename: 'AttributeValueDate' } | { __typename: 'AttributeValueDateRange' } | { __typename: 'AttributeValueTime' } | { __typename: 'AttributeValueTimeRange' } | { __typename: 'AttributeValueDateTime' } | { __typename: 'AttributeValueDateTimeRange' } | { __typename: 'AttributeValueZoneId' } | { __typename: 'AttributeValueId' }> }
  )>, inputTextUserInput: (
    { __typename: 'SubmitInputTextPathFlowQuestionInputTypeCopy' }
    & Pick<SubmitInputTextPathFlowQuestionInputTypeCopy, 'value'>
  ) }
  & InputTextPathFlowQuestionMixinInputTextPathFlowQuestionFragment
);

type InputTextPathFlowQuestionMixinEmbeddedInputTextPathFlowQuestionFragment = (
  { __typename: 'EmbeddedInputTextPathFlowQuestion' }
  & Pick<EmbeddedInputTextPathFlowQuestion, 'required' | 'fieldType' | 'placeholder'>
  & { inputTextValidations: Array<(
    { __typename: 'InputTextPathFlowQuestionLengthValidation' }
    & InputTextPathFlowQuestionValidationInputTextPathFlowQuestionLengthValidationFragment
  ) | (
    { __typename: 'InputTextPathFlowQuestionNoArgValidation' }
    & InputTextPathFlowQuestionValidationInputTextPathFlowQuestionNoArgValidationFragment
  ) | (
    { __typename: 'InputTextPathFlowQuestionRegexValidation' }
    & InputTextPathFlowQuestionValidationInputTextPathFlowQuestionRegexValidationFragment
  )>, questionSubText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )> }
);

type InputTextPathFlowQuestionMixinInputTextPathFlowQuestionFragment = (
  { __typename: 'InputTextPathFlowQuestion' }
  & Pick<InputTextPathFlowQuestion, 'required' | 'fieldType' | 'placeholder'>
  & { inputTextValidations: Array<(
    { __typename: 'InputTextPathFlowQuestionLengthValidation' }
    & InputTextPathFlowQuestionValidationInputTextPathFlowQuestionLengthValidationFragment
  ) | (
    { __typename: 'InputTextPathFlowQuestionNoArgValidation' }
    & InputTextPathFlowQuestionValidationInputTextPathFlowQuestionNoArgValidationFragment
  ) | (
    { __typename: 'InputTextPathFlowQuestionRegexValidation' }
    & InputTextPathFlowQuestionValidationInputTextPathFlowQuestionRegexValidationFragment
  )>, questionSubText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )> }
);

export type InputTextPathFlowQuestionMixinFragment = InputTextPathFlowQuestionMixinEmbeddedInputTextPathFlowQuestionFragment | InputTextPathFlowQuestionMixinInputTextPathFlowQuestionFragment;

type InputTextPathFlowQuestionValidationInputTextPathFlowQuestionLengthValidationFragment = (
  { __typename: 'InputTextPathFlowQuestionLengthValidation' }
  & Pick<InputTextPathFlowQuestionLengthValidation, 'minSize' | 'maxSize' | 'type'>
);

type InputTextPathFlowQuestionValidationInputTextPathFlowQuestionNoArgValidationFragment = (
  { __typename: 'InputTextPathFlowQuestionNoArgValidation' }
  & Pick<InputTextPathFlowQuestionNoArgValidation, 'type'>
);

type InputTextPathFlowQuestionValidationInputTextPathFlowQuestionRegexValidationFragment = (
  { __typename: 'InputTextPathFlowQuestionRegexValidation' }
  & Pick<InputTextPathFlowQuestionRegexValidation, 'regex' | 'errorMessage' | 'type'>
);

export type InputTextPathFlowQuestionValidationFragment = InputTextPathFlowQuestionValidationInputTextPathFlowQuestionLengthValidationFragment | InputTextPathFlowQuestionValidationInputTextPathFlowQuestionNoArgValidationFragment | InputTextPathFlowQuestionValidationInputTextPathFlowQuestionRegexValidationFragment;

export type InterstitialPageMetadataFragment = (
  { __typename: 'InterstitialPathFlowPageMetadata' }
  & Pick<InterstitialPathFlowPageMetadata, 'interstitialType'>
  & { title: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, body: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )> }
);

export type ListPathFlowQuestionFragment = (
  { __typename: 'ListPathFlowQuestion' }
  & Pick<ListPathFlowQuestion, 'renderStyle'>
  & { listType: ListPathFlowQuestion['type'] }
  & { choices: Array<(
    { __typename: 'ListPathFlowQuestionChoice' }
    & Pick<ListPathFlowQuestionChoice, 'value'>
    & { text: Maybe<(
      { __typename: 'AttributedHtmlTextViewModel' }
      & TextViewModelFragment
    )>, subText: Maybe<(
      { __typename: 'AttributedHtmlTextViewModel' }
      & TextViewModelFragment
    )>, primaryImage: Maybe<(
      { __typename: 'PathImageViewModel' }
      & ImageViewModelFragment
    )>, iconImage: Maybe<(
      { __typename: 'PathImageViewModel' }
      & ImageViewModelFragment
    )> }
  )>, other: Maybe<(
    { __typename: 'EmbeddedInputTextPathFlowQuestion' }
    & InputTextPathFlowQuestionMixinEmbeddedInputTextPathFlowQuestionFragment
  )>, listUserInput: (
    { __typename: 'SubmitListPathFlowQuestionInputTypeCopy' }
    & Pick<SubmitListPathFlowQuestionInputTypeCopy, 'value' | 'other'>
  ) }
);

export type NumericPathFlowQuestionFragment = (
  { __typename: 'NumericPathFlowQuestion' }
  & Pick<NumericPathFlowQuestion, 'unit' | 'unitLabel' | 'placeholder' | 'displayType'>
  & { numericUserInput: (
    { __typename: 'SubmitNumericPathFlowQuestionInputTypeCopy' }
    & Pick<SubmitNumericPathFlowQuestionInputTypeCopy, 'value' | 'decimalValue'>
  ) }
);

export type OAuthEmailPathFlowQuestionFragment = (
  { __typename: 'OAuthEmailPathFlowQuestion' }
  & { oAuthEmailUserInput: (
    { __typename: 'SubmitOAuthEmailPathFlowQuestionInputTypeCopy' }
    & Pick<SubmitOAuthEmailPathFlowQuestionInputTypeCopy, 'firstName' | 'lastName' | 'email' | 'googleIdToken' | 'facebookUserAccessToken' | 'skipFirstName' | 'skipLastName'>
  ) }
);

export type PathFlowOnCompleteLeadFragment = (
  { __typename: 'Lead' }
  & Pick<Lead, 'id'>
  & { expert: (
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'vanityId'>
  ), latestRequest: Maybe<(
    { __typename: 'DealRequest' }
    & Pick<DealRequest, 'id'>
  )> }
);

export type PathFlowOnCompleteConversationWithLeadFragment = (
  { __typename: 'Conversation' }
  & Pick<Conversation, 'id'>
  & { lead: Maybe<(
    { __typename: 'Lead' }
    & PathFlowOnCompleteLeadFragment
  )> }
);

export type PathFlowPagesConnectionFragment = (
  { __typename: 'PathFlowPagesConnection' }
  & { edges: Array<(
    { __typename: 'PathFlowPagesEdge' }
    & Pick<PathFlowPagesEdge, 'cursor'>
    & { node: (
      { __typename: 'PathFlowPage' }
      & PathFlowPageFragment
    ) }
  )> }
);

export type PathFlowFragment = (
  { __typename: 'PathFlow' }
  & Pick<PathFlow, 'id' | 'completed' | 'slug'>
  & { title: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, onComplete: Maybe<(
    { __typename: 'PathFlowOnCompleteBroadcast' }
    & Pick<PathFlowOnCompleteBroadcast, 'location'>
    & { conversation: (
      { __typename: 'Conversation' }
      & PathFlowOnCompleteConversationWithLeadFragment
    ) }
  ) | (
    { __typename: 'PathFlowOnCompleteLead' }
    & Pick<PathFlowOnCompleteLead, 'location'>
    & { lead: (
      { __typename: 'Lead' }
      & PathFlowOnCompleteLeadFragment
    ), conversation: (
      { __typename: 'Conversation' }
      & PathFlowOnCompleteConversationWithLeadFragment
    ) }
  ) | (
    { __typename: 'PathFlowOnCompleteNewPath' }
    & { flow: (
      { __typename: 'PathFlow' }
      & Pick<PathFlow, 'id' | 'slug'>
      & { pagesConnection: (
        { __typename: 'PathFlowPagesConnection' }
        & PathFlowPagesConnectionFragment
      ) }
    ) }
  ) | { __typename: 'PathFlowOnCompleteDealRequest' } | (
    { __typename: 'PathFlowOnCompleteExpertReview' }
    & Pick<PathFlowOnCompleteExpertReview, 'location'>
    & { review: (
      { __typename: 'ConsumerExpertReview' }
      & Pick<ConsumerExpertReview, 'id'>
    ) }
  ) | (
    { __typename: 'PathFlowOnCompleteRedirectOnly' }
    & Pick<PathFlowOnCompleteRedirectOnly, 'location'>
  ) | (
    { __typename: 'PathFlowOnCompleteRedirectWithUpsert' }
    & Pick<PathFlowOnCompleteRedirectWithUpsert, 'location'>
  ) | (
    { __typename: 'PathFlowOnCompleteExpertApplication' }
    & Pick<PathFlowOnCompleteExpertApplication, 'location'>
    & { application: (
      { __typename: 'ExpertApplication' }
      & Pick<ExpertApplication, 'id'>
    ) }
  )>, theme: (
    { __typename: 'PathFlowTheme' }
    & Pick<PathFlowTheme, 'type'>
  ), category: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'slug'>
    & { department: Maybe<(
      { __typename: 'Department' }
      & DepartmentContextFragment
    )> }
  )>, pagesConnection: (
    { __typename: 'PathFlowPagesConnection' }
    & PathFlowPagesConnectionFragment
  ) }
);

export type PathFlowPageFragment = (
  { __typename: 'PathFlowPage' }
  & Pick<PathFlowPage, 'id' | 'internalName' | 'slug' | 'completed' | 'completionPercentage' | 'requiresServerSyncAfterSubmit'>
  & { metadata: Array<(
    { __typename: 'BasicPathFlowPageMetadata' }
    & PathFlowPageMetadataBasicPathFlowPageMetadataFragment
  ) | (
    { __typename: 'ContactPrivacyMetadata' }
    & PathFlowPageMetadataContactPrivacyMetadataFragment
  ) | (
    { __typename: 'ContactTCPAComplianceMetadata' }
    & PathFlowPageMetadataContactTcpaComplianceMetadataFragment
  ) | (
    { __typename: 'FacebookMessengerPathFlowPageMetadata' }
    & PathFlowPageMetadataFacebookMessengerPathFlowPageMetadataFragment
  ) | (
    { __typename: 'FacebookTCPAComplianceMetadata' }
    & PathFlowPageMetadataFacebookTcpaComplianceMetadataFragment
  ) | (
    { __typename: 'GenericInfoBoxPageMetadata' }
    & PathFlowPageMetadataGenericInfoBoxPageMetadataFragment
  ) | (
    { __typename: 'GenericModalPageMetadata' }
    & PathFlowPageMetadataGenericModalPageMetadataFragment
  ) | (
    { __typename: 'InterstitialPathFlowPageMetadata' }
    & PathFlowPageMetadataInterstitialPathFlowPageMetadataFragment
  ) | (
    { __typename: 'PhoneExplanationModalMetadata' }
    & PathFlowPageMetadataPhoneExplanationModalMetadataFragment
  ) | (
    { __typename: 'RatingContactPageMetadata' }
    & PathFlowPageMetadataRatingContactPageMetadataFragment
  ) | (
    { __typename: 'ReviewFooterPageMetadata' }
    & PathFlowPageMetadataReviewFooterPageMetadataFragment
  ) | (
    { __typename: 'TermsAndConditionsPathFlowPageMetadata' }
    & PathFlowPageMetadataTermsAndConditionsPathFlowPageMetadataFragment
  ) | (
    { __typename: 'TermsPrivacyMedicalPathFlowPageMetadata' }
    & PathFlowPageMetadataTermsPrivacyMedicalPathFlowPageMetadataFragment
  )>, title: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, notificationTexts: Array<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, questions: Array<(
    { __typename: 'DatePathFlowQuestion' }
    & PathFlowQuestionDatePathFlowQuestionFragment
  ) | (
    { __typename: 'DateRangePathFlowQuestion' }
    & PathFlowQuestionDateRangePathFlowQuestionFragment
  ) | (
    { __typename: 'IdPathFlowQuestion' }
    & PathFlowQuestionIdPathFlowQuestionFragment
  ) | (
    { __typename: 'InputTextPathFlowQuestion' }
    & PathFlowQuestionInputTextPathFlowQuestionFragment
  ) | (
    { __typename: 'ListPathFlowQuestion' }
    & PathFlowQuestionListPathFlowQuestionFragment
  ) | (
    { __typename: 'NumericPathFlowQuestion' }
    & PathFlowQuestionNumericPathFlowQuestionFragment
  ) | (
    { __typename: 'OAuthEmailPathFlowQuestion' }
    & PathFlowQuestionOAuthEmailPathFlowQuestionFragment
  ) | (
    { __typename: 'UserContactPathFlowQuestion' }
    & PathFlowQuestionUserContactPathFlowQuestionFragment
  )>, submitButtonText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, skipButtonText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )> }
);

export type RatingContactPageMetadataFragment = (
  { __typename: 'RatingContactPageMetadata' }
  & Pick<RatingContactPageMetadata, 'type'>
);

export type TermsAndConditionsPageMetadataFragment = (
  { __typename: 'TermsAndConditionsPathFlowPageMetadata' }
  & Pick<TermsAndConditionsPathFlowPageMetadata, 'type'>
);

type PathFlowPageMetadataBasicPathFlowPageMetadataFragment = (
  { __typename: 'BasicPathFlowPageMetadata' }
  & Pick<BasicPathFlowPageMetadata, 'type'>
);

type PathFlowPageMetadataContactPrivacyMetadataFragment = (
  { __typename: 'ContactPrivacyMetadata' }
  & Pick<ContactPrivacyMetadata, 'type'>
);

type PathFlowPageMetadataContactTcpaComplianceMetadataFragment = (
  { __typename: 'ContactTCPAComplianceMetadata' }
  & Pick<ContactTcpaComplianceMetadata, 'type'>
);

type PathFlowPageMetadataFacebookMessengerPathFlowPageMetadataFragment = (
  { __typename: 'FacebookMessengerPathFlowPageMetadata' }
  & Pick<FacebookMessengerPathFlowPageMetadata, 'type'>
);

type PathFlowPageMetadataFacebookTcpaComplianceMetadataFragment = (
  { __typename: 'FacebookTCPAComplianceMetadata' }
  & Pick<FacebookTcpaComplianceMetadata, 'type'>
);

type PathFlowPageMetadataGenericInfoBoxPageMetadataFragment = (
  { __typename: 'GenericInfoBoxPageMetadata' }
  & Pick<GenericInfoBoxPageMetadata, 'type'>
  & GenericInfoBoxPageMetadataFragment
);

type PathFlowPageMetadataGenericModalPageMetadataFragment = (
  { __typename: 'GenericModalPageMetadata' }
  & Pick<GenericModalPageMetadata, 'type'>
  & GenericModalPageMetadataFragment
);

type PathFlowPageMetadataInterstitialPathFlowPageMetadataFragment = (
  { __typename: 'InterstitialPathFlowPageMetadata' }
  & Pick<InterstitialPathFlowPageMetadata, 'type'>
  & InterstitialPageMetadataFragment
);

type PathFlowPageMetadataPhoneExplanationModalMetadataFragment = (
  { __typename: 'PhoneExplanationModalMetadata' }
  & Pick<PhoneExplanationModalMetadata, 'type'>
);

type PathFlowPageMetadataRatingContactPageMetadataFragment = (
  { __typename: 'RatingContactPageMetadata' }
  & Pick<RatingContactPageMetadata, 'type'>
  & RatingContactPageMetadataFragment
);

type PathFlowPageMetadataReviewFooterPageMetadataFragment = (
  { __typename: 'ReviewFooterPageMetadata' }
  & Pick<ReviewFooterPageMetadata, 'type'>
);

type PathFlowPageMetadataTermsAndConditionsPathFlowPageMetadataFragment = (
  { __typename: 'TermsAndConditionsPathFlowPageMetadata' }
  & Pick<TermsAndConditionsPathFlowPageMetadata, 'type'>
  & TermsAndConditionsPageMetadataFragment
);

type PathFlowPageMetadataTermsPrivacyMedicalPathFlowPageMetadataFragment = (
  { __typename: 'TermsPrivacyMedicalPathFlowPageMetadata' }
  & Pick<TermsPrivacyMedicalPathFlowPageMetadata, 'type'>
);

export type PathFlowPageMetadataFragment = PathFlowPageMetadataBasicPathFlowPageMetadataFragment | PathFlowPageMetadataContactPrivacyMetadataFragment | PathFlowPageMetadataContactTcpaComplianceMetadataFragment | PathFlowPageMetadataFacebookMessengerPathFlowPageMetadataFragment | PathFlowPageMetadataFacebookTcpaComplianceMetadataFragment | PathFlowPageMetadataGenericInfoBoxPageMetadataFragment | PathFlowPageMetadataGenericModalPageMetadataFragment | PathFlowPageMetadataInterstitialPathFlowPageMetadataFragment | PathFlowPageMetadataPhoneExplanationModalMetadataFragment | PathFlowPageMetadataRatingContactPageMetadataFragment | PathFlowPageMetadataReviewFooterPageMetadataFragment | PathFlowPageMetadataTermsAndConditionsPathFlowPageMetadataFragment | PathFlowPageMetadataTermsPrivacyMedicalPathFlowPageMetadataFragment;

type PathFlowQuestionDatePathFlowQuestionFragment = (
  { __typename: 'DatePathFlowQuestion' }
  & DatePathFlowQuestionFragment
  & SharedPathFlowQuestionDatePathFlowQuestionFragment
);

type PathFlowQuestionDateRangePathFlowQuestionFragment = (
  { __typename: 'DateRangePathFlowQuestion' }
  & DateRangePathFlowQuestionFragment
  & SharedPathFlowQuestionDateRangePathFlowQuestionFragment
);

type PathFlowQuestionIdPathFlowQuestionFragment = (
  { __typename: 'IdPathFlowQuestion' }
  & IdPathFlowQuestionFragment
  & SharedPathFlowQuestionIdPathFlowQuestionFragment
);

type PathFlowQuestionInputTextPathFlowQuestionFragment = (
  { __typename: 'InputTextPathFlowQuestion' }
  & InputTextPathFlowQuestionFragment
  & SharedPathFlowQuestionInputTextPathFlowQuestionFragment
);

type PathFlowQuestionListPathFlowQuestionFragment = (
  { __typename: 'ListPathFlowQuestion' }
  & ListPathFlowQuestionFragment
  & SharedPathFlowQuestionListPathFlowQuestionFragment
);

type PathFlowQuestionNumericPathFlowQuestionFragment = (
  { __typename: 'NumericPathFlowQuestion' }
  & NumericPathFlowQuestionFragment
  & SharedPathFlowQuestionNumericPathFlowQuestionFragment
);

type PathFlowQuestionOAuthEmailPathFlowQuestionFragment = (
  { __typename: 'OAuthEmailPathFlowQuestion' }
  & OAuthEmailPathFlowQuestionFragment
  & SharedPathFlowQuestionOAuthEmailPathFlowQuestionFragment
);

type PathFlowQuestionUserContactPathFlowQuestionFragment = (
  { __typename: 'UserContactPathFlowQuestion' }
  & SharedPathFlowQuestionUserContactPathFlowQuestionFragment
);

export type PathFlowQuestionFragment = PathFlowQuestionDatePathFlowQuestionFragment | PathFlowQuestionDateRangePathFlowQuestionFragment | PathFlowQuestionIdPathFlowQuestionFragment | PathFlowQuestionInputTextPathFlowQuestionFragment | PathFlowQuestionListPathFlowQuestionFragment | PathFlowQuestionNumericPathFlowQuestionFragment | PathFlowQuestionOAuthEmailPathFlowQuestionFragment | PathFlowQuestionUserContactPathFlowQuestionFragment;

export type PathValidationErrorFragment = (
  { __typename: 'PathValidationError' }
  & Pick<PathValidationError, 'pageName' | 'questionName' | 'tags'>
  & { message: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )> }
);

type SharedPathFlowQuestionDatePathFlowQuestionFragment = (
  { __typename: 'DatePathFlowQuestion' }
  & Pick<DatePathFlowQuestion, 'internalName' | 'required'>
  & { questionText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, questionSubText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputLabel: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputIconImage: Maybe<(
    { __typename: 'PathImageViewModel' }
    & ImageViewModelFragment
  )> }
);

type SharedPathFlowQuestionDateRangePathFlowQuestionFragment = (
  { __typename: 'DateRangePathFlowQuestion' }
  & Pick<DateRangePathFlowQuestion, 'internalName' | 'required'>
  & { questionText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, questionSubText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputLabel: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputIconImage: Maybe<(
    { __typename: 'PathImageViewModel' }
    & ImageViewModelFragment
  )> }
);

type SharedPathFlowQuestionIdPathFlowQuestionFragment = (
  { __typename: 'IdPathFlowQuestion' }
  & Pick<IdPathFlowQuestion, 'internalName' | 'required'>
  & { questionText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, questionSubText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputLabel: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputIconImage: Maybe<(
    { __typename: 'PathImageViewModel' }
    & ImageViewModelFragment
  )> }
);

type SharedPathFlowQuestionInputTextPathFlowQuestionFragment = (
  { __typename: 'InputTextPathFlowQuestion' }
  & Pick<InputTextPathFlowQuestion, 'internalName' | 'required'>
  & { questionText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, questionSubText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputLabel: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputIconImage: Maybe<(
    { __typename: 'PathImageViewModel' }
    & ImageViewModelFragment
  )> }
);

type SharedPathFlowQuestionListPathFlowQuestionFragment = (
  { __typename: 'ListPathFlowQuestion' }
  & Pick<ListPathFlowQuestion, 'internalName' | 'required'>
  & { questionText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, questionSubText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputLabel: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputIconImage: Maybe<(
    { __typename: 'PathImageViewModel' }
    & ImageViewModelFragment
  )> }
);

type SharedPathFlowQuestionNumericPathFlowQuestionFragment = (
  { __typename: 'NumericPathFlowQuestion' }
  & Pick<NumericPathFlowQuestion, 'internalName' | 'required'>
  & { questionText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, questionSubText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputLabel: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputIconImage: Maybe<(
    { __typename: 'PathImageViewModel' }
    & ImageViewModelFragment
  )> }
);

type SharedPathFlowQuestionOAuthEmailPathFlowQuestionFragment = (
  { __typename: 'OAuthEmailPathFlowQuestion' }
  & Pick<OAuthEmailPathFlowQuestion, 'internalName' | 'required'>
  & { questionText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, questionSubText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputLabel: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputIconImage: Maybe<(
    { __typename: 'PathImageViewModel' }
    & ImageViewModelFragment
  )> }
);

type SharedPathFlowQuestionUserContactPathFlowQuestionFragment = (
  { __typename: 'UserContactPathFlowQuestion' }
  & Pick<UserContactPathFlowQuestion, 'internalName' | 'required'>
  & { questionText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, questionSubText: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputLabel: Maybe<(
    { __typename: 'AttributedHtmlTextViewModel' }
    & TextViewModelFragment
  )>, inputIconImage: Maybe<(
    { __typename: 'PathImageViewModel' }
    & ImageViewModelFragment
  )> }
);

export type SharedPathFlowQuestionFragment = SharedPathFlowQuestionDatePathFlowQuestionFragment | SharedPathFlowQuestionDateRangePathFlowQuestionFragment | SharedPathFlowQuestionIdPathFlowQuestionFragment | SharedPathFlowQuestionInputTextPathFlowQuestionFragment | SharedPathFlowQuestionListPathFlowQuestionFragment | SharedPathFlowQuestionNumericPathFlowQuestionFragment | SharedPathFlowQuestionOAuthEmailPathFlowQuestionFragment | SharedPathFlowQuestionUserContactPathFlowQuestionFragment;

export type TextViewModelFragment = (
  { __typename: 'AttributedHtmlTextViewModel' }
  & Pick<AttributedHtmlTextViewModel, 'text'>
  & { attributes: Maybe<Array<(
    { __typename: 'AttributedHtmlTextViewModelAttribute' }
    & Pick<AttributedHtmlTextViewModelAttribute, 'key' | 'type'>
    & { image: Maybe<(
      { __typename: 'PathImageViewModel' }
      & ImageViewModelFragment
    )> }
  )>> }
);

export type CreatePathFlowMutationVariables = {
  input: CreatePathFlowInput
};


export type CreatePathFlowMutation = (
  { __typename: 'Mutation' }
  & { createPathFlow: (
    { __typename: 'CreatePathFlowPayload' }
    & Pick<CreatePathFlowPayload, 'newUserRegistered'>
    & { flow: Maybe<(
      { __typename: 'PathFlow' }
      & PathFlowFragment
    )>, errors: Maybe<Array<(
      { __typename: 'PathValidationError' }
      & PathValidationErrorFragment
    )>> }
  ) }
);

export type GenerateCollectPhoneNumberTextInPathMutationVariables = {
  input: GenerateCollectPhoneNumberTextInPathInput
};


export type GenerateCollectPhoneNumberTextInPathMutation = (
  { __typename: 'Mutation' }
  & { generateCollectPhoneNumberTextInPath: (
    { __typename: 'GenerateCollectPhoneNumberTextInPathPayload' }
    & Pick<GenerateCollectPhoneNumberTextInPathPayload, 'toNumber' | 'body'>
  ) }
);

export type SubmitDatePathFlowQuestionMutationVariables = {
  input: SubmitDatePathFlowQuestionInput
};


export type SubmitDatePathFlowQuestionMutation = (
  { __typename: 'Mutation' }
  & { submitDatePathFlowQuestion: (
    { __typename: 'SubmitDatePathFlowQuestionPayload' }
    & { errors: Maybe<Array<(
      { __typename: 'PathValidationError' }
      & PathValidationErrorFragment
    )>> }
  ) }
);

export type SubmitDateRangePathFlowQuestionMutationVariables = {
  input: SubmitDateRangePathFlowQuestionInput
};


export type SubmitDateRangePathFlowQuestionMutation = (
  { __typename: 'Mutation' }
  & { submitDateRangePathFlowQuestion: (
    { __typename: 'SubmitDateRangePathFlowQuestionPayload' }
    & { errors: Maybe<Array<(
      { __typename: 'PathValidationError' }
      & PathValidationErrorFragment
    )>> }
  ) }
);

export type SubmitFacebookPathFlowQuestionMutationVariables = {
  input: SubmitInputTextPathFlowQuestionInput
};


export type SubmitFacebookPathFlowQuestionMutation = (
  { __typename: 'Mutation' }
  & { submitInputTextPathFlowQuestion: (
    { __typename: 'SubmitInputTextPathFlowQuestionPayload' }
    & { errors: Maybe<Array<(
      { __typename: 'PathValidationError' }
      & PathValidationErrorFragment
    )>> }
  ) }
);

export type SubmitIdPathFlowQuestionMutationVariables = {
  input: SubmitIdPathFlowQuestionInput
};


export type SubmitIdPathFlowQuestionMutation = (
  { __typename: 'Mutation' }
  & { submitIdPathFlowQuestion: (
    { __typename: 'SubmitIdPathFlowQuestionPayload' }
    & { errors: Maybe<Array<(
      { __typename: 'PathValidationError' }
      & PathValidationErrorFragment
    )>> }
  ) }
);

export type SubmitInputTextPathFlowQuestionMutationVariables = {
  input: SubmitInputTextPathFlowQuestionInput
};


export type SubmitInputTextPathFlowQuestionMutation = (
  { __typename: 'Mutation' }
  & { submitInputTextPathFlowQuestion: (
    { __typename: 'SubmitInputTextPathFlowQuestionPayload' }
    & { errors: Maybe<Array<(
      { __typename: 'PathValidationError' }
      & PathValidationErrorFragment
    )>> }
  ) }
);

export type SubmitListPathFlowQuestionMutationVariables = {
  input: SubmitListPathFlowQuestionInput
};


export type SubmitListPathFlowQuestionMutation = (
  { __typename: 'Mutation' }
  & { submitListPathFlowQuestion: (
    { __typename: 'SubmitListPathFlowQuestionPayload' }
    & { errors: Maybe<Array<(
      { __typename: 'PathValidationError' }
      & PathValidationErrorFragment
    )>> }
  ) }
);

export type SubmitNumericPathFlowQuestionMutationVariables = {
  input: SubmitNumericPathFlowQuestionInput
};


export type SubmitNumericPathFlowQuestionMutation = (
  { __typename: 'Mutation' }
  & { submitNumericPathFlowQuestion: (
    { __typename: 'SubmitNumericPathFlowQuestionPayload' }
    & { errors: Maybe<Array<(
      { __typename: 'PathValidationError' }
      & PathValidationErrorFragment
    )>> }
  ) }
);

export type SubmitOAuthEmailPathFlowQuestionMutationVariables = {
  input: SubmitOAuthEmailPathFlowQuestionInput
};


export type SubmitOAuthEmailPathFlowQuestionMutation = (
  { __typename: 'Mutation' }
  & { submitOAuthEmailPathFlowQuestion: (
    { __typename: 'SubmitOAuthEmailPathFlowQuestionPayload' }
    & { errors: Maybe<Array<(
      { __typename: 'PathValidationError' }
      & PathValidationErrorFragment
    )>> }
  ) }
);

export type SubmitPathFlowPageMutationVariables = {
  input: SubmitPathFlowPageInput
};


export type SubmitPathFlowPageMutation = (
  { __typename: 'Mutation' }
  & { submitPathFlowPage: (
    { __typename: 'SubmitPathFlowPagePayload' }
    & Pick<SubmitPathFlowPagePayload, 'newUserRegistered'>
    & { flow: Maybe<(
      { __typename: 'PathFlow' }
      & PathFlowFragment
    )>, errors: Maybe<Array<(
      { __typename: 'PathValidationError' }
      & PathValidationErrorFragment
    )>> }
  ) }
);

export type SubmitPushNotifcationFcmTokenMutationVariables = {
  input: SubmitInputTextPathFlowQuestionInput
};


export type SubmitPushNotifcationFcmTokenMutation = (
  { __typename: 'Mutation' }
  & { submitInputTextPathFlowQuestion: (
    { __typename: 'SubmitInputTextPathFlowQuestionPayload' }
    & { errors: Maybe<Array<(
      { __typename: 'PathValidationError' }
      & PathValidationErrorFragment
    )>> }
  ) }
);

export type SubmitPushNotificationAuthorizedStatusMutationVariables = {
  input: SubmitListPathFlowQuestionInput
};


export type SubmitPushNotificationAuthorizedStatusMutation = (
  { __typename: 'Mutation' }
  & { submitListPathFlowQuestion: (
    { __typename: 'SubmitListPathFlowQuestionPayload' }
    & { errors: Maybe<Array<(
      { __typename: 'PathValidationError' }
      & PathValidationErrorFragment
    )>> }
  ) }
);

export type SubmitUserContactPathFlowQuestionMutationVariables = {
  input: SubmitUserContactPathFlowQuestionInput
};


export type SubmitUserContactPathFlowQuestionMutation = (
  { __typename: 'Mutation' }
  & { submitUserContactPathFlowQuestion: (
    { __typename: 'SubmitUserContactPathFlowQuestionPayload' }
    & { errors: Maybe<Array<(
      { __typename: 'PathValidationError' }
      & PathValidationErrorFragment
    )>> }
  ) }
);

export type UploadGearImageMutationVariables = {
  input: UploadMediaInput
};


export type UploadGearImageMutation = (
  { __typename: 'Mutation' }
  & { uploadMedia: (
    { __typename: 'UploadMediaPayload' }
    & { mediaFile: Maybe<(
      { __typename: 'MediaFile' }
      & Pick<MediaFile, 'id' | 'url'>
    )> }
  ) }
);

export type PathFlowQueryVariables = {
  id: Scalars['PathFlowId']
};


export type PathFlowQuery = (
  { __typename: 'Query' }
  & { pathFlow: (
    { __typename: 'PathFlowPayload' }
    & { flow: Maybe<(
      { __typename: 'PathFlow' }
      & PathFlowFragment
    )> }
  ) }
);

export type PathFlowPageQueryVariables = {
  pathFlowId: Scalars['PathFlowId'],
  pathFlowPageSlug: Scalars['String']
};


export type PathFlowPageQuery = (
  { __typename: 'Query' }
  & { pathFlowPage: (
    { __typename: 'PathFlowPagePayload' }
    & { page: Maybe<(
      { __typename: 'PathFlowPage' }
      & PathFlowPageFragment
    )> }
  ) }
);

export type PathExpertFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
  & { expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id' | 'background' | 'headline'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )>, highlights: Array<(
      { __typename: 'ProfileHighlight' }
      & Pick<ProfileHighlight, 'value' | 'secondaryValue'>
      & { type: (
        { __typename: 'ProfileHighlightType' }
        & Pick<ProfileHighlightType, 'id' | 'displayName'>
      ) }
    )> }
  )>, expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & ExpertStatsFragment
  )> }
);

export type RecommendExpertsForPathFlowQueryVariables = {
  pathFlowId: Scalars['PathFlowId']
};


export type RecommendExpertsForPathFlowQuery = (
  { __typename: 'Query' }
  & { recommendExpertsForPathFlow: Array<(
    { __typename: 'RecommendedExpert' }
    & { expert: (
      { __typename: 'BusinessUser' }
      & PathExpertFragment
    ) }
  )> }
);

export type VerifyPaymentTransactionMutationVariables = {
  input: VerifyPaymentTransactionInput
};


export type VerifyPaymentTransactionMutation = (
  { __typename: 'Mutation' }
  & { verifyPaymentTransaction: (
    { __typename: 'VerifyPaymentTransactionPayload' }
    & Pick<VerifyPaymentTransactionPayload, 'error' | 'verified'>
    & { order: (
      { __typename: 'Order' }
      & Pick<Order, 'id' | 'state'>
    ) }
  ) }
);

export type IssueVerificationCodeMutationVariables = {
  input: InitiateVerifyHandleInput
};


export type IssueVerificationCodeMutation = (
  { __typename: 'Mutation' }
  & { initiateVerifyHandle: (
    { __typename: 'InitiateVerifyHandlePayload' }
    & Pick<InitiateVerifyHandlePayload, 'success'>
  ) }
);

export type UpdateUserPhoneMutationVariables = {
  input: UpdateUserProfileInput
};


export type UpdateUserPhoneMutation = (
  { __typename: 'Mutation' }
  & { updateUserProfile: (
    { __typename: 'UpdateUserProfilePayload' }
    & Pick<UpdateUserProfilePayload, 'errors'>
    & { user: (
      { __typename: 'User' }
      & Pick<User, 'id'>
      & { contacts: Array<(
        { __typename: 'Contact' }
        & Pick<Contact, 'id' | 'type' | 'value' | 'verified'>
      )> }
    ) }
  ) }
);

export type ConfirmVerificationCodeMutationVariables = {
  input: VerifyHandleChallengeInput
};


export type ConfirmVerificationCodeMutation = (
  { __typename: 'Mutation' }
  & { verifyHandleChallenge: (
    { __typename: 'VerifyHandleChallengePayload' }
    & Pick<VerifyHandleChallengePayload, 'message' | 'success'>
  ) }
);

export type RecommendedListFragment = (
  { __typename: 'RecommendedList' }
  & Pick<RecommendedList, 'displayName' | 'subTitle'>
  & { recommendedListDefinition: Maybe<(
    { __typename: 'RecommendedListDefinition' }
    & Pick<RecommendedListDefinition, 'id' | 'rank'>
  )>, sellables: Array<(
    { __typename: 'Sellable' }
    & RecommendedListSellableCardFragment
  )> }
);

export type RecommendedListByTypeQueryVariables = {
  categorySlug: Scalars['String'],
  types?: Maybe<Array<RecommendedListType>>
};


export type RecommendedListByTypeQuery = (
  { __typename: 'Query' }
  & { recommendedListsForCategory: (
    { __typename: 'RecommendedListConnection' }
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), edges: Array<(
      { __typename: 'RecommendedListEdge' }
      & Pick<RecommendedListEdge, 'cursor'>
      & { node: (
        { __typename: 'RecommendedList' }
        & RecommendedListFragment
      ) }
    )> }
  ) }
);

export type ExpertForRatingFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
  & { expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id' | 'headline'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
  )>, department: (
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'slug' | 'type'>
  ) }
);

export type ExpertForRatingQueryVariables = {
  vanityIdOrId: Scalars['String']
};


export type ExpertForRatingQuery = (
  { __typename: 'Query' }
  & { findExpert: Maybe<(
    { __typename: 'BusinessUser' }
    & ExpertForRatingFragment
  )> }
);

export type StartExpertRatingPathMutationVariables = {
  input: StartExpertRatingInput
};


export type StartExpertRatingPathMutation = (
  { __typename: 'Mutation' }
  & { startExpertRatingPath: (
    { __typename: 'StartExpertRatingPayload' }
    & { flow: Maybe<(
      { __typename: 'PathFlow' }
      & Pick<PathFlow, 'id' | 'slug'>
      & { pagesConnection: (
        { __typename: 'PathFlowPagesConnection' }
        & { edges: Array<(
          { __typename: 'PathFlowPagesEdge' }
          & { node: (
            { __typename: 'PathFlowPage' }
            & Pick<PathFlowPage, 'id' | 'slug'>
          ) }
        )> }
      ) }
    )>, errors: Maybe<Array<(
      { __typename: 'PathValidationError' }
      & Pick<PathValidationError, 'pageName' | 'questionName'>
    )>> }
  ) }
);

export type DepartmentReviewsQueryVariables = {
  id: Scalars['DepartmentId']
};


export type DepartmentReviewsQuery = (
  { __typename: 'Query' }
  & { department: (
    { __typename: 'Department' }
    & Pick<Department, 'id'>
    & { reviewSummary: (
      { __typename: 'ReviewSummary' }
      & Pick<ReviewSummary, 'averageRating' | 'totalReviews'>
    ) }
  ) }
);

export type DepartmentForSchemaQueryVariables = {
  id: Scalars['DepartmentId']
};


export type DepartmentForSchemaQuery = (
  { __typename: 'Query' }
  & { department: (
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'slug' | 'displayName'>
    & { reviewSummary: (
      { __typename: 'ReviewSummary' }
      & Pick<ReviewSummary, 'averageRating' | 'totalReviews'>
    ) }
  ) }
);

export type ExpertForSchemaQueryVariables = {
  vanityIdOrId: Scalars['String']
};


export type ExpertForSchemaQuery = (
  { __typename: 'Query' }
  & { findExpert: Maybe<(
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
    & { expertProfile: Maybe<(
      { __typename: 'ExpertProfile' }
      & Pick<ExpertProfile, 'id' | 'background'>
      & { profilePhoto: Maybe<(
        { __typename: 'MediaFile' }
        & MediaFileFragment
      )> }
    )>, expertStats: Maybe<(
      { __typename: 'ExpertStats' }
      & Pick<ExpertStats, 'averageRating' | 'totalReviews'>
    )> }
  )> }
);

export type SingleConsumerReviewQueryVariables = {
  id: Scalars['ConsumerExpertReviewId']
};


export type SingleConsumerReviewQuery = (
  { __typename: 'Query' }
  & { consumerExpertReview: (
    { __typename: 'ConsumerExpertReview' }
    & ConsumerExpertReviewFragment
  ) }
);

export type SaveSellableMutationVariables = {
  input: SaveSavedSellableInput
};


export type SaveSellableMutation = (
  { __typename: 'Mutation' }
  & { saveSavedSellable: (
    { __typename: 'SaveSavedSellablePayload' }
    & { savedSellable: (
      { __typename: 'SavedSellable' }
      & Pick<SavedSellable, 'id' | 'saved'>
      & { sellable: (
        { __typename: 'Sellable' }
        & SellableCardFragment
      ) }
    ) }
  ) }
);

export type SaveableSellableFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id'>
  & { savedSellable: Maybe<(
    { __typename: 'SavedSellable' }
    & Pick<SavedSellable, 'id' | 'saved'>
  )>, parent: Maybe<(
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id'>
    & { savedSellable: Maybe<(
      { __typename: 'SavedSellable' }
      & Pick<SavedSellable, 'id' | 'saved'>
    )> }
  )> }
);

export type SaveableSellableResponseFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id'>
  & { savedSellable: Maybe<(
    { __typename: 'SavedSellable' }
    & Pick<SavedSellable, 'id' | 'saved'>
  )> }
);

export type UnsaveSellableMutationVariables = {
  input: UnsaveSavedSellableInput
};


export type UnsaveSellableMutation = (
  { __typename: 'Mutation' }
  & { unsaveSavedSellable: (
    { __typename: 'UnsaveSavedSellablePayload' }
    & { savedSellable: (
      { __typename: 'SavedSellable' }
      & Pick<SavedSellable, 'id' | 'saved'>
      & { sellable: (
        { __typename: 'Sellable' }
        & SellableCardFragment
      ) }
    ) }
  ) }
);

export type SellableCardFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id' | 'type' | 'areAllVariantsOutOfStock'>
  & { metrics: Maybe<(
    { __typename: 'SellableMetrics' }
    & Pick<SellableMetrics, 'totalUniquePVsInPastWeek' | 'totalPurchasesInLast30Days'>
  )>, department: Maybe<(
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'type' | 'slug'>
  )>, parent: Maybe<(
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id'>
    & { metrics: Maybe<(
      { __typename: 'SellableMetrics' }
      & Pick<SellableMetrics, 'totalUniquePVsInPastWeek' | 'totalPurchasesInLast30Days'>
    )>, savedSellable: Maybe<(
      { __typename: 'SavedSellable' }
      & Pick<SavedSellable, 'id' | 'saved'>
    )> }
  )>, savedSellable: Maybe<(
    { __typename: 'SavedSellable' }
    & Pick<SavedSellable, 'id' | 'saved'>
  )>, serviceLocation: Maybe<(
    { __typename: 'SellableServiceLocation' }
    & Pick<SellableServiceLocation, 'displayTitle'>
  )>, variationMatrix: Maybe<(
    { __typename: 'VariationMatrix' }
    & { priceRange: Maybe<(
      { __typename: 'VariationMatrixPriceRange' }
      & { max: (
        { __typename: 'MonetaryAmount' }
        & MonetaryAmountFragment
      ), min: (
        { __typename: 'MonetaryAmount' }
        & MonetaryAmountFragment
      ) }
    )>, defaultVariant: (
      { __typename: 'Sellable' }
      & Pick<Sellable, 'id'>
      & { images: Array<(
        { __typename: 'MediaFile' }
        & MediaFileFragment
      )> }
      & SellableUrlFragment
      & TrackableSellableFragment
    ) }
  )>, charterBathrooms: Maybe<(
    { __typename: 'Attribute' }
    & { formatted: Maybe<(
      { __typename: 'FormattedAttribute' }
      & Pick<FormattedAttribute, 'name' | 'displayHtml' | 'displayHtmlValues'>
    )> }
  )>, charterCabins: Maybe<(
    { __typename: 'Attribute' }
    & { formatted: Maybe<(
      { __typename: 'FormattedAttribute' }
      & Pick<FormattedAttribute, 'name' | 'displayHtml' | 'displayHtmlValues'>
    )> }
  )>, charterCapacity: Maybe<(
    { __typename: 'Attribute' }
    & { formatted: Maybe<(
      { __typename: 'FormattedAttribute' }
      & Pick<FormattedAttribute, 'name' | 'displayHtml' | 'displayHtmlValues'>
    )> }
  )> }
  & TrackableSellableFragment
);

export type SaveRecommendedListRatingMutationVariables = {
  input: SaveConsumerSellableReactionInput
};


export type SaveRecommendedListRatingMutation = (
  { __typename: 'Mutation' }
  & { saveConsumerSellableReaction: (
    { __typename: 'SaveConsumerSellableReactionPayload' }
    & { consumerSellableReaction: Maybe<(
      { __typename: 'ConsumerSellableReaction' }
      & Pick<ConsumerSellableReaction, 'id'>
      & { sellable: (
        { __typename: 'Sellable' }
        & RecommendedListSellableCardFragment
      ) }
    )> }
  ) }
);

export type ConsumerReactionsForSellableQueryVariables = {
  id: Scalars['SellableId']
};


export type ConsumerReactionsForSellableQuery = (
  { __typename: 'Query' }
  & { sellable: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id'>
    & { consumerSellableReactions: (
      { __typename: 'ConsumerSellableReactionConnection' }
      & { edges: Array<(
        { __typename: 'ConsumerSellableReactionEdge' }
        & { node: (
          { __typename: 'ConsumerSellableReaction' }
          & Pick<ConsumerSellableReaction, 'id'>
          & { ratingWithDisplayName: (
            { __typename: 'ConsumerSellableReactionRatingWithDisplayName' }
            & Pick<ConsumerSellableReactionRatingWithDisplayName, 'displayName' | 'rating'>
          ) }
        ) }
      )> }
    ) }
  ) }
);

export type CreateShareLinkMutationVariables = {
  input: ShortenUrlInput
};


export type CreateShareLinkMutation = (
  { __typename: 'Mutation' }
  & { shortenUrl: Maybe<(
    { __typename: 'ShortenUrlPayload' }
    & Pick<ShortenUrlPayload, 'url'>
  )> }
);

export type SendExpertReferralMutationVariables = {
  input: SendExpertReferralInput
};


export type SendExpertReferralMutation = (
  { __typename: 'Mutation' }
  & { sendExpertReferral: (
    { __typename: 'SendExpertReferralPayload' }
    & Pick<SendExpertReferralPayload, 'errors'>
  ) }
);

export type GuestSellableFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type' | 'title'>
  & { images: Array<(
    { __typename: 'MediaFile' }
    & MediaFileFragment
  )>, variants: Array<(
    { __typename: 'SellableFormattedVariant' }
    & Pick<SellableFormattedVariant, 'displayValueHtml'>
  )> }
  & SellablePricingFragment
  & TrackableSellableFragment
);

export type GuestSellablesQueryVariables = {
  ids: Array<Scalars['SellableId']>
};


export type GuestSellablesQuery = (
  { __typename: 'Query' }
  & { sellables: Array<(
    { __typename: 'Sellable' }
    & GuestSellableFragment
  )> }
);

export type DismissOrderMessageMutationVariables = {};


export type DismissOrderMessageMutation = (
  { __typename: 'Mutation' }
  & { dismissOrderMessages: (
    { __typename: 'DismissOrderMessagesPayload' }
    & { order: (
      { __typename: 'Order' }
      & ShoppingCartOrderFragment
    ) }
  ) }
);

export type RemoveItemFromOrderMutationVariables = {
  input: RemoveItemsFromOrderInput
};


export type RemoveItemFromOrderMutation = (
  { __typename: 'Mutation' }
  & { removeItemsFromOrder: (
    { __typename: 'RemoveItemsFromOrderPayload' }
    & { order: (
      { __typename: 'Order' }
      & ShoppingCartOrderFragment
    ) }
  ) }
);

export type UpdateQuantityForOrderMutationVariables = {
  input: UpdateQuantityForOrderInput
};


export type UpdateQuantityForOrderMutation = (
  { __typename: 'Mutation' }
  & { updateQuantityForOrder: (
    { __typename: 'UpdateQuantityForOrderPayload' }
    & { order: (
      { __typename: 'Order' }
      & ShoppingCartOrderFragment
    ) }
  ) }
);

export type SimilarProductsQueryVariables = {
  sellableId: Scalars['SellableId']
};


export type SimilarProductsQuery = (
  { __typename: 'Query' }
  & { similarSellables: (
    { __typename: 'SimilarSellablePayload' }
    & { sellables: Maybe<Array<(
      { __typename: 'Sellable' }
      & RecommendedListSellableCardFragment
    )>> }
  ) }
);

export type StandaloneRegisterMutationVariables = {
  input: RegisterCustomerInput
};


export type StandaloneRegisterMutation = (
  { __typename: 'Mutation' }
  & { registerCustomer: (
    { __typename: 'RegisterCustomerPayload' }
    & Pick<RegisterCustomerPayload, 'errors' | 'errorCodes'>
    & { user: Maybe<(
      { __typename: 'User' }
      & AuthenticatedUserFragment
    )> }
  ) }
);

export type UploadMediaMutationVariables = {
  input: UploadMediaInput
};


export type UploadMediaMutation = (
  { __typename: 'Mutation' }
  & { uploadMedia: (
    { __typename: 'UploadMediaPayload' }
    & { mediaFile: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
  ) }
);

export type UpdateProfileDataMutationVariables = {
  input: UpdateUserProfileInput
};


export type UpdateProfileDataMutation = (
  { __typename: 'Mutation' }
  & { updateUserProfile: (
    { __typename: 'UpdateUserProfilePayload' }
    & Pick<UpdateUserProfilePayload, 'errors'>
  ) }
);

export type VariationMatrixQueryVariables = {
  id: Scalars['SellableId']
};


export type VariationMatrixQuery = (
  { __typename: 'Query' }
  & { sellable: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id'>
    & { variationMatrix: Maybe<(
      { __typename: 'VariationMatrix' }
      & VariationMatrixFragment
    )> }
  ) }
);

export type LandingPageExpertCardFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'vanityId' | 'active' | 'displayName' | 'shortName'>
  & { expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id' | 'background'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )>, highlights: Array<(
      { __typename: 'ProfileHighlight' }
      & Pick<ProfileHighlight, 'secondaryValue' | 'value'>
    )> }
  )>, expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & Pick<ExpertStats, 'averageRating' | 'totalReviews' | 'totalMessagesSent'>
  )> }
);

export type LandingPageExpertsQueryVariables = {
  slug: Scalars['String']
};


export type LandingPageExpertsQuery = (
  { __typename: 'Query' }
  & { categoryBySlug: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id'>
    & { experts: Array<(
      { __typename: 'BusinessUser' }
      & LandingPageExpertCardFragment
    )> }
  )> }
);

export type FeaturedExpertForDepartmentFritosFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
  & { expertAttributes: (
    { __typename: 'BusinessUserExpertAttributes' }
    & { category: (
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'singularDisplayName'>
    ) }
  ), expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & Pick<MediaFile, 'id' | 'url'>
    )> }
  )> }
);

export type FeaturedExpertsForDepartmentFritosQueryVariables = {
  query: ExpertSearchQuery
};


export type FeaturedExpertsForDepartmentFritosQuery = (
  { __typename: 'Query' }
  & { expertSearchConnection: (
    { __typename: 'ExpertSearchConnection' }
    & { edges: Array<(
      { __typename: 'ExpertSearchEdge' }
      & Pick<ExpertSearchEdge, 'cursor'>
      & { node: (
        { __typename: 'BusinessUser' }
        & FeaturedExpertForDepartmentFritosFragment
      ) }
    )> }
  ) }
);

export type KeystoneExpertsQueryVariables = {
  slug: Scalars['String']
};


export type KeystoneExpertsQuery = (
  { __typename: 'Query' }
  & { categoryBySlug: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id'>
    & { experts: Array<(
      { __typename: 'BusinessUser' }
      & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
      & { expertProfile: Maybe<(
        { __typename: 'ExpertProfile' }
        & Pick<ExpertProfile, 'id' | 'headline'>
        & { profilePhoto: Maybe<(
          { __typename: 'MediaFile' }
          & MediaFileFragment
        )> }
      )> }
    )> }
  )> }
);

export type SearchSellablesLandingQueryVariables = {
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  type?: Maybe<SellableType>,
  facets?: Maybe<Array<FacetSelection>>
};


export type SearchSellablesLandingQuery = (
  { __typename: 'Query' }
  & { searchSellables: (
    { __typename: 'SellableSearchConnection' }
    & Pick<SellableSearchConnection, 'count'>
    & { facets: Array<(
      { __typename: 'BucketedDisplayFacet' }
      & DisplayFacetBucketedDisplayFacetFragment
    ) | (
      { __typename: 'BucketedRangeDisplayFacet' }
      & DisplayFacetBucketedRangeDisplayFacetFragment
    ) | (
      { __typename: 'NumericRangeDisplayFacet' }
      & DisplayFacetNumericRangeDisplayFacetFragment
    )> }
  ) }
);

export type BusinessUserChatWidgetQueryVariables = {
  id: Scalars['BusinessUserId']
};


export type BusinessUserChatWidgetQuery = (
  { __typename: 'Query' }
  & { businessUser: (
    { __typename: 'BusinessUser' }
    & { existingLeadForConsumer: Maybe<(
      { __typename: 'Lead' }
      & Pick<Lead, 'id'>
      & { conversation: (
        { __typename: 'Conversation' }
        & Pick<Conversation, 'id' | 'externalId'>
      ) }
    )> }
    & ChatWidgetExpertFragment
  ) }
);

export type GetShoppingCartQueryVariables = {
  id: Scalars['OrderId']
};


export type GetShoppingCartQuery = (
  { __typename: 'Query' }
  & { order: (
    { __typename: 'Order' }
    & ShoppingCartOrderFragment
  ) }
);

export type ShoppingCartSubscriptionVariables = {
  userId?: Maybe<Scalars['UserId']>
};


export type ShoppingCartSubscription = (
  { __typename: 'Subscription' }
  & { userCartLineItemsChanged: (
    { __typename: 'Order' }
    & ShoppingCartOrderFragment
  ) }
);

export type SyncShoppingCartMutationVariables = {};


export type SyncShoppingCartMutation = (
  { __typename: 'Mutation' }
  & { syncOrder: (
    { __typename: 'SyncOrderPayload' }
    & { order: (
      { __typename: 'Order' }
      & ShoppingCartOrderFragment
    ) }
  ) }
);

export type RecommendExpert2QueryVariables = {
  consumerId: Scalars['UserId'],
  categoryId: Scalars['CategoryId']
};


export type RecommendExpert2Query = (
  { __typename: 'Query' }
  & { recommendExpert2: (
    { __typename: 'RecommendExpertPayload' }
    & { expert: Maybe<(
      { __typename: 'BusinessUser' }
      & { existingLeadForConsumer: Maybe<(
        { __typename: 'Lead' }
        & Pick<Lead, 'id'>
        & { conversation: (
          { __typename: 'Conversation' }
          & Pick<Conversation, 'id' | 'externalId'>
        ) }
      )> }
      & ChatWidgetExpertFragment
    )> }
  ) }
);

export type GetMessagingUsersQueryVariables = {
  ids: Array<Scalars['AnyId']>
};


export type GetMessagingUsersQuery = (
  { __typename: 'Query' }
  & { messagingUsers: Array<(
    { __typename: 'MessagingUser' }
    & Pick<MessagingUser, 'id' | 'displayName' | 'type'>
    & { avatar: Maybe<(
      { __typename: 'MediaFile' }
      & Pick<MediaFile, 'id' | 'url'>
    )>, profile: { __typename: 'User' } | { __typename: 'Merchant' } | { __typename: 'Operator' } | (
      { __typename: 'BusinessUser' }
      & Pick<BusinessUser, 'id' | 'vanityId'>
      & { expertStats: Maybe<(
        { __typename: 'ExpertStats' }
        & Pick<ExpertStats, 'averageRating'>
      )> }
    ) | { __typename: 'InternalMessagingUser' } | { __typename: 'OnboardingSpecialistUser' } | { __typename: 'SupportMessagingUser' } }
  )> }
);

export type ChatWidgetExpertFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
  & { assignedSmsAddress: BusinessUser['assignedAddress'], assignedEmailAddress: BusinessUser['assignedAddress'] }
  & { messagingUser: (
    { __typename: 'MessagingUser' }
    & Pick<MessagingUser, 'id'>
  ), expertAttributes: (
    { __typename: 'BusinessUserExpertAttributes' }
    & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>
  ), expertPresence: (
    { __typename: 'ExpertPresenceAway' }
    & Pick<ExpertPresenceAway, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOffShift' }
    & Pick<ExpertPresenceOffShift, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOnCall' }
    & Pick<ExpertPresenceOnCall, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOnShift' }
    & Pick<ExpertPresenceOnShift, 'status'>
  ), expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id' | 'headline'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )>, highlights: Array<(
      { __typename: 'ProfileHighlight' }
      & Pick<ProfileHighlight, 'secondaryValue' | 'value'>
      & { type: (
        { __typename: 'ProfileHighlightType' }
        & Pick<ProfileHighlightType, 'id' | 'icon'>
      ) }
    )> }
  )>, expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & Pick<ExpertStats, 'averageRating' | 'totalMessagesSent' | 'totalReviews'>
  )> }
);

export type ContentfulImageDataFragment = (
  { __typename: 'ContentAsset' }
  & Pick<ContentAsset, 'mimeType' | 'title' | 'imageUrl'>
);

type RawContentTypesContentBooleanValueFragment = (
  { __typename: 'ContentBooleanValue' }
  & Pick<ContentBooleanValue, 'booleanValue'>
);

type RawContentTypesContentStringValueFragment = (
  { __typename: 'ContentStringValue' }
  & Pick<ContentStringValue, 'stringValue'>
);

type RawContentTypesContentIntValueFragment = (
  { __typename: 'ContentIntValue' }
  & Pick<ContentIntValue, 'intValue'>
);

type RawContentTypesContentFloatValueFragment = (
  { __typename: 'ContentFloatValue' }
  & Pick<ContentFloatValue, 'floatValue'>
);

type RawContentTypesContentAssetFragment = (
  { __typename: 'ContentAsset' }
  & ContentfulImageDataFragment
);

type RawContentTypesContentValueArrayFragment = { __typename: 'ContentValueArray' };

type RawContentTypesContentObjectFragment = { __typename: 'ContentObject' };

export type RawContentTypesFragment = RawContentTypesContentBooleanValueFragment | RawContentTypesContentStringValueFragment | RawContentTypesContentIntValueFragment | RawContentTypesContentFloatValueFragment | RawContentTypesContentAssetFragment | RawContentTypesContentValueArrayFragment | RawContentTypesContentObjectFragment;

type ContentTypesContentBooleanValueFragment = (
  { __typename: 'ContentBooleanValue' }
  & RawContentTypesContentBooleanValueFragment
);

type ContentTypesContentStringValueFragment = (
  { __typename: 'ContentStringValue' }
  & RawContentTypesContentStringValueFragment
);

type ContentTypesContentIntValueFragment = (
  { __typename: 'ContentIntValue' }
  & RawContentTypesContentIntValueFragment
);

type ContentTypesContentFloatValueFragment = (
  { __typename: 'ContentFloatValue' }
  & RawContentTypesContentFloatValueFragment
);

type ContentTypesContentAssetFragment = (
  { __typename: 'ContentAsset' }
  & RawContentTypesContentAssetFragment
);

type ContentTypesContentValueArrayFragment = (
  { __typename: 'ContentValueArray' }
  & { values: Array<(
    { __typename: 'ContentBooleanValue' }
    & RawContentTypesContentBooleanValueFragment
  ) | (
    { __typename: 'ContentStringValue' }
    & RawContentTypesContentStringValueFragment
  ) | (
    { __typename: 'ContentIntValue' }
    & RawContentTypesContentIntValueFragment
  ) | (
    { __typename: 'ContentFloatValue' }
    & RawContentTypesContentFloatValueFragment
  ) | (
    { __typename: 'ContentAsset' }
    & RawContentTypesContentAssetFragment
  ) | (
    { __typename: 'ContentValueArray' }
    & RawContentTypesContentValueArrayFragment
  ) | (
    { __typename: 'ContentObject' }
    & { entries: Array<(
      { __typename: 'ContentObjectEntry' }
      & Pick<ContentObjectEntry, 'key'>
      & { value: (
        { __typename: 'ContentBooleanValue' }
        & RawContentTypesContentBooleanValueFragment
      ) | (
        { __typename: 'ContentStringValue' }
        & RawContentTypesContentStringValueFragment
      ) | (
        { __typename: 'ContentIntValue' }
        & RawContentTypesContentIntValueFragment
      ) | (
        { __typename: 'ContentFloatValue' }
        & RawContentTypesContentFloatValueFragment
      ) | (
        { __typename: 'ContentAsset' }
        & RawContentTypesContentAssetFragment
      ) | (
        { __typename: 'ContentValueArray' }
        & { values: Array<(
          { __typename: 'ContentBooleanValue' }
          & RawContentTypesContentBooleanValueFragment
        ) | (
          { __typename: 'ContentStringValue' }
          & RawContentTypesContentStringValueFragment
        ) | (
          { __typename: 'ContentIntValue' }
          & RawContentTypesContentIntValueFragment
        ) | (
          { __typename: 'ContentFloatValue' }
          & RawContentTypesContentFloatValueFragment
        ) | (
          { __typename: 'ContentAsset' }
          & RawContentTypesContentAssetFragment
        ) | (
          { __typename: 'ContentValueArray' }
          & RawContentTypesContentValueArrayFragment
        ) | (
          { __typename: 'ContentObject' }
          & { entries: Array<(
            { __typename: 'ContentObjectEntry' }
            & Pick<ContentObjectEntry, 'key'>
            & { value: (
              { __typename: 'ContentBooleanValue' }
              & RawContentTypesContentBooleanValueFragment
            ) | (
              { __typename: 'ContentStringValue' }
              & RawContentTypesContentStringValueFragment
            ) | (
              { __typename: 'ContentIntValue' }
              & RawContentTypesContentIntValueFragment
            ) | (
              { __typename: 'ContentFloatValue' }
              & RawContentTypesContentFloatValueFragment
            ) | (
              { __typename: 'ContentAsset' }
              & RawContentTypesContentAssetFragment
            ) | (
              { __typename: 'ContentValueArray' }
              & { values: Array<(
                { __typename: 'ContentBooleanValue' }
                & RawContentTypesContentBooleanValueFragment
              ) | (
                { __typename: 'ContentStringValue' }
                & RawContentTypesContentStringValueFragment
              ) | (
                { __typename: 'ContentIntValue' }
                & RawContentTypesContentIntValueFragment
              ) | (
                { __typename: 'ContentFloatValue' }
                & RawContentTypesContentFloatValueFragment
              ) | (
                { __typename: 'ContentAsset' }
                & RawContentTypesContentAssetFragment
              ) | (
                { __typename: 'ContentValueArray' }
                & RawContentTypesContentValueArrayFragment
              ) | (
                { __typename: 'ContentObject' }
                & { entries: Array<(
                  { __typename: 'ContentObjectEntry' }
                  & Pick<ContentObjectEntry, 'key'>
                  & { value: (
                    { __typename: 'ContentBooleanValue' }
                    & RawContentTypesContentBooleanValueFragment
                  ) | (
                    { __typename: 'ContentStringValue' }
                    & RawContentTypesContentStringValueFragment
                  ) | (
                    { __typename: 'ContentIntValue' }
                    & RawContentTypesContentIntValueFragment
                  ) | (
                    { __typename: 'ContentFloatValue' }
                    & RawContentTypesContentFloatValueFragment
                  ) | (
                    { __typename: 'ContentAsset' }
                    & RawContentTypesContentAssetFragment
                  ) | (
                    { __typename: 'ContentValueArray' }
                    & { values: Array<(
                      { __typename: 'ContentBooleanValue' }
                      & RawContentTypesContentBooleanValueFragment
                    ) | (
                      { __typename: 'ContentStringValue' }
                      & RawContentTypesContentStringValueFragment
                    ) | (
                      { __typename: 'ContentIntValue' }
                      & RawContentTypesContentIntValueFragment
                    ) | (
                      { __typename: 'ContentFloatValue' }
                      & RawContentTypesContentFloatValueFragment
                    ) | (
                      { __typename: 'ContentAsset' }
                      & RawContentTypesContentAssetFragment
                    ) | (
                      { __typename: 'ContentValueArray' }
                      & RawContentTypesContentValueArrayFragment
                    ) | (
                      { __typename: 'ContentObject' }
                      & RawContentTypesContentObjectFragment
                    )> }
                    & RawContentTypesContentValueArrayFragment
                  ) | (
                    { __typename: 'ContentObject' }
                    & RawContentTypesContentObjectFragment
                  ) }
                )> }
                & RawContentTypesContentObjectFragment
              )> }
              & RawContentTypesContentValueArrayFragment
            ) | (
              { __typename: 'ContentObject' }
              & RawContentTypesContentObjectFragment
            ) }
          )> }
          & RawContentTypesContentObjectFragment
        )> }
        & RawContentTypesContentValueArrayFragment
      ) | (
        { __typename: 'ContentObject' }
        & { entries: Array<(
          { __typename: 'ContentObjectEntry' }
          & Pick<ContentObjectEntry, 'key'>
          & { value: (
            { __typename: 'ContentBooleanValue' }
            & RawContentTypesContentBooleanValueFragment
          ) | (
            { __typename: 'ContentStringValue' }
            & RawContentTypesContentStringValueFragment
          ) | (
            { __typename: 'ContentIntValue' }
            & RawContentTypesContentIntValueFragment
          ) | (
            { __typename: 'ContentFloatValue' }
            & RawContentTypesContentFloatValueFragment
          ) | (
            { __typename: 'ContentAsset' }
            & RawContentTypesContentAssetFragment
          ) | (
            { __typename: 'ContentValueArray' }
            & { values: Array<(
              { __typename: 'ContentBooleanValue' }
              & RawContentTypesContentBooleanValueFragment
            ) | (
              { __typename: 'ContentStringValue' }
              & RawContentTypesContentStringValueFragment
            ) | (
              { __typename: 'ContentIntValue' }
              & RawContentTypesContentIntValueFragment
            ) | (
              { __typename: 'ContentFloatValue' }
              & RawContentTypesContentFloatValueFragment
            ) | (
              { __typename: 'ContentAsset' }
              & RawContentTypesContentAssetFragment
            ) | (
              { __typename: 'ContentValueArray' }
              & RawContentTypesContentValueArrayFragment
            ) | (
              { __typename: 'ContentObject' }
              & { entries: Array<(
                { __typename: 'ContentObjectEntry' }
                & Pick<ContentObjectEntry, 'key'>
                & { value: (
                  { __typename: 'ContentBooleanValue' }
                  & RawContentTypesContentBooleanValueFragment
                ) | (
                  { __typename: 'ContentStringValue' }
                  & RawContentTypesContentStringValueFragment
                ) | (
                  { __typename: 'ContentIntValue' }
                  & RawContentTypesContentIntValueFragment
                ) | (
                  { __typename: 'ContentFloatValue' }
                  & RawContentTypesContentFloatValueFragment
                ) | (
                  { __typename: 'ContentAsset' }
                  & RawContentTypesContentAssetFragment
                ) | (
                  { __typename: 'ContentValueArray' }
                  & { values: Array<(
                    { __typename: 'ContentBooleanValue' }
                    & RawContentTypesContentBooleanValueFragment
                  ) | (
                    { __typename: 'ContentStringValue' }
                    & RawContentTypesContentStringValueFragment
                  ) | (
                    { __typename: 'ContentIntValue' }
                    & RawContentTypesContentIntValueFragment
                  ) | (
                    { __typename: 'ContentFloatValue' }
                    & RawContentTypesContentFloatValueFragment
                  ) | (
                    { __typename: 'ContentAsset' }
                    & RawContentTypesContentAssetFragment
                  ) | (
                    { __typename: 'ContentValueArray' }
                    & RawContentTypesContentValueArrayFragment
                  ) | (
                    { __typename: 'ContentObject' }
                    & RawContentTypesContentObjectFragment
                  )> }
                  & RawContentTypesContentValueArrayFragment
                ) | (
                  { __typename: 'ContentObject' }
                  & RawContentTypesContentObjectFragment
                ) }
              )> }
              & RawContentTypesContentObjectFragment
            )> }
            & RawContentTypesContentValueArrayFragment
          ) | (
            { __typename: 'ContentObject' }
            & RawContentTypesContentObjectFragment
          ) }
        )> }
        & RawContentTypesContentObjectFragment
      ) }
    )> }
    & RawContentTypesContentObjectFragment
  )> }
  & RawContentTypesContentValueArrayFragment
);

type ContentTypesContentObjectFragment = (
  { __typename: 'ContentObject' }
  & { entries: Array<(
    { __typename: 'ContentObjectEntry' }
    & Pick<ContentObjectEntry, 'key'>
    & { value: (
      { __typename: 'ContentBooleanValue' }
      & RawContentTypesContentBooleanValueFragment
    ) | (
      { __typename: 'ContentStringValue' }
      & RawContentTypesContentStringValueFragment
    ) | (
      { __typename: 'ContentIntValue' }
      & RawContentTypesContentIntValueFragment
    ) | (
      { __typename: 'ContentFloatValue' }
      & RawContentTypesContentFloatValueFragment
    ) | (
      { __typename: 'ContentAsset' }
      & RawContentTypesContentAssetFragment
    ) | (
      { __typename: 'ContentValueArray' }
      & { values: Array<(
        { __typename: 'ContentBooleanValue' }
        & RawContentTypesContentBooleanValueFragment
      ) | (
        { __typename: 'ContentStringValue' }
        & RawContentTypesContentStringValueFragment
      ) | (
        { __typename: 'ContentIntValue' }
        & RawContentTypesContentIntValueFragment
      ) | (
        { __typename: 'ContentFloatValue' }
        & RawContentTypesContentFloatValueFragment
      ) | (
        { __typename: 'ContentAsset' }
        & RawContentTypesContentAssetFragment
      ) | (
        { __typename: 'ContentValueArray' }
        & RawContentTypesContentValueArrayFragment
      ) | (
        { __typename: 'ContentObject' }
        & { entries: Array<(
          { __typename: 'ContentObjectEntry' }
          & Pick<ContentObjectEntry, 'key'>
          & { value: (
            { __typename: 'ContentBooleanValue' }
            & RawContentTypesContentBooleanValueFragment
          ) | (
            { __typename: 'ContentStringValue' }
            & RawContentTypesContentStringValueFragment
          ) | (
            { __typename: 'ContentIntValue' }
            & RawContentTypesContentIntValueFragment
          ) | (
            { __typename: 'ContentFloatValue' }
            & RawContentTypesContentFloatValueFragment
          ) | (
            { __typename: 'ContentAsset' }
            & RawContentTypesContentAssetFragment
          ) | (
            { __typename: 'ContentValueArray' }
            & { values: Array<(
              { __typename: 'ContentBooleanValue' }
              & RawContentTypesContentBooleanValueFragment
            ) | (
              { __typename: 'ContentStringValue' }
              & RawContentTypesContentStringValueFragment
            ) | (
              { __typename: 'ContentIntValue' }
              & RawContentTypesContentIntValueFragment
            ) | (
              { __typename: 'ContentFloatValue' }
              & RawContentTypesContentFloatValueFragment
            ) | (
              { __typename: 'ContentAsset' }
              & RawContentTypesContentAssetFragment
            ) | (
              { __typename: 'ContentValueArray' }
              & RawContentTypesContentValueArrayFragment
            ) | (
              { __typename: 'ContentObject' }
              & { entries: Array<(
                { __typename: 'ContentObjectEntry' }
                & Pick<ContentObjectEntry, 'key'>
                & { value: (
                  { __typename: 'ContentBooleanValue' }
                  & RawContentTypesContentBooleanValueFragment
                ) | (
                  { __typename: 'ContentStringValue' }
                  & RawContentTypesContentStringValueFragment
                ) | (
                  { __typename: 'ContentIntValue' }
                  & RawContentTypesContentIntValueFragment
                ) | (
                  { __typename: 'ContentFloatValue' }
                  & RawContentTypesContentFloatValueFragment
                ) | (
                  { __typename: 'ContentAsset' }
                  & RawContentTypesContentAssetFragment
                ) | (
                  { __typename: 'ContentValueArray' }
                  & { values: Array<(
                    { __typename: 'ContentBooleanValue' }
                    & RawContentTypesContentBooleanValueFragment
                  ) | (
                    { __typename: 'ContentStringValue' }
                    & RawContentTypesContentStringValueFragment
                  ) | (
                    { __typename: 'ContentIntValue' }
                    & RawContentTypesContentIntValueFragment
                  ) | (
                    { __typename: 'ContentFloatValue' }
                    & RawContentTypesContentFloatValueFragment
                  ) | (
                    { __typename: 'ContentAsset' }
                    & RawContentTypesContentAssetFragment
                  ) | (
                    { __typename: 'ContentValueArray' }
                    & RawContentTypesContentValueArrayFragment
                  ) | (
                    { __typename: 'ContentObject' }
                    & RawContentTypesContentObjectFragment
                  )> }
                  & RawContentTypesContentValueArrayFragment
                ) | (
                  { __typename: 'ContentObject' }
                  & { entries: Array<(
                    { __typename: 'ContentObjectEntry' }
                    & Pick<ContentObjectEntry, 'key'>
                    & { value: (
                      { __typename: 'ContentBooleanValue' }
                      & RawContentTypesContentBooleanValueFragment
                    ) | (
                      { __typename: 'ContentStringValue' }
                      & RawContentTypesContentStringValueFragment
                    ) | (
                      { __typename: 'ContentIntValue' }
                      & RawContentTypesContentIntValueFragment
                    ) | (
                      { __typename: 'ContentFloatValue' }
                      & RawContentTypesContentFloatValueFragment
                    ) | (
                      { __typename: 'ContentAsset' }
                      & RawContentTypesContentAssetFragment
                    ) | (
                      { __typename: 'ContentValueArray' }
                      & { values: Array<(
                        { __typename: 'ContentBooleanValue' }
                        & RawContentTypesContentBooleanValueFragment
                      ) | (
                        { __typename: 'ContentStringValue' }
                        & RawContentTypesContentStringValueFragment
                      ) | (
                        { __typename: 'ContentIntValue' }
                        & RawContentTypesContentIntValueFragment
                      ) | (
                        { __typename: 'ContentFloatValue' }
                        & RawContentTypesContentFloatValueFragment
                      ) | (
                        { __typename: 'ContentAsset' }
                        & RawContentTypesContentAssetFragment
                      ) | (
                        { __typename: 'ContentValueArray' }
                        & RawContentTypesContentValueArrayFragment
                      ) | (
                        { __typename: 'ContentObject' }
                        & { entries: Array<(
                          { __typename: 'ContentObjectEntry' }
                          & Pick<ContentObjectEntry, 'key'>
                          & { value: (
                            { __typename: 'ContentBooleanValue' }
                            & RawContentTypesContentBooleanValueFragment
                          ) | (
                            { __typename: 'ContentStringValue' }
                            & RawContentTypesContentStringValueFragment
                          ) | (
                            { __typename: 'ContentIntValue' }
                            & RawContentTypesContentIntValueFragment
                          ) | (
                            { __typename: 'ContentFloatValue' }
                            & RawContentTypesContentFloatValueFragment
                          ) | (
                            { __typename: 'ContentAsset' }
                            & RawContentTypesContentAssetFragment
                          ) | (
                            { __typename: 'ContentValueArray' }
                            & RawContentTypesContentValueArrayFragment
                          ) | (
                            { __typename: 'ContentObject' }
                            & RawContentTypesContentObjectFragment
                          ) }
                        )> }
                        & RawContentTypesContentObjectFragment
                      )> }
                      & RawContentTypesContentValueArrayFragment
                    ) | (
                      { __typename: 'ContentObject' }
                      & RawContentTypesContentObjectFragment
                    ) }
                  )> }
                  & RawContentTypesContentObjectFragment
                ) }
              )> }
              & RawContentTypesContentObjectFragment
            )> }
            & RawContentTypesContentValueArrayFragment
          ) | (
            { __typename: 'ContentObject' }
            & RawContentTypesContentObjectFragment
          ) }
        )> }
        & RawContentTypesContentObjectFragment
      )> }
      & RawContentTypesContentValueArrayFragment
    ) | (
      { __typename: 'ContentObject' }
      & { entries: Array<(
        { __typename: 'ContentObjectEntry' }
        & Pick<ContentObjectEntry, 'key'>
        & { value: (
          { __typename: 'ContentBooleanValue' }
          & RawContentTypesContentBooleanValueFragment
        ) | (
          { __typename: 'ContentStringValue' }
          & RawContentTypesContentStringValueFragment
        ) | (
          { __typename: 'ContentIntValue' }
          & RawContentTypesContentIntValueFragment
        ) | (
          { __typename: 'ContentFloatValue' }
          & RawContentTypesContentFloatValueFragment
        ) | (
          { __typename: 'ContentAsset' }
          & RawContentTypesContentAssetFragment
        ) | (
          { __typename: 'ContentValueArray' }
          & { values: Array<(
            { __typename: 'ContentBooleanValue' }
            & RawContentTypesContentBooleanValueFragment
          ) | (
            { __typename: 'ContentStringValue' }
            & RawContentTypesContentStringValueFragment
          ) | (
            { __typename: 'ContentIntValue' }
            & RawContentTypesContentIntValueFragment
          ) | (
            { __typename: 'ContentFloatValue' }
            & RawContentTypesContentFloatValueFragment
          ) | (
            { __typename: 'ContentAsset' }
            & RawContentTypesContentAssetFragment
          ) | (
            { __typename: 'ContentValueArray' }
            & RawContentTypesContentValueArrayFragment
          ) | (
            { __typename: 'ContentObject' }
            & { entries: Array<(
              { __typename: 'ContentObjectEntry' }
              & Pick<ContentObjectEntry, 'key'>
              & { value: (
                { __typename: 'ContentBooleanValue' }
                & RawContentTypesContentBooleanValueFragment
              ) | (
                { __typename: 'ContentStringValue' }
                & RawContentTypesContentStringValueFragment
              ) | (
                { __typename: 'ContentIntValue' }
                & RawContentTypesContentIntValueFragment
              ) | (
                { __typename: 'ContentFloatValue' }
                & RawContentTypesContentFloatValueFragment
              ) | (
                { __typename: 'ContentAsset' }
                & RawContentTypesContentAssetFragment
              ) | (
                { __typename: 'ContentValueArray' }
                & { values: Array<(
                  { __typename: 'ContentBooleanValue' }
                  & RawContentTypesContentBooleanValueFragment
                ) | (
                  { __typename: 'ContentStringValue' }
                  & RawContentTypesContentStringValueFragment
                ) | (
                  { __typename: 'ContentIntValue' }
                  & RawContentTypesContentIntValueFragment
                ) | (
                  { __typename: 'ContentFloatValue' }
                  & RawContentTypesContentFloatValueFragment
                ) | (
                  { __typename: 'ContentAsset' }
                  & RawContentTypesContentAssetFragment
                ) | (
                  { __typename: 'ContentValueArray' }
                  & RawContentTypesContentValueArrayFragment
                ) | (
                  { __typename: 'ContentObject' }
                  & { entries: Array<(
                    { __typename: 'ContentObjectEntry' }
                    & Pick<ContentObjectEntry, 'key'>
                    & { value: (
                      { __typename: 'ContentBooleanValue' }
                      & RawContentTypesContentBooleanValueFragment
                    ) | (
                      { __typename: 'ContentStringValue' }
                      & RawContentTypesContentStringValueFragment
                    ) | (
                      { __typename: 'ContentIntValue' }
                      & RawContentTypesContentIntValueFragment
                    ) | (
                      { __typename: 'ContentFloatValue' }
                      & RawContentTypesContentFloatValueFragment
                    ) | (
                      { __typename: 'ContentAsset' }
                      & RawContentTypesContentAssetFragment
                    ) | (
                      { __typename: 'ContentValueArray' }
                      & { values: Array<(
                        { __typename: 'ContentBooleanValue' }
                        & RawContentTypesContentBooleanValueFragment
                      ) | (
                        { __typename: 'ContentStringValue' }
                        & RawContentTypesContentStringValueFragment
                      ) | (
                        { __typename: 'ContentIntValue' }
                        & RawContentTypesContentIntValueFragment
                      ) | (
                        { __typename: 'ContentFloatValue' }
                        & RawContentTypesContentFloatValueFragment
                      ) | (
                        { __typename: 'ContentAsset' }
                        & RawContentTypesContentAssetFragment
                      ) | (
                        { __typename: 'ContentValueArray' }
                        & RawContentTypesContentValueArrayFragment
                      ) | (
                        { __typename: 'ContentObject' }
                        & RawContentTypesContentObjectFragment
                      )> }
                      & RawContentTypesContentValueArrayFragment
                    ) | (
                      { __typename: 'ContentObject' }
                      & { entries: Array<(
                        { __typename: 'ContentObjectEntry' }
                        & Pick<ContentObjectEntry, 'key'>
                        & { value: (
                          { __typename: 'ContentBooleanValue' }
                          & RawContentTypesContentBooleanValueFragment
                        ) | (
                          { __typename: 'ContentStringValue' }
                          & RawContentTypesContentStringValueFragment
                        ) | (
                          { __typename: 'ContentIntValue' }
                          & RawContentTypesContentIntValueFragment
                        ) | (
                          { __typename: 'ContentFloatValue' }
                          & RawContentTypesContentFloatValueFragment
                        ) | (
                          { __typename: 'ContentAsset' }
                          & RawContentTypesContentAssetFragment
                        ) | (
                          { __typename: 'ContentValueArray' }
                          & RawContentTypesContentValueArrayFragment
                        ) | (
                          { __typename: 'ContentObject' }
                          & RawContentTypesContentObjectFragment
                        ) }
                      )> }
                      & RawContentTypesContentObjectFragment
                    ) }
                  )> }
                  & RawContentTypesContentObjectFragment
                )> }
                & RawContentTypesContentValueArrayFragment
              ) | (
                { __typename: 'ContentObject' }
                & RawContentTypesContentObjectFragment
              ) }
            )> }
            & RawContentTypesContentObjectFragment
          )> }
          & RawContentTypesContentValueArrayFragment
        ) | (
          { __typename: 'ContentObject' }
          & RawContentTypesContentObjectFragment
        ) }
      )> }
      & RawContentTypesContentObjectFragment
    ) }
  )> }
  & RawContentTypesContentObjectFragment
);

export type ContentTypesFragment = ContentTypesContentBooleanValueFragment | ContentTypesContentStringValueFragment | ContentTypesContentIntValueFragment | ContentTypesContentFloatValueFragment | ContentTypesContentAssetFragment | ContentTypesContentValueArrayFragment | ContentTypesContentObjectFragment;

export type ContentfulByVariationQueryVariables = {
  template: Scalars['String'],
  variation: Scalars['String'],
  space?: Maybe<Scalars['String']>
};


export type ContentfulByVariationQuery = (
  { __typename: 'Query' }
  & { findContentByTemplate: Maybe<(
    { __typename: 'ContentObject' }
    & { entries: Array<(
      { __typename: 'ContentObjectEntry' }
      & Pick<ContentObjectEntry, 'key'>
      & { value: (
        { __typename: 'ContentBooleanValue' }
        & ContentTypesContentBooleanValueFragment
      ) | (
        { __typename: 'ContentStringValue' }
        & ContentTypesContentStringValueFragment
      ) | (
        { __typename: 'ContentIntValue' }
        & ContentTypesContentIntValueFragment
      ) | (
        { __typename: 'ContentFloatValue' }
        & ContentTypesContentFloatValueFragment
      ) | (
        { __typename: 'ContentAsset' }
        & ContentTypesContentAssetFragment
      ) | (
        { __typename: 'ContentValueArray' }
        & ContentTypesContentValueArrayFragment
      ) | (
        { __typename: 'ContentObject' }
        & ContentTypesContentObjectFragment
      ) }
    )> }
  )> }
);

export type RealUserFragment = (
  { __typename: 'User' }
  & Pick<User, 'id' | 'firstName' | 'lastName'>
  & { assignedOperatorSeat: Maybe<(
    { __typename: 'Operator' }
    & Pick<Operator, 'id'>
  )> }
);

export type MyselfFragment = (
  { __typename: 'Myself' }
  & Pick<Myself, 'id' | 'hasPassword'>
  & { user: (
    { __typename: 'User' }
    & Pick<User, 'isAllowedToRefer' | 'referralCode' | 'referral'>
    & { mostRecentLead: Maybe<(
      { __typename: 'Lead' }
      & Pick<Lead, 'id' | 'createdAt'>
      & { category: Maybe<(
        { __typename: 'Category' }
        & Pick<Category, 'id'>
        & { department: Maybe<(
          { __typename: 'Department' }
          & DepartmentContextFragment
        )> }
      )> }
    )>, source: Maybe<(
      { __typename: 'UserSource' }
      & { attributes: Array<(
        { __typename: 'UserSourceAttribute' }
        & Pick<UserSourceAttribute, 'name' | 'value'>
      )> }
    )>, assignedBusinessUsers: Array<(
      { __typename: 'BusinessUser' }
      & Pick<BusinessUser, 'id'>
      & { expertProfile: Maybe<(
        { __typename: 'ExpertProfile' }
        & Pick<ExpertProfile, 'id' | 'isDraft'>
      )>, expertApplication: Maybe<(
        { __typename: 'ExpertApplication' }
        & Pick<ExpertApplication, 'id' | 'state'>
      )> }
    )> }
    & AuthenticatedUserFragment
  ), realUser: (
    { __typename: 'User' }
    & RealUserFragment
  ) }
);

export type SessionFragment = (
  { __typename: 'Session' }
  & Pick<Session, 'id' | 'experimentUserId'>
);

export type MyselfQueryVariables = {};


export type MyselfQuery = (
  { __typename: 'Query' }
  & { me: Maybe<(
    { __typename: 'Myself' }
    & MyselfFragment
  )>, session: (
    { __typename: 'Session' }
    & SessionFragment
  ) }
);

export type ConversationFragment = (
  { __typename: 'Conversation' }
  & Pick<Conversation, 'id' | 'externalId'>
);

export type LeadForChatWidgetQueryVariables = {
  leadId: Scalars['LeadId']
};


export type LeadForChatWidgetQuery = (
  { __typename: 'Query' }
  & { lead: Maybe<(
    { __typename: 'Lead' }
    & Pick<Lead, 'id'>
    & { conversation: (
      { __typename: 'Conversation' }
      & ConversationFragment
    ), expert: (
      { __typename: 'BusinessUser' }
      & ChatWidgetExpertFragment
    ) }
  )> }
);

export type DepartmentContextFragment = (
  { __typename: 'Department' }
  & Pick<Department, 'id' | 'type' | 'slug' | 'displayName' | 'acceptingRequests' | 'launched'>
  & { topLevelCategory: (
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'slug' | 'type'>
  ) }
);

export type ActivityFeedSellableFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type' | 'title'>
  & { images: Array<(
    { __typename: 'MediaFile' }
    & MediaFileFragment
  )> }
  & SellablePricingWithDefaultVariantFragment
);

export type AddressFragment = (
  { __typename: 'Address' }
  & Pick<Address, 'id' | 'addresseeName' | 'line1' | 'line2' | 'city' | 'state' | 'country' | 'postalCode' | 'securityCode' | 'phoneNumber' | 'active' | 'isDefault'>
  & { countryDetails: Maybe<(
    { __typename: 'Country' }
    & Pick<Country, 'displayCountry'>
  )> }
);

export type AuthenticatedUserFragment = (
  { __typename: 'User' }
  & Pick<User, 'id' | 'experimentUserId' | 'firstName' | 'lastName' | 'roles'>
  & { profilePhoto: Maybe<(
    { __typename: 'MediaFile' }
    & Pick<MediaFile, 'id' | 'url'>
  )>, messagingUser: (
    { __typename: 'MessagingUser' }
    & Pick<MessagingUser, 'id' | 'notificationChannels' | 'preferredMessagingChannels'>
  ), address: Maybe<(
    { __typename: 'PostalAddress' }
    & Pick<PostalAddress, 'line1' | 'city' | 'state' | 'postalCode' | 'country'>
  )>, savedAddresses: Array<(
    { __typename: 'Address' }
    & AddressFragment
  )>, contacts: Array<(
    { __typename: 'Contact' }
    & Pick<Contact, 'id' | 'type' | 'value' | 'verified' | 'emailAddress' | 'phoneNumber'>
    & { parsedPhoneNumber: Maybe<(
      { __typename: 'ParsedPhoneNumber' }
      & Pick<ParsedPhoneNumber, 'countryCode' | 'regionCode' | 'nationalNumber'>
    )> }
  )> }
);

export type BrandFragment = (
  { __typename: 'Brand' }
  & Pick<Brand, 'id' | 'name' | 'displayName'>
  & { logo: Maybe<(
    { __typename: 'MediaFile' }
    & MediaFileFragment
  )> }
);

export type ConsumerExpertReviewFragment = (
  { __typename: 'ConsumerExpertReview' }
  & Pick<ConsumerExpertReview, 'id' | 'reviewedAt' | 'rating' | 'headline' | 'comments' | 'consumerName'>
  & { expert: (
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
    & { expertProfile: Maybe<(
      { __typename: 'ExpertProfile' }
      & Pick<ExpertProfile, 'id'>
      & { profilePhoto: Maybe<(
        { __typename: 'MediaFile' }
        & MediaFileFragment
      )> }
    )>, expertPresence: (
      { __typename: 'ExpertPresenceAway' }
      & Pick<ExpertPresenceAway, 'status'>
    ) | (
      { __typename: 'ExpertPresenceOffShift' }
      & Pick<ExpertPresenceOffShift, 'status'>
    ) | (
      { __typename: 'ExpertPresenceOnCall' }
      & Pick<ExpertPresenceOnCall, 'status'>
    ) | (
      { __typename: 'ExpertPresenceOnShift' }
      & Pick<ExpertPresenceOnShift, 'status'>
    ) }
  ), verifiedPurchases: Array<(
    { __typename: 'Sellable' }
    & ActivityFeedSellableFragment
  )> }
);

export type ExpertCuratedItemCustomizationFragment = (
  { __typename: 'ExpertCuratedItemCustomization' }
  & Pick<ExpertCuratedItemCustomization, 'createdAt' | 'title'>
  & { sellable: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id' | 'expireAt'>
  ), price: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ) }
);

export type ExpertCuratedItemCategoryFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id' | 'pluralDisplayName' | 'singularDisplayName' | 'slug'>
  & { department: Maybe<(
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'slug'>
  )> }
);

export type ExpertCuratedItemFragment = (
  { __typename: 'ExpertCuratedItem' }
  & Pick<ExpertCuratedItem, 'id' | 'createdAt' | 'priceOverrideValidUntil' | 'rank'>
  & { lead: (
    { __typename: 'Lead' }
    & Pick<Lead, 'id'>
  ), priceOverride: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, createdBy: (
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
    & { expertProfile: Maybe<(
      { __typename: 'ExpertProfile' }
      & Pick<ExpertProfile, 'id'>
      & { profilePhoto: Maybe<(
        { __typename: 'MediaFile' }
        & MediaFileFragment
      )> }
    )> }
  ), tag: Maybe<(
    { __typename: 'ExpertCuratedItemTag' }
    & Pick<ExpertCuratedItemTag, 'type' | 'displayLabel'>
  )>, note: Maybe<(
    { __typename: 'ExpertCuratedItemNote' }
    & Pick<ExpertCuratedItemNote, 'id' | 'text'>
  )>, category: (
    { __typename: 'Category' }
    & ExpertCuratedItemCategoryFragment
  ), sellable: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'active' | 'outOfStock' | 'adHoc' | 'expireAt'>
    & { variants: Array<(
      { __typename: 'SellableFormattedVariant' }
      & Pick<SellableFormattedVariant, 'name' | 'displayName' | 'displayValueHtml'>
    )>, specifications: Array<(
      { __typename: 'SellableSpecification' }
      & Pick<SellableSpecification, 'key' | 'name' | 'valueHtml'>
    )>, parent: Maybe<(
      { __typename: 'Sellable' }
      & Pick<Sellable, 'id'>
      & { savedSellable: Maybe<(
        { __typename: 'SavedSellable' }
        & Pick<SavedSellable, 'id' | 'saved'>
      )> }
      & TrackableSellableFragment
    )> }
    & RecommendedListSellableCardFragment
  ), salePrice: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, lineItemInCart: Maybe<(
    { __typename: 'OrderLineItem' }
    & Pick<OrderLineItem, 'id'>
  )>, customizations: Array<(
    { __typename: 'ExpertCuratedItemCustomization' }
    & ExpertCuratedItemCustomizationFragment
  )> }
);

export type ExpertCuratedItemsByCategoryFragment = (
  { __typename: 'ExpertCuratedItemsByCategory' }
  & Pick<ExpertCuratedItemsByCategory, 'id'>
  & { category: (
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'pluralDisplayName' | 'singularDisplayName' | 'slug'>
    & { department: Maybe<(
      { __typename: 'Department' }
      & Pick<Department, 'id' | 'slug'>
    )> }
  ), items: Array<(
    { __typename: 'ExpertCuratedItem' }
    & ExpertCuratedItemFragment
  )> }
);

export type ExpertCuratedVariationOptionFragment = (
  { __typename: 'ExpertCuratedOrderVariationOption' }
  & Pick<ExpertCuratedOrderVariationOption, 'enabled' | 'selected'>
  & { price: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), sellable: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id' | 'title' | 'descriptionText'>
    & { variants: Array<(
      { __typename: 'SellableFormattedVariant' }
      & Pick<SellableFormattedVariant, 'displayName' | 'value' | 'displayValueHtml'>
    )> }
  ) }
);

export type ExpertCuratedAttributeFragment = (
  { __typename: 'Attribute' }
  & { formatted: Maybe<(
    { __typename: 'FormattedAttribute' }
    & Pick<FormattedAttribute, 'name' | 'displayHtml'>
  )> }
);

export type ExpertCuratedSellableDetailsFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id'>
  & { charterLocation: Maybe<(
    { __typename: 'Attribute' }
    & ExpertCuratedAttributeFragment
  )>, charterLengthFeet: Maybe<(
    { __typename: 'Attribute' }
    & ExpertCuratedAttributeFragment
  )>, charterCabins: Maybe<(
    { __typename: 'Attribute' }
    & ExpertCuratedAttributeFragment
  )>, charterCapacity: Maybe<(
    { __typename: 'Attribute' }
    & ExpertCuratedAttributeFragment
  )>, charterAmenities: Maybe<(
    { __typename: 'Attribute' }
    & ExpertCuratedAttributeFragment
  )>, charterBathrooms: Maybe<(
    { __typename: 'Attribute' }
    & ExpertCuratedAttributeFragment
  )>, aircraftType: Maybe<(
    { __typename: 'Attribute' }
    & ExpertCuratedAttributeFragment
  )>, department: Maybe<(
    { __typename: 'Department' }
    & Pick<Department, 'id'>
    & { mostRecentLeadForConsumer: Maybe<(
      { __typename: 'Lead' }
      & Pick<Lead, 'id'>
    )> }
  )> }
  & SellableDetailsFragment
  & SellablePricingWithDefaultVariantFragment
  & TrackableSellableFragment
);

export type ExpertCuratedOrderLineItemFragment = (
  { __typename: 'OrderLineItem' }
  & Pick<OrderLineItem, 'id' | 'isGroup' | 'title' | 'quantity'>
  & { unitPrice: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), source: (
    { __typename: 'OrderLineItemAdHocSource' }
    & Pick<OrderLineItemAdHocSource, 'type'>
  ) | (
    { __typename: 'OrderLineItemBasePriceSource' }
    & Pick<OrderLineItemBasePriceSource, 'type'>
  ) | (
    { __typename: 'OrderLineItemExpertTipSource' }
    & Pick<OrderLineItemExpertTipSource, 'type'>
  ) | (
    { __typename: 'OrderLineItemGratuitySource' }
    & Pick<OrderLineItemGratuitySource, 'type'>
  ) | (
    { __typename: 'OrderLineItemPrepaidIncidentalSource' }
    & Pick<OrderLineItemPrepaidIncidentalSource, 'type'>
  ) | (
    { __typename: 'OrderLineItemRefundSource' }
    & Pick<OrderLineItemRefundSource, 'type'>
  ) | (
    { __typename: 'OrderLineItemSellableSource' }
    & Pick<OrderLineItemSellableSource, 'type'>
    & { sellable: (
      { __typename: 'Sellable' }
      & ExpertCuratedSellableDetailsFragment
    ) }
  ) | (
    { __typename: 'OrderLineItemShipmentSource' }
    & Pick<OrderLineItemShipmentSource, 'type'>
  ) }
);

export type LeadCuratedOrderFragment = (
  { __typename: 'Lead' }
  & Pick<Lead, 'id'>
  & { conversation: (
    { __typename: 'Conversation' }
    & Pick<Conversation, 'id'>
  ), category: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id'>
    & { contentAssets: (
      { __typename: 'CategoryContentAssets' }
      & { bannerImages: Array<(
        { __typename: 'ContentAsset' }
        & Pick<ContentAsset, 'title' | 'imageUrl'>
      )> }
    ) }
  )>, consumer: (
    { __typename: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName'>
  ), expert: (
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
    & { phoneNumber: BusinessUser['assignedAddress'] }
    & { expertProfile: Maybe<(
      { __typename: 'ExpertProfile' }
      & Pick<ExpertProfile, 'id'>
      & { profilePhoto: Maybe<(
        { __typename: 'MediaFile' }
        & MediaFileFragment
      )> }
    )> }
  ) }
);

export type AirportFragment = (
  { __typename: 'Airport' }
  & Pick<Airport, 'id' | 'zoneId' | 'displayCode'>
);

export type FlightPlanLegFragment = (
  { __typename: 'FlightPlanLeg' }
  & Pick<FlightPlanLeg, 'id' | 'departAt' | 'departOn' | 'arriveAt' | 'durationInMinutes' | 'flightOperator'>
  & { departureAirport: Maybe<(
    { __typename: 'Airport' }
    & AirportFragment
  )>, arrivalAirport: Maybe<(
    { __typename: 'Airport' }
    & AirportFragment
  )> }
);

export type FlightPlanFragment = (
  { __typename: 'FlightPlan' }
  & Pick<FlightPlan, 'id' | 'state'>
  & { legs: Array<(
    { __typename: 'FlightPlanLeg' }
    & FlightPlanLegFragment
  )> }
);

export type ExpertCuratedOrderManualTaxAdjustmentFragment = (
  { __typename: 'ExpertCuratedOrderManualTaxAdjustment' }
  & Pick<ExpertCuratedOrderManualTaxAdjustment, 'taxRate'>
  & { amount: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, computedFromAmount: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )> }
);

export type ExpertCuratedOrderFragment = (
  { __typename: 'ExpertCuratedOrder' }
  & Pick<ExpertCuratedOrder, 'id' | 'state' | 'serviceStartAt' | 'inPreview' | 'expiresAt' | 'taxWillBeAutomaticallyComputed'>
  & { category: (
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'slug'>
  ), serviceLocation: Maybe<(
    { __typename: 'PostalAddress' }
    & Pick<PostalAddress, 'displayTitle'>
  )>, curatedFor: (
    { __typename: 'User' }
    & Pick<User, 'id' | 'firstName'>
  ), items: Array<(
    { __typename: 'ExpertCuratedOrderItem' }
    & Pick<ExpertCuratedOrderItem, 'id'>
  )>, order: (
    { __typename: 'Order' }
    & Pick<Order, 'id' | 'title' | 'description' | 'state'>
    & { primaryImage: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )>, totalCostBeforeTax: (
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    ), tax: (
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    ), totalCost: (
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    ), remainingBalance: (
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    ), minimumDeposit: Maybe<(
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    )>, lineItems: Array<(
      { __typename: 'OrderLineItem' }
      & ExpertCuratedOrderLineItemFragment
    )> }
  ), variationOptions: Array<(
    { __typename: 'ExpertCuratedOrderVariationOption' }
    & ExpertCuratedVariationOptionFragment
  )>, lead: (
    { __typename: 'Lead' }
    & Pick<Lead, 'id'>
    & { category: Maybe<(
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'singularDisplayName'>
      & { department: Maybe<(
        { __typename: 'Department' }
        & DepartmentContextFragment
      )> }
    )> }
    & LeadCuratedOrderFragment
  ), flightPlan: Maybe<(
    { __typename: 'FlightPlan' }
    & FlightPlanFragment
  )>, defaultManualTaxAdjustment: Maybe<(
    { __typename: 'ExpertCuratedOrderManualTaxAdjustment' }
    & ExpertCuratedOrderManualTaxAdjustmentFragment
  )> }
);

export type ExpertProfileHighlightsFragment = (
  { __typename: 'ProfileHighlight' }
  & Pick<ProfileHighlight, 'value' | 'secondaryValue'>
  & { type: (
    { __typename: 'ProfileHighlightType' }
    & Pick<ProfileHighlightType, 'id' | 'icon' | 'displayName'>
  ) }
);

export type ExpertStatsFragment = (
  { __typename: 'ExpertStats' }
  & Pick<ExpertStats, 'topGoodQualities' | 'averageRating' | 'totalMessagesSent' | 'totalLeadsAsPrimaryExpert' | 'totalReviews'>
);

export type BucketedDisplayFacetFragment = (
  { __typename: 'BucketedDisplayFacet' }
  & Pick<BucketedDisplayFacet, 'displayName' | 'name' | 'alias'>
  & { buckets: Array<(
    { __typename: 'IndividualBucketedDisplayFacet' }
    & Pick<IndividualBucketedDisplayFacet, 'displayName' | 'value' | 'count'>
    & { imageMetadata: Maybe<(
      { __typename: 'BackgroundFacetImageMetadata' }
      & Pick<BackgroundFacetImageMetadata, 'type' | 'imageUrl'>
    ) | (
      { __typename: 'IconFacetImageMetadata' }
      & Pick<IconFacetImageMetadata, 'type' | 'imageUrl'>
    )> }
  )> }
);

export type BucketedRangeDisplayFacetFragment = (
  { __typename: 'BucketedRangeDisplayFacet' }
  & Pick<BucketedRangeDisplayFacet, 'displayName' | 'name' | 'alias'>
);

export type NumericRangeDisplayFacetFragment = (
  { __typename: 'NumericRangeDisplayFacet' }
  & Pick<NumericRangeDisplayFacet, 'displayName' | 'name' | 'alias' | 'type' | 'lower' | 'upper' | 'scale' | 'upperCapped'>
);

type DisplayFacetBucketedDisplayFacetFragment = (
  { __typename: 'BucketedDisplayFacet' }
  & BucketedDisplayFacetFragment
);

type DisplayFacetBucketedRangeDisplayFacetFragment = (
  { __typename: 'BucketedRangeDisplayFacet' }
  & BucketedRangeDisplayFacetFragment
);

type DisplayFacetNumericRangeDisplayFacetFragment = (
  { __typename: 'NumericRangeDisplayFacet' }
  & NumericRangeDisplayFacetFragment
);

export type DisplayFacetFragment = DisplayFacetBucketedDisplayFacetFragment | DisplayFacetBucketedRangeDisplayFacetFragment | DisplayFacetNumericRangeDisplayFacetFragment;

export type MediaFileFragment = (
  { __typename: 'MediaFile' }
  & Pick<MediaFile, 'id' | 'url' | 'mimeType' | 'size' | 'persisted'>
);

export type MonetaryAmountFragment = (
  { __typename: 'MonetaryAmount' }
  & Pick<MonetaryAmount, 'currency' | 'amount'>
  & { amountInSmallestDenomination: MonetaryAmount['amount'] }
);

export type OrderMessageFragment = (
  { __typename: 'OrderMessage' }
  & Pick<OrderMessage, 'dismissible' | 'message'>
);

export type TransactionFragment = (
  { __typename: 'Transaction' }
  & Pick<Transaction, 'id' | 'status'>
  & { request: (
    { __typename: 'TransactionRequest' }
    & Pick<TransactionRequest, 'paymentSourceType'>
    & { chargeAmount: (
      { __typename: 'MonetaryAmount' }
      & Pick<MonetaryAmount, 'amount' | 'currency'>
    ) }
  ), response: Maybe<(
    { __typename: 'TransactionResponse' }
    & Pick<TransactionResponse, 'paymentVerificationMethod' | 'errorMessage' | 'userFriendlyErrorMessage'>
    & { paymentSource: Maybe<(
      { __typename: 'AffirmPaymentSource' }
      & PaymentSourceAffirmPaymentSourceFragment
    ) | (
      { __typename: 'AfterpayPaymentSource' }
      & PaymentSourceAfterpayPaymentSourceFragment
    ) | (
      { __typename: 'DealPaymentSource' }
      & PaymentSourceDealPaymentSourceFragment
    ) | (
      { __typename: 'PaypalPaymentSource' }
      & PaymentSourcePaypalPaymentSourceFragment
    ) | (
      { __typename: 'StripePaymentSource' }
      & PaymentSourceStripePaymentSourceFragment
    )> }
  )> }
);

export type WireTransferPaymentEntityFragment = (
  { __typename: 'WireTransferPaymentEntity' }
  & Pick<WireTransferPaymentEntity, 'paymentMethod' | 'accountNumber' | 'bankName' | 'routingNumber' | 'swiftCode'>
  & { chargeableAmount: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ) }
);

export type OrderFragment = (
  { __typename: 'Order' }
  & Pick<Order, 'id' | 'state' | 'createdAt' | 'paidAt' | 'categoryType' | 'requiresShippingAddress' | 'itemsCount'>
  & { user: (
    { __typename: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName'>
  ), tax: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), shippingCost: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), chargingPaymentSource: Maybe<(
    { __typename: 'AffirmPaymentSource' }
    & Pick<AffirmPaymentSource, 'id'>
    & { paymentEntity: { __typename: 'BankCheckPaymentEntity' } | { __typename: 'InstallmentPaymentEntity' } | { __typename: 'Payment3DSecure' } | { __typename: 'PaymentCard' } | { __typename: 'PaypalPaymentEntity' } | (
      { __typename: 'WireTransferPaymentEntity' }
      & WireTransferPaymentEntityFragment
    ) }
  ) | (
    { __typename: 'AfterpayPaymentSource' }
    & Pick<AfterpayPaymentSource, 'id'>
    & { paymentEntity: { __typename: 'BankCheckPaymentEntity' } | { __typename: 'InstallmentPaymentEntity' } | { __typename: 'Payment3DSecure' } | { __typename: 'PaymentCard' } | { __typename: 'PaypalPaymentEntity' } | (
      { __typename: 'WireTransferPaymentEntity' }
      & WireTransferPaymentEntityFragment
    ) }
  ) | (
    { __typename: 'DealPaymentSource' }
    & Pick<DealPaymentSource, 'id'>
    & { paymentEntity: { __typename: 'BankCheckPaymentEntity' } | { __typename: 'InstallmentPaymentEntity' } | { __typename: 'Payment3DSecure' } | { __typename: 'PaymentCard' } | { __typename: 'PaypalPaymentEntity' } | (
      { __typename: 'WireTransferPaymentEntity' }
      & WireTransferPaymentEntityFragment
    ) }
  ) | (
    { __typename: 'PaypalPaymentSource' }
    & Pick<PaypalPaymentSource, 'id'>
    & { paymentEntity: { __typename: 'BankCheckPaymentEntity' } | { __typename: 'InstallmentPaymentEntity' } | { __typename: 'Payment3DSecure' } | { __typename: 'PaymentCard' } | { __typename: 'PaypalPaymentEntity' } | (
      { __typename: 'WireTransferPaymentEntity' }
      & WireTransferPaymentEntityFragment
    ) }
  ) | (
    { __typename: 'StripePaymentSource' }
    & Pick<StripePaymentSource, 'id'>
    & { paymentEntity: { __typename: 'BankCheckPaymentEntity' } | { __typename: 'InstallmentPaymentEntity' } | { __typename: 'Payment3DSecure' } | { __typename: 'PaymentCard' } | { __typename: 'PaypalPaymentEntity' } | (
      { __typename: 'WireTransferPaymentEntity' }
      & WireTransferPaymentEntityFragment
    ) }
  )>, totalCost: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), totalCostBeforeTax: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), subtotal: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), totalCostWithoutTip: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), totalShippingCost: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), tip: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, messages: Array<(
    { __typename: 'OrderMessage' }
    & OrderMessageFragment
  )>, shippingAddress: Maybe<(
    { __typename: 'Address' }
    & AddressFragment
  )>, shipmentTrackings: Maybe<Array<(
    { __typename: 'ShipmentTracking' }
    & ShipmentTrackingFragment
  )>>, transactions: Maybe<Array<(
    { __typename: 'Transaction' }
    & TransactionFragment
  )>>, offer: Maybe<(
    { __typename: 'BroadcastOffer' }
    & Pick<BroadcastOffer, 'id' | 'title' | 'type'>
    & { images: Array<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
  )>, supportedPaymentMethods: Array<(
    { __typename: 'SupportedPaymentMethod' }
    & Pick<SupportedPaymentMethod, 'paymentMethod' | 'paymentProvider'>
  )>, appliedPromotionEntry: Maybe<(
    { __typename: 'OrderPromotionEntry' }
    & Pick<OrderPromotionEntry, 'applied'>
    & { discount: (
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    ), promotion: (
      { __typename: 'Promotion' }
      & Pick<Promotion, 'id' | 'code'>
    ) }
  )> }
);

export type OrderLineItemFragment = (
  { __typename: 'OrderLineItem' }
  & Pick<OrderLineItem, 'id' | 'quantity' | 'isGroup' | 'etaFromMerchant' | 'maxEtaFromMerchant' | 'parentId' | 'title'>
  & { messages: Array<(
    { __typename: 'OrderMessage' }
    & Pick<OrderMessage, 'dismissible' | 'message'>
  )>, price: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), shipmentTracking: Maybe<(
    { __typename: 'ShipmentTracking' }
    & Pick<ShipmentTracking, 'estimatedDeliveryTime' | 'status' | 'trackingUrl'>
  )>, source: (
    { __typename: 'OrderLineItemAdHocSource' }
    & Pick<OrderLineItemAdHocSource, 'type'>
  ) | (
    { __typename: 'OrderLineItemBasePriceSource' }
    & Pick<OrderLineItemBasePriceSource, 'type'>
  ) | (
    { __typename: 'OrderLineItemExpertTipSource' }
    & Pick<OrderLineItemExpertTipSource, 'type'>
    & { amount: (
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    ), expertAmounts: Array<(
      { __typename: 'OrderLineItemExpertTipSourceExpertAmount' }
      & { expert: (
        { __typename: 'BusinessUser' }
        & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
        & { expertProfile: Maybe<(
          { __typename: 'ExpertProfile' }
          & Pick<ExpertProfile, 'id'>
          & { profilePhoto: Maybe<(
            { __typename: 'MediaFile' }
            & Pick<MediaFile, 'id' | 'url'>
          )> }
        )> }
      ) }
    )> }
  ) | (
    { __typename: 'OrderLineItemGratuitySource' }
    & Pick<OrderLineItemGratuitySource, 'type' | 'percentage'>
  ) | (
    { __typename: 'OrderLineItemPrepaidIncidentalSource' }
    & Pick<OrderLineItemPrepaidIncidentalSource, 'type' | 'percentage'>
  ) | (
    { __typename: 'OrderLineItemRefundSource' }
    & Pick<OrderLineItemRefundSource, 'type'>
  ) | (
    { __typename: 'OrderLineItemSellableSource' }
    & Pick<OrderLineItemSellableSource, 'type'>
    & { sellable: (
      { __typename: 'Sellable' }
      & Pick<Sellable, 'id' | 'adHoc' | 'inShortSupply'>
      & { images: Array<(
        { __typename: 'MediaFile' }
        & MediaFileFragment
      )>, variants: Array<(
        { __typename: 'SellableFormattedVariant' }
        & Pick<SellableFormattedVariant, 'name' | 'displayName' | 'value' | 'displayValueHtml'>
      )>, categories: Array<(
        { __typename: 'Category' }
        & Pick<Category, 'id' | 'slug'>
        & { parents: Array<(
          { __typename: 'Category' }
          & Pick<Category, 'id' | 'slug'>
        )> }
      )> }
      & SellableUrlFragment
      & SellablePricingFragment
      & TrackableSellableFragment
    ) }
  ) | (
    { __typename: 'OrderLineItemShipmentSource' }
    & Pick<OrderLineItemShipmentSource, 'type'>
    & { amount: (
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    ) }
  ), unitPrice: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), totalBeforeTax: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ) }
);

export type PageInfoFragment = (
  { __typename: 'PageInfo' }
  & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
);

export type StripePaymentSourceFragment = (
  { __typename: 'StripePaymentSource' }
  & Pick<StripePaymentSource, 'id' | 'createdAt' | 'updatedAt' | 'externalSourceId' | 'type' | 'usage' | 'status' | 'userId' | 'isDefault'>
  & { owner: Maybe<(
    { __typename: 'StripeOwner' }
    & Pick<StripeOwner, 'name' | 'verifiedName'>
  )>, billingAddress: Maybe<(
    { __typename: 'Address' }
    & AddressFragment
  )>, paymentEntity: { __typename: 'BankCheckPaymentEntity' } | { __typename: 'InstallmentPaymentEntity' } | { __typename: 'Payment3DSecure' } | (
    { __typename: 'PaymentCard' }
    & Pick<PaymentCard, 'paymentMethod' | 'last4' | 'brand' | 'threeDSecureVerificationRequired'>
  ) | { __typename: 'PaypalPaymentEntity' } | { __typename: 'WireTransferPaymentEntity' } }
);

type PaymentSourceAffirmPaymentSourceFragment = (
  { __typename: 'AffirmPaymentSource' }
  & Pick<AffirmPaymentSource, 'id'>
);

type PaymentSourceAfterpayPaymentSourceFragment = (
  { __typename: 'AfterpayPaymentSource' }
  & Pick<AfterpayPaymentSource, 'id'>
);

type PaymentSourceDealPaymentSourceFragment = { __typename: 'DealPaymentSource' };

type PaymentSourcePaypalPaymentSourceFragment = (
  { __typename: 'PaypalPaymentSource' }
  & Pick<PaypalPaymentSource, 'id'>
);

type PaymentSourceStripePaymentSourceFragment = (
  { __typename: 'StripePaymentSource' }
  & StripePaymentSourceFragment
);

export type PaymentSourceFragment = PaymentSourceAffirmPaymentSourceFragment | PaymentSourceAfterpayPaymentSourceFragment | PaymentSourceDealPaymentSourceFragment | PaymentSourcePaypalPaymentSourceFragment | PaymentSourceStripePaymentSourceFragment;

export type RecommendedListSellableCardFragment = (
  { __typename: 'Sellable' }
  & { consumerSellableReactions: (
    { __typename: 'ConsumerSellableReactionConnection' }
    & { edges: Array<(
      { __typename: 'ConsumerSellableReactionEdge' }
      & { node: (
        { __typename: 'ConsumerSellableReaction' }
        & Pick<ConsumerSellableReaction, 'id'>
        & { ratingWithDisplayName: (
          { __typename: 'ConsumerSellableReactionRatingWithDisplayName' }
          & Pick<ConsumerSellableReactionRatingWithDisplayName, 'displayName' | 'rating'>
        ) }
      ) }
    )> }
  ), recommendingExperts: (
    { __typename: 'ExpertSellableRecommendationCountConnection' }
    & Pick<ExpertSellableRecommendationCountConnection, 'count' | 'total'>
    & { edges: Array<(
      { __typename: 'ExpertSellableRecommendationCountEdge' }
      & { node: (
        { __typename: 'ExpertSellableRecommendationCount' }
        & Pick<ExpertSellableRecommendationCount, 'timesRecommended'>
        & { expert: (
          { __typename: 'BusinessUser' }
          & RecommendingExpertsFragment
        ) }
      ) }
    )> }
  ) }
  & SellableCardFragment
  & TrackableSellableFragment
);

export type VideoReviewFragment = (
  { __typename: 'ExternalVideo' }
  & Pick<ExternalVideo, 'id' | 'idType' | 'destinationUrl'>
);

export type FeaturedContentFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id'>
  & { featuredContent: Maybe<(
    { __typename: 'FeaturedSellableContent' }
    & Pick<FeaturedSellableContent, 'id'>
    & { externalVideos: Array<(
      { __typename: 'ExternalVideo' }
      & VideoReviewFragment
    )> }
  )> }
);

export type SellableDetailsVariantFragment = (
  { __typename: 'SellableFormattedVariant' }
  & Pick<SellableFormattedVariant, 'name' | 'displayName' | 'value' | 'displayValueHtml'>
);

export type SellableSpecificationFragment = (
  { __typename: 'SellableSpecification' }
  & Pick<SellableSpecification, 'key' | 'name' | 'valueHtml'>
);

export type ConsumerSellableReactionFragment = (
  { __typename: 'ConsumerSellableReaction' }
  & Pick<ConsumerSellableReaction, 'id'>
  & { ratingWithDisplayName: (
    { __typename: 'ConsumerSellableReactionRatingWithDisplayName' }
    & Pick<ConsumerSellableReactionRatingWithDisplayName, 'rating' | 'displayName'>
  ), recommendedBy: Maybe<(
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id'>
  )> }
);

export type SellableDetailsFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id' | 'type' | 'adHoc' | 'descriptionText' | 'descriptionMarkdown' | 'features' | 'active' | 'outOfStock' | 'inShortSupply' | 'variant'>
  & { department: Maybe<(
    { __typename: 'Department' }
    & DepartmentContextFragment
  )>, savedSellable: Maybe<(
    { __typename: 'SavedSellable' }
    & Pick<SavedSellable, 'id' | 'saved'>
  )>, variants: Array<(
    { __typename: 'SellableFormattedVariant' }
    & SellableDetailsVariantFragment
  )>, specifications: Array<(
    { __typename: 'SellableSpecification' }
    & SellableSpecificationFragment
  )>, images: Array<(
    { __typename: 'MediaFile' }
    & MediaFileFragment
  )>, brand: Maybe<(
    { __typename: 'Brand' }
    & BrandFragment
  )>, metrics: Maybe<(
    { __typename: 'SellableMetrics' }
    & Pick<SellableMetrics, 'totalUniquePVsInPastWeek' | 'totalPurchasesInLast30Days' | 'timesRecommendedByExpert'>
  )>, serviceLocation: Maybe<(
    { __typename: 'SellableServiceLocation' }
    & Pick<SellableServiceLocation, 'displayTitle'>
  )>, categories: Array<(
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'slug'>
    & { breadcrumbs: Array<(
      { __typename: 'Category' }
      & CategoryBreadcrumbFragment
    )> }
  )>, parent: Maybe<(
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id'>
    & { metrics: Maybe<(
      { __typename: 'SellableMetrics' }
      & Pick<SellableMetrics, 'totalUniquePVsInPastWeek' | 'totalPurchasesInLast30Days'>
    )>, savedSellable: Maybe<(
      { __typename: 'SavedSellable' }
      & Pick<SavedSellable, 'id' | 'saved'>
    )>, department: Maybe<(
      { __typename: 'Department' }
      & DepartmentContextFragment
    )> }
  )>, variationMatrix: Maybe<(
    { __typename: 'VariationMatrix' }
    & { defaultVariant: (
      { __typename: 'Sellable' }
      & Pick<Sellable, 'id' | 'active' | 'outOfStock'>
      & { originalPrice: Maybe<(
        { __typename: 'MonetaryAmount' }
        & MonetaryAmountFragment
      )>, salePrice: Maybe<(
        { __typename: 'MonetaryAmount' }
        & MonetaryAmountFragment
      )> }
      & SellableUrlFragment
    ), outOfStockSellables: Array<(
      { __typename: 'Sellable' }
      & Pick<Sellable, 'id'>
    )>, priceRange: Maybe<(
      { __typename: 'VariationMatrixPriceRange' }
      & { max: (
        { __typename: 'MonetaryAmount' }
        & MonetaryAmountFragment
      ), min: (
        { __typename: 'MonetaryAmount' }
        & MonetaryAmountFragment
      ) }
    )> }
  )>, salePrice: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, originalPrice: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, consumerSellableReactions: (
    { __typename: 'ConsumerSellableReactionConnection' }
    & { edges: Array<(
      { __typename: 'ConsumerSellableReactionEdge' }
      & { node: (
        { __typename: 'ConsumerSellableReaction' }
        & ConsumerSellableReactionFragment
      ) }
    )> }
  ), recentExpertCuratedItem: Maybe<(
    { __typename: 'ExpertCuratedItem' }
    & Pick<ExpertCuratedItem, 'id'>
    & { salePrice: Maybe<(
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    )>, sellable: (
      { __typename: 'Sellable' }
      & Pick<Sellable, 'id'>
    ) }
  )> }
  & FeaturedContentFragment
);

export type SellableInactiveFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id' | 'active' | 'outOfStock'>
  & { salePrice: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )> }
);

export type SellablePricingFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id'>
  & { salePrice: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, originalPrice: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )> }
);

export type SellablePricingWithDefaultVariantFragment = (
  { __typename: 'Sellable' }
  & { variationMatrix: Maybe<(
    { __typename: 'VariationMatrix' }
    & { defaultVariant: (
      { __typename: 'Sellable' }
      & Pick<Sellable, 'id'>
      & { salePrice: Maybe<(
        { __typename: 'MonetaryAmount' }
        & MonetaryAmountFragment
      )>, originalPrice: Maybe<(
        { __typename: 'MonetaryAmount' }
        & MonetaryAmountFragment
      )> }
    ) }
  )> }
  & SellablePricingFragment
);

export type SellableUrlFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type'>
);

export type ShipmentTrackingFragment = (
  { __typename: 'ShipmentTracking' }
  & Pick<ShipmentTracking, 'trackingNumber' | 'status' | 'estimatedDeliveryTime' | 'trackingUrl'>
  & { shippingCarrier: (
    { __typename: 'ShippingCarrier' }
    & Pick<ShippingCarrier, 'id' | 'displayName'>
  ) }
);

export type ShoppingCartOrderFragment = (
  { __typename: 'Order' }
  & { lineItems: Array<(
    { __typename: 'OrderLineItem' }
    & OrderLineItemFragment
  )> }
  & OrderFragment
);

export type CategoryDataFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id' | 'name' | 'slug'>
);

export type TrackableSellableFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type' | 'googleId' | 'title' | 'feedId' | 'variant' | 'sampleImageIds'>
  & { brand: Maybe<(
    { __typename: 'Brand' }
    & BrandFragment
  )>, images: Array<(
    { __typename: 'MediaFile' }
    & MediaFileFragment
  )>, salePrice: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, originalPrice: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, categories: Array<(
    { __typename: 'Category' }
    & CategoryDataFragment
  )> }
);

export type TrackableSellableWithDefaultVariantFragment = (
  { __typename: 'Sellable' }
  & { variationMatrix: Maybe<(
    { __typename: 'VariationMatrix' }
    & { defaultVariant: (
      { __typename: 'Sellable' }
      & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type'>
      & { salePrice: Maybe<(
        { __typename: 'MonetaryAmount' }
        & MonetaryAmountFragment
      )>, originalPrice: Maybe<(
        { __typename: 'MonetaryAmount' }
        & MonetaryAmountFragment
      )> }
    ) }
  )> }
  & TrackableSellableFragment
);

export type VariationMatrixDimensionFragment = (
  { __typename: 'VariationMatrixDimension' }
  & Pick<VariationMatrixDimension, 'name' | 'displayName'>
  & { vectors: Array<(
    { __typename: 'VariationMatrixVector' }
    & VariationMatrixVectorFragment
  )> }
);

export type VariationMatrixVectorFragment = (
  { __typename: 'VariationMatrixVector' }
  & Pick<VariationMatrixVector, 'value' | 'displayValueHtml' | 'sellableIds'>
);

export type VariationMatrixSellableFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type' | 'outOfStock'>
);

export type VariationMatrixFragment = (
  { __typename: 'VariationMatrix' }
  & Pick<VariationMatrix, 'maximumSavingsPercent'>
  & { dimensions: Array<(
    { __typename: 'VariationMatrixDimension' }
    & VariationMatrixDimensionFragment
  )>, sellables: Array<(
    { __typename: 'Sellable' }
    & VariationMatrixSellableFragment
  )>, defaultVariant: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type'>
    & { salePrice: Maybe<(
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    )>, originalPrice: Maybe<(
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    )>, images: Array<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
  ), priceRange: Maybe<(
    { __typename: 'VariationMatrixPriceRange' }
    & { min: (
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    ), max: (
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    ) }
  )>, maximumSavingsAmount: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, outOfStockSellables: Array<(
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id'>
  )> }
);

export type CreateBookingFlightPlanMutationVariables = {
  input: CreateFlightPlanInput
};


export type CreateBookingFlightPlanMutation = (
  { __typename: 'Mutation' }
  & { createFlightPlan: (
    { __typename: 'CreateFlightPlanPayload' }
    & Pick<CreateFlightPlanPayload, 'hasError' | 'errorMessage'>
    & { flightPlan: Maybe<(
      { __typename: 'FlightPlan' }
      & Pick<FlightPlan, 'id'>
    )> }
  ) }
);

export type StartExpertConsumerConversationMutationVariables = {
  input: StartExpertConsumerConversationInput
};


export type StartExpertConsumerConversationMutation = (
  { __typename: 'Mutation' }
  & { startExpertConsumerConversation: (
    { __typename: 'StartExpertConsumerConversationPayload' }
    & Pick<StartExpertConsumerConversationPayload, 'error'>
    & { conversation: Maybe<(
      { __typename: 'Conversation' }
      & Pick<Conversation, 'id' | 'externalId'>
      & { lead: Maybe<(
        { __typename: 'Lead' }
        & Pick<Lead, 'id'>
      )> }
    )> }
  ) }
);

export type CategoryWithPathQueryVariables = {
  categorySlug: Scalars['String']
};


export type CategoryWithPathQuery = (
  { __typename: 'Query' }
  & { categoryBySlug: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id'>
    & { ancestorWithPath: Maybe<(
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'slug'>
    )> }
  )> }
);

export type CountryFragment = (
  { __typename: 'Country' }
  & Pick<Country, 'countryCode' | 'displayCountry' | 'displayFirstAdministrativeAreaLabel' | 'displayPostalCodeLabel' | 'displayCityLabel'>
  & { firstAdministrativeAreas: Array<(
    { __typename: 'AdministrativeArea' }
    & Pick<AdministrativeArea, 'countryCode' | 'code' | 'displayName'>
  )> }
);

export type CountriesQueryVariables = {
  filter: CountryFilter
};


export type CountriesQuery = (
  { __typename: 'Query' }
  & { countries: Array<(
    { __typename: 'Country' }
    & CountryFragment
  )> }
);

export type GetSessionIdQueryVariables = {};


export type GetSessionIdQuery = (
  { __typename: 'Query' }
  & { session: (
    { __typename: 'Session' }
    & Pick<Session, 'id' | 'experimentUserId'>
  ) }
);

export type ChangePasswordMutationVariables = {
  oldPassword: Scalars['String'],
  newPassword: Scalars['String']
};


export type ChangePasswordMutation = (
  { __typename: 'Mutation' }
  & { changePassword: (
    { __typename: 'ChangePasswordPayload' }
    & Pick<ChangePasswordPayload, 'result' | 'message'>
  ) }
);

export type CreatePasswordMutationVariables = {
  password: Scalars['String']
};


export type CreatePasswordMutation = (
  { __typename: 'Mutation' }
  & { createPassword: (
    { __typename: 'CreatePasswordPayload' }
    & Pick<CreatePasswordPayload, 'success'>
  ) }
);

export type OrderListLineItemFragment = (
  { __typename: 'OrderLineItem' }
  & Pick<OrderLineItem, 'id' | 'state' | 'title'>
  & { shipmentTracking: Maybe<(
    { __typename: 'ShipmentTracking' }
    & ShipmentTrackingFragment
  )>, source: (
    { __typename: 'OrderLineItemAdHocSource' }
    & Pick<OrderLineItemAdHocSource, 'type'>
  ) | (
    { __typename: 'OrderLineItemBasePriceSource' }
    & Pick<OrderLineItemBasePriceSource, 'type'>
  ) | (
    { __typename: 'OrderLineItemExpertTipSource' }
    & Pick<OrderLineItemExpertTipSource, 'type'>
    & { amount: (
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    ), expertAmounts: Array<(
      { __typename: 'OrderLineItemExpertTipSourceExpertAmount' }
      & { expert: (
        { __typename: 'BusinessUser' }
        & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
        & { expertProfile: Maybe<(
          { __typename: 'ExpertProfile' }
          & Pick<ExpertProfile, 'id'>
          & { profilePhoto: Maybe<(
            { __typename: 'MediaFile' }
            & Pick<MediaFile, 'id' | 'url'>
          )> }
        )> }
      ) }
    )> }
  ) | (
    { __typename: 'OrderLineItemGratuitySource' }
    & Pick<OrderLineItemGratuitySource, 'type'>
  ) | (
    { __typename: 'OrderLineItemPrepaidIncidentalSource' }
    & Pick<OrderLineItemPrepaidIncidentalSource, 'type'>
  ) | (
    { __typename: 'OrderLineItemRefundSource' }
    & Pick<OrderLineItemRefundSource, 'type'>
  ) | (
    { __typename: 'OrderLineItemSellableSource' }
    & Pick<OrderLineItemSellableSource, 'type'>
    & { sellable: (
      { __typename: 'Sellable' }
      & Pick<Sellable, 'id'>
      & { images: Array<(
        { __typename: 'MediaFile' }
        & MediaFileFragment
      )>, variants: Array<(
        { __typename: 'SellableFormattedVariant' }
        & Pick<SellableFormattedVariant, 'displayValueHtml'>
      )> }
    ) }
  ) | (
    { __typename: 'OrderLineItemShipmentSource' }
    & Pick<OrderLineItemShipmentSource, 'type'>
  ) }
);

export type OrderListEscalationFragment = (
  { __typename: 'OrderEscalation' }
  & Pick<OrderEscalation, 'id' | 'orderId' | 'orderLineItemId' | 'consumerFriendlyId' | 'createdAt' | 'type' | 'status'>
  & { assignedTo: Maybe<(
    { __typename: 'Operator' }
    & Pick<Operator, 'id' | 'firstName'>
  )> }
);

export type MyOrderListItemFragment = (
  { __typename: 'Order' }
  & Pick<Order, 'id' | 'consumerFriendlyId' | 'state' | 'categoryType' | 'sortTimestamp'>
  & { totalCost: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), lineItems: Array<(
    { __typename: 'OrderLineItem' }
    & OrderListLineItemFragment
  )>, escalations: Array<(
    { __typename: 'OrderEscalation' }
    & OrderListEscalationFragment
  )> }
);

export type MyOrdersConnectionQueryVariables = {
  query: OrderQuery,
  after?: Maybe<Scalars['String']>
};


export type MyOrdersConnectionQuery = (
  { __typename: 'Query' }
  & { ordersConnection: (
    { __typename: 'OrdersConnection' }
    & { edges: Array<(
      { __typename: 'OrdersEdge' }
      & { node: (
        { __typename: 'Order' }
        & MyOrderListItemFragment
      ) }
    )> }
  ) }
);

export type OrderEscalationFragment = (
  { __typename: 'OrderEscalation' }
  & Pick<OrderEscalation, 'id' | 'type' | 'status' | 'createdAt' | 'orderLineItemId' | 'consumerFriendlyId'>
);

export type EscalateOrderMutationVariables = {
  input: CreateOrderEscalationInput
};


export type EscalateOrderMutation = (
  { __typename: 'Mutation' }
  & { createOrderEscalation: (
    { __typename: 'CreateOrderEscalationsPayload' }
    & { orderEscalation: (
      { __typename: 'OrderEscalation' }
      & OrderEscalationFragment
    ) }
  ) }
);

export type StartingSupportConversationFragment = (
  { __typename: 'SupportConversation' }
  & Pick<SupportConversation, 'id' | 'conversationId' | 'consumerId'>
);

export type StartSupportConversationMutationVariables = {
  input: StartSupportConversationInput
};


export type StartSupportConversationMutation = (
  { __typename: 'Mutation' }
  & { startSupportConversation: (
    { __typename: 'UpdateSupportConversationPayload' }
    & { supportConversation: (
      { __typename: 'SupportConversation' }
      & SupportConversationFragment
    ) }
  ) }
);

export type UpdateUserProfileMutationVariables = {
  input: UpdateUserProfileInput
};


export type UpdateUserProfileMutation = (
  { __typename: 'Mutation' }
  & { updateUserProfile: (
    { __typename: 'UpdateUserProfilePayload' }
    & Pick<UpdateUserProfilePayload, 'errors'>
    & { user: (
      { __typename: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName' | 'roles'>
      & { messagingUser: (
        { __typename: 'MessagingUser' }
        & Pick<MessagingUser, 'id'>
      ), address: Maybe<(
        { __typename: 'PostalAddress' }
        & Pick<PostalAddress, 'line1' | 'city' | 'state' | 'postalCode' | 'country'>
      )>, contacts: Array<(
        { __typename: 'Contact' }
        & Pick<Contact, 'id' | 'type' | 'value' | 'verified'>
      )> }
    ) }
  ) }
);

export type UpdateNotificationChannelsMutationVariables = {
  input: UpdateNotificationChannelsInput
};


export type UpdateNotificationChannelsMutation = (
  { __typename: 'Mutation' }
  & { updateNotificationChannels: (
    { __typename: 'UpdateNotificationChannelsPayload' }
    & { messagingUser: Maybe<(
      { __typename: 'MessagingUser' }
      & Pick<MessagingUser, 'id' | 'notificationChannels'>
    )> }
  ) }
);

export type UpdatePreferredMessagingChannelsMutationVariables = {
  input: UpdatePreferredMessagingChannelsInput
};


export type UpdatePreferredMessagingChannelsMutation = (
  { __typename: 'Mutation' }
  & { updatePreferredMessagingChannels: (
    { __typename: 'UpdatePreferredMessagingChannelsPayload' }
    & { messagingUser: Maybe<(
      { __typename: 'MessagingUser' }
      & Pick<MessagingUser, 'id' | 'preferredMessagingChannels'>
    )> }
  ) }
);

export type CreateExpertFromApplicationMutationVariables = {
  applicationId: Scalars['ExpertApplicationId']
};


export type CreateExpertFromApplicationMutation = (
  { __typename: 'Mutation' }
  & { createExpertFromApplication: (
    { __typename: 'CreateExpertFromApplicationPayload' }
    & { expert: (
      { __typename: 'BusinessUser' }
      & Pick<BusinessUser, 'id'>
    ) }
  ) }
);

export type CategoryFilterDisplayMetadataFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'>
);

export type CategoryFilterBreadcrumbsFragment = (
  { __typename: 'Category' }
  & { ancestry: Array<(
    { __typename: 'Category' }
    & CategoryFilterDisplayMetadataFragment
  )>, children: Array<(
    { __typename: 'Category' }
    & CategoryFilterDisplayMetadataFragment
  )> }
  & CategoryFilterDisplayMetadataFragment
);

export type CategorySellableSearchResultFragment = (
  { __typename: 'SellableSearchEdge' }
  & Pick<SellableSearchEdge, 'cursor'>
  & { node: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'type'>
    & SellableCardFragment
    & TrackableSellableWithDefaultVariantFragment
  ) }
);

export type CategorySellableSearchQueryVariables = {
  keywords?: Maybe<Scalars['String']>,
  categorySlug: Scalars['String'],
  facets?: Maybe<Array<FacetSelection>>,
  after?: Maybe<Scalars['String']>,
  maxFacetTerms?: Maybe<Scalars['Int']>,
  filters?: Maybe<Array<SellableSearchFilter>>,
  sortBy: SellableSort,
  order: SortOrder
};


export type CategorySellableSearchQuery = (
  { __typename: 'Query' }
  & { searchSellables: (
    { __typename: 'SellableSearchConnection' }
    & Pick<SellableSearchConnection, 'count'>
    & { facets: Array<(
      { __typename: 'BucketedDisplayFacet' }
      & DisplayFacetBucketedDisplayFacetFragment
    ) | (
      { __typename: 'BucketedRangeDisplayFacet' }
      & DisplayFacetBucketedRangeDisplayFacetFragment
    ) | (
      { __typename: 'NumericRangeDisplayFacet' }
      & DisplayFacetNumericRangeDisplayFacetFragment
    )>, edges: Array<(
      { __typename: 'SellableSearchEdge' }
      & CategorySellableSearchResultFragment
    )>, pageInfo: (
      { __typename: 'PageInfo' }
      & PageInfoFragment
    ) }
  ), categoryBySlug: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'pluralDisplayName' | 'type'>
    & { department: Maybe<(
      { __typename: 'Department' }
      & DepartmentContextFragment
    )>, breadcrumbs: Array<(
      { __typename: 'Category' }
      & CategoryBreadcrumbFragment
    )> }
    & CategoryFilterBreadcrumbsFragment
  )> }
);

export type CategoryAssetsForMetadataQueryVariables = {
  categoryId: Scalars['CategoryId']
};


export type CategoryAssetsForMetadataQuery = (
  { __typename: 'Query' }
  & { category: (
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'>
    & { contentAssets: (
      { __typename: 'CategoryContentAssets' }
      & { communityPoster: Maybe<(
        { __typename: 'ContentAsset' }
        & Pick<ContentAsset, 'imageUrl'>
      )> }
    ) }
  ) }
);

export type NoResultsDepartmentsQueryVariables = {};


export type NoResultsDepartmentsQuery = (
  { __typename: 'Query' }
  & { departments: Array<(
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'slug'>
  )> }
);

export type SellableSearchResultFragment = (
  { __typename: 'SellableSearchEdge' }
  & Pick<SellableSearchEdge, 'cursor'>
  & { node: (
    { __typename: 'Sellable' }
    & SellableCardFragment
  ) }
);

export type LeadForCurationsFragment = (
  { __typename: 'Lead' }
  & Pick<Lead, 'id'>
  & { consumer: (
    { __typename: 'User' }
    & Pick<User, 'id' | 'firstName'>
  ), expert: (
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
    & { expertProfile: Maybe<(
      { __typename: 'ExpertProfile' }
      & Pick<ExpertProfile, 'id'>
      & { profilePhoto: Maybe<(
        { __typename: 'MediaFile' }
        & MediaFileFragment
      )> }
    )> }
  ), conversation: (
    { __typename: 'Conversation' }
    & Pick<Conversation, 'id'>
  ), category: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id'>
    & { contentAssets: (
      { __typename: 'CategoryContentAssets' }
      & { bannerImages: Array<(
        { __typename: 'ContentAsset' }
        & Pick<ContentAsset, 'title' | 'mimeType' | 'imageUrl'>
      )> }
    ) }
  )>, department: Maybe<(
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'slug'>
  )> }
);

export type LeadForCurationsQueryVariables = {
  id: Scalars['LeadId']
};


export type LeadForCurationsQuery = (
  { __typename: 'Query' }
  & { lead: Maybe<(
    { __typename: 'Lead' }
    & LeadForCurationsFragment
  )> }
);

export type CustomerRequestExpertCuratedOrderMutationVariables = {
  id: Scalars['ExpertCuratedOrderId']
};


export type CustomerRequestExpertCuratedOrderMutation = (
  { __typename: 'Mutation' }
  & { customerRequestExpertCuratedOrder: (
    { __typename: 'CustomerRequestExpertCuratedOrderPayload' }
    & { expertCuratedOrder: (
      { __typename: 'ExpertCuratedOrder' }
      & Pick<ExpertCuratedOrder, 'id'>
    ) }
  ) }
);

export type ExpertCuratedLeadItineraryQueryVariables = {
  leadId: Scalars['LeadId']
};


export type ExpertCuratedLeadItineraryQuery = (
  { __typename: 'Query' }
  & { expertCuratedLeadItinerary: Maybe<(
    { __typename: 'ExpertCuratedLeadItinerary' }
    & Pick<ExpertCuratedLeadItinerary, 'id' | 'contentfulVariation'>
  )> }
);

export type ExpertCuratedOrdersForLeadConnectionQueryVariables = {
  query: ExpertCuratedOrdersForLeadQueryInput,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type ExpertCuratedOrdersForLeadConnectionQuery = (
  { __typename: 'Query' }
  & { expertCuratedOrdersForLeadConnection: (
    { __typename: 'ExpertCuratedOrdersForLeadConnection' }
    & { edges: Array<(
      { __typename: 'ExpertCuratedOrdersForLeadEdge' }
      & { node: (
        { __typename: 'ExpertCuratedOrder' }
        & ExpertCuratedOrderFragment
      ) }
    )> }
  ) }
);

export type ExpertCuratedOrdersForLeadConnectionChangedSubscriptionVariables = {
  query: ExpertCuratedOrdersForLeadQueryInput
};


export type ExpertCuratedOrdersForLeadConnectionChangedSubscription = (
  { __typename: 'Subscription' }
  & { expertCuratedOrdersForLeadConnectionChanged: (
    { __typename: 'ExpertCuratedOrdersForLeadConnectionChangedPayload' }
    & { connection: (
      { __typename: 'ExpertCuratedOrdersForLeadConnection' }
      & { edges: Array<(
        { __typename: 'ExpertCuratedOrdersForLeadEdge' }
        & { node: (
          { __typename: 'ExpertCuratedOrder' }
          & ExpertCuratedOrderFragment
        ) }
      )> }
    ) }
  ) }
);

export type GetUserJourneyQueryVariables = {
  userId: Scalars['UserId']
};


export type GetUserJourneyQuery = (
  { __typename: 'Query' }
  & { user: (
    { __typename: 'User' }
    & Pick<User, 'id'>
    & { userJourneyStages: Array<(
      { __typename: 'UserJourneyLeadStage' }
      & Pick<UserJourneyLeadStage, 'type' | 'leadStageStatus'>
      & { lead: (
        { __typename: 'Lead' }
        & Pick<Lead, 'id'>
        & { department: Maybe<(
          { __typename: 'Department' }
          & Pick<Department, 'id' | 'slug'>
        )>, category: Maybe<(
          { __typename: 'Category' }
          & Pick<Category, 'id' | 'slug'>
          & { contentAssets: (
            { __typename: 'CategoryContentAssets' }
            & { bannerImages: Array<(
              { __typename: 'ContentAsset' }
              & Pick<ContentAsset, 'imageUrl'>
            )> }
          ) }
        )> }
      ) }
    ) | (
      { __typename: 'UserJourneyNewStage' }
      & Pick<UserJourneyNewStage, 'type'>
    ) | (
      { __typename: 'UserJourneyOrderStage' }
      & Pick<UserJourneyOrderStage, 'type'>
      & { order: (
        { __typename: 'Order' }
        & Pick<Order, 'id'>
      ) }
    )> }
  ) }
);

export type CurationCardItemCategoryFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id' | 'singularDisplayName'>
);

export type CurationCardItemFragment = (
  { __typename: 'ExpertCuratedItem' }
  & Pick<ExpertCuratedItem, 'id' | 'createdAt'>
  & { category: (
    { __typename: 'Category' }
    & CurationCardItemCategoryFragment
  ), note: Maybe<(
    { __typename: 'ExpertCuratedItemNote' }
    & Pick<ExpertCuratedItemNote, 'id'>
  )>, lead: (
    { __typename: 'Lead' }
    & Pick<Lead, 'id'>
    & { department: Maybe<(
      { __typename: 'Department' }
      & Pick<Department, 'id' | 'type'>
    )> }
  ) }
);

export type CurationCardInfoFragment = (
  { __typename: 'ExpertCuratedItemsForLeadPayload' }
  & Pick<ExpertCuratedItemsForLeadPayload, 'id'>
  & { items: Array<(
    { __typename: 'ExpertCuratedItem' }
    & CurationCardItemFragment
  )> }
);

export type CurationCardLeadInfoFragment = (
  { __typename: 'Lead' }
  & Pick<Lead, 'id'>
  & { category: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'slug'>
  )>, department: Maybe<(
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'type' | 'displayName' | 'slug'>
  )>, latestRequest: Maybe<(
    { __typename: 'DealRequest' }
    & Pick<DealRequest, 'id' | 'createdAt'>
  )>, expert: (
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'shortName' | 'displayName'>
    & { expertProfile: Maybe<(
      { __typename: 'ExpertProfile' }
      & Pick<ExpertProfile, 'id' | 'headline'>
      & { profilePhoto: Maybe<(
        { __typename: 'MediaFile' }
        & Pick<MediaFile, 'id' | 'url'>
      )> }
    )> }
  ), conversation: (
    { __typename: 'Conversation' }
    & Pick<Conversation, 'id'>
  ), curationSummary: (
    { __typename: 'CurationSummary' }
    & Pick<CurationSummary, 'lastCurationSentAt'>
  ), consumerConversationMetrics: (
    { __typename: 'ConversationMetrics' }
    & Pick<ConversationMetrics, 'firstManualMessageSentAt'>
  ) }
);

export type GetCurationCardInfoQueryVariables = {
  leadId: Scalars['LeadId']
};


export type GetCurationCardInfoQuery = (
  { __typename: 'Query' }
  & { expertCuratedItemsForLead: (
    { __typename: 'ExpertCuratedItemsForLeadPayload' }
    & CurationCardInfoFragment
  ), lead: Maybe<(
    { __typename: 'Lead' }
    & CurationCardLeadInfoFragment
  )> }
);

export type GetDepartmentBannerQueryVariables = {
  departmentSlug: Scalars['String']
};


export type GetDepartmentBannerQuery = (
  { __typename: 'Query' }
  & { departmentBySlug: Maybe<(
    { __typename: 'Department' }
    & Pick<Department, 'id'>
    & { topLevelCategory: (
      { __typename: 'Category' }
      & Pick<Category, 'id'>
      & { contentAssets: (
        { __typename: 'CategoryContentAssets' }
        & { bannerImages: Array<(
          { __typename: 'ContentAsset' }
          & Pick<ContentAsset, 'imageUrl'>
        )> }
      ) }
    ) }
  )> }
);

export type GetRecommendationsByDepartmentQueryVariables = {
  departmentSlug: Scalars['String']
};


export type GetRecommendationsByDepartmentQuery = (
  { __typename: 'Query' }
  & { recommendedLists: (
    { __typename: 'RecommendedListConnection' }
    & { edges: Array<(
      { __typename: 'RecommendedListEdge' }
      & { node: (
        { __typename: 'RecommendedList' }
        & RecommendedListFragment
      ) }
    )> }
  ) }
);

export type AddExpertCuratedItemToCartMutationVariables = {
  id: Scalars['ExpertCuratedItemId']
};


export type AddExpertCuratedItemToCartMutation = (
  { __typename: 'Mutation' }
  & { addExpertCuratedItemToCart: (
    { __typename: 'AddExpertCuratedItemToCartPayload' }
    & { expertCuratedItem: (
      { __typename: 'ExpertCuratedItem' }
      & Pick<ExpertCuratedItem, 'id'>
      & { lineItemInCart: Maybe<(
        { __typename: 'OrderLineItem' }
        & Pick<OrderLineItem, 'id'>
      )> }
    ), order: (
      { __typename: 'Order' }
      & ShoppingCartOrderFragment
    ) }
  ) }
);

export type RemoveExpertCuratedItemsFromCartMutationVariables = {
  id: Scalars['OrderLineItemId']
};


export type RemoveExpertCuratedItemsFromCartMutation = (
  { __typename: 'Mutation' }
  & { removeItemsFromOrder: (
    { __typename: 'RemoveItemsFromOrderPayload' }
    & { order: (
      { __typename: 'Order' }
      & ShoppingCartOrderFragment
    ) }
  ) }
);

export type ReportPredictedLifeTimeValueToPlatformMutationVariables = {
  input: ReportPredictedLifeTimeValueInput
};


export type ReportPredictedLifeTimeValueToPlatformMutation = (
  { __typename: 'Mutation' }
  & { reportPredictedLifeTimeValueToPlatform: (
    { __typename: 'ReportPredictedLifeTimeValuePayload' }
    & { predictedLifeTimeValues: Array<(
      { __typename: 'PredictedLifeTimeValue' }
      & Pick<PredictedLifeTimeValue, 'id' | 'userId' | 'ltvType'>
      & { pLTV: (
        { __typename: 'MonetaryAmount' }
        & Pick<MonetaryAmount, 'amount' | 'currency'>
      ) }
    )> }
  ) }
);

export type SelectExpertCuratedOrderVariationOptionMutationVariables = {
  input: SelectExpertCuratedOrderVariationOptionInput
};


export type SelectExpertCuratedOrderVariationOptionMutation = (
  { __typename: 'Mutation' }
  & { selectExpertCuratedOrderVariationOption: (
    { __typename: 'SelectExpertCuratedOrderVariationOptionPayload' }
    & { expertCuratedOrder: (
      { __typename: 'ExpertCuratedOrder' }
      & ExpertCuratedOrderFragment
    ) }
  ) }
);

export type ExpertCuratedItemsForLeadQueryVariables = {
  leadId: Scalars['LeadId']
};


export type ExpertCuratedItemsForLeadQuery = (
  { __typename: 'Query' }
  & { expertCuratedItemsForLead: (
    { __typename: 'ExpertCuratedItemsForLeadPayload' }
    & Pick<ExpertCuratedItemsForLeadPayload, 'id'>
    & { items: Array<(
      { __typename: 'ExpertCuratedItem' }
      & ExpertCuratedItemFragment
    )> }
  ) }
);

export type ExpertCuratedItemsForLeadChangedSubscriptionVariables = {
  leadId: Scalars['LeadId']
};


export type ExpertCuratedItemsForLeadChangedSubscription = (
  { __typename: 'Subscription' }
  & { expertCuratedItemsChanged: (
    { __typename: 'ExpertCuratedItemsChangedPayload' }
    & Pick<ExpertCuratedItemsChangedPayload, 'leadId'>
  ) }
);

export type CategoryBannerAssetsFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id'>
  & { contentAssets: (
    { __typename: 'CategoryContentAssets' }
    & { bannerImages: Array<(
      { __typename: 'ContentAsset' }
      & Pick<ContentAsset, 'imageUrl'>
    )> }
  ) }
);

export type CuratedItemsLeadFragment = (
  { __typename: 'Lead' }
  & Pick<Lead, 'id' | 'createdAt'>
  & { expert: (
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
    & { department: (
      { __typename: 'Department' }
      & Pick<Department, 'id' | 'slug'>
    ) }
  ), delegateExpert: Maybe<(
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
  )>, department: Maybe<(
    { __typename: 'Department' }
    & { topLevelCategory: (
      { __typename: 'Category' }
      & CategoryBannerAssetsFragment
    ) }
    & DepartmentContextFragment
  )>, conversation: (
    { __typename: 'Conversation' }
    & Pick<Conversation, 'id' | 'externalId'>
  ), consumerConversationMetrics: (
    { __typename: 'ConversationMetrics' }
    & Pick<ConversationMetrics, 'messageCount'>
  ), expertConversationMetrics: (
    { __typename: 'ConversationMetrics' }
    & Pick<ConversationMetrics, 'messageCount'>
  ) }
);

export type ExpertCuratedLeadQueryVariables = {
  leadId: Scalars['LeadId']
};


export type ExpertCuratedLeadQuery = (
  { __typename: 'Query' }
  & { lead: Maybe<(
    { __typename: 'Lead' }
    & CuratedItemsLeadFragment
  )> }
);

export type RemoveExpertCuratedItemFromListMutationVariables = {
  id: Scalars['ExpertCuratedItemId'],
  reason: ExpertCuratedItemRemovedReason,
  otherReason?: Maybe<Scalars['String']>
};


export type RemoveExpertCuratedItemFromListMutation = (
  { __typename: 'Mutation' }
  & { removeExpertCuratedItem: (
    { __typename: 'RemoveExpertCuratedItemPayload' }
    & { expertCuratedItemsByCategories: (
      { __typename: 'ExpertCuratedItemsByCategories' }
      & Pick<ExpertCuratedItemsByCategories, 'id'>
      & { categories: Array<(
        { __typename: 'ExpertCuratedItemsByCategory' }
        & Pick<ExpertCuratedItemsByCategory, 'id'>
        & { items: Array<(
          { __typename: 'ExpertCuratedItem' }
          & ExpertCuratedItemFragment
        )> }
      )> }
    ) }
  ) }
);

export type ExpertCuratedItemForCurationProductPageFragment = (
  { __typename: 'ExpertCuratedItem' }
  & Pick<ExpertCuratedItem, 'id' | 'createdAt' | 'priceOverrideValidUntil' | 'rank'>
  & { priceOverride: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, createdBy: (
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'firstName' | 'lastName' | 'shortName'>
    & { expertProfile: Maybe<(
      { __typename: 'ExpertProfile' }
      & Pick<ExpertProfile, 'id'>
      & { profilePhoto: Maybe<(
        { __typename: 'MediaFile' }
        & MediaFileFragment
      )> }
    )> }
  ), tag: Maybe<(
    { __typename: 'ExpertCuratedItemTag' }
    & Pick<ExpertCuratedItemTag, 'type' | 'displayLabel'>
  )>, note: Maybe<(
    { __typename: 'ExpertCuratedItemNote' }
    & Pick<ExpertCuratedItemNote, 'id' | 'text'>
  )>, category: (
    { __typename: 'Category' }
    & ExpertCuratedItemCategoryFragment
  ), sellable: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id' | 'active' | 'expireAt'>
    & { department: Maybe<(
      { __typename: 'Department' }
      & Pick<Department, 'id'>
      & { mostRecentLeadForConsumer: Maybe<(
        { __typename: 'Lead' }
        & Pick<Lead, 'id'>
      )> }
    )>, variationMatrix: Maybe<(
      { __typename: 'VariationMatrix' }
      & VariationMatrixFragment
    )> }
    & SellableDetailsFragment
    & TrackableSellableFragment
  ), salePrice: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, lineItemInCart: Maybe<(
    { __typename: 'OrderLineItem' }
    & Pick<OrderLineItem, 'id'>
  )>, customizations: Array<(
    { __typename: 'ExpertCuratedItemCustomization' }
    & ExpertCuratedItemCustomizationFragment
  )> }
);

export type ExpertCuratedItemForCurationProductPageQueryVariables = {
  id: Scalars['ExpertCuratedItemId']
};


export type ExpertCuratedItemForCurationProductPageQuery = (
  { __typename: 'Query' }
  & { expertCuratedItem: (
    { __typename: 'ExpertCuratedItem' }
    & ExpertCuratedItemForCurationProductPageFragment
  ) }
);

export type ReactionSellableFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type' | 'title'>
  & { brand: Maybe<(
    { __typename: 'Brand' }
    & BrandFragment
  )>, images: Array<(
    { __typename: 'MediaFile' }
    & MediaFileFragment
  )>, salePrice: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, originalPrice: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )> }
);

export type UserSellableReactionFragment = (
  { __typename: 'ConsumerSellableReaction' }
  & Pick<ConsumerSellableReaction, 'id'>
  & { ratingWithDisplayName: (
    { __typename: 'ConsumerSellableReactionRatingWithDisplayName' }
    & Pick<ConsumerSellableReactionRatingWithDisplayName, 'displayName' | 'rating'>
  ), reasonsWithDisplayName: Array<(
    { __typename: 'ConsumerSellableReactionReasonWithDisplayName' }
    & Pick<ConsumerSellableReactionReasonWithDisplayName, 'displayName' | 'reason'>
  )>, sellable: (
    { __typename: 'Sellable' }
    & ReactionSellableFragment
  ) }
);

export type UserSellableReactionsQueryVariables = {
  last?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  query?: Maybe<ConsumerSellableReactionsQuery>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>
};


export type UserSellableReactionsQuery = (
  { __typename: 'Query' }
  & { consumerSellableReactions: (
    { __typename: 'ConsumerSellableReactionConnection' }
    & { edges: Array<(
      { __typename: 'ConsumerSellableReactionEdge' }
      & { node: (
        { __typename: 'ConsumerSellableReaction' }
        & UserSellableReactionFragment
      ) }
    )> }
  ) }
);

export type SubcategoryInfoFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'>
);

export type CategoryInfoFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id' | 'slug' | 'type' | 'pluralDisplayName'>
  & { contentAssets: (
    { __typename: 'CategoryContentAssets' }
    & { communityPoster: Maybe<(
      { __typename: 'ContentAsset' }
      & Pick<ContentAsset, 'imageUrl'>
    )> }
  ), children: Array<(
    { __typename: 'Category' }
    & SubcategoryInfoFragment
  )>, parents: Array<(
    { __typename: 'Category' }
    & Pick<Category, 'id'>
    & { children: Array<(
      { __typename: 'Category' }
      & SubcategoryInfoFragment
    )> }
  )>, brands: Array<(
    { __typename: 'Brand' }
    & BrandFragment
  )> }
);

export type HomeExpertFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
  & { department: (
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'slug' | 'type'>
  ) }
);

export type MostRecentLeadFragment = (
  { __typename: 'Lead' }
  & Pick<Lead, 'id'>
  & { conversation: (
    { __typename: 'Conversation' }
    & Pick<Conversation, 'id'>
  ), expert: (
    { __typename: 'BusinessUser' }
    & HomeExpertFragment
  ) }
);

export type CurationItemsQueryVariables = {
  leadId: Scalars['LeadId']
};


export type CurationItemsQuery = (
  { __typename: 'Query' }
  & { expertCuratedItemsForLead: (
    { __typename: 'ExpertCuratedItemsForLeadPayload' }
    & Pick<ExpertCuratedItemsForLeadPayload, 'id'>
    & { items: Array<(
      { __typename: 'ExpertCuratedItem' }
      & Pick<ExpertCuratedItem, 'id'>
    )> }
  ), expertCuratedOrdersForLeadConnection: (
    { __typename: 'ExpertCuratedOrdersForLeadConnection' }
    & { edges: Array<(
      { __typename: 'ExpertCuratedOrdersForLeadEdge' }
      & { node: (
        { __typename: 'ExpertCuratedOrder' }
        & Pick<ExpertCuratedOrder, 'id'>
      ) }
    )> }
  ) }
);

export type DepartmentExpertFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
  & { expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id' | 'background' | 'backgroundRichText' | 'headline'>
    & { gallery: Array<(
      { __typename: 'MediaFileWithCaption' }
      & Pick<MediaFileWithCaption, 'caption'>
      & { mediaFile: (
        { __typename: 'MediaFile' }
        & MediaFileFragment
      ) }
    )>, highlights: Array<(
      { __typename: 'ProfileHighlight' }
      & ExpertProfileHighlightsFragment
    )>, profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )>, socialMediaLinks: Array<(
      { __typename: 'SocialMediaLink' }
      & Pick<SocialMediaLink, 'socialMediaType' | 'url'>
    )> }
  )>, expertAttributes: (
    { __typename: 'BusinessUserExpertAttributes' }
    & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>
  ), expertPresence: (
    { __typename: 'ExpertPresenceAway' }
    & Pick<ExpertPresenceAway, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOffShift' }
    & Pick<ExpertPresenceOffShift, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOnCall' }
    & Pick<ExpertPresenceOnCall, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOnShift' }
    & Pick<ExpertPresenceOnShift, 'status'>
  ), expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & Pick<ExpertStats, 'averageRating' | 'totalReviews' | 'totalMessagesSent' | 'totalLeadsAsPrimaryExpert'>
  )>, department: (
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'slug' | 'type'>
  ) }
);

export type DepartmentLeadFragment = (
  { __typename: 'Lead' }
  & Pick<Lead, 'id'>
  & { curationSummary: (
    { __typename: 'CurationSummary' }
    & Pick<CurationSummary, 'lastCurationSentAt'>
  ), conversation: (
    { __typename: 'Conversation' }
    & Pick<Conversation, 'id'>
  ), category: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'type'>
  )>, expert: (
    { __typename: 'BusinessUser' }
    & DepartmentExpertFragment
  ) }
);

export type DepartmentConsumerExpertReviewFragment = (
  { __typename: 'ConsumerExpertReview' }
  & Pick<ConsumerExpertReview, 'id' | 'comments' | 'goodQualities' | 'headline' | 'rating' | 'reviewedAt'>
  & { consumer: (
    { __typename: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName'>
  ), expert: (
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'displayName'>
    & { expertProfile: Maybe<(
      { __typename: 'ExpertProfile' }
      & Pick<ExpertProfile, 'id'>
      & { profilePhoto: Maybe<(
        { __typename: 'MediaFile' }
        & MediaFileFragment
      )> }
    )> }
  ) }
);

export type DepartmentSearchFacetSelectionsFragment = (
  { __typename: 'FacetSelectionPayload' }
  & Pick<FacetSelectionPayload, 'name' | 'displayName' | 'bucketValues'>
);

export type DepartmentTopLevelCategoryFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'>
  & { contentAssets: (
    { __typename: 'CategoryContentAssets' }
    & { communityPoster: Maybe<(
      { __typename: 'ContentAsset' }
      & Pick<ContentAsset, 'imageUrl'>
    )> }
  ) }
);

export type DepartmentInfoQueryVariables = {
  departmentSlug: Scalars['String']
};


export type DepartmentInfoQuery = (
  { __typename: 'Query' }
  & { departmentBySlug: Maybe<(
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'displayName'>
    & { sellableSearchFacets: Array<(
      { __typename: 'DisplayFacetSelection' }
      & Pick<DisplayFacetSelection, 'name' | 'displayName'>
      & { selections: Array<(
        { __typename: 'FacetSelectionPayload' }
        & DepartmentSearchFacetSelectionsFragment
      )> }
    )>, topLevelCategory: (
      { __typename: 'Category' }
      & DepartmentTopLevelCategoryFragment
    ), mostRecentLeadForConsumer: Maybe<(
      { __typename: 'Lead' }
      & DepartmentLeadFragment
    )> }
    & DepartmentContextFragment
  )>, recommendedLists: (
    { __typename: 'RecommendedListConnection' }
    & { edges: Array<(
      { __typename: 'RecommendedListEdge' }
      & { node: (
        { __typename: 'RecommendedList' }
        & RecommendedListFragment
      ) }
    )> }
  ) }
);

export type DepartmentSavedSellablesQueryVariables = {
  query: SavedSellableQueryInput
};


export type DepartmentSavedSellablesQuery = (
  { __typename: 'Query' }
  & { savedSellablesConnection: (
    { __typename: 'SavedSellablesConnection' }
    & { edges: Array<(
      { __typename: 'SavedSellableEdge' }
      & { node: (
        { __typename: 'SavedSellable' }
        & Pick<SavedSellable, 'id'>
        & { sellable: (
          { __typename: 'Sellable' }
          & RecommendedListSellableCardFragment
        ) }
      ) }
    )> }
  ) }
);

export type InfiniteScrollSellablesQueryVariables = {
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  after?: Maybe<Scalars['String']>,
  filters?: Maybe<Array<SellableSearchFilter>>
};


export type InfiniteScrollSellablesQuery = (
  { __typename: 'Query' }
  & { searchSellables: (
    { __typename: 'SellableSearchConnection' }
    & Pick<SellableSearchConnection, 'count'>
    & { edges: Array<(
      { __typename: 'SellableSearchEdge' }
      & Pick<SellableSearchEdge, 'cursor'>
      & { node: (
        { __typename: 'Sellable' }
        & SellableCardFragment
      ) }
    )>, pageInfo: (
      { __typename: 'PageInfo' }
      & PageInfoFragment
    ) }
  ) }
);

export type YachtSearchBarFacetsQueryVariables = {};


export type YachtSearchBarFacetsQuery = (
  { __typename: 'Query' }
  & { departmentBySlug: Maybe<(
    { __typename: 'Department' }
    & Pick<Department, 'id'>
    & { sellableSearchFacets: Array<(
      { __typename: 'DisplayFacetSelection' }
      & Pick<DisplayFacetSelection, 'name' | 'displayName'>
      & { selections: Array<(
        { __typename: 'FacetSelectionPayload' }
        & Pick<FacetSelectionPayload, 'name' | 'displayName' | 'bucketValues' | 'lower' | 'upper'>
      )> }
    )> }
  )> }
);

export type ExpertReviewFragment = (
  { __typename: 'ConsumerExpertReview' }
  & Pick<ConsumerExpertReview, 'id' | 'consumerName' | 'consumerLocation' | 'rating' | 'comments' | 'headline' | 'goodQualities' | 'reviewedAt'>
);

export type ExpertProfileBusinessUserFragment = (
  { __typename: 'ExpertProfile' }
  & Pick<ExpertProfile, 'id' | 'headline' | 'background' | 'backgroundRichText' | 'location'>
  & { highlights: Array<(
    { __typename: 'ProfileHighlight' }
    & ExpertProfileHighlightsFragment
  )>, profilePhoto: Maybe<(
    { __typename: 'MediaFile' }
    & MediaFileFragment
  )>, socialMediaLinks: Array<(
    { __typename: 'SocialMediaLink' }
    & Pick<SocialMediaLink, 'socialMediaType' | 'url'>
  )>, favoriteBrands: Array<(
    { __typename: 'Brand' }
    & BrandFragment
  )>, currentGears: Array<(
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id' | 'title' | 'friendlyId' | 'slug' | 'type'>
    & { brand: Maybe<(
      { __typename: 'Brand' }
      & Pick<Brand, 'id' | 'displayName'>
    )>, images: Array<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
  )> }
  & ExpertProfilePhotoCarouselFragment
);

export type ExpertBusinessUserFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
  & { messagingUser: (
    { __typename: 'MessagingUser' }
    & Pick<MessagingUser, 'id'>
  ), expertAttributes: (
    { __typename: 'BusinessUserExpertAttributes' }
    & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>
    & { categories: Array<(
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'>
    )> }
  ), expertPresence: (
    { __typename: 'ExpertPresenceAway' }
    & Pick<ExpertPresenceAway, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOffShift' }
    & Pick<ExpertPresenceOffShift, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOnCall' }
    & Pick<ExpertPresenceOnCall, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOnShift' }
    & Pick<ExpertPresenceOnShift, 'status'>
  ), department: (
    { __typename: 'Department' }
    & { topLevelCategory: (
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'slug'>
    ) }
    & DepartmentContextFragment
  ), expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & ExpertProfileBusinessUserFragment
  )>, consumerExpertReviewConnection: (
    { __typename: 'ConsumerExpertReviewConnection' }
    & { edges: Array<(
      { __typename: 'ConsumerExpertReviewEdge' }
      & { node: (
        { __typename: 'ConsumerExpertReview' }
        & ExpertReviewFragment
      ) }
    )> }
  ), expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & ExpertStatsFragment
  )> }
);

export type GetExpertProfileQueryVariables = {
  vanityIdOrId: Scalars['String']
};


export type GetExpertProfileQuery = (
  { __typename: 'Query' }
  & { findExpert: Maybe<(
    { __typename: 'BusinessUser' }
    & ExpertBusinessUserFragment
  )> }
);

export type TopRecommendedSellableCategoryFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id' | 'pluralDisplayName'>
);

export type TopRecommendedSellableFragment = (
  { __typename: 'ExpertTopRecommendedSellable' }
  & Pick<ExpertTopRecommendedSellable, 'timesRecommended'>
  & { sellable: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type' | 'title'>
    & { images: Array<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )>, brand: Maybe<(
      { __typename: 'Brand' }
      & Pick<Brand, 'id' | 'displayName'>
      & { logo: Maybe<(
        { __typename: 'MediaFile' }
        & MediaFileFragment
      )> }
    )> }
  ) }
);

export type ExpertTopSellablesFragment = (
  { __typename: 'ExpertCategoryTopRecommendedSellable' }
  & Pick<ExpertCategoryTopRecommendedSellable, 'displayTitle'>
  & { category: (
    { __typename: 'Category' }
    & TopRecommendedSellableCategoryFragment
  ), topRecommendedSellables: Array<(
    { __typename: 'ExpertTopRecommendedSellable' }
    & TopRecommendedSellableFragment
  )> }
);

export type ExpertTopRecommendedSellablesQueryVariables = {
  query: ExpertTopRecommendedSellablesInput
};


export type ExpertTopRecommendedSellablesQuery = (
  { __typename: 'Query' }
  & { expertTopRecommendedSellables: (
    { __typename: 'ExpertTopRecommendedSellablesPayload' }
    & { categoryTopRecommendedSellables: Array<(
      { __typename: 'ExpertCategoryTopRecommendedSellable' }
      & ExpertTopSellablesFragment
    )> }
  ) }
);

export type ExpertTopBrandsQueryVariables = {
  query: ExpertTopRecommendedBrandsInput
};


export type ExpertTopBrandsQuery = (
  { __typename: 'Query' }
  & { expertTopRecommendedBrands: (
    { __typename: 'ExpertTopRecommendedBrandsPayload' }
    & { topRecommendedBrands: Array<(
      { __typename: 'ExpertTopRecommendedBrand' }
      & { brand: (
        { __typename: 'Brand' }
        & Pick<Brand, 'id' | 'displayName' | 'name'>
        & { logo: Maybe<(
          { __typename: 'MediaFile' }
          & MediaFileFragment
        )> }
      ) }
    )> }
  ) }
);

export type ExpertInfoFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
  & { expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & Pick<MediaFile, 'id' | 'url'>
    )> }
  )> }
);

export type MyCurationsQueryVariables = {
  leadId: Scalars['LeadId']
};


export type MyCurationsQuery = (
  { __typename: 'Query' }
  & { expertCuratedItemsForLead: (
    { __typename: 'ExpertCuratedItemsForLeadPayload' }
    & Pick<ExpertCuratedItemsForLeadPayload, 'id'>
    & { items: Array<(
      { __typename: 'ExpertCuratedItem' }
      & Pick<ExpertCuratedItem, 'id'>
      & { sellable: (
        { __typename: 'Sellable' }
        & Pick<Sellable, 'id' | 'title'>
        & { images: Array<(
          { __typename: 'MediaFile' }
          & Pick<MediaFile, 'id' | 'url'>
        )> }
      ) }
    )> }
  ), lead: Maybe<(
    { __typename: 'Lead' }
    & Pick<Lead, 'id'>
    & { expert: (
      { __typename: 'BusinessUser' }
      & ExpertInfoFragment
    ), delegateExpert: Maybe<(
      { __typename: 'BusinessUser' }
      & ExpertInfoFragment
    )>, category: Maybe<(
      { __typename: 'Category' }
      & Pick<Category, 'id'>
      & { contentAssets: (
        { __typename: 'CategoryContentAssets' }
        & { bannerImages: Array<(
          { __typename: 'ContentAsset' }
          & Pick<ContentAsset, 'imageUrl'>
        )> }
      ) }
    )> }
  )>, expertCuratedOrdersForLeadConnection: (
    { __typename: 'ExpertCuratedOrdersForLeadConnection' }
    & { edges: Array<(
      { __typename: 'ExpertCuratedOrdersForLeadEdge' }
      & { node: (
        { __typename: 'ExpertCuratedOrder' }
        & Pick<ExpertCuratedOrder, 'id' | 'serviceStartAt'>
        & { serviceLocation: Maybe<(
          { __typename: 'PostalAddress' }
          & Pick<PostalAddress, 'city' | 'state'>
        )>, order: (
          { __typename: 'Order' }
          & Pick<Order, 'id' | 'title'>
          & { primaryImage: Maybe<(
            { __typename: 'MediaFile' }
            & Pick<MediaFile, 'id' | 'url'>
          )> }
        ) }
      ) }
    )> }
  ) }
);

export type MyFavoritesQueryVariables = {};


export type MyFavoritesQuery = (
  { __typename: 'Query' }
  & { savedSellablesConnection: (
    { __typename: 'SavedSellablesConnection' }
    & { edges: Array<(
      { __typename: 'SavedSellableEdge' }
      & { node: (
        { __typename: 'SavedSellable' }
        & Pick<SavedSellable, 'id' | 'saved' | 'savedReason'>
        & { sellable: (
          { __typename: 'Sellable' }
          & SellableCardFragment
        ) }
      ) }
    )> }
  ) }
);

export type LatestLeadQueryVariables = {};


export type LatestLeadQuery = (
  { __typename: 'Query' }
  & { me: Maybe<(
    { __typename: 'Myself' }
    & Pick<Myself, 'id'>
    & { user: (
      { __typename: 'User' }
      & Pick<User, 'id'>
      & { mostRecentLead: Maybe<(
        { __typename: 'Lead' }
        & Pick<Lead, 'id'>
        & { department: Maybe<(
          { __typename: 'Department' }
          & Pick<Department, 'id' | 'type' | 'slug'>
        )> }
      )> }
    ) }
  )> }
);

export type HomepageReviewCountsQueryVariables = {};


export type HomepageReviewCountsQuery = (
  { __typename: 'Query' }
  & { consumerExpertReviewConnection: (
    { __typename: 'ConsumerExpertReviewConnection' }
    & Pick<ConsumerExpertReviewConnection, 'count'>
    & { facets: Array<(
      { __typename: 'BucketedDisplayFacet' }
      & Pick<BucketedDisplayFacet, 'displayName' | 'alias' | 'name'>
      & { buckets: Array<(
        { __typename: 'IndividualBucketedDisplayFacet' }
        & Pick<IndividualBucketedDisplayFacet, 'count' | 'value'>
      )> }
    ) | (
      { __typename: 'BucketedRangeDisplayFacet' }
      & Pick<BucketedRangeDisplayFacet, 'displayName' | 'alias' | 'name'>
    ) | (
      { __typename: 'NumericRangeDisplayFacet' }
      & Pick<NumericRangeDisplayFacet, 'displayName' | 'alias' | 'name'>
    )> }
  ) }
);

export type SpotlightExpertFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
  & { department: (
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'type'>
    & { topLevelCategory: (
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'slug' | 'singularDisplayName'>
    ) }
  ), expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id' | 'location' | 'headline' | 'spotlightHeadline'>
    & { portraitVideo: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )>, introductionVideoLink: Maybe<(
      { __typename: 'ExternalVideoLink' }
      & Pick<ExternalVideoLink, 'smallUrl' | 'mediumUrl' | 'largeUrl' | 'xLargeUrl'>
    )> }
  )> }
);

export type SpotlightExpertsQueryVariables = {
  query: ExpertSearchQuery
};


export type SpotlightExpertsQuery = (
  { __typename: 'Query' }
  & { expertSearchConnection: (
    { __typename: 'ExpertSearchConnection' }
    & { edges: Array<(
      { __typename: 'ExpertSearchEdge' }
      & Pick<ExpertSearchEdge, 'cursor'>
      & { node: (
        { __typename: 'BusinessUser' }
        & SpotlightExpertFragment
      ) }
    )> }
  ) }
);

export type RecommendedExpertsForDepartmentQueryVariables = {
  query: ExpertSearchQuery
};


export type RecommendedExpertsForDepartmentQuery = (
  { __typename: 'Query' }
  & { expertSearchConnection: (
    { __typename: 'ExpertSearchConnection' }
    & Pick<ExpertSearchConnection, 'count'>
    & { edges: Array<(
      { __typename: 'ExpertSearchEdge' }
      & { node: (
        { __typename: 'BusinessUser' }
        & RecommendingExpertsFragment
      ) }
    )> }
  ) }
);

export type LeadOverviewFragment = (
  { __typename: 'Lead' }
  & Pick<Lead, 'id'>
  & { conversation: (
    { __typename: 'Conversation' }
    & Pick<Conversation, 'id' | 'externalId'>
  ), offers: Array<(
    { __typename: 'BroadcastOffer' }
    & Pick<BroadcastOffer, 'id' | 'state'>
  )> }
);

export type LeadsQueryVariables = {
  consumerId: Scalars['UserId'],
  after?: Maybe<Scalars['String']>
};


export type LeadsQuery = (
  { __typename: 'Query' }
  & { leads: (
    { __typename: 'LeadSearchConnection' }
    & { edges: Array<(
      { __typename: 'LeadSearchEdge' }
      & { node: (
        { __typename: 'Lead' }
        & LeadOverviewFragment
      ) }
    )> }
  ) }
);

export type SupportConversationFragment = (
  { __typename: 'SupportConversation' }
  & Pick<SupportConversation, 'id'>
  & { conversation: (
    { __typename: 'Conversation' }
    & Pick<Conversation, 'id' | 'externalId'>
  ) }
);

export type SupportConversationQueryVariables = {
  consumerId: Scalars['UserId']
};


export type SupportConversationQuery = (
  { __typename: 'Query' }
  & { supportConversation: Maybe<(
    { __typename: 'SupportConversation' }
    & SupportConversationFragment
  )> }
);

export type ByLeadExpertFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'displayName' | 'shortName' | 'presence'>
  & { expertAttributes: (
    { __typename: 'BusinessUserExpertAttributes' }
    & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>
  ), expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
  )>, expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & Pick<ExpertStats, 'averageRating' | 'totalReviews' | 'totalMessagesSent'>
  )> }
);

export type ExpertByLeadQueryVariables = {
  leadId: Scalars['LeadId']
};


export type ExpertByLeadQuery = (
  { __typename: 'Query' }
  & { lead: Maybe<(
    { __typename: 'Lead' }
    & Pick<Lead, 'id'>
    & { latestRequest: Maybe<(
      { __typename: 'DealRequest' }
      & Pick<DealRequest, 'id'>
      & { attributes: Array<(
        { __typename: 'Attribute' }
        & { formatted: Maybe<(
          { __typename: 'FormattedAttribute' }
          & Pick<FormattedAttribute, 'displayHtml'>
        )> }
      )> }
    )>, department: Maybe<(
      { __typename: 'Department' }
      & Pick<Department, 'id' | 'type'>
    )>, conversation: (
      { __typename: 'Conversation' }
      & Pick<Conversation, 'id'>
    ), expert: (
      { __typename: 'BusinessUser' }
      & ByLeadExpertFragment
    ), category: Maybe<(
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'slug' | 'singularDisplayName'>
      & { department: Maybe<(
        { __typename: 'Department' }
        & Pick<Department, 'id' | 'slug'>
      )>, contentAssets: (
        { __typename: 'CategoryContentAssets' }
        & { modalHeader: Maybe<(
          { __typename: 'ContentAsset' }
          & Pick<ContentAsset, 'imageUrl'>
        )>, fullPageTakeover: Maybe<(
          { __typename: 'ContentAsset' }
          & Pick<ContentAsset, 'imageUrl'>
        )> }
      ) }
    )> }
  )> }
);

export type SetConsumerInitialLeadActionMutationVariables = {
  leadId: Scalars['LeadId'],
  action: ConsumerInitialLeadAction
};


export type SetConsumerInitialLeadActionMutation = (
  { __typename: 'Mutation' }
  & { setConsumerInitialLeadAction: (
    { __typename: 'SetConsumerInitialLeadActionPayload' }
    & { lead: Maybe<(
      { __typename: 'Lead' }
      & Pick<Lead, 'id'>
      & { conversation: (
        { __typename: 'Conversation' }
        & Pick<Conversation, 'id' | 'externalId'>
      ), category: Maybe<(
        { __typename: 'Category' }
        & Pick<Category, 'id' | 'slug'>
      )> }
    )> }
  ) }
);

export type LeadExpertProfileExpertProfileFragment = (
  { __typename: 'ExpertProfile' }
  & Pick<ExpertProfile, 'id' | 'headline' | 'background' | 'quotes'>
  & { socialMediaLinks: Array<(
    { __typename: 'SocialMediaLink' }
    & Pick<SocialMediaLink, 'socialMediaType' | 'url'>
  )>, highlights: Array<(
    { __typename: 'ProfileHighlight' }
    & Pick<ProfileHighlight, 'value' | 'secondaryValue'>
    & { type: (
      { __typename: 'ProfileHighlightType' }
      & Pick<ProfileHighlightType, 'id' | 'icon' | 'displayName'>
    ) }
  )>, profilePhoto: Maybe<(
    { __typename: 'MediaFile' }
    & MediaFileFragment
  )> }
);

export type LeadExpertProfileExpertFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
  & { expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & LeadExpertProfileExpertProfileFragment
  )>, expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & ExpertStatsFragment
  )>, department: (
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'type' | 'slug'>
  ) }
);

export type LeadExpertProfileFragment = (
  { __typename: 'Lead' }
  & Pick<Lead, 'id'>
  & { expert: (
    { __typename: 'BusinessUser' }
    & LeadExpertProfileExpertFragment
  ), consumerConversationMetrics: (
    { __typename: 'ConversationMetrics' }
    & Pick<ConversationMetrics, 'messageCount'>
  ), expertConversationMetrics: (
    { __typename: 'ConversationMetrics' }
    & Pick<ConversationMetrics, 'messageCount'>
  ) }
);

export type ConversationExpertProfileQueryVariables = {
  id: Scalars['LeadId']
};


export type ConversationExpertProfileQuery = (
  { __typename: 'Query' }
  & { lead: Maybe<(
    { __typename: 'Lead' }
    & LeadExpertProfileFragment
  )>, expertCuratedItemsForLead: (
    { __typename: 'ExpertCuratedItemsForLeadPayload' }
    & Pick<ExpertCuratedItemsForLeadPayload, 'id'>
    & { items: Array<(
      { __typename: 'ExpertCuratedItem' }
      & Pick<ExpertCuratedItem, 'id'>
    )> }
  ) }
);

export type ConversationExpertFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
  & { expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id' | 'headline'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )>, highlights: Array<(
      { __typename: 'ProfileHighlight' }
      & Pick<ProfileHighlight, 'value' | 'secondaryValue'>
      & { type: (
        { __typename: 'ProfileHighlightType' }
        & Pick<ProfileHighlightType, 'id' | 'icon'>
      ) }
    )> }
  )>, expertAttributes: (
    { __typename: 'BusinessUserExpertAttributes' }
    & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>
  ), expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & Pick<ExpertStats, 'totalMessagesSent' | 'totalReviews'>
  )> }
);

export type ConversationWithMetaDataFragment = (
  { __typename: 'Conversation' }
  & Pick<Conversation, 'id' | 'externalId' | 'title' | 'active'>
  & { lead: Maybe<(
    { __typename: 'Lead' }
    & Pick<Lead, 'id' | 'consumerInitialAction'>
    & { expert: (
      { __typename: 'BusinessUser' }
      & ConversationExpertFragment
    ), consumerConversationMetrics: (
      { __typename: 'ConversationMetrics' }
      & Pick<ConversationMetrics, 'messageCount'>
    ), expertConversationMetrics: (
      { __typename: 'ConversationMetrics' }
      & Pick<ConversationMetrics, 'messageCount'>
    ), dealbotConversationMetrics: (
      { __typename: 'ConversationMetrics' }
      & Pick<ConversationMetrics, 'messageCount'>
    ) }
  )> }
);

export type ConversationQueryVariables = {
  id: Scalars['ConversationId']
};


export type ConversationQuery = (
  { __typename: 'Query' }
  & { conversation: (
    { __typename: 'Conversation' }
    & ConversationWithMetaDataFragment
  ) }
);

export type DepartmentSlugByCategorySlugQueryVariables = {
  categorySlug: Scalars['String']
};


export type DepartmentSlugByCategorySlugQuery = (
  { __typename: 'Query' }
  & { categoryBySlug: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id'>
    & { department: Maybe<(
      { __typename: 'Department' }
      & Pick<Department, 'id' | 'type' | 'slug'>
    )> }
  )> }
);

export type ExpertDepartmentBySlugQueryVariables = {
  slug: Scalars['String']
};


export type ExpertDepartmentBySlugQuery = (
  { __typename: 'Query' }
  & { departmentBySlug: Maybe<(
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'displayName' | 'type'>
    & { topLevelCategory: (
      { __typename: 'Category' }
      & Pick<Category, 'id'>
    ) }
  )> }
);

export type FeaturedExpertFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
  & { department: (
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'slug' | 'type'>
    & { topLevelCategory: (
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'singularDisplayName' | 'pluralDisplayName'>
    ) }
  ), expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id' | 'location' | 'background' | 'headline'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )>, highlights: Array<(
      { __typename: 'ProfileHighlight' }
      & ExpertProfileHighlightsFragment
    )> }
  )>, expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & Pick<ExpertStats, 'averageRating' | 'totalLeadsAsPrimaryExpert' | 'totalReviews'>
  )> }
);

export type FeaturedExpertsForDepartmentQueryVariables = {
  query: ExpertSearchQuery,
  after?: Maybe<Scalars['String']>
};


export type FeaturedExpertsForDepartmentQuery = (
  { __typename: 'Query' }
  & { expertSearchConnection: (
    { __typename: 'ExpertSearchConnection' }
    & Pick<ExpertSearchConnection, 'count'>
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & PageInfoFragment
    ), edges: Array<(
      { __typename: 'ExpertSearchEdge' }
      & Pick<ExpertSearchEdge, 'cursor'>
      & { node: (
        { __typename: 'BusinessUser' }
        & FeaturedExpertFragment
      ) }
    )> }
  ) }
);

export type InitiateAffirmPaymentForOrderMutationVariables = {
  input: InitiateAffirmPaymentForOrderInput
};


export type InitiateAffirmPaymentForOrderMutation = (
  { __typename: 'Mutation' }
  & { initiateAffirmPaymentForOrder: (
    { __typename: 'InitiateAffirmPaymentForOrderPayload' }
    & Pick<InitiateAffirmPaymentForOrderPayload, 'checkoutData'>
    & { order: (
      { __typename: 'Order' }
      & OrderWithLineItemsFragment
    ) }
  ) }
);

export type InitiateAfterpayPaymentForOrderMutationVariables = {
  input: InitiateAfterpayPaymentForOrderInput
};


export type InitiateAfterpayPaymentForOrderMutation = (
  { __typename: 'Mutation' }
  & { initiateAfterpayPaymentForOrder: (
    { __typename: 'InitiateAfterpayPaymentForOrderPayload' }
    & Pick<InitiateAfterpayPaymentForOrderPayload, 'orderToken'>
    & { order: (
      { __typename: 'Order' }
      & OrderWithLineItemsFragment
    ) }
  ) }
);

export type SyncOrderMutationVariables = {
  input: SyncOrderInput
};


export type SyncOrderMutation = (
  { __typename: 'Mutation' }
  & { syncOrder: (
    { __typename: 'SyncOrderPayload' }
    & { order: (
      { __typename: 'Order' }
      & OrderWithLineItemsFragment
    ) }
  ) }
);

export type GetOrderQueryVariables = {
  id: Scalars['OrderId']
};


export type GetOrderQuery = (
  { __typename: 'Query' }
  & { order: (
    { __typename: 'Order' }
    & OrderWithLineItemsFragment
  ) }
);

export type OrderForRatingQueryVariables = {
  id: Scalars['OrderId']
};


export type OrderForRatingQuery = (
  { __typename: 'Query' }
  & { order: (
    { __typename: 'Order' }
    & Pick<Order, 'id' | 'state'>
    & { associatedLeads: Array<(
      { __typename: 'Lead' }
      & Pick<Lead, 'id'>
      & { expert: (
        { __typename: 'BusinessUser' }
        & Pick<BusinessUser, 'id'>
        & { expertAttributes: (
          { __typename: 'BusinessUserExpertAttributes' }
          & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>
        ) }
      ) }
    )>, user: (
      { __typename: 'User' }
      & Pick<User, 'id'>
      & { expertReviews: Array<(
        { __typename: 'ConsumerExpertReview' }
        & Pick<ConsumerExpertReview, 'id'>
        & { expert: (
          { __typename: 'BusinessUser' }
          & Pick<BusinessUser, 'id'>
        ) }
      )> }
    ) }
  ) }
);

export type OrderChargingStatusQueryVariables = {
  id: Scalars['OrderId']
};


export type OrderChargingStatusQuery = (
  { __typename: 'Query' }
  & { order: (
    { __typename: 'Order' }
    & OrderWithLineItemsFragment
  ) }
);

export type PaymentSourceForReviewQueryVariables = {
  id: Scalars['PaymentSourceId']
};


export type PaymentSourceForReviewQuery = (
  { __typename: 'Query' }
  & { paymentSource: (
    { __typename: 'AffirmPaymentSource' }
    & PaymentSourceAffirmPaymentSourceFragment
  ) | (
    { __typename: 'AfterpayPaymentSource' }
    & PaymentSourceAfterpayPaymentSourceFragment
  ) | (
    { __typename: 'DealPaymentSource' }
    & PaymentSourceDealPaymentSourceFragment
  ) | (
    { __typename: 'PaypalPaymentSource' }
    & PaymentSourcePaypalPaymentSourceFragment
  ) | (
    { __typename: 'StripePaymentSource' }
    & PaymentSourceStripePaymentSourceFragment
  ) }
);

export type InitiatePaypalPaymentForOrderMutationVariables = {
  input: InitiatePaypalPaymentForOrderInput
};


export type InitiatePaypalPaymentForOrderMutation = (
  { __typename: 'Mutation' }
  & { initiatePaypalPaymentForOrder: (
    { __typename: 'InitiatePaypalPaymentForOrderPayload' }
    & Pick<InitiatePaypalPaymentForOrderPayload, 'paymentId' | 'authorizationUrl'>
    & { order: (
      { __typename: 'Order' }
      & OrderWithLineItemsFragment
    ) }
  ) }
);

export type AddPromotionToOrderMutationVariables = {
  id: Scalars['OrderId'],
  promotionCode: Scalars['String']
};


export type AddPromotionToOrderMutation = (
  { __typename: 'Mutation' }
  & { addPromotionToOrder: (
    { __typename: 'AddPromotionToOrderPayload' }
    & Pick<AddPromotionToOrderPayload, 'hasError' | 'errorMessage'>
    & { order: (
      { __typename: 'Order' }
      & OrderWithLineItemsFragment
    ) }
  ) }
);

export type DeletePaymentSourceMutationVariables = {
  id: Scalars['PaymentSourceId']
};


export type DeletePaymentSourceMutation = (
  { __typename: 'Mutation' }
  & { deletePaymentSource: (
    { __typename: 'DeletePaymentSourcePayload' }
    & Pick<DeletePaymentSourcePayload, 'error' | 'success'>
  ) }
);

export type UpdateAddressPreferencesMutationVariables = {
  input: UpdateAddressPreferencesInput
};


export type UpdateAddressPreferencesMutation = (
  { __typename: 'Mutation' }
  & { updateAddressPreferences: (
    { __typename: 'UpdateAddressPreferencesPayload' }
    & Pick<UpdateAddressPreferencesPayload, 'error'>
    & { updatedAddress: Maybe<(
      { __typename: 'Address' }
      & AddressFragment
    )> }
  ) }
);

export type UpdateOrderShippingAddressMutationVariables = {
  input: UpdateOrderShippingAddressInput
};


export type UpdateOrderShippingAddressMutation = (
  { __typename: 'Mutation' }
  & { updateOrderShippingAddress: (
    { __typename: 'UpdateOrderShippingAddressPayload' }
    & Pick<UpdateOrderShippingAddressPayload, 'hasError' | 'errorMessage'>
    & { order: (
      { __typename: 'Order' }
      & OrderWithLineItemsFragment
    ) }
  ) }
);

export type ShippingMethodCostFragment = (
  { __typename: 'ShippingMethodCost' }
  & Pick<ShippingMethodCost, 'shippingMethod' | 'estimatedToArriveAt'>
  & { cost: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ) }
);

export type OrderShippingCostQueryVariables = {
  id: Scalars['OrderId'],
  orderShippingCostAddress?: Maybe<OrderShippingCostAddressInput>
};


export type OrderShippingCostQuery = (
  { __typename: 'Query' }
  & { orderShippingCost: Maybe<(
    { __typename: 'OrderShippingCost' }
    & { shippingMethodCosts: Array<(
      { __typename: 'ShippingMethodCost' }
      & ShippingMethodCostFragment
    )> }
  )> }
);

export type UpdateShippingMethodMutationVariables = {
  orderId: Scalars['OrderId'],
  shippingMethod: ShippingMethod
};


export type UpdateShippingMethodMutation = (
  { __typename: 'Mutation' }
  & { updateShippingMethod: (
    { __typename: 'UpdateShippingMethodPayload' }
    & { order: (
      { __typename: 'Order' }
      & Pick<Order, 'id' | 'shippingMethod'>
      & { lineItems: Array<(
        { __typename: 'OrderLineItem' }
        & OrderLineItemFragment
      )>, totalShippingCost: (
        { __typename: 'MonetaryAmount' }
        & MonetaryAmountFragment
      ) }
    ) }
  ) }
);

export type ReusablePaymentSourcesQueryVariables = {};


export type ReusablePaymentSourcesQuery = (
  { __typename: 'Query' }
  & { reusablePaymentSources: Array<(
    { __typename: 'AffirmPaymentSource' }
    & PaymentSourceAffirmPaymentSourceFragment
  ) | (
    { __typename: 'AfterpayPaymentSource' }
    & PaymentSourceAfterpayPaymentSourceFragment
  ) | (
    { __typename: 'DealPaymentSource' }
    & PaymentSourceDealPaymentSourceFragment
  ) | (
    { __typename: 'PaypalPaymentSource' }
    & PaymentSourcePaypalPaymentSourceFragment
  ) | (
    { __typename: 'StripePaymentSource' }
    & PaymentSourceStripePaymentSourceFragment
  )> }
);

export type InitiateWireTransferForOrderMutationVariables = {
  input: InitiateWireTransferPaymentForOrderInput
};


export type InitiateWireTransferForOrderMutation = (
  { __typename: 'Mutation' }
  & { initiateWireTransferPaymentForOrder: (
    { __typename: 'InitiateWireTransferPaymentForOrderPayload' }
    & { paymentSource: (
      { __typename: 'AffirmPaymentSource' }
      & Pick<AffirmPaymentSource, 'id'>
    ) | (
      { __typename: 'AfterpayPaymentSource' }
      & Pick<AfterpayPaymentSource, 'id'>
    ) | (
      { __typename: 'DealPaymentSource' }
      & Pick<DealPaymentSource, 'id'>
    ) | (
      { __typename: 'PaypalPaymentSource' }
      & Pick<PaypalPaymentSource, 'id'>
    ) | (
      { __typename: 'StripePaymentSource' }
      & Pick<StripePaymentSource, 'id'>
    ) }
  ) }
);

export type SubmitWireOrderMutationVariables = {
  input: SubmitOrderInput
};


export type SubmitWireOrderMutation = (
  { __typename: 'Mutation' }
  & { submitOrder: (
    { __typename: 'SubmitOrderPayload' }
    & { order: (
      { __typename: 'Order' }
      & TrackableOrderFragment
    ) }
  ) }
);

export type AddTipToOrderMutationVariables = {
  input: AddTipToOrderInput
};


export type AddTipToOrderMutation = (
  { __typename: 'Mutation' }
  & { addTipToOrder: (
    { __typename: 'AddTipToOrderPayload' }
    & { order: (
      { __typename: 'Order' }
      & OrderWithLineItemsFragment
    ) }
  ) }
);

export type TipContainerOrderFragment = (
  { __typename: 'Order' }
  & Pick<Order, 'id' | 'state' | 'categoryType'>
  & { tip: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, tipMethod: (
    { __typename: 'TipMethodFixedAmount' }
    & Pick<TipMethodFixedAmount, 'type'>
    & { amountOptions: Array<(
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    )> }
  ) | (
    { __typename: 'TipMethodPercentOfAmount' }
    & Pick<TipMethodPercentOfAmount, 'type'>
    & { percentOptions: Array<(
      { __typename: 'TipMethodPercentOption' }
      & Pick<TipMethodPercentOption, 'rate'>
      & { maximumAmount: (
        { __typename: 'MonetaryAmount' }
        & MonetaryAmountFragment
      ), minimumAmount: (
        { __typename: 'MonetaryAmount' }
        & MonetaryAmountFragment
      ) }
    )> }
  ), lineItems: Array<(
    { __typename: 'OrderLineItem' }
    & Pick<OrderLineItem, 'id'>
    & { source: (
      { __typename: 'OrderLineItemAdHocSource' }
      & Pick<OrderLineItemAdHocSource, 'type'>
    ) | (
      { __typename: 'OrderLineItemBasePriceSource' }
      & Pick<OrderLineItemBasePriceSource, 'type'>
    ) | (
      { __typename: 'OrderLineItemExpertTipSource' }
      & Pick<OrderLineItemExpertTipSource, 'type'>
    ) | (
      { __typename: 'OrderLineItemGratuitySource' }
      & Pick<OrderLineItemGratuitySource, 'type'>
    ) | (
      { __typename: 'OrderLineItemPrepaidIncidentalSource' }
      & Pick<OrderLineItemPrepaidIncidentalSource, 'type'>
    ) | (
      { __typename: 'OrderLineItemRefundSource' }
      & Pick<OrderLineItemRefundSource, 'type'>
    ) | (
      { __typename: 'OrderLineItemSellableSource' }
      & Pick<OrderLineItemSellableSource, 'type'>
      & { sellable: (
        { __typename: 'Sellable' }
        & Pick<Sellable, 'id' | 'type'>
        & { originalPrice: Maybe<(
          { __typename: 'MonetaryAmount' }
          & MonetaryAmountFragment
        )> }
      ) }
    ) | (
      { __typename: 'OrderLineItemShipmentSource' }
      & Pick<OrderLineItemShipmentSource, 'type'>
    ) }
  )>, subtotal: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ) }
);

export type ExpertTipPercentageFragment = (
  { __typename: 'ExpertTipPercentage' }
  & Pick<ExpertTipPercentage, 'percentOfTip'>
  & { expert: (
    { __typename: 'BusinessUser' }
    & Pick<BusinessUser, 'id' | 'displayName' | 'shortName' | 'active'>
    & { expertProfile: Maybe<(
      { __typename: 'ExpertProfile' }
      & Pick<ExpertProfile, 'id'>
      & { profilePhoto: Maybe<(
        { __typename: 'MediaFile' }
        & MediaFileFragment
      )> }
    )> }
  ) }
);

export type RecommendTipPercentagesForOrderQueryVariables = {
  id: Scalars['OrderId']
};


export type RecommendTipPercentagesForOrderQuery = (
  { __typename: 'Query' }
  & { recommendTipPercentagesForOrder: Array<(
    { __typename: 'ExpertTipPercentage' }
    & ExpertTipPercentageFragment
  )> }
);

export type OrderSellableInfoFragment = (
  { __typename: 'OrderLineItemSellableSource' }
  & { sellable: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id' | 'title'>
    & { images: Array<(
      { __typename: 'MediaFile' }
      & Pick<MediaFile, 'url'>
    )>, originalPrice: Maybe<(
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    )>, salePrice: Maybe<(
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    )> }
  ), overridePrice: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )> }
);

export type OrderWithLineItemsFragment = (
  { __typename: 'Order' }
  & Pick<Order, 'estimatedToArriveAt' | 'shippingMethod' | 'consumerFriendlyId' | 'depositPaidAt' | 'fullPaymentDueAt' | 'paidInFullAt'>
  & { user: (
    { __typename: 'User' }
    & Pick<User, 'id'>
    & { expertReviews: Array<(
      { __typename: 'ConsumerExpertReview' }
      & Pick<ConsumerExpertReview, 'id'>
      & { expert: (
        { __typename: 'BusinessUser' }
        & Pick<BusinessUser, 'id'>
      ) }
    )> }
  ), appliedPromotionEntry: Maybe<(
    { __typename: 'OrderPromotionEntry' }
    & Pick<OrderPromotionEntry, 'applied'>
    & { discount: (
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    ), promotion: (
      { __typename: 'Promotion' }
      & Pick<Promotion, 'id' | 'code'>
    ) }
  )>, promotionEntries: Array<(
    { __typename: 'OrderPromotionEntry' }
    & Pick<OrderPromotionEntry, 'applied'>
    & { discount: (
      { __typename: 'MonetaryAmount' }
      & MonetaryAmountFragment
    ), promotion: (
      { __typename: 'Promotion' }
      & Pick<Promotion, 'id' | 'code'>
    ) }
  )>, chargeableStatus: (
    { __typename: 'OrderChargeableStatus' }
    & Pick<OrderChargeableStatus, 'type' | 'message'>
  ), remainingBalance: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), minimumDeposit: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, paidAmount: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), lineItems: Array<(
    { __typename: 'OrderLineItem' }
    & OrderLineItemFragment
  )>, serviceLocation: Maybe<(
    { __typename: 'PostalAddress' }
    & Pick<PostalAddress, 'displayTitle'>
  )>, simpleCuratedOrder: Maybe<(
    { __typename: 'SimpleCuratedOrder' }
    & Pick<SimpleCuratedOrder, 'id' | 'type'>
  )> }
  & OrderFragment
  & TrackableOrderFragment
  & TipContainerOrderFragment
);

export type TrackableOrderFragment = (
  { __typename: 'Order' }
  & Pick<Order, 'id' | 'state'>
  & { tax: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), tip: Maybe<(
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  )>, totalCost: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), totalShippingCost: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), subtotal: (
    { __typename: 'MonetaryAmount' }
    & MonetaryAmountFragment
  ), appliedPromotionEntry: Maybe<(
    { __typename: 'OrderPromotionEntry' }
    & { promotion: (
      { __typename: 'Promotion' }
      & Pick<Promotion, 'id' | 'code'>
    ) }
  )>, lineItems: Array<(
    { __typename: 'OrderLineItem' }
    & Pick<OrderLineItem, 'id' | 'quantity'>
    & { source: { __typename: 'OrderLineItemAdHocSource' } | { __typename: 'OrderLineItemBasePriceSource' } | { __typename: 'OrderLineItemExpertTipSource' } | { __typename: 'OrderLineItemGratuitySource' } | { __typename: 'OrderLineItemPrepaidIncidentalSource' } | { __typename: 'OrderLineItemRefundSource' } | (
      { __typename: 'OrderLineItemSellableSource' }
      & { sellable: (
        { __typename: 'Sellable' }
        & TrackableSellableFragment
      ) }
    ) | { __typename: 'OrderLineItemShipmentSource' } }
  )> }
);

export type CancelPaymentRequestForOrderMutationVariables = {
  input: CancelPaymentRequestForOrderInput
};


export type CancelPaymentRequestForOrderMutation = (
  { __typename: 'Mutation' }
  & { cancelPaymentRequestForOrder: (
    { __typename: 'CancelPaymentRequestForOrderPayload' }
    & { order: (
      { __typename: 'Order' }
      & OrderWithLineItemsFragment
    ) }
  ) }
);

export type DeleteAddressMutationVariables = {
  input: DeleteAddressInput
};


export type DeleteAddressMutation = (
  { __typename: 'Mutation' }
  & { deleteAddress: (
    { __typename: 'DeleteAddressPayload' }
    & Pick<DeleteAddressPayload, 'error' | 'success'>
  ) }
);

export type MarkPaymentPreApprovalFailedForOrderMutationVariables = {
  input: MarkPaymentPreApprovalFailedForOrderInput
};


export type MarkPaymentPreApprovalFailedForOrderMutation = (
  { __typename: 'Mutation' }
  & { markPaymentPreApprovalFailedForOrder: (
    { __typename: 'MarkPaymentPreApprovalFailedForOrderPayload' }
    & { order: (
      { __typename: 'Order' }
      & OrderWithLineItemsFragment
    ) }
  ) }
);

export type PayForOrderMutationVariables = {
  input: PayForOrderInput
};


export type PayForOrderMutation = (
  { __typename: 'Mutation' }
  & { payForOrder: (
    { __typename: 'PayForOrderPayload' }
    & Pick<PayForOrderPayload, 'error'>
    & { order: Maybe<(
      { __typename: 'Order' }
      & OrderWithLineItemsFragment
    )> }
  ) }
);

export type ProductDetailsFragment = (
  { __typename: 'Sellable' }
  & Pick<Sellable, 'id'>
  & { department: Maybe<(
    { __typename: 'Department' }
    & Pick<Department, 'id'>
    & { mostRecentLeadForConsumer: Maybe<(
      { __typename: 'Lead' }
      & Pick<Lead, 'id'>
    )> }
  )>, categories: Array<(
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'singularDisplayName' | 'pluralDisplayName'>
  )> }
  & SellableDetailsFragment
  & TrackableSellableFragment
);

export type ReviewStatsFragment = (
  { __typename: 'AggregateExpertReport' }
  & { globalStats: (
    { __typename: 'GlobalStatsAggregateExpertReport' }
    & Pick<GlobalStatsAggregateExpertReport, 'reviewsCount' | 'averageExpertRating'>
  ) }
);

export type ProductByFriendlyIdOrIdQueryVariables = {
  friendlyIdOrId: Scalars['String']
};


export type ProductByFriendlyIdOrIdQuery = (
  { __typename: 'Query' }
  & { findSellable: Maybe<(
    { __typename: 'Sellable' }
    & ProductDetailsFragment
  )>, aggregateExpertReport: (
    { __typename: 'AggregateExpertReport' }
    & ReviewStatsFragment
  ) }
);

export type ExistingLeadFragment = (
  { __typename: 'Lead' }
  & Pick<Lead, 'id'>
  & { conversation: (
    { __typename: 'Conversation' }
    & Pick<Conversation, 'id' | 'externalId'>
  ) }
);

export type ProductRecommendedExpertFragment = (
  { __typename: 'RecommendExpertPayload' }
  & { existingLead: Maybe<(
    { __typename: 'Lead' }
    & ExistingLeadFragment
  )>, expert: Maybe<(
    { __typename: 'BusinessUser' }
    & ProductExpertFragment
  )> }
);

export type ProductExpertQueryVariables = {
  consumerId: Scalars['UserId'],
  categoryId: Scalars['CategoryId']
};


export type ProductExpertQuery = (
  { __typename: 'Query' }
  & { recommendExpert2: (
    { __typename: 'RecommendExpertPayload' }
    & ProductRecommendedExpertFragment
  ) }
);

export type ExpertCuratedItemNoteFragment = (
  { __typename: 'ExpertCuratedItemNote' }
  & Pick<ExpertCuratedItemNote, 'id' | 'text' | 'useCount'>
  & { createdBy: (
    { __typename: 'BusinessUser' }
    & ProductExpertFragment
  ), sellable: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id'>
    & { categories: Array<(
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'singularDisplayName'>
    )> }
  ) }
);

export type ExpertSellableNotesQueryVariables = {
  query: SuggestExpertCuratedItemNotesQueryInput
};


export type ExpertSellableNotesQuery = (
  { __typename: 'Query' }
  & { suggestExpertCuratedItemNotes: (
    { __typename: 'SuggestExpertCuratedItemNotesConnection' }
    & { edges: Array<(
      { __typename: 'SuggestExpertCuratedItemNotesEdge' }
      & { node: (
        { __typename: 'ExpertCuratedItemNote' }
        & ExpertCuratedItemNoteFragment
      ) }
    )> }
  ) }
);

export type ProductExpertFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'vanityId' | 'displayName' | 'shortName'>
  & { expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & ExpertStatsFragment
  )>, expertAttributes: (
    { __typename: 'BusinessUserExpertAttributes' }
    & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>
  ), expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id' | 'headline'>
    & { highlights: Array<(
      { __typename: 'ProfileHighlight' }
      & ExpertProfileHighlightsFragment
    )>, profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
  )>, department: (
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'type'>
  ) }
);

export type RecommendedProductsByCategoryQueryVariables = {
  query: RecommendedListsQuery
};


export type RecommendedProductsByCategoryQuery = (
  { __typename: 'Query' }
  & { recommendedLists: (
    { __typename: 'RecommendedListConnection' }
    & { edges: Array<(
      { __typename: 'RecommendedListEdge' }
      & Pick<RecommendedListEdge, 'cursor'>
      & { node: (
        { __typename: 'RecommendedList' }
        & Pick<RecommendedList, 'displayName'>
        & { recommendedListDefinition: Maybe<(
          { __typename: 'RecommendedListDefinition' }
          & Pick<RecommendedListDefinition, 'id' | 'rank'>
        )>, sellables: Array<(
          { __typename: 'Sellable' }
          & RecommendedListSellableCardFragment
        )> }
      ) }
    )> }
  ) }
);

export type RequestSellablePriceMatchMutationVariables = {
  input: RequestSellablePriceMatchInput
};


export type RequestSellablePriceMatchMutation = (
  { __typename: 'Mutation' }
  & { requestSellablePriceMatch: (
    { __typename: 'RequestSellablePriceMatchPayload' }
    & Pick<RequestSellablePriceMatchPayload, 'error'>
    & { lead: Maybe<(
      { __typename: 'Lead' }
      & Pick<Lead, 'id'>
    )> }
  ) }
);

export type SellablePriceComparisonsQueryVariables = {
  sellableId: Scalars['SellableId']
};


export type SellablePriceComparisonsQuery = (
  { __typename: 'Query' }
  & { sellable: (
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id'>
    & { otherOnlineRetailers: Array<(
      { __typename: 'SellableOnlineRetailer' }
      & Pick<SellableOnlineRetailer, 'name' | 'freeShipping'>
      & { salePrice: (
        { __typename: 'MonetaryAmount' }
        & MonetaryAmountFragment
      ) }
    )> }
  ) }
);

export type UserLeadForSellableDepartmentQueryVariables = {
  id: Scalars['DepartmentId']
};


export type UserLeadForSellableDepartmentQuery = (
  { __typename: 'Query' }
  & { department: (
    { __typename: 'Department' }
    & Pick<Department, 'id'>
    & { mostRecentLeadForConsumer: Maybe<(
      { __typename: 'Lead' }
      & Pick<Lead, 'id'>
      & { expert: (
        { __typename: 'BusinessUser' }
        & Pick<BusinessUser, 'id'>
      ) }
    )> }
  ) }
);

export type AllowedToReferQueryVariables = {};


export type AllowedToReferQuery = (
  { __typename: 'Query' }
  & { me: Maybe<(
    { __typename: 'Myself' }
    & Pick<Myself, 'id'>
    & { user: (
      { __typename: 'User' }
      & Pick<User, 'id' | 'isAllowedToRefer'>
    ) }
  )> }
);

export type ShareReferralCodeViaEmailMutationVariables = {
  referralCodeId: Scalars['ReferralCodeId'],
  emails: Array<Scalars['String']>,
  note?: Maybe<Scalars['String']>
};


export type ShareReferralCodeViaEmailMutation = (
  { __typename: 'Mutation' }
  & { shareReferralCodeViaEmail: (
    { __typename: 'ReferralCodeSharePayload' }
    & Pick<ReferralCodeSharePayload, 'shareCount' | 'errors'>
  ) }
);

export type ExpertToRecommendFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
  & { expertAttributes: (
    { __typename: 'BusinessUserExpertAttributes' }
    & { category: (
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'singularDisplayName'>
    ) }
  ), expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
  )> }
);

export type ReferralSourceConsumerGenericFragment = (
  { __typename: 'ReferralSourceConsumerGeneric' }
  & Pick<ReferralSourceConsumerGeneric, 'type'>
);

export type ReferralSourceConsumerToExpertFragment = (
  { __typename: 'ReferralSourceConsumerToExpert' }
  & Pick<ReferralSourceConsumerToExpert, 'type'>
  & { referredToExpert: (
    { __typename: 'BusinessUser' }
    & ExpertToRecommendFragment
  ) }
);

export type ReferralCodeFragment = (
  { __typename: 'ReferralCode' }
  & Pick<ReferralCode, 'id' | 'code' | 'urlWithoutTracking'>
  & { facebookShortenedUrl: ReferralCode['shortenedUrl'], smsShortenedUrl: ReferralCode['shortenedUrl'], linkShortenedUrl: ReferralCode['shortenedUrl'], emailShortenedUrl: ReferralCode['shortenedUrl'] }
  & { source: (
    { __typename: 'ReferralSourceConsumerGeneric' }
    & ReferralSourceConsumerGenericFragment
  ) | (
    { __typename: 'ReferralSourceConsumerToExpert' }
    & ReferralSourceConsumerToExpertFragment
  ) | { __typename: 'ReferralSourceExpertDirect' } }
);

export type PotentialConsumerReferralSourcesQueryVariables = {
  sourceKey: Scalars['String'],
  expertId?: Maybe<Scalars['BusinessUserId']>
};


export type PotentialConsumerReferralSourcesQuery = (
  { __typename: 'Query' }
  & { potentialConsumerReferralSources: Array<(
    { __typename: 'ReferralCode' }
    & ReferralCodeFragment
  )> }
);

export type RefereeExpertReviewFragment = (
  { __typename: 'ConsumerExpertReview' }
  & Pick<ConsumerExpertReview, 'id' | 'rating' | 'headline' | 'comments' | 'goodQualities' | 'reviewedAt'>
  & { consumer: (
    { __typename: 'User' }
    & Pick<User, 'id' | 'firstName'>
  ), verifiedPurchases: Array<(
    { __typename: 'Sellable' }
    & ActivityFeedSellableFragment
  )> }
);

export type LookupRefereeExpertReviewQueryVariables = {
  expertId: Scalars['BusinessUserId'],
  userId: Scalars['UserId']
};


export type LookupRefereeExpertReviewQuery = (
  { __typename: 'Query' }
  & { user: (
    { __typename: 'User' }
    & Pick<User, 'id'>
    & { expertReviews: Array<(
      { __typename: 'ConsumerExpertReview' }
      & RefereeExpertReviewFragment
    )> }
  ) }
);

export type ReferralExpertFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'displayName' | 'shortName' | 'vanityId' | 'state'>
  & { department: (
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'slug' | 'type'>
  ), expertPresence: (
    { __typename: 'ExpertPresenceAway' }
    & Pick<ExpertPresenceAway, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOffShift' }
    & Pick<ExpertPresenceOffShift, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOnCall' }
    & Pick<ExpertPresenceOnCall, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOnShift' }
    & Pick<ExpertPresenceOnShift, 'status'>
  ), expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & Pick<ExpertStats, 'totalReviews' | 'averageRating' | 'totalLeadsAsPrimaryExpert'>
  )>, expertAttributes: (
    { __typename: 'BusinessUserExpertAttributes' }
    & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>
    & { category: (
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'singularDisplayName' | 'slug'>
    ) }
  ), expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id' | 'background' | 'headline'>
    & { socialMediaLinks: Array<(
      { __typename: 'SocialMediaLink' }
      & Pick<SocialMediaLink, 'url' | 'socialMediaType'>
    )>, profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )>, highlights: Array<(
      { __typename: 'ProfileHighlight' }
      & ExpertProfileHighlightsFragment
    )> }
  )> }
);

export type RefereeFragment = (
  { __typename: 'User' }
  & Pick<User, 'id' | 'firstName'>
);

export type LandingPageReferralSourceConsumerGenericFragment = (
  { __typename: 'ReferralSourceConsumerGeneric' }
  & Pick<ReferralSourceConsumerGeneric, 'type'>
  & { expertsToRefer: Array<(
    { __typename: 'BusinessUser' }
    & ReferralExpertFragment
  )>, user: (
    { __typename: 'User' }
    & RefereeFragment
  ) }
);

export type LandingPageReferralSourceConsumerToExpertFragment = (
  { __typename: 'ReferralSourceConsumerToExpert' }
  & Pick<ReferralSourceConsumerToExpert, 'type'>
  & { referredToExpert: (
    { __typename: 'BusinessUser' }
    & ReferralExpertFragment
  ), user: (
    { __typename: 'User' }
    & RefereeFragment
  ) }
);

export type LandingPageReferralSourceExpertDirectFragment = (
  { __typename: 'ReferralSourceExpertDirect' }
  & Pick<ReferralSourceExpertDirect, 'type'>
  & { referredByExpert: (
    { __typename: 'BusinessUser' }
    & ReferralExpertFragment
  ) }
);

export type LookupReferralCodeFragment = (
  { __typename: 'ReferralCode' }
  & Pick<ReferralCode, 'id' | 'code'>
  & { source: (
    { __typename: 'ReferralSourceConsumerGeneric' }
    & LandingPageReferralSourceConsumerGenericFragment
  ) | (
    { __typename: 'ReferralSourceConsumerToExpert' }
    & LandingPageReferralSourceConsumerToExpertFragment
  ) | (
    { __typename: 'ReferralSourceExpertDirect' }
    & LandingPageReferralSourceExpertDirectFragment
  ) }
);

export type LookupReferralCodeQueryVariables = {
  code: Scalars['String']
};


export type LookupReferralCodeQuery = (
  { __typename: 'Query' }
  & { lookupReferralCode: (
    { __typename: 'LookupReferralCodePayload' }
    & Pick<LookupReferralCodePayload, 'errorCode'>
    & { referralCode: Maybe<(
      { __typename: 'ReferralCode' }
      & LookupReferralCodeFragment
    )> }
  ) }
);

export type ReferralCategoryFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id' | 'pluralDisplayName' | 'slug'>
  & { department: Maybe<(
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'type'>
  )> }
);

export type ReferralDepartmentFragment = (
  { __typename: 'Department' }
  & Pick<Department, 'id'>
  & { topLevelCategory: (
    { __typename: 'Category' }
    & Pick<Category, 'id'>
    & { expertCategories: Array<(
      { __typename: 'Category' }
      & ReferralCategoryFragment
    )> }
  ) }
);

export type ActiveExpertCategoriesQueryVariables = {};


export type ActiveExpertCategoriesQuery = (
  { __typename: 'Query' }
  & { departmentsForNavigation: Array<(
    { __typename: 'Department' }
    & ReferralDepartmentFragment
  )> }
);

export type ReenterPathFlowPageMutationVariables = {
  input: ReenterPathFlowPageInput
};


export type ReenterPathFlowPageMutation = (
  { __typename: 'Mutation' }
  & { reenterPathFlowPage: (
    { __typename: 'ReenterPathFlowPagePayload' }
    & { flow: Maybe<(
      { __typename: 'PathFlow' }
      & PathFlowFragment
    )> }
  ) }
);

export type GlobalStatsFragment = (
  { __typename: 'GlobalStatsAggregateExpertReport' }
  & Pick<GlobalStatsAggregateExpertReport, 'conversationsCountThisWeek' | 'conversationsCountTotal' | 'curationsCountTotal' | 'curationsCountThisWeek'>
);

export type CommunityAggregateStatsQueryVariables = {};


export type CommunityAggregateStatsQuery = (
  { __typename: 'Query' }
  & { aggregateExpertReport: (
    { __typename: 'AggregateExpertReport' }
    & { globalStats: (
      { __typename: 'GlobalStatsAggregateExpertReport' }
      & GlobalStatsFragment
    ) }
  ) }
);

export type TopLevelCategoryFragment = (
  { __typename: 'Category' }
  & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'>
  & { contentAssets: (
    { __typename: 'CategoryContentAssets' }
    & { communityPoster: Maybe<(
      { __typename: 'ContentAsset' }
      & Pick<ContentAsset, 'imageUrl'>
    )> }
  ) }
);

export type CommunityLeadExpertFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
  & { expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id' | 'background' | 'headline'>
    & { socialMediaLinks: Array<(
      { __typename: 'SocialMediaLink' }
      & Pick<SocialMediaLink, 'socialMediaType' | 'url'>
    )>, highlights: Array<(
      { __typename: 'ProfileHighlight' }
      & ExpertProfileHighlightsFragment
    )>, profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & Pick<MediaFile, 'id' | 'url'>
    )> }
    & ExpertProfilePhotoCarouselFragment
  )>, expertAttributes: (
    { __typename: 'BusinessUserExpertAttributes' }
    & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>
  ), expertPresence: (
    { __typename: 'ExpertPresenceAway' }
    & Pick<ExpertPresenceAway, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOffShift' }
    & Pick<ExpertPresenceOffShift, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOnCall' }
    & Pick<ExpertPresenceOnCall, 'status'>
  ) | (
    { __typename: 'ExpertPresenceOnShift' }
    & Pick<ExpertPresenceOnShift, 'status'>
  ), expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & Pick<ExpertStats, 'totalReviews' | 'totalLeadsAsPrimaryExpert' | 'averageRating'>
  )>, department: (
    { __typename: 'Department' }
    & Pick<Department, 'id' | 'slug' | 'type'>
  ) }
);

export type DepartmentBySlugQueryVariables = {
  slug: Scalars['String']
};


export type DepartmentBySlugQuery = (
  { __typename: 'Query' }
  & { departmentBySlug: Maybe<(
    { __typename: 'Department' }
    & { mostRecentLeadForConsumer: Maybe<(
      { __typename: 'Lead' }
      & Pick<Lead, 'id'>
      & { expert: (
        { __typename: 'BusinessUser' }
        & CommunityLeadExpertFragment
      ) }
    )>, topLevelCategories: Array<(
      { __typename: 'Category' }
      & TopLevelCategoryFragment
    )> }
    & DepartmentContextFragment
  )> }
);

export type ReviewSummaryBucketsFragment = (
  { __typename: 'BucketedDisplayFacet' }
  & { buckets: Array<(
    { __typename: 'IndividualBucketedDisplayFacet' }
    & Pick<IndividualBucketedDisplayFacet, 'count' | 'value'>
  )> }
);

export type DepartmentCuratedActivityFeedQueryVariables = {
  query: ConsumerReviewSearchQuery,
  after?: Maybe<Scalars['String']>,
  sortBy: ConsumerReviewSearchSort
};


export type DepartmentCuratedActivityFeedQuery = (
  { __typename: 'Query' }
  & { consumerExpertReviewConnection: (
    { __typename: 'ConsumerExpertReviewConnection' }
    & Pick<ConsumerExpertReviewConnection, 'count'>
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & PageInfoFragment
    ), facets: Array<(
      { __typename: 'BucketedDisplayFacet' }
      & Pick<BucketedDisplayFacet, 'displayName' | 'alias' | 'name'>
      & ReviewSummaryBucketsFragment
    ) | (
      { __typename: 'BucketedRangeDisplayFacet' }
      & Pick<BucketedRangeDisplayFacet, 'displayName' | 'alias' | 'name'>
    ) | (
      { __typename: 'NumericRangeDisplayFacet' }
      & Pick<NumericRangeDisplayFacet, 'displayName' | 'alias' | 'name'>
    )>, edges: Array<(
      { __typename: 'ConsumerExpertReviewEdge' }
      & Pick<ConsumerExpertReviewEdge, 'cursor'>
      & { node: (
        { __typename: 'ConsumerExpertReview' }
        & ConsumerExpertReviewFragment
      ) }
    )> }
  ) }
);

export type GlobalReviewStatisticsFragment = (
  { __typename: 'ConsumerExpertReviewConnection' }
  & Pick<ConsumerExpertReviewConnection, 'count'>
  & { facets: Array<(
    { __typename: 'BucketedDisplayFacet' }
    & Pick<BucketedDisplayFacet, 'displayName' | 'alias' | 'name'>
    & { buckets: Array<(
      { __typename: 'IndividualBucketedDisplayFacet' }
      & Pick<IndividualBucketedDisplayFacet, 'count' | 'value'>
    )> }
  ) | (
    { __typename: 'BucketedRangeDisplayFacet' }
    & Pick<BucketedRangeDisplayFacet, 'displayName' | 'alias' | 'name'>
  ) | (
    { __typename: 'NumericRangeDisplayFacet' }
    & Pick<NumericRangeDisplayFacet, 'displayName' | 'alias' | 'name'>
  )> }
);

export type GlobalReviewCountsQueryVariables = {};


export type GlobalReviewCountsQuery = (
  { __typename: 'Query' }
  & { consumerExpertReviewConnection: (
    { __typename: 'ConsumerExpertReviewConnection' }
    & GlobalReviewStatisticsFragment
  ) }
);

export type SellableByIdQueryVariables = {
  friendlyIdOrId: Scalars['String']
};


export type SellableByIdQuery = (
  { __typename: 'Query' }
  & { findSellable: Maybe<(
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type'>
  )> }
);

export type OrderEscalationSummaryFragment = (
  { __typename: 'OrderEscalation' }
  & Pick<OrderEscalation, 'id' | 'consumerFriendlyId' | 'createdAt' | 'type' | 'status'>
  & { assignedTo: Maybe<(
    { __typename: 'Operator' }
    & Pick<Operator, 'id' | 'firstName'>
  )> }
);

export type OrderEscalationSearchResultFragment = (
  { __typename: 'OrderEscalationEdge' }
  & Pick<OrderEscalationEdge, 'cursor'>
  & { node: (
    { __typename: 'OrderEscalation' }
    & OrderEscalationSummaryFragment
  ) }
);

export type SearchOrderEscalationsQueryVariables = {
  pageSize?: Maybe<Scalars['Int']>,
  userIds?: Maybe<Array<Scalars['UserId']>>
};


export type SearchOrderEscalationsQuery = (
  { __typename: 'Query' }
  & { orderEscalations: (
    { __typename: 'OrderEscalationConnection' }
    & { edges: Array<(
      { __typename: 'OrderEscalationEdge' }
      & OrderEscalationSearchResultFragment
    )> }
  ) }
);

export type SellableDetailsForExpertItemQueryVariables = {
  friendlyIdOrId: Scalars['String']
};


export type SellableDetailsForExpertItemQuery = (
  { __typename: 'Query' }
  & { findSellable: Maybe<(
    { __typename: 'Sellable' }
    & Pick<Sellable, 'id' | 'title'>
    & { images: Array<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
    & SellablePricingWithDefaultVariantFragment
  )> }
);

export type TopicPageExpertFragment = (
  { __typename: 'BusinessUser' }
  & Pick<BusinessUser, 'id' | 'displayName' | 'shortName'>
  & { expertProfile: Maybe<(
    { __typename: 'ExpertProfile' }
    & Pick<ExpertProfile, 'id' | 'location'>
    & { profilePhoto: Maybe<(
      { __typename: 'MediaFile' }
      & MediaFileFragment
    )> }
  )>, expertStats: Maybe<(
    { __typename: 'ExpertStats' }
    & ExpertStatsFragment
  )> }
);

export type TopicExpertsQueryVariables = {
  departmentId: Scalars['DepartmentId']
};


export type TopicExpertsQuery = (
  { __typename: 'Query' }
  & { recommendExpertsForDepartment: Array<(
    { __typename: 'RecommendedExpert' }
    & { expert: (
      { __typename: 'BusinessUser' }
      & TopicPageExpertFragment
    ) }
  )> }
);

export const AuthenticationStateFragmentDoc = gql`
    fragment AuthenticationState on Session {
  id
  authenticationMethod
  authenticationState {
    handle
    handleId
    loginChallengeType
    resetPasswordChallengeVerified
  }
}
    `;
export const MediaFileFragmentDoc = gql`
    fragment MediaFile on MediaFile {
  id
  url
  mimeType
  size
  persisted
}
    `;
export const HeroCuratedExpertFragmentDoc = gql`
    fragment HeroCuratedExpert on BusinessUser {
  id
  vanityId
  displayName
  shortName
  expertAttributes {
    placeholderExpert
  }
  expertProfile {
    id
    profilePhoto {
      ...MediaFile
    }
  }
}
    ${MediaFileFragmentDoc}`;
export const HeroCuratedItemsLeadFragmentDoc = gql`
    fragment HeroCuratedItemsLead on Lead {
  id
  conversation {
    id
  }
  expert {
    ...HeroCuratedExpert
  }
  consumerConversationMetrics {
    messageCount
  }
  expertConversationMetrics {
    messageCount
  }
  department {
    id
    type
  }
}
    ${HeroCuratedExpertFragmentDoc}`;
export const HeroExpertCuratedItemImageFragmentDoc = gql`
    fragment HeroExpertCuratedItemImage on ExpertCuratedItem {
  id
  category {
    id
    singularDisplayName
  }
  note {
    id
  }
  sellable {
    id
    title
    images {
      id
      url
    }
  }
}
    `;
export const DepartmentExpertReviewFragmentDoc = gql`
    fragment DepartmentExpertReview on ConsumerExpertReview {
  id
  comments
  goodQualities
  headline
  rating
  consumer {
    id
    firstName
    lastName
  }
  expert {
    id
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
    displayName
    shortName
  }
  reviewedAt
}
    ${MediaFileFragmentDoc}`;
export const PathCategoryFragmentDoc = gql`
    fragment PathCategory on Category {
  id
  slug
  parents {
    id
    slug
  }
}
    `;
export const EngagementChannelCategoryFragmentDoc = gql`
    fragment EngagementChannelCategory on Category {
  id
  slug
  department {
    id
    type
    slug
    acceptingRequests
    launched
  }
  contentAssets {
    fixedBarDesktop {
      imageUrl
    }
    callout {
      imageUrl
    }
    fullPageTakeover {
      imageUrl
    }
  }
  ancestorWithPath {
    id
    slug
  }
  ...PathCategory
}
    ${PathCategoryFragmentDoc}`;
export const MonetaryAmountFragmentDoc = gql`
    fragment MonetaryAmount on MonetaryAmount {
  currency
  amount
  amountInSmallestDenomination: amount(denominationType: SMALLEST)
}
    `;
export const SellablePricingFragmentDoc = gql`
    fragment SellablePricing on Sellable {
  id
  salePrice {
    ...MonetaryAmount
  }
  originalPrice {
    ...MonetaryAmount
  }
}
    ${MonetaryAmountFragmentDoc}`;
export const SellablePricingWithDefaultVariantFragmentDoc = gql`
    fragment SellablePricingWithDefaultVariant on Sellable {
  ...SellablePricing
  variationMatrix {
    defaultVariant {
      id
      salePrice {
        ...MonetaryAmount
      }
      originalPrice {
        ...MonetaryAmount
      }
    }
  }
}
    ${SellablePricingFragmentDoc}
${MonetaryAmountFragmentDoc}`;
export const SellableForModalFragmentDoc = gql`
    fragment SellableForModal on Sellable {
  id
  title
  images {
    ...MediaFile
  }
  ...SellablePricingWithDefaultVariant
}
    ${MediaFileFragmentDoc}
${SellablePricingWithDefaultVariantFragmentDoc}`;
export const CategoryModalFragmentDoc = gql`
    fragment CategoryModal on Category {
  id
  slug
  pluralDisplayName
  singularDisplayName
  ancestorWithPath {
    id
    slug
  }
}
    `;
export const ExperienceAttributeFragmentDoc = gql`
    fragment ExperienceAttribute on Attribute {
  formatted {
    name
    displayHtml
  }
}
    `;
export const DepartmentContextFragmentDoc = gql`
    fragment DepartmentContext on Department {
  id
  type
  slug
  displayName
  acceptingRequests
  launched
  topLevelCategory {
    id
    slug
    type
  }
}
    `;
export const SellableDetailsVariantFragmentDoc = gql`
    fragment SellableDetailsVariant on SellableFormattedVariant {
  name
  displayName
  value
  displayValueHtml
}
    `;
export const SellableSpecificationFragmentDoc = gql`
    fragment SellableSpecification on SellableSpecification {
  key
  name
  valueHtml
}
    `;
export const BrandFragmentDoc = gql`
    fragment Brand on Brand {
  id
  name
  displayName
  logo {
    ...MediaFile
  }
}
    ${MediaFileFragmentDoc}`;
export const CategoryBreadcrumbFragmentDoc = gql`
    fragment CategoryBreadcrumb on Category {
  id
  slug
  pluralDisplayName
}
    `;
export const SellableUrlFragmentDoc = gql`
    fragment SellableUrl on Sellable {
  id
  friendlyId
  slug
  type
}
    `;
export const ConsumerSellableReactionFragmentDoc = gql`
    fragment ConsumerSellableReaction on ConsumerSellableReaction {
  id
  ratingWithDisplayName {
    rating
    displayName
  }
  recommendedBy {
    id
  }
}
    `;
export const VideoReviewFragmentDoc = gql`
    fragment VideoReview on ExternalVideo {
  id
  idType
  destinationUrl
}
    `;
export const FeaturedContentFragmentDoc = gql`
    fragment FeaturedContent on Sellable {
  id
  featuredContent {
    id
    externalVideos {
      ...VideoReview
    }
  }
}
    ${VideoReviewFragmentDoc}`;
export const SellableDetailsFragmentDoc = gql`
    fragment SellableDetails on Sellable {
  id
  type
  adHoc
  descriptionText
  descriptionMarkdown
  features
  active
  outOfStock
  inShortSupply
  department {
    ...DepartmentContext
  }
  savedSellable {
    id
    saved
  }
  variant
  variants {
    ...SellableDetailsVariant
  }
  specifications {
    ...SellableSpecification
  }
  images {
    ...MediaFile
  }
  brand {
    ...Brand
  }
  metrics {
    totalUniquePVsInPastWeek
    totalPurchasesInLast30Days
    timesRecommendedByExpert
  }
  serviceLocation {
    displayTitle
  }
  categories {
    id
    slug
    breadcrumbs: parents {
      ...CategoryBreadcrumb
    }
  }
  parent {
    id
    metrics {
      totalUniquePVsInPastWeek
      totalPurchasesInLast30Days
    }
    savedSellable {
      id
      saved
    }
    department {
      ...DepartmentContext
    }
  }
  variationMatrix {
    defaultVariant {
      id
      active
      outOfStock
      originalPrice {
        ...MonetaryAmount
      }
      salePrice {
        ...MonetaryAmount
      }
      ...SellableUrl
    }
    outOfStockSellables {
      id
    }
    priceRange {
      max {
        ...MonetaryAmount
      }
      min {
        ...MonetaryAmount
      }
    }
  }
  salePrice {
    ...MonetaryAmount
  }
  originalPrice {
    ...MonetaryAmount
  }
  consumerSellableReactions {
    edges {
      node {
        ...ConsumerSellableReaction
      }
    }
  }
  recentExpertCuratedItem {
    id
    salePrice {
      ...MonetaryAmount
    }
    sellable {
      id
    }
  }
  ...FeaturedContent
}
    ${DepartmentContextFragmentDoc}
${SellableDetailsVariantFragmentDoc}
${SellableSpecificationFragmentDoc}
${MediaFileFragmentDoc}
${BrandFragmentDoc}
${CategoryBreadcrumbFragmentDoc}
${MonetaryAmountFragmentDoc}
${SellableUrlFragmentDoc}
${ConsumerSellableReactionFragmentDoc}
${FeaturedContentFragmentDoc}`;
export const CategoryDataFragmentDoc = gql`
    fragment CategoryData on Category {
  id
  name
  slug
}
    `;
export const TrackableSellableFragmentDoc = gql`
    fragment TrackableSellable on Sellable {
  id
  friendlyId
  slug
  type
  googleId
  title
  feedId
  variant
  feedId
  brand {
    ...Brand
  }
  images {
    ...MediaFile
  }
  sampleImageIds
  salePrice {
    ...MonetaryAmount
  }
  originalPrice {
    ...MonetaryAmount
  }
  categories {
    ...CategoryData
  }
}
    ${BrandFragmentDoc}
${MediaFileFragmentDoc}
${MonetaryAmountFragmentDoc}
${CategoryDataFragmentDoc}`;
export const ExperienceDetailsFragmentDoc = gql`
    fragment ExperienceDetails on Sellable {
  id
  charterLocation: attribute(attributeName: "charterLocation") {
    ...ExperienceAttribute
  }
  charterLengthFeet: attribute(attributeName: "charterLengthFeet") {
    ...ExperienceAttribute
  }
  charterCabins: attribute(attributeName: "charterCabins") {
    ...ExperienceAttribute
  }
  charterCapacity: attribute(attributeName: "charterCapacity") {
    ...ExperienceAttribute
  }
  charterAmenities: attribute(attributeName: "charterAmenities") {
    ...ExperienceAttribute
  }
  ...SellableDetails
  ...SellablePricingWithDefaultVariant
  ...TrackableSellable
  categories {
    id
  }
  department {
    id
    mostRecentLeadForConsumer {
      id
    }
  }
}
    ${ExperienceAttributeFragmentDoc}
${SellableDetailsFragmentDoc}
${SellablePricingWithDefaultVariantFragmentDoc}
${TrackableSellableFragmentDoc}`;
export const VariationMatrixVectorFragmentDoc = gql`
    fragment VariationMatrixVector on VariationMatrixVector {
  value
  displayValueHtml
  sellableIds
}
    `;
export const VariationMatrixDimensionFragmentDoc = gql`
    fragment VariationMatrixDimension on VariationMatrixDimension {
  name
  displayName
  vectors {
    ...VariationMatrixVector
  }
}
    ${VariationMatrixVectorFragmentDoc}`;
export const VariationMatrixSellableFragmentDoc = gql`
    fragment VariationMatrixSellable on Sellable {
  id
  friendlyId
  slug
  type
  outOfStock
}
    `;
export const VariationMatrixFragmentDoc = gql`
    fragment VariationMatrix on VariationMatrix {
  dimensions {
    ...VariationMatrixDimension
  }
  sellables {
    ...VariationMatrixSellable
  }
  defaultVariant {
    id
    friendlyId
    slug
    type
    salePrice {
      ...MonetaryAmount
    }
    originalPrice {
      ...MonetaryAmount
    }
    images {
      ...MediaFile
    }
  }
  priceRange {
    min {
      ...MonetaryAmount
    }
    max {
      ...MonetaryAmount
    }
  }
  maximumSavingsAmount {
    ...MonetaryAmount
  }
  maximumSavingsPercent
  outOfStockSellables {
    id
  }
}
    ${VariationMatrixDimensionFragmentDoc}
${VariationMatrixSellableFragmentDoc}
${MonetaryAmountFragmentDoc}
${MediaFileFragmentDoc}`;
export const DurationSelectorFragmentDoc = gql`
    fragment DurationSelector on Sellable {
  id
  originalPrice {
    ...MonetaryAmount
  }
  salePrice {
    ...MonetaryAmount
  }
  variants {
    value
  }
  variationMatrix {
    ...VariationMatrix
  }
}
    ${MonetaryAmountFragmentDoc}
${VariationMatrixFragmentDoc}`;
export const ExpertDepartmentFragmentDoc = gql`
    fragment ExpertDepartment on Department {
  id
  type
}
    `;
export const ProductExpertCardFragmentDoc = gql`
    fragment ProductExpertCard on BusinessUser {
  id
  active
  vanityId
  displayName
  shortName
  department {
    ...ExpertDepartment
  }
  expertProfile {
    id
    headline
    location
    background
    profilePhoto {
      ...MediaFile
    }
  }
  expertAttributes {
    placeholderExpert
  }
  expertStats {
    averageRating
    totalMessagesSent
    totalReviews
    totalLeadsAsPrimaryExpert
  }
}
    ${ExpertDepartmentFragmentDoc}
${MediaFileFragmentDoc}`;
export const BusinessUserToShareFragmentDoc = gql`
    fragment BusinessUserToShare on BusinessUser {
  id
  displayName
  shortName
  expertProfile {
    id
    profilePhoto {
      ...MediaFile
    }
  }
  expertAttributes {
    category {
      id
      singularDisplayName
    }
  }
}
    ${MediaFileFragmentDoc}`;
export const FeaturedReviewFragmentDoc = gql`
    fragment FeaturedReview on ConsumerExpertReview {
  id
  rating
  headline
  comments
  consumerName
  reviewedAt
  expert {
    id
    vanityId
    department {
      id
      type
    }
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
    profileUrl
    displayName
    shortName
  }
}
    ${MediaFileFragmentDoc}`;
export const NavInactiveDepartmentFragmentDoc = gql`
    fragment NavInactiveDepartment on Department {
  id
  type
  slug
  displayName
  acceptingRequests
  launched
  topLevelCategory {
    id
  }
}
    `;
export const FacetSelectionPayloadFragmentDoc = gql`
    fragment FacetSelectionPayload on FacetSelectionPayload {
  name
  alias
  displayName
  bucketValues
  lower
  upper
}
    `;
export const DepartmentNavigationLinkFragmentDoc = gql`
    fragment DepartmentNavigationLink on DepartmentNavigationLink {
  ... on DepartmentNavigationCategoryLink {
    category {
      id
      slug
    }
  }
  ... on DepartmentNavigationSearchLink {
    category {
      id
      slug
    }
    facets {
      ...FacetSelectionPayload
    }
  }
  ... on DepartmentNavigationCreatePathLink {
    pathSlug
  }
  ... on DepartmentNavigationExpertCommunityLink {
    departmentSlug
  }
}
    ${FacetSelectionPayloadFragmentDoc}`;
export const DepartmentNavigationListSubSectionFragmentDoc = gql`
    fragment DepartmentNavigationListSubSection on DepartmentNavigationListSubSection {
  id
  title
  titleLink {
    ...DepartmentNavigationLink
  }
  items {
    id
    label
    labelStyles
    imagePath
    imageUrl
    link {
      ...DepartmentNavigationLink
    }
  }
}
    ${DepartmentNavigationLinkFragmentDoc}`;
export const DepartmentNavigationResponsiveMixinFragmentDoc = gql`
    fragment DepartmentNavigationResponsiveMixin on DepartmentNavigationResponsiveMixin {
  showIfSmallSize
  showIfFullSize
  smallSizeOptions
  fullSizeOptions
}
    `;
export const DepartmentNavigationSubSectionFragmentDoc = gql`
    fragment DepartmentNavigationSubSection on DepartmentNavigationSubSection {
  id
  title
  titleLink {
    ...DepartmentNavigationLink
  }
  ... on DepartmentNavigationListSubSection {
    ...DepartmentNavigationListSubSection
  }
  ...DepartmentNavigationResponsiveMixin
}
    ${DepartmentNavigationLinkFragmentDoc}
${DepartmentNavigationListSubSectionFragmentDoc}
${DepartmentNavigationResponsiveMixinFragmentDoc}`;
export const DepartmentNavigationTopLevelItemFragmentDoc = gql`
    fragment DepartmentNavigationTopLevelItem on DepartmentNavigationTopLevelItem {
  id
  label
  labelLink {
    ...DepartmentNavigationLink
  }
  subSections {
    ...DepartmentNavigationSubSection
  }
  ...DepartmentNavigationResponsiveMixin
}
    ${DepartmentNavigationLinkFragmentDoc}
${DepartmentNavigationSubSectionFragmentDoc}
${DepartmentNavigationResponsiveMixinFragmentDoc}`;
export const NavActiveDepartmentFragmentDoc = gql`
    fragment NavActiveDepartment on Department {
  id
  type
  slug
  displayName
  navigation {
    topLevelItems {
      ...DepartmentNavigationTopLevelItem
    }
  }
  topLevelCategories {
    id
    slug
  }
  launched
  acceptingRequests
}
    ${DepartmentNavigationTopLevelItemFragmentDoc}`;
export const SellableKeywordTypeaheadResultFragmentDoc = gql`
    fragment SellableKeywordTypeaheadResult on SellableTypeaheadHit {
  id
  text
  title
  brandName
  sellable {
    id
    friendlyId
    slug
    type
  }
}
    `;
export const SystemCuratedItemSourceFragmentDoc = gql`
    fragment SystemCuratedItemSource on SystemCuratedItemSource {
  type
  ... on PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource {
    expertCuratedItem {
      id
    }
  }
  ... on TopRecommendedListSystemCuratedItemSource {
    recommendedListDefinition {
      id
    }
  }
  ... on TopRecommendationAndSimilarUserSystemCuratedItemSource {
    recentExpertCuratedItemFromSimilarUserSource {
      type
      expertCuratedItem {
        id
      }
    }
    topRecommendedListSystemCuratedItemSource {
      type
      recommendedListDefinition {
        id
      }
    }
  }
  ... on RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource {
    type
    expertCuratedItem {
      id
    }
  }
}
    `;
export const SystemCuratedItemFragmentDoc = gql`
    fragment SystemCuratedItem on SystemCuratedItem {
  id
  type
  sellable {
    id
    friendlyId
    slug
    type
    title
    images {
      ...MediaFile
    }
    ...TrackableSellable
    ...SellablePricingWithDefaultVariant
  }
  category {
    id
  }
  systemCuratedItemSource {
    ...SystemCuratedItemSource
  }
}
    ${MediaFileFragmentDoc}
${TrackableSellableFragmentDoc}
${SellablePricingWithDefaultVariantFragmentDoc}
${SystemCuratedItemSourceFragmentDoc}`;
export const SystemCuratedItemSurveyStatsFragmentDoc = gql`
    fragment SystemCuratedItemSurveyStats on SystemCuratedItemSurveyStats {
  ratingStats {
    rating
    count
  }
}
    `;
export const RoryReviewFragmentDoc = gql`
    fragment RoryReview on ConsumerExpertReview {
  id
  comments
  reviewedAt
  rating
  consumerName
  consumerLocation
}
    `;
export const ExpertProfileDetailFragmentDoc = gql`
    fragment ExpertProfileDetail on ExpertProfile {
  id
  businessUser {
    id
    displayName
    shortName
  }
  profilePhoto {
    ...MediaFile
  }
  headline
  background
  quotes
  socialMediaUrls
}
    ${MediaFileFragmentDoc}`;
export const ImageViewModelFragmentDoc = gql`
    fragment ImageViewModel on PathImageViewModel {
  imageUrl
  imagePath
}
    `;
export const TextViewModelFragmentDoc = gql`
    fragment TextViewModel on TextViewModel {
  ... on AttributedHtmlTextViewModel {
    text
    attributes {
      key
      type
      image {
        ...ImageViewModel
      }
    }
  }
}
    ${ImageViewModelFragmentDoc}`;
export const PathFlowOnCompleteLeadFragmentDoc = gql`
    fragment PathFlowOnCompleteLead on Lead {
  id
  expert {
    id
    vanityId
  }
  latestRequest {
    id
  }
}
    `;
export const PathFlowOnCompleteConversationWithLeadFragmentDoc = gql`
    fragment PathFlowOnCompleteConversationWithLead on Conversation {
  id
  lead {
    ...PathFlowOnCompleteLead
  }
}
    ${PathFlowOnCompleteLeadFragmentDoc}`;
export const InterstitialPageMetadataFragmentDoc = gql`
    fragment InterstitialPageMetadata on InterstitialPathFlowPageMetadata {
  interstitialType
  title {
    ...TextViewModel
  }
  body {
    ...TextViewModel
  }
}
    ${TextViewModelFragmentDoc}`;
export const TermsAndConditionsPageMetadataFragmentDoc = gql`
    fragment TermsAndConditionsPageMetadata on TermsAndConditionsPathFlowPageMetadata {
  type
}
    `;
export const RatingContactPageMetadataFragmentDoc = gql`
    fragment RatingContactPageMetadata on RatingContactPageMetadata {
  type
}
    `;
export const GenericModalPageMetadataFragmentDoc = gql`
    fragment GenericModalPageMetadata on GenericModalPageMetadata {
  type
  body {
    ...TextViewModel
  }
  openCtaText {
    ...TextViewModel
  }
}
    ${TextViewModelFragmentDoc}`;
export const GenericInfoBoxPageMetadataFragmentDoc = gql`
    fragment GenericInfoBoxPageMetadata on GenericInfoBoxPageMetadata {
  type
  body {
    ...TextViewModel
  }
}
    ${TextViewModelFragmentDoc}`;
export const PathFlowPageMetadataFragmentDoc = gql`
    fragment PathFlowPageMetadata on PathFlowPageMetadata {
  type
  ...InterstitialPageMetadata
  ...TermsAndConditionsPageMetadata
  ...RatingContactPageMetadata
  ...GenericModalPageMetadata
  ...GenericInfoBoxPageMetadata
}
    ${InterstitialPageMetadataFragmentDoc}
${TermsAndConditionsPageMetadataFragmentDoc}
${RatingContactPageMetadataFragmentDoc}
${GenericModalPageMetadataFragmentDoc}
${GenericInfoBoxPageMetadataFragmentDoc}`;
export const SharedPathFlowQuestionFragmentDoc = gql`
    fragment SharedPathFlowQuestion on PathFlowQuestion {
  internalName
  required
  questionText {
    ...TextViewModel
  }
  questionSubText {
    ...TextViewModel
  }
  inputLabel {
    ...TextViewModel
  }
  inputIconImage {
    ...ImageViewModel
  }
}
    ${TextViewModelFragmentDoc}
${ImageViewModelFragmentDoc}`;
export const InputTextPathFlowQuestionValidationFragmentDoc = gql`
    fragment InputTextPathFlowQuestionValidation on InputTextPathFlowQuestionValidation {
  type
  ... on InputTextPathFlowQuestionLengthValidation {
    minSize
    maxSize
  }
  ... on InputTextPathFlowQuestionRegexValidation {
    regex
    errorMessage
  }
}
    `;
export const InputTextPathFlowQuestionMixinFragmentDoc = gql`
    fragment InputTextPathFlowQuestionMixin on InputTextPathFlowQuestionMixin {
  required
  fieldType
  placeholder
  inputTextValidations {
    ...InputTextPathFlowQuestionValidation
  }
  questionSubText {
    ...TextViewModel
  }
}
    ${InputTextPathFlowQuestionValidationFragmentDoc}
${TextViewModelFragmentDoc}`;
export const ListPathFlowQuestionFragmentDoc = gql`
    fragment ListPathFlowQuestion on ListPathFlowQuestion {
  listType: type
  choices {
    value
    text {
      ...TextViewModel
    }
    subText {
      ...TextViewModel
    }
    primaryImage {
      ...ImageViewModel
    }
    iconImage {
      ...ImageViewModel
    }
  }
  renderStyle
  other {
    ...InputTextPathFlowQuestionMixin
  }
  listUserInput {
    value
    other
  }
}
    ${TextViewModelFragmentDoc}
${ImageViewModelFragmentDoc}
${InputTextPathFlowQuestionMixinFragmentDoc}`;
export const InputTextPathFlowQuestionFragmentDoc = gql`
    fragment InputTextPathFlowQuestion on InputTextPathFlowQuestion {
  ...InputTextPathFlowQuestionMixin
  countryCodeAttribute: attribute(attributeName: "countryCode") {
    values {
      ... on AttributeValueEnumeration {
        enumerationValue
        enumerationValueDescription
      }
    }
  }
  inputTextUserInput {
    value
  }
}
    ${InputTextPathFlowQuestionMixinFragmentDoc}`;
export const NumericPathFlowQuestionFragmentDoc = gql`
    fragment NumericPathFlowQuestion on NumericPathFlowQuestion {
  unit
  unitLabel
  placeholder
  numericUserInput {
    value
    decimalValue
  }
  displayType
}
    `;
export const OAuthEmailPathFlowQuestionFragmentDoc = gql`
    fragment OAuthEmailPathFlowQuestion on OAuthEmailPathFlowQuestion {
  oAuthEmailUserInput {
    firstName
    lastName
    email
    googleIdToken
    facebookUserAccessToken
    skipFirstName
    skipLastName
  }
}
    `;
export const IdPathFlowQuestionFragmentDoc = gql`
    fragment IdPathFlowQuestion on IdPathFlowQuestion {
  idType: type
  idUserInput {
    value
  }
}
    `;
export const DateRangePathFlowQuestionFragmentDoc = gql`
    fragment DateRangePathFlowQuestion on DateRangePathFlowQuestion {
  dateRangeUserInput {
    startValue
    endValue
  }
  endRequired
  startRequired
}
    `;
export const DatePathFlowQuestionFragmentDoc = gql`
    fragment DatePathFlowQuestion on DatePathFlowQuestion {
  dateUserInput {
    value
  }
}
    `;
export const PathFlowQuestionFragmentDoc = gql`
    fragment PathFlowQuestion on PathFlowQuestion {
  ...SharedPathFlowQuestion
  ... on ListPathFlowQuestion {
    ...ListPathFlowQuestion
  }
  ... on InputTextPathFlowQuestion {
    ...InputTextPathFlowQuestion
  }
  ... on NumericPathFlowQuestion {
    ...NumericPathFlowQuestion
  }
  ... on OAuthEmailPathFlowQuestion {
    ...OAuthEmailPathFlowQuestion
  }
  ... on IdPathFlowQuestion {
    ...IdPathFlowQuestion
  }
  ... on DateRangePathFlowQuestion {
    ...DateRangePathFlowQuestion
  }
  ... on DatePathFlowQuestion {
    ...DatePathFlowQuestion
  }
}
    ${SharedPathFlowQuestionFragmentDoc}
${ListPathFlowQuestionFragmentDoc}
${InputTextPathFlowQuestionFragmentDoc}
${NumericPathFlowQuestionFragmentDoc}
${OAuthEmailPathFlowQuestionFragmentDoc}
${IdPathFlowQuestionFragmentDoc}
${DateRangePathFlowQuestionFragmentDoc}
${DatePathFlowQuestionFragmentDoc}`;
export const PathFlowPageFragmentDoc = gql`
    fragment PathFlowPage on PathFlowPage {
  id
  internalName
  metadata {
    ...PathFlowPageMetadata
  }
  title {
    ...TextViewModel
  }
  slug
  completed
  completionPercentage
  requiresServerSyncAfterSubmit
  notificationTexts {
    ...TextViewModel
  }
  questions {
    ...PathFlowQuestion
  }
  submitButtonText {
    ...TextViewModel
  }
  skipButtonText {
    ...TextViewModel
  }
}
    ${PathFlowPageMetadataFragmentDoc}
${TextViewModelFragmentDoc}
${PathFlowQuestionFragmentDoc}`;
export const PathFlowPagesConnectionFragmentDoc = gql`
    fragment PathFlowPagesConnection on PathFlowPagesConnection {
  edges {
    cursor
    node {
      ...PathFlowPage
    }
  }
}
    ${PathFlowPageFragmentDoc}`;
export const PathFlowFragmentDoc = gql`
    fragment PathFlow on PathFlow {
  id
  title {
    ...TextViewModel
  }
  completed
  onComplete {
    ... on PathFlowOnCompleteBroadcast {
      location
      conversation {
        ...PathFlowOnCompleteConversationWithLead
      }
    }
    ... on PathFlowOnCompleteLead {
      lead {
        ...PathFlowOnCompleteLead
      }
      conversation {
        ...PathFlowOnCompleteConversationWithLead
      }
      location
    }
    ... on PathFlowOnCompleteNewPath {
      flow {
        id
        slug
        pagesConnection {
          ...PathFlowPagesConnection
        }
      }
    }
    ... on PathFlowOnCompleteExpertReview {
      review {
        id
      }
      location
    }
    ... on PathFlowOnCompleteRedirectOnly {
      location
    }
    ... on PathFlowOnCompleteRedirectWithUpsert {
      location
    }
    ... on PathFlowOnCompleteExpertApplication {
      application {
        id
      }
      location
    }
  }
  theme {
    type
  }
  slug
  category {
    id
    slug
    department {
      ...DepartmentContext
    }
  }
  pagesConnection {
    ...PathFlowPagesConnection
  }
}
    ${TextViewModelFragmentDoc}
${PathFlowOnCompleteConversationWithLeadFragmentDoc}
${PathFlowOnCompleteLeadFragmentDoc}
${PathFlowPagesConnectionFragmentDoc}
${DepartmentContextFragmentDoc}`;
export const PathValidationErrorFragmentDoc = gql`
    fragment PathValidationError on PathValidationError {
  pageName
  questionName
  message {
    ...TextViewModel
  }
  tags
}
    ${TextViewModelFragmentDoc}`;
export const ExpertStatsFragmentDoc = gql`
    fragment ExpertStats on ExpertStats {
  topGoodQualities
  averageRating
  totalMessagesSent
  totalLeadsAsPrimaryExpert
  totalReviews
}
    `;
export const PathExpertFragmentDoc = gql`
    fragment PathExpert on BusinessUser {
  id
  displayName
  shortName
  expertProfile {
    id
    background
    headline
    profilePhoto {
      ...MediaFile
    }
    highlights {
      type {
        id
        displayName
      }
      value
      secondaryValue
    }
  }
  expertStats {
    ...ExpertStats
  }
}
    ${MediaFileFragmentDoc}
${ExpertStatsFragmentDoc}`;
export const SellableCardFragmentDoc = gql`
    fragment SellableCard on Sellable {
  id
  type
  metrics {
    totalUniquePVsInPastWeek
    totalPurchasesInLast30Days
  }
  areAllVariantsOutOfStock
  department {
    id
    type
    slug
  }
  parent {
    id
    metrics {
      totalUniquePVsInPastWeek
      totalPurchasesInLast30Days
    }
    savedSellable {
      id
      saved
    }
  }
  savedSellable {
    id
    saved
  }
  serviceLocation {
    displayTitle
  }
  variationMatrix {
    priceRange {
      max {
        ...MonetaryAmount
      }
      min {
        ...MonetaryAmount
      }
    }
    defaultVariant {
      id
      images {
        ...MediaFile
      }
      ...SellableUrl
      ...TrackableSellable
    }
  }
  charterBathrooms: attribute(attributeName: "charterBathrooms") {
    formatted {
      name
      displayHtml
      displayHtmlValues
    }
  }
  charterCabins: attribute(attributeName: "charterCabins") {
    formatted {
      name
      displayHtml
      displayHtmlValues
    }
  }
  charterCapacity: attribute(attributeName: "charterCapacity") {
    formatted {
      name
      displayHtml
      displayHtmlValues
    }
  }
  ...TrackableSellable
}
    ${MonetaryAmountFragmentDoc}
${MediaFileFragmentDoc}
${SellableUrlFragmentDoc}
${TrackableSellableFragmentDoc}`;
export const RecommendingExpertsFragmentDoc = gql`
    fragment RecommendingExperts on BusinessUser {
  id
  vanityId
  displayName
  shortName
  expertProfile {
    id
    profilePhoto {
      ...MediaFile
    }
  }
  expertStats {
    averageRating
    totalReviews
  }
}
    ${MediaFileFragmentDoc}`;
export const RecommendedListSellableCardFragmentDoc = gql`
    fragment RecommendedListSellableCard on Sellable {
  ...SellableCard
  ...TrackableSellable
  consumerSellableReactions {
    edges {
      node {
        id
        ratingWithDisplayName {
          displayName
          rating
        }
      }
    }
  }
  recommendingExperts(first: 9) {
    count
    total
    edges {
      node {
        expert {
          ...RecommendingExperts
        }
        timesRecommended
      }
    }
  }
}
    ${SellableCardFragmentDoc}
${TrackableSellableFragmentDoc}
${RecommendingExpertsFragmentDoc}`;
export const RecommendedListFragmentDoc = gql`
    fragment RecommendedList on RecommendedList {
  displayName
  subTitle
  recommendedListDefinition {
    id
    rank
  }
  sellables {
    ...RecommendedListSellableCard
  }
}
    ${RecommendedListSellableCardFragmentDoc}`;
export const ExpertForRatingFragmentDoc = gql`
    fragment ExpertForRating on BusinessUser {
  id
  displayName
  shortName
  expertProfile {
    id
    headline
    profilePhoto {
      ...MediaFile
    }
  }
  department {
    id
    slug
    type
  }
}
    ${MediaFileFragmentDoc}`;
export const SaveableSellableFragmentDoc = gql`
    fragment SaveableSellable on Sellable {
  id
  savedSellable {
    id
    saved
  }
  parent {
    id
    savedSellable {
      id
      saved
    }
  }
}
    `;
export const SaveableSellableResponseFragmentDoc = gql`
    fragment SaveableSellableResponse on Sellable {
  id
  savedSellable {
    id
    saved
  }
}
    `;
export const GuestSellableFragmentDoc = gql`
    fragment GuestSellable on Sellable {
  id
  friendlyId
  slug
  type
  title
  images {
    ...MediaFile
  }
  variants {
    displayValueHtml
  }
  ...SellablePricing
  ...TrackableSellable
}
    ${MediaFileFragmentDoc}
${SellablePricingFragmentDoc}
${TrackableSellableFragmentDoc}`;
export const LandingPageExpertCardFragmentDoc = gql`
    fragment LandingPageExpertCard on BusinessUser {
  id
  vanityId
  active
  displayName
  shortName
  expertProfile {
    id
    background
    profilePhoto {
      ...MediaFile
    }
    highlights {
      secondaryValue
      value
    }
  }
  expertStats {
    averageRating
    totalReviews
    totalMessagesSent
  }
}
    ${MediaFileFragmentDoc}`;
export const FeaturedExpertForDepartmentFritosFragmentDoc = gql`
    fragment FeaturedExpertForDepartmentFritos on BusinessUser {
  id
  vanityId
  displayName
  shortName
  expertAttributes {
    category {
      id
      singularDisplayName
    }
  }
  expertProfile {
    id
    profilePhoto {
      id
      url
    }
  }
}
    `;
export const ChatWidgetExpertFragmentDoc = gql`
    fragment ChatWidgetExpert on BusinessUser {
  id
  vanityId
  displayName
  shortName
  assignedSmsAddress: assignedAddress(type: SMS)
  assignedEmailAddress: assignedAddress(type: EMAIL)
  messagingUser {
    id
  }
  expertAttributes {
    placeholderExpert
  }
  expertPresence {
    status
  }
  expertProfile {
    id
    headline
    profilePhoto {
      ...MediaFile
    }
    highlights {
      secondaryValue
      type {
        id
        icon
      }
      value
    }
  }
  expertStats {
    averageRating
    totalMessagesSent
    totalReviews
  }
}
    ${MediaFileFragmentDoc}`;
export const ContentfulImageDataFragmentDoc = gql`
    fragment ContentfulImageData on ContentAsset {
  mimeType
  title
  imageUrl
}
    `;
export const RawContentTypesFragmentDoc = gql`
    fragment RawContentTypes on ContentValue {
  ... on ContentBooleanValue {
    booleanValue
  }
  ... on ContentStringValue {
    stringValue
  }
  ... on ContentIntValue {
    intValue
  }
  ... on ContentFloatValue {
    floatValue
  }
  ... on ContentAsset {
    ...ContentfulImageData
  }
}
    ${ContentfulImageDataFragmentDoc}`;
export const ContentTypesFragmentDoc = gql`
    fragment ContentTypes on ContentValue {
  ...RawContentTypes
  ... on ContentObject {
    entries {
      key
      value {
        ...RawContentTypes
        ... on ContentValueArray {
          values {
            ...RawContentTypes
            ... on ContentObject {
              entries {
                key
                value {
                  ...RawContentTypes
                  ... on ContentValueArray {
                    values {
                      ...RawContentTypes
                      ... on ContentObject {
                        entries {
                          key
                          value {
                            ...RawContentTypes
                            ... on ContentValueArray {
                              values {
                                ...RawContentTypes
                              }
                            }
                            ... on ContentObject {
                              entries {
                                key
                                value {
                                  ...RawContentTypes
                                  ... on ContentValueArray {
                                    values {
                                      ...RawContentTypes
                                      ... on ContentObject {
                                        entries {
                                          key
                                          value {
                                            ...RawContentTypes
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        ... on ContentObject {
          entries {
            key
            value {
              ...RawContentTypes
              ... on ContentValueArray {
                values {
                  ...RawContentTypes
                  ... on ContentObject {
                    entries {
                      key
                      value {
                        ...RawContentTypes
                        ... on ContentValueArray {
                          values {
                            ...RawContentTypes
                            ... on ContentObject {
                              entries {
                                key
                                value {
                                  ...RawContentTypes
                                  ... on ContentValueArray {
                                    values {
                                      ...RawContentTypes
                                    }
                                  }
                                  ... on ContentObject {
                                    entries {
                                      key
                                      value {
                                        ...RawContentTypes
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ... on ContentValueArray {
    values {
      ...RawContentTypes
      ... on ContentObject {
        entries {
          key
          value {
            ...RawContentTypes
            ... on ContentValueArray {
              values {
                ...RawContentTypes
                ... on ContentObject {
                  entries {
                    key
                    value {
                      ...RawContentTypes
                      ... on ContentValueArray {
                        values {
                          ...RawContentTypes
                          ... on ContentObject {
                            entries {
                              key
                              value {
                                ...RawContentTypes
                                ... on ContentValueArray {
                                  values {
                                    ...RawContentTypes
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            ... on ContentObject {
              entries {
                key
                value {
                  ...RawContentTypes
                  ... on ContentValueArray {
                    values {
                      ...RawContentTypes
                      ... on ContentObject {
                        entries {
                          key
                          value {
                            ...RawContentTypes
                            ... on ContentValueArray {
                              values {
                                ...RawContentTypes
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${RawContentTypesFragmentDoc}`;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  id
  addresseeName
  line1
  line2
  city
  state
  country
  countryDetails {
    displayCountry
  }
  postalCode
  securityCode
  phoneNumber
  active
  isDefault
}
    `;
export const AuthenticatedUserFragmentDoc = gql`
    fragment AuthenticatedUser on User {
  id
  experimentUserId
  firstName
  lastName
  roles
  profilePhoto {
    id
    url
  }
  messagingUser {
    id
    notificationChannels
    preferredMessagingChannels
  }
  address {
    line1
    city
    state
    postalCode
    country
  }
  savedAddresses {
    ...Address
  }
  contacts {
    id
    type
    value
    verified
    emailAddress
    phoneNumber
    parsedPhoneNumber {
      countryCode
      regionCode
      nationalNumber
    }
  }
}
    ${AddressFragmentDoc}`;
export const RealUserFragmentDoc = gql`
    fragment RealUser on User {
  id
  firstName
  lastName
  assignedOperatorSeat {
    id
  }
}
    `;
export const MyselfFragmentDoc = gql`
    fragment Myself on Myself {
  id
  hasPassword
  user {
    ...AuthenticatedUser
    isAllowedToRefer
    mostRecentLead {
      id
      createdAt
      category {
        id
        department {
          ...DepartmentContext
        }
      }
    }
    source {
      attributes {
        name
        value
      }
    }
    referralCode
    referral
    assignedBusinessUsers {
      id
      expertProfile {
        id
        isDraft
      }
      expertApplication {
        id
        state
      }
    }
  }
  realUser {
    ...RealUser
  }
}
    ${AuthenticatedUserFragmentDoc}
${DepartmentContextFragmentDoc}
${RealUserFragmentDoc}`;
export const SessionFragmentDoc = gql`
    fragment Session on Session {
  id
  experimentUserId
}
    `;
export const ConversationFragmentDoc = gql`
    fragment Conversation on Conversation {
  id
  externalId
}
    `;
export const ActivityFeedSellableFragmentDoc = gql`
    fragment ActivityFeedSellable on Sellable {
  id
  friendlyId
  slug
  type
  title
  ...SellablePricingWithDefaultVariant
  images {
    ...MediaFile
  }
}
    ${SellablePricingWithDefaultVariantFragmentDoc}
${MediaFileFragmentDoc}`;
export const ConsumerExpertReviewFragmentDoc = gql`
    fragment ConsumerExpertReview on ConsumerExpertReview {
  id
  reviewedAt
  rating
  headline
  comments
  consumerName
  expert {
    id
    vanityId
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
    expertPresence {
      status
    }
    displayName
    shortName
  }
  verifiedPurchases {
    ...ActivityFeedSellable
  }
}
    ${MediaFileFragmentDoc}
${ActivityFeedSellableFragmentDoc}`;
export const ExpertCuratedItemCategoryFragmentDoc = gql`
    fragment ExpertCuratedItemCategory on Category {
  id
  pluralDisplayName
  singularDisplayName
  slug
  department {
    id
    slug
  }
}
    `;
export const ExpertCuratedItemCustomizationFragmentDoc = gql`
    fragment ExpertCuratedItemCustomization on ExpertCuratedItemCustomization {
  sellable {
    id
    expireAt
  }
  createdAt
  title
  price {
    ...MonetaryAmount
  }
}
    ${MonetaryAmountFragmentDoc}`;
export const ExpertCuratedItemFragmentDoc = gql`
    fragment ExpertCuratedItem on ExpertCuratedItem {
  id
  lead {
    id
  }
  createdAt
  priceOverride {
    ...MonetaryAmount
  }
  priceOverrideValidUntil
  createdBy {
    id
    displayName
    shortName
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
  }
  tag {
    type
    displayLabel
  }
  note {
    id
    text
  }
  category {
    ...ExpertCuratedItemCategory
  }
  sellable {
    ...RecommendedListSellableCard
    active
    outOfStock
    adHoc
    expireAt
    variants {
      name
      displayName
      displayValueHtml
    }
    specifications {
      key
      name
      valueHtml
    }
    parent {
      id
      ...TrackableSellable
      savedSellable {
        id
        saved
      }
    }
  }
  salePrice {
    ...MonetaryAmount
  }
  lineItemInCart {
    id
  }
  customizations {
    ...ExpertCuratedItemCustomization
  }
  rank
}
    ${MonetaryAmountFragmentDoc}
${MediaFileFragmentDoc}
${ExpertCuratedItemCategoryFragmentDoc}
${RecommendedListSellableCardFragmentDoc}
${TrackableSellableFragmentDoc}
${ExpertCuratedItemCustomizationFragmentDoc}`;
export const ExpertCuratedItemsByCategoryFragmentDoc = gql`
    fragment ExpertCuratedItemsByCategory on ExpertCuratedItemsByCategory {
  id
  category {
    id
    pluralDisplayName
    singularDisplayName
    slug
    department {
      id
      slug
    }
  }
  items {
    ...ExpertCuratedItem
  }
}
    ${ExpertCuratedItemFragmentDoc}`;
export const ExpertCuratedAttributeFragmentDoc = gql`
    fragment ExpertCuratedAttribute on Attribute {
  formatted {
    name
    displayHtml
  }
}
    `;
export const ExpertCuratedSellableDetailsFragmentDoc = gql`
    fragment ExpertCuratedSellableDetails on Sellable {
  id
  charterLocation: attribute(attributeName: "charterLocation") {
    ...ExpertCuratedAttribute
  }
  charterLengthFeet: attribute(attributeName: "charterLengthFeet") {
    ...ExpertCuratedAttribute
  }
  charterCabins: attribute(attributeName: "charterCabins") {
    ...ExpertCuratedAttribute
  }
  charterCapacity: attribute(attributeName: "charterCapacity") {
    ...ExpertCuratedAttribute
  }
  charterAmenities: attribute(attributeName: "charterAmenities") {
    ...ExpertCuratedAttribute
  }
  charterBathrooms: attribute(attributeName: "charterBathrooms") {
    ...ExpertCuratedAttribute
  }
  aircraftType: attribute(attributeName: "aircraftType") {
    ...ExpertCuratedAttribute
  }
  ...SellableDetails
  ...SellablePricingWithDefaultVariant
  ...TrackableSellable
  department {
    id
    mostRecentLeadForConsumer {
      id
    }
  }
}
    ${ExpertCuratedAttributeFragmentDoc}
${SellableDetailsFragmentDoc}
${SellablePricingWithDefaultVariantFragmentDoc}
${TrackableSellableFragmentDoc}`;
export const ExpertCuratedOrderLineItemFragmentDoc = gql`
    fragment ExpertCuratedOrderLineItem on OrderLineItem {
  id
  isGroup
  title
  unitPrice {
    ...MonetaryAmount
  }
  quantity
  source {
    type
    ... on OrderLineItemSellableSource {
      sellable {
        ...ExpertCuratedSellableDetails
      }
    }
    ... on OrderLineItemAdHocSource {
      type
    }
    ... on OrderLineItemBasePriceSource {
      type
    }
    ... on OrderLineItemExpertTipSource {
      type
    }
    ... on OrderLineItemGratuitySource {
      type
    }
    ... on OrderLineItemPrepaidIncidentalSource {
      type
    }
    ... on OrderLineItemShipmentSource {
      type
    }
    ... on OrderLineItemSource {
      type
    }
  }
}
    ${MonetaryAmountFragmentDoc}
${ExpertCuratedSellableDetailsFragmentDoc}`;
export const ExpertCuratedVariationOptionFragmentDoc = gql`
    fragment ExpertCuratedVariationOption on ExpertCuratedOrderVariationOption {
  enabled
  price {
    ...MonetaryAmount
  }
  selected
  sellable {
    id
    title
    descriptionText
    variants {
      displayName
      value
      displayValueHtml
    }
  }
}
    ${MonetaryAmountFragmentDoc}`;
export const LeadCuratedOrderFragmentDoc = gql`
    fragment LeadCuratedOrder on Lead {
  id
  conversation {
    id
  }
  category {
    id
    contentAssets {
      bannerImages {
        title
        imageUrl
      }
    }
  }
  consumer {
    id
    firstName
    lastName
  }
  expert {
    id
    displayName
    shortName
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
    phoneNumber: assignedAddress(type: SMS)
  }
}
    ${MediaFileFragmentDoc}`;
export const AirportFragmentDoc = gql`
    fragment Airport on Airport {
  id
  zoneId
  displayCode
}
    `;
export const FlightPlanLegFragmentDoc = gql`
    fragment FlightPlanLeg on FlightPlanLeg {
  id
  departAt
  departOn
  arriveAt
  durationInMinutes
  flightOperator
  departureAirport {
    ...Airport
  }
  arrivalAirport {
    ...Airport
  }
}
    ${AirportFragmentDoc}`;
export const FlightPlanFragmentDoc = gql`
    fragment FlightPlan on FlightPlan {
  id
  state
  legs {
    ...FlightPlanLeg
  }
}
    ${FlightPlanLegFragmentDoc}`;
export const ExpertCuratedOrderManualTaxAdjustmentFragmentDoc = gql`
    fragment ExpertCuratedOrderManualTaxAdjustment on ExpertCuratedOrderManualTaxAdjustment {
  taxRate
  amount {
    ...MonetaryAmount
  }
  computedFromAmount {
    ...MonetaryAmount
  }
}
    ${MonetaryAmountFragmentDoc}`;
export const ExpertCuratedOrderFragmentDoc = gql`
    fragment ExpertCuratedOrder on ExpertCuratedOrder {
  id
  state
  serviceStartAt
  inPreview
  expiresAt
  category {
    id
    slug
  }
  serviceLocation {
    displayTitle
  }
  curatedFor {
    id
    firstName
  }
  items {
    id
  }
  order {
    id
    title
    description
    primaryImage {
      ...MediaFile
    }
    totalCostBeforeTax {
      ...MonetaryAmount
    }
    tax {
      ...MonetaryAmount
    }
    totalCost {
      ...MonetaryAmount
    }
    remainingBalance {
      ...MonetaryAmount
    }
    minimumDeposit {
      ...MonetaryAmount
    }
    lineItems {
      ...ExpertCuratedOrderLineItem
    }
    state
  }
  variationOptions {
    ...ExpertCuratedVariationOption
  }
  serviceStartAt
  lead {
    id
    category {
      id
      singularDisplayName
      department {
        ...DepartmentContext
      }
    }
    ...LeadCuratedOrder
  }
  flightPlan {
    ...FlightPlan
  }
  taxWillBeAutomaticallyComputed
  defaultManualTaxAdjustment {
    ...ExpertCuratedOrderManualTaxAdjustment
  }
}
    ${MediaFileFragmentDoc}
${MonetaryAmountFragmentDoc}
${ExpertCuratedOrderLineItemFragmentDoc}
${ExpertCuratedVariationOptionFragmentDoc}
${DepartmentContextFragmentDoc}
${LeadCuratedOrderFragmentDoc}
${FlightPlanFragmentDoc}
${ExpertCuratedOrderManualTaxAdjustmentFragmentDoc}`;
export const BucketedDisplayFacetFragmentDoc = gql`
    fragment BucketedDisplayFacet on BucketedDisplayFacet {
  displayName
  name
  alias
  buckets {
    displayName
    value
    count
    imageMetadata {
      ... on BackgroundFacetImageMetadata {
        type
        imageUrl
      }
      ... on IconFacetImageMetadata {
        type
        imageUrl
      }
    }
  }
}
    `;
export const BucketedRangeDisplayFacetFragmentDoc = gql`
    fragment BucketedRangeDisplayFacet on BucketedRangeDisplayFacet {
  displayName
  name
  alias
}
    `;
export const NumericRangeDisplayFacetFragmentDoc = gql`
    fragment NumericRangeDisplayFacet on NumericRangeDisplayFacet {
  displayName
  name
  alias
  type
  lower
  upper
  scale
  upperCapped
}
    `;
export const DisplayFacetFragmentDoc = gql`
    fragment DisplayFacet on DisplayFacet {
  ...BucketedDisplayFacet
  ...BucketedRangeDisplayFacet
  ...NumericRangeDisplayFacet
}
    ${BucketedDisplayFacetFragmentDoc}
${BucketedRangeDisplayFacetFragmentDoc}
${NumericRangeDisplayFacetFragmentDoc}`;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const SellableInactiveFragmentDoc = gql`
    fragment SellableInactive on Sellable {
  id
  active
  salePrice {
    ...MonetaryAmount
  }
  outOfStock
}
    ${MonetaryAmountFragmentDoc}`;
export const WireTransferPaymentEntityFragmentDoc = gql`
    fragment WireTransferPaymentEntity on WireTransferPaymentEntity {
  paymentMethod
  accountNumber
  bankName
  chargeableAmount {
    ...MonetaryAmount
  }
  routingNumber
  swiftCode
}
    ${MonetaryAmountFragmentDoc}`;
export const OrderMessageFragmentDoc = gql`
    fragment OrderMessage on OrderMessage {
  dismissible
  message
}
    `;
export const ShipmentTrackingFragmentDoc = gql`
    fragment ShipmentTracking on ShipmentTracking {
  shippingCarrier {
    id
    displayName
  }
  trackingNumber
  status
  estimatedDeliveryTime
  trackingUrl
}
    `;
export const StripePaymentSourceFragmentDoc = gql`
    fragment StripePaymentSource on StripePaymentSource {
  id
  createdAt
  updatedAt
  externalSourceId
  type
  usage
  status
  userId
  owner {
    name
    verifiedName
  }
  billingAddress {
    ...Address
  }
  paymentEntity {
    ... on PaymentCard {
      paymentMethod
      last4
      brand
      threeDSecureVerificationRequired
    }
  }
  isDefault
}
    ${AddressFragmentDoc}`;
export const PaymentSourceFragmentDoc = gql`
    fragment PaymentSource on PaymentSource {
  ...StripePaymentSource
  ... on AffirmPaymentSource {
    id
  }
  ... on PaypalPaymentSource {
    id
  }
  ... on AfterpayPaymentSource {
    id
  }
}
    ${StripePaymentSourceFragmentDoc}`;
export const TransactionFragmentDoc = gql`
    fragment Transaction on Transaction {
  id
  status
  request {
    chargeAmount {
      amount
      currency
    }
    paymentSourceType
  }
  response {
    paymentVerificationMethod
    paymentSource {
      ...PaymentSource
    }
    errorMessage
    userFriendlyErrorMessage
  }
}
    ${PaymentSourceFragmentDoc}`;
export const OrderFragmentDoc = gql`
    fragment Order on Order {
  id
  state
  createdAt
  paidAt
  categoryType
  user {
    id
    firstName
    lastName
  }
  tax {
    ...MonetaryAmount
  }
  shippingCost {
    ...MonetaryAmount
  }
  chargingPaymentSource {
    id
    paymentEntity {
      ... on WireTransferPaymentEntity {
        ...WireTransferPaymentEntity
      }
    }
  }
  totalCost {
    ...MonetaryAmount
  }
  totalCostBeforeTax {
    ...MonetaryAmount
  }
  subtotal: totalCostOnlyIncluding(costComponents: [CORE, GRATUITY]) {
    ...MonetaryAmount
  }
  totalCostWithoutTip: totalCostExcluding(costComponents: [EXPERT_TIP]) {
    ...MonetaryAmount
  }
  totalShippingCost: totalCostOnlyIncluding(costComponents: [SHIPMENT]) {
    ...MonetaryAmount
  }
  tip {
    ...MonetaryAmount
  }
  messages {
    ...OrderMessage
  }
  shippingAddress {
    ...Address
  }
  shipmentTrackings {
    ...ShipmentTracking
  }
  transactions {
    ...Transaction
  }
  offer {
    id
    images {
      ...MediaFile
    }
    title
    type
  }
  requiresShippingAddress
  itemsCount
  supportedPaymentMethods {
    paymentMethod
    paymentProvider
  }
  appliedPromotionEntry {
    applied
    discount {
      ...MonetaryAmount
    }
    promotion {
      id
      code
    }
  }
}
    ${MonetaryAmountFragmentDoc}
${WireTransferPaymentEntityFragmentDoc}
${OrderMessageFragmentDoc}
${AddressFragmentDoc}
${ShipmentTrackingFragmentDoc}
${TransactionFragmentDoc}
${MediaFileFragmentDoc}`;
export const OrderLineItemFragmentDoc = gql`
    fragment OrderLineItem on OrderLineItem {
  id
  messages {
    dismissible
    message
  }
  price {
    ...MonetaryAmount
  }
  quantity
  isGroup
  shipmentTracking {
    estimatedDeliveryTime
    status
    trackingUrl
  }
  etaFromMerchant
  maxEtaFromMerchant
  parentId
  source {
    type
    ... on OrderLineItemBasePriceSource {
      type
    }
    ... on OrderLineItemGratuitySource {
      type
      percentage
    }
    ... on OrderLineItemPrepaidIncidentalSource {
      type
      percentage
    }
    ... on OrderLineItemExpertTipSource {
      type
      amount {
        ...MonetaryAmount
      }
      expertAmounts {
        expert {
          id
          displayName
          shortName
          expertProfile {
            id
            profilePhoto {
              id
              url
            }
          }
        }
      }
    }
    ... on OrderLineItemShipmentSource {
      type
      amount {
        ...MonetaryAmount
      }
    }
    ... on OrderLineItemAdHocSource {
      type
    }
    ... on OrderLineItemSellableSource {
      type
      sellable {
        id
        adHoc
        inShortSupply
        images {
          ...MediaFile
        }
        variants {
          name
          displayName
          value
          displayValueHtml
        }
        categories {
          id
          slug
          parents {
            id
            slug
          }
        }
        ...SellableUrl
        ...SellablePricing
        ...TrackableSellable
      }
    }
  }
  title
  unitPrice {
    ...MonetaryAmount
  }
  totalBeforeTax {
    ...MonetaryAmount
  }
}
    ${MonetaryAmountFragmentDoc}
${MediaFileFragmentDoc}
${SellableUrlFragmentDoc}
${SellablePricingFragmentDoc}
${TrackableSellableFragmentDoc}`;
export const ShoppingCartOrderFragmentDoc = gql`
    fragment ShoppingCartOrder on Order {
  ...Order
  lineItems {
    ...OrderLineItem
  }
}
    ${OrderFragmentDoc}
${OrderLineItemFragmentDoc}`;
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  countryCode
  displayCountry
  displayFirstAdministrativeAreaLabel
  displayPostalCodeLabel
  displayCityLabel
  firstAdministrativeAreas {
    countryCode
    code
    displayName
  }
}
    `;
export const OrderListLineItemFragmentDoc = gql`
    fragment OrderListLineItem on OrderLineItem {
  id
  state
  shipmentTracking {
    ...ShipmentTracking
  }
  source {
    type
    ... on OrderLineItemSellableSource {
      sellable {
        id
        images {
          ...MediaFile
        }
        variants {
          displayValueHtml
        }
      }
    }
    ... on OrderLineItemExpertTipSource {
      type
      amount {
        ...MonetaryAmount
      }
      expertAmounts {
        expert {
          id
          displayName
          shortName
          expertProfile {
            id
            profilePhoto {
              id
              url
            }
          }
        }
      }
    }
  }
  title
}
    ${ShipmentTrackingFragmentDoc}
${MediaFileFragmentDoc}
${MonetaryAmountFragmentDoc}`;
export const OrderListEscalationFragmentDoc = gql`
    fragment OrderListEscalation on OrderEscalation {
  id
  orderId
  orderLineItemId
  consumerFriendlyId
  createdAt
  type
  status
  assignedTo {
    id
    firstName
  }
}
    `;
export const MyOrderListItemFragmentDoc = gql`
    fragment MyOrderListItem on Order {
  id
  consumerFriendlyId
  state
  categoryType
  sortTimestamp
  totalCost {
    ...MonetaryAmount
  }
  lineItems {
    ...OrderListLineItem
  }
  escalations(sources: [CONSUMER]) {
    ...OrderListEscalation
  }
}
    ${MonetaryAmountFragmentDoc}
${OrderListLineItemFragmentDoc}
${OrderListEscalationFragmentDoc}`;
export const OrderEscalationFragmentDoc = gql`
    fragment OrderEscalation on OrderEscalation {
  id
  type
  status
  createdAt
  orderLineItemId
  consumerFriendlyId
}
    `;
export const StartingSupportConversationFragmentDoc = gql`
    fragment StartingSupportConversation on SupportConversation {
  id
  conversationId
  consumerId
}
    `;
export const CategoryFilterDisplayMetadataFragmentDoc = gql`
    fragment CategoryFilterDisplayMetadata on Category {
  id
  slug
  pluralDisplayName
}
    `;
export const CategoryFilterBreadcrumbsFragmentDoc = gql`
    fragment CategoryFilterBreadcrumbs on Category {
  ...CategoryFilterDisplayMetadata
  ancestry: parents {
    ...CategoryFilterDisplayMetadata
  }
  children(recurse: false) {
    ...CategoryFilterDisplayMetadata
  }
}
    ${CategoryFilterDisplayMetadataFragmentDoc}`;
export const TrackableSellableWithDefaultVariantFragmentDoc = gql`
    fragment TrackableSellableWithDefaultVariant on Sellable {
  ...TrackableSellable
  variationMatrix {
    defaultVariant {
      id
      friendlyId
      slug
      type
      salePrice {
        ...MonetaryAmount
      }
      originalPrice {
        ...MonetaryAmount
      }
    }
  }
}
    ${TrackableSellableFragmentDoc}
${MonetaryAmountFragmentDoc}`;
export const CategorySellableSearchResultFragmentDoc = gql`
    fragment CategorySellableSearchResult on SellableSearchEdge {
  cursor
  node {
    type
    ...SellableCard
    ...TrackableSellableWithDefaultVariant
  }
}
    ${SellableCardFragmentDoc}
${TrackableSellableWithDefaultVariantFragmentDoc}`;
export const SellableSearchResultFragmentDoc = gql`
    fragment SellableSearchResult on SellableSearchEdge {
  cursor
  node {
    ...SellableCard
  }
}
    ${SellableCardFragmentDoc}`;
export const LeadForCurationsFragmentDoc = gql`
    fragment LeadForCurations on Lead {
  id
  consumer {
    id
    firstName
  }
  expert {
    id
    displayName
    shortName
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
  }
  conversation {
    id
  }
  category {
    id
    contentAssets {
      bannerImages {
        title
        mimeType
        imageUrl
      }
    }
  }
  department {
    id
    slug
  }
}
    ${MediaFileFragmentDoc}`;
export const CurationCardItemCategoryFragmentDoc = gql`
    fragment CurationCardItemCategory on Category {
  id
  singularDisplayName
}
    `;
export const CurationCardItemFragmentDoc = gql`
    fragment CurationCardItem on ExpertCuratedItem {
  id
  createdAt
  category {
    ...CurationCardItemCategory
  }
  note {
    id
  }
  lead {
    id
    department {
      id
      type
    }
  }
}
    ${CurationCardItemCategoryFragmentDoc}`;
export const CurationCardInfoFragmentDoc = gql`
    fragment CurationCardInfo on ExpertCuratedItemsForLeadPayload {
  id
  items {
    ...CurationCardItem
  }
}
    ${CurationCardItemFragmentDoc}`;
export const CurationCardLeadInfoFragmentDoc = gql`
    fragment CurationCardLeadInfo on Lead {
  id
  category {
    id
    slug
  }
  department {
    id
    type
    displayName
    slug
  }
  latestRequest {
    id
    createdAt
  }
  expert {
    id
    shortName
    displayName
    expertProfile {
      id
      headline
      profilePhoto {
        id
        url
      }
    }
  }
  conversation {
    id
  }
  curationSummary {
    lastCurationSentAt
  }
  consumerConversationMetrics {
    firstManualMessageSentAt
  }
}
    `;
export const CategoryBannerAssetsFragmentDoc = gql`
    fragment CategoryBannerAssets on Category {
  id
  contentAssets {
    bannerImages {
      imageUrl
    }
  }
}
    `;
export const CuratedItemsLeadFragmentDoc = gql`
    fragment CuratedItemsLead on Lead {
  id
  createdAt
  expert {
    id
    vanityId
    displayName
    shortName
    department {
      id
      slug
    }
  }
  delegateExpert {
    id
    displayName
    shortName
  }
  department {
    ...DepartmentContext
    topLevelCategory {
      ...CategoryBannerAssets
    }
  }
  conversation {
    id
    externalId
  }
  consumerConversationMetrics {
    messageCount
  }
  expertConversationMetrics {
    messageCount
  }
  createdAt
}
    ${DepartmentContextFragmentDoc}
${CategoryBannerAssetsFragmentDoc}`;
export const ExpertCuratedItemForCurationProductPageFragmentDoc = gql`
    fragment ExpertCuratedItemForCurationProductPage on ExpertCuratedItem {
  id
  createdAt
  priceOverride {
    ...MonetaryAmount
  }
  priceOverrideValidUntil
  createdBy {
    id
    firstName
    lastName
    shortName
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
  }
  tag {
    type
    displayLabel
  }
  note {
    id
    text
  }
  category {
    ...ExpertCuratedItemCategory
  }
  sellable {
    id
    active
    ...SellableDetails
    ...TrackableSellable
    department {
      id
      mostRecentLeadForConsumer {
        id
      }
    }
    expireAt
    variationMatrix {
      ...VariationMatrix
    }
  }
  salePrice {
    ...MonetaryAmount
  }
  lineItemInCart {
    id
  }
  customizations {
    ...ExpertCuratedItemCustomization
  }
  rank
}
    ${MonetaryAmountFragmentDoc}
${MediaFileFragmentDoc}
${ExpertCuratedItemCategoryFragmentDoc}
${SellableDetailsFragmentDoc}
${TrackableSellableFragmentDoc}
${VariationMatrixFragmentDoc}
${ExpertCuratedItemCustomizationFragmentDoc}`;
export const ReactionSellableFragmentDoc = gql`
    fragment ReactionSellable on Sellable {
  id
  friendlyId
  slug
  type
  title
  brand {
    ...Brand
  }
  images {
    ...MediaFile
  }
  salePrice {
    ...MonetaryAmount
  }
  originalPrice {
    ...MonetaryAmount
  }
}
    ${BrandFragmentDoc}
${MediaFileFragmentDoc}
${MonetaryAmountFragmentDoc}`;
export const UserSellableReactionFragmentDoc = gql`
    fragment UserSellableReaction on ConsumerSellableReaction {
  id
  ratingWithDisplayName {
    displayName
    rating
  }
  reasonsWithDisplayName {
    displayName
    reason
  }
  sellable {
    ...ReactionSellable
  }
}
    ${ReactionSellableFragmentDoc}`;
export const SubcategoryInfoFragmentDoc = gql`
    fragment SubcategoryInfo on Category {
  id
  slug
  pluralDisplayName
}
    `;
export const CategoryInfoFragmentDoc = gql`
    fragment CategoryInfo on Category {
  id
  slug
  type
  pluralDisplayName
  contentAssets {
    communityPoster {
      imageUrl
    }
  }
  children(recurse: false) {
    ...SubcategoryInfo
  }
  parents {
    id
    children(recurse: false) {
      ...SubcategoryInfo
    }
  }
  brands(activeOnly: true) {
    ...Brand
  }
}
    ${SubcategoryInfoFragmentDoc}
${BrandFragmentDoc}`;
export const HomeExpertFragmentDoc = gql`
    fragment HomeExpert on BusinessUser {
  id
  displayName
  shortName
  department {
    id
    slug
    type
  }
}
    `;
export const MostRecentLeadFragmentDoc = gql`
    fragment MostRecentLead on Lead {
  id
  conversation {
    id
  }
  expert {
    ...HomeExpert
  }
}
    ${HomeExpertFragmentDoc}`;
export const ExpertProfileHighlightsFragmentDoc = gql`
    fragment ExpertProfileHighlights on ProfileHighlight {
  type {
    id
    icon
    displayName
  }
  value
  secondaryValue
}
    `;
export const DepartmentExpertFragmentDoc = gql`
    fragment DepartmentExpert on BusinessUser {
  id
  vanityId
  expertProfile {
    id
    background
    backgroundRichText
    headline
    gallery {
      caption
      mediaFile {
        ...MediaFile
      }
    }
    highlights {
      ...ExpertProfileHighlights
    }
    profilePhoto {
      ...MediaFile
    }
    socialMediaLinks {
      socialMediaType
      url
    }
  }
  expertAttributes {
    placeholderExpert
  }
  expertPresence {
    status
  }
  expertStats {
    averageRating
    totalReviews
    totalMessagesSent
    totalLeadsAsPrimaryExpert
  }
  displayName
  shortName
  department {
    id
    slug
    type
  }
}
    ${MediaFileFragmentDoc}
${ExpertProfileHighlightsFragmentDoc}`;
export const DepartmentLeadFragmentDoc = gql`
    fragment DepartmentLead on Lead {
  id
  curationSummary {
    lastCurationSentAt
  }
  conversation {
    id
  }
  category {
    id
    type
  }
  expert {
    ...DepartmentExpert
  }
}
    ${DepartmentExpertFragmentDoc}`;
export const DepartmentConsumerExpertReviewFragmentDoc = gql`
    fragment DepartmentConsumerExpertReview on ConsumerExpertReview {
  id
  comments
  goodQualities
  headline
  rating
  consumer {
    id
    firstName
    lastName
  }
  expert {
    id
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
    displayName
  }
  reviewedAt
}
    ${MediaFileFragmentDoc}`;
export const DepartmentSearchFacetSelectionsFragmentDoc = gql`
    fragment DepartmentSearchFacetSelections on FacetSelectionPayload {
  name
  displayName
  bucketValues
}
    `;
export const DepartmentTopLevelCategoryFragmentDoc = gql`
    fragment DepartmentTopLevelCategory on Category {
  id
  slug
  pluralDisplayName
  contentAssets {
    communityPoster {
      imageUrl
    }
  }
}
    `;
export const ExpertProfilePhotoCarouselFragmentDoc = gql`
    fragment ExpertProfilePhotoCarousel on ExpertProfile {
  id
  profilePhoto {
    ...MediaFile
  }
  gallery {
    caption
    mediaFile {
      ...MediaFile
    }
  }
}
    ${MediaFileFragmentDoc}`;
export const ExpertProfileBusinessUserFragmentDoc = gql`
    fragment ExpertProfileBusinessUser on ExpertProfile {
  id
  headline
  background
  backgroundRichText
  location
  highlights {
    ...ExpertProfileHighlights
  }
  profilePhoto {
    ...MediaFile
  }
  ...ExpertProfilePhotoCarousel
  socialMediaLinks {
    socialMediaType
    url
  }
  favoriteBrands {
    ...Brand
  }
  currentGears {
    id
    title
    friendlyId
    slug
    type
    brand {
      id
      displayName
    }
    images {
      ...MediaFile
    }
  }
}
    ${ExpertProfileHighlightsFragmentDoc}
${MediaFileFragmentDoc}
${ExpertProfilePhotoCarouselFragmentDoc}
${BrandFragmentDoc}`;
export const ExpertReviewFragmentDoc = gql`
    fragment ExpertReview on ConsumerExpertReview {
  id
  consumerName
  consumerLocation
  rating
  comments
  headline
  goodQualities
  reviewedAt
}
    `;
export const ExpertBusinessUserFragmentDoc = gql`
    fragment ExpertBusinessUser on BusinessUser {
  id
  vanityId
  messagingUser {
    id
  }
  expertAttributes {
    placeholderExpert
    categories {
      id
      slug
      pluralDisplayName
    }
  }
  expertPresence {
    status
  }
  department {
    ...DepartmentContext
    topLevelCategory {
      id
      slug
    }
  }
  displayName
  shortName
  expertProfile {
    ...ExpertProfileBusinessUser
  }
  consumerExpertReviewConnection {
    edges {
      node {
        ...ExpertReview
      }
    }
  }
  expertStats {
    ...ExpertStats
  }
}
    ${DepartmentContextFragmentDoc}
${ExpertProfileBusinessUserFragmentDoc}
${ExpertReviewFragmentDoc}
${ExpertStatsFragmentDoc}`;
export const TopRecommendedSellableCategoryFragmentDoc = gql`
    fragment TopRecommendedSellableCategory on Category {
  id
  pluralDisplayName
}
    `;
export const TopRecommendedSellableFragmentDoc = gql`
    fragment TopRecommendedSellable on ExpertTopRecommendedSellable {
  sellable {
    id
    friendlyId
    slug
    type
    images {
      ...MediaFile
    }
    title
    brand {
      id
      displayName
      logo {
        ...MediaFile
      }
    }
  }
  timesRecommended
}
    ${MediaFileFragmentDoc}`;
export const ExpertTopSellablesFragmentDoc = gql`
    fragment ExpertTopSellables on ExpertCategoryTopRecommendedSellable {
  displayTitle
  category {
    ...TopRecommendedSellableCategory
  }
  topRecommendedSellables {
    ...TopRecommendedSellable
  }
}
    ${TopRecommendedSellableCategoryFragmentDoc}
${TopRecommendedSellableFragmentDoc}`;
export const ExpertInfoFragmentDoc = gql`
    fragment ExpertInfo on BusinessUser {
  id
  displayName
  shortName
  expertProfile {
    id
    profilePhoto {
      id
      url
    }
  }
}
    `;
export const SpotlightExpertFragmentDoc = gql`
    fragment SpotlightExpert on BusinessUser {
  id
  vanityId
  displayName
  shortName
  department {
    id
    type
    topLevelCategory {
      id
      slug
      singularDisplayName
    }
  }
  expertProfile {
    id
    location
    headline
    spotlightHeadline
    portraitVideo {
      ...MediaFile
    }
    introductionVideoLink {
      smallUrl
      mediumUrl
      largeUrl
      xLargeUrl
    }
  }
}
    ${MediaFileFragmentDoc}`;
export const LeadOverviewFragmentDoc = gql`
    fragment LeadOverview on Lead {
  id
  conversation {
    id
    externalId
  }
  offers {
    id
    state
  }
}
    `;
export const SupportConversationFragmentDoc = gql`
    fragment SupportConversation on SupportConversation {
  id
  conversation {
    id
    externalId
  }
}
    `;
export const ByLeadExpertFragmentDoc = gql`
    fragment ByLeadExpert on BusinessUser {
  id
  displayName
  shortName
  presence
  expertAttributes {
    placeholderExpert
  }
  expertProfile {
    id
    profilePhoto {
      ...MediaFile
    }
  }
  expertStats {
    averageRating
    totalReviews
    totalMessagesSent
  }
}
    ${MediaFileFragmentDoc}`;
export const LeadExpertProfileExpertProfileFragmentDoc = gql`
    fragment LeadExpertProfileExpertProfile on ExpertProfile {
  id
  headline
  background
  quotes
  socialMediaLinks {
    socialMediaType
    url
  }
  highlights {
    type {
      id
      icon
      displayName
    }
    value
    secondaryValue
  }
  profilePhoto {
    ...MediaFile
  }
}
    ${MediaFileFragmentDoc}`;
export const LeadExpertProfileExpertFragmentDoc = gql`
    fragment LeadExpertProfileExpert on BusinessUser {
  id
  vanityId
  displayName
  shortName
  expertProfile {
    ...LeadExpertProfileExpertProfile
  }
  expertStats {
    ...ExpertStats
  }
  department {
    id
    type
    slug
  }
}
    ${LeadExpertProfileExpertProfileFragmentDoc}
${ExpertStatsFragmentDoc}`;
export const LeadExpertProfileFragmentDoc = gql`
    fragment LeadExpertProfile on Lead {
  id
  expert {
    ...LeadExpertProfileExpert
  }
  consumerConversationMetrics {
    messageCount
  }
  expertConversationMetrics {
    messageCount
  }
}
    ${LeadExpertProfileExpertFragmentDoc}`;
export const ConversationExpertFragmentDoc = gql`
    fragment ConversationExpert on BusinessUser {
  id
  vanityId
  displayName
  shortName
  expertProfile {
    id
    headline
    profilePhoto {
      ...MediaFile
    }
    highlights {
      value
      secondaryValue
      type {
        id
        icon
      }
    }
  }
  expertAttributes {
    placeholderExpert
  }
  expertStats {
    totalMessagesSent
    totalReviews
  }
}
    ${MediaFileFragmentDoc}`;
export const ConversationWithMetaDataFragmentDoc = gql`
    fragment ConversationWithMetaData on Conversation {
  id
  externalId
  title
  active
  lead {
    id
    expert {
      ...ConversationExpert
    }
    consumerConversationMetrics {
      messageCount
    }
    expertConversationMetrics {
      messageCount
    }
    dealbotConversationMetrics {
      messageCount
    }
    consumerInitialAction
  }
}
    ${ConversationExpertFragmentDoc}`;
export const FeaturedExpertFragmentDoc = gql`
    fragment FeaturedExpert on BusinessUser {
  id
  vanityId
  displayName
  shortName
  department {
    id
    slug
    type
    topLevelCategory {
      id
      singularDisplayName
      pluralDisplayName
    }
  }
  expertProfile {
    id
    location
    background
    headline
    profilePhoto {
      ...MediaFile
    }
    highlights {
      ...ExpertProfileHighlights
    }
  }
  expertStats {
    averageRating
    totalLeadsAsPrimaryExpert
    totalReviews
  }
}
    ${MediaFileFragmentDoc}
${ExpertProfileHighlightsFragmentDoc}`;
export const ShippingMethodCostFragmentDoc = gql`
    fragment ShippingMethodCost on ShippingMethodCost {
  shippingMethod
  cost {
    ...MonetaryAmount
  }
  estimatedToArriveAt
}
    ${MonetaryAmountFragmentDoc}`;
export const ExpertTipPercentageFragmentDoc = gql`
    fragment ExpertTipPercentage on ExpertTipPercentage {
  expert {
    id
    displayName
    shortName
    active
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
  }
  percentOfTip
}
    ${MediaFileFragmentDoc}`;
export const OrderSellableInfoFragmentDoc = gql`
    fragment OrderSellableInfo on OrderLineItemSellableSource {
  sellable {
    id
    images {
      url
    }
    title
    originalPrice {
      ...MonetaryAmount
    }
    salePrice {
      ...MonetaryAmount
    }
  }
  overridePrice {
    ...MonetaryAmount
  }
}
    ${MonetaryAmountFragmentDoc}`;
export const TrackableOrderFragmentDoc = gql`
    fragment TrackableOrder on Order {
  id
  state
  tax {
    ...MonetaryAmount
  }
  tip {
    ...MonetaryAmount
  }
  totalCost {
    ...MonetaryAmount
  }
  totalShippingCost: totalCostOnlyIncluding(costComponents: [SHIPMENT]) {
    ...MonetaryAmount
  }
  subtotal: totalCostOnlyIncluding(costComponents: [CORE, GRATUITY]) {
    ...MonetaryAmount
  }
  appliedPromotionEntry {
    promotion {
      id
      code
    }
  }
  lineItems {
    id
    quantity
    source {
      ... on OrderLineItemSellableSource {
        sellable {
          ...TrackableSellable
        }
      }
    }
  }
}
    ${MonetaryAmountFragmentDoc}
${TrackableSellableFragmentDoc}`;
export const TipContainerOrderFragmentDoc = gql`
    fragment TipContainerOrder on Order {
  id
  state
  tip {
    ...MonetaryAmount
  }
  tipMethod {
    type
    ... on TipMethodPercentOfAmount {
      percentOptions: options {
        rate
        maximumAmount {
          ...MonetaryAmount
        }
        minimumAmount {
          ...MonetaryAmount
        }
      }
    }
    ... on TipMethodFixedAmount {
      amountOptions: options {
        ...MonetaryAmount
      }
    }
  }
  categoryType
  lineItems {
    id
    source {
      type
      ... on OrderLineItemSellableSource {
        sellable {
          id
          type
          originalPrice {
            ...MonetaryAmount
          }
        }
      }
    }
  }
  subtotal: totalCostOnlyIncluding(costComponents: [CORE, GRATUITY]) {
    ...MonetaryAmount
  }
}
    ${MonetaryAmountFragmentDoc}`;
export const OrderWithLineItemsFragmentDoc = gql`
    fragment OrderWithLineItems on Order {
  ...Order
  ...TrackableOrder
  ...TipContainerOrder
  estimatedToArriveAt
  shippingMethod
  consumerFriendlyId
  user {
    id
    expertReviews {
      id
      expert {
        id
      }
    }
  }
  appliedPromotionEntry {
    applied
    discount {
      ...MonetaryAmount
    }
    promotion {
      id
      code
    }
  }
  promotionEntries {
    applied
    discount {
      ...MonetaryAmount
    }
    promotion {
      id
      code
    }
  }
  chargeableStatus(useCase: PURCHASE) {
    type
    message
  }
  remainingBalance {
    ...MonetaryAmount
  }
  minimumDeposit {
    ...MonetaryAmount
  }
  depositPaidAt
  fullPaymentDueAt
  paidInFullAt
  paidAmount {
    ...MonetaryAmount
  }
  lineItems {
    ...OrderLineItem
  }
  serviceLocation {
    displayTitle
  }
  simpleCuratedOrder {
    id
    type
  }
}
    ${OrderFragmentDoc}
${TrackableOrderFragmentDoc}
${TipContainerOrderFragmentDoc}
${MonetaryAmountFragmentDoc}
${OrderLineItemFragmentDoc}`;
export const ProductDetailsFragmentDoc = gql`
    fragment ProductDetails on Sellable {
  id
  ...SellableDetails
  ...TrackableSellable
  department {
    id
    mostRecentLeadForConsumer {
      id
    }
  }
  categories {
    id
    singularDisplayName
    pluralDisplayName
  }
}
    ${SellableDetailsFragmentDoc}
${TrackableSellableFragmentDoc}`;
export const ReviewStatsFragmentDoc = gql`
    fragment ReviewStats on AggregateExpertReport {
  globalStats {
    reviewsCount
    averageExpertRating
  }
}
    `;
export const ExistingLeadFragmentDoc = gql`
    fragment ExistingLead on Lead {
  id
  conversation {
    id
    externalId
  }
}
    `;
export const ProductExpertFragmentDoc = gql`
    fragment ProductExpert on BusinessUser {
  id
  vanityId
  expertStats {
    ...ExpertStats
  }
  displayName
  shortName
  expertAttributes {
    placeholderExpert
  }
  expertProfile {
    id
    headline
    highlights {
      ...ExpertProfileHighlights
    }
    profilePhoto {
      ...MediaFile
    }
  }
  department {
    id
    type
  }
}
    ${ExpertStatsFragmentDoc}
${ExpertProfileHighlightsFragmentDoc}
${MediaFileFragmentDoc}`;
export const ProductRecommendedExpertFragmentDoc = gql`
    fragment ProductRecommendedExpert on RecommendExpertPayload {
  existingLead {
    ...ExistingLead
  }
  expert {
    ...ProductExpert
  }
}
    ${ExistingLeadFragmentDoc}
${ProductExpertFragmentDoc}`;
export const ExpertCuratedItemNoteFragmentDoc = gql`
    fragment ExpertCuratedItemNote on ExpertCuratedItemNote {
  id
  text
  useCount
  createdBy {
    ...ProductExpert
  }
  sellable {
    id
    categories {
      id
      singularDisplayName
    }
  }
}
    ${ProductExpertFragmentDoc}`;
export const ReferralSourceConsumerGenericFragmentDoc = gql`
    fragment ReferralSourceConsumerGeneric on ReferralSourceConsumerGeneric {
  type
}
    `;
export const ExpertToRecommendFragmentDoc = gql`
    fragment ExpertToRecommend on BusinessUser {
  id
  displayName
  shortName
  expertAttributes {
    category {
      id
      singularDisplayName
    }
  }
  expertProfile {
    id
    profilePhoto {
      ...MediaFile
    }
  }
}
    ${MediaFileFragmentDoc}`;
export const ReferralSourceConsumerToExpertFragmentDoc = gql`
    fragment ReferralSourceConsumerToExpert on ReferralSourceConsumerToExpert {
  type
  referredToExpert {
    ...ExpertToRecommend
  }
}
    ${ExpertToRecommendFragmentDoc}`;
export const ReferralCodeFragmentDoc = gql`
    fragment ReferralCode on ReferralCode {
  id
  code
  source {
    ...ReferralSourceConsumerGeneric
    ...ReferralSourceConsumerToExpert
  }
  facebookShortenedUrl: shortenedUrl(medium: FACEBOOK, sourceKey: $sourceKey)
  smsShortenedUrl: shortenedUrl(medium: LINK, sourceKey: $sourceKey)
  linkShortenedUrl: shortenedUrl(medium: LINK, sourceKey: $sourceKey)
  emailShortenedUrl: shortenedUrl(medium: EMAIL, sourceKey: $sourceKey)
  urlWithoutTracking
}
    ${ReferralSourceConsumerGenericFragmentDoc}
${ReferralSourceConsumerToExpertFragmentDoc}`;
export const RefereeExpertReviewFragmentDoc = gql`
    fragment RefereeExpertReview on ConsumerExpertReview {
  id
  rating
  headline
  comments
  goodQualities
  reviewedAt
  consumer {
    id
    firstName
  }
  verifiedPurchases {
    ...ActivityFeedSellable
  }
}
    ${ActivityFeedSellableFragmentDoc}`;
export const ReferralExpertFragmentDoc = gql`
    fragment ReferralExpert on BusinessUser {
  id
  displayName
  shortName
  vanityId
  state
  department {
    id
    slug
    type
  }
  expertPresence {
    status
  }
  expertStats {
    totalReviews
    averageRating
    totalLeadsAsPrimaryExpert
  }
  expertAttributes {
    placeholderExpert
    category {
      id
      singularDisplayName
      slug
    }
  }
  expertProfile {
    id
    background
    headline
    socialMediaLinks {
      url
      socialMediaType
    }
    profilePhoto {
      ...MediaFile
    }
    highlights {
      ...ExpertProfileHighlights
    }
  }
}
    ${MediaFileFragmentDoc}
${ExpertProfileHighlightsFragmentDoc}`;
export const RefereeFragmentDoc = gql`
    fragment Referee on User {
  id
  firstName
}
    `;
export const LandingPageReferralSourceConsumerGenericFragmentDoc = gql`
    fragment LandingPageReferralSourceConsumerGeneric on ReferralSourceConsumerGeneric {
  type
  expertsToRefer {
    ...ReferralExpert
  }
  user {
    ...Referee
  }
}
    ${ReferralExpertFragmentDoc}
${RefereeFragmentDoc}`;
export const LandingPageReferralSourceConsumerToExpertFragmentDoc = gql`
    fragment LandingPageReferralSourceConsumerToExpert on ReferralSourceConsumerToExpert {
  type
  referredToExpert {
    ...ReferralExpert
  }
  user {
    ...Referee
  }
}
    ${ReferralExpertFragmentDoc}
${RefereeFragmentDoc}`;
export const LandingPageReferralSourceExpertDirectFragmentDoc = gql`
    fragment LandingPageReferralSourceExpertDirect on ReferralSourceExpertDirect {
  type
  referredByExpert {
    ...ReferralExpert
  }
}
    ${ReferralExpertFragmentDoc}`;
export const LookupReferralCodeFragmentDoc = gql`
    fragment LookupReferralCode on ReferralCode {
  id
  code
  source {
    ...LandingPageReferralSourceConsumerGeneric
    ...LandingPageReferralSourceConsumerToExpert
    ...LandingPageReferralSourceExpertDirect
  }
}
    ${LandingPageReferralSourceConsumerGenericFragmentDoc}
${LandingPageReferralSourceConsumerToExpertFragmentDoc}
${LandingPageReferralSourceExpertDirectFragmentDoc}`;
export const ReferralCategoryFragmentDoc = gql`
    fragment ReferralCategory on Category {
  id
  pluralDisplayName
  slug
  department {
    id
    type
  }
}
    `;
export const ReferralDepartmentFragmentDoc = gql`
    fragment ReferralDepartment on Department {
  id
  topLevelCategory {
    id
    expertCategories {
      ...ReferralCategory
    }
  }
}
    ${ReferralCategoryFragmentDoc}`;
export const GlobalStatsFragmentDoc = gql`
    fragment GlobalStats on GlobalStatsAggregateExpertReport {
  conversationsCountThisWeek
  conversationsCountTotal
  curationsCountTotal
  curationsCountThisWeek
}
    `;
export const TopLevelCategoryFragmentDoc = gql`
    fragment TopLevelCategory on Category {
  id
  slug
  pluralDisplayName
  contentAssets {
    communityPoster {
      imageUrl
    }
  }
}
    `;
export const CommunityLeadExpertFragmentDoc = gql`
    fragment CommunityLeadExpert on BusinessUser {
  id
  expertProfile {
    ...ExpertProfilePhotoCarousel
    id
    background
    socialMediaLinks {
      socialMediaType
      url
    }
    highlights {
      ...ExpertProfileHighlights
    }
    headline
    profilePhoto {
      id
      url
    }
  }
  expertAttributes {
    placeholderExpert
  }
  expertPresence {
    status
  }
  expertStats {
    totalReviews
    totalLeadsAsPrimaryExpert
    averageRating
  }
  department {
    id
    slug
    type
  }
  displayName
  shortName
}
    ${ExpertProfilePhotoCarouselFragmentDoc}
${ExpertProfileHighlightsFragmentDoc}`;
export const ReviewSummaryBucketsFragmentDoc = gql`
    fragment ReviewSummaryBuckets on BucketedDisplayFacet {
  buckets {
    count
    value
  }
}
    `;
export const GlobalReviewStatisticsFragmentDoc = gql`
    fragment GlobalReviewStatistics on ConsumerExpertReviewConnection {
  count
  facets {
    ... on BucketedDisplayFacet {
      buckets {
        count
        value
      }
    }
    displayName
    alias
    name
  }
}
    `;
export const OrderEscalationSummaryFragmentDoc = gql`
    fragment OrderEscalationSummary on OrderEscalation {
  id
  consumerFriendlyId
  createdAt
  type
  status
  assignedTo {
    id
    firstName
  }
}
    `;
export const OrderEscalationSearchResultFragmentDoc = gql`
    fragment OrderEscalationSearchResult on OrderEscalationEdge {
  cursor
  node {
    ...OrderEscalationSummary
  }
}
    ${OrderEscalationSummaryFragmentDoc}`;
export const TopicPageExpertFragmentDoc = gql`
    fragment TopicPageExpert on BusinessUser {
  id
  displayName
  shortName
  expertProfile {
    id
    profilePhoto {
      ...MediaFile
    }
    location
  }
  expertStats {
    ...ExpertStats
  }
}
    ${MediaFileFragmentDoc}
${ExpertStatsFragmentDoc}`;
export const AuthenticateDocument = gql`
    mutation Authenticate($input: AuthenticationInput!) {
  authenticate(input: $input) {
    result
    message
    user {
      ...AuthenticatedUser
    }
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export type AuthenticateMutationFn = ApolloReactCommon.MutationFunction<AuthenticateMutation, AuthenticateMutationVariables>;
export type AuthenticateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AuthenticateMutation, AuthenticateMutationVariables>, 'mutation'>;

    export const AuthenticateComponent = (props: AuthenticateComponentProps) => (
      <ApolloReactComponents.Mutation<AuthenticateMutation, AuthenticateMutationVariables> mutation={AuthenticateDocument} {...props} />
    );
    

/**
 * __useAuthenticateMutation__
 *
 * To run a mutation, you first call `useAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateMutation, { data, loading, error }] = useAuthenticateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticateMutation, AuthenticateMutationVariables>) {
        return ApolloReactHooks.useMutation<AuthenticateMutation, AuthenticateMutationVariables>(AuthenticateDocument, baseOptions);
      }
export type AuthenticateMutationHookResult = ReturnType<typeof useAuthenticateMutation>;
export type AuthenticateMutationResult = ApolloReactCommon.MutationResult<AuthenticateMutation>;
export type AuthenticateMutationOptions = ApolloReactCommon.BaseMutationOptions<AuthenticateMutation, AuthenticateMutationVariables>;
export const AuthenticationSessionStateDocument = gql`
    query AuthenticationSessionState {
  session {
    ...AuthenticationState
  }
}
    ${AuthenticationStateFragmentDoc}`;
export type AuthenticationSessionStateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AuthenticationSessionStateQuery, AuthenticationSessionStateQueryVariables>, 'query'>;

    export const AuthenticationSessionStateComponent = (props: AuthenticationSessionStateComponentProps) => (
      <ApolloReactComponents.Query<AuthenticationSessionStateQuery, AuthenticationSessionStateQueryVariables> query={AuthenticationSessionStateDocument} {...props} />
    );
    

/**
 * __useAuthenticationSessionStateQuery__
 *
 * To run a query within a React component, call `useAuthenticationSessionStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationSessionStateQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticationSessionStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthenticationSessionStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AuthenticationSessionStateQuery, AuthenticationSessionStateQueryVariables>) {
        return ApolloReactHooks.useQuery<AuthenticationSessionStateQuery, AuthenticationSessionStateQueryVariables>(AuthenticationSessionStateDocument, baseOptions);
      }
export function useAuthenticationSessionStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AuthenticationSessionStateQuery, AuthenticationSessionStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AuthenticationSessionStateQuery, AuthenticationSessionStateQueryVariables>(AuthenticationSessionStateDocument, baseOptions);
        }
export type AuthenticationSessionStateQueryHookResult = ReturnType<typeof useAuthenticationSessionStateQuery>;
export type AuthenticationSessionStateLazyQueryHookResult = ReturnType<typeof useAuthenticationSessionStateLazyQuery>;
export type AuthenticationSessionStateQueryResult = ApolloReactCommon.QueryResult<AuthenticationSessionStateQuery, AuthenticationSessionStateQueryVariables>;
export const FindContactDocument = gql`
    query FindContact($contactId: ContactId!) {
  findContact(contactId: $contactId) {
    id
    type
    value
    verified
  }
}
    `;
export type FindContactComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FindContactQuery, FindContactQueryVariables>, 'query'> & ({ variables: FindContactQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FindContactComponent = (props: FindContactComponentProps) => (
      <ApolloReactComponents.Query<FindContactQuery, FindContactQueryVariables> query={FindContactDocument} {...props} />
    );
    

/**
 * __useFindContactQuery__
 *
 * To run a query within a React component, call `useFindContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindContactQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindContactQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useFindContactQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindContactQuery, FindContactQueryVariables>) {
        return ApolloReactHooks.useQuery<FindContactQuery, FindContactQueryVariables>(FindContactDocument, baseOptions);
      }
export function useFindContactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindContactQuery, FindContactQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FindContactQuery, FindContactQueryVariables>(FindContactDocument, baseOptions);
        }
export type FindContactQueryHookResult = ReturnType<typeof useFindContactQuery>;
export type FindContactLazyQueryHookResult = ReturnType<typeof useFindContactLazyQuery>;
export type FindContactQueryResult = ApolloReactCommon.QueryResult<FindContactQuery, FindContactQueryVariables>;
export const InitiateAuthenticationDocument = gql`
    mutation InitiateAuthentication($input: InitiateAuthenticationInput!) {
  initiateAuthentication(input: $input) {
    isValidHandle
    challengeType
    session {
      ...AuthenticationState
    }
  }
}
    ${AuthenticationStateFragmentDoc}`;
export type InitiateAuthenticationMutationFn = ApolloReactCommon.MutationFunction<InitiateAuthenticationMutation, InitiateAuthenticationMutationVariables>;
export type InitiateAuthenticationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InitiateAuthenticationMutation, InitiateAuthenticationMutationVariables>, 'mutation'>;

    export const InitiateAuthenticationComponent = (props: InitiateAuthenticationComponentProps) => (
      <ApolloReactComponents.Mutation<InitiateAuthenticationMutation, InitiateAuthenticationMutationVariables> mutation={InitiateAuthenticationDocument} {...props} />
    );
    

/**
 * __useInitiateAuthenticationMutation__
 *
 * To run a mutation, you first call `useInitiateAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateAuthenticationMutation, { data, loading, error }] = useInitiateAuthenticationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateAuthenticationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InitiateAuthenticationMutation, InitiateAuthenticationMutationVariables>) {
        return ApolloReactHooks.useMutation<InitiateAuthenticationMutation, InitiateAuthenticationMutationVariables>(InitiateAuthenticationDocument, baseOptions);
      }
export type InitiateAuthenticationMutationHookResult = ReturnType<typeof useInitiateAuthenticationMutation>;
export type InitiateAuthenticationMutationResult = ApolloReactCommon.MutationResult<InitiateAuthenticationMutation>;
export type InitiateAuthenticationMutationOptions = ApolloReactCommon.BaseMutationOptions<InitiateAuthenticationMutation, InitiateAuthenticationMutationVariables>;
export const InitiateResetPasswordDocument = gql`
    mutation InitiateResetPassword($input: InitiateResetPasswordInput!) {
  initiateResetPassword(input: $input) {
    success
    errorMessage
  }
}
    `;
export type InitiateResetPasswordMutationFn = ApolloReactCommon.MutationFunction<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables>;
export type InitiateResetPasswordComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables>, 'mutation'>;

    export const InitiateResetPasswordComponent = (props: InitiateResetPasswordComponentProps) => (
      <ApolloReactComponents.Mutation<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables> mutation={InitiateResetPasswordDocument} {...props} />
    );
    

/**
 * __useInitiateResetPasswordMutation__
 *
 * To run a mutation, you first call `useInitiateResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateResetPasswordMutation, { data, loading, error }] = useInitiateResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables>(InitiateResetPasswordDocument, baseOptions);
      }
export type InitiateResetPasswordMutationHookResult = ReturnType<typeof useInitiateResetPasswordMutation>;
export type InitiateResetPasswordMutationResult = ApolloReactCommon.MutationResult<InitiateResetPasswordMutation>;
export type InitiateResetPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = ApolloReactCommon.MutationFunction<LogoutMutation, LogoutMutationVariables>;
export type LogoutComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<LogoutMutation, LogoutMutationVariables>, 'mutation'>;

    export const LogoutComponent = (props: LogoutComponentProps) => (
      <ApolloReactComponents.Mutation<LogoutMutation, LogoutMutationVariables> mutation={LogoutDocument} {...props} />
    );
    

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, baseOptions);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = ApolloReactCommon.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    result
    message
    user {
      ...AuthenticatedUser
    }
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export type ResetPasswordMutationFn = ApolloReactCommon.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;
export type ResetPasswordComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ResetPasswordMutation, ResetPasswordMutationVariables>, 'mutation'>;

    export const ResetPasswordComponent = (props: ResetPasswordComponentProps) => (
      <ApolloReactComponents.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> mutation={ResetPasswordDocument} {...props} />
    );
    

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, baseOptions);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = ApolloReactCommon.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SessionAuthenticationStateDocument = gql`
    query SessionAuthenticationState {
  session {
    id
    authenticationMethod
    authenticationState {
      handle
      handleId
      loginChallengeType
      resetPasswordChallengeVerified
    }
  }
}
    `;
export type SessionAuthenticationStateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SessionAuthenticationStateQuery, SessionAuthenticationStateQueryVariables>, 'query'>;

    export const SessionAuthenticationStateComponent = (props: SessionAuthenticationStateComponentProps) => (
      <ApolloReactComponents.Query<SessionAuthenticationStateQuery, SessionAuthenticationStateQueryVariables> query={SessionAuthenticationStateDocument} {...props} />
    );
    

/**
 * __useSessionAuthenticationStateQuery__
 *
 * To run a query within a React component, call `useSessionAuthenticationStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionAuthenticationStateQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionAuthenticationStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionAuthenticationStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SessionAuthenticationStateQuery, SessionAuthenticationStateQueryVariables>) {
        return ApolloReactHooks.useQuery<SessionAuthenticationStateQuery, SessionAuthenticationStateQueryVariables>(SessionAuthenticationStateDocument, baseOptions);
      }
export function useSessionAuthenticationStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SessionAuthenticationStateQuery, SessionAuthenticationStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SessionAuthenticationStateQuery, SessionAuthenticationStateQueryVariables>(SessionAuthenticationStateDocument, baseOptions);
        }
export type SessionAuthenticationStateQueryHookResult = ReturnType<typeof useSessionAuthenticationStateQuery>;
export type SessionAuthenticationStateLazyQueryHookResult = ReturnType<typeof useSessionAuthenticationStateLazyQuery>;
export type SessionAuthenticationStateQueryResult = ApolloReactCommon.QueryResult<SessionAuthenticationStateQuery, SessionAuthenticationStateQueryVariables>;
export const ExpertPhoneNumberBySlugDocument = gql`
    query ExpertPhoneNumberBySlug($slug: String!) {
  categoryBySlug(slug: $slug) {
    id
    recommendExpertForConsumer {
      expert {
        id
        displayName
        shortName
        expertProfile {
          id
          profilePhoto {
            id
            url
          }
        }
        assignedPhone: assignedAddress(type: SMS)
      }
    }
  }
}
    `;
export type ExpertPhoneNumberBySlugComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertPhoneNumberBySlugQuery, ExpertPhoneNumberBySlugQueryVariables>, 'query'> & ({ variables: ExpertPhoneNumberBySlugQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertPhoneNumberBySlugComponent = (props: ExpertPhoneNumberBySlugComponentProps) => (
      <ApolloReactComponents.Query<ExpertPhoneNumberBySlugQuery, ExpertPhoneNumberBySlugQueryVariables> query={ExpertPhoneNumberBySlugDocument} {...props} />
    );
    

/**
 * __useExpertPhoneNumberBySlugQuery__
 *
 * To run a query within a React component, call `useExpertPhoneNumberBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertPhoneNumberBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertPhoneNumberBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useExpertPhoneNumberBySlugQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertPhoneNumberBySlugQuery, ExpertPhoneNumberBySlugQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertPhoneNumberBySlugQuery, ExpertPhoneNumberBySlugQueryVariables>(ExpertPhoneNumberBySlugDocument, baseOptions);
      }
export function useExpertPhoneNumberBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertPhoneNumberBySlugQuery, ExpertPhoneNumberBySlugQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertPhoneNumberBySlugQuery, ExpertPhoneNumberBySlugQueryVariables>(ExpertPhoneNumberBySlugDocument, baseOptions);
        }
export type ExpertPhoneNumberBySlugQueryHookResult = ReturnType<typeof useExpertPhoneNumberBySlugQuery>;
export type ExpertPhoneNumberBySlugLazyQueryHookResult = ReturnType<typeof useExpertPhoneNumberBySlugLazyQuery>;
export type ExpertPhoneNumberBySlugQueryResult = ApolloReactCommon.QueryResult<ExpertPhoneNumberBySlugQuery, ExpertPhoneNumberBySlugQueryVariables>;
export const ChatExpertDocument = gql`
    query ChatExpert($businessUserId: BusinessUserId!) {
  businessUser(id: $businessUserId) {
    ...ChatWidgetExpert
  }
}
    ${ChatWidgetExpertFragmentDoc}`;
export type ChatExpertComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ChatExpertQuery, ChatExpertQueryVariables>, 'query'> & ({ variables: ChatExpertQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ChatExpertComponent = (props: ChatExpertComponentProps) => (
      <ApolloReactComponents.Query<ChatExpertQuery, ChatExpertQueryVariables> query={ChatExpertDocument} {...props} />
    );
    

/**
 * __useChatExpertQuery__
 *
 * To run a query within a React component, call `useChatExpertQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatExpertQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatExpertQuery({
 *   variables: {
 *      businessUserId: // value for 'businessUserId'
 *   },
 * });
 */
export function useChatExpertQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChatExpertQuery, ChatExpertQueryVariables>) {
        return ApolloReactHooks.useQuery<ChatExpertQuery, ChatExpertQueryVariables>(ChatExpertDocument, baseOptions);
      }
export function useChatExpertLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatExpertQuery, ChatExpertQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ChatExpertQuery, ChatExpertQueryVariables>(ChatExpertDocument, baseOptions);
        }
export type ChatExpertQueryHookResult = ReturnType<typeof useChatExpertQuery>;
export type ChatExpertLazyQueryHookResult = ReturnType<typeof useChatExpertLazyQuery>;
export type ChatExpertQueryResult = ApolloReactCommon.QueryResult<ChatExpertQuery, ChatExpertQueryVariables>;
export const ChatExpertByDepartmentDocument = gql`
    query ChatExpertByDepartment($id: DepartmentId!) {
  department(id: $id) {
    id
    topLevelCategory {
      id
      recommendExpertForConsumer {
        expert {
          ...ChatWidgetExpert
        }
        existingLead {
          id
          conversation {
            id
            externalId
          }
        }
      }
    }
  }
}
    ${ChatWidgetExpertFragmentDoc}`;
export type ChatExpertByDepartmentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ChatExpertByDepartmentQuery, ChatExpertByDepartmentQueryVariables>, 'query'> & ({ variables: ChatExpertByDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ChatExpertByDepartmentComponent = (props: ChatExpertByDepartmentComponentProps) => (
      <ApolloReactComponents.Query<ChatExpertByDepartmentQuery, ChatExpertByDepartmentQueryVariables> query={ChatExpertByDepartmentDocument} {...props} />
    );
    

/**
 * __useChatExpertByDepartmentQuery__
 *
 * To run a query within a React component, call `useChatExpertByDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatExpertByDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatExpertByDepartmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChatExpertByDepartmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChatExpertByDepartmentQuery, ChatExpertByDepartmentQueryVariables>) {
        return ApolloReactHooks.useQuery<ChatExpertByDepartmentQuery, ChatExpertByDepartmentQueryVariables>(ChatExpertByDepartmentDocument, baseOptions);
      }
export function useChatExpertByDepartmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatExpertByDepartmentQuery, ChatExpertByDepartmentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ChatExpertByDepartmentQuery, ChatExpertByDepartmentQueryVariables>(ChatExpertByDepartmentDocument, baseOptions);
        }
export type ChatExpertByDepartmentQueryHookResult = ReturnType<typeof useChatExpertByDepartmentQuery>;
export type ChatExpertByDepartmentLazyQueryHookResult = ReturnType<typeof useChatExpertByDepartmentLazyQuery>;
export type ChatExpertByDepartmentQueryResult = ApolloReactCommon.QueryResult<ChatExpertByDepartmentQuery, ChatExpertByDepartmentQueryVariables>;
export const UserLoginTokenDocument = gql`
    query UserLoginToken {
  me {
    id
    loginToken
  }
}
    `;
export type UserLoginTokenComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserLoginTokenQuery, UserLoginTokenQueryVariables>, 'query'>;

    export const UserLoginTokenComponent = (props: UserLoginTokenComponentProps) => (
      <ApolloReactComponents.Query<UserLoginTokenQuery, UserLoginTokenQueryVariables> query={UserLoginTokenDocument} {...props} />
    );
    

/**
 * __useUserLoginTokenQuery__
 *
 * To run a query within a React component, call `useUserLoginTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserLoginTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserLoginTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserLoginTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserLoginTokenQuery, UserLoginTokenQueryVariables>) {
        return ApolloReactHooks.useQuery<UserLoginTokenQuery, UserLoginTokenQueryVariables>(UserLoginTokenDocument, baseOptions);
      }
export function useUserLoginTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserLoginTokenQuery, UserLoginTokenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<UserLoginTokenQuery, UserLoginTokenQueryVariables>(UserLoginTokenDocument, baseOptions);
        }
export type UserLoginTokenQueryHookResult = ReturnType<typeof useUserLoginTokenQuery>;
export type UserLoginTokenLazyQueryHookResult = ReturnType<typeof useUserLoginTokenLazyQuery>;
export type UserLoginTokenQueryResult = ApolloReactCommon.QueryResult<UserLoginTokenQuery, UserLoginTokenQueryVariables>;
export const CuratedItemsForLeadDocument = gql`
    query CuratedItemsForLead($leadId: LeadId!) {
  expertCuratedItemsForLead(leadId: $leadId) {
    id
    items {
      ...HeroExpertCuratedItemImage
    }
  }
  lead(id: $leadId) {
    ...HeroCuratedItemsLead
  }
  expertCuratedOrdersForLeadConnection(query: {leadId: $leadId, showClosed: true}) {
    edges {
      node {
        ...ExpertCuratedOrder
      }
    }
  }
}
    ${HeroExpertCuratedItemImageFragmentDoc}
${HeroCuratedItemsLeadFragmentDoc}
${ExpertCuratedOrderFragmentDoc}`;
export type CuratedItemsForLeadComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CuratedItemsForLeadQuery, CuratedItemsForLeadQueryVariables>, 'query'> & ({ variables: CuratedItemsForLeadQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CuratedItemsForLeadComponent = (props: CuratedItemsForLeadComponentProps) => (
      <ApolloReactComponents.Query<CuratedItemsForLeadQuery, CuratedItemsForLeadQueryVariables> query={CuratedItemsForLeadDocument} {...props} />
    );
    

/**
 * __useCuratedItemsForLeadQuery__
 *
 * To run a query within a React component, call `useCuratedItemsForLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useCuratedItemsForLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCuratedItemsForLeadQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useCuratedItemsForLeadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CuratedItemsForLeadQuery, CuratedItemsForLeadQueryVariables>) {
        return ApolloReactHooks.useQuery<CuratedItemsForLeadQuery, CuratedItemsForLeadQueryVariables>(CuratedItemsForLeadDocument, baseOptions);
      }
export function useCuratedItemsForLeadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CuratedItemsForLeadQuery, CuratedItemsForLeadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CuratedItemsForLeadQuery, CuratedItemsForLeadQueryVariables>(CuratedItemsForLeadDocument, baseOptions);
        }
export type CuratedItemsForLeadQueryHookResult = ReturnType<typeof useCuratedItemsForLeadQuery>;
export type CuratedItemsForLeadLazyQueryHookResult = ReturnType<typeof useCuratedItemsForLeadLazyQuery>;
export type CuratedItemsForLeadQueryResult = ApolloReactCommon.QueryResult<CuratedItemsForLeadQuery, CuratedItemsForLeadQueryVariables>;
export const DepartmentDetailedReviewsDocument = gql`
    query DepartmentDetailedReviews($departmentId: DepartmentId!) {
  department(id: $departmentId) {
    id
    displayName
    slug
    reviewSummary {
      averageRating
      totalReviews
    }
    consumerExpertReviewConnection(filter: {source: SHOPPER_APPROVED}, first: 15) {
      edges {
        node {
          ...DepartmentExpertReview
        }
      }
    }
  }
}
    ${DepartmentExpertReviewFragmentDoc}`;
export type DepartmentDetailedReviewsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DepartmentDetailedReviewsQuery, DepartmentDetailedReviewsQueryVariables>, 'query'> & ({ variables: DepartmentDetailedReviewsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DepartmentDetailedReviewsComponent = (props: DepartmentDetailedReviewsComponentProps) => (
      <ApolloReactComponents.Query<DepartmentDetailedReviewsQuery, DepartmentDetailedReviewsQueryVariables> query={DepartmentDetailedReviewsDocument} {...props} />
    );
    

/**
 * __useDepartmentDetailedReviewsQuery__
 *
 * To run a query within a React component, call `useDepartmentDetailedReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentDetailedReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentDetailedReviewsQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useDepartmentDetailedReviewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DepartmentDetailedReviewsQuery, DepartmentDetailedReviewsQueryVariables>) {
        return ApolloReactHooks.useQuery<DepartmentDetailedReviewsQuery, DepartmentDetailedReviewsQueryVariables>(DepartmentDetailedReviewsDocument, baseOptions);
      }
export function useDepartmentDetailedReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentDetailedReviewsQuery, DepartmentDetailedReviewsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DepartmentDetailedReviewsQuery, DepartmentDetailedReviewsQueryVariables>(DepartmentDetailedReviewsDocument, baseOptions);
        }
export type DepartmentDetailedReviewsQueryHookResult = ReturnType<typeof useDepartmentDetailedReviewsQuery>;
export type DepartmentDetailedReviewsLazyQueryHookResult = ReturnType<typeof useDepartmentDetailedReviewsLazyQuery>;
export type DepartmentDetailedReviewsQueryResult = ApolloReactCommon.QueryResult<DepartmentDetailedReviewsQuery, DepartmentDetailedReviewsQueryVariables>;
export const EngagementChannelCategoryAssetsDocument = gql`
    query EngagementChannelCategoryAssets($categoryId: CategoryId!) {
  category(categoryId: $categoryId) {
    ...EngagementChannelCategory
  }
}
    ${EngagementChannelCategoryFragmentDoc}`;
export type EngagementChannelCategoryAssetsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EngagementChannelCategoryAssetsQuery, EngagementChannelCategoryAssetsQueryVariables>, 'query'> & ({ variables: EngagementChannelCategoryAssetsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EngagementChannelCategoryAssetsComponent = (props: EngagementChannelCategoryAssetsComponentProps) => (
      <ApolloReactComponents.Query<EngagementChannelCategoryAssetsQuery, EngagementChannelCategoryAssetsQueryVariables> query={EngagementChannelCategoryAssetsDocument} {...props} />
    );
    

/**
 * __useEngagementChannelCategoryAssetsQuery__
 *
 * To run a query within a React component, call `useEngagementChannelCategoryAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementChannelCategoryAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementChannelCategoryAssetsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useEngagementChannelCategoryAssetsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EngagementChannelCategoryAssetsQuery, EngagementChannelCategoryAssetsQueryVariables>) {
        return ApolloReactHooks.useQuery<EngagementChannelCategoryAssetsQuery, EngagementChannelCategoryAssetsQueryVariables>(EngagementChannelCategoryAssetsDocument, baseOptions);
      }
export function useEngagementChannelCategoryAssetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EngagementChannelCategoryAssetsQuery, EngagementChannelCategoryAssetsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EngagementChannelCategoryAssetsQuery, EngagementChannelCategoryAssetsQueryVariables>(EngagementChannelCategoryAssetsDocument, baseOptions);
        }
export type EngagementChannelCategoryAssetsQueryHookResult = ReturnType<typeof useEngagementChannelCategoryAssetsQuery>;
export type EngagementChannelCategoryAssetsLazyQueryHookResult = ReturnType<typeof useEngagementChannelCategoryAssetsLazyQuery>;
export type EngagementChannelCategoryAssetsQueryResult = ApolloReactCommon.QueryResult<EngagementChannelCategoryAssetsQuery, EngagementChannelCategoryAssetsQueryVariables>;
export const PathSlugForCategoryDocument = gql`
    query PathSlugForCategory($slug: String!) {
  categoryBySlug(slug: $slug) {
    id
    slug
    ancestorWithPath {
      id
      slug
    }
  }
}
    `;
export type PathSlugForCategoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PathSlugForCategoryQuery, PathSlugForCategoryQueryVariables>, 'query'> & ({ variables: PathSlugForCategoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PathSlugForCategoryComponent = (props: PathSlugForCategoryComponentProps) => (
      <ApolloReactComponents.Query<PathSlugForCategoryQuery, PathSlugForCategoryQueryVariables> query={PathSlugForCategoryDocument} {...props} />
    );
    

/**
 * __usePathSlugForCategoryQuery__
 *
 * To run a query within a React component, call `usePathSlugForCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathSlugForCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathSlugForCategoryQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePathSlugForCategoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PathSlugForCategoryQuery, PathSlugForCategoryQueryVariables>) {
        return ApolloReactHooks.useQuery<PathSlugForCategoryQuery, PathSlugForCategoryQueryVariables>(PathSlugForCategoryDocument, baseOptions);
      }
export function usePathSlugForCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PathSlugForCategoryQuery, PathSlugForCategoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PathSlugForCategoryQuery, PathSlugForCategoryQueryVariables>(PathSlugForCategoryDocument, baseOptions);
        }
export type PathSlugForCategoryQueryHookResult = ReturnType<typeof usePathSlugForCategoryQuery>;
export type PathSlugForCategoryLazyQueryHookResult = ReturnType<typeof usePathSlugForCategoryLazyQuery>;
export type PathSlugForCategoryQueryResult = ApolloReactCommon.QueryResult<PathSlugForCategoryQuery, PathSlugForCategoryQueryVariables>;
export const SellableForModalDocument = gql`
    query SellableForModal($friendlyIdOrId: String!) {
  findSellable(friendlyIdOrId: $friendlyIdOrId) {
    ...SellableForModal
  }
}
    ${SellableForModalFragmentDoc}`;
export type SellableForModalComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SellableForModalQuery, SellableForModalQueryVariables>, 'query'> & ({ variables: SellableForModalQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellableForModalComponent = (props: SellableForModalComponentProps) => (
      <ApolloReactComponents.Query<SellableForModalQuery, SellableForModalQueryVariables> query={SellableForModalDocument} {...props} />
    );
    

/**
 * __useSellableForModalQuery__
 *
 * To run a query within a React component, call `useSellableForModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellableForModalQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellableForModalQuery({
 *   variables: {
 *      friendlyIdOrId: // value for 'friendlyIdOrId'
 *   },
 * });
 */
export function useSellableForModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SellableForModalQuery, SellableForModalQueryVariables>) {
        return ApolloReactHooks.useQuery<SellableForModalQuery, SellableForModalQueryVariables>(SellableForModalDocument, baseOptions);
      }
export function useSellableForModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SellableForModalQuery, SellableForModalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SellableForModalQuery, SellableForModalQueryVariables>(SellableForModalDocument, baseOptions);
        }
export type SellableForModalQueryHookResult = ReturnType<typeof useSellableForModalQuery>;
export type SellableForModalLazyQueryHookResult = ReturnType<typeof useSellableForModalLazyQuery>;
export type SellableForModalQueryResult = ApolloReactCommon.QueryResult<SellableForModalQuery, SellableForModalQueryVariables>;
export const SellableBrandCategoryDocument = gql`
    query SellableBrandCategory($friendlyIdOrId: String!) {
  findSellable(friendlyIdOrId: $friendlyIdOrId) {
    id
    brand {
      ...Brand
    }
    categories {
      ...CategoryModal
    }
  }
}
    ${BrandFragmentDoc}
${CategoryModalFragmentDoc}`;
export type SellableBrandCategoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SellableBrandCategoryQuery, SellableBrandCategoryQueryVariables>, 'query'> & ({ variables: SellableBrandCategoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellableBrandCategoryComponent = (props: SellableBrandCategoryComponentProps) => (
      <ApolloReactComponents.Query<SellableBrandCategoryQuery, SellableBrandCategoryQueryVariables> query={SellableBrandCategoryDocument} {...props} />
    );
    

/**
 * __useSellableBrandCategoryQuery__
 *
 * To run a query within a React component, call `useSellableBrandCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellableBrandCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellableBrandCategoryQuery({
 *   variables: {
 *      friendlyIdOrId: // value for 'friendlyIdOrId'
 *   },
 * });
 */
export function useSellableBrandCategoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SellableBrandCategoryQuery, SellableBrandCategoryQueryVariables>) {
        return ApolloReactHooks.useQuery<SellableBrandCategoryQuery, SellableBrandCategoryQueryVariables>(SellableBrandCategoryDocument, baseOptions);
      }
export function useSellableBrandCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SellableBrandCategoryQuery, SellableBrandCategoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SellableBrandCategoryQuery, SellableBrandCategoryQueryVariables>(SellableBrandCategoryDocument, baseOptions);
        }
export type SellableBrandCategoryQueryHookResult = ReturnType<typeof useSellableBrandCategoryQuery>;
export type SellableBrandCategoryLazyQueryHookResult = ReturnType<typeof useSellableBrandCategoryLazyQuery>;
export type SellableBrandCategoryQueryResult = ApolloReactCommon.QueryResult<SellableBrandCategoryQuery, SellableBrandCategoryQueryVariables>;
export const AddItemsToOrderDocument = gql`
    mutation AddItemsToOrder($input: AddItemsToOrderInput!) {
  addItemsToOrder(input: $input) {
    order {
      id
    }
  }
}
    `;
export type AddItemsToOrderMutationFn = ApolloReactCommon.MutationFunction<AddItemsToOrderMutation, AddItemsToOrderMutationVariables>;
export type AddItemsToOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddItemsToOrderMutation, AddItemsToOrderMutationVariables>, 'mutation'>;

    export const AddItemsToOrderComponent = (props: AddItemsToOrderComponentProps) => (
      <ApolloReactComponents.Mutation<AddItemsToOrderMutation, AddItemsToOrderMutationVariables> mutation={AddItemsToOrderDocument} {...props} />
    );
    

/**
 * __useAddItemsToOrderMutation__
 *
 * To run a mutation, you first call `useAddItemsToOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemsToOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemsToOrderMutation, { data, loading, error }] = useAddItemsToOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddItemsToOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddItemsToOrderMutation, AddItemsToOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<AddItemsToOrderMutation, AddItemsToOrderMutationVariables>(AddItemsToOrderDocument, baseOptions);
      }
export type AddItemsToOrderMutationHookResult = ReturnType<typeof useAddItemsToOrderMutation>;
export type AddItemsToOrderMutationResult = ApolloReactCommon.MutationResult<AddItemsToOrderMutation>;
export type AddItemsToOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<AddItemsToOrderMutation, AddItemsToOrderMutationVariables>;
export const ExpertByCategoryDocument = gql`
    query ExpertByCategory($categoryId: CategoryId!) {
  category(categoryId: $categoryId) {
    id
    ancestorWithPath {
      id
      name
      slug
      startPathUrl
      contentAssets {
        bannerImages {
          imageUrl
        }
      }
      department {
        id
        slug
      }
    }
    recommendExpertForConsumer {
      expert {
        ...ChatWidgetExpert
      }
    }
  }
}
    ${ChatWidgetExpertFragmentDoc}`;
export type ExpertByCategoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertByCategoryQuery, ExpertByCategoryQueryVariables>, 'query'> & ({ variables: ExpertByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertByCategoryComponent = (props: ExpertByCategoryComponentProps) => (
      <ApolloReactComponents.Query<ExpertByCategoryQuery, ExpertByCategoryQueryVariables> query={ExpertByCategoryDocument} {...props} />
    );
    

/**
 * __useExpertByCategoryQuery__
 *
 * To run a query within a React component, call `useExpertByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertByCategoryQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useExpertByCategoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertByCategoryQuery, ExpertByCategoryQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertByCategoryQuery, ExpertByCategoryQueryVariables>(ExpertByCategoryDocument, baseOptions);
      }
export function useExpertByCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertByCategoryQuery, ExpertByCategoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertByCategoryQuery, ExpertByCategoryQueryVariables>(ExpertByCategoryDocument, baseOptions);
        }
export type ExpertByCategoryQueryHookResult = ReturnType<typeof useExpertByCategoryQuery>;
export type ExpertByCategoryLazyQueryHookResult = ReturnType<typeof useExpertByCategoryLazyQuery>;
export type ExpertByCategoryQueryResult = ApolloReactCommon.QueryResult<ExpertByCategoryQuery, ExpertByCategoryQueryVariables>;
export const ExperienceByExpertCuratedOrderDocument = gql`
    query ExperienceByExpertCuratedOrder($id: ExpertCuratedOrderId!) {
  expertCuratedOrder(id: $id) {
    ...ExpertCuratedOrder
  }
}
    ${ExpertCuratedOrderFragmentDoc}`;
export type ExperienceByExpertCuratedOrderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExperienceByExpertCuratedOrderQuery, ExperienceByExpertCuratedOrderQueryVariables>, 'query'> & ({ variables: ExperienceByExpertCuratedOrderQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExperienceByExpertCuratedOrderComponent = (props: ExperienceByExpertCuratedOrderComponentProps) => (
      <ApolloReactComponents.Query<ExperienceByExpertCuratedOrderQuery, ExperienceByExpertCuratedOrderQueryVariables> query={ExperienceByExpertCuratedOrderDocument} {...props} />
    );
    

/**
 * __useExperienceByExpertCuratedOrderQuery__
 *
 * To run a query within a React component, call `useExperienceByExpertCuratedOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperienceByExpertCuratedOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperienceByExpertCuratedOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExperienceByExpertCuratedOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExperienceByExpertCuratedOrderQuery, ExperienceByExpertCuratedOrderQueryVariables>) {
        return ApolloReactHooks.useQuery<ExperienceByExpertCuratedOrderQuery, ExperienceByExpertCuratedOrderQueryVariables>(ExperienceByExpertCuratedOrderDocument, baseOptions);
      }
export function useExperienceByExpertCuratedOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExperienceByExpertCuratedOrderQuery, ExperienceByExpertCuratedOrderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExperienceByExpertCuratedOrderQuery, ExperienceByExpertCuratedOrderQueryVariables>(ExperienceByExpertCuratedOrderDocument, baseOptions);
        }
export type ExperienceByExpertCuratedOrderQueryHookResult = ReturnType<typeof useExperienceByExpertCuratedOrderQuery>;
export type ExperienceByExpertCuratedOrderLazyQueryHookResult = ReturnType<typeof useExperienceByExpertCuratedOrderLazyQuery>;
export type ExperienceByExpertCuratedOrderQueryResult = ApolloReactCommon.QueryResult<ExperienceByExpertCuratedOrderQuery, ExperienceByExpertCuratedOrderQueryVariables>;
export const ExperienceByFriendlyIdOrIdDocument = gql`
    query ExperienceByFriendlyIdOrId($friendlyIdOrId: String!) {
  findSellable(friendlyIdOrId: $friendlyIdOrId) {
    ...ExperienceDetails
  }
}
    ${ExperienceDetailsFragmentDoc}`;
export type ExperienceByFriendlyIdOrIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExperienceByFriendlyIdOrIdQuery, ExperienceByFriendlyIdOrIdQueryVariables>, 'query'> & ({ variables: ExperienceByFriendlyIdOrIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExperienceByFriendlyIdOrIdComponent = (props: ExperienceByFriendlyIdOrIdComponentProps) => (
      <ApolloReactComponents.Query<ExperienceByFriendlyIdOrIdQuery, ExperienceByFriendlyIdOrIdQueryVariables> query={ExperienceByFriendlyIdOrIdDocument} {...props} />
    );
    

/**
 * __useExperienceByFriendlyIdOrIdQuery__
 *
 * To run a query within a React component, call `useExperienceByFriendlyIdOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperienceByFriendlyIdOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperienceByFriendlyIdOrIdQuery({
 *   variables: {
 *      friendlyIdOrId: // value for 'friendlyIdOrId'
 *   },
 * });
 */
export function useExperienceByFriendlyIdOrIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExperienceByFriendlyIdOrIdQuery, ExperienceByFriendlyIdOrIdQueryVariables>) {
        return ApolloReactHooks.useQuery<ExperienceByFriendlyIdOrIdQuery, ExperienceByFriendlyIdOrIdQueryVariables>(ExperienceByFriendlyIdOrIdDocument, baseOptions);
      }
export function useExperienceByFriendlyIdOrIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExperienceByFriendlyIdOrIdQuery, ExperienceByFriendlyIdOrIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExperienceByFriendlyIdOrIdQuery, ExperienceByFriendlyIdOrIdQueryVariables>(ExperienceByFriendlyIdOrIdDocument, baseOptions);
        }
export type ExperienceByFriendlyIdOrIdQueryHookResult = ReturnType<typeof useExperienceByFriendlyIdOrIdQuery>;
export type ExperienceByFriendlyIdOrIdLazyQueryHookResult = ReturnType<typeof useExperienceByFriendlyIdOrIdLazyQuery>;
export type ExperienceByFriendlyIdOrIdQueryResult = ApolloReactCommon.QueryResult<ExperienceByFriendlyIdOrIdQuery, ExperienceByFriendlyIdOrIdQueryVariables>;
export const RequestSellableDocument = gql`
    mutation RequestSellable($input: RequestSellableInput!) {
  requestSellable(input: $input) {
    error
    lead {
      id
      conversation {
        id
        externalId
      }
    }
  }
}
    `;
export type RequestSellableMutationFn = ApolloReactCommon.MutationFunction<RequestSellableMutation, RequestSellableMutationVariables>;
export type RequestSellableComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RequestSellableMutation, RequestSellableMutationVariables>, 'mutation'>;

    export const RequestSellableComponent = (props: RequestSellableComponentProps) => (
      <ApolloReactComponents.Mutation<RequestSellableMutation, RequestSellableMutationVariables> mutation={RequestSellableDocument} {...props} />
    );
    

/**
 * __useRequestSellableMutation__
 *
 * To run a mutation, you first call `useRequestSellableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSellableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSellableMutation, { data, loading, error }] = useRequestSellableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestSellableMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestSellableMutation, RequestSellableMutationVariables>) {
        return ApolloReactHooks.useMutation<RequestSellableMutation, RequestSellableMutationVariables>(RequestSellableDocument, baseOptions);
      }
export type RequestSellableMutationHookResult = ReturnType<typeof useRequestSellableMutation>;
export type RequestSellableMutationResult = ApolloReactCommon.MutationResult<RequestSellableMutation>;
export type RequestSellableMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestSellableMutation, RequestSellableMutationVariables>;
export const ExpertPhoneNumberDocument = gql`
    query ExpertPhoneNumber($slug: String!) {
  categoryBySlug(slug: $slug) {
    id
    recommendExpertForConsumer {
      expert {
        id
        assignedPhone: assignedAddress(type: SMS)
      }
    }
  }
}
    `;
export type ExpertPhoneNumberComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertPhoneNumberQuery, ExpertPhoneNumberQueryVariables>, 'query'> & ({ variables: ExpertPhoneNumberQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertPhoneNumberComponent = (props: ExpertPhoneNumberComponentProps) => (
      <ApolloReactComponents.Query<ExpertPhoneNumberQuery, ExpertPhoneNumberQueryVariables> query={ExpertPhoneNumberDocument} {...props} />
    );
    

/**
 * __useExpertPhoneNumberQuery__
 *
 * To run a query within a React component, call `useExpertPhoneNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertPhoneNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertPhoneNumberQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useExpertPhoneNumberQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertPhoneNumberQuery, ExpertPhoneNumberQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertPhoneNumberQuery, ExpertPhoneNumberQueryVariables>(ExpertPhoneNumberDocument, baseOptions);
      }
export function useExpertPhoneNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertPhoneNumberQuery, ExpertPhoneNumberQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertPhoneNumberQuery, ExpertPhoneNumberQueryVariables>(ExpertPhoneNumberDocument, baseOptions);
        }
export type ExpertPhoneNumberQueryHookResult = ReturnType<typeof useExpertPhoneNumberQuery>;
export type ExpertPhoneNumberLazyQueryHookResult = ReturnType<typeof useExpertPhoneNumberLazyQuery>;
export type ExpertPhoneNumberQueryResult = ApolloReactCommon.QueryResult<ExpertPhoneNumberQuery, ExpertPhoneNumberQueryVariables>;
export const RatesTableDocument = gql`
    query RatesTable($id: SellableId!) {
  sellable(id: $id) {
    id
    variationMatrix {
      ...VariationMatrix
    }
  }
}
    ${VariationMatrixFragmentDoc}`;
export type RatesTableComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RatesTableQuery, RatesTableQueryVariables>, 'query'> & ({ variables: RatesTableQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RatesTableComponent = (props: RatesTableComponentProps) => (
      <ApolloReactComponents.Query<RatesTableQuery, RatesTableQueryVariables> query={RatesTableDocument} {...props} />
    );
    

/**
 * __useRatesTableQuery__
 *
 * To run a query within a React component, call `useRatesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatesTableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRatesTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RatesTableQuery, RatesTableQueryVariables>) {
        return ApolloReactHooks.useQuery<RatesTableQuery, RatesTableQueryVariables>(RatesTableDocument, baseOptions);
      }
export function useRatesTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RatesTableQuery, RatesTableQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RatesTableQuery, RatesTableQueryVariables>(RatesTableDocument, baseOptions);
        }
export type RatesTableQueryHookResult = ReturnType<typeof useRatesTableQuery>;
export type RatesTableLazyQueryHookResult = ReturnType<typeof useRatesTableLazyQuery>;
export type RatesTableQueryResult = ApolloReactCommon.QueryResult<RatesTableQuery, RatesTableQueryVariables>;
export const RatesTableSellableDocument = gql`
    query RatesTableSellable($ids: [SellableId!]!) {
  sellables(ids: $ids) {
    ...SellablePricingWithDefaultVariant
  }
}
    ${SellablePricingWithDefaultVariantFragmentDoc}`;
export type RatesTableSellableComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RatesTableSellableQuery, RatesTableSellableQueryVariables>, 'query'> & ({ variables: RatesTableSellableQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RatesTableSellableComponent = (props: RatesTableSellableComponentProps) => (
      <ApolloReactComponents.Query<RatesTableSellableQuery, RatesTableSellableQueryVariables> query={RatesTableSellableDocument} {...props} />
    );
    

/**
 * __useRatesTableSellableQuery__
 *
 * To run a query within a React component, call `useRatesTableSellableQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatesTableSellableQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatesTableSellableQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRatesTableSellableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RatesTableSellableQuery, RatesTableSellableQueryVariables>) {
        return ApolloReactHooks.useQuery<RatesTableSellableQuery, RatesTableSellableQueryVariables>(RatesTableSellableDocument, baseOptions);
      }
export function useRatesTableSellableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RatesTableSellableQuery, RatesTableSellableQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RatesTableSellableQuery, RatesTableSellableQueryVariables>(RatesTableSellableDocument, baseOptions);
        }
export type RatesTableSellableQueryHookResult = ReturnType<typeof useRatesTableSellableQuery>;
export type RatesTableSellableLazyQueryHookResult = ReturnType<typeof useRatesTableSellableLazyQuery>;
export type RatesTableSellableQueryResult = ApolloReactCommon.QueryResult<RatesTableSellableQuery, RatesTableSellableQueryVariables>;
export const SelectExperienceVariationOptionDocument = gql`
    mutation SelectExperienceVariationOption($input: SelectExpertCuratedOrderVariationOptionInput!) {
  selectExpertCuratedOrderVariationOption(input: $input) {
    expertCuratedOrder {
      ...ExpertCuratedOrder
    }
  }
}
    ${ExpertCuratedOrderFragmentDoc}`;
export type SelectExperienceVariationOptionMutationFn = ApolloReactCommon.MutationFunction<SelectExperienceVariationOptionMutation, SelectExperienceVariationOptionMutationVariables>;
export type SelectExperienceVariationOptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SelectExperienceVariationOptionMutation, SelectExperienceVariationOptionMutationVariables>, 'mutation'>;

    export const SelectExperienceVariationOptionComponent = (props: SelectExperienceVariationOptionComponentProps) => (
      <ApolloReactComponents.Mutation<SelectExperienceVariationOptionMutation, SelectExperienceVariationOptionMutationVariables> mutation={SelectExperienceVariationOptionDocument} {...props} />
    );
    

/**
 * __useSelectExperienceVariationOptionMutation__
 *
 * To run a mutation, you first call `useSelectExperienceVariationOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectExperienceVariationOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectExperienceVariationOptionMutation, { data, loading, error }] = useSelectExperienceVariationOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelectExperienceVariationOptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SelectExperienceVariationOptionMutation, SelectExperienceVariationOptionMutationVariables>) {
        return ApolloReactHooks.useMutation<SelectExperienceVariationOptionMutation, SelectExperienceVariationOptionMutationVariables>(SelectExperienceVariationOptionDocument, baseOptions);
      }
export type SelectExperienceVariationOptionMutationHookResult = ReturnType<typeof useSelectExperienceVariationOptionMutation>;
export type SelectExperienceVariationOptionMutationResult = ApolloReactCommon.MutationResult<SelectExperienceVariationOptionMutation>;
export type SelectExperienceVariationOptionMutationOptions = ApolloReactCommon.BaseMutationOptions<SelectExperienceVariationOptionMutation, SelectExperienceVariationOptionMutationVariables>;
export const DurationSelectorDocument = gql`
    query DurationSelector($id: SellableId!) {
  sellable(id: $id) {
    ...DurationSelector
  }
}
    ${DurationSelectorFragmentDoc}`;
export type DurationSelectorComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DurationSelectorQuery, DurationSelectorQueryVariables>, 'query'> & ({ variables: DurationSelectorQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DurationSelectorComponent = (props: DurationSelectorComponentProps) => (
      <ApolloReactComponents.Query<DurationSelectorQuery, DurationSelectorQueryVariables> query={DurationSelectorDocument} {...props} />
    );
    

/**
 * __useDurationSelectorQuery__
 *
 * To run a query within a React component, call `useDurationSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDurationSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDurationSelectorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDurationSelectorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DurationSelectorQuery, DurationSelectorQueryVariables>) {
        return ApolloReactHooks.useQuery<DurationSelectorQuery, DurationSelectorQueryVariables>(DurationSelectorDocument, baseOptions);
      }
export function useDurationSelectorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DurationSelectorQuery, DurationSelectorQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DurationSelectorQuery, DurationSelectorQueryVariables>(DurationSelectorDocument, baseOptions);
        }
export type DurationSelectorQueryHookResult = ReturnType<typeof useDurationSelectorQuery>;
export type DurationSelectorLazyQueryHookResult = ReturnType<typeof useDurationSelectorLazyQuery>;
export type DurationSelectorQueryResult = ApolloReactCommon.QueryResult<DurationSelectorQuery, DurationSelectorQueryVariables>;
export const RecommendedExpertForRequestDocument = gql`
    query RecommendedExpertForRequest($consumerId: UserId!, $categoryId: CategoryId!) {
  recommendExpert2(consumerId: $consumerId, categoryId: $categoryId) {
    expert {
      id
    }
  }
}
    `;
export type RecommendedExpertForRequestComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecommendedExpertForRequestQuery, RecommendedExpertForRequestQueryVariables>, 'query'> & ({ variables: RecommendedExpertForRequestQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RecommendedExpertForRequestComponent = (props: RecommendedExpertForRequestComponentProps) => (
      <ApolloReactComponents.Query<RecommendedExpertForRequestQuery, RecommendedExpertForRequestQueryVariables> query={RecommendedExpertForRequestDocument} {...props} />
    );
    

/**
 * __useRecommendedExpertForRequestQuery__
 *
 * To run a query within a React component, call `useRecommendedExpertForRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedExpertForRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedExpertForRequestQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useRecommendedExpertForRequestQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RecommendedExpertForRequestQuery, RecommendedExpertForRequestQueryVariables>) {
        return ApolloReactHooks.useQuery<RecommendedExpertForRequestQuery, RecommendedExpertForRequestQueryVariables>(RecommendedExpertForRequestDocument, baseOptions);
      }
export function useRecommendedExpertForRequestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecommendedExpertForRequestQuery, RecommendedExpertForRequestQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RecommendedExpertForRequestQuery, RecommendedExpertForRequestQueryVariables>(RecommendedExpertForRequestDocument, baseOptions);
        }
export type RecommendedExpertForRequestQueryHookResult = ReturnType<typeof useRecommendedExpertForRequestQuery>;
export type RecommendedExpertForRequestLazyQueryHookResult = ReturnType<typeof useRecommendedExpertForRequestLazyQuery>;
export type RecommendedExpertForRequestQueryResult = ApolloReactCommon.QueryResult<RecommendedExpertForRequestQuery, RecommendedExpertForRequestQueryVariables>;
export const FindExpertCalloutDocument = gql`
    query FindExpertCallout($vanityIdOrId: String!) {
  findExpert(vanityIdOrId: $vanityIdOrId) {
    ...ProductExpertCard
  }
}
    ${ProductExpertCardFragmentDoc}`;
export type FindExpertCalloutComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FindExpertCalloutQuery, FindExpertCalloutQueryVariables>, 'query'> & ({ variables: FindExpertCalloutQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FindExpertCalloutComponent = (props: FindExpertCalloutComponentProps) => (
      <ApolloReactComponents.Query<FindExpertCalloutQuery, FindExpertCalloutQueryVariables> query={FindExpertCalloutDocument} {...props} />
    );
    

/**
 * __useFindExpertCalloutQuery__
 *
 * To run a query within a React component, call `useFindExpertCalloutQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindExpertCalloutQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindExpertCalloutQuery({
 *   variables: {
 *      vanityIdOrId: // value for 'vanityIdOrId'
 *   },
 * });
 */
export function useFindExpertCalloutQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindExpertCalloutQuery, FindExpertCalloutQueryVariables>) {
        return ApolloReactHooks.useQuery<FindExpertCalloutQuery, FindExpertCalloutQueryVariables>(FindExpertCalloutDocument, baseOptions);
      }
export function useFindExpertCalloutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindExpertCalloutQuery, FindExpertCalloutQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FindExpertCalloutQuery, FindExpertCalloutQueryVariables>(FindExpertCalloutDocument, baseOptions);
        }
export type FindExpertCalloutQueryHookResult = ReturnType<typeof useFindExpertCalloutQuery>;
export type FindExpertCalloutLazyQueryHookResult = ReturnType<typeof useFindExpertCalloutLazyQuery>;
export type FindExpertCalloutQueryResult = ApolloReactCommon.QueryResult<FindExpertCalloutQuery, FindExpertCalloutQueryVariables>;
export const ProductRecommendedExpertCalloutDocument = gql`
    query ProductRecommendedExpertCallout($consumerId: UserId!, $categoryId: CategoryId!) {
  recommendExpert2(consumerId: $consumerId, categoryId: $categoryId) {
    existingLead {
      id
      conversation {
        id
        externalId
      }
    }
    expert {
      ...ProductExpertCard
    }
  }
}
    ${ProductExpertCardFragmentDoc}`;
export type ProductRecommendedExpertCalloutComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductRecommendedExpertCalloutQuery, ProductRecommendedExpertCalloutQueryVariables>, 'query'> & ({ variables: ProductRecommendedExpertCalloutQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductRecommendedExpertCalloutComponent = (props: ProductRecommendedExpertCalloutComponentProps) => (
      <ApolloReactComponents.Query<ProductRecommendedExpertCalloutQuery, ProductRecommendedExpertCalloutQueryVariables> query={ProductRecommendedExpertCalloutDocument} {...props} />
    );
    

/**
 * __useProductRecommendedExpertCalloutQuery__
 *
 * To run a query within a React component, call `useProductRecommendedExpertCalloutQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductRecommendedExpertCalloutQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductRecommendedExpertCalloutQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useProductRecommendedExpertCalloutQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductRecommendedExpertCalloutQuery, ProductRecommendedExpertCalloutQueryVariables>) {
        return ApolloReactHooks.useQuery<ProductRecommendedExpertCalloutQuery, ProductRecommendedExpertCalloutQueryVariables>(ProductRecommendedExpertCalloutDocument, baseOptions);
      }
export function useProductRecommendedExpertCalloutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductRecommendedExpertCalloutQuery, ProductRecommendedExpertCalloutQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProductRecommendedExpertCalloutQuery, ProductRecommendedExpertCalloutQueryVariables>(ProductRecommendedExpertCalloutDocument, baseOptions);
        }
export type ProductRecommendedExpertCalloutQueryHookResult = ReturnType<typeof useProductRecommendedExpertCalloutQuery>;
export type ProductRecommendedExpertCalloutLazyQueryHookResult = ReturnType<typeof useProductRecommendedExpertCalloutLazyQuery>;
export type ProductRecommendedExpertCalloutQueryResult = ApolloReactCommon.QueryResult<ProductRecommendedExpertCalloutQuery, ProductRecommendedExpertCalloutQueryVariables>;
export const ExpertForChatButtonDocument = gql`
    query ExpertForChatButton($vanityIdOrId: String!) {
  findExpert(vanityIdOrId: $vanityIdOrId) {
    id
    active
    expertAttributes {
      placeholderExpert
    }
  }
}
    `;
export type ExpertForChatButtonComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertForChatButtonQuery, ExpertForChatButtonQueryVariables>, 'query'> & ({ variables: ExpertForChatButtonQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertForChatButtonComponent = (props: ExpertForChatButtonComponentProps) => (
      <ApolloReactComponents.Query<ExpertForChatButtonQuery, ExpertForChatButtonQueryVariables> query={ExpertForChatButtonDocument} {...props} />
    );
    

/**
 * __useExpertForChatButtonQuery__
 *
 * To run a query within a React component, call `useExpertForChatButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertForChatButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertForChatButtonQuery({
 *   variables: {
 *      vanityIdOrId: // value for 'vanityIdOrId'
 *   },
 * });
 */
export function useExpertForChatButtonQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertForChatButtonQuery, ExpertForChatButtonQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertForChatButtonQuery, ExpertForChatButtonQueryVariables>(ExpertForChatButtonDocument, baseOptions);
      }
export function useExpertForChatButtonLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertForChatButtonQuery, ExpertForChatButtonQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertForChatButtonQuery, ExpertForChatButtonQueryVariables>(ExpertForChatButtonDocument, baseOptions);
        }
export type ExpertForChatButtonQueryHookResult = ReturnType<typeof useExpertForChatButtonQuery>;
export type ExpertForChatButtonLazyQueryHookResult = ReturnType<typeof useExpertForChatButtonLazyQuery>;
export type ExpertForChatButtonQueryResult = ApolloReactCommon.QueryResult<ExpertForChatButtonQuery, ExpertForChatButtonQueryVariables>;
export const ExpertFooterUserReviewsDocument = gql`
    query ExpertFooterUserReviews($userId: UserId!, $expertId: BusinessUserId) {
  user(userId: $userId) {
    id
    consumerExpertReviewConnection(expertId: $expertId) {
      edges {
        node {
          id
          expert {
            id
          }
        }
      }
    }
  }
}
    `;
export type ExpertFooterUserReviewsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertFooterUserReviewsQuery, ExpertFooterUserReviewsQueryVariables>, 'query'> & ({ variables: ExpertFooterUserReviewsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertFooterUserReviewsComponent = (props: ExpertFooterUserReviewsComponentProps) => (
      <ApolloReactComponents.Query<ExpertFooterUserReviewsQuery, ExpertFooterUserReviewsQueryVariables> query={ExpertFooterUserReviewsDocument} {...props} />
    );
    

/**
 * __useExpertFooterUserReviewsQuery__
 *
 * To run a query within a React component, call `useExpertFooterUserReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertFooterUserReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertFooterUserReviewsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      expertId: // value for 'expertId'
 *   },
 * });
 */
export function useExpertFooterUserReviewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertFooterUserReviewsQuery, ExpertFooterUserReviewsQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertFooterUserReviewsQuery, ExpertFooterUserReviewsQueryVariables>(ExpertFooterUserReviewsDocument, baseOptions);
      }
export function useExpertFooterUserReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertFooterUserReviewsQuery, ExpertFooterUserReviewsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertFooterUserReviewsQuery, ExpertFooterUserReviewsQueryVariables>(ExpertFooterUserReviewsDocument, baseOptions);
        }
export type ExpertFooterUserReviewsQueryHookResult = ReturnType<typeof useExpertFooterUserReviewsQuery>;
export type ExpertFooterUserReviewsLazyQueryHookResult = ReturnType<typeof useExpertFooterUserReviewsLazyQuery>;
export type ExpertFooterUserReviewsQueryResult = ApolloReactCommon.QueryResult<ExpertFooterUserReviewsQuery, ExpertFooterUserReviewsQueryVariables>;
export const BusinessUserToShareDocument = gql`
    query BusinessUserToShare($id: BusinessUserId!) {
  businessUser(id: $id) {
    ...BusinessUserToShare
  }
}
    ${BusinessUserToShareFragmentDoc}`;
export type BusinessUserToShareComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BusinessUserToShareQuery, BusinessUserToShareQueryVariables>, 'query'> & ({ variables: BusinessUserToShareQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BusinessUserToShareComponent = (props: BusinessUserToShareComponentProps) => (
      <ApolloReactComponents.Query<BusinessUserToShareQuery, BusinessUserToShareQueryVariables> query={BusinessUserToShareDocument} {...props} />
    );
    

/**
 * __useBusinessUserToShareQuery__
 *
 * To run a query within a React component, call `useBusinessUserToShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessUserToShareQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessUserToShareQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBusinessUserToShareQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BusinessUserToShareQuery, BusinessUserToShareQueryVariables>) {
        return ApolloReactHooks.useQuery<BusinessUserToShareQuery, BusinessUserToShareQueryVariables>(BusinessUserToShareDocument, baseOptions);
      }
export function useBusinessUserToShareLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BusinessUserToShareQuery, BusinessUserToShareQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BusinessUserToShareQuery, BusinessUserToShareQueryVariables>(BusinessUserToShareDocument, baseOptions);
        }
export type BusinessUserToShareQueryHookResult = ReturnType<typeof useBusinessUserToShareQuery>;
export type BusinessUserToShareLazyQueryHookResult = ReturnType<typeof useBusinessUserToShareLazyQuery>;
export type BusinessUserToShareQueryResult = ApolloReactCommon.QueryResult<BusinessUserToShareQuery, BusinessUserToShareQueryVariables>;
export const FeaturedReviewsDocument = gql`
    query FeaturedReviews($query: ConsumerReviewSearchQuery!, $after: String) {
  consumerExpertReviewConnection(query: $query, after: $after, first: 20) {
    pageInfo {
      ...PageInfo
    }
    count
    facets {
      displayName
      alias
      name
    }
    edges {
      cursor
      node {
        ...FeaturedReview
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${FeaturedReviewFragmentDoc}`;
export type FeaturedReviewsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FeaturedReviewsQuery, FeaturedReviewsQueryVariables>, 'query'> & ({ variables: FeaturedReviewsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FeaturedReviewsComponent = (props: FeaturedReviewsComponentProps) => (
      <ApolloReactComponents.Query<FeaturedReviewsQuery, FeaturedReviewsQueryVariables> query={FeaturedReviewsDocument} {...props} />
    );
    

/**
 * __useFeaturedReviewsQuery__
 *
 * To run a query within a React component, call `useFeaturedReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedReviewsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFeaturedReviewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeaturedReviewsQuery, FeaturedReviewsQueryVariables>) {
        return ApolloReactHooks.useQuery<FeaturedReviewsQuery, FeaturedReviewsQueryVariables>(FeaturedReviewsDocument, baseOptions);
      }
export function useFeaturedReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeaturedReviewsQuery, FeaturedReviewsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FeaturedReviewsQuery, FeaturedReviewsQueryVariables>(FeaturedReviewsDocument, baseOptions);
        }
export type FeaturedReviewsQueryHookResult = ReturnType<typeof useFeaturedReviewsQuery>;
export type FeaturedReviewsLazyQueryHookResult = ReturnType<typeof useFeaturedReviewsLazyQuery>;
export type FeaturedReviewsQueryResult = ApolloReactCommon.QueryResult<FeaturedReviewsQuery, FeaturedReviewsQueryVariables>;
export const NavDepartmentsDocument = gql`
    query NavDepartments {
  departmentsForNavigation {
    ...NavInactiveDepartment
  }
}
    ${NavInactiveDepartmentFragmentDoc}`;
export type NavDepartmentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NavDepartmentsQuery, NavDepartmentsQueryVariables>, 'query'>;

    export const NavDepartmentsComponent = (props: NavDepartmentsComponentProps) => (
      <ApolloReactComponents.Query<NavDepartmentsQuery, NavDepartmentsQueryVariables> query={NavDepartmentsDocument} {...props} />
    );
    

/**
 * __useNavDepartmentsQuery__
 *
 * To run a query within a React component, call `useNavDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavDepartmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NavDepartmentsQuery, NavDepartmentsQueryVariables>) {
        return ApolloReactHooks.useQuery<NavDepartmentsQuery, NavDepartmentsQueryVariables>(NavDepartmentsDocument, baseOptions);
      }
export function useNavDepartmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NavDepartmentsQuery, NavDepartmentsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<NavDepartmentsQuery, NavDepartmentsQueryVariables>(NavDepartmentsDocument, baseOptions);
        }
export type NavDepartmentsQueryHookResult = ReturnType<typeof useNavDepartmentsQuery>;
export type NavDepartmentsLazyQueryHookResult = ReturnType<typeof useNavDepartmentsLazyQuery>;
export type NavDepartmentsQueryResult = ApolloReactCommon.QueryResult<NavDepartmentsQuery, NavDepartmentsQueryVariables>;
export const NavHierarchyDocument = gql`
    query NavHierarchy($activeDepartmentId: DepartmentId!) {
  activeDepartment: department(id: $activeDepartmentId) {
    ...NavActiveDepartment
  }
}
    ${NavActiveDepartmentFragmentDoc}`;
export type NavHierarchyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NavHierarchyQuery, NavHierarchyQueryVariables>, 'query'> & ({ variables: NavHierarchyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const NavHierarchyComponent = (props: NavHierarchyComponentProps) => (
      <ApolloReactComponents.Query<NavHierarchyQuery, NavHierarchyQueryVariables> query={NavHierarchyDocument} {...props} />
    );
    

/**
 * __useNavHierarchyQuery__
 *
 * To run a query within a React component, call `useNavHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavHierarchyQuery({
 *   variables: {
 *      activeDepartmentId: // value for 'activeDepartmentId'
 *   },
 * });
 */
export function useNavHierarchyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NavHierarchyQuery, NavHierarchyQueryVariables>) {
        return ApolloReactHooks.useQuery<NavHierarchyQuery, NavHierarchyQueryVariables>(NavHierarchyDocument, baseOptions);
      }
export function useNavHierarchyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NavHierarchyQuery, NavHierarchyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<NavHierarchyQuery, NavHierarchyQueryVariables>(NavHierarchyDocument, baseOptions);
        }
export type NavHierarchyQueryHookResult = ReturnType<typeof useNavHierarchyQuery>;
export type NavHierarchyLazyQueryHookResult = ReturnType<typeof useNavHierarchyLazyQuery>;
export type NavHierarchyQueryResult = ApolloReactCommon.QueryResult<NavHierarchyQuery, NavHierarchyQueryVariables>;
export const SellableKeywordTypeaheadDocument = gql`
    query SellableKeywordTypeahead($query: SellableTypeaheadQuery!, $first: Int) {
  sellableTypeahead(query: $query, first: $first) {
    hits {
      ...SellableKeywordTypeaheadResult
    }
  }
}
    ${SellableKeywordTypeaheadResultFragmentDoc}`;
export type SellableKeywordTypeaheadComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SellableKeywordTypeaheadQuery, SellableKeywordTypeaheadQueryVariables>, 'query'> & ({ variables: SellableKeywordTypeaheadQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellableKeywordTypeaheadComponent = (props: SellableKeywordTypeaheadComponentProps) => (
      <ApolloReactComponents.Query<SellableKeywordTypeaheadQuery, SellableKeywordTypeaheadQueryVariables> query={SellableKeywordTypeaheadDocument} {...props} />
    );
    

/**
 * __useSellableKeywordTypeaheadQuery__
 *
 * To run a query within a React component, call `useSellableKeywordTypeaheadQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellableKeywordTypeaheadQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellableKeywordTypeaheadQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSellableKeywordTypeaheadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SellableKeywordTypeaheadQuery, SellableKeywordTypeaheadQueryVariables>) {
        return ApolloReactHooks.useQuery<SellableKeywordTypeaheadQuery, SellableKeywordTypeaheadQueryVariables>(SellableKeywordTypeaheadDocument, baseOptions);
      }
export function useSellableKeywordTypeaheadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SellableKeywordTypeaheadQuery, SellableKeywordTypeaheadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SellableKeywordTypeaheadQuery, SellableKeywordTypeaheadQueryVariables>(SellableKeywordTypeaheadDocument, baseOptions);
        }
export type SellableKeywordTypeaheadQueryHookResult = ReturnType<typeof useSellableKeywordTypeaheadQuery>;
export type SellableKeywordTypeaheadLazyQueryHookResult = ReturnType<typeof useSellableKeywordTypeaheadLazyQuery>;
export type SellableKeywordTypeaheadQueryResult = ApolloReactCommon.QueryResult<SellableKeywordTypeaheadQuery, SellableKeywordTypeaheadQueryVariables>;
export const ReleaseConsumerIdentityDocument = gql`
    mutation ReleaseConsumerIdentity {
  releaseConsumerIdentity {
    user {
      id
      firstName
      lastName
    }
  }
}
    `;
export type ReleaseConsumerIdentityMutationFn = ApolloReactCommon.MutationFunction<ReleaseConsumerIdentityMutation, ReleaseConsumerIdentityMutationVariables>;
export type ReleaseConsumerIdentityComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ReleaseConsumerIdentityMutation, ReleaseConsumerIdentityMutationVariables>, 'mutation'>;

    export const ReleaseConsumerIdentityComponent = (props: ReleaseConsumerIdentityComponentProps) => (
      <ApolloReactComponents.Mutation<ReleaseConsumerIdentityMutation, ReleaseConsumerIdentityMutationVariables> mutation={ReleaseConsumerIdentityDocument} {...props} />
    );
    

/**
 * __useReleaseConsumerIdentityMutation__
 *
 * To run a mutation, you first call `useReleaseConsumerIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseConsumerIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseConsumerIdentityMutation, { data, loading, error }] = useReleaseConsumerIdentityMutation({
 *   variables: {
 *   },
 * });
 */
export function useReleaseConsumerIdentityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReleaseConsumerIdentityMutation, ReleaseConsumerIdentityMutationVariables>) {
        return ApolloReactHooks.useMutation<ReleaseConsumerIdentityMutation, ReleaseConsumerIdentityMutationVariables>(ReleaseConsumerIdentityDocument, baseOptions);
      }
export type ReleaseConsumerIdentityMutationHookResult = ReturnType<typeof useReleaseConsumerIdentityMutation>;
export type ReleaseConsumerIdentityMutationResult = ApolloReactCommon.MutationResult<ReleaseConsumerIdentityMutation>;
export type ReleaseConsumerIdentityMutationOptions = ApolloReactCommon.BaseMutationOptions<ReleaseConsumerIdentityMutation, ReleaseConsumerIdentityMutationVariables>;
export const SubSectionExpertDocument = gql`
    query SubSectionExpert($departmentId: DepartmentId!) {
  recommendExpertsForDepartment(departmentId: $departmentId) {
    expert {
      id
      vanityId
      displayName
      shortName
      expertStats {
        averageRating
        totalMessagesSent
      }
      expertProfile {
        id
        headline
        profilePhoto {
          id
          url
        }
      }
    }
    existingLead {
      id
      conversation {
        id
      }
    }
  }
}
    `;
export type SubSectionExpertComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SubSectionExpertQuery, SubSectionExpertQueryVariables>, 'query'> & ({ variables: SubSectionExpertQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SubSectionExpertComponent = (props: SubSectionExpertComponentProps) => (
      <ApolloReactComponents.Query<SubSectionExpertQuery, SubSectionExpertQueryVariables> query={SubSectionExpertDocument} {...props} />
    );
    

/**
 * __useSubSectionExpertQuery__
 *
 * To run a query within a React component, call `useSubSectionExpertQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubSectionExpertQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubSectionExpertQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useSubSectionExpertQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubSectionExpertQuery, SubSectionExpertQueryVariables>) {
        return ApolloReactHooks.useQuery<SubSectionExpertQuery, SubSectionExpertQueryVariables>(SubSectionExpertDocument, baseOptions);
      }
export function useSubSectionExpertLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubSectionExpertQuery, SubSectionExpertQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SubSectionExpertQuery, SubSectionExpertQueryVariables>(SubSectionExpertDocument, baseOptions);
        }
export type SubSectionExpertQueryHookResult = ReturnType<typeof useSubSectionExpertQuery>;
export type SubSectionExpertLazyQueryHookResult = ReturnType<typeof useSubSectionExpertLazyQuery>;
export type SubSectionExpertQueryResult = ApolloReactCommon.QueryResult<SubSectionExpertQuery, SubSectionExpertQueryVariables>;
export const HeartbeatDocument = gql`
    subscription Heartbeat {
  heartbeat
}
    `;
export type HeartbeatComponentProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<HeartbeatSubscription, HeartbeatSubscriptionVariables>, 'subscription'>;

    export const HeartbeatComponent = (props: HeartbeatComponentProps) => (
      <ApolloReactComponents.Subscription<HeartbeatSubscription, HeartbeatSubscriptionVariables> subscription={HeartbeatDocument} {...props} />
    );
    

/**
 * __useHeartbeatSubscription__
 *
 * To run a query within a React component, call `useHeartbeatSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHeartbeatSubscription` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeartbeatSubscription({
 *   variables: {
 *   },
 * });
 */
export function useHeartbeatSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<HeartbeatSubscription, HeartbeatSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<HeartbeatSubscription, HeartbeatSubscriptionVariables>(HeartbeatDocument, baseOptions);
      }
export type HeartbeatSubscriptionHookResult = ReturnType<typeof useHeartbeatSubscription>;
export type HeartbeatSubscriptionResult = ApolloReactCommon.SubscriptionResult<HeartbeatSubscription>;
export const SaveConsumerSellableReactionDocument = gql`
    mutation SaveConsumerSellableReaction($input: SaveConsumerSellableReactionInput!) {
  saveConsumerSellableReaction(input: $input) {
    consumerSellableReaction {
      id
      reasonsWithDisplayName {
        reason
        displayName
      }
      ratingWithDisplayName {
        rating
        displayName
      }
      additionalReason
      sellable {
        id
      }
      systemRecommended
      recommendedBy {
        id
      }
    }
    error
  }
}
    `;
export type SaveConsumerSellableReactionMutationFn = ApolloReactCommon.MutationFunction<SaveConsumerSellableReactionMutation, SaveConsumerSellableReactionMutationVariables>;
export type SaveConsumerSellableReactionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SaveConsumerSellableReactionMutation, SaveConsumerSellableReactionMutationVariables>, 'mutation'>;

    export const SaveConsumerSellableReactionComponent = (props: SaveConsumerSellableReactionComponentProps) => (
      <ApolloReactComponents.Mutation<SaveConsumerSellableReactionMutation, SaveConsumerSellableReactionMutationVariables> mutation={SaveConsumerSellableReactionDocument} {...props} />
    );
    

/**
 * __useSaveConsumerSellableReactionMutation__
 *
 * To run a mutation, you first call `useSaveConsumerSellableReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveConsumerSellableReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveConsumerSellableReactionMutation, { data, loading, error }] = useSaveConsumerSellableReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveConsumerSellableReactionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveConsumerSellableReactionMutation, SaveConsumerSellableReactionMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveConsumerSellableReactionMutation, SaveConsumerSellableReactionMutationVariables>(SaveConsumerSellableReactionDocument, baseOptions);
      }
export type SaveConsumerSellableReactionMutationHookResult = ReturnType<typeof useSaveConsumerSellableReactionMutation>;
export type SaveConsumerSellableReactionMutationResult = ApolloReactCommon.MutationResult<SaveConsumerSellableReactionMutation>;
export type SaveConsumerSellableReactionMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveConsumerSellableReactionMutation, SaveConsumerSellableReactionMutationVariables>;
export const StartSystemCuratedItemSurveyDocument = gql`
    mutation StartSystemCuratedItemSurvey($id: SystemCuratedItemSurveyId!) {
  startSystemCuratedItemSurvey(id: $id) {
    data {
      id
      startedAt
    }
    error
  }
}
    `;
export type StartSystemCuratedItemSurveyMutationFn = ApolloReactCommon.MutationFunction<StartSystemCuratedItemSurveyMutation, StartSystemCuratedItemSurveyMutationVariables>;
export type StartSystemCuratedItemSurveyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<StartSystemCuratedItemSurveyMutation, StartSystemCuratedItemSurveyMutationVariables>, 'mutation'>;

    export const StartSystemCuratedItemSurveyComponent = (props: StartSystemCuratedItemSurveyComponentProps) => (
      <ApolloReactComponents.Mutation<StartSystemCuratedItemSurveyMutation, StartSystemCuratedItemSurveyMutationVariables> mutation={StartSystemCuratedItemSurveyDocument} {...props} />
    );
    

/**
 * __useStartSystemCuratedItemSurveyMutation__
 *
 * To run a mutation, you first call `useStartSystemCuratedItemSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSystemCuratedItemSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSystemCuratedItemSurveyMutation, { data, loading, error }] = useStartSystemCuratedItemSurveyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartSystemCuratedItemSurveyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartSystemCuratedItemSurveyMutation, StartSystemCuratedItemSurveyMutationVariables>) {
        return ApolloReactHooks.useMutation<StartSystemCuratedItemSurveyMutation, StartSystemCuratedItemSurveyMutationVariables>(StartSystemCuratedItemSurveyDocument, baseOptions);
      }
export type StartSystemCuratedItemSurveyMutationHookResult = ReturnType<typeof useStartSystemCuratedItemSurveyMutation>;
export type StartSystemCuratedItemSurveyMutationResult = ApolloReactCommon.MutationResult<StartSystemCuratedItemSurveyMutation>;
export type StartSystemCuratedItemSurveyMutationOptions = ApolloReactCommon.BaseMutationOptions<StartSystemCuratedItemSurveyMutation, StartSystemCuratedItemSurveyMutationVariables>;
export const SystemCuratedItemSurveyDocument = gql`
    query SystemCuratedItemSurvey($id: SystemCuratedItemSurveyId!) {
  systemCuratedItemSurvey(id: $id) {
    id
    ended
    terminationReason
    systemCuratedItems {
      ...SystemCuratedItem
    }
    stats {
      ...SystemCuratedItemSurveyStats
    }
  }
}
    ${SystemCuratedItemFragmentDoc}
${SystemCuratedItemSurveyStatsFragmentDoc}`;
export type SystemCuratedItemSurveyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SystemCuratedItemSurveyQuery, SystemCuratedItemSurveyQueryVariables>, 'query'> & ({ variables: SystemCuratedItemSurveyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SystemCuratedItemSurveyComponent = (props: SystemCuratedItemSurveyComponentProps) => (
      <ApolloReactComponents.Query<SystemCuratedItemSurveyQuery, SystemCuratedItemSurveyQueryVariables> query={SystemCuratedItemSurveyDocument} {...props} />
    );
    

/**
 * __useSystemCuratedItemSurveyQuery__
 *
 * To run a query within a React component, call `useSystemCuratedItemSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemCuratedItemSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemCuratedItemSurveyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemCuratedItemSurveyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SystemCuratedItemSurveyQuery, SystemCuratedItemSurveyQueryVariables>) {
        return ApolloReactHooks.useQuery<SystemCuratedItemSurveyQuery, SystemCuratedItemSurveyQueryVariables>(SystemCuratedItemSurveyDocument, baseOptions);
      }
export function useSystemCuratedItemSurveyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SystemCuratedItemSurveyQuery, SystemCuratedItemSurveyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SystemCuratedItemSurveyQuery, SystemCuratedItemSurveyQueryVariables>(SystemCuratedItemSurveyDocument, baseOptions);
        }
export type SystemCuratedItemSurveyQueryHookResult = ReturnType<typeof useSystemCuratedItemSurveyQuery>;
export type SystemCuratedItemSurveyLazyQueryHookResult = ReturnType<typeof useSystemCuratedItemSurveyLazyQuery>;
export type SystemCuratedItemSurveyQueryResult = ApolloReactCommon.QueryResult<SystemCuratedItemSurveyQuery, SystemCuratedItemSurveyQueryVariables>;
export const TerminateSystemCuratedItemSurveyDocument = gql`
    mutation TerminateSystemCuratedItemSurvey($input: TerminateSystemCuratedItemSurveyInput!) {
  terminateSystemCuratedItemSurvey(input: $input) {
    data {
      id
      ended
      terminationReason
      systemCuratedItems {
        ...SystemCuratedItem
      }
      stats {
        ...SystemCuratedItemSurveyStats
      }
    }
    error
  }
}
    ${SystemCuratedItemFragmentDoc}
${SystemCuratedItemSurveyStatsFragmentDoc}`;
export type TerminateSystemCuratedItemSurveyMutationFn = ApolloReactCommon.MutationFunction<TerminateSystemCuratedItemSurveyMutation, TerminateSystemCuratedItemSurveyMutationVariables>;
export type TerminateSystemCuratedItemSurveyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<TerminateSystemCuratedItemSurveyMutation, TerminateSystemCuratedItemSurveyMutationVariables>, 'mutation'>;

    export const TerminateSystemCuratedItemSurveyComponent = (props: TerminateSystemCuratedItemSurveyComponentProps) => (
      <ApolloReactComponents.Mutation<TerminateSystemCuratedItemSurveyMutation, TerminateSystemCuratedItemSurveyMutationVariables> mutation={TerminateSystemCuratedItemSurveyDocument} {...props} />
    );
    

/**
 * __useTerminateSystemCuratedItemSurveyMutation__
 *
 * To run a mutation, you first call `useTerminateSystemCuratedItemSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminateSystemCuratedItemSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminateSystemCuratedItemSurveyMutation, { data, loading, error }] = useTerminateSystemCuratedItemSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTerminateSystemCuratedItemSurveyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TerminateSystemCuratedItemSurveyMutation, TerminateSystemCuratedItemSurveyMutationVariables>) {
        return ApolloReactHooks.useMutation<TerminateSystemCuratedItemSurveyMutation, TerminateSystemCuratedItemSurveyMutationVariables>(TerminateSystemCuratedItemSurveyDocument, baseOptions);
      }
export type TerminateSystemCuratedItemSurveyMutationHookResult = ReturnType<typeof useTerminateSystemCuratedItemSurveyMutation>;
export type TerminateSystemCuratedItemSurveyMutationResult = ApolloReactCommon.MutationResult<TerminateSystemCuratedItemSurveyMutation>;
export type TerminateSystemCuratedItemSurveyMutationOptions = ApolloReactCommon.BaseMutationOptions<TerminateSystemCuratedItemSurveyMutation, TerminateSystemCuratedItemSurveyMutationVariables>;
export const AuthenticateByExternalOAuthTokenDocument = gql`
    mutation AuthenticateByExternalOAuthToken($input: AuthenticateByExternalOAuthTokenInput!) {
  authenticateByExternalOAuthToken(input: $input) {
    result
    message
    user {
      ...AuthenticatedUser
    }
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export type AuthenticateByExternalOAuthTokenMutationFn = ApolloReactCommon.MutationFunction<AuthenticateByExternalOAuthTokenMutation, AuthenticateByExternalOAuthTokenMutationVariables>;
export type AuthenticateByExternalOAuthTokenComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AuthenticateByExternalOAuthTokenMutation, AuthenticateByExternalOAuthTokenMutationVariables>, 'mutation'>;

    export const AuthenticateByExternalOAuthTokenComponent = (props: AuthenticateByExternalOAuthTokenComponentProps) => (
      <ApolloReactComponents.Mutation<AuthenticateByExternalOAuthTokenMutation, AuthenticateByExternalOAuthTokenMutationVariables> mutation={AuthenticateByExternalOAuthTokenDocument} {...props} />
    );
    

/**
 * __useAuthenticateByExternalOAuthTokenMutation__
 *
 * To run a mutation, you first call `useAuthenticateByExternalOAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateByExternalOAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateByExternalOAuthTokenMutation, { data, loading, error }] = useAuthenticateByExternalOAuthTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticateByExternalOAuthTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticateByExternalOAuthTokenMutation, AuthenticateByExternalOAuthTokenMutationVariables>) {
        return ApolloReactHooks.useMutation<AuthenticateByExternalOAuthTokenMutation, AuthenticateByExternalOAuthTokenMutationVariables>(AuthenticateByExternalOAuthTokenDocument, baseOptions);
      }
export type AuthenticateByExternalOAuthTokenMutationHookResult = ReturnType<typeof useAuthenticateByExternalOAuthTokenMutation>;
export type AuthenticateByExternalOAuthTokenMutationResult = ApolloReactCommon.MutationResult<AuthenticateByExternalOAuthTokenMutation>;
export type AuthenticateByExternalOAuthTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<AuthenticateByExternalOAuthTokenMutation, AuthenticateByExternalOAuthTokenMutationVariables>;
export const RegisterCustomerDocument = gql`
    mutation RegisterCustomer($input: RegisterCustomerInput!) {
  registerCustomer(input: $input) {
    user {
      ...AuthenticatedUser
    }
    errors
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export type RegisterCustomerMutationFn = ApolloReactCommon.MutationFunction<RegisterCustomerMutation, RegisterCustomerMutationVariables>;
export type RegisterCustomerComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RegisterCustomerMutation, RegisterCustomerMutationVariables>, 'mutation'>;

    export const RegisterCustomerComponent = (props: RegisterCustomerComponentProps) => (
      <ApolloReactComponents.Mutation<RegisterCustomerMutation, RegisterCustomerMutationVariables> mutation={RegisterCustomerDocument} {...props} />
    );
    

/**
 * __useRegisterCustomerMutation__
 *
 * To run a mutation, you first call `useRegisterCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerCustomerMutation, { data, loading, error }] = useRegisterCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterCustomerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterCustomerMutation, RegisterCustomerMutationVariables>) {
        return ApolloReactHooks.useMutation<RegisterCustomerMutation, RegisterCustomerMutationVariables>(RegisterCustomerDocument, baseOptions);
      }
export type RegisterCustomerMutationHookResult = ReturnType<typeof useRegisterCustomerMutation>;
export type RegisterCustomerMutationResult = ApolloReactCommon.MutationResult<RegisterCustomerMutation>;
export type RegisterCustomerMutationOptions = ApolloReactCommon.BaseMutationOptions<RegisterCustomerMutation, RegisterCustomerMutationVariables>;
export const RoryReviewsDocument = gql`
    query RoryReviews($departmentId: DepartmentId!) {
  department(id: $departmentId) {
    id
    reviewSummary {
      averageRating
      totalReviews
    }
    consumerExpertReviewConnection(filter: {source: SHOPPER_APPROVED}, first: 3) {
      edges {
        node {
          ...RoryReview
        }
      }
    }
  }
}
    ${RoryReviewFragmentDoc}`;
export type RoryReviewsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RoryReviewsQuery, RoryReviewsQueryVariables>, 'query'> & ({ variables: RoryReviewsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RoryReviewsComponent = (props: RoryReviewsComponentProps) => (
      <ApolloReactComponents.Query<RoryReviewsQuery, RoryReviewsQueryVariables> query={RoryReviewsDocument} {...props} />
    );
    

/**
 * __useRoryReviewsQuery__
 *
 * To run a query within a React component, call `useRoryReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoryReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoryReviewsQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useRoryReviewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RoryReviewsQuery, RoryReviewsQueryVariables>) {
        return ApolloReactHooks.useQuery<RoryReviewsQuery, RoryReviewsQueryVariables>(RoryReviewsDocument, baseOptions);
      }
export function useRoryReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RoryReviewsQuery, RoryReviewsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RoryReviewsQuery, RoryReviewsQueryVariables>(RoryReviewsDocument, baseOptions);
        }
export type RoryReviewsQueryHookResult = ReturnType<typeof useRoryReviewsQuery>;
export type RoryReviewsLazyQueryHookResult = ReturnType<typeof useRoryReviewsLazyQuery>;
export type RoryReviewsQueryResult = ApolloReactCommon.QueryResult<RoryReviewsQuery, RoryReviewsQueryVariables>;
export const CreatePathFlowDocument = gql`
    mutation CreatePathFlow($input: CreatePathFlowInput!) {
  createPathFlow(input: $input) {
    flow {
      ...PathFlow
    }
    errors {
      ...PathValidationError
    }
    newUserRegistered
  }
}
    ${PathFlowFragmentDoc}
${PathValidationErrorFragmentDoc}`;
export type CreatePathFlowMutationFn = ApolloReactCommon.MutationFunction<CreatePathFlowMutation, CreatePathFlowMutationVariables>;
export type CreatePathFlowComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreatePathFlowMutation, CreatePathFlowMutationVariables>, 'mutation'>;

    export const CreatePathFlowComponent = (props: CreatePathFlowComponentProps) => (
      <ApolloReactComponents.Mutation<CreatePathFlowMutation, CreatePathFlowMutationVariables> mutation={CreatePathFlowDocument} {...props} />
    );
    

/**
 * __useCreatePathFlowMutation__
 *
 * To run a mutation, you first call `useCreatePathFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePathFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPathFlowMutation, { data, loading, error }] = useCreatePathFlowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePathFlowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePathFlowMutation, CreatePathFlowMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePathFlowMutation, CreatePathFlowMutationVariables>(CreatePathFlowDocument, baseOptions);
      }
export type CreatePathFlowMutationHookResult = ReturnType<typeof useCreatePathFlowMutation>;
export type CreatePathFlowMutationResult = ApolloReactCommon.MutationResult<CreatePathFlowMutation>;
export type CreatePathFlowMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePathFlowMutation, CreatePathFlowMutationVariables>;
export const GenerateCollectPhoneNumberTextInPathDocument = gql`
    mutation GenerateCollectPhoneNumberTextInPath($input: GenerateCollectPhoneNumberTextInPathInput!) {
  generateCollectPhoneNumberTextInPath(input: $input) {
    toNumber
    body
  }
}
    `;
export type GenerateCollectPhoneNumberTextInPathMutationFn = ApolloReactCommon.MutationFunction<GenerateCollectPhoneNumberTextInPathMutation, GenerateCollectPhoneNumberTextInPathMutationVariables>;
export type GenerateCollectPhoneNumberTextInPathComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<GenerateCollectPhoneNumberTextInPathMutation, GenerateCollectPhoneNumberTextInPathMutationVariables>, 'mutation'>;

    export const GenerateCollectPhoneNumberTextInPathComponent = (props: GenerateCollectPhoneNumberTextInPathComponentProps) => (
      <ApolloReactComponents.Mutation<GenerateCollectPhoneNumberTextInPathMutation, GenerateCollectPhoneNumberTextInPathMutationVariables> mutation={GenerateCollectPhoneNumberTextInPathDocument} {...props} />
    );
    

/**
 * __useGenerateCollectPhoneNumberTextInPathMutation__
 *
 * To run a mutation, you first call `useGenerateCollectPhoneNumberTextInPathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCollectPhoneNumberTextInPathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCollectPhoneNumberTextInPathMutation, { data, loading, error }] = useGenerateCollectPhoneNumberTextInPathMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateCollectPhoneNumberTextInPathMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateCollectPhoneNumberTextInPathMutation, GenerateCollectPhoneNumberTextInPathMutationVariables>) {
        return ApolloReactHooks.useMutation<GenerateCollectPhoneNumberTextInPathMutation, GenerateCollectPhoneNumberTextInPathMutationVariables>(GenerateCollectPhoneNumberTextInPathDocument, baseOptions);
      }
export type GenerateCollectPhoneNumberTextInPathMutationHookResult = ReturnType<typeof useGenerateCollectPhoneNumberTextInPathMutation>;
export type GenerateCollectPhoneNumberTextInPathMutationResult = ApolloReactCommon.MutationResult<GenerateCollectPhoneNumberTextInPathMutation>;
export type GenerateCollectPhoneNumberTextInPathMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateCollectPhoneNumberTextInPathMutation, GenerateCollectPhoneNumberTextInPathMutationVariables>;
export const SubmitDatePathFlowQuestionDocument = gql`
    mutation SubmitDatePathFlowQuestion($input: SubmitDatePathFlowQuestionInput!) {
  submitDatePathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitDatePathFlowQuestionMutationFn = ApolloReactCommon.MutationFunction<SubmitDatePathFlowQuestionMutation, SubmitDatePathFlowQuestionMutationVariables>;
export type SubmitDatePathFlowQuestionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitDatePathFlowQuestionMutation, SubmitDatePathFlowQuestionMutationVariables>, 'mutation'>;

    export const SubmitDatePathFlowQuestionComponent = (props: SubmitDatePathFlowQuestionComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitDatePathFlowQuestionMutation, SubmitDatePathFlowQuestionMutationVariables> mutation={SubmitDatePathFlowQuestionDocument} {...props} />
    );
    

/**
 * __useSubmitDatePathFlowQuestionMutation__
 *
 * To run a mutation, you first call `useSubmitDatePathFlowQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitDatePathFlowQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitDatePathFlowQuestionMutation, { data, loading, error }] = useSubmitDatePathFlowQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitDatePathFlowQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitDatePathFlowQuestionMutation, SubmitDatePathFlowQuestionMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitDatePathFlowQuestionMutation, SubmitDatePathFlowQuestionMutationVariables>(SubmitDatePathFlowQuestionDocument, baseOptions);
      }
export type SubmitDatePathFlowQuestionMutationHookResult = ReturnType<typeof useSubmitDatePathFlowQuestionMutation>;
export type SubmitDatePathFlowQuestionMutationResult = ApolloReactCommon.MutationResult<SubmitDatePathFlowQuestionMutation>;
export type SubmitDatePathFlowQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitDatePathFlowQuestionMutation, SubmitDatePathFlowQuestionMutationVariables>;
export const SubmitDateRangePathFlowQuestionDocument = gql`
    mutation SubmitDateRangePathFlowQuestion($input: SubmitDateRangePathFlowQuestionInput!) {
  submitDateRangePathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitDateRangePathFlowQuestionMutationFn = ApolloReactCommon.MutationFunction<SubmitDateRangePathFlowQuestionMutation, SubmitDateRangePathFlowQuestionMutationVariables>;
export type SubmitDateRangePathFlowQuestionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitDateRangePathFlowQuestionMutation, SubmitDateRangePathFlowQuestionMutationVariables>, 'mutation'>;

    export const SubmitDateRangePathFlowQuestionComponent = (props: SubmitDateRangePathFlowQuestionComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitDateRangePathFlowQuestionMutation, SubmitDateRangePathFlowQuestionMutationVariables> mutation={SubmitDateRangePathFlowQuestionDocument} {...props} />
    );
    

/**
 * __useSubmitDateRangePathFlowQuestionMutation__
 *
 * To run a mutation, you first call `useSubmitDateRangePathFlowQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitDateRangePathFlowQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitDateRangePathFlowQuestionMutation, { data, loading, error }] = useSubmitDateRangePathFlowQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitDateRangePathFlowQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitDateRangePathFlowQuestionMutation, SubmitDateRangePathFlowQuestionMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitDateRangePathFlowQuestionMutation, SubmitDateRangePathFlowQuestionMutationVariables>(SubmitDateRangePathFlowQuestionDocument, baseOptions);
      }
export type SubmitDateRangePathFlowQuestionMutationHookResult = ReturnType<typeof useSubmitDateRangePathFlowQuestionMutation>;
export type SubmitDateRangePathFlowQuestionMutationResult = ApolloReactCommon.MutationResult<SubmitDateRangePathFlowQuestionMutation>;
export type SubmitDateRangePathFlowQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitDateRangePathFlowQuestionMutation, SubmitDateRangePathFlowQuestionMutationVariables>;
export const SubmitFacebookPathFlowQuestionDocument = gql`
    mutation SubmitFacebookPathFlowQuestion($input: SubmitInputTextPathFlowQuestionInput!) {
  submitInputTextPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitFacebookPathFlowQuestionMutationFn = ApolloReactCommon.MutationFunction<SubmitFacebookPathFlowQuestionMutation, SubmitFacebookPathFlowQuestionMutationVariables>;
export type SubmitFacebookPathFlowQuestionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitFacebookPathFlowQuestionMutation, SubmitFacebookPathFlowQuestionMutationVariables>, 'mutation'>;

    export const SubmitFacebookPathFlowQuestionComponent = (props: SubmitFacebookPathFlowQuestionComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitFacebookPathFlowQuestionMutation, SubmitFacebookPathFlowQuestionMutationVariables> mutation={SubmitFacebookPathFlowQuestionDocument} {...props} />
    );
    

/**
 * __useSubmitFacebookPathFlowQuestionMutation__
 *
 * To run a mutation, you first call `useSubmitFacebookPathFlowQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFacebookPathFlowQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFacebookPathFlowQuestionMutation, { data, loading, error }] = useSubmitFacebookPathFlowQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitFacebookPathFlowQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitFacebookPathFlowQuestionMutation, SubmitFacebookPathFlowQuestionMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitFacebookPathFlowQuestionMutation, SubmitFacebookPathFlowQuestionMutationVariables>(SubmitFacebookPathFlowQuestionDocument, baseOptions);
      }
export type SubmitFacebookPathFlowQuestionMutationHookResult = ReturnType<typeof useSubmitFacebookPathFlowQuestionMutation>;
export type SubmitFacebookPathFlowQuestionMutationResult = ApolloReactCommon.MutationResult<SubmitFacebookPathFlowQuestionMutation>;
export type SubmitFacebookPathFlowQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitFacebookPathFlowQuestionMutation, SubmitFacebookPathFlowQuestionMutationVariables>;
export const SubmitIdPathFlowQuestionDocument = gql`
    mutation SubmitIdPathFlowQuestion($input: SubmitIdPathFlowQuestionInput!) {
  submitIdPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitIdPathFlowQuestionMutationFn = ApolloReactCommon.MutationFunction<SubmitIdPathFlowQuestionMutation, SubmitIdPathFlowQuestionMutationVariables>;
export type SubmitIdPathFlowQuestionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitIdPathFlowQuestionMutation, SubmitIdPathFlowQuestionMutationVariables>, 'mutation'>;

    export const SubmitIdPathFlowQuestionComponent = (props: SubmitIdPathFlowQuestionComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitIdPathFlowQuestionMutation, SubmitIdPathFlowQuestionMutationVariables> mutation={SubmitIdPathFlowQuestionDocument} {...props} />
    );
    

/**
 * __useSubmitIdPathFlowQuestionMutation__
 *
 * To run a mutation, you first call `useSubmitIdPathFlowQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitIdPathFlowQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitIdPathFlowQuestionMutation, { data, loading, error }] = useSubmitIdPathFlowQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitIdPathFlowQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitIdPathFlowQuestionMutation, SubmitIdPathFlowQuestionMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitIdPathFlowQuestionMutation, SubmitIdPathFlowQuestionMutationVariables>(SubmitIdPathFlowQuestionDocument, baseOptions);
      }
export type SubmitIdPathFlowQuestionMutationHookResult = ReturnType<typeof useSubmitIdPathFlowQuestionMutation>;
export type SubmitIdPathFlowQuestionMutationResult = ApolloReactCommon.MutationResult<SubmitIdPathFlowQuestionMutation>;
export type SubmitIdPathFlowQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitIdPathFlowQuestionMutation, SubmitIdPathFlowQuestionMutationVariables>;
export const SubmitInputTextPathFlowQuestionDocument = gql`
    mutation SubmitInputTextPathFlowQuestion($input: SubmitInputTextPathFlowQuestionInput!) {
  submitInputTextPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitInputTextPathFlowQuestionMutationFn = ApolloReactCommon.MutationFunction<SubmitInputTextPathFlowQuestionMutation, SubmitInputTextPathFlowQuestionMutationVariables>;
export type SubmitInputTextPathFlowQuestionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitInputTextPathFlowQuestionMutation, SubmitInputTextPathFlowQuestionMutationVariables>, 'mutation'>;

    export const SubmitInputTextPathFlowQuestionComponent = (props: SubmitInputTextPathFlowQuestionComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitInputTextPathFlowQuestionMutation, SubmitInputTextPathFlowQuestionMutationVariables> mutation={SubmitInputTextPathFlowQuestionDocument} {...props} />
    );
    

/**
 * __useSubmitInputTextPathFlowQuestionMutation__
 *
 * To run a mutation, you first call `useSubmitInputTextPathFlowQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitInputTextPathFlowQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitInputTextPathFlowQuestionMutation, { data, loading, error }] = useSubmitInputTextPathFlowQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitInputTextPathFlowQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitInputTextPathFlowQuestionMutation, SubmitInputTextPathFlowQuestionMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitInputTextPathFlowQuestionMutation, SubmitInputTextPathFlowQuestionMutationVariables>(SubmitInputTextPathFlowQuestionDocument, baseOptions);
      }
export type SubmitInputTextPathFlowQuestionMutationHookResult = ReturnType<typeof useSubmitInputTextPathFlowQuestionMutation>;
export type SubmitInputTextPathFlowQuestionMutationResult = ApolloReactCommon.MutationResult<SubmitInputTextPathFlowQuestionMutation>;
export type SubmitInputTextPathFlowQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitInputTextPathFlowQuestionMutation, SubmitInputTextPathFlowQuestionMutationVariables>;
export const SubmitListPathFlowQuestionDocument = gql`
    mutation SubmitListPathFlowQuestion($input: SubmitListPathFlowQuestionInput!) {
  submitListPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitListPathFlowQuestionMutationFn = ApolloReactCommon.MutationFunction<SubmitListPathFlowQuestionMutation, SubmitListPathFlowQuestionMutationVariables>;
export type SubmitListPathFlowQuestionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitListPathFlowQuestionMutation, SubmitListPathFlowQuestionMutationVariables>, 'mutation'>;

    export const SubmitListPathFlowQuestionComponent = (props: SubmitListPathFlowQuestionComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitListPathFlowQuestionMutation, SubmitListPathFlowQuestionMutationVariables> mutation={SubmitListPathFlowQuestionDocument} {...props} />
    );
    

/**
 * __useSubmitListPathFlowQuestionMutation__
 *
 * To run a mutation, you first call `useSubmitListPathFlowQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitListPathFlowQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitListPathFlowQuestionMutation, { data, loading, error }] = useSubmitListPathFlowQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitListPathFlowQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitListPathFlowQuestionMutation, SubmitListPathFlowQuestionMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitListPathFlowQuestionMutation, SubmitListPathFlowQuestionMutationVariables>(SubmitListPathFlowQuestionDocument, baseOptions);
      }
export type SubmitListPathFlowQuestionMutationHookResult = ReturnType<typeof useSubmitListPathFlowQuestionMutation>;
export type SubmitListPathFlowQuestionMutationResult = ApolloReactCommon.MutationResult<SubmitListPathFlowQuestionMutation>;
export type SubmitListPathFlowQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitListPathFlowQuestionMutation, SubmitListPathFlowQuestionMutationVariables>;
export const SubmitNumericPathFlowQuestionDocument = gql`
    mutation SubmitNumericPathFlowQuestion($input: SubmitNumericPathFlowQuestionInput!) {
  submitNumericPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitNumericPathFlowQuestionMutationFn = ApolloReactCommon.MutationFunction<SubmitNumericPathFlowQuestionMutation, SubmitNumericPathFlowQuestionMutationVariables>;
export type SubmitNumericPathFlowQuestionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitNumericPathFlowQuestionMutation, SubmitNumericPathFlowQuestionMutationVariables>, 'mutation'>;

    export const SubmitNumericPathFlowQuestionComponent = (props: SubmitNumericPathFlowQuestionComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitNumericPathFlowQuestionMutation, SubmitNumericPathFlowQuestionMutationVariables> mutation={SubmitNumericPathFlowQuestionDocument} {...props} />
    );
    

/**
 * __useSubmitNumericPathFlowQuestionMutation__
 *
 * To run a mutation, you first call `useSubmitNumericPathFlowQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitNumericPathFlowQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitNumericPathFlowQuestionMutation, { data, loading, error }] = useSubmitNumericPathFlowQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitNumericPathFlowQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitNumericPathFlowQuestionMutation, SubmitNumericPathFlowQuestionMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitNumericPathFlowQuestionMutation, SubmitNumericPathFlowQuestionMutationVariables>(SubmitNumericPathFlowQuestionDocument, baseOptions);
      }
export type SubmitNumericPathFlowQuestionMutationHookResult = ReturnType<typeof useSubmitNumericPathFlowQuestionMutation>;
export type SubmitNumericPathFlowQuestionMutationResult = ApolloReactCommon.MutationResult<SubmitNumericPathFlowQuestionMutation>;
export type SubmitNumericPathFlowQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitNumericPathFlowQuestionMutation, SubmitNumericPathFlowQuestionMutationVariables>;
export const SubmitOAuthEmailPathFlowQuestionDocument = gql`
    mutation SubmitOAuthEmailPathFlowQuestion($input: SubmitOAuthEmailPathFlowQuestionInput!) {
  submitOAuthEmailPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitOAuthEmailPathFlowQuestionMutationFn = ApolloReactCommon.MutationFunction<SubmitOAuthEmailPathFlowQuestionMutation, SubmitOAuthEmailPathFlowQuestionMutationVariables>;
export type SubmitOAuthEmailPathFlowQuestionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitOAuthEmailPathFlowQuestionMutation, SubmitOAuthEmailPathFlowQuestionMutationVariables>, 'mutation'>;

    export const SubmitOAuthEmailPathFlowQuestionComponent = (props: SubmitOAuthEmailPathFlowQuestionComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitOAuthEmailPathFlowQuestionMutation, SubmitOAuthEmailPathFlowQuestionMutationVariables> mutation={SubmitOAuthEmailPathFlowQuestionDocument} {...props} />
    );
    

/**
 * __useSubmitOAuthEmailPathFlowQuestionMutation__
 *
 * To run a mutation, you first call `useSubmitOAuthEmailPathFlowQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOAuthEmailPathFlowQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOAuthEmailPathFlowQuestionMutation, { data, loading, error }] = useSubmitOAuthEmailPathFlowQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitOAuthEmailPathFlowQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitOAuthEmailPathFlowQuestionMutation, SubmitOAuthEmailPathFlowQuestionMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitOAuthEmailPathFlowQuestionMutation, SubmitOAuthEmailPathFlowQuestionMutationVariables>(SubmitOAuthEmailPathFlowQuestionDocument, baseOptions);
      }
export type SubmitOAuthEmailPathFlowQuestionMutationHookResult = ReturnType<typeof useSubmitOAuthEmailPathFlowQuestionMutation>;
export type SubmitOAuthEmailPathFlowQuestionMutationResult = ApolloReactCommon.MutationResult<SubmitOAuthEmailPathFlowQuestionMutation>;
export type SubmitOAuthEmailPathFlowQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitOAuthEmailPathFlowQuestionMutation, SubmitOAuthEmailPathFlowQuestionMutationVariables>;
export const SubmitPathFlowPageDocument = gql`
    mutation SubmitPathFlowPage($input: SubmitPathFlowPageInput!) {
  submitPathFlowPage(input: $input) {
    flow {
      ...PathFlow
    }
    errors {
      ...PathValidationError
    }
    newUserRegistered
  }
}
    ${PathFlowFragmentDoc}
${PathValidationErrorFragmentDoc}`;
export type SubmitPathFlowPageMutationFn = ApolloReactCommon.MutationFunction<SubmitPathFlowPageMutation, SubmitPathFlowPageMutationVariables>;
export type SubmitPathFlowPageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitPathFlowPageMutation, SubmitPathFlowPageMutationVariables>, 'mutation'>;

    export const SubmitPathFlowPageComponent = (props: SubmitPathFlowPageComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitPathFlowPageMutation, SubmitPathFlowPageMutationVariables> mutation={SubmitPathFlowPageDocument} {...props} />
    );
    

/**
 * __useSubmitPathFlowPageMutation__
 *
 * To run a mutation, you first call `useSubmitPathFlowPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPathFlowPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPathFlowPageMutation, { data, loading, error }] = useSubmitPathFlowPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPathFlowPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitPathFlowPageMutation, SubmitPathFlowPageMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitPathFlowPageMutation, SubmitPathFlowPageMutationVariables>(SubmitPathFlowPageDocument, baseOptions);
      }
export type SubmitPathFlowPageMutationHookResult = ReturnType<typeof useSubmitPathFlowPageMutation>;
export type SubmitPathFlowPageMutationResult = ApolloReactCommon.MutationResult<SubmitPathFlowPageMutation>;
export type SubmitPathFlowPageMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitPathFlowPageMutation, SubmitPathFlowPageMutationVariables>;
export const SubmitPushNotifcationFcmTokenDocument = gql`
    mutation SubmitPushNotifcationFCMToken($input: SubmitInputTextPathFlowQuestionInput!) {
  submitInputTextPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitPushNotifcationFcmTokenMutationFn = ApolloReactCommon.MutationFunction<SubmitPushNotifcationFcmTokenMutation, SubmitPushNotifcationFcmTokenMutationVariables>;
export type SubmitPushNotifcationFcmTokenComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitPushNotifcationFcmTokenMutation, SubmitPushNotifcationFcmTokenMutationVariables>, 'mutation'>;

    export const SubmitPushNotifcationFcmTokenComponent = (props: SubmitPushNotifcationFcmTokenComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitPushNotifcationFcmTokenMutation, SubmitPushNotifcationFcmTokenMutationVariables> mutation={SubmitPushNotifcationFcmTokenDocument} {...props} />
    );
    

/**
 * __useSubmitPushNotifcationFcmTokenMutation__
 *
 * To run a mutation, you first call `useSubmitPushNotifcationFcmTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPushNotifcationFcmTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPushNotifcationFcmTokenMutation, { data, loading, error }] = useSubmitPushNotifcationFcmTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPushNotifcationFcmTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitPushNotifcationFcmTokenMutation, SubmitPushNotifcationFcmTokenMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitPushNotifcationFcmTokenMutation, SubmitPushNotifcationFcmTokenMutationVariables>(SubmitPushNotifcationFcmTokenDocument, baseOptions);
      }
export type SubmitPushNotifcationFcmTokenMutationHookResult = ReturnType<typeof useSubmitPushNotifcationFcmTokenMutation>;
export type SubmitPushNotifcationFcmTokenMutationResult = ApolloReactCommon.MutationResult<SubmitPushNotifcationFcmTokenMutation>;
export type SubmitPushNotifcationFcmTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitPushNotifcationFcmTokenMutation, SubmitPushNotifcationFcmTokenMutationVariables>;
export const SubmitPushNotificationAuthorizedStatusDocument = gql`
    mutation SubmitPushNotificationAuthorizedStatus($input: SubmitListPathFlowQuestionInput!) {
  submitListPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitPushNotificationAuthorizedStatusMutationFn = ApolloReactCommon.MutationFunction<SubmitPushNotificationAuthorizedStatusMutation, SubmitPushNotificationAuthorizedStatusMutationVariables>;
export type SubmitPushNotificationAuthorizedStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitPushNotificationAuthorizedStatusMutation, SubmitPushNotificationAuthorizedStatusMutationVariables>, 'mutation'>;

    export const SubmitPushNotificationAuthorizedStatusComponent = (props: SubmitPushNotificationAuthorizedStatusComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitPushNotificationAuthorizedStatusMutation, SubmitPushNotificationAuthorizedStatusMutationVariables> mutation={SubmitPushNotificationAuthorizedStatusDocument} {...props} />
    );
    

/**
 * __useSubmitPushNotificationAuthorizedStatusMutation__
 *
 * To run a mutation, you first call `useSubmitPushNotificationAuthorizedStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPushNotificationAuthorizedStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPushNotificationAuthorizedStatusMutation, { data, loading, error }] = useSubmitPushNotificationAuthorizedStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPushNotificationAuthorizedStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitPushNotificationAuthorizedStatusMutation, SubmitPushNotificationAuthorizedStatusMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitPushNotificationAuthorizedStatusMutation, SubmitPushNotificationAuthorizedStatusMutationVariables>(SubmitPushNotificationAuthorizedStatusDocument, baseOptions);
      }
export type SubmitPushNotificationAuthorizedStatusMutationHookResult = ReturnType<typeof useSubmitPushNotificationAuthorizedStatusMutation>;
export type SubmitPushNotificationAuthorizedStatusMutationResult = ApolloReactCommon.MutationResult<SubmitPushNotificationAuthorizedStatusMutation>;
export type SubmitPushNotificationAuthorizedStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitPushNotificationAuthorizedStatusMutation, SubmitPushNotificationAuthorizedStatusMutationVariables>;
export const SubmitUserContactPathFlowQuestionDocument = gql`
    mutation SubmitUserContactPathFlowQuestion($input: SubmitUserContactPathFlowQuestionInput!) {
  submitUserContactPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitUserContactPathFlowQuestionMutationFn = ApolloReactCommon.MutationFunction<SubmitUserContactPathFlowQuestionMutation, SubmitUserContactPathFlowQuestionMutationVariables>;
export type SubmitUserContactPathFlowQuestionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitUserContactPathFlowQuestionMutation, SubmitUserContactPathFlowQuestionMutationVariables>, 'mutation'>;

    export const SubmitUserContactPathFlowQuestionComponent = (props: SubmitUserContactPathFlowQuestionComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitUserContactPathFlowQuestionMutation, SubmitUserContactPathFlowQuestionMutationVariables> mutation={SubmitUserContactPathFlowQuestionDocument} {...props} />
    );
    

/**
 * __useSubmitUserContactPathFlowQuestionMutation__
 *
 * To run a mutation, you first call `useSubmitUserContactPathFlowQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitUserContactPathFlowQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitUserContactPathFlowQuestionMutation, { data, loading, error }] = useSubmitUserContactPathFlowQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitUserContactPathFlowQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitUserContactPathFlowQuestionMutation, SubmitUserContactPathFlowQuestionMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitUserContactPathFlowQuestionMutation, SubmitUserContactPathFlowQuestionMutationVariables>(SubmitUserContactPathFlowQuestionDocument, baseOptions);
      }
export type SubmitUserContactPathFlowQuestionMutationHookResult = ReturnType<typeof useSubmitUserContactPathFlowQuestionMutation>;
export type SubmitUserContactPathFlowQuestionMutationResult = ApolloReactCommon.MutationResult<SubmitUserContactPathFlowQuestionMutation>;
export type SubmitUserContactPathFlowQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitUserContactPathFlowQuestionMutation, SubmitUserContactPathFlowQuestionMutationVariables>;
export const UploadGearImageDocument = gql`
    mutation UploadGearImage($input: UploadMediaInput!) {
  uploadMedia(input: $input) {
    mediaFile {
      id
      url
    }
  }
}
    `;
export type UploadGearImageMutationFn = ApolloReactCommon.MutationFunction<UploadGearImageMutation, UploadGearImageMutationVariables>;
export type UploadGearImageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UploadGearImageMutation, UploadGearImageMutationVariables>, 'mutation'>;

    export const UploadGearImageComponent = (props: UploadGearImageComponentProps) => (
      <ApolloReactComponents.Mutation<UploadGearImageMutation, UploadGearImageMutationVariables> mutation={UploadGearImageDocument} {...props} />
    );
    

/**
 * __useUploadGearImageMutation__
 *
 * To run a mutation, you first call `useUploadGearImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadGearImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadGearImageMutation, { data, loading, error }] = useUploadGearImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadGearImageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadGearImageMutation, UploadGearImageMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadGearImageMutation, UploadGearImageMutationVariables>(UploadGearImageDocument, baseOptions);
      }
export type UploadGearImageMutationHookResult = ReturnType<typeof useUploadGearImageMutation>;
export type UploadGearImageMutationResult = ApolloReactCommon.MutationResult<UploadGearImageMutation>;
export type UploadGearImageMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadGearImageMutation, UploadGearImageMutationVariables>;
export const PathFlowDocument = gql`
    query PathFlow($id: PathFlowId!) {
  pathFlow(id: $id) {
    flow {
      ...PathFlow
    }
  }
}
    ${PathFlowFragmentDoc}`;
export type PathFlowComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PathFlowQuery, PathFlowQueryVariables>, 'query'> & ({ variables: PathFlowQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PathFlowComponent = (props: PathFlowComponentProps) => (
      <ApolloReactComponents.Query<PathFlowQuery, PathFlowQueryVariables> query={PathFlowDocument} {...props} />
    );
    

/**
 * __usePathFlowQuery__
 *
 * To run a query within a React component, call `usePathFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathFlowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePathFlowQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PathFlowQuery, PathFlowQueryVariables>) {
        return ApolloReactHooks.useQuery<PathFlowQuery, PathFlowQueryVariables>(PathFlowDocument, baseOptions);
      }
export function usePathFlowLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PathFlowQuery, PathFlowQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PathFlowQuery, PathFlowQueryVariables>(PathFlowDocument, baseOptions);
        }
export type PathFlowQueryHookResult = ReturnType<typeof usePathFlowQuery>;
export type PathFlowLazyQueryHookResult = ReturnType<typeof usePathFlowLazyQuery>;
export type PathFlowQueryResult = ApolloReactCommon.QueryResult<PathFlowQuery, PathFlowQueryVariables>;
export const PathFlowPageDocument = gql`
    query PathFlowPage($pathFlowId: PathFlowId!, $pathFlowPageSlug: String!) {
  pathFlowPage(id: $pathFlowId, pageSlug: $pathFlowPageSlug) {
    page {
      ...PathFlowPage
    }
  }
}
    ${PathFlowPageFragmentDoc}`;
export type PathFlowPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PathFlowPageQuery, PathFlowPageQueryVariables>, 'query'> & ({ variables: PathFlowPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PathFlowPageComponent = (props: PathFlowPageComponentProps) => (
      <ApolloReactComponents.Query<PathFlowPageQuery, PathFlowPageQueryVariables> query={PathFlowPageDocument} {...props} />
    );
    

/**
 * __usePathFlowPageQuery__
 *
 * To run a query within a React component, call `usePathFlowPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathFlowPageQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathFlowPageQuery({
 *   variables: {
 *      pathFlowId: // value for 'pathFlowId'
 *      pathFlowPageSlug: // value for 'pathFlowPageSlug'
 *   },
 * });
 */
export function usePathFlowPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PathFlowPageQuery, PathFlowPageQueryVariables>) {
        return ApolloReactHooks.useQuery<PathFlowPageQuery, PathFlowPageQueryVariables>(PathFlowPageDocument, baseOptions);
      }
export function usePathFlowPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PathFlowPageQuery, PathFlowPageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PathFlowPageQuery, PathFlowPageQueryVariables>(PathFlowPageDocument, baseOptions);
        }
export type PathFlowPageQueryHookResult = ReturnType<typeof usePathFlowPageQuery>;
export type PathFlowPageLazyQueryHookResult = ReturnType<typeof usePathFlowPageLazyQuery>;
export type PathFlowPageQueryResult = ApolloReactCommon.QueryResult<PathFlowPageQuery, PathFlowPageQueryVariables>;
export const RecommendExpertsForPathFlowDocument = gql`
    query RecommendExpertsForPathFlow($pathFlowId: PathFlowId!) {
  recommendExpertsForPathFlow(pathFlowId: $pathFlowId, limit: 3) {
    expert {
      ...PathExpert
    }
  }
}
    ${PathExpertFragmentDoc}`;
export type RecommendExpertsForPathFlowComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecommendExpertsForPathFlowQuery, RecommendExpertsForPathFlowQueryVariables>, 'query'> & ({ variables: RecommendExpertsForPathFlowQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RecommendExpertsForPathFlowComponent = (props: RecommendExpertsForPathFlowComponentProps) => (
      <ApolloReactComponents.Query<RecommendExpertsForPathFlowQuery, RecommendExpertsForPathFlowQueryVariables> query={RecommendExpertsForPathFlowDocument} {...props} />
    );
    

/**
 * __useRecommendExpertsForPathFlowQuery__
 *
 * To run a query within a React component, call `useRecommendExpertsForPathFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendExpertsForPathFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendExpertsForPathFlowQuery({
 *   variables: {
 *      pathFlowId: // value for 'pathFlowId'
 *   },
 * });
 */
export function useRecommendExpertsForPathFlowQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RecommendExpertsForPathFlowQuery, RecommendExpertsForPathFlowQueryVariables>) {
        return ApolloReactHooks.useQuery<RecommendExpertsForPathFlowQuery, RecommendExpertsForPathFlowQueryVariables>(RecommendExpertsForPathFlowDocument, baseOptions);
      }
export function useRecommendExpertsForPathFlowLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecommendExpertsForPathFlowQuery, RecommendExpertsForPathFlowQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RecommendExpertsForPathFlowQuery, RecommendExpertsForPathFlowQueryVariables>(RecommendExpertsForPathFlowDocument, baseOptions);
        }
export type RecommendExpertsForPathFlowQueryHookResult = ReturnType<typeof useRecommendExpertsForPathFlowQuery>;
export type RecommendExpertsForPathFlowLazyQueryHookResult = ReturnType<typeof useRecommendExpertsForPathFlowLazyQuery>;
export type RecommendExpertsForPathFlowQueryResult = ApolloReactCommon.QueryResult<RecommendExpertsForPathFlowQuery, RecommendExpertsForPathFlowQueryVariables>;
export const VerifyPaymentTransactionDocument = gql`
    mutation VerifyPaymentTransaction($input: VerifyPaymentTransactionInput!) {
  verifyPaymentTransaction(input: $input) {
    order {
      id
      state
    }
    error
    verified
  }
}
    `;
export type VerifyPaymentTransactionMutationFn = ApolloReactCommon.MutationFunction<VerifyPaymentTransactionMutation, VerifyPaymentTransactionMutationVariables>;
export type VerifyPaymentTransactionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<VerifyPaymentTransactionMutation, VerifyPaymentTransactionMutationVariables>, 'mutation'>;

    export const VerifyPaymentTransactionComponent = (props: VerifyPaymentTransactionComponentProps) => (
      <ApolloReactComponents.Mutation<VerifyPaymentTransactionMutation, VerifyPaymentTransactionMutationVariables> mutation={VerifyPaymentTransactionDocument} {...props} />
    );
    

/**
 * __useVerifyPaymentTransactionMutation__
 *
 * To run a mutation, you first call `useVerifyPaymentTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPaymentTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPaymentTransactionMutation, { data, loading, error }] = useVerifyPaymentTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyPaymentTransactionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyPaymentTransactionMutation, VerifyPaymentTransactionMutationVariables>) {
        return ApolloReactHooks.useMutation<VerifyPaymentTransactionMutation, VerifyPaymentTransactionMutationVariables>(VerifyPaymentTransactionDocument, baseOptions);
      }
export type VerifyPaymentTransactionMutationHookResult = ReturnType<typeof useVerifyPaymentTransactionMutation>;
export type VerifyPaymentTransactionMutationResult = ApolloReactCommon.MutationResult<VerifyPaymentTransactionMutation>;
export type VerifyPaymentTransactionMutationOptions = ApolloReactCommon.BaseMutationOptions<VerifyPaymentTransactionMutation, VerifyPaymentTransactionMutationVariables>;
export const IssueVerificationCodeDocument = gql`
    mutation IssueVerificationCode($input: InitiateVerifyHandleInput!) {
  initiateVerifyHandle(input: $input) {
    success
  }
}
    `;
export type IssueVerificationCodeMutationFn = ApolloReactCommon.MutationFunction<IssueVerificationCodeMutation, IssueVerificationCodeMutationVariables>;
export type IssueVerificationCodeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<IssueVerificationCodeMutation, IssueVerificationCodeMutationVariables>, 'mutation'>;

    export const IssueVerificationCodeComponent = (props: IssueVerificationCodeComponentProps) => (
      <ApolloReactComponents.Mutation<IssueVerificationCodeMutation, IssueVerificationCodeMutationVariables> mutation={IssueVerificationCodeDocument} {...props} />
    );
    

/**
 * __useIssueVerificationCodeMutation__
 *
 * To run a mutation, you first call `useIssueVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueVerificationCodeMutation, { data, loading, error }] = useIssueVerificationCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssueVerificationCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IssueVerificationCodeMutation, IssueVerificationCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<IssueVerificationCodeMutation, IssueVerificationCodeMutationVariables>(IssueVerificationCodeDocument, baseOptions);
      }
export type IssueVerificationCodeMutationHookResult = ReturnType<typeof useIssueVerificationCodeMutation>;
export type IssueVerificationCodeMutationResult = ApolloReactCommon.MutationResult<IssueVerificationCodeMutation>;
export type IssueVerificationCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<IssueVerificationCodeMutation, IssueVerificationCodeMutationVariables>;
export const UpdateUserPhoneDocument = gql`
    mutation UpdateUserPhone($input: UpdateUserProfileInput!) {
  updateUserProfile(input: $input) {
    errors
    user {
      id
      contacts {
        id
        type
        value
        verified
      }
    }
  }
}
    `;
export type UpdateUserPhoneMutationFn = ApolloReactCommon.MutationFunction<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>;
export type UpdateUserPhoneComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>, 'mutation'>;

    export const UpdateUserPhoneComponent = (props: UpdateUserPhoneComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables> mutation={UpdateUserPhoneDocument} {...props} />
    );
    

/**
 * __useUpdateUserPhoneMutation__
 *
 * To run a mutation, you first call `useUpdateUserPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPhoneMutation, { data, loading, error }] = useUpdateUserPhoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPhoneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>(UpdateUserPhoneDocument, baseOptions);
      }
export type UpdateUserPhoneMutationHookResult = ReturnType<typeof useUpdateUserPhoneMutation>;
export type UpdateUserPhoneMutationResult = ApolloReactCommon.MutationResult<UpdateUserPhoneMutation>;
export type UpdateUserPhoneMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>;
export const ConfirmVerificationCodeDocument = gql`
    mutation ConfirmVerificationCode($input: VerifyHandleChallengeInput!) {
  verifyHandleChallenge(input: $input) {
    message
    success
  }
}
    `;
export type ConfirmVerificationCodeMutationFn = ApolloReactCommon.MutationFunction<ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables>;
export type ConfirmVerificationCodeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables>, 'mutation'>;

    export const ConfirmVerificationCodeComponent = (props: ConfirmVerificationCodeComponentProps) => (
      <ApolloReactComponents.Mutation<ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables> mutation={ConfirmVerificationCodeDocument} {...props} />
    );
    

/**
 * __useConfirmVerificationCodeMutation__
 *
 * To run a mutation, you first call `useConfirmVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmVerificationCodeMutation, { data, loading, error }] = useConfirmVerificationCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmVerificationCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables>(ConfirmVerificationCodeDocument, baseOptions);
      }
export type ConfirmVerificationCodeMutationHookResult = ReturnType<typeof useConfirmVerificationCodeMutation>;
export type ConfirmVerificationCodeMutationResult = ApolloReactCommon.MutationResult<ConfirmVerificationCodeMutation>;
export type ConfirmVerificationCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables>;
export const RecommendedListByTypeDocument = gql`
    query RecommendedListByType($categorySlug: String!, $types: [RecommendedListType!]) {
  recommendedListsForCategory(categorySlug: $categorySlug, types: $types) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...RecommendedList
      }
    }
  }
}
    ${RecommendedListFragmentDoc}`;
export type RecommendedListByTypeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecommendedListByTypeQuery, RecommendedListByTypeQueryVariables>, 'query'> & ({ variables: RecommendedListByTypeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RecommendedListByTypeComponent = (props: RecommendedListByTypeComponentProps) => (
      <ApolloReactComponents.Query<RecommendedListByTypeQuery, RecommendedListByTypeQueryVariables> query={RecommendedListByTypeDocument} {...props} />
    );
    

/**
 * __useRecommendedListByTypeQuery__
 *
 * To run a query within a React component, call `useRecommendedListByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedListByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedListByTypeQuery({
 *   variables: {
 *      categorySlug: // value for 'categorySlug'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useRecommendedListByTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RecommendedListByTypeQuery, RecommendedListByTypeQueryVariables>) {
        return ApolloReactHooks.useQuery<RecommendedListByTypeQuery, RecommendedListByTypeQueryVariables>(RecommendedListByTypeDocument, baseOptions);
      }
export function useRecommendedListByTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecommendedListByTypeQuery, RecommendedListByTypeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RecommendedListByTypeQuery, RecommendedListByTypeQueryVariables>(RecommendedListByTypeDocument, baseOptions);
        }
export type RecommendedListByTypeQueryHookResult = ReturnType<typeof useRecommendedListByTypeQuery>;
export type RecommendedListByTypeLazyQueryHookResult = ReturnType<typeof useRecommendedListByTypeLazyQuery>;
export type RecommendedListByTypeQueryResult = ApolloReactCommon.QueryResult<RecommendedListByTypeQuery, RecommendedListByTypeQueryVariables>;
export const ExpertForRatingDocument = gql`
    query ExpertForRating($vanityIdOrId: String!) {
  findExpert(vanityIdOrId: $vanityIdOrId) {
    ...ExpertForRating
  }
}
    ${ExpertForRatingFragmentDoc}`;
export type ExpertForRatingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertForRatingQuery, ExpertForRatingQueryVariables>, 'query'> & ({ variables: ExpertForRatingQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertForRatingComponent = (props: ExpertForRatingComponentProps) => (
      <ApolloReactComponents.Query<ExpertForRatingQuery, ExpertForRatingQueryVariables> query={ExpertForRatingDocument} {...props} />
    );
    

/**
 * __useExpertForRatingQuery__
 *
 * To run a query within a React component, call `useExpertForRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertForRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertForRatingQuery({
 *   variables: {
 *      vanityIdOrId: // value for 'vanityIdOrId'
 *   },
 * });
 */
export function useExpertForRatingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertForRatingQuery, ExpertForRatingQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertForRatingQuery, ExpertForRatingQueryVariables>(ExpertForRatingDocument, baseOptions);
      }
export function useExpertForRatingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertForRatingQuery, ExpertForRatingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertForRatingQuery, ExpertForRatingQueryVariables>(ExpertForRatingDocument, baseOptions);
        }
export type ExpertForRatingQueryHookResult = ReturnType<typeof useExpertForRatingQuery>;
export type ExpertForRatingLazyQueryHookResult = ReturnType<typeof useExpertForRatingLazyQuery>;
export type ExpertForRatingQueryResult = ApolloReactCommon.QueryResult<ExpertForRatingQuery, ExpertForRatingQueryVariables>;
export const StartExpertRatingPathDocument = gql`
    mutation StartExpertRatingPath($input: StartExpertRatingInput!) {
  startExpertRatingPath(input: $input) {
    flow {
      id
      slug
      pagesConnection {
        edges {
          node {
            id
            slug
          }
        }
      }
    }
    errors {
      pageName
      questionName
    }
  }
}
    `;
export type StartExpertRatingPathMutationFn = ApolloReactCommon.MutationFunction<StartExpertRatingPathMutation, StartExpertRatingPathMutationVariables>;
export type StartExpertRatingPathComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<StartExpertRatingPathMutation, StartExpertRatingPathMutationVariables>, 'mutation'>;

    export const StartExpertRatingPathComponent = (props: StartExpertRatingPathComponentProps) => (
      <ApolloReactComponents.Mutation<StartExpertRatingPathMutation, StartExpertRatingPathMutationVariables> mutation={StartExpertRatingPathDocument} {...props} />
    );
    

/**
 * __useStartExpertRatingPathMutation__
 *
 * To run a mutation, you first call `useStartExpertRatingPathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartExpertRatingPathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startExpertRatingPathMutation, { data, loading, error }] = useStartExpertRatingPathMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartExpertRatingPathMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartExpertRatingPathMutation, StartExpertRatingPathMutationVariables>) {
        return ApolloReactHooks.useMutation<StartExpertRatingPathMutation, StartExpertRatingPathMutationVariables>(StartExpertRatingPathDocument, baseOptions);
      }
export type StartExpertRatingPathMutationHookResult = ReturnType<typeof useStartExpertRatingPathMutation>;
export type StartExpertRatingPathMutationResult = ApolloReactCommon.MutationResult<StartExpertRatingPathMutation>;
export type StartExpertRatingPathMutationOptions = ApolloReactCommon.BaseMutationOptions<StartExpertRatingPathMutation, StartExpertRatingPathMutationVariables>;
export const DepartmentReviewsDocument = gql`
    query DepartmentReviews($id: DepartmentId!) {
  department(id: $id) {
    id
    reviewSummary {
      averageRating
      totalReviews
    }
  }
}
    `;
export type DepartmentReviewsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DepartmentReviewsQuery, DepartmentReviewsQueryVariables>, 'query'> & ({ variables: DepartmentReviewsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DepartmentReviewsComponent = (props: DepartmentReviewsComponentProps) => (
      <ApolloReactComponents.Query<DepartmentReviewsQuery, DepartmentReviewsQueryVariables> query={DepartmentReviewsDocument} {...props} />
    );
    

/**
 * __useDepartmentReviewsQuery__
 *
 * To run a query within a React component, call `useDepartmentReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentReviewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDepartmentReviewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DepartmentReviewsQuery, DepartmentReviewsQueryVariables>) {
        return ApolloReactHooks.useQuery<DepartmentReviewsQuery, DepartmentReviewsQueryVariables>(DepartmentReviewsDocument, baseOptions);
      }
export function useDepartmentReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentReviewsQuery, DepartmentReviewsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DepartmentReviewsQuery, DepartmentReviewsQueryVariables>(DepartmentReviewsDocument, baseOptions);
        }
export type DepartmentReviewsQueryHookResult = ReturnType<typeof useDepartmentReviewsQuery>;
export type DepartmentReviewsLazyQueryHookResult = ReturnType<typeof useDepartmentReviewsLazyQuery>;
export type DepartmentReviewsQueryResult = ApolloReactCommon.QueryResult<DepartmentReviewsQuery, DepartmentReviewsQueryVariables>;
export const DepartmentForSchemaDocument = gql`
    query DepartmentForSchema($id: DepartmentId!) {
  department(id: $id) {
    id
    slug
    displayName
    reviewSummary {
      averageRating
      totalReviews
    }
  }
}
    `;
export type DepartmentForSchemaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DepartmentForSchemaQuery, DepartmentForSchemaQueryVariables>, 'query'> & ({ variables: DepartmentForSchemaQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DepartmentForSchemaComponent = (props: DepartmentForSchemaComponentProps) => (
      <ApolloReactComponents.Query<DepartmentForSchemaQuery, DepartmentForSchemaQueryVariables> query={DepartmentForSchemaDocument} {...props} />
    );
    

/**
 * __useDepartmentForSchemaQuery__
 *
 * To run a query within a React component, call `useDepartmentForSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentForSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentForSchemaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDepartmentForSchemaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DepartmentForSchemaQuery, DepartmentForSchemaQueryVariables>) {
        return ApolloReactHooks.useQuery<DepartmentForSchemaQuery, DepartmentForSchemaQueryVariables>(DepartmentForSchemaDocument, baseOptions);
      }
export function useDepartmentForSchemaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentForSchemaQuery, DepartmentForSchemaQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DepartmentForSchemaQuery, DepartmentForSchemaQueryVariables>(DepartmentForSchemaDocument, baseOptions);
        }
export type DepartmentForSchemaQueryHookResult = ReturnType<typeof useDepartmentForSchemaQuery>;
export type DepartmentForSchemaLazyQueryHookResult = ReturnType<typeof useDepartmentForSchemaLazyQuery>;
export type DepartmentForSchemaQueryResult = ApolloReactCommon.QueryResult<DepartmentForSchemaQuery, DepartmentForSchemaQueryVariables>;
export const ExpertForSchemaDocument = gql`
    query ExpertForSchema($vanityIdOrId: String!) {
  findExpert(vanityIdOrId: $vanityIdOrId) {
    id
    vanityId
    displayName
    shortName
    expertProfile {
      id
      background
      profilePhoto {
        ...MediaFile
      }
    }
    expertStats {
      averageRating
      totalReviews
    }
  }
}
    ${MediaFileFragmentDoc}`;
export type ExpertForSchemaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertForSchemaQuery, ExpertForSchemaQueryVariables>, 'query'> & ({ variables: ExpertForSchemaQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertForSchemaComponent = (props: ExpertForSchemaComponentProps) => (
      <ApolloReactComponents.Query<ExpertForSchemaQuery, ExpertForSchemaQueryVariables> query={ExpertForSchemaDocument} {...props} />
    );
    

/**
 * __useExpertForSchemaQuery__
 *
 * To run a query within a React component, call `useExpertForSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertForSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertForSchemaQuery({
 *   variables: {
 *      vanityIdOrId: // value for 'vanityIdOrId'
 *   },
 * });
 */
export function useExpertForSchemaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertForSchemaQuery, ExpertForSchemaQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertForSchemaQuery, ExpertForSchemaQueryVariables>(ExpertForSchemaDocument, baseOptions);
      }
export function useExpertForSchemaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertForSchemaQuery, ExpertForSchemaQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertForSchemaQuery, ExpertForSchemaQueryVariables>(ExpertForSchemaDocument, baseOptions);
        }
export type ExpertForSchemaQueryHookResult = ReturnType<typeof useExpertForSchemaQuery>;
export type ExpertForSchemaLazyQueryHookResult = ReturnType<typeof useExpertForSchemaLazyQuery>;
export type ExpertForSchemaQueryResult = ApolloReactCommon.QueryResult<ExpertForSchemaQuery, ExpertForSchemaQueryVariables>;
export const SingleConsumerReviewDocument = gql`
    query SingleConsumerReview($id: ConsumerExpertReviewId!) {
  consumerExpertReview(id: $id) {
    ...ConsumerExpertReview
  }
}
    ${ConsumerExpertReviewFragmentDoc}`;
export type SingleConsumerReviewComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SingleConsumerReviewQuery, SingleConsumerReviewQueryVariables>, 'query'> & ({ variables: SingleConsumerReviewQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SingleConsumerReviewComponent = (props: SingleConsumerReviewComponentProps) => (
      <ApolloReactComponents.Query<SingleConsumerReviewQuery, SingleConsumerReviewQueryVariables> query={SingleConsumerReviewDocument} {...props} />
    );
    

/**
 * __useSingleConsumerReviewQuery__
 *
 * To run a query within a React component, call `useSingleConsumerReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleConsumerReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleConsumerReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleConsumerReviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SingleConsumerReviewQuery, SingleConsumerReviewQueryVariables>) {
        return ApolloReactHooks.useQuery<SingleConsumerReviewQuery, SingleConsumerReviewQueryVariables>(SingleConsumerReviewDocument, baseOptions);
      }
export function useSingleConsumerReviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SingleConsumerReviewQuery, SingleConsumerReviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SingleConsumerReviewQuery, SingleConsumerReviewQueryVariables>(SingleConsumerReviewDocument, baseOptions);
        }
export type SingleConsumerReviewQueryHookResult = ReturnType<typeof useSingleConsumerReviewQuery>;
export type SingleConsumerReviewLazyQueryHookResult = ReturnType<typeof useSingleConsumerReviewLazyQuery>;
export type SingleConsumerReviewQueryResult = ApolloReactCommon.QueryResult<SingleConsumerReviewQuery, SingleConsumerReviewQueryVariables>;
export const SaveSellableDocument = gql`
    mutation SaveSellable($input: SaveSavedSellableInput!) {
  saveSavedSellable(input: $input) {
    savedSellable {
      id
      saved
      sellable {
        ...SellableCard
      }
    }
  }
}
    ${SellableCardFragmentDoc}`;
export type SaveSellableMutationFn = ApolloReactCommon.MutationFunction<SaveSellableMutation, SaveSellableMutationVariables>;
export type SaveSellableComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SaveSellableMutation, SaveSellableMutationVariables>, 'mutation'>;

    export const SaveSellableComponent = (props: SaveSellableComponentProps) => (
      <ApolloReactComponents.Mutation<SaveSellableMutation, SaveSellableMutationVariables> mutation={SaveSellableDocument} {...props} />
    );
    

/**
 * __useSaveSellableMutation__
 *
 * To run a mutation, you first call `useSaveSellableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSellableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSellableMutation, { data, loading, error }] = useSaveSellableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSellableMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveSellableMutation, SaveSellableMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveSellableMutation, SaveSellableMutationVariables>(SaveSellableDocument, baseOptions);
      }
export type SaveSellableMutationHookResult = ReturnType<typeof useSaveSellableMutation>;
export type SaveSellableMutationResult = ApolloReactCommon.MutationResult<SaveSellableMutation>;
export type SaveSellableMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveSellableMutation, SaveSellableMutationVariables>;
export const UnsaveSellableDocument = gql`
    mutation UnsaveSellable($input: UnsaveSavedSellableInput!) {
  unsaveSavedSellable(input: $input) {
    savedSellable {
      id
      saved
      sellable {
        ...SellableCard
      }
    }
  }
}
    ${SellableCardFragmentDoc}`;
export type UnsaveSellableMutationFn = ApolloReactCommon.MutationFunction<UnsaveSellableMutation, UnsaveSellableMutationVariables>;
export type UnsaveSellableComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UnsaveSellableMutation, UnsaveSellableMutationVariables>, 'mutation'>;

    export const UnsaveSellableComponent = (props: UnsaveSellableComponentProps) => (
      <ApolloReactComponents.Mutation<UnsaveSellableMutation, UnsaveSellableMutationVariables> mutation={UnsaveSellableDocument} {...props} />
    );
    

/**
 * __useUnsaveSellableMutation__
 *
 * To run a mutation, you first call `useUnsaveSellableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsaveSellableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsaveSellableMutation, { data, loading, error }] = useUnsaveSellableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsaveSellableMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnsaveSellableMutation, UnsaveSellableMutationVariables>) {
        return ApolloReactHooks.useMutation<UnsaveSellableMutation, UnsaveSellableMutationVariables>(UnsaveSellableDocument, baseOptions);
      }
export type UnsaveSellableMutationHookResult = ReturnType<typeof useUnsaveSellableMutation>;
export type UnsaveSellableMutationResult = ApolloReactCommon.MutationResult<UnsaveSellableMutation>;
export type UnsaveSellableMutationOptions = ApolloReactCommon.BaseMutationOptions<UnsaveSellableMutation, UnsaveSellableMutationVariables>;
export const SaveRecommendedListRatingDocument = gql`
    mutation SaveRecommendedListRating($input: SaveConsumerSellableReactionInput!) {
  saveConsumerSellableReaction(input: $input) {
    consumerSellableReaction {
      id
      sellable {
        ...RecommendedListSellableCard
      }
    }
  }
}
    ${RecommendedListSellableCardFragmentDoc}`;
export type SaveRecommendedListRatingMutationFn = ApolloReactCommon.MutationFunction<SaveRecommendedListRatingMutation, SaveRecommendedListRatingMutationVariables>;
export type SaveRecommendedListRatingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SaveRecommendedListRatingMutation, SaveRecommendedListRatingMutationVariables>, 'mutation'>;

    export const SaveRecommendedListRatingComponent = (props: SaveRecommendedListRatingComponentProps) => (
      <ApolloReactComponents.Mutation<SaveRecommendedListRatingMutation, SaveRecommendedListRatingMutationVariables> mutation={SaveRecommendedListRatingDocument} {...props} />
    );
    

/**
 * __useSaveRecommendedListRatingMutation__
 *
 * To run a mutation, you first call `useSaveRecommendedListRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRecommendedListRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRecommendedListRatingMutation, { data, loading, error }] = useSaveRecommendedListRatingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveRecommendedListRatingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveRecommendedListRatingMutation, SaveRecommendedListRatingMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveRecommendedListRatingMutation, SaveRecommendedListRatingMutationVariables>(SaveRecommendedListRatingDocument, baseOptions);
      }
export type SaveRecommendedListRatingMutationHookResult = ReturnType<typeof useSaveRecommendedListRatingMutation>;
export type SaveRecommendedListRatingMutationResult = ApolloReactCommon.MutationResult<SaveRecommendedListRatingMutation>;
export type SaveRecommendedListRatingMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveRecommendedListRatingMutation, SaveRecommendedListRatingMutationVariables>;
export const ConsumerReactionsForSellableDocument = gql`
    query ConsumerReactionsForSellable($id: SellableId!) {
  sellable(id: $id) {
    id
    consumerSellableReactions {
      edges {
        node {
          id
          ratingWithDisplayName {
            displayName
            rating
          }
        }
      }
    }
  }
}
    `;
export type ConsumerReactionsForSellableComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConsumerReactionsForSellableQuery, ConsumerReactionsForSellableQueryVariables>, 'query'> & ({ variables: ConsumerReactionsForSellableQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConsumerReactionsForSellableComponent = (props: ConsumerReactionsForSellableComponentProps) => (
      <ApolloReactComponents.Query<ConsumerReactionsForSellableQuery, ConsumerReactionsForSellableQueryVariables> query={ConsumerReactionsForSellableDocument} {...props} />
    );
    

/**
 * __useConsumerReactionsForSellableQuery__
 *
 * To run a query within a React component, call `useConsumerReactionsForSellableQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerReactionsForSellableQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerReactionsForSellableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsumerReactionsForSellableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ConsumerReactionsForSellableQuery, ConsumerReactionsForSellableQueryVariables>) {
        return ApolloReactHooks.useQuery<ConsumerReactionsForSellableQuery, ConsumerReactionsForSellableQueryVariables>(ConsumerReactionsForSellableDocument, baseOptions);
      }
export function useConsumerReactionsForSellableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConsumerReactionsForSellableQuery, ConsumerReactionsForSellableQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ConsumerReactionsForSellableQuery, ConsumerReactionsForSellableQueryVariables>(ConsumerReactionsForSellableDocument, baseOptions);
        }
export type ConsumerReactionsForSellableQueryHookResult = ReturnType<typeof useConsumerReactionsForSellableQuery>;
export type ConsumerReactionsForSellableLazyQueryHookResult = ReturnType<typeof useConsumerReactionsForSellableLazyQuery>;
export type ConsumerReactionsForSellableQueryResult = ApolloReactCommon.QueryResult<ConsumerReactionsForSellableQuery, ConsumerReactionsForSellableQueryVariables>;
export const CreateShareLinkDocument = gql`
    mutation CreateShareLink($input: ShortenUrlInput!) {
  shortenUrl(input: $input) {
    url
  }
}
    `;
export type CreateShareLinkMutationFn = ApolloReactCommon.MutationFunction<CreateShareLinkMutation, CreateShareLinkMutationVariables>;
export type CreateShareLinkComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateShareLinkMutation, CreateShareLinkMutationVariables>, 'mutation'>;

    export const CreateShareLinkComponent = (props: CreateShareLinkComponentProps) => (
      <ApolloReactComponents.Mutation<CreateShareLinkMutation, CreateShareLinkMutationVariables> mutation={CreateShareLinkDocument} {...props} />
    );
    

/**
 * __useCreateShareLinkMutation__
 *
 * To run a mutation, you first call `useCreateShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShareLinkMutation, { data, loading, error }] = useCreateShareLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShareLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateShareLinkMutation, CreateShareLinkMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateShareLinkMutation, CreateShareLinkMutationVariables>(CreateShareLinkDocument, baseOptions);
      }
export type CreateShareLinkMutationHookResult = ReturnType<typeof useCreateShareLinkMutation>;
export type CreateShareLinkMutationResult = ApolloReactCommon.MutationResult<CreateShareLinkMutation>;
export type CreateShareLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateShareLinkMutation, CreateShareLinkMutationVariables>;
export const SendExpertReferralDocument = gql`
    mutation SendExpertReferral($input: SendExpertReferralInput!) {
  sendExpertReferral(input: $input) {
    errors
  }
}
    `;
export type SendExpertReferralMutationFn = ApolloReactCommon.MutationFunction<SendExpertReferralMutation, SendExpertReferralMutationVariables>;
export type SendExpertReferralComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SendExpertReferralMutation, SendExpertReferralMutationVariables>, 'mutation'>;

    export const SendExpertReferralComponent = (props: SendExpertReferralComponentProps) => (
      <ApolloReactComponents.Mutation<SendExpertReferralMutation, SendExpertReferralMutationVariables> mutation={SendExpertReferralDocument} {...props} />
    );
    

/**
 * __useSendExpertReferralMutation__
 *
 * To run a mutation, you first call `useSendExpertReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendExpertReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendExpertReferralMutation, { data, loading, error }] = useSendExpertReferralMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendExpertReferralMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendExpertReferralMutation, SendExpertReferralMutationVariables>) {
        return ApolloReactHooks.useMutation<SendExpertReferralMutation, SendExpertReferralMutationVariables>(SendExpertReferralDocument, baseOptions);
      }
export type SendExpertReferralMutationHookResult = ReturnType<typeof useSendExpertReferralMutation>;
export type SendExpertReferralMutationResult = ApolloReactCommon.MutationResult<SendExpertReferralMutation>;
export type SendExpertReferralMutationOptions = ApolloReactCommon.BaseMutationOptions<SendExpertReferralMutation, SendExpertReferralMutationVariables>;
export const GuestSellablesDocument = gql`
    query GuestSellables($ids: [SellableId!]!) {
  sellables(ids: $ids) {
    ...GuestSellable
  }
}
    ${GuestSellableFragmentDoc}`;
export type GuestSellablesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GuestSellablesQuery, GuestSellablesQueryVariables>, 'query'> & ({ variables: GuestSellablesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GuestSellablesComponent = (props: GuestSellablesComponentProps) => (
      <ApolloReactComponents.Query<GuestSellablesQuery, GuestSellablesQueryVariables> query={GuestSellablesDocument} {...props} />
    );
    

/**
 * __useGuestSellablesQuery__
 *
 * To run a query within a React component, call `useGuestSellablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestSellablesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestSellablesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGuestSellablesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestSellablesQuery, GuestSellablesQueryVariables>) {
        return ApolloReactHooks.useQuery<GuestSellablesQuery, GuestSellablesQueryVariables>(GuestSellablesDocument, baseOptions);
      }
export function useGuestSellablesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestSellablesQuery, GuestSellablesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GuestSellablesQuery, GuestSellablesQueryVariables>(GuestSellablesDocument, baseOptions);
        }
export type GuestSellablesQueryHookResult = ReturnType<typeof useGuestSellablesQuery>;
export type GuestSellablesLazyQueryHookResult = ReturnType<typeof useGuestSellablesLazyQuery>;
export type GuestSellablesQueryResult = ApolloReactCommon.QueryResult<GuestSellablesQuery, GuestSellablesQueryVariables>;
export const DismissOrderMessageDocument = gql`
    mutation DismissOrderMessage {
  dismissOrderMessages(input: {}) {
    order {
      ...ShoppingCartOrder
    }
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type DismissOrderMessageMutationFn = ApolloReactCommon.MutationFunction<DismissOrderMessageMutation, DismissOrderMessageMutationVariables>;
export type DismissOrderMessageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DismissOrderMessageMutation, DismissOrderMessageMutationVariables>, 'mutation'>;

    export const DismissOrderMessageComponent = (props: DismissOrderMessageComponentProps) => (
      <ApolloReactComponents.Mutation<DismissOrderMessageMutation, DismissOrderMessageMutationVariables> mutation={DismissOrderMessageDocument} {...props} />
    );
    

/**
 * __useDismissOrderMessageMutation__
 *
 * To run a mutation, you first call `useDismissOrderMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissOrderMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissOrderMessageMutation, { data, loading, error }] = useDismissOrderMessageMutation({
 *   variables: {
 *   },
 * });
 */
export function useDismissOrderMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DismissOrderMessageMutation, DismissOrderMessageMutationVariables>) {
        return ApolloReactHooks.useMutation<DismissOrderMessageMutation, DismissOrderMessageMutationVariables>(DismissOrderMessageDocument, baseOptions);
      }
export type DismissOrderMessageMutationHookResult = ReturnType<typeof useDismissOrderMessageMutation>;
export type DismissOrderMessageMutationResult = ApolloReactCommon.MutationResult<DismissOrderMessageMutation>;
export type DismissOrderMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<DismissOrderMessageMutation, DismissOrderMessageMutationVariables>;
export const RemoveItemFromOrderDocument = gql`
    mutation RemoveItemFromOrder($input: RemoveItemsFromOrderInput!) {
  removeItemsFromOrder(input: $input) {
    order {
      ...ShoppingCartOrder
    }
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type RemoveItemFromOrderMutationFn = ApolloReactCommon.MutationFunction<RemoveItemFromOrderMutation, RemoveItemFromOrderMutationVariables>;
export type RemoveItemFromOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveItemFromOrderMutation, RemoveItemFromOrderMutationVariables>, 'mutation'>;

    export const RemoveItemFromOrderComponent = (props: RemoveItemFromOrderComponentProps) => (
      <ApolloReactComponents.Mutation<RemoveItemFromOrderMutation, RemoveItemFromOrderMutationVariables> mutation={RemoveItemFromOrderDocument} {...props} />
    );
    

/**
 * __useRemoveItemFromOrderMutation__
 *
 * To run a mutation, you first call `useRemoveItemFromOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemFromOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemFromOrderMutation, { data, loading, error }] = useRemoveItemFromOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveItemFromOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveItemFromOrderMutation, RemoveItemFromOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveItemFromOrderMutation, RemoveItemFromOrderMutationVariables>(RemoveItemFromOrderDocument, baseOptions);
      }
export type RemoveItemFromOrderMutationHookResult = ReturnType<typeof useRemoveItemFromOrderMutation>;
export type RemoveItemFromOrderMutationResult = ApolloReactCommon.MutationResult<RemoveItemFromOrderMutation>;
export type RemoveItemFromOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveItemFromOrderMutation, RemoveItemFromOrderMutationVariables>;
export const UpdateQuantityForOrderDocument = gql`
    mutation UpdateQuantityForOrder($input: UpdateQuantityForOrderInput!) {
  updateQuantityForOrder(input: $input) {
    order {
      ...ShoppingCartOrder
    }
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type UpdateQuantityForOrderMutationFn = ApolloReactCommon.MutationFunction<UpdateQuantityForOrderMutation, UpdateQuantityForOrderMutationVariables>;
export type UpdateQuantityForOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateQuantityForOrderMutation, UpdateQuantityForOrderMutationVariables>, 'mutation'>;

    export const UpdateQuantityForOrderComponent = (props: UpdateQuantityForOrderComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateQuantityForOrderMutation, UpdateQuantityForOrderMutationVariables> mutation={UpdateQuantityForOrderDocument} {...props} />
    );
    

/**
 * __useUpdateQuantityForOrderMutation__
 *
 * To run a mutation, you first call `useUpdateQuantityForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuantityForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuantityForOrderMutation, { data, loading, error }] = useUpdateQuantityForOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuantityForOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateQuantityForOrderMutation, UpdateQuantityForOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateQuantityForOrderMutation, UpdateQuantityForOrderMutationVariables>(UpdateQuantityForOrderDocument, baseOptions);
      }
export type UpdateQuantityForOrderMutationHookResult = ReturnType<typeof useUpdateQuantityForOrderMutation>;
export type UpdateQuantityForOrderMutationResult = ApolloReactCommon.MutationResult<UpdateQuantityForOrderMutation>;
export type UpdateQuantityForOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateQuantityForOrderMutation, UpdateQuantityForOrderMutationVariables>;
export const SimilarProductsDocument = gql`
    query SimilarProducts($sellableId: SellableId!) {
  similarSellables(id: $sellableId) {
    sellables {
      ...RecommendedListSellableCard
    }
  }
}
    ${RecommendedListSellableCardFragmentDoc}`;
export type SimilarProductsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SimilarProductsQuery, SimilarProductsQueryVariables>, 'query'> & ({ variables: SimilarProductsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SimilarProductsComponent = (props: SimilarProductsComponentProps) => (
      <ApolloReactComponents.Query<SimilarProductsQuery, SimilarProductsQueryVariables> query={SimilarProductsDocument} {...props} />
    );
    

/**
 * __useSimilarProductsQuery__
 *
 * To run a query within a React component, call `useSimilarProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarProductsQuery({
 *   variables: {
 *      sellableId: // value for 'sellableId'
 *   },
 * });
 */
export function useSimilarProductsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SimilarProductsQuery, SimilarProductsQueryVariables>) {
        return ApolloReactHooks.useQuery<SimilarProductsQuery, SimilarProductsQueryVariables>(SimilarProductsDocument, baseOptions);
      }
export function useSimilarProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SimilarProductsQuery, SimilarProductsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SimilarProductsQuery, SimilarProductsQueryVariables>(SimilarProductsDocument, baseOptions);
        }
export type SimilarProductsQueryHookResult = ReturnType<typeof useSimilarProductsQuery>;
export type SimilarProductsLazyQueryHookResult = ReturnType<typeof useSimilarProductsLazyQuery>;
export type SimilarProductsQueryResult = ApolloReactCommon.QueryResult<SimilarProductsQuery, SimilarProductsQueryVariables>;
export const StandaloneRegisterDocument = gql`
    mutation StandaloneRegister($input: RegisterCustomerInput!) {
  registerCustomer(input: $input) {
    user {
      ...AuthenticatedUser
    }
    errors
    errorCodes
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export type StandaloneRegisterMutationFn = ApolloReactCommon.MutationFunction<StandaloneRegisterMutation, StandaloneRegisterMutationVariables>;
export type StandaloneRegisterComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<StandaloneRegisterMutation, StandaloneRegisterMutationVariables>, 'mutation'>;

    export const StandaloneRegisterComponent = (props: StandaloneRegisterComponentProps) => (
      <ApolloReactComponents.Mutation<StandaloneRegisterMutation, StandaloneRegisterMutationVariables> mutation={StandaloneRegisterDocument} {...props} />
    );
    

/**
 * __useStandaloneRegisterMutation__
 *
 * To run a mutation, you first call `useStandaloneRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStandaloneRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [standaloneRegisterMutation, { data, loading, error }] = useStandaloneRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStandaloneRegisterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StandaloneRegisterMutation, StandaloneRegisterMutationVariables>) {
        return ApolloReactHooks.useMutation<StandaloneRegisterMutation, StandaloneRegisterMutationVariables>(StandaloneRegisterDocument, baseOptions);
      }
export type StandaloneRegisterMutationHookResult = ReturnType<typeof useStandaloneRegisterMutation>;
export type StandaloneRegisterMutationResult = ApolloReactCommon.MutationResult<StandaloneRegisterMutation>;
export type StandaloneRegisterMutationOptions = ApolloReactCommon.BaseMutationOptions<StandaloneRegisterMutation, StandaloneRegisterMutationVariables>;
export const UploadMediaDocument = gql`
    mutation UploadMedia($input: UploadMediaInput!) {
  uploadMedia(input: $input) {
    mediaFile {
      ...MediaFile
    }
  }
}
    ${MediaFileFragmentDoc}`;
export type UploadMediaMutationFn = ApolloReactCommon.MutationFunction<UploadMediaMutation, UploadMediaMutationVariables>;
export type UploadMediaComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UploadMediaMutation, UploadMediaMutationVariables>, 'mutation'>;

    export const UploadMediaComponent = (props: UploadMediaComponentProps) => (
      <ApolloReactComponents.Mutation<UploadMediaMutation, UploadMediaMutationVariables> mutation={UploadMediaDocument} {...props} />
    );
    

/**
 * __useUploadMediaMutation__
 *
 * To run a mutation, you first call `useUploadMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMediaMutation, { data, loading, error }] = useUploadMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadMediaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadMediaMutation, UploadMediaMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadMediaMutation, UploadMediaMutationVariables>(UploadMediaDocument, baseOptions);
      }
export type UploadMediaMutationHookResult = ReturnType<typeof useUploadMediaMutation>;
export type UploadMediaMutationResult = ApolloReactCommon.MutationResult<UploadMediaMutation>;
export type UploadMediaMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadMediaMutation, UploadMediaMutationVariables>;
export const UpdateProfileDataDocument = gql`
    mutation UpdateProfileData($input: UpdateUserProfileInput!) {
  updateUserProfile(input: $input) {
    errors
  }
}
    `;
export type UpdateProfileDataMutationFn = ApolloReactCommon.MutationFunction<UpdateProfileDataMutation, UpdateProfileDataMutationVariables>;
export type UpdateProfileDataComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateProfileDataMutation, UpdateProfileDataMutationVariables>, 'mutation'>;

    export const UpdateProfileDataComponent = (props: UpdateProfileDataComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateProfileDataMutation, UpdateProfileDataMutationVariables> mutation={UpdateProfileDataDocument} {...props} />
    );
    

/**
 * __useUpdateProfileDataMutation__
 *
 * To run a mutation, you first call `useUpdateProfileDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileDataMutation, { data, loading, error }] = useUpdateProfileDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProfileDataMutation, UpdateProfileDataMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateProfileDataMutation, UpdateProfileDataMutationVariables>(UpdateProfileDataDocument, baseOptions);
      }
export type UpdateProfileDataMutationHookResult = ReturnType<typeof useUpdateProfileDataMutation>;
export type UpdateProfileDataMutationResult = ApolloReactCommon.MutationResult<UpdateProfileDataMutation>;
export type UpdateProfileDataMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProfileDataMutation, UpdateProfileDataMutationVariables>;
export const VariationMatrixDocument = gql`
    query VariationMatrix($id: SellableId!) {
  sellable(id: $id) {
    id
    variationMatrix {
      ...VariationMatrix
    }
  }
}
    ${VariationMatrixFragmentDoc}`;
export type VariationMatrixComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<VariationMatrixQuery, VariationMatrixQueryVariables>, 'query'> & ({ variables: VariationMatrixQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const VariationMatrixComponent = (props: VariationMatrixComponentProps) => (
      <ApolloReactComponents.Query<VariationMatrixQuery, VariationMatrixQueryVariables> query={VariationMatrixDocument} {...props} />
    );
    

/**
 * __useVariationMatrixQuery__
 *
 * To run a query within a React component, call `useVariationMatrixQuery` and pass it any options that fit your needs.
 * When your component renders, `useVariationMatrixQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVariationMatrixQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVariationMatrixQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VariationMatrixQuery, VariationMatrixQueryVariables>) {
        return ApolloReactHooks.useQuery<VariationMatrixQuery, VariationMatrixQueryVariables>(VariationMatrixDocument, baseOptions);
      }
export function useVariationMatrixLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VariationMatrixQuery, VariationMatrixQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VariationMatrixQuery, VariationMatrixQueryVariables>(VariationMatrixDocument, baseOptions);
        }
export type VariationMatrixQueryHookResult = ReturnType<typeof useVariationMatrixQuery>;
export type VariationMatrixLazyQueryHookResult = ReturnType<typeof useVariationMatrixLazyQuery>;
export type VariationMatrixQueryResult = ApolloReactCommon.QueryResult<VariationMatrixQuery, VariationMatrixQueryVariables>;
export const LandingPageExpertsDocument = gql`
    query LandingPageExperts($slug: String!) {
  categoryBySlug(slug: $slug) {
    id
    experts {
      ...LandingPageExpertCard
    }
  }
}
    ${LandingPageExpertCardFragmentDoc}`;
export type LandingPageExpertsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LandingPageExpertsQuery, LandingPageExpertsQueryVariables>, 'query'> & ({ variables: LandingPageExpertsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LandingPageExpertsComponent = (props: LandingPageExpertsComponentProps) => (
      <ApolloReactComponents.Query<LandingPageExpertsQuery, LandingPageExpertsQueryVariables> query={LandingPageExpertsDocument} {...props} />
    );
    

/**
 * __useLandingPageExpertsQuery__
 *
 * To run a query within a React component, call `useLandingPageExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPageExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPageExpertsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useLandingPageExpertsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LandingPageExpertsQuery, LandingPageExpertsQueryVariables>) {
        return ApolloReactHooks.useQuery<LandingPageExpertsQuery, LandingPageExpertsQueryVariables>(LandingPageExpertsDocument, baseOptions);
      }
export function useLandingPageExpertsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LandingPageExpertsQuery, LandingPageExpertsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LandingPageExpertsQuery, LandingPageExpertsQueryVariables>(LandingPageExpertsDocument, baseOptions);
        }
export type LandingPageExpertsQueryHookResult = ReturnType<typeof useLandingPageExpertsQuery>;
export type LandingPageExpertsLazyQueryHookResult = ReturnType<typeof useLandingPageExpertsLazyQuery>;
export type LandingPageExpertsQueryResult = ApolloReactCommon.QueryResult<LandingPageExpertsQuery, LandingPageExpertsQueryVariables>;
export const FeaturedExpertsForDepartmentFritosDocument = gql`
    query FeaturedExpertsForDepartmentFritos($query: ExpertSearchQuery!) {
  expertSearchConnection(query: $query, first: 6) {
    edges {
      cursor
      node {
        ...FeaturedExpertForDepartmentFritos
      }
    }
  }
}
    ${FeaturedExpertForDepartmentFritosFragmentDoc}`;
export type FeaturedExpertsForDepartmentFritosComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FeaturedExpertsForDepartmentFritosQuery, FeaturedExpertsForDepartmentFritosQueryVariables>, 'query'> & ({ variables: FeaturedExpertsForDepartmentFritosQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FeaturedExpertsForDepartmentFritosComponent = (props: FeaturedExpertsForDepartmentFritosComponentProps) => (
      <ApolloReactComponents.Query<FeaturedExpertsForDepartmentFritosQuery, FeaturedExpertsForDepartmentFritosQueryVariables> query={FeaturedExpertsForDepartmentFritosDocument} {...props} />
    );
    

/**
 * __useFeaturedExpertsForDepartmentFritosQuery__
 *
 * To run a query within a React component, call `useFeaturedExpertsForDepartmentFritosQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedExpertsForDepartmentFritosQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedExpertsForDepartmentFritosQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFeaturedExpertsForDepartmentFritosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeaturedExpertsForDepartmentFritosQuery, FeaturedExpertsForDepartmentFritosQueryVariables>) {
        return ApolloReactHooks.useQuery<FeaturedExpertsForDepartmentFritosQuery, FeaturedExpertsForDepartmentFritosQueryVariables>(FeaturedExpertsForDepartmentFritosDocument, baseOptions);
      }
export function useFeaturedExpertsForDepartmentFritosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeaturedExpertsForDepartmentFritosQuery, FeaturedExpertsForDepartmentFritosQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FeaturedExpertsForDepartmentFritosQuery, FeaturedExpertsForDepartmentFritosQueryVariables>(FeaturedExpertsForDepartmentFritosDocument, baseOptions);
        }
export type FeaturedExpertsForDepartmentFritosQueryHookResult = ReturnType<typeof useFeaturedExpertsForDepartmentFritosQuery>;
export type FeaturedExpertsForDepartmentFritosLazyQueryHookResult = ReturnType<typeof useFeaturedExpertsForDepartmentFritosLazyQuery>;
export type FeaturedExpertsForDepartmentFritosQueryResult = ApolloReactCommon.QueryResult<FeaturedExpertsForDepartmentFritosQuery, FeaturedExpertsForDepartmentFritosQueryVariables>;
export const KeystoneExpertsDocument = gql`
    query KeystoneExperts($slug: String!) {
  categoryBySlug(slug: $slug) {
    id
    experts {
      id
      displayName
      shortName
      expertProfile {
        id
        headline
        profilePhoto {
          ...MediaFile
        }
      }
    }
  }
}
    ${MediaFileFragmentDoc}`;
export type KeystoneExpertsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<KeystoneExpertsQuery, KeystoneExpertsQueryVariables>, 'query'> & ({ variables: KeystoneExpertsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const KeystoneExpertsComponent = (props: KeystoneExpertsComponentProps) => (
      <ApolloReactComponents.Query<KeystoneExpertsQuery, KeystoneExpertsQueryVariables> query={KeystoneExpertsDocument} {...props} />
    );
    

/**
 * __useKeystoneExpertsQuery__
 *
 * To run a query within a React component, call `useKeystoneExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeystoneExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeystoneExpertsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useKeystoneExpertsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<KeystoneExpertsQuery, KeystoneExpertsQueryVariables>) {
        return ApolloReactHooks.useQuery<KeystoneExpertsQuery, KeystoneExpertsQueryVariables>(KeystoneExpertsDocument, baseOptions);
      }
export function useKeystoneExpertsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<KeystoneExpertsQuery, KeystoneExpertsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<KeystoneExpertsQuery, KeystoneExpertsQueryVariables>(KeystoneExpertsDocument, baseOptions);
        }
export type KeystoneExpertsQueryHookResult = ReturnType<typeof useKeystoneExpertsQuery>;
export type KeystoneExpertsLazyQueryHookResult = ReturnType<typeof useKeystoneExpertsLazyQuery>;
export type KeystoneExpertsQueryResult = ApolloReactCommon.QueryResult<KeystoneExpertsQuery, KeystoneExpertsQueryVariables>;
export const SearchSellablesLandingDocument = gql`
    query SearchSellablesLanding($categoryIds: [CategoryId!], $type: SellableType, $facets: [FacetSelection!]) {
  searchSellables(query: {facets: $facets, maxFacetTerms: 25, categoryIds: $categoryIds, type: $type}, first: 6) {
    count
    facets {
      ...DisplayFacet
    }
  }
}
    ${DisplayFacetFragmentDoc}`;
export type SearchSellablesLandingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchSellablesLandingQuery, SearchSellablesLandingQueryVariables>, 'query'>;

    export const SearchSellablesLandingComponent = (props: SearchSellablesLandingComponentProps) => (
      <ApolloReactComponents.Query<SearchSellablesLandingQuery, SearchSellablesLandingQueryVariables> query={SearchSellablesLandingDocument} {...props} />
    );
    

/**
 * __useSearchSellablesLandingQuery__
 *
 * To run a query within a React component, call `useSearchSellablesLandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSellablesLandingQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSellablesLandingQuery({
 *   variables: {
 *      categoryIds: // value for 'categoryIds'
 *      type: // value for 'type'
 *      facets: // value for 'facets'
 *   },
 * });
 */
export function useSearchSellablesLandingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchSellablesLandingQuery, SearchSellablesLandingQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchSellablesLandingQuery, SearchSellablesLandingQueryVariables>(SearchSellablesLandingDocument, baseOptions);
      }
export function useSearchSellablesLandingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchSellablesLandingQuery, SearchSellablesLandingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchSellablesLandingQuery, SearchSellablesLandingQueryVariables>(SearchSellablesLandingDocument, baseOptions);
        }
export type SearchSellablesLandingQueryHookResult = ReturnType<typeof useSearchSellablesLandingQuery>;
export type SearchSellablesLandingLazyQueryHookResult = ReturnType<typeof useSearchSellablesLandingLazyQuery>;
export type SearchSellablesLandingQueryResult = ApolloReactCommon.QueryResult<SearchSellablesLandingQuery, SearchSellablesLandingQueryVariables>;
export const BusinessUserChatWidgetDocument = gql`
    query BusinessUserChatWidget($id: BusinessUserId!) {
  businessUser(id: $id) {
    ...ChatWidgetExpert
    existingLeadForConsumer {
      id
      conversation {
        id
        externalId
      }
    }
  }
}
    ${ChatWidgetExpertFragmentDoc}`;
export type BusinessUserChatWidgetComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BusinessUserChatWidgetQuery, BusinessUserChatWidgetQueryVariables>, 'query'> & ({ variables: BusinessUserChatWidgetQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BusinessUserChatWidgetComponent = (props: BusinessUserChatWidgetComponentProps) => (
      <ApolloReactComponents.Query<BusinessUserChatWidgetQuery, BusinessUserChatWidgetQueryVariables> query={BusinessUserChatWidgetDocument} {...props} />
    );
    

/**
 * __useBusinessUserChatWidgetQuery__
 *
 * To run a query within a React component, call `useBusinessUserChatWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessUserChatWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessUserChatWidgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBusinessUserChatWidgetQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BusinessUserChatWidgetQuery, BusinessUserChatWidgetQueryVariables>) {
        return ApolloReactHooks.useQuery<BusinessUserChatWidgetQuery, BusinessUserChatWidgetQueryVariables>(BusinessUserChatWidgetDocument, baseOptions);
      }
export function useBusinessUserChatWidgetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BusinessUserChatWidgetQuery, BusinessUserChatWidgetQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BusinessUserChatWidgetQuery, BusinessUserChatWidgetQueryVariables>(BusinessUserChatWidgetDocument, baseOptions);
        }
export type BusinessUserChatWidgetQueryHookResult = ReturnType<typeof useBusinessUserChatWidgetQuery>;
export type BusinessUserChatWidgetLazyQueryHookResult = ReturnType<typeof useBusinessUserChatWidgetLazyQuery>;
export type BusinessUserChatWidgetQueryResult = ApolloReactCommon.QueryResult<BusinessUserChatWidgetQuery, BusinessUserChatWidgetQueryVariables>;
export const GetShoppingCartDocument = gql`
    query GetShoppingCart($id: OrderId!) {
  order(id: $id) {
    ...ShoppingCartOrder
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type GetShoppingCartComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShoppingCartQuery, GetShoppingCartQueryVariables>, 'query'> & ({ variables: GetShoppingCartQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetShoppingCartComponent = (props: GetShoppingCartComponentProps) => (
      <ApolloReactComponents.Query<GetShoppingCartQuery, GetShoppingCartQueryVariables> query={GetShoppingCartDocument} {...props} />
    );
    

/**
 * __useGetShoppingCartQuery__
 *
 * To run a query within a React component, call `useGetShoppingCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShoppingCartQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShoppingCartQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShoppingCartQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetShoppingCartQuery, GetShoppingCartQueryVariables>) {
        return ApolloReactHooks.useQuery<GetShoppingCartQuery, GetShoppingCartQueryVariables>(GetShoppingCartDocument, baseOptions);
      }
export function useGetShoppingCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShoppingCartQuery, GetShoppingCartQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetShoppingCartQuery, GetShoppingCartQueryVariables>(GetShoppingCartDocument, baseOptions);
        }
export type GetShoppingCartQueryHookResult = ReturnType<typeof useGetShoppingCartQuery>;
export type GetShoppingCartLazyQueryHookResult = ReturnType<typeof useGetShoppingCartLazyQuery>;
export type GetShoppingCartQueryResult = ApolloReactCommon.QueryResult<GetShoppingCartQuery, GetShoppingCartQueryVariables>;
export const ShoppingCartDocument = gql`
    subscription ShoppingCart($userId: UserId) {
  userCartLineItemsChanged(userId: $userId) {
    ...ShoppingCartOrder
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type ShoppingCartComponentProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<ShoppingCartSubscription, ShoppingCartSubscriptionVariables>, 'subscription'>;

    export const ShoppingCartComponent = (props: ShoppingCartComponentProps) => (
      <ApolloReactComponents.Subscription<ShoppingCartSubscription, ShoppingCartSubscriptionVariables> subscription={ShoppingCartDocument} {...props} />
    );
    

/**
 * __useShoppingCartSubscription__
 *
 * To run a query within a React component, call `useShoppingCartSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShoppingCartSubscription` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShoppingCartSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useShoppingCartSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<ShoppingCartSubscription, ShoppingCartSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<ShoppingCartSubscription, ShoppingCartSubscriptionVariables>(ShoppingCartDocument, baseOptions);
      }
export type ShoppingCartSubscriptionHookResult = ReturnType<typeof useShoppingCartSubscription>;
export type ShoppingCartSubscriptionResult = ApolloReactCommon.SubscriptionResult<ShoppingCartSubscription>;
export const SyncShoppingCartDocument = gql`
    mutation SyncShoppingCart {
  syncOrder(input: {useCase: CART_VIEW}) {
    order {
      ...ShoppingCartOrder
    }
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type SyncShoppingCartMutationFn = ApolloReactCommon.MutationFunction<SyncShoppingCartMutation, SyncShoppingCartMutationVariables>;
export type SyncShoppingCartComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SyncShoppingCartMutation, SyncShoppingCartMutationVariables>, 'mutation'>;

    export const SyncShoppingCartComponent = (props: SyncShoppingCartComponentProps) => (
      <ApolloReactComponents.Mutation<SyncShoppingCartMutation, SyncShoppingCartMutationVariables> mutation={SyncShoppingCartDocument} {...props} />
    );
    

/**
 * __useSyncShoppingCartMutation__
 *
 * To run a mutation, you first call `useSyncShoppingCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncShoppingCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncShoppingCartMutation, { data, loading, error }] = useSyncShoppingCartMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncShoppingCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncShoppingCartMutation, SyncShoppingCartMutationVariables>) {
        return ApolloReactHooks.useMutation<SyncShoppingCartMutation, SyncShoppingCartMutationVariables>(SyncShoppingCartDocument, baseOptions);
      }
export type SyncShoppingCartMutationHookResult = ReturnType<typeof useSyncShoppingCartMutation>;
export type SyncShoppingCartMutationResult = ApolloReactCommon.MutationResult<SyncShoppingCartMutation>;
export type SyncShoppingCartMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncShoppingCartMutation, SyncShoppingCartMutationVariables>;
export const RecommendExpert2Document = gql`
    query RecommendExpert2($consumerId: UserId!, $categoryId: CategoryId!) {
  recommendExpert2(consumerId: $consumerId, categoryId: $categoryId) {
    expert {
      ...ChatWidgetExpert
      existingLeadForConsumer {
        id
        conversation {
          id
          externalId
        }
      }
    }
  }
}
    ${ChatWidgetExpertFragmentDoc}`;
export type RecommendExpert2ComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecommendExpert2Query, RecommendExpert2QueryVariables>, 'query'> & ({ variables: RecommendExpert2QueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RecommendExpert2Component = (props: RecommendExpert2ComponentProps) => (
      <ApolloReactComponents.Query<RecommendExpert2Query, RecommendExpert2QueryVariables> query={RecommendExpert2Document} {...props} />
    );
    

/**
 * __useRecommendExpert2Query__
 *
 * To run a query within a React component, call `useRecommendExpert2Query` and pass it any options that fit your needs.
 * When your component renders, `useRecommendExpert2Query` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendExpert2Query({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useRecommendExpert2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<RecommendExpert2Query, RecommendExpert2QueryVariables>) {
        return ApolloReactHooks.useQuery<RecommendExpert2Query, RecommendExpert2QueryVariables>(RecommendExpert2Document, baseOptions);
      }
export function useRecommendExpert2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecommendExpert2Query, RecommendExpert2QueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RecommendExpert2Query, RecommendExpert2QueryVariables>(RecommendExpert2Document, baseOptions);
        }
export type RecommendExpert2QueryHookResult = ReturnType<typeof useRecommendExpert2Query>;
export type RecommendExpert2LazyQueryHookResult = ReturnType<typeof useRecommendExpert2LazyQuery>;
export type RecommendExpert2QueryResult = ApolloReactCommon.QueryResult<RecommendExpert2Query, RecommendExpert2QueryVariables>;
export const GetMessagingUsersDocument = gql`
    query GetMessagingUsers($ids: [AnyId!]!) {
  messagingUsers(ids: $ids) {
    id
    displayName
    avatar {
      id
      url
    }
    type
    profile {
      ... on BusinessUser {
        id
        vanityId
        expertStats {
          averageRating
        }
      }
    }
  }
}
    `;
export type GetMessagingUsersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMessagingUsersQuery, GetMessagingUsersQueryVariables>, 'query'> & ({ variables: GetMessagingUsersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMessagingUsersComponent = (props: GetMessagingUsersComponentProps) => (
      <ApolloReactComponents.Query<GetMessagingUsersQuery, GetMessagingUsersQueryVariables> query={GetMessagingUsersDocument} {...props} />
    );
    

/**
 * __useGetMessagingUsersQuery__
 *
 * To run a query within a React component, call `useGetMessagingUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagingUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagingUsersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetMessagingUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMessagingUsersQuery, GetMessagingUsersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMessagingUsersQuery, GetMessagingUsersQueryVariables>(GetMessagingUsersDocument, baseOptions);
      }
export function useGetMessagingUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMessagingUsersQuery, GetMessagingUsersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMessagingUsersQuery, GetMessagingUsersQueryVariables>(GetMessagingUsersDocument, baseOptions);
        }
export type GetMessagingUsersQueryHookResult = ReturnType<typeof useGetMessagingUsersQuery>;
export type GetMessagingUsersLazyQueryHookResult = ReturnType<typeof useGetMessagingUsersLazyQuery>;
export type GetMessagingUsersQueryResult = ApolloReactCommon.QueryResult<GetMessagingUsersQuery, GetMessagingUsersQueryVariables>;
export const ContentfulByVariationDocument = gql`
    query ContentfulByVariation($template: String!, $variation: String!, $space: String) {
  findContentByTemplate(template: $template, variation: $variation, space: $space) {
    entries {
      key
      value {
        ...ContentTypes
      }
    }
  }
}
    ${ContentTypesFragmentDoc}`;
export type ContentfulByVariationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ContentfulByVariationQuery, ContentfulByVariationQueryVariables>, 'query'> & ({ variables: ContentfulByVariationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ContentfulByVariationComponent = (props: ContentfulByVariationComponentProps) => (
      <ApolloReactComponents.Query<ContentfulByVariationQuery, ContentfulByVariationQueryVariables> query={ContentfulByVariationDocument} {...props} />
    );
    

/**
 * __useContentfulByVariationQuery__
 *
 * To run a query within a React component, call `useContentfulByVariationQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentfulByVariationQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentfulByVariationQuery({
 *   variables: {
 *      template: // value for 'template'
 *      variation: // value for 'variation'
 *      space: // value for 'space'
 *   },
 * });
 */
export function useContentfulByVariationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ContentfulByVariationQuery, ContentfulByVariationQueryVariables>) {
        return ApolloReactHooks.useQuery<ContentfulByVariationQuery, ContentfulByVariationQueryVariables>(ContentfulByVariationDocument, baseOptions);
      }
export function useContentfulByVariationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContentfulByVariationQuery, ContentfulByVariationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ContentfulByVariationQuery, ContentfulByVariationQueryVariables>(ContentfulByVariationDocument, baseOptions);
        }
export type ContentfulByVariationQueryHookResult = ReturnType<typeof useContentfulByVariationQuery>;
export type ContentfulByVariationLazyQueryHookResult = ReturnType<typeof useContentfulByVariationLazyQuery>;
export type ContentfulByVariationQueryResult = ApolloReactCommon.QueryResult<ContentfulByVariationQuery, ContentfulByVariationQueryVariables>;
export const MyselfDocument = gql`
    query Myself {
  me {
    ...Myself
  }
  session {
    ...Session
  }
}
    ${MyselfFragmentDoc}
${SessionFragmentDoc}`;
export type MyselfComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MyselfQuery, MyselfQueryVariables>, 'query'>;

    export const MyselfComponent = (props: MyselfComponentProps) => (
      <ApolloReactComponents.Query<MyselfQuery, MyselfQueryVariables> query={MyselfDocument} {...props} />
    );
    

/**
 * __useMyselfQuery__
 *
 * To run a query within a React component, call `useMyselfQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyselfQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyselfQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyselfQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyselfQuery, MyselfQueryVariables>) {
        return ApolloReactHooks.useQuery<MyselfQuery, MyselfQueryVariables>(MyselfDocument, baseOptions);
      }
export function useMyselfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyselfQuery, MyselfQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MyselfQuery, MyselfQueryVariables>(MyselfDocument, baseOptions);
        }
export type MyselfQueryHookResult = ReturnType<typeof useMyselfQuery>;
export type MyselfLazyQueryHookResult = ReturnType<typeof useMyselfLazyQuery>;
export type MyselfQueryResult = ApolloReactCommon.QueryResult<MyselfQuery, MyselfQueryVariables>;
export const LeadForChatWidgetDocument = gql`
    query LeadForChatWidget($leadId: LeadId!) {
  lead(id: $leadId) {
    id
    conversation {
      ...Conversation
    }
    expert {
      ...ChatWidgetExpert
    }
  }
}
    ${ConversationFragmentDoc}
${ChatWidgetExpertFragmentDoc}`;
export type LeadForChatWidgetComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LeadForChatWidgetQuery, LeadForChatWidgetQueryVariables>, 'query'> & ({ variables: LeadForChatWidgetQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LeadForChatWidgetComponent = (props: LeadForChatWidgetComponentProps) => (
      <ApolloReactComponents.Query<LeadForChatWidgetQuery, LeadForChatWidgetQueryVariables> query={LeadForChatWidgetDocument} {...props} />
    );
    

/**
 * __useLeadForChatWidgetQuery__
 *
 * To run a query within a React component, call `useLeadForChatWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadForChatWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadForChatWidgetQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useLeadForChatWidgetQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LeadForChatWidgetQuery, LeadForChatWidgetQueryVariables>) {
        return ApolloReactHooks.useQuery<LeadForChatWidgetQuery, LeadForChatWidgetQueryVariables>(LeadForChatWidgetDocument, baseOptions);
      }
export function useLeadForChatWidgetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LeadForChatWidgetQuery, LeadForChatWidgetQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LeadForChatWidgetQuery, LeadForChatWidgetQueryVariables>(LeadForChatWidgetDocument, baseOptions);
        }
export type LeadForChatWidgetQueryHookResult = ReturnType<typeof useLeadForChatWidgetQuery>;
export type LeadForChatWidgetLazyQueryHookResult = ReturnType<typeof useLeadForChatWidgetLazyQuery>;
export type LeadForChatWidgetQueryResult = ApolloReactCommon.QueryResult<LeadForChatWidgetQuery, LeadForChatWidgetQueryVariables>;
export const CreateBookingFlightPlanDocument = gql`
    mutation CreateBookingFlightPlan($input: CreateFlightPlanInput!) {
  createFlightPlan(input: $input) {
    flightPlan {
      id
    }
    hasError
    errorMessage
  }
}
    `;
export type CreateBookingFlightPlanMutationFn = ApolloReactCommon.MutationFunction<CreateBookingFlightPlanMutation, CreateBookingFlightPlanMutationVariables>;
export type CreateBookingFlightPlanComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateBookingFlightPlanMutation, CreateBookingFlightPlanMutationVariables>, 'mutation'>;

    export const CreateBookingFlightPlanComponent = (props: CreateBookingFlightPlanComponentProps) => (
      <ApolloReactComponents.Mutation<CreateBookingFlightPlanMutation, CreateBookingFlightPlanMutationVariables> mutation={CreateBookingFlightPlanDocument} {...props} />
    );
    

/**
 * __useCreateBookingFlightPlanMutation__
 *
 * To run a mutation, you first call `useCreateBookingFlightPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingFlightPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingFlightPlanMutation, { data, loading, error }] = useCreateBookingFlightPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookingFlightPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBookingFlightPlanMutation, CreateBookingFlightPlanMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBookingFlightPlanMutation, CreateBookingFlightPlanMutationVariables>(CreateBookingFlightPlanDocument, baseOptions);
      }
export type CreateBookingFlightPlanMutationHookResult = ReturnType<typeof useCreateBookingFlightPlanMutation>;
export type CreateBookingFlightPlanMutationResult = ApolloReactCommon.MutationResult<CreateBookingFlightPlanMutation>;
export type CreateBookingFlightPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBookingFlightPlanMutation, CreateBookingFlightPlanMutationVariables>;
export const StartExpertConsumerConversationDocument = gql`
    mutation StartExpertConsumerConversation($input: StartExpertConsumerConversationInput!) {
  startExpertConsumerConversation(input: $input) {
    error
    conversation {
      id
      externalId
      lead {
        id
      }
    }
  }
}
    `;
export type StartExpertConsumerConversationMutationFn = ApolloReactCommon.MutationFunction<StartExpertConsumerConversationMutation, StartExpertConsumerConversationMutationVariables>;
export type StartExpertConsumerConversationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<StartExpertConsumerConversationMutation, StartExpertConsumerConversationMutationVariables>, 'mutation'>;

    export const StartExpertConsumerConversationComponent = (props: StartExpertConsumerConversationComponentProps) => (
      <ApolloReactComponents.Mutation<StartExpertConsumerConversationMutation, StartExpertConsumerConversationMutationVariables> mutation={StartExpertConsumerConversationDocument} {...props} />
    );
    

/**
 * __useStartExpertConsumerConversationMutation__
 *
 * To run a mutation, you first call `useStartExpertConsumerConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartExpertConsumerConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startExpertConsumerConversationMutation, { data, loading, error }] = useStartExpertConsumerConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartExpertConsumerConversationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartExpertConsumerConversationMutation, StartExpertConsumerConversationMutationVariables>) {
        return ApolloReactHooks.useMutation<StartExpertConsumerConversationMutation, StartExpertConsumerConversationMutationVariables>(StartExpertConsumerConversationDocument, baseOptions);
      }
export type StartExpertConsumerConversationMutationHookResult = ReturnType<typeof useStartExpertConsumerConversationMutation>;
export type StartExpertConsumerConversationMutationResult = ApolloReactCommon.MutationResult<StartExpertConsumerConversationMutation>;
export type StartExpertConsumerConversationMutationOptions = ApolloReactCommon.BaseMutationOptions<StartExpertConsumerConversationMutation, StartExpertConsumerConversationMutationVariables>;
export const CategoryWithPathDocument = gql`
    query CategoryWithPath($categorySlug: String!) {
  categoryBySlug(slug: $categorySlug) {
    id
    ancestorWithPath {
      id
      slug
    }
  }
}
    `;
export type CategoryWithPathComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CategoryWithPathQuery, CategoryWithPathQueryVariables>, 'query'> & ({ variables: CategoryWithPathQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CategoryWithPathComponent = (props: CategoryWithPathComponentProps) => (
      <ApolloReactComponents.Query<CategoryWithPathQuery, CategoryWithPathQueryVariables> query={CategoryWithPathDocument} {...props} />
    );
    

/**
 * __useCategoryWithPathQuery__
 *
 * To run a query within a React component, call `useCategoryWithPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryWithPathQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryWithPathQuery({
 *   variables: {
 *      categorySlug: // value for 'categorySlug'
 *   },
 * });
 */
export function useCategoryWithPathQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CategoryWithPathQuery, CategoryWithPathQueryVariables>) {
        return ApolloReactHooks.useQuery<CategoryWithPathQuery, CategoryWithPathQueryVariables>(CategoryWithPathDocument, baseOptions);
      }
export function useCategoryWithPathLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CategoryWithPathQuery, CategoryWithPathQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CategoryWithPathQuery, CategoryWithPathQueryVariables>(CategoryWithPathDocument, baseOptions);
        }
export type CategoryWithPathQueryHookResult = ReturnType<typeof useCategoryWithPathQuery>;
export type CategoryWithPathLazyQueryHookResult = ReturnType<typeof useCategoryWithPathLazyQuery>;
export type CategoryWithPathQueryResult = ApolloReactCommon.QueryResult<CategoryWithPathQuery, CategoryWithPathQueryVariables>;
export const CountriesDocument = gql`
    query Countries($filter: CountryFilter!) {
  countries(filter: $filter) {
    ...Country
  }
}
    ${CountryFragmentDoc}`;
export type CountriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CountriesQuery, CountriesQueryVariables>, 'query'> & ({ variables: CountriesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CountriesComponent = (props: CountriesComponentProps) => (
      <ApolloReactComponents.Query<CountriesQuery, CountriesQueryVariables> query={CountriesDocument} {...props} />
    );
    

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        return ApolloReactHooks.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, baseOptions);
      }
export function useCountriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, baseOptions);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesQueryResult = ApolloReactCommon.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const GetSessionIdDocument = gql`
    query GetSessionId {
  session {
    id
    experimentUserId
  }
}
    `;
export type GetSessionIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSessionIdQuery, GetSessionIdQueryVariables>, 'query'>;

    export const GetSessionIdComponent = (props: GetSessionIdComponentProps) => (
      <ApolloReactComponents.Query<GetSessionIdQuery, GetSessionIdQueryVariables> query={GetSessionIdDocument} {...props} />
    );
    

/**
 * __useGetSessionIdQuery__
 *
 * To run a query within a React component, call `useGetSessionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSessionIdQuery, GetSessionIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSessionIdQuery, GetSessionIdQueryVariables>(GetSessionIdDocument, baseOptions);
      }
export function useGetSessionIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionIdQuery, GetSessionIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSessionIdQuery, GetSessionIdQueryVariables>(GetSessionIdDocument, baseOptions);
        }
export type GetSessionIdQueryHookResult = ReturnType<typeof useGetSessionIdQuery>;
export type GetSessionIdLazyQueryHookResult = ReturnType<typeof useGetSessionIdLazyQuery>;
export type GetSessionIdQueryResult = ApolloReactCommon.QueryResult<GetSessionIdQuery, GetSessionIdQueryVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  changePassword(input: {oldPassword: $oldPassword, newPassword: $newPassword}) {
    result
    message
  }
}
    `;
export type ChangePasswordMutationFn = ApolloReactCommon.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;
export type ChangePasswordComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ChangePasswordMutation, ChangePasswordMutationVariables>, 'mutation'>;

    export const ChangePasswordComponent = (props: ChangePasswordComponentProps) => (
      <ApolloReactComponents.Mutation<ChangePasswordMutation, ChangePasswordMutationVariables> mutation={ChangePasswordDocument} {...props} />
    );
    

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, baseOptions);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = ApolloReactCommon.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const CreatePasswordDocument = gql`
    mutation CreatePassword($password: String!) {
  createPassword(input: {password: $password}) {
    success
  }
}
    `;
export type CreatePasswordMutationFn = ApolloReactCommon.MutationFunction<CreatePasswordMutation, CreatePasswordMutationVariables>;
export type CreatePasswordComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreatePasswordMutation, CreatePasswordMutationVariables>, 'mutation'>;

    export const CreatePasswordComponent = (props: CreatePasswordComponentProps) => (
      <ApolloReactComponents.Mutation<CreatePasswordMutation, CreatePasswordMutationVariables> mutation={CreatePasswordDocument} {...props} />
    );
    

/**
 * __useCreatePasswordMutation__
 *
 * To run a mutation, you first call `useCreatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPasswordMutation, { data, loading, error }] = useCreatePasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreatePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePasswordMutation, CreatePasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePasswordMutation, CreatePasswordMutationVariables>(CreatePasswordDocument, baseOptions);
      }
export type CreatePasswordMutationHookResult = ReturnType<typeof useCreatePasswordMutation>;
export type CreatePasswordMutationResult = ApolloReactCommon.MutationResult<CreatePasswordMutation>;
export type CreatePasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePasswordMutation, CreatePasswordMutationVariables>;
export const MyOrdersConnectionDocument = gql`
    query MyOrdersConnection($query: OrderQuery!, $after: String) {
  ordersConnection(query: $query, after: $after, first: 50) {
    edges {
      node {
        ...MyOrderListItem
      }
    }
  }
}
    ${MyOrderListItemFragmentDoc}`;
export type MyOrdersConnectionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MyOrdersConnectionQuery, MyOrdersConnectionQueryVariables>, 'query'> & ({ variables: MyOrdersConnectionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MyOrdersConnectionComponent = (props: MyOrdersConnectionComponentProps) => (
      <ApolloReactComponents.Query<MyOrdersConnectionQuery, MyOrdersConnectionQueryVariables> query={MyOrdersConnectionDocument} {...props} />
    );
    

/**
 * __useMyOrdersConnectionQuery__
 *
 * To run a query within a React component, call `useMyOrdersConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOrdersConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOrdersConnectionQuery({
 *   variables: {
 *      query: // value for 'query'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMyOrdersConnectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyOrdersConnectionQuery, MyOrdersConnectionQueryVariables>) {
        return ApolloReactHooks.useQuery<MyOrdersConnectionQuery, MyOrdersConnectionQueryVariables>(MyOrdersConnectionDocument, baseOptions);
      }
export function useMyOrdersConnectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyOrdersConnectionQuery, MyOrdersConnectionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MyOrdersConnectionQuery, MyOrdersConnectionQueryVariables>(MyOrdersConnectionDocument, baseOptions);
        }
export type MyOrdersConnectionQueryHookResult = ReturnType<typeof useMyOrdersConnectionQuery>;
export type MyOrdersConnectionLazyQueryHookResult = ReturnType<typeof useMyOrdersConnectionLazyQuery>;
export type MyOrdersConnectionQueryResult = ApolloReactCommon.QueryResult<MyOrdersConnectionQuery, MyOrdersConnectionQueryVariables>;
export const EscalateOrderDocument = gql`
    mutation EscalateOrder($input: CreateOrderEscalationInput!) {
  createOrderEscalation(input: $input) {
    orderEscalation {
      ...OrderEscalation
    }
  }
}
    ${OrderEscalationFragmentDoc}`;
export type EscalateOrderMutationFn = ApolloReactCommon.MutationFunction<EscalateOrderMutation, EscalateOrderMutationVariables>;
export type EscalateOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<EscalateOrderMutation, EscalateOrderMutationVariables>, 'mutation'>;

    export const EscalateOrderComponent = (props: EscalateOrderComponentProps) => (
      <ApolloReactComponents.Mutation<EscalateOrderMutation, EscalateOrderMutationVariables> mutation={EscalateOrderDocument} {...props} />
    );
    

/**
 * __useEscalateOrderMutation__
 *
 * To run a mutation, you first call `useEscalateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEscalateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [escalateOrderMutation, { data, loading, error }] = useEscalateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEscalateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EscalateOrderMutation, EscalateOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<EscalateOrderMutation, EscalateOrderMutationVariables>(EscalateOrderDocument, baseOptions);
      }
export type EscalateOrderMutationHookResult = ReturnType<typeof useEscalateOrderMutation>;
export type EscalateOrderMutationResult = ApolloReactCommon.MutationResult<EscalateOrderMutation>;
export type EscalateOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<EscalateOrderMutation, EscalateOrderMutationVariables>;
export const StartSupportConversationDocument = gql`
    mutation StartSupportConversation($input: StartSupportConversationInput!) {
  startSupportConversation(input: $input) {
    supportConversation {
      ...SupportConversation
    }
  }
}
    ${SupportConversationFragmentDoc}`;
export type StartSupportConversationMutationFn = ApolloReactCommon.MutationFunction<StartSupportConversationMutation, StartSupportConversationMutationVariables>;
export type StartSupportConversationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<StartSupportConversationMutation, StartSupportConversationMutationVariables>, 'mutation'>;

    export const StartSupportConversationComponent = (props: StartSupportConversationComponentProps) => (
      <ApolloReactComponents.Mutation<StartSupportConversationMutation, StartSupportConversationMutationVariables> mutation={StartSupportConversationDocument} {...props} />
    );
    

/**
 * __useStartSupportConversationMutation__
 *
 * To run a mutation, you first call `useStartSupportConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSupportConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSupportConversationMutation, { data, loading, error }] = useStartSupportConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartSupportConversationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartSupportConversationMutation, StartSupportConversationMutationVariables>) {
        return ApolloReactHooks.useMutation<StartSupportConversationMutation, StartSupportConversationMutationVariables>(StartSupportConversationDocument, baseOptions);
      }
export type StartSupportConversationMutationHookResult = ReturnType<typeof useStartSupportConversationMutation>;
export type StartSupportConversationMutationResult = ApolloReactCommon.MutationResult<StartSupportConversationMutation>;
export type StartSupportConversationMutationOptions = ApolloReactCommon.BaseMutationOptions<StartSupportConversationMutation, StartSupportConversationMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
  updateUserProfile(input: $input) {
    errors
    user {
      id
      firstName
      lastName
      roles
      messagingUser {
        id
      }
      address {
        line1
        city
        state
        postalCode
        country
      }
      contacts {
        id
        type
        value
        verified
      }
    }
  }
}
    `;
export type UpdateUserProfileMutationFn = ApolloReactCommon.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export type UpdateUserProfileComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>, 'mutation'>;

    export const UpdateUserProfileComponent = (props: UpdateUserProfileComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables> mutation={UpdateUserProfileDocument} {...props} />
    );
    

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, baseOptions);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = ApolloReactCommon.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const UpdateNotificationChannelsDocument = gql`
    mutation UpdateNotificationChannels($input: UpdateNotificationChannelsInput!) {
  updateNotificationChannels(input: $input) {
    messagingUser {
      id
      notificationChannels
    }
  }
}
    `;
export type UpdateNotificationChannelsMutationFn = ApolloReactCommon.MutationFunction<UpdateNotificationChannelsMutation, UpdateNotificationChannelsMutationVariables>;
export type UpdateNotificationChannelsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateNotificationChannelsMutation, UpdateNotificationChannelsMutationVariables>, 'mutation'>;

    export const UpdateNotificationChannelsComponent = (props: UpdateNotificationChannelsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateNotificationChannelsMutation, UpdateNotificationChannelsMutationVariables> mutation={UpdateNotificationChannelsDocument} {...props} />
    );
    

/**
 * __useUpdateNotificationChannelsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationChannelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationChannelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationChannelsMutation, { data, loading, error }] = useUpdateNotificationChannelsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationChannelsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNotificationChannelsMutation, UpdateNotificationChannelsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateNotificationChannelsMutation, UpdateNotificationChannelsMutationVariables>(UpdateNotificationChannelsDocument, baseOptions);
      }
export type UpdateNotificationChannelsMutationHookResult = ReturnType<typeof useUpdateNotificationChannelsMutation>;
export type UpdateNotificationChannelsMutationResult = ApolloReactCommon.MutationResult<UpdateNotificationChannelsMutation>;
export type UpdateNotificationChannelsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNotificationChannelsMutation, UpdateNotificationChannelsMutationVariables>;
export const UpdatePreferredMessagingChannelsDocument = gql`
    mutation UpdatePreferredMessagingChannels($input: UpdatePreferredMessagingChannelsInput!) {
  updatePreferredMessagingChannels(input: $input) {
    messagingUser {
      id
      preferredMessagingChannels
    }
  }
}
    `;
export type UpdatePreferredMessagingChannelsMutationFn = ApolloReactCommon.MutationFunction<UpdatePreferredMessagingChannelsMutation, UpdatePreferredMessagingChannelsMutationVariables>;
export type UpdatePreferredMessagingChannelsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdatePreferredMessagingChannelsMutation, UpdatePreferredMessagingChannelsMutationVariables>, 'mutation'>;

    export const UpdatePreferredMessagingChannelsComponent = (props: UpdatePreferredMessagingChannelsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdatePreferredMessagingChannelsMutation, UpdatePreferredMessagingChannelsMutationVariables> mutation={UpdatePreferredMessagingChannelsDocument} {...props} />
    );
    

/**
 * __useUpdatePreferredMessagingChannelsMutation__
 *
 * To run a mutation, you first call `useUpdatePreferredMessagingChannelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreferredMessagingChannelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreferredMessagingChannelsMutation, { data, loading, error }] = useUpdatePreferredMessagingChannelsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePreferredMessagingChannelsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePreferredMessagingChannelsMutation, UpdatePreferredMessagingChannelsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePreferredMessagingChannelsMutation, UpdatePreferredMessagingChannelsMutationVariables>(UpdatePreferredMessagingChannelsDocument, baseOptions);
      }
export type UpdatePreferredMessagingChannelsMutationHookResult = ReturnType<typeof useUpdatePreferredMessagingChannelsMutation>;
export type UpdatePreferredMessagingChannelsMutationResult = ApolloReactCommon.MutationResult<UpdatePreferredMessagingChannelsMutation>;
export type UpdatePreferredMessagingChannelsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePreferredMessagingChannelsMutation, UpdatePreferredMessagingChannelsMutationVariables>;
export const CreateExpertFromApplicationDocument = gql`
    mutation CreateExpertFromApplication($applicationId: ExpertApplicationId!) {
  createExpertFromApplication(input: {applicationId: $applicationId}) {
    expert {
      id
    }
  }
}
    `;
export type CreateExpertFromApplicationMutationFn = ApolloReactCommon.MutationFunction<CreateExpertFromApplicationMutation, CreateExpertFromApplicationMutationVariables>;
export type CreateExpertFromApplicationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateExpertFromApplicationMutation, CreateExpertFromApplicationMutationVariables>, 'mutation'>;

    export const CreateExpertFromApplicationComponent = (props: CreateExpertFromApplicationComponentProps) => (
      <ApolloReactComponents.Mutation<CreateExpertFromApplicationMutation, CreateExpertFromApplicationMutationVariables> mutation={CreateExpertFromApplicationDocument} {...props} />
    );
    

/**
 * __useCreateExpertFromApplicationMutation__
 *
 * To run a mutation, you first call `useCreateExpertFromApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpertFromApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpertFromApplicationMutation, { data, loading, error }] = useCreateExpertFromApplicationMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useCreateExpertFromApplicationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateExpertFromApplicationMutation, CreateExpertFromApplicationMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateExpertFromApplicationMutation, CreateExpertFromApplicationMutationVariables>(CreateExpertFromApplicationDocument, baseOptions);
      }
export type CreateExpertFromApplicationMutationHookResult = ReturnType<typeof useCreateExpertFromApplicationMutation>;
export type CreateExpertFromApplicationMutationResult = ApolloReactCommon.MutationResult<CreateExpertFromApplicationMutation>;
export type CreateExpertFromApplicationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateExpertFromApplicationMutation, CreateExpertFromApplicationMutationVariables>;
export const CategorySellableSearchDocument = gql`
    query CategorySellableSearch($keywords: String, $categorySlug: String!, $facets: [FacetSelection!], $after: String, $maxFacetTerms: Int, $filters: [SellableSearchFilter!], $sortBy: SellableSort!, $order: SortOrder!) {
  searchSellables(query: {facets: $facets, keywords: $keywords, categorySlugs: [$categorySlug], maxFacetTerms: $maxFacetTerms, filters: $filters}, sortBy: $sortBy, order: $order, first: 36, after: $after) {
    count
    facets {
      ...DisplayFacet
    }
    edges {
      ...CategorySellableSearchResult
    }
    pageInfo {
      ...PageInfo
    }
  }
  categoryBySlug(slug: $categorySlug) {
    id
    pluralDisplayName
    type
    department {
      ...DepartmentContext
    }
    breadcrumbs: parents {
      ...CategoryBreadcrumb
    }
    ...CategoryFilterBreadcrumbs
  }
}
    ${DisplayFacetFragmentDoc}
${CategorySellableSearchResultFragmentDoc}
${PageInfoFragmentDoc}
${DepartmentContextFragmentDoc}
${CategoryBreadcrumbFragmentDoc}
${CategoryFilterBreadcrumbsFragmentDoc}`;
export type CategorySellableSearchComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CategorySellableSearchQuery, CategorySellableSearchQueryVariables>, 'query'> & ({ variables: CategorySellableSearchQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CategorySellableSearchComponent = (props: CategorySellableSearchComponentProps) => (
      <ApolloReactComponents.Query<CategorySellableSearchQuery, CategorySellableSearchQueryVariables> query={CategorySellableSearchDocument} {...props} />
    );
    

/**
 * __useCategorySellableSearchQuery__
 *
 * To run a query within a React component, call `useCategorySellableSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorySellableSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorySellableSearchQuery({
 *   variables: {
 *      keywords: // value for 'keywords'
 *      categorySlug: // value for 'categorySlug'
 *      facets: // value for 'facets'
 *      after: // value for 'after'
 *      maxFacetTerms: // value for 'maxFacetTerms'
 *      filters: // value for 'filters'
 *      sortBy: // value for 'sortBy'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCategorySellableSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CategorySellableSearchQuery, CategorySellableSearchQueryVariables>) {
        return ApolloReactHooks.useQuery<CategorySellableSearchQuery, CategorySellableSearchQueryVariables>(CategorySellableSearchDocument, baseOptions);
      }
export function useCategorySellableSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CategorySellableSearchQuery, CategorySellableSearchQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CategorySellableSearchQuery, CategorySellableSearchQueryVariables>(CategorySellableSearchDocument, baseOptions);
        }
export type CategorySellableSearchQueryHookResult = ReturnType<typeof useCategorySellableSearchQuery>;
export type CategorySellableSearchLazyQueryHookResult = ReturnType<typeof useCategorySellableSearchLazyQuery>;
export type CategorySellableSearchQueryResult = ApolloReactCommon.QueryResult<CategorySellableSearchQuery, CategorySellableSearchQueryVariables>;
export const CategoryAssetsForMetadataDocument = gql`
    query CategoryAssetsForMetadata($categoryId: CategoryId!) {
  category(categoryId: $categoryId) {
    id
    slug
    pluralDisplayName
    contentAssets {
      communityPoster {
        imageUrl
      }
    }
  }
}
    `;
export type CategoryAssetsForMetadataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CategoryAssetsForMetadataQuery, CategoryAssetsForMetadataQueryVariables>, 'query'> & ({ variables: CategoryAssetsForMetadataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CategoryAssetsForMetadataComponent = (props: CategoryAssetsForMetadataComponentProps) => (
      <ApolloReactComponents.Query<CategoryAssetsForMetadataQuery, CategoryAssetsForMetadataQueryVariables> query={CategoryAssetsForMetadataDocument} {...props} />
    );
    

/**
 * __useCategoryAssetsForMetadataQuery__
 *
 * To run a query within a React component, call `useCategoryAssetsForMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryAssetsForMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryAssetsForMetadataQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useCategoryAssetsForMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CategoryAssetsForMetadataQuery, CategoryAssetsForMetadataQueryVariables>) {
        return ApolloReactHooks.useQuery<CategoryAssetsForMetadataQuery, CategoryAssetsForMetadataQueryVariables>(CategoryAssetsForMetadataDocument, baseOptions);
      }
export function useCategoryAssetsForMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CategoryAssetsForMetadataQuery, CategoryAssetsForMetadataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CategoryAssetsForMetadataQuery, CategoryAssetsForMetadataQueryVariables>(CategoryAssetsForMetadataDocument, baseOptions);
        }
export type CategoryAssetsForMetadataQueryHookResult = ReturnType<typeof useCategoryAssetsForMetadataQuery>;
export type CategoryAssetsForMetadataLazyQueryHookResult = ReturnType<typeof useCategoryAssetsForMetadataLazyQuery>;
export type CategoryAssetsForMetadataQueryResult = ApolloReactCommon.QueryResult<CategoryAssetsForMetadataQuery, CategoryAssetsForMetadataQueryVariables>;
export const NoResultsDepartmentsDocument = gql`
    query NoResultsDepartments {
  departments {
    id
    slug
  }
}
    `;
export type NoResultsDepartmentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NoResultsDepartmentsQuery, NoResultsDepartmentsQueryVariables>, 'query'>;

    export const NoResultsDepartmentsComponent = (props: NoResultsDepartmentsComponentProps) => (
      <ApolloReactComponents.Query<NoResultsDepartmentsQuery, NoResultsDepartmentsQueryVariables> query={NoResultsDepartmentsDocument} {...props} />
    );
    

/**
 * __useNoResultsDepartmentsQuery__
 *
 * To run a query within a React component, call `useNoResultsDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoResultsDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoResultsDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNoResultsDepartmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NoResultsDepartmentsQuery, NoResultsDepartmentsQueryVariables>) {
        return ApolloReactHooks.useQuery<NoResultsDepartmentsQuery, NoResultsDepartmentsQueryVariables>(NoResultsDepartmentsDocument, baseOptions);
      }
export function useNoResultsDepartmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NoResultsDepartmentsQuery, NoResultsDepartmentsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<NoResultsDepartmentsQuery, NoResultsDepartmentsQueryVariables>(NoResultsDepartmentsDocument, baseOptions);
        }
export type NoResultsDepartmentsQueryHookResult = ReturnType<typeof useNoResultsDepartmentsQuery>;
export type NoResultsDepartmentsLazyQueryHookResult = ReturnType<typeof useNoResultsDepartmentsLazyQuery>;
export type NoResultsDepartmentsQueryResult = ApolloReactCommon.QueryResult<NoResultsDepartmentsQuery, NoResultsDepartmentsQueryVariables>;
export const LeadForCurationsDocument = gql`
    query LeadForCurations($id: LeadId!) {
  lead(id: $id) {
    ...LeadForCurations
  }
}
    ${LeadForCurationsFragmentDoc}`;
export type LeadForCurationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LeadForCurationsQuery, LeadForCurationsQueryVariables>, 'query'> & ({ variables: LeadForCurationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LeadForCurationsComponent = (props: LeadForCurationsComponentProps) => (
      <ApolloReactComponents.Query<LeadForCurationsQuery, LeadForCurationsQueryVariables> query={LeadForCurationsDocument} {...props} />
    );
    

/**
 * __useLeadForCurationsQuery__
 *
 * To run a query within a React component, call `useLeadForCurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadForCurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadForCurationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeadForCurationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LeadForCurationsQuery, LeadForCurationsQueryVariables>) {
        return ApolloReactHooks.useQuery<LeadForCurationsQuery, LeadForCurationsQueryVariables>(LeadForCurationsDocument, baseOptions);
      }
export function useLeadForCurationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LeadForCurationsQuery, LeadForCurationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LeadForCurationsQuery, LeadForCurationsQueryVariables>(LeadForCurationsDocument, baseOptions);
        }
export type LeadForCurationsQueryHookResult = ReturnType<typeof useLeadForCurationsQuery>;
export type LeadForCurationsLazyQueryHookResult = ReturnType<typeof useLeadForCurationsLazyQuery>;
export type LeadForCurationsQueryResult = ApolloReactCommon.QueryResult<LeadForCurationsQuery, LeadForCurationsQueryVariables>;
export const CustomerRequestExpertCuratedOrderDocument = gql`
    mutation CustomerRequestExpertCuratedOrder($id: ExpertCuratedOrderId!) {
  customerRequestExpertCuratedOrder(input: {id: $id}) {
    expertCuratedOrder {
      id
    }
  }
}
    `;
export type CustomerRequestExpertCuratedOrderMutationFn = ApolloReactCommon.MutationFunction<CustomerRequestExpertCuratedOrderMutation, CustomerRequestExpertCuratedOrderMutationVariables>;
export type CustomerRequestExpertCuratedOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CustomerRequestExpertCuratedOrderMutation, CustomerRequestExpertCuratedOrderMutationVariables>, 'mutation'>;

    export const CustomerRequestExpertCuratedOrderComponent = (props: CustomerRequestExpertCuratedOrderComponentProps) => (
      <ApolloReactComponents.Mutation<CustomerRequestExpertCuratedOrderMutation, CustomerRequestExpertCuratedOrderMutationVariables> mutation={CustomerRequestExpertCuratedOrderDocument} {...props} />
    );
    

/**
 * __useCustomerRequestExpertCuratedOrderMutation__
 *
 * To run a mutation, you first call `useCustomerRequestExpertCuratedOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerRequestExpertCuratedOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerRequestExpertCuratedOrderMutation, { data, loading, error }] = useCustomerRequestExpertCuratedOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerRequestExpertCuratedOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CustomerRequestExpertCuratedOrderMutation, CustomerRequestExpertCuratedOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<CustomerRequestExpertCuratedOrderMutation, CustomerRequestExpertCuratedOrderMutationVariables>(CustomerRequestExpertCuratedOrderDocument, baseOptions);
      }
export type CustomerRequestExpertCuratedOrderMutationHookResult = ReturnType<typeof useCustomerRequestExpertCuratedOrderMutation>;
export type CustomerRequestExpertCuratedOrderMutationResult = ApolloReactCommon.MutationResult<CustomerRequestExpertCuratedOrderMutation>;
export type CustomerRequestExpertCuratedOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<CustomerRequestExpertCuratedOrderMutation, CustomerRequestExpertCuratedOrderMutationVariables>;
export const ExpertCuratedLeadItineraryDocument = gql`
    query ExpertCuratedLeadItinerary($leadId: LeadId!) {
  expertCuratedLeadItinerary(leadId: $leadId) {
    id
    contentfulVariation
  }
}
    `;
export type ExpertCuratedLeadItineraryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertCuratedLeadItineraryQuery, ExpertCuratedLeadItineraryQueryVariables>, 'query'> & ({ variables: ExpertCuratedLeadItineraryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertCuratedLeadItineraryComponent = (props: ExpertCuratedLeadItineraryComponentProps) => (
      <ApolloReactComponents.Query<ExpertCuratedLeadItineraryQuery, ExpertCuratedLeadItineraryQueryVariables> query={ExpertCuratedLeadItineraryDocument} {...props} />
    );
    

/**
 * __useExpertCuratedLeadItineraryQuery__
 *
 * To run a query within a React component, call `useExpertCuratedLeadItineraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertCuratedLeadItineraryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertCuratedLeadItineraryQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useExpertCuratedLeadItineraryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertCuratedLeadItineraryQuery, ExpertCuratedLeadItineraryQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertCuratedLeadItineraryQuery, ExpertCuratedLeadItineraryQueryVariables>(ExpertCuratedLeadItineraryDocument, baseOptions);
      }
export function useExpertCuratedLeadItineraryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertCuratedLeadItineraryQuery, ExpertCuratedLeadItineraryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertCuratedLeadItineraryQuery, ExpertCuratedLeadItineraryQueryVariables>(ExpertCuratedLeadItineraryDocument, baseOptions);
        }
export type ExpertCuratedLeadItineraryQueryHookResult = ReturnType<typeof useExpertCuratedLeadItineraryQuery>;
export type ExpertCuratedLeadItineraryLazyQueryHookResult = ReturnType<typeof useExpertCuratedLeadItineraryLazyQuery>;
export type ExpertCuratedLeadItineraryQueryResult = ApolloReactCommon.QueryResult<ExpertCuratedLeadItineraryQuery, ExpertCuratedLeadItineraryQueryVariables>;
export const ExpertCuratedOrdersForLeadConnectionDocument = gql`
    query ExpertCuratedOrdersForLeadConnection($query: ExpertCuratedOrdersForLeadQueryInput!, $after: String, $first: Int, $before: String, $last: Int) {
  expertCuratedOrdersForLeadConnection(query: $query, after: $after, first: $first, before: $before, last: $last) {
    edges {
      node {
        ...ExpertCuratedOrder
      }
    }
  }
}
    ${ExpertCuratedOrderFragmentDoc}`;
export type ExpertCuratedOrdersForLeadConnectionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertCuratedOrdersForLeadConnectionQuery, ExpertCuratedOrdersForLeadConnectionQueryVariables>, 'query'> & ({ variables: ExpertCuratedOrdersForLeadConnectionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertCuratedOrdersForLeadConnectionComponent = (props: ExpertCuratedOrdersForLeadConnectionComponentProps) => (
      <ApolloReactComponents.Query<ExpertCuratedOrdersForLeadConnectionQuery, ExpertCuratedOrdersForLeadConnectionQueryVariables> query={ExpertCuratedOrdersForLeadConnectionDocument} {...props} />
    );
    

/**
 * __useExpertCuratedOrdersForLeadConnectionQuery__
 *
 * To run a query within a React component, call `useExpertCuratedOrdersForLeadConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertCuratedOrdersForLeadConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertCuratedOrdersForLeadConnectionQuery({
 *   variables: {
 *      query: // value for 'query'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useExpertCuratedOrdersForLeadConnectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertCuratedOrdersForLeadConnectionQuery, ExpertCuratedOrdersForLeadConnectionQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertCuratedOrdersForLeadConnectionQuery, ExpertCuratedOrdersForLeadConnectionQueryVariables>(ExpertCuratedOrdersForLeadConnectionDocument, baseOptions);
      }
export function useExpertCuratedOrdersForLeadConnectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertCuratedOrdersForLeadConnectionQuery, ExpertCuratedOrdersForLeadConnectionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertCuratedOrdersForLeadConnectionQuery, ExpertCuratedOrdersForLeadConnectionQueryVariables>(ExpertCuratedOrdersForLeadConnectionDocument, baseOptions);
        }
export type ExpertCuratedOrdersForLeadConnectionQueryHookResult = ReturnType<typeof useExpertCuratedOrdersForLeadConnectionQuery>;
export type ExpertCuratedOrdersForLeadConnectionLazyQueryHookResult = ReturnType<typeof useExpertCuratedOrdersForLeadConnectionLazyQuery>;
export type ExpertCuratedOrdersForLeadConnectionQueryResult = ApolloReactCommon.QueryResult<ExpertCuratedOrdersForLeadConnectionQuery, ExpertCuratedOrdersForLeadConnectionQueryVariables>;
export const ExpertCuratedOrdersForLeadConnectionChangedDocument = gql`
    subscription ExpertCuratedOrdersForLeadConnectionChanged($query: ExpertCuratedOrdersForLeadQueryInput!) {
  expertCuratedOrdersForLeadConnectionChanged(query: $query) {
    connection {
      edges {
        node {
          ...ExpertCuratedOrder
        }
      }
    }
  }
}
    ${ExpertCuratedOrderFragmentDoc}`;
export type ExpertCuratedOrdersForLeadConnectionChangedComponentProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<ExpertCuratedOrdersForLeadConnectionChangedSubscription, ExpertCuratedOrdersForLeadConnectionChangedSubscriptionVariables>, 'subscription'>;

    export const ExpertCuratedOrdersForLeadConnectionChangedComponent = (props: ExpertCuratedOrdersForLeadConnectionChangedComponentProps) => (
      <ApolloReactComponents.Subscription<ExpertCuratedOrdersForLeadConnectionChangedSubscription, ExpertCuratedOrdersForLeadConnectionChangedSubscriptionVariables> subscription={ExpertCuratedOrdersForLeadConnectionChangedDocument} {...props} />
    );
    

/**
 * __useExpertCuratedOrdersForLeadConnectionChangedSubscription__
 *
 * To run a query within a React component, call `useExpertCuratedOrdersForLeadConnectionChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExpertCuratedOrdersForLeadConnectionChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertCuratedOrdersForLeadConnectionChangedSubscription({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useExpertCuratedOrdersForLeadConnectionChangedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<ExpertCuratedOrdersForLeadConnectionChangedSubscription, ExpertCuratedOrdersForLeadConnectionChangedSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<ExpertCuratedOrdersForLeadConnectionChangedSubscription, ExpertCuratedOrdersForLeadConnectionChangedSubscriptionVariables>(ExpertCuratedOrdersForLeadConnectionChangedDocument, baseOptions);
      }
export type ExpertCuratedOrdersForLeadConnectionChangedSubscriptionHookResult = ReturnType<typeof useExpertCuratedOrdersForLeadConnectionChangedSubscription>;
export type ExpertCuratedOrdersForLeadConnectionChangedSubscriptionResult = ApolloReactCommon.SubscriptionResult<ExpertCuratedOrdersForLeadConnectionChangedSubscription>;
export const GetUserJourneyDocument = gql`
    query GetUserJourney($userId: UserId!) {
  user(userId: $userId) {
    id
    userJourneyStages {
      ... on UserJourneyNewStage {
        type
      }
      ... on UserJourneyLeadStage {
        type
        leadStageStatus
        lead {
          id
          department {
            id
            slug
          }
          category {
            id
            slug
            contentAssets {
              bannerImages {
                imageUrl
              }
            }
          }
        }
      }
      ... on UserJourneyOrderStage {
        type
        order {
          id
        }
      }
    }
  }
}
    `;
export type GetUserJourneyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserJourneyQuery, GetUserJourneyQueryVariables>, 'query'> & ({ variables: GetUserJourneyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetUserJourneyComponent = (props: GetUserJourneyComponentProps) => (
      <ApolloReactComponents.Query<GetUserJourneyQuery, GetUserJourneyQueryVariables> query={GetUserJourneyDocument} {...props} />
    );
    

/**
 * __useGetUserJourneyQuery__
 *
 * To run a query within a React component, call `useGetUserJourneyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserJourneyQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserJourneyQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserJourneyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserJourneyQuery, GetUserJourneyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserJourneyQuery, GetUserJourneyQueryVariables>(GetUserJourneyDocument, baseOptions);
      }
export function useGetUserJourneyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserJourneyQuery, GetUserJourneyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserJourneyQuery, GetUserJourneyQueryVariables>(GetUserJourneyDocument, baseOptions);
        }
export type GetUserJourneyQueryHookResult = ReturnType<typeof useGetUserJourneyQuery>;
export type GetUserJourneyLazyQueryHookResult = ReturnType<typeof useGetUserJourneyLazyQuery>;
export type GetUserJourneyQueryResult = ApolloReactCommon.QueryResult<GetUserJourneyQuery, GetUserJourneyQueryVariables>;
export const GetCurationCardInfoDocument = gql`
    query GetCurationCardInfo($leadId: LeadId!) {
  expertCuratedItemsForLead(leadId: $leadId) {
    ...CurationCardInfo
  }
  lead(id: $leadId) {
    ...CurationCardLeadInfo
  }
}
    ${CurationCardInfoFragmentDoc}
${CurationCardLeadInfoFragmentDoc}`;
export type GetCurationCardInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCurationCardInfoQuery, GetCurationCardInfoQueryVariables>, 'query'> & ({ variables: GetCurationCardInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetCurationCardInfoComponent = (props: GetCurationCardInfoComponentProps) => (
      <ApolloReactComponents.Query<GetCurationCardInfoQuery, GetCurationCardInfoQueryVariables> query={GetCurationCardInfoDocument} {...props} />
    );
    

/**
 * __useGetCurationCardInfoQuery__
 *
 * To run a query within a React component, call `useGetCurationCardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurationCardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurationCardInfoQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useGetCurationCardInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurationCardInfoQuery, GetCurationCardInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCurationCardInfoQuery, GetCurationCardInfoQueryVariables>(GetCurationCardInfoDocument, baseOptions);
      }
export function useGetCurationCardInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurationCardInfoQuery, GetCurationCardInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCurationCardInfoQuery, GetCurationCardInfoQueryVariables>(GetCurationCardInfoDocument, baseOptions);
        }
export type GetCurationCardInfoQueryHookResult = ReturnType<typeof useGetCurationCardInfoQuery>;
export type GetCurationCardInfoLazyQueryHookResult = ReturnType<typeof useGetCurationCardInfoLazyQuery>;
export type GetCurationCardInfoQueryResult = ApolloReactCommon.QueryResult<GetCurationCardInfoQuery, GetCurationCardInfoQueryVariables>;
export const GetDepartmentBannerDocument = gql`
    query GetDepartmentBanner($departmentSlug: String!) {
  departmentBySlug(slug: $departmentSlug) {
    id
    topLevelCategory {
      id
      contentAssets {
        bannerImages {
          imageUrl
        }
      }
    }
  }
}
    `;
export type GetDepartmentBannerComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDepartmentBannerQuery, GetDepartmentBannerQueryVariables>, 'query'> & ({ variables: GetDepartmentBannerQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetDepartmentBannerComponent = (props: GetDepartmentBannerComponentProps) => (
      <ApolloReactComponents.Query<GetDepartmentBannerQuery, GetDepartmentBannerQueryVariables> query={GetDepartmentBannerDocument} {...props} />
    );
    

/**
 * __useGetDepartmentBannerQuery__
 *
 * To run a query within a React component, call `useGetDepartmentBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentBannerQuery({
 *   variables: {
 *      departmentSlug: // value for 'departmentSlug'
 *   },
 * });
 */
export function useGetDepartmentBannerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDepartmentBannerQuery, GetDepartmentBannerQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDepartmentBannerQuery, GetDepartmentBannerQueryVariables>(GetDepartmentBannerDocument, baseOptions);
      }
export function useGetDepartmentBannerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDepartmentBannerQuery, GetDepartmentBannerQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDepartmentBannerQuery, GetDepartmentBannerQueryVariables>(GetDepartmentBannerDocument, baseOptions);
        }
export type GetDepartmentBannerQueryHookResult = ReturnType<typeof useGetDepartmentBannerQuery>;
export type GetDepartmentBannerLazyQueryHookResult = ReturnType<typeof useGetDepartmentBannerLazyQuery>;
export type GetDepartmentBannerQueryResult = ApolloReactCommon.QueryResult<GetDepartmentBannerQuery, GetDepartmentBannerQueryVariables>;
export const GetRecommendationsByDepartmentDocument = gql`
    query GetRecommendationsByDepartment($departmentSlug: String!) {
  recommendedLists(first: 3, query: {departmentSlug: $departmentSlug, types: [MY_TOP_LIST, STRICT_MY_TOP_LIST, PRICE_AND_PRIMARY_ATTRIBUTES, BRAND_AND_PRIMARY_ATTRIBUTES, ACCESSORIES, CURATED_LIST_TO_SIMILAR_USERS, PRICE_SENSITIVE_INTENT_BASED_DIGEST, CUSTOM]}) {
    edges {
      node {
        ...RecommendedList
      }
    }
  }
}
    ${RecommendedListFragmentDoc}`;
export type GetRecommendationsByDepartmentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRecommendationsByDepartmentQuery, GetRecommendationsByDepartmentQueryVariables>, 'query'> & ({ variables: GetRecommendationsByDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetRecommendationsByDepartmentComponent = (props: GetRecommendationsByDepartmentComponentProps) => (
      <ApolloReactComponents.Query<GetRecommendationsByDepartmentQuery, GetRecommendationsByDepartmentQueryVariables> query={GetRecommendationsByDepartmentDocument} {...props} />
    );
    

/**
 * __useGetRecommendationsByDepartmentQuery__
 *
 * To run a query within a React component, call `useGetRecommendationsByDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendationsByDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendationsByDepartmentQuery({
 *   variables: {
 *      departmentSlug: // value for 'departmentSlug'
 *   },
 * });
 */
export function useGetRecommendationsByDepartmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecommendationsByDepartmentQuery, GetRecommendationsByDepartmentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRecommendationsByDepartmentQuery, GetRecommendationsByDepartmentQueryVariables>(GetRecommendationsByDepartmentDocument, baseOptions);
      }
export function useGetRecommendationsByDepartmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecommendationsByDepartmentQuery, GetRecommendationsByDepartmentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRecommendationsByDepartmentQuery, GetRecommendationsByDepartmentQueryVariables>(GetRecommendationsByDepartmentDocument, baseOptions);
        }
export type GetRecommendationsByDepartmentQueryHookResult = ReturnType<typeof useGetRecommendationsByDepartmentQuery>;
export type GetRecommendationsByDepartmentLazyQueryHookResult = ReturnType<typeof useGetRecommendationsByDepartmentLazyQuery>;
export type GetRecommendationsByDepartmentQueryResult = ApolloReactCommon.QueryResult<GetRecommendationsByDepartmentQuery, GetRecommendationsByDepartmentQueryVariables>;
export const AddExpertCuratedItemToCartDocument = gql`
    mutation AddExpertCuratedItemToCart($id: ExpertCuratedItemId!) {
  addExpertCuratedItemToCart(input: {id: $id}) {
    expertCuratedItem {
      id
      lineItemInCart {
        id
      }
    }
    order {
      ...ShoppingCartOrder
    }
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type AddExpertCuratedItemToCartMutationFn = ApolloReactCommon.MutationFunction<AddExpertCuratedItemToCartMutation, AddExpertCuratedItemToCartMutationVariables>;
export type AddExpertCuratedItemToCartComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddExpertCuratedItemToCartMutation, AddExpertCuratedItemToCartMutationVariables>, 'mutation'>;

    export const AddExpertCuratedItemToCartComponent = (props: AddExpertCuratedItemToCartComponentProps) => (
      <ApolloReactComponents.Mutation<AddExpertCuratedItemToCartMutation, AddExpertCuratedItemToCartMutationVariables> mutation={AddExpertCuratedItemToCartDocument} {...props} />
    );
    

/**
 * __useAddExpertCuratedItemToCartMutation__
 *
 * To run a mutation, you first call `useAddExpertCuratedItemToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExpertCuratedItemToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExpertCuratedItemToCartMutation, { data, loading, error }] = useAddExpertCuratedItemToCartMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddExpertCuratedItemToCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddExpertCuratedItemToCartMutation, AddExpertCuratedItemToCartMutationVariables>) {
        return ApolloReactHooks.useMutation<AddExpertCuratedItemToCartMutation, AddExpertCuratedItemToCartMutationVariables>(AddExpertCuratedItemToCartDocument, baseOptions);
      }
export type AddExpertCuratedItemToCartMutationHookResult = ReturnType<typeof useAddExpertCuratedItemToCartMutation>;
export type AddExpertCuratedItemToCartMutationResult = ApolloReactCommon.MutationResult<AddExpertCuratedItemToCartMutation>;
export type AddExpertCuratedItemToCartMutationOptions = ApolloReactCommon.BaseMutationOptions<AddExpertCuratedItemToCartMutation, AddExpertCuratedItemToCartMutationVariables>;
export const RemoveExpertCuratedItemsFromCartDocument = gql`
    mutation RemoveExpertCuratedItemsFromCart($id: OrderLineItemId!) {
  removeItemsFromOrder(input: {lineItemIds: [$id]}) {
    order {
      ...ShoppingCartOrder
    }
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type RemoveExpertCuratedItemsFromCartMutationFn = ApolloReactCommon.MutationFunction<RemoveExpertCuratedItemsFromCartMutation, RemoveExpertCuratedItemsFromCartMutationVariables>;
export type RemoveExpertCuratedItemsFromCartComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveExpertCuratedItemsFromCartMutation, RemoveExpertCuratedItemsFromCartMutationVariables>, 'mutation'>;

    export const RemoveExpertCuratedItemsFromCartComponent = (props: RemoveExpertCuratedItemsFromCartComponentProps) => (
      <ApolloReactComponents.Mutation<RemoveExpertCuratedItemsFromCartMutation, RemoveExpertCuratedItemsFromCartMutationVariables> mutation={RemoveExpertCuratedItemsFromCartDocument} {...props} />
    );
    

/**
 * __useRemoveExpertCuratedItemsFromCartMutation__
 *
 * To run a mutation, you first call `useRemoveExpertCuratedItemsFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExpertCuratedItemsFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExpertCuratedItemsFromCartMutation, { data, loading, error }] = useRemoveExpertCuratedItemsFromCartMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveExpertCuratedItemsFromCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveExpertCuratedItemsFromCartMutation, RemoveExpertCuratedItemsFromCartMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveExpertCuratedItemsFromCartMutation, RemoveExpertCuratedItemsFromCartMutationVariables>(RemoveExpertCuratedItemsFromCartDocument, baseOptions);
      }
export type RemoveExpertCuratedItemsFromCartMutationHookResult = ReturnType<typeof useRemoveExpertCuratedItemsFromCartMutation>;
export type RemoveExpertCuratedItemsFromCartMutationResult = ApolloReactCommon.MutationResult<RemoveExpertCuratedItemsFromCartMutation>;
export type RemoveExpertCuratedItemsFromCartMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveExpertCuratedItemsFromCartMutation, RemoveExpertCuratedItemsFromCartMutationVariables>;
export const ReportPredictedLifeTimeValueToPlatformDocument = gql`
    mutation ReportPredictedLifeTimeValueToPlatform($input: ReportPredictedLifeTimeValueInput!) {
  reportPredictedLifeTimeValueToPlatform(input: $input) {
    predictedLifeTimeValues {
      id
      userId
      ltvType
      pLTV {
        amount
        currency
      }
    }
  }
}
    `;
export type ReportPredictedLifeTimeValueToPlatformMutationFn = ApolloReactCommon.MutationFunction<ReportPredictedLifeTimeValueToPlatformMutation, ReportPredictedLifeTimeValueToPlatformMutationVariables>;
export type ReportPredictedLifeTimeValueToPlatformComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ReportPredictedLifeTimeValueToPlatformMutation, ReportPredictedLifeTimeValueToPlatformMutationVariables>, 'mutation'>;

    export const ReportPredictedLifeTimeValueToPlatformComponent = (props: ReportPredictedLifeTimeValueToPlatformComponentProps) => (
      <ApolloReactComponents.Mutation<ReportPredictedLifeTimeValueToPlatformMutation, ReportPredictedLifeTimeValueToPlatformMutationVariables> mutation={ReportPredictedLifeTimeValueToPlatformDocument} {...props} />
    );
    

/**
 * __useReportPredictedLifeTimeValueToPlatformMutation__
 *
 * To run a mutation, you first call `useReportPredictedLifeTimeValueToPlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportPredictedLifeTimeValueToPlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportPredictedLifeTimeValueToPlatformMutation, { data, loading, error }] = useReportPredictedLifeTimeValueToPlatformMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportPredictedLifeTimeValueToPlatformMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReportPredictedLifeTimeValueToPlatformMutation, ReportPredictedLifeTimeValueToPlatformMutationVariables>) {
        return ApolloReactHooks.useMutation<ReportPredictedLifeTimeValueToPlatformMutation, ReportPredictedLifeTimeValueToPlatformMutationVariables>(ReportPredictedLifeTimeValueToPlatformDocument, baseOptions);
      }
export type ReportPredictedLifeTimeValueToPlatformMutationHookResult = ReturnType<typeof useReportPredictedLifeTimeValueToPlatformMutation>;
export type ReportPredictedLifeTimeValueToPlatformMutationResult = ApolloReactCommon.MutationResult<ReportPredictedLifeTimeValueToPlatformMutation>;
export type ReportPredictedLifeTimeValueToPlatformMutationOptions = ApolloReactCommon.BaseMutationOptions<ReportPredictedLifeTimeValueToPlatformMutation, ReportPredictedLifeTimeValueToPlatformMutationVariables>;
export const SelectExpertCuratedOrderVariationOptionDocument = gql`
    mutation SelectExpertCuratedOrderVariationOption($input: SelectExpertCuratedOrderVariationOptionInput!) {
  selectExpertCuratedOrderVariationOption(input: $input) {
    expertCuratedOrder {
      ...ExpertCuratedOrder
    }
  }
}
    ${ExpertCuratedOrderFragmentDoc}`;
export type SelectExpertCuratedOrderVariationOptionMutationFn = ApolloReactCommon.MutationFunction<SelectExpertCuratedOrderVariationOptionMutation, SelectExpertCuratedOrderVariationOptionMutationVariables>;
export type SelectExpertCuratedOrderVariationOptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SelectExpertCuratedOrderVariationOptionMutation, SelectExpertCuratedOrderVariationOptionMutationVariables>, 'mutation'>;

    export const SelectExpertCuratedOrderVariationOptionComponent = (props: SelectExpertCuratedOrderVariationOptionComponentProps) => (
      <ApolloReactComponents.Mutation<SelectExpertCuratedOrderVariationOptionMutation, SelectExpertCuratedOrderVariationOptionMutationVariables> mutation={SelectExpertCuratedOrderVariationOptionDocument} {...props} />
    );
    

/**
 * __useSelectExpertCuratedOrderVariationOptionMutation__
 *
 * To run a mutation, you first call `useSelectExpertCuratedOrderVariationOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectExpertCuratedOrderVariationOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectExpertCuratedOrderVariationOptionMutation, { data, loading, error }] = useSelectExpertCuratedOrderVariationOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelectExpertCuratedOrderVariationOptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SelectExpertCuratedOrderVariationOptionMutation, SelectExpertCuratedOrderVariationOptionMutationVariables>) {
        return ApolloReactHooks.useMutation<SelectExpertCuratedOrderVariationOptionMutation, SelectExpertCuratedOrderVariationOptionMutationVariables>(SelectExpertCuratedOrderVariationOptionDocument, baseOptions);
      }
export type SelectExpertCuratedOrderVariationOptionMutationHookResult = ReturnType<typeof useSelectExpertCuratedOrderVariationOptionMutation>;
export type SelectExpertCuratedOrderVariationOptionMutationResult = ApolloReactCommon.MutationResult<SelectExpertCuratedOrderVariationOptionMutation>;
export type SelectExpertCuratedOrderVariationOptionMutationOptions = ApolloReactCommon.BaseMutationOptions<SelectExpertCuratedOrderVariationOptionMutation, SelectExpertCuratedOrderVariationOptionMutationVariables>;
export const ExpertCuratedItemsForLeadDocument = gql`
    query ExpertCuratedItemsForLead($leadId: LeadId!) {
  expertCuratedItemsForLead(leadId: $leadId) {
    id
    items {
      ...ExpertCuratedItem
    }
  }
}
    ${ExpertCuratedItemFragmentDoc}`;
export type ExpertCuratedItemsForLeadComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertCuratedItemsForLeadQuery, ExpertCuratedItemsForLeadQueryVariables>, 'query'> & ({ variables: ExpertCuratedItemsForLeadQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertCuratedItemsForLeadComponent = (props: ExpertCuratedItemsForLeadComponentProps) => (
      <ApolloReactComponents.Query<ExpertCuratedItemsForLeadQuery, ExpertCuratedItemsForLeadQueryVariables> query={ExpertCuratedItemsForLeadDocument} {...props} />
    );
    

/**
 * __useExpertCuratedItemsForLeadQuery__
 *
 * To run a query within a React component, call `useExpertCuratedItemsForLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertCuratedItemsForLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertCuratedItemsForLeadQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useExpertCuratedItemsForLeadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertCuratedItemsForLeadQuery, ExpertCuratedItemsForLeadQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertCuratedItemsForLeadQuery, ExpertCuratedItemsForLeadQueryVariables>(ExpertCuratedItemsForLeadDocument, baseOptions);
      }
export function useExpertCuratedItemsForLeadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertCuratedItemsForLeadQuery, ExpertCuratedItemsForLeadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertCuratedItemsForLeadQuery, ExpertCuratedItemsForLeadQueryVariables>(ExpertCuratedItemsForLeadDocument, baseOptions);
        }
export type ExpertCuratedItemsForLeadQueryHookResult = ReturnType<typeof useExpertCuratedItemsForLeadQuery>;
export type ExpertCuratedItemsForLeadLazyQueryHookResult = ReturnType<typeof useExpertCuratedItemsForLeadLazyQuery>;
export type ExpertCuratedItemsForLeadQueryResult = ApolloReactCommon.QueryResult<ExpertCuratedItemsForLeadQuery, ExpertCuratedItemsForLeadQueryVariables>;
export const ExpertCuratedItemsForLeadChangedDocument = gql`
    subscription ExpertCuratedItemsForLeadChanged($leadId: LeadId!) {
  expertCuratedItemsChanged(leadId: $leadId) {
    leadId
  }
}
    `;
export type ExpertCuratedItemsForLeadChangedComponentProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<ExpertCuratedItemsForLeadChangedSubscription, ExpertCuratedItemsForLeadChangedSubscriptionVariables>, 'subscription'>;

    export const ExpertCuratedItemsForLeadChangedComponent = (props: ExpertCuratedItemsForLeadChangedComponentProps) => (
      <ApolloReactComponents.Subscription<ExpertCuratedItemsForLeadChangedSubscription, ExpertCuratedItemsForLeadChangedSubscriptionVariables> subscription={ExpertCuratedItemsForLeadChangedDocument} {...props} />
    );
    

/**
 * __useExpertCuratedItemsForLeadChangedSubscription__
 *
 * To run a query within a React component, call `useExpertCuratedItemsForLeadChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExpertCuratedItemsForLeadChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertCuratedItemsForLeadChangedSubscription({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useExpertCuratedItemsForLeadChangedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<ExpertCuratedItemsForLeadChangedSubscription, ExpertCuratedItemsForLeadChangedSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<ExpertCuratedItemsForLeadChangedSubscription, ExpertCuratedItemsForLeadChangedSubscriptionVariables>(ExpertCuratedItemsForLeadChangedDocument, baseOptions);
      }
export type ExpertCuratedItemsForLeadChangedSubscriptionHookResult = ReturnType<typeof useExpertCuratedItemsForLeadChangedSubscription>;
export type ExpertCuratedItemsForLeadChangedSubscriptionResult = ApolloReactCommon.SubscriptionResult<ExpertCuratedItemsForLeadChangedSubscription>;
export const ExpertCuratedLeadDocument = gql`
    query ExpertCuratedLead($leadId: LeadId!) {
  lead(id: $leadId) {
    ...CuratedItemsLead
  }
}
    ${CuratedItemsLeadFragmentDoc}`;
export type ExpertCuratedLeadComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertCuratedLeadQuery, ExpertCuratedLeadQueryVariables>, 'query'> & ({ variables: ExpertCuratedLeadQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertCuratedLeadComponent = (props: ExpertCuratedLeadComponentProps) => (
      <ApolloReactComponents.Query<ExpertCuratedLeadQuery, ExpertCuratedLeadQueryVariables> query={ExpertCuratedLeadDocument} {...props} />
    );
    

/**
 * __useExpertCuratedLeadQuery__
 *
 * To run a query within a React component, call `useExpertCuratedLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertCuratedLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertCuratedLeadQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useExpertCuratedLeadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertCuratedLeadQuery, ExpertCuratedLeadQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertCuratedLeadQuery, ExpertCuratedLeadQueryVariables>(ExpertCuratedLeadDocument, baseOptions);
      }
export function useExpertCuratedLeadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertCuratedLeadQuery, ExpertCuratedLeadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertCuratedLeadQuery, ExpertCuratedLeadQueryVariables>(ExpertCuratedLeadDocument, baseOptions);
        }
export type ExpertCuratedLeadQueryHookResult = ReturnType<typeof useExpertCuratedLeadQuery>;
export type ExpertCuratedLeadLazyQueryHookResult = ReturnType<typeof useExpertCuratedLeadLazyQuery>;
export type ExpertCuratedLeadQueryResult = ApolloReactCommon.QueryResult<ExpertCuratedLeadQuery, ExpertCuratedLeadQueryVariables>;
export const RemoveExpertCuratedItemFromListDocument = gql`
    mutation RemoveExpertCuratedItemFromList($id: ExpertCuratedItemId!, $reason: ExpertCuratedItemRemovedReason!, $otherReason: String) {
  removeExpertCuratedItem(input: {id: $id, reason: $reason, otherReason: $otherReason}) {
    expertCuratedItemsByCategories {
      id
      categories {
        id
        items {
          ...ExpertCuratedItem
        }
      }
    }
  }
}
    ${ExpertCuratedItemFragmentDoc}`;
export type RemoveExpertCuratedItemFromListMutationFn = ApolloReactCommon.MutationFunction<RemoveExpertCuratedItemFromListMutation, RemoveExpertCuratedItemFromListMutationVariables>;
export type RemoveExpertCuratedItemFromListComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveExpertCuratedItemFromListMutation, RemoveExpertCuratedItemFromListMutationVariables>, 'mutation'>;

    export const RemoveExpertCuratedItemFromListComponent = (props: RemoveExpertCuratedItemFromListComponentProps) => (
      <ApolloReactComponents.Mutation<RemoveExpertCuratedItemFromListMutation, RemoveExpertCuratedItemFromListMutationVariables> mutation={RemoveExpertCuratedItemFromListDocument} {...props} />
    );
    

/**
 * __useRemoveExpertCuratedItemFromListMutation__
 *
 * To run a mutation, you first call `useRemoveExpertCuratedItemFromListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExpertCuratedItemFromListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExpertCuratedItemFromListMutation, { data, loading, error }] = useRemoveExpertCuratedItemFromListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *      otherReason: // value for 'otherReason'
 *   },
 * });
 */
export function useRemoveExpertCuratedItemFromListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveExpertCuratedItemFromListMutation, RemoveExpertCuratedItemFromListMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveExpertCuratedItemFromListMutation, RemoveExpertCuratedItemFromListMutationVariables>(RemoveExpertCuratedItemFromListDocument, baseOptions);
      }
export type RemoveExpertCuratedItemFromListMutationHookResult = ReturnType<typeof useRemoveExpertCuratedItemFromListMutation>;
export type RemoveExpertCuratedItemFromListMutationResult = ApolloReactCommon.MutationResult<RemoveExpertCuratedItemFromListMutation>;
export type RemoveExpertCuratedItemFromListMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveExpertCuratedItemFromListMutation, RemoveExpertCuratedItemFromListMutationVariables>;
export const ExpertCuratedItemForCurationProductPageDocument = gql`
    query ExpertCuratedItemForCurationProductPage($id: ExpertCuratedItemId!) {
  expertCuratedItem(id: $id) {
    ...ExpertCuratedItemForCurationProductPage
  }
}
    ${ExpertCuratedItemForCurationProductPageFragmentDoc}`;
export type ExpertCuratedItemForCurationProductPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertCuratedItemForCurationProductPageQuery, ExpertCuratedItemForCurationProductPageQueryVariables>, 'query'> & ({ variables: ExpertCuratedItemForCurationProductPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertCuratedItemForCurationProductPageComponent = (props: ExpertCuratedItemForCurationProductPageComponentProps) => (
      <ApolloReactComponents.Query<ExpertCuratedItemForCurationProductPageQuery, ExpertCuratedItemForCurationProductPageQueryVariables> query={ExpertCuratedItemForCurationProductPageDocument} {...props} />
    );
    

/**
 * __useExpertCuratedItemForCurationProductPageQuery__
 *
 * To run a query within a React component, call `useExpertCuratedItemForCurationProductPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertCuratedItemForCurationProductPageQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertCuratedItemForCurationProductPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpertCuratedItemForCurationProductPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertCuratedItemForCurationProductPageQuery, ExpertCuratedItemForCurationProductPageQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertCuratedItemForCurationProductPageQuery, ExpertCuratedItemForCurationProductPageQueryVariables>(ExpertCuratedItemForCurationProductPageDocument, baseOptions);
      }
export function useExpertCuratedItemForCurationProductPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertCuratedItemForCurationProductPageQuery, ExpertCuratedItemForCurationProductPageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertCuratedItemForCurationProductPageQuery, ExpertCuratedItemForCurationProductPageQueryVariables>(ExpertCuratedItemForCurationProductPageDocument, baseOptions);
        }
export type ExpertCuratedItemForCurationProductPageQueryHookResult = ReturnType<typeof useExpertCuratedItemForCurationProductPageQuery>;
export type ExpertCuratedItemForCurationProductPageLazyQueryHookResult = ReturnType<typeof useExpertCuratedItemForCurationProductPageLazyQuery>;
export type ExpertCuratedItemForCurationProductPageQueryResult = ApolloReactCommon.QueryResult<ExpertCuratedItemForCurationProductPageQuery, ExpertCuratedItemForCurationProductPageQueryVariables>;
export const UserSellableReactionsDocument = gql`
    query UserSellableReactions($last: Int, $before: String, $query: ConsumerSellableReactionsQuery, $after: String, $first: Int) {
  consumerSellableReactions(last: $last, before: $before, query: $query, after: $after, first: $first) {
    edges {
      node {
        ...UserSellableReaction
      }
    }
  }
}
    ${UserSellableReactionFragmentDoc}`;
export type UserSellableReactionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserSellableReactionsQuery, UserSellableReactionsQueryVariables>, 'query'>;

    export const UserSellableReactionsComponent = (props: UserSellableReactionsComponentProps) => (
      <ApolloReactComponents.Query<UserSellableReactionsQuery, UserSellableReactionsQueryVariables> query={UserSellableReactionsDocument} {...props} />
    );
    

/**
 * __useUserSellableReactionsQuery__
 *
 * To run a query within a React component, call `useUserSellableReactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSellableReactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSellableReactionsQuery({
 *   variables: {
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useUserSellableReactionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserSellableReactionsQuery, UserSellableReactionsQueryVariables>) {
        return ApolloReactHooks.useQuery<UserSellableReactionsQuery, UserSellableReactionsQueryVariables>(UserSellableReactionsDocument, baseOptions);
      }
export function useUserSellableReactionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserSellableReactionsQuery, UserSellableReactionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<UserSellableReactionsQuery, UserSellableReactionsQueryVariables>(UserSellableReactionsDocument, baseOptions);
        }
export type UserSellableReactionsQueryHookResult = ReturnType<typeof useUserSellableReactionsQuery>;
export type UserSellableReactionsLazyQueryHookResult = ReturnType<typeof useUserSellableReactionsLazyQuery>;
export type UserSellableReactionsQueryResult = ApolloReactCommon.QueryResult<UserSellableReactionsQuery, UserSellableReactionsQueryVariables>;
export const CurationItemsDocument = gql`
    query CurationItems($leadId: LeadId!) {
  expertCuratedItemsForLead(leadId: $leadId) {
    id
    items {
      id
    }
  }
  expertCuratedOrdersForLeadConnection(query: {leadId: $leadId, showClosed: true}) {
    edges {
      node {
        id
      }
    }
  }
}
    `;
export type CurationItemsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CurationItemsQuery, CurationItemsQueryVariables>, 'query'> & ({ variables: CurationItemsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CurationItemsComponent = (props: CurationItemsComponentProps) => (
      <ApolloReactComponents.Query<CurationItemsQuery, CurationItemsQueryVariables> query={CurationItemsDocument} {...props} />
    );
    

/**
 * __useCurationItemsQuery__
 *
 * To run a query within a React component, call `useCurationItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurationItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurationItemsQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useCurationItemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurationItemsQuery, CurationItemsQueryVariables>) {
        return ApolloReactHooks.useQuery<CurationItemsQuery, CurationItemsQueryVariables>(CurationItemsDocument, baseOptions);
      }
export function useCurationItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurationItemsQuery, CurationItemsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CurationItemsQuery, CurationItemsQueryVariables>(CurationItemsDocument, baseOptions);
        }
export type CurationItemsQueryHookResult = ReturnType<typeof useCurationItemsQuery>;
export type CurationItemsLazyQueryHookResult = ReturnType<typeof useCurationItemsLazyQuery>;
export type CurationItemsQueryResult = ApolloReactCommon.QueryResult<CurationItemsQuery, CurationItemsQueryVariables>;
export const DepartmentInfoDocument = gql`
    query DepartmentInfo($departmentSlug: String!) {
  departmentBySlug(slug: $departmentSlug) {
    id
    displayName
    sellableSearchFacets(query: {maxFacetTerms: 100}) {
      name
      displayName
      selections {
        ...DepartmentSearchFacetSelections
      }
    }
    topLevelCategory {
      ...DepartmentTopLevelCategory
    }
    mostRecentLeadForConsumer {
      ...DepartmentLead
    }
    ...DepartmentContext
  }
  recommendedLists(first: 4, query: {departmentSlug: $departmentSlug, types: [CUSTOM]}) {
    edges {
      node {
        ...RecommendedList
      }
    }
  }
}
    ${DepartmentSearchFacetSelectionsFragmentDoc}
${DepartmentTopLevelCategoryFragmentDoc}
${DepartmentLeadFragmentDoc}
${DepartmentContextFragmentDoc}
${RecommendedListFragmentDoc}`;
export type DepartmentInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DepartmentInfoQuery, DepartmentInfoQueryVariables>, 'query'> & ({ variables: DepartmentInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DepartmentInfoComponent = (props: DepartmentInfoComponentProps) => (
      <ApolloReactComponents.Query<DepartmentInfoQuery, DepartmentInfoQueryVariables> query={DepartmentInfoDocument} {...props} />
    );
    

/**
 * __useDepartmentInfoQuery__
 *
 * To run a query within a React component, call `useDepartmentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentInfoQuery({
 *   variables: {
 *      departmentSlug: // value for 'departmentSlug'
 *   },
 * });
 */
export function useDepartmentInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DepartmentInfoQuery, DepartmentInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<DepartmentInfoQuery, DepartmentInfoQueryVariables>(DepartmentInfoDocument, baseOptions);
      }
export function useDepartmentInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentInfoQuery, DepartmentInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DepartmentInfoQuery, DepartmentInfoQueryVariables>(DepartmentInfoDocument, baseOptions);
        }
export type DepartmentInfoQueryHookResult = ReturnType<typeof useDepartmentInfoQuery>;
export type DepartmentInfoLazyQueryHookResult = ReturnType<typeof useDepartmentInfoLazyQuery>;
export type DepartmentInfoQueryResult = ApolloReactCommon.QueryResult<DepartmentInfoQuery, DepartmentInfoQueryVariables>;
export const DepartmentSavedSellablesDocument = gql`
    query DepartmentSavedSellables($query: SavedSellableQueryInput!) {
  savedSellablesConnection(query: $query) {
    edges {
      node {
        id
        sellable {
          ...RecommendedListSellableCard
        }
      }
    }
  }
}
    ${RecommendedListSellableCardFragmentDoc}`;
export type DepartmentSavedSellablesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DepartmentSavedSellablesQuery, DepartmentSavedSellablesQueryVariables>, 'query'> & ({ variables: DepartmentSavedSellablesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DepartmentSavedSellablesComponent = (props: DepartmentSavedSellablesComponentProps) => (
      <ApolloReactComponents.Query<DepartmentSavedSellablesQuery, DepartmentSavedSellablesQueryVariables> query={DepartmentSavedSellablesDocument} {...props} />
    );
    

/**
 * __useDepartmentSavedSellablesQuery__
 *
 * To run a query within a React component, call `useDepartmentSavedSellablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentSavedSellablesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentSavedSellablesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useDepartmentSavedSellablesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DepartmentSavedSellablesQuery, DepartmentSavedSellablesQueryVariables>) {
        return ApolloReactHooks.useQuery<DepartmentSavedSellablesQuery, DepartmentSavedSellablesQueryVariables>(DepartmentSavedSellablesDocument, baseOptions);
      }
export function useDepartmentSavedSellablesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentSavedSellablesQuery, DepartmentSavedSellablesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DepartmentSavedSellablesQuery, DepartmentSavedSellablesQueryVariables>(DepartmentSavedSellablesDocument, baseOptions);
        }
export type DepartmentSavedSellablesQueryHookResult = ReturnType<typeof useDepartmentSavedSellablesQuery>;
export type DepartmentSavedSellablesLazyQueryHookResult = ReturnType<typeof useDepartmentSavedSellablesLazyQuery>;
export type DepartmentSavedSellablesQueryResult = ApolloReactCommon.QueryResult<DepartmentSavedSellablesQuery, DepartmentSavedSellablesQueryVariables>;
export const InfiniteScrollSellablesDocument = gql`
    query InfiniteScrollSellables($categoryIds: [CategoryId!], $after: String, $filters: [SellableSearchFilter!]) {
  searchSellables(query: {categoryIds: $categoryIds, sellableSearchUseCase: CONSUMER_SEARCH, filters: $filters}, first: 10, after: $after) {
    count
    edges {
      cursor
      node {
        ...SellableCard
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${SellableCardFragmentDoc}
${PageInfoFragmentDoc}`;
export type InfiniteScrollSellablesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<InfiniteScrollSellablesQuery, InfiniteScrollSellablesQueryVariables>, 'query'>;

    export const InfiniteScrollSellablesComponent = (props: InfiniteScrollSellablesComponentProps) => (
      <ApolloReactComponents.Query<InfiniteScrollSellablesQuery, InfiniteScrollSellablesQueryVariables> query={InfiniteScrollSellablesDocument} {...props} />
    );
    

/**
 * __useInfiniteScrollSellablesQuery__
 *
 * To run a query within a React component, call `useInfiniteScrollSellablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfiniteScrollSellablesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfiniteScrollSellablesQuery({
 *   variables: {
 *      categoryIds: // value for 'categoryIds'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useInfiniteScrollSellablesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InfiniteScrollSellablesQuery, InfiniteScrollSellablesQueryVariables>) {
        return ApolloReactHooks.useQuery<InfiniteScrollSellablesQuery, InfiniteScrollSellablesQueryVariables>(InfiniteScrollSellablesDocument, baseOptions);
      }
export function useInfiniteScrollSellablesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InfiniteScrollSellablesQuery, InfiniteScrollSellablesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<InfiniteScrollSellablesQuery, InfiniteScrollSellablesQueryVariables>(InfiniteScrollSellablesDocument, baseOptions);
        }
export type InfiniteScrollSellablesQueryHookResult = ReturnType<typeof useInfiniteScrollSellablesQuery>;
export type InfiniteScrollSellablesLazyQueryHookResult = ReturnType<typeof useInfiniteScrollSellablesLazyQuery>;
export type InfiniteScrollSellablesQueryResult = ApolloReactCommon.QueryResult<InfiniteScrollSellablesQuery, InfiniteScrollSellablesQueryVariables>;
export const YachtSearchBarFacetsDocument = gql`
    query YachtSearchBarFacets {
  departmentBySlug(slug: "yacht-charters") {
    id
    sellableSearchFacets(query: {}) {
      name
      displayName
      selections {
        name
        displayName
        bucketValues
        lower
        upper
      }
    }
  }
}
    `;
export type YachtSearchBarFacetsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<YachtSearchBarFacetsQuery, YachtSearchBarFacetsQueryVariables>, 'query'>;

    export const YachtSearchBarFacetsComponent = (props: YachtSearchBarFacetsComponentProps) => (
      <ApolloReactComponents.Query<YachtSearchBarFacetsQuery, YachtSearchBarFacetsQueryVariables> query={YachtSearchBarFacetsDocument} {...props} />
    );
    

/**
 * __useYachtSearchBarFacetsQuery__
 *
 * To run a query within a React component, call `useYachtSearchBarFacetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useYachtSearchBarFacetsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYachtSearchBarFacetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useYachtSearchBarFacetsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<YachtSearchBarFacetsQuery, YachtSearchBarFacetsQueryVariables>) {
        return ApolloReactHooks.useQuery<YachtSearchBarFacetsQuery, YachtSearchBarFacetsQueryVariables>(YachtSearchBarFacetsDocument, baseOptions);
      }
export function useYachtSearchBarFacetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<YachtSearchBarFacetsQuery, YachtSearchBarFacetsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<YachtSearchBarFacetsQuery, YachtSearchBarFacetsQueryVariables>(YachtSearchBarFacetsDocument, baseOptions);
        }
export type YachtSearchBarFacetsQueryHookResult = ReturnType<typeof useYachtSearchBarFacetsQuery>;
export type YachtSearchBarFacetsLazyQueryHookResult = ReturnType<typeof useYachtSearchBarFacetsLazyQuery>;
export type YachtSearchBarFacetsQueryResult = ApolloReactCommon.QueryResult<YachtSearchBarFacetsQuery, YachtSearchBarFacetsQueryVariables>;
export const GetExpertProfileDocument = gql`
    query GetExpertProfile($vanityIdOrId: String!) {
  findExpert(vanityIdOrId: $vanityIdOrId) {
    ...ExpertBusinessUser
  }
}
    ${ExpertBusinessUserFragmentDoc}`;
export type GetExpertProfileComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetExpertProfileQuery, GetExpertProfileQueryVariables>, 'query'> & ({ variables: GetExpertProfileQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetExpertProfileComponent = (props: GetExpertProfileComponentProps) => (
      <ApolloReactComponents.Query<GetExpertProfileQuery, GetExpertProfileQueryVariables> query={GetExpertProfileDocument} {...props} />
    );
    

/**
 * __useGetExpertProfileQuery__
 *
 * To run a query within a React component, call `useGetExpertProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpertProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpertProfileQuery({
 *   variables: {
 *      vanityIdOrId: // value for 'vanityIdOrId'
 *   },
 * });
 */
export function useGetExpertProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetExpertProfileQuery, GetExpertProfileQueryVariables>) {
        return ApolloReactHooks.useQuery<GetExpertProfileQuery, GetExpertProfileQueryVariables>(GetExpertProfileDocument, baseOptions);
      }
export function useGetExpertProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExpertProfileQuery, GetExpertProfileQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetExpertProfileQuery, GetExpertProfileQueryVariables>(GetExpertProfileDocument, baseOptions);
        }
export type GetExpertProfileQueryHookResult = ReturnType<typeof useGetExpertProfileQuery>;
export type GetExpertProfileLazyQueryHookResult = ReturnType<typeof useGetExpertProfileLazyQuery>;
export type GetExpertProfileQueryResult = ApolloReactCommon.QueryResult<GetExpertProfileQuery, GetExpertProfileQueryVariables>;
export const ExpertTopRecommendedSellablesDocument = gql`
    query ExpertTopRecommendedSellables($query: ExpertTopRecommendedSellablesInput!) {
  expertTopRecommendedSellables(query: $query) {
    categoryTopRecommendedSellables {
      ...ExpertTopSellables
    }
  }
}
    ${ExpertTopSellablesFragmentDoc}`;
export type ExpertTopRecommendedSellablesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertTopRecommendedSellablesQuery, ExpertTopRecommendedSellablesQueryVariables>, 'query'> & ({ variables: ExpertTopRecommendedSellablesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertTopRecommendedSellablesComponent = (props: ExpertTopRecommendedSellablesComponentProps) => (
      <ApolloReactComponents.Query<ExpertTopRecommendedSellablesQuery, ExpertTopRecommendedSellablesQueryVariables> query={ExpertTopRecommendedSellablesDocument} {...props} />
    );
    

/**
 * __useExpertTopRecommendedSellablesQuery__
 *
 * To run a query within a React component, call `useExpertTopRecommendedSellablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertTopRecommendedSellablesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertTopRecommendedSellablesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useExpertTopRecommendedSellablesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertTopRecommendedSellablesQuery, ExpertTopRecommendedSellablesQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertTopRecommendedSellablesQuery, ExpertTopRecommendedSellablesQueryVariables>(ExpertTopRecommendedSellablesDocument, baseOptions);
      }
export function useExpertTopRecommendedSellablesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertTopRecommendedSellablesQuery, ExpertTopRecommendedSellablesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertTopRecommendedSellablesQuery, ExpertTopRecommendedSellablesQueryVariables>(ExpertTopRecommendedSellablesDocument, baseOptions);
        }
export type ExpertTopRecommendedSellablesQueryHookResult = ReturnType<typeof useExpertTopRecommendedSellablesQuery>;
export type ExpertTopRecommendedSellablesLazyQueryHookResult = ReturnType<typeof useExpertTopRecommendedSellablesLazyQuery>;
export type ExpertTopRecommendedSellablesQueryResult = ApolloReactCommon.QueryResult<ExpertTopRecommendedSellablesQuery, ExpertTopRecommendedSellablesQueryVariables>;
export const ExpertTopBrandsDocument = gql`
    query ExpertTopBrands($query: ExpertTopRecommendedBrandsInput!) {
  expertTopRecommendedBrands(query: $query) {
    topRecommendedBrands {
      brand {
        id
        displayName
        name
        logo {
          ...MediaFile
        }
      }
    }
  }
}
    ${MediaFileFragmentDoc}`;
export type ExpertTopBrandsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertTopBrandsQuery, ExpertTopBrandsQueryVariables>, 'query'> & ({ variables: ExpertTopBrandsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertTopBrandsComponent = (props: ExpertTopBrandsComponentProps) => (
      <ApolloReactComponents.Query<ExpertTopBrandsQuery, ExpertTopBrandsQueryVariables> query={ExpertTopBrandsDocument} {...props} />
    );
    

/**
 * __useExpertTopBrandsQuery__
 *
 * To run a query within a React component, call `useExpertTopBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertTopBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertTopBrandsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useExpertTopBrandsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertTopBrandsQuery, ExpertTopBrandsQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertTopBrandsQuery, ExpertTopBrandsQueryVariables>(ExpertTopBrandsDocument, baseOptions);
      }
export function useExpertTopBrandsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertTopBrandsQuery, ExpertTopBrandsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertTopBrandsQuery, ExpertTopBrandsQueryVariables>(ExpertTopBrandsDocument, baseOptions);
        }
export type ExpertTopBrandsQueryHookResult = ReturnType<typeof useExpertTopBrandsQuery>;
export type ExpertTopBrandsLazyQueryHookResult = ReturnType<typeof useExpertTopBrandsLazyQuery>;
export type ExpertTopBrandsQueryResult = ApolloReactCommon.QueryResult<ExpertTopBrandsQuery, ExpertTopBrandsQueryVariables>;
export const MyCurationsDocument = gql`
    query MyCurations($leadId: LeadId!) {
  expertCuratedItemsForLead(leadId: $leadId) {
    id
    items {
      id
      sellable {
        id
        title
        images {
          id
          url
        }
      }
    }
  }
  lead(id: $leadId) {
    id
    expert {
      ...ExpertInfo
    }
    delegateExpert {
      ...ExpertInfo
    }
    category {
      id
      contentAssets {
        bannerImages {
          imageUrl
        }
      }
    }
  }
  expertCuratedOrdersForLeadConnection(query: {leadId: $leadId, showClosed: false}) {
    edges {
      node {
        id
        serviceStartAt
        serviceLocation {
          city
          state
        }
        order {
          id
          title
          primaryImage {
            id
            url
          }
        }
      }
    }
  }
}
    ${ExpertInfoFragmentDoc}`;
export type MyCurationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MyCurationsQuery, MyCurationsQueryVariables>, 'query'> & ({ variables: MyCurationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MyCurationsComponent = (props: MyCurationsComponentProps) => (
      <ApolloReactComponents.Query<MyCurationsQuery, MyCurationsQueryVariables> query={MyCurationsDocument} {...props} />
    );
    

/**
 * __useMyCurationsQuery__
 *
 * To run a query within a React component, call `useMyCurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCurationsQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useMyCurationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyCurationsQuery, MyCurationsQueryVariables>) {
        return ApolloReactHooks.useQuery<MyCurationsQuery, MyCurationsQueryVariables>(MyCurationsDocument, baseOptions);
      }
export function useMyCurationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyCurationsQuery, MyCurationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MyCurationsQuery, MyCurationsQueryVariables>(MyCurationsDocument, baseOptions);
        }
export type MyCurationsQueryHookResult = ReturnType<typeof useMyCurationsQuery>;
export type MyCurationsLazyQueryHookResult = ReturnType<typeof useMyCurationsLazyQuery>;
export type MyCurationsQueryResult = ApolloReactCommon.QueryResult<MyCurationsQuery, MyCurationsQueryVariables>;
export const MyFavoritesDocument = gql`
    query MyFavorites {
  savedSellablesConnection(first: 30, query: {}) {
    edges {
      node {
        id
        sellable {
          ...SellableCard
        }
        saved
        savedReason
      }
    }
  }
}
    ${SellableCardFragmentDoc}`;
export type MyFavoritesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MyFavoritesQuery, MyFavoritesQueryVariables>, 'query'>;

    export const MyFavoritesComponent = (props: MyFavoritesComponentProps) => (
      <ApolloReactComponents.Query<MyFavoritesQuery, MyFavoritesQueryVariables> query={MyFavoritesDocument} {...props} />
    );
    

/**
 * __useMyFavoritesQuery__
 *
 * To run a query within a React component, call `useMyFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyFavoritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyFavoritesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyFavoritesQuery, MyFavoritesQueryVariables>) {
        return ApolloReactHooks.useQuery<MyFavoritesQuery, MyFavoritesQueryVariables>(MyFavoritesDocument, baseOptions);
      }
export function useMyFavoritesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyFavoritesQuery, MyFavoritesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MyFavoritesQuery, MyFavoritesQueryVariables>(MyFavoritesDocument, baseOptions);
        }
export type MyFavoritesQueryHookResult = ReturnType<typeof useMyFavoritesQuery>;
export type MyFavoritesLazyQueryHookResult = ReturnType<typeof useMyFavoritesLazyQuery>;
export type MyFavoritesQueryResult = ApolloReactCommon.QueryResult<MyFavoritesQuery, MyFavoritesQueryVariables>;
export const LatestLeadDocument = gql`
    query LatestLead {
  me {
    id
    user {
      id
      mostRecentLead {
        id
        department {
          id
          type
          slug
        }
      }
    }
  }
}
    `;
export type LatestLeadComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LatestLeadQuery, LatestLeadQueryVariables>, 'query'>;

    export const LatestLeadComponent = (props: LatestLeadComponentProps) => (
      <ApolloReactComponents.Query<LatestLeadQuery, LatestLeadQueryVariables> query={LatestLeadDocument} {...props} />
    );
    

/**
 * __useLatestLeadQuery__
 *
 * To run a query within a React component, call `useLatestLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestLeadQuery({
 *   variables: {
 *   },
 * });
 */
export function useLatestLeadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LatestLeadQuery, LatestLeadQueryVariables>) {
        return ApolloReactHooks.useQuery<LatestLeadQuery, LatestLeadQueryVariables>(LatestLeadDocument, baseOptions);
      }
export function useLatestLeadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LatestLeadQuery, LatestLeadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LatestLeadQuery, LatestLeadQueryVariables>(LatestLeadDocument, baseOptions);
        }
export type LatestLeadQueryHookResult = ReturnType<typeof useLatestLeadQuery>;
export type LatestLeadLazyQueryHookResult = ReturnType<typeof useLatestLeadLazyQuery>;
export type LatestLeadQueryResult = ApolloReactCommon.QueryResult<LatestLeadQuery, LatestLeadQueryVariables>;
export const HomepageReviewCountsDocument = gql`
    query HomepageReviewCounts {
  consumerExpertReviewConnection(query: {departmentIds: []}) {
    count
    facets {
      ... on BucketedDisplayFacet {
        buckets {
          count
          value
        }
      }
      displayName
      alias
      name
    }
  }
}
    `;
export type HomepageReviewCountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HomepageReviewCountsQuery, HomepageReviewCountsQueryVariables>, 'query'>;

    export const HomepageReviewCountsComponent = (props: HomepageReviewCountsComponentProps) => (
      <ApolloReactComponents.Query<HomepageReviewCountsQuery, HomepageReviewCountsQueryVariables> query={HomepageReviewCountsDocument} {...props} />
    );
    

/**
 * __useHomepageReviewCountsQuery__
 *
 * To run a query within a React component, call `useHomepageReviewCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomepageReviewCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomepageReviewCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomepageReviewCountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HomepageReviewCountsQuery, HomepageReviewCountsQueryVariables>) {
        return ApolloReactHooks.useQuery<HomepageReviewCountsQuery, HomepageReviewCountsQueryVariables>(HomepageReviewCountsDocument, baseOptions);
      }
export function useHomepageReviewCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomepageReviewCountsQuery, HomepageReviewCountsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HomepageReviewCountsQuery, HomepageReviewCountsQueryVariables>(HomepageReviewCountsDocument, baseOptions);
        }
export type HomepageReviewCountsQueryHookResult = ReturnType<typeof useHomepageReviewCountsQuery>;
export type HomepageReviewCountsLazyQueryHookResult = ReturnType<typeof useHomepageReviewCountsLazyQuery>;
export type HomepageReviewCountsQueryResult = ApolloReactCommon.QueryResult<HomepageReviewCountsQuery, HomepageReviewCountsQueryVariables>;
export const SpotlightExpertsDocument = gql`
    query SpotlightExperts($query: ExpertSearchQuery!) {
  expertSearchConnection(query: $query, first: 6) {
    edges {
      cursor
      node {
        ...SpotlightExpert
      }
    }
  }
}
    ${SpotlightExpertFragmentDoc}`;
export type SpotlightExpertsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SpotlightExpertsQuery, SpotlightExpertsQueryVariables>, 'query'> & ({ variables: SpotlightExpertsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SpotlightExpertsComponent = (props: SpotlightExpertsComponentProps) => (
      <ApolloReactComponents.Query<SpotlightExpertsQuery, SpotlightExpertsQueryVariables> query={SpotlightExpertsDocument} {...props} />
    );
    

/**
 * __useSpotlightExpertsQuery__
 *
 * To run a query within a React component, call `useSpotlightExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpotlightExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpotlightExpertsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSpotlightExpertsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SpotlightExpertsQuery, SpotlightExpertsQueryVariables>) {
        return ApolloReactHooks.useQuery<SpotlightExpertsQuery, SpotlightExpertsQueryVariables>(SpotlightExpertsDocument, baseOptions);
      }
export function useSpotlightExpertsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SpotlightExpertsQuery, SpotlightExpertsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SpotlightExpertsQuery, SpotlightExpertsQueryVariables>(SpotlightExpertsDocument, baseOptions);
        }
export type SpotlightExpertsQueryHookResult = ReturnType<typeof useSpotlightExpertsQuery>;
export type SpotlightExpertsLazyQueryHookResult = ReturnType<typeof useSpotlightExpertsLazyQuery>;
export type SpotlightExpertsQueryResult = ApolloReactCommon.QueryResult<SpotlightExpertsQuery, SpotlightExpertsQueryVariables>;
export const RecommendedExpertsForDepartmentDocument = gql`
    query RecommendedExpertsForDepartment($query: ExpertSearchQuery!) {
  expertSearchConnection(query: $query, sortBy: FEATURED, first: 6) {
    count
    edges {
      node {
        ...RecommendingExperts
      }
    }
  }
}
    ${RecommendingExpertsFragmentDoc}`;
export type RecommendedExpertsForDepartmentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecommendedExpertsForDepartmentQuery, RecommendedExpertsForDepartmentQueryVariables>, 'query'> & ({ variables: RecommendedExpertsForDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RecommendedExpertsForDepartmentComponent = (props: RecommendedExpertsForDepartmentComponentProps) => (
      <ApolloReactComponents.Query<RecommendedExpertsForDepartmentQuery, RecommendedExpertsForDepartmentQueryVariables> query={RecommendedExpertsForDepartmentDocument} {...props} />
    );
    

/**
 * __useRecommendedExpertsForDepartmentQuery__
 *
 * To run a query within a React component, call `useRecommendedExpertsForDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedExpertsForDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedExpertsForDepartmentQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useRecommendedExpertsForDepartmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RecommendedExpertsForDepartmentQuery, RecommendedExpertsForDepartmentQueryVariables>) {
        return ApolloReactHooks.useQuery<RecommendedExpertsForDepartmentQuery, RecommendedExpertsForDepartmentQueryVariables>(RecommendedExpertsForDepartmentDocument, baseOptions);
      }
export function useRecommendedExpertsForDepartmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecommendedExpertsForDepartmentQuery, RecommendedExpertsForDepartmentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RecommendedExpertsForDepartmentQuery, RecommendedExpertsForDepartmentQueryVariables>(RecommendedExpertsForDepartmentDocument, baseOptions);
        }
export type RecommendedExpertsForDepartmentQueryHookResult = ReturnType<typeof useRecommendedExpertsForDepartmentQuery>;
export type RecommendedExpertsForDepartmentLazyQueryHookResult = ReturnType<typeof useRecommendedExpertsForDepartmentLazyQuery>;
export type RecommendedExpertsForDepartmentQueryResult = ApolloReactCommon.QueryResult<RecommendedExpertsForDepartmentQuery, RecommendedExpertsForDepartmentQueryVariables>;
export const LeadsDocument = gql`
    query Leads($consumerId: UserId!, $after: String) {
  leads(query: {consumerId: $consumerId, facetedSearch: false}, first: 50, after: $after) {
    edges {
      node {
        ...LeadOverview
      }
    }
  }
}
    ${LeadOverviewFragmentDoc}`;
export type LeadsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LeadsQuery, LeadsQueryVariables>, 'query'> & ({ variables: LeadsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LeadsComponent = (props: LeadsComponentProps) => (
      <ApolloReactComponents.Query<LeadsQuery, LeadsQueryVariables> query={LeadsDocument} {...props} />
    );
    

/**
 * __useLeadsQuery__
 *
 * To run a query within a React component, call `useLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadsQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLeadsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LeadsQuery, LeadsQueryVariables>) {
        return ApolloReactHooks.useQuery<LeadsQuery, LeadsQueryVariables>(LeadsDocument, baseOptions);
      }
export function useLeadsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LeadsQuery, LeadsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LeadsQuery, LeadsQueryVariables>(LeadsDocument, baseOptions);
        }
export type LeadsQueryHookResult = ReturnType<typeof useLeadsQuery>;
export type LeadsLazyQueryHookResult = ReturnType<typeof useLeadsLazyQuery>;
export type LeadsQueryResult = ApolloReactCommon.QueryResult<LeadsQuery, LeadsQueryVariables>;
export const SupportConversationDocument = gql`
    query SupportConversation($consumerId: UserId!) {
  supportConversation(consumerId: $consumerId) {
    ...SupportConversation
  }
}
    ${SupportConversationFragmentDoc}`;
export type SupportConversationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SupportConversationQuery, SupportConversationQueryVariables>, 'query'> & ({ variables: SupportConversationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SupportConversationComponent = (props: SupportConversationComponentProps) => (
      <ApolloReactComponents.Query<SupportConversationQuery, SupportConversationQueryVariables> query={SupportConversationDocument} {...props} />
    );
    

/**
 * __useSupportConversationQuery__
 *
 * To run a query within a React component, call `useSupportConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportConversationQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *   },
 * });
 */
export function useSupportConversationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SupportConversationQuery, SupportConversationQueryVariables>) {
        return ApolloReactHooks.useQuery<SupportConversationQuery, SupportConversationQueryVariables>(SupportConversationDocument, baseOptions);
      }
export function useSupportConversationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupportConversationQuery, SupportConversationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SupportConversationQuery, SupportConversationQueryVariables>(SupportConversationDocument, baseOptions);
        }
export type SupportConversationQueryHookResult = ReturnType<typeof useSupportConversationQuery>;
export type SupportConversationLazyQueryHookResult = ReturnType<typeof useSupportConversationLazyQuery>;
export type SupportConversationQueryResult = ApolloReactCommon.QueryResult<SupportConversationQuery, SupportConversationQueryVariables>;
export const ExpertByLeadDocument = gql`
    query ExpertByLead($leadId: LeadId!) {
  lead(id: $leadId) {
    id
    latestRequest {
      id
      attributes {
        formatted {
          displayHtml
        }
      }
    }
    department {
      id
      type
    }
    conversation {
      id
    }
    expert {
      ...ByLeadExpert
    }
    category {
      id
      department {
        id
        slug
      }
      slug
      singularDisplayName
      contentAssets {
        modalHeader {
          imageUrl
        }
        fullPageTakeover {
          imageUrl
        }
      }
    }
  }
}
    ${ByLeadExpertFragmentDoc}`;
export type ExpertByLeadComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertByLeadQuery, ExpertByLeadQueryVariables>, 'query'> & ({ variables: ExpertByLeadQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertByLeadComponent = (props: ExpertByLeadComponentProps) => (
      <ApolloReactComponents.Query<ExpertByLeadQuery, ExpertByLeadQueryVariables> query={ExpertByLeadDocument} {...props} />
    );
    

/**
 * __useExpertByLeadQuery__
 *
 * To run a query within a React component, call `useExpertByLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertByLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertByLeadQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useExpertByLeadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertByLeadQuery, ExpertByLeadQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertByLeadQuery, ExpertByLeadQueryVariables>(ExpertByLeadDocument, baseOptions);
      }
export function useExpertByLeadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertByLeadQuery, ExpertByLeadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertByLeadQuery, ExpertByLeadQueryVariables>(ExpertByLeadDocument, baseOptions);
        }
export type ExpertByLeadQueryHookResult = ReturnType<typeof useExpertByLeadQuery>;
export type ExpertByLeadLazyQueryHookResult = ReturnType<typeof useExpertByLeadLazyQuery>;
export type ExpertByLeadQueryResult = ApolloReactCommon.QueryResult<ExpertByLeadQuery, ExpertByLeadQueryVariables>;
export const SetConsumerInitialLeadActionDocument = gql`
    mutation SetConsumerInitialLeadAction($leadId: LeadId!, $action: ConsumerInitialLeadAction!) {
  setConsumerInitialLeadAction(input: {leadId: $leadId, action: $action}) {
    lead {
      id
      conversation {
        id
        externalId
      }
      category {
        id
        slug
      }
    }
  }
}
    `;
export type SetConsumerInitialLeadActionMutationFn = ApolloReactCommon.MutationFunction<SetConsumerInitialLeadActionMutation, SetConsumerInitialLeadActionMutationVariables>;
export type SetConsumerInitialLeadActionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SetConsumerInitialLeadActionMutation, SetConsumerInitialLeadActionMutationVariables>, 'mutation'>;

    export const SetConsumerInitialLeadActionComponent = (props: SetConsumerInitialLeadActionComponentProps) => (
      <ApolloReactComponents.Mutation<SetConsumerInitialLeadActionMutation, SetConsumerInitialLeadActionMutationVariables> mutation={SetConsumerInitialLeadActionDocument} {...props} />
    );
    

/**
 * __useSetConsumerInitialLeadActionMutation__
 *
 * To run a mutation, you first call `useSetConsumerInitialLeadActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetConsumerInitialLeadActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setConsumerInitialLeadActionMutation, { data, loading, error }] = useSetConsumerInitialLeadActionMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useSetConsumerInitialLeadActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetConsumerInitialLeadActionMutation, SetConsumerInitialLeadActionMutationVariables>) {
        return ApolloReactHooks.useMutation<SetConsumerInitialLeadActionMutation, SetConsumerInitialLeadActionMutationVariables>(SetConsumerInitialLeadActionDocument, baseOptions);
      }
export type SetConsumerInitialLeadActionMutationHookResult = ReturnType<typeof useSetConsumerInitialLeadActionMutation>;
export type SetConsumerInitialLeadActionMutationResult = ApolloReactCommon.MutationResult<SetConsumerInitialLeadActionMutation>;
export type SetConsumerInitialLeadActionMutationOptions = ApolloReactCommon.BaseMutationOptions<SetConsumerInitialLeadActionMutation, SetConsumerInitialLeadActionMutationVariables>;
export const ConversationExpertProfileDocument = gql`
    query ConversationExpertProfile($id: LeadId!) {
  lead(id: $id) {
    ...LeadExpertProfile
  }
  expertCuratedItemsForLead(leadId: $id) {
    id
    items {
      id
    }
  }
}
    ${LeadExpertProfileFragmentDoc}`;
export type ConversationExpertProfileComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConversationExpertProfileQuery, ConversationExpertProfileQueryVariables>, 'query'> & ({ variables: ConversationExpertProfileQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConversationExpertProfileComponent = (props: ConversationExpertProfileComponentProps) => (
      <ApolloReactComponents.Query<ConversationExpertProfileQuery, ConversationExpertProfileQueryVariables> query={ConversationExpertProfileDocument} {...props} />
    );
    

/**
 * __useConversationExpertProfileQuery__
 *
 * To run a query within a React component, call `useConversationExpertProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationExpertProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationExpertProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConversationExpertProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ConversationExpertProfileQuery, ConversationExpertProfileQueryVariables>) {
        return ApolloReactHooks.useQuery<ConversationExpertProfileQuery, ConversationExpertProfileQueryVariables>(ConversationExpertProfileDocument, baseOptions);
      }
export function useConversationExpertProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConversationExpertProfileQuery, ConversationExpertProfileQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ConversationExpertProfileQuery, ConversationExpertProfileQueryVariables>(ConversationExpertProfileDocument, baseOptions);
        }
export type ConversationExpertProfileQueryHookResult = ReturnType<typeof useConversationExpertProfileQuery>;
export type ConversationExpertProfileLazyQueryHookResult = ReturnType<typeof useConversationExpertProfileLazyQuery>;
export type ConversationExpertProfileQueryResult = ApolloReactCommon.QueryResult<ConversationExpertProfileQuery, ConversationExpertProfileQueryVariables>;
export const ConversationDocument = gql`
    query Conversation($id: ConversationId!) {
  conversation(id: $id) {
    ...ConversationWithMetaData
  }
}
    ${ConversationWithMetaDataFragmentDoc}`;
export type ConversationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConversationQuery, ConversationQueryVariables>, 'query'> & ({ variables: ConversationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConversationComponent = (props: ConversationComponentProps) => (
      <ApolloReactComponents.Query<ConversationQuery, ConversationQueryVariables> query={ConversationDocument} {...props} />
    );
    

/**
 * __useConversationQuery__
 *
 * To run a query within a React component, call `useConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConversationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ConversationQuery, ConversationQueryVariables>) {
        return ApolloReactHooks.useQuery<ConversationQuery, ConversationQueryVariables>(ConversationDocument, baseOptions);
      }
export function useConversationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConversationQuery, ConversationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ConversationQuery, ConversationQueryVariables>(ConversationDocument, baseOptions);
        }
export type ConversationQueryHookResult = ReturnType<typeof useConversationQuery>;
export type ConversationLazyQueryHookResult = ReturnType<typeof useConversationLazyQuery>;
export type ConversationQueryResult = ApolloReactCommon.QueryResult<ConversationQuery, ConversationQueryVariables>;
export const DepartmentSlugByCategorySlugDocument = gql`
    query DepartmentSlugByCategorySlug($categorySlug: String!) {
  categoryBySlug(slug: $categorySlug) {
    id
    department {
      id
      type
      slug
    }
  }
}
    `;
export type DepartmentSlugByCategorySlugComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DepartmentSlugByCategorySlugQuery, DepartmentSlugByCategorySlugQueryVariables>, 'query'> & ({ variables: DepartmentSlugByCategorySlugQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DepartmentSlugByCategorySlugComponent = (props: DepartmentSlugByCategorySlugComponentProps) => (
      <ApolloReactComponents.Query<DepartmentSlugByCategorySlugQuery, DepartmentSlugByCategorySlugQueryVariables> query={DepartmentSlugByCategorySlugDocument} {...props} />
    );
    

/**
 * __useDepartmentSlugByCategorySlugQuery__
 *
 * To run a query within a React component, call `useDepartmentSlugByCategorySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentSlugByCategorySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentSlugByCategorySlugQuery({
 *   variables: {
 *      categorySlug: // value for 'categorySlug'
 *   },
 * });
 */
export function useDepartmentSlugByCategorySlugQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DepartmentSlugByCategorySlugQuery, DepartmentSlugByCategorySlugQueryVariables>) {
        return ApolloReactHooks.useQuery<DepartmentSlugByCategorySlugQuery, DepartmentSlugByCategorySlugQueryVariables>(DepartmentSlugByCategorySlugDocument, baseOptions);
      }
export function useDepartmentSlugByCategorySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentSlugByCategorySlugQuery, DepartmentSlugByCategorySlugQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DepartmentSlugByCategorySlugQuery, DepartmentSlugByCategorySlugQueryVariables>(DepartmentSlugByCategorySlugDocument, baseOptions);
        }
export type DepartmentSlugByCategorySlugQueryHookResult = ReturnType<typeof useDepartmentSlugByCategorySlugQuery>;
export type DepartmentSlugByCategorySlugLazyQueryHookResult = ReturnType<typeof useDepartmentSlugByCategorySlugLazyQuery>;
export type DepartmentSlugByCategorySlugQueryResult = ApolloReactCommon.QueryResult<DepartmentSlugByCategorySlugQuery, DepartmentSlugByCategorySlugQueryVariables>;
export const ExpertDepartmentBySlugDocument = gql`
    query ExpertDepartmentBySlug($slug: String!) {
  departmentBySlug(slug: $slug) {
    id
    displayName
    type
    topLevelCategory {
      id
    }
  }
}
    `;
export type ExpertDepartmentBySlugComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertDepartmentBySlugQuery, ExpertDepartmentBySlugQueryVariables>, 'query'> & ({ variables: ExpertDepartmentBySlugQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertDepartmentBySlugComponent = (props: ExpertDepartmentBySlugComponentProps) => (
      <ApolloReactComponents.Query<ExpertDepartmentBySlugQuery, ExpertDepartmentBySlugQueryVariables> query={ExpertDepartmentBySlugDocument} {...props} />
    );
    

/**
 * __useExpertDepartmentBySlugQuery__
 *
 * To run a query within a React component, call `useExpertDepartmentBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertDepartmentBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertDepartmentBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useExpertDepartmentBySlugQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertDepartmentBySlugQuery, ExpertDepartmentBySlugQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertDepartmentBySlugQuery, ExpertDepartmentBySlugQueryVariables>(ExpertDepartmentBySlugDocument, baseOptions);
      }
export function useExpertDepartmentBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertDepartmentBySlugQuery, ExpertDepartmentBySlugQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertDepartmentBySlugQuery, ExpertDepartmentBySlugQueryVariables>(ExpertDepartmentBySlugDocument, baseOptions);
        }
export type ExpertDepartmentBySlugQueryHookResult = ReturnType<typeof useExpertDepartmentBySlugQuery>;
export type ExpertDepartmentBySlugLazyQueryHookResult = ReturnType<typeof useExpertDepartmentBySlugLazyQuery>;
export type ExpertDepartmentBySlugQueryResult = ApolloReactCommon.QueryResult<ExpertDepartmentBySlugQuery, ExpertDepartmentBySlugQueryVariables>;
export const FeaturedExpertsForDepartmentDocument = gql`
    query FeaturedExpertsForDepartment($query: ExpertSearchQuery!, $after: String) {
  expertSearchConnection(query: $query, sortBy: FEATURED, first: 8, last: 8, after: $after) {
    count
    pageInfo {
      ...PageInfo
    }
    edges {
      cursor
      node {
        ...FeaturedExpert
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${FeaturedExpertFragmentDoc}`;
export type FeaturedExpertsForDepartmentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FeaturedExpertsForDepartmentQuery, FeaturedExpertsForDepartmentQueryVariables>, 'query'> & ({ variables: FeaturedExpertsForDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FeaturedExpertsForDepartmentComponent = (props: FeaturedExpertsForDepartmentComponentProps) => (
      <ApolloReactComponents.Query<FeaturedExpertsForDepartmentQuery, FeaturedExpertsForDepartmentQueryVariables> query={FeaturedExpertsForDepartmentDocument} {...props} />
    );
    

/**
 * __useFeaturedExpertsForDepartmentQuery__
 *
 * To run a query within a React component, call `useFeaturedExpertsForDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedExpertsForDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedExpertsForDepartmentQuery({
 *   variables: {
 *      query: // value for 'query'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFeaturedExpertsForDepartmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeaturedExpertsForDepartmentQuery, FeaturedExpertsForDepartmentQueryVariables>) {
        return ApolloReactHooks.useQuery<FeaturedExpertsForDepartmentQuery, FeaturedExpertsForDepartmentQueryVariables>(FeaturedExpertsForDepartmentDocument, baseOptions);
      }
export function useFeaturedExpertsForDepartmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeaturedExpertsForDepartmentQuery, FeaturedExpertsForDepartmentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FeaturedExpertsForDepartmentQuery, FeaturedExpertsForDepartmentQueryVariables>(FeaturedExpertsForDepartmentDocument, baseOptions);
        }
export type FeaturedExpertsForDepartmentQueryHookResult = ReturnType<typeof useFeaturedExpertsForDepartmentQuery>;
export type FeaturedExpertsForDepartmentLazyQueryHookResult = ReturnType<typeof useFeaturedExpertsForDepartmentLazyQuery>;
export type FeaturedExpertsForDepartmentQueryResult = ApolloReactCommon.QueryResult<FeaturedExpertsForDepartmentQuery, FeaturedExpertsForDepartmentQueryVariables>;
export const InitiateAffirmPaymentForOrderDocument = gql`
    mutation InitiateAffirmPaymentForOrder($input: InitiateAffirmPaymentForOrderInput!) {
  initiateAffirmPaymentForOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
    checkoutData
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type InitiateAffirmPaymentForOrderMutationFn = ApolloReactCommon.MutationFunction<InitiateAffirmPaymentForOrderMutation, InitiateAffirmPaymentForOrderMutationVariables>;
export type InitiateAffirmPaymentForOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InitiateAffirmPaymentForOrderMutation, InitiateAffirmPaymentForOrderMutationVariables>, 'mutation'>;

    export const InitiateAffirmPaymentForOrderComponent = (props: InitiateAffirmPaymentForOrderComponentProps) => (
      <ApolloReactComponents.Mutation<InitiateAffirmPaymentForOrderMutation, InitiateAffirmPaymentForOrderMutationVariables> mutation={InitiateAffirmPaymentForOrderDocument} {...props} />
    );
    

/**
 * __useInitiateAffirmPaymentForOrderMutation__
 *
 * To run a mutation, you first call `useInitiateAffirmPaymentForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateAffirmPaymentForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateAffirmPaymentForOrderMutation, { data, loading, error }] = useInitiateAffirmPaymentForOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateAffirmPaymentForOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InitiateAffirmPaymentForOrderMutation, InitiateAffirmPaymentForOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<InitiateAffirmPaymentForOrderMutation, InitiateAffirmPaymentForOrderMutationVariables>(InitiateAffirmPaymentForOrderDocument, baseOptions);
      }
export type InitiateAffirmPaymentForOrderMutationHookResult = ReturnType<typeof useInitiateAffirmPaymentForOrderMutation>;
export type InitiateAffirmPaymentForOrderMutationResult = ApolloReactCommon.MutationResult<InitiateAffirmPaymentForOrderMutation>;
export type InitiateAffirmPaymentForOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<InitiateAffirmPaymentForOrderMutation, InitiateAffirmPaymentForOrderMutationVariables>;
export const InitiateAfterpayPaymentForOrderDocument = gql`
    mutation InitiateAfterpayPaymentForOrder($input: InitiateAfterpayPaymentForOrderInput!) {
  initiateAfterpayPaymentForOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
    orderToken
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type InitiateAfterpayPaymentForOrderMutationFn = ApolloReactCommon.MutationFunction<InitiateAfterpayPaymentForOrderMutation, InitiateAfterpayPaymentForOrderMutationVariables>;
export type InitiateAfterpayPaymentForOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InitiateAfterpayPaymentForOrderMutation, InitiateAfterpayPaymentForOrderMutationVariables>, 'mutation'>;

    export const InitiateAfterpayPaymentForOrderComponent = (props: InitiateAfterpayPaymentForOrderComponentProps) => (
      <ApolloReactComponents.Mutation<InitiateAfterpayPaymentForOrderMutation, InitiateAfterpayPaymentForOrderMutationVariables> mutation={InitiateAfterpayPaymentForOrderDocument} {...props} />
    );
    

/**
 * __useInitiateAfterpayPaymentForOrderMutation__
 *
 * To run a mutation, you first call `useInitiateAfterpayPaymentForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateAfterpayPaymentForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateAfterpayPaymentForOrderMutation, { data, loading, error }] = useInitiateAfterpayPaymentForOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateAfterpayPaymentForOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InitiateAfterpayPaymentForOrderMutation, InitiateAfterpayPaymentForOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<InitiateAfterpayPaymentForOrderMutation, InitiateAfterpayPaymentForOrderMutationVariables>(InitiateAfterpayPaymentForOrderDocument, baseOptions);
      }
export type InitiateAfterpayPaymentForOrderMutationHookResult = ReturnType<typeof useInitiateAfterpayPaymentForOrderMutation>;
export type InitiateAfterpayPaymentForOrderMutationResult = ApolloReactCommon.MutationResult<InitiateAfterpayPaymentForOrderMutation>;
export type InitiateAfterpayPaymentForOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<InitiateAfterpayPaymentForOrderMutation, InitiateAfterpayPaymentForOrderMutationVariables>;
export const SyncOrderDocument = gql`
    mutation SyncOrder($input: SyncOrderInput!) {
  syncOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type SyncOrderMutationFn = ApolloReactCommon.MutationFunction<SyncOrderMutation, SyncOrderMutationVariables>;
export type SyncOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SyncOrderMutation, SyncOrderMutationVariables>, 'mutation'>;

    export const SyncOrderComponent = (props: SyncOrderComponentProps) => (
      <ApolloReactComponents.Mutation<SyncOrderMutation, SyncOrderMutationVariables> mutation={SyncOrderDocument} {...props} />
    );
    

/**
 * __useSyncOrderMutation__
 *
 * To run a mutation, you first call `useSyncOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncOrderMutation, { data, loading, error }] = useSyncOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncOrderMutation, SyncOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<SyncOrderMutation, SyncOrderMutationVariables>(SyncOrderDocument, baseOptions);
      }
export type SyncOrderMutationHookResult = ReturnType<typeof useSyncOrderMutation>;
export type SyncOrderMutationResult = ApolloReactCommon.MutationResult<SyncOrderMutation>;
export type SyncOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncOrderMutation, SyncOrderMutationVariables>;
export const GetOrderDocument = gql`
    query GetOrder($id: OrderId!) {
  order(id: $id) {
    ...OrderWithLineItems
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type GetOrderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetOrderQuery, GetOrderQueryVariables>, 'query'> & ({ variables: GetOrderQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetOrderComponent = (props: GetOrderComponentProps) => (
      <ApolloReactComponents.Query<GetOrderQuery, GetOrderQueryVariables> query={GetOrderDocument} {...props} />
    );
    

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, baseOptions);
      }
export function useGetOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, baseOptions);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderQueryResult = ApolloReactCommon.QueryResult<GetOrderQuery, GetOrderQueryVariables>;
export const OrderForRatingDocument = gql`
    query OrderForRating($id: OrderId!) {
  order(id: $id) {
    id
    state
    associatedLeads {
      id
      expert {
        id
        expertAttributes {
          placeholderExpert
        }
      }
    }
    user {
      id
      expertReviews {
        id
        expert {
          id
        }
      }
    }
  }
}
    `;
export type OrderForRatingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrderForRatingQuery, OrderForRatingQueryVariables>, 'query'> & ({ variables: OrderForRatingQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrderForRatingComponent = (props: OrderForRatingComponentProps) => (
      <ApolloReactComponents.Query<OrderForRatingQuery, OrderForRatingQueryVariables> query={OrderForRatingDocument} {...props} />
    );
    

/**
 * __useOrderForRatingQuery__
 *
 * To run a query within a React component, call `useOrderForRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderForRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderForRatingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderForRatingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrderForRatingQuery, OrderForRatingQueryVariables>) {
        return ApolloReactHooks.useQuery<OrderForRatingQuery, OrderForRatingQueryVariables>(OrderForRatingDocument, baseOptions);
      }
export function useOrderForRatingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderForRatingQuery, OrderForRatingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OrderForRatingQuery, OrderForRatingQueryVariables>(OrderForRatingDocument, baseOptions);
        }
export type OrderForRatingQueryHookResult = ReturnType<typeof useOrderForRatingQuery>;
export type OrderForRatingLazyQueryHookResult = ReturnType<typeof useOrderForRatingLazyQuery>;
export type OrderForRatingQueryResult = ApolloReactCommon.QueryResult<OrderForRatingQuery, OrderForRatingQueryVariables>;
export const OrderChargingStatusDocument = gql`
    query OrderChargingStatus($id: OrderId!) {
  order(id: $id) {
    ...OrderWithLineItems
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type OrderChargingStatusComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrderChargingStatusQuery, OrderChargingStatusQueryVariables>, 'query'> & ({ variables: OrderChargingStatusQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrderChargingStatusComponent = (props: OrderChargingStatusComponentProps) => (
      <ApolloReactComponents.Query<OrderChargingStatusQuery, OrderChargingStatusQueryVariables> query={OrderChargingStatusDocument} {...props} />
    );
    

/**
 * __useOrderChargingStatusQuery__
 *
 * To run a query within a React component, call `useOrderChargingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderChargingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderChargingStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderChargingStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrderChargingStatusQuery, OrderChargingStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<OrderChargingStatusQuery, OrderChargingStatusQueryVariables>(OrderChargingStatusDocument, baseOptions);
      }
export function useOrderChargingStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderChargingStatusQuery, OrderChargingStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OrderChargingStatusQuery, OrderChargingStatusQueryVariables>(OrderChargingStatusDocument, baseOptions);
        }
export type OrderChargingStatusQueryHookResult = ReturnType<typeof useOrderChargingStatusQuery>;
export type OrderChargingStatusLazyQueryHookResult = ReturnType<typeof useOrderChargingStatusLazyQuery>;
export type OrderChargingStatusQueryResult = ApolloReactCommon.QueryResult<OrderChargingStatusQuery, OrderChargingStatusQueryVariables>;
export const PaymentSourceForReviewDocument = gql`
    query PaymentSourceForReview($id: PaymentSourceId!) {
  paymentSource(id: $id) {
    ...PaymentSource
  }
}
    ${PaymentSourceFragmentDoc}`;
export type PaymentSourceForReviewComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PaymentSourceForReviewQuery, PaymentSourceForReviewQueryVariables>, 'query'> & ({ variables: PaymentSourceForReviewQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PaymentSourceForReviewComponent = (props: PaymentSourceForReviewComponentProps) => (
      <ApolloReactComponents.Query<PaymentSourceForReviewQuery, PaymentSourceForReviewQueryVariables> query={PaymentSourceForReviewDocument} {...props} />
    );
    

/**
 * __usePaymentSourceForReviewQuery__
 *
 * To run a query within a React component, call `usePaymentSourceForReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentSourceForReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentSourceForReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentSourceForReviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PaymentSourceForReviewQuery, PaymentSourceForReviewQueryVariables>) {
        return ApolloReactHooks.useQuery<PaymentSourceForReviewQuery, PaymentSourceForReviewQueryVariables>(PaymentSourceForReviewDocument, baseOptions);
      }
export function usePaymentSourceForReviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaymentSourceForReviewQuery, PaymentSourceForReviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PaymentSourceForReviewQuery, PaymentSourceForReviewQueryVariables>(PaymentSourceForReviewDocument, baseOptions);
        }
export type PaymentSourceForReviewQueryHookResult = ReturnType<typeof usePaymentSourceForReviewQuery>;
export type PaymentSourceForReviewLazyQueryHookResult = ReturnType<typeof usePaymentSourceForReviewLazyQuery>;
export type PaymentSourceForReviewQueryResult = ApolloReactCommon.QueryResult<PaymentSourceForReviewQuery, PaymentSourceForReviewQueryVariables>;
export const InitiatePaypalPaymentForOrderDocument = gql`
    mutation InitiatePaypalPaymentForOrder($input: InitiatePaypalPaymentForOrderInput!) {
  initiatePaypalPaymentForOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
    paymentId
    authorizationUrl
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type InitiatePaypalPaymentForOrderMutationFn = ApolloReactCommon.MutationFunction<InitiatePaypalPaymentForOrderMutation, InitiatePaypalPaymentForOrderMutationVariables>;
export type InitiatePaypalPaymentForOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InitiatePaypalPaymentForOrderMutation, InitiatePaypalPaymentForOrderMutationVariables>, 'mutation'>;

    export const InitiatePaypalPaymentForOrderComponent = (props: InitiatePaypalPaymentForOrderComponentProps) => (
      <ApolloReactComponents.Mutation<InitiatePaypalPaymentForOrderMutation, InitiatePaypalPaymentForOrderMutationVariables> mutation={InitiatePaypalPaymentForOrderDocument} {...props} />
    );
    

/**
 * __useInitiatePaypalPaymentForOrderMutation__
 *
 * To run a mutation, you first call `useInitiatePaypalPaymentForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiatePaypalPaymentForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiatePaypalPaymentForOrderMutation, { data, loading, error }] = useInitiatePaypalPaymentForOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiatePaypalPaymentForOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InitiatePaypalPaymentForOrderMutation, InitiatePaypalPaymentForOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<InitiatePaypalPaymentForOrderMutation, InitiatePaypalPaymentForOrderMutationVariables>(InitiatePaypalPaymentForOrderDocument, baseOptions);
      }
export type InitiatePaypalPaymentForOrderMutationHookResult = ReturnType<typeof useInitiatePaypalPaymentForOrderMutation>;
export type InitiatePaypalPaymentForOrderMutationResult = ApolloReactCommon.MutationResult<InitiatePaypalPaymentForOrderMutation>;
export type InitiatePaypalPaymentForOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<InitiatePaypalPaymentForOrderMutation, InitiatePaypalPaymentForOrderMutationVariables>;
export const AddPromotionToOrderDocument = gql`
    mutation AddPromotionToOrder($id: OrderId!, $promotionCode: String!) {
  addPromotionToOrder(input: {id: $id, promotionCode: $promotionCode}) {
    order {
      ...OrderWithLineItems
    }
    hasError
    errorMessage
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type AddPromotionToOrderMutationFn = ApolloReactCommon.MutationFunction<AddPromotionToOrderMutation, AddPromotionToOrderMutationVariables>;
export type AddPromotionToOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddPromotionToOrderMutation, AddPromotionToOrderMutationVariables>, 'mutation'>;

    export const AddPromotionToOrderComponent = (props: AddPromotionToOrderComponentProps) => (
      <ApolloReactComponents.Mutation<AddPromotionToOrderMutation, AddPromotionToOrderMutationVariables> mutation={AddPromotionToOrderDocument} {...props} />
    );
    

/**
 * __useAddPromotionToOrderMutation__
 *
 * To run a mutation, you first call `useAddPromotionToOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPromotionToOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPromotionToOrderMutation, { data, loading, error }] = useAddPromotionToOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      promotionCode: // value for 'promotionCode'
 *   },
 * });
 */
export function useAddPromotionToOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddPromotionToOrderMutation, AddPromotionToOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<AddPromotionToOrderMutation, AddPromotionToOrderMutationVariables>(AddPromotionToOrderDocument, baseOptions);
      }
export type AddPromotionToOrderMutationHookResult = ReturnType<typeof useAddPromotionToOrderMutation>;
export type AddPromotionToOrderMutationResult = ApolloReactCommon.MutationResult<AddPromotionToOrderMutation>;
export type AddPromotionToOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<AddPromotionToOrderMutation, AddPromotionToOrderMutationVariables>;
export const DeletePaymentSourceDocument = gql`
    mutation DeletePaymentSource($id: PaymentSourceId!) {
  deletePaymentSource(id: $id) {
    error
    success
  }
}
    `;
export type DeletePaymentSourceMutationFn = ApolloReactCommon.MutationFunction<DeletePaymentSourceMutation, DeletePaymentSourceMutationVariables>;
export type DeletePaymentSourceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeletePaymentSourceMutation, DeletePaymentSourceMutationVariables>, 'mutation'>;

    export const DeletePaymentSourceComponent = (props: DeletePaymentSourceComponentProps) => (
      <ApolloReactComponents.Mutation<DeletePaymentSourceMutation, DeletePaymentSourceMutationVariables> mutation={DeletePaymentSourceDocument} {...props} />
    );
    

/**
 * __useDeletePaymentSourceMutation__
 *
 * To run a mutation, you first call `useDeletePaymentSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentSourceMutation, { data, loading, error }] = useDeletePaymentSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePaymentSourceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePaymentSourceMutation, DeletePaymentSourceMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePaymentSourceMutation, DeletePaymentSourceMutationVariables>(DeletePaymentSourceDocument, baseOptions);
      }
export type DeletePaymentSourceMutationHookResult = ReturnType<typeof useDeletePaymentSourceMutation>;
export type DeletePaymentSourceMutationResult = ApolloReactCommon.MutationResult<DeletePaymentSourceMutation>;
export type DeletePaymentSourceMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePaymentSourceMutation, DeletePaymentSourceMutationVariables>;
export const UpdateAddressPreferencesDocument = gql`
    mutation UpdateAddressPreferences($input: UpdateAddressPreferencesInput!) {
  updateAddressPreferences(input: $input) {
    updatedAddress {
      ...Address
    }
    error
  }
}
    ${AddressFragmentDoc}`;
export type UpdateAddressPreferencesMutationFn = ApolloReactCommon.MutationFunction<UpdateAddressPreferencesMutation, UpdateAddressPreferencesMutationVariables>;
export type UpdateAddressPreferencesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateAddressPreferencesMutation, UpdateAddressPreferencesMutationVariables>, 'mutation'>;

    export const UpdateAddressPreferencesComponent = (props: UpdateAddressPreferencesComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateAddressPreferencesMutation, UpdateAddressPreferencesMutationVariables> mutation={UpdateAddressPreferencesDocument} {...props} />
    );
    

/**
 * __useUpdateAddressPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateAddressPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressPreferencesMutation, { data, loading, error }] = useUpdateAddressPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAddressPreferencesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAddressPreferencesMutation, UpdateAddressPreferencesMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAddressPreferencesMutation, UpdateAddressPreferencesMutationVariables>(UpdateAddressPreferencesDocument, baseOptions);
      }
export type UpdateAddressPreferencesMutationHookResult = ReturnType<typeof useUpdateAddressPreferencesMutation>;
export type UpdateAddressPreferencesMutationResult = ApolloReactCommon.MutationResult<UpdateAddressPreferencesMutation>;
export type UpdateAddressPreferencesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAddressPreferencesMutation, UpdateAddressPreferencesMutationVariables>;
export const UpdateOrderShippingAddressDocument = gql`
    mutation UpdateOrderShippingAddress($input: UpdateOrderShippingAddressInput!) {
  updateOrderShippingAddress(input: $input) {
    order {
      ...OrderWithLineItems
    }
    hasError
    errorMessage
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type UpdateOrderShippingAddressMutationFn = ApolloReactCommon.MutationFunction<UpdateOrderShippingAddressMutation, UpdateOrderShippingAddressMutationVariables>;
export type UpdateOrderShippingAddressComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOrderShippingAddressMutation, UpdateOrderShippingAddressMutationVariables>, 'mutation'>;

    export const UpdateOrderShippingAddressComponent = (props: UpdateOrderShippingAddressComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOrderShippingAddressMutation, UpdateOrderShippingAddressMutationVariables> mutation={UpdateOrderShippingAddressDocument} {...props} />
    );
    

/**
 * __useUpdateOrderShippingAddressMutation__
 *
 * To run a mutation, you first call `useUpdateOrderShippingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderShippingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderShippingAddressMutation, { data, loading, error }] = useUpdateOrderShippingAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderShippingAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderShippingAddressMutation, UpdateOrderShippingAddressMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateOrderShippingAddressMutation, UpdateOrderShippingAddressMutationVariables>(UpdateOrderShippingAddressDocument, baseOptions);
      }
export type UpdateOrderShippingAddressMutationHookResult = ReturnType<typeof useUpdateOrderShippingAddressMutation>;
export type UpdateOrderShippingAddressMutationResult = ApolloReactCommon.MutationResult<UpdateOrderShippingAddressMutation>;
export type UpdateOrderShippingAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrderShippingAddressMutation, UpdateOrderShippingAddressMutationVariables>;
export const OrderShippingCostDocument = gql`
    query OrderShippingCost($id: OrderId!, $orderShippingCostAddress: OrderShippingCostAddressInput) {
  orderShippingCost(id: $id, orderShippingCostAddress: $orderShippingCostAddress) {
    shippingMethodCosts {
      ...ShippingMethodCost
    }
  }
}
    ${ShippingMethodCostFragmentDoc}`;
export type OrderShippingCostComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrderShippingCostQuery, OrderShippingCostQueryVariables>, 'query'> & ({ variables: OrderShippingCostQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrderShippingCostComponent = (props: OrderShippingCostComponentProps) => (
      <ApolloReactComponents.Query<OrderShippingCostQuery, OrderShippingCostQueryVariables> query={OrderShippingCostDocument} {...props} />
    );
    

/**
 * __useOrderShippingCostQuery__
 *
 * To run a query within a React component, call `useOrderShippingCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderShippingCostQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderShippingCostQuery({
 *   variables: {
 *      id: // value for 'id'
 *      orderShippingCostAddress: // value for 'orderShippingCostAddress'
 *   },
 * });
 */
export function useOrderShippingCostQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrderShippingCostQuery, OrderShippingCostQueryVariables>) {
        return ApolloReactHooks.useQuery<OrderShippingCostQuery, OrderShippingCostQueryVariables>(OrderShippingCostDocument, baseOptions);
      }
export function useOrderShippingCostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderShippingCostQuery, OrderShippingCostQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OrderShippingCostQuery, OrderShippingCostQueryVariables>(OrderShippingCostDocument, baseOptions);
        }
export type OrderShippingCostQueryHookResult = ReturnType<typeof useOrderShippingCostQuery>;
export type OrderShippingCostLazyQueryHookResult = ReturnType<typeof useOrderShippingCostLazyQuery>;
export type OrderShippingCostQueryResult = ApolloReactCommon.QueryResult<OrderShippingCostQuery, OrderShippingCostQueryVariables>;
export const UpdateShippingMethodDocument = gql`
    mutation UpdateShippingMethod($orderId: OrderId!, $shippingMethod: ShippingMethod!) {
  updateShippingMethod(input: {orderId: $orderId, shippingMethod: $shippingMethod}) {
    order {
      id
      shippingMethod
      lineItems {
        ...OrderLineItem
      }
      totalShippingCost: totalCostOnlyIncluding(costComponents: [SHIPMENT]) {
        ...MonetaryAmount
      }
    }
  }
}
    ${OrderLineItemFragmentDoc}
${MonetaryAmountFragmentDoc}`;
export type UpdateShippingMethodMutationFn = ApolloReactCommon.MutationFunction<UpdateShippingMethodMutation, UpdateShippingMethodMutationVariables>;
export type UpdateShippingMethodComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateShippingMethodMutation, UpdateShippingMethodMutationVariables>, 'mutation'>;

    export const UpdateShippingMethodComponent = (props: UpdateShippingMethodComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateShippingMethodMutation, UpdateShippingMethodMutationVariables> mutation={UpdateShippingMethodDocument} {...props} />
    );
    

/**
 * __useUpdateShippingMethodMutation__
 *
 * To run a mutation, you first call `useUpdateShippingMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShippingMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShippingMethodMutation, { data, loading, error }] = useUpdateShippingMethodMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      shippingMethod: // value for 'shippingMethod'
 *   },
 * });
 */
export function useUpdateShippingMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateShippingMethodMutation, UpdateShippingMethodMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateShippingMethodMutation, UpdateShippingMethodMutationVariables>(UpdateShippingMethodDocument, baseOptions);
      }
export type UpdateShippingMethodMutationHookResult = ReturnType<typeof useUpdateShippingMethodMutation>;
export type UpdateShippingMethodMutationResult = ApolloReactCommon.MutationResult<UpdateShippingMethodMutation>;
export type UpdateShippingMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateShippingMethodMutation, UpdateShippingMethodMutationVariables>;
export const ReusablePaymentSourcesDocument = gql`
    query ReusablePaymentSources {
  reusablePaymentSources {
    ...PaymentSource
  }
}
    ${PaymentSourceFragmentDoc}`;
export type ReusablePaymentSourcesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ReusablePaymentSourcesQuery, ReusablePaymentSourcesQueryVariables>, 'query'>;

    export const ReusablePaymentSourcesComponent = (props: ReusablePaymentSourcesComponentProps) => (
      <ApolloReactComponents.Query<ReusablePaymentSourcesQuery, ReusablePaymentSourcesQueryVariables> query={ReusablePaymentSourcesDocument} {...props} />
    );
    

/**
 * __useReusablePaymentSourcesQuery__
 *
 * To run a query within a React component, call `useReusablePaymentSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReusablePaymentSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReusablePaymentSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useReusablePaymentSourcesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReusablePaymentSourcesQuery, ReusablePaymentSourcesQueryVariables>) {
        return ApolloReactHooks.useQuery<ReusablePaymentSourcesQuery, ReusablePaymentSourcesQueryVariables>(ReusablePaymentSourcesDocument, baseOptions);
      }
export function useReusablePaymentSourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReusablePaymentSourcesQuery, ReusablePaymentSourcesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ReusablePaymentSourcesQuery, ReusablePaymentSourcesQueryVariables>(ReusablePaymentSourcesDocument, baseOptions);
        }
export type ReusablePaymentSourcesQueryHookResult = ReturnType<typeof useReusablePaymentSourcesQuery>;
export type ReusablePaymentSourcesLazyQueryHookResult = ReturnType<typeof useReusablePaymentSourcesLazyQuery>;
export type ReusablePaymentSourcesQueryResult = ApolloReactCommon.QueryResult<ReusablePaymentSourcesQuery, ReusablePaymentSourcesQueryVariables>;
export const InitiateWireTransferForOrderDocument = gql`
    mutation InitiateWireTransferForOrder($input: InitiateWireTransferPaymentForOrderInput!) {
  initiateWireTransferPaymentForOrder(input: $input) {
    paymentSource {
      id
    }
  }
}
    `;
export type InitiateWireTransferForOrderMutationFn = ApolloReactCommon.MutationFunction<InitiateWireTransferForOrderMutation, InitiateWireTransferForOrderMutationVariables>;
export type InitiateWireTransferForOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InitiateWireTransferForOrderMutation, InitiateWireTransferForOrderMutationVariables>, 'mutation'>;

    export const InitiateWireTransferForOrderComponent = (props: InitiateWireTransferForOrderComponentProps) => (
      <ApolloReactComponents.Mutation<InitiateWireTransferForOrderMutation, InitiateWireTransferForOrderMutationVariables> mutation={InitiateWireTransferForOrderDocument} {...props} />
    );
    

/**
 * __useInitiateWireTransferForOrderMutation__
 *
 * To run a mutation, you first call `useInitiateWireTransferForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateWireTransferForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateWireTransferForOrderMutation, { data, loading, error }] = useInitiateWireTransferForOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateWireTransferForOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InitiateWireTransferForOrderMutation, InitiateWireTransferForOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<InitiateWireTransferForOrderMutation, InitiateWireTransferForOrderMutationVariables>(InitiateWireTransferForOrderDocument, baseOptions);
      }
export type InitiateWireTransferForOrderMutationHookResult = ReturnType<typeof useInitiateWireTransferForOrderMutation>;
export type InitiateWireTransferForOrderMutationResult = ApolloReactCommon.MutationResult<InitiateWireTransferForOrderMutation>;
export type InitiateWireTransferForOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<InitiateWireTransferForOrderMutation, InitiateWireTransferForOrderMutationVariables>;
export const SubmitWireOrderDocument = gql`
    mutation SubmitWireOrder($input: SubmitOrderInput!) {
  submitOrder(input: $input) {
    order {
      ...TrackableOrder
    }
  }
}
    ${TrackableOrderFragmentDoc}`;
export type SubmitWireOrderMutationFn = ApolloReactCommon.MutationFunction<SubmitWireOrderMutation, SubmitWireOrderMutationVariables>;
export type SubmitWireOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitWireOrderMutation, SubmitWireOrderMutationVariables>, 'mutation'>;

    export const SubmitWireOrderComponent = (props: SubmitWireOrderComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitWireOrderMutation, SubmitWireOrderMutationVariables> mutation={SubmitWireOrderDocument} {...props} />
    );
    

/**
 * __useSubmitWireOrderMutation__
 *
 * To run a mutation, you first call `useSubmitWireOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitWireOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitWireOrderMutation, { data, loading, error }] = useSubmitWireOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitWireOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitWireOrderMutation, SubmitWireOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitWireOrderMutation, SubmitWireOrderMutationVariables>(SubmitWireOrderDocument, baseOptions);
      }
export type SubmitWireOrderMutationHookResult = ReturnType<typeof useSubmitWireOrderMutation>;
export type SubmitWireOrderMutationResult = ApolloReactCommon.MutationResult<SubmitWireOrderMutation>;
export type SubmitWireOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitWireOrderMutation, SubmitWireOrderMutationVariables>;
export const AddTipToOrderDocument = gql`
    mutation AddTipToOrder($input: AddTipToOrderInput!) {
  addTipToOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type AddTipToOrderMutationFn = ApolloReactCommon.MutationFunction<AddTipToOrderMutation, AddTipToOrderMutationVariables>;
export type AddTipToOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddTipToOrderMutation, AddTipToOrderMutationVariables>, 'mutation'>;

    export const AddTipToOrderComponent = (props: AddTipToOrderComponentProps) => (
      <ApolloReactComponents.Mutation<AddTipToOrderMutation, AddTipToOrderMutationVariables> mutation={AddTipToOrderDocument} {...props} />
    );
    

/**
 * __useAddTipToOrderMutation__
 *
 * To run a mutation, you first call `useAddTipToOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTipToOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTipToOrderMutation, { data, loading, error }] = useAddTipToOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTipToOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTipToOrderMutation, AddTipToOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<AddTipToOrderMutation, AddTipToOrderMutationVariables>(AddTipToOrderDocument, baseOptions);
      }
export type AddTipToOrderMutationHookResult = ReturnType<typeof useAddTipToOrderMutation>;
export type AddTipToOrderMutationResult = ApolloReactCommon.MutationResult<AddTipToOrderMutation>;
export type AddTipToOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<AddTipToOrderMutation, AddTipToOrderMutationVariables>;
export const RecommendTipPercentagesForOrderDocument = gql`
    query RecommendTipPercentagesForOrder($id: OrderId!) {
  recommendTipPercentagesForOrder(id: $id) {
    ...ExpertTipPercentage
  }
}
    ${ExpertTipPercentageFragmentDoc}`;
export type RecommendTipPercentagesForOrderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecommendTipPercentagesForOrderQuery, RecommendTipPercentagesForOrderQueryVariables>, 'query'> & ({ variables: RecommendTipPercentagesForOrderQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RecommendTipPercentagesForOrderComponent = (props: RecommendTipPercentagesForOrderComponentProps) => (
      <ApolloReactComponents.Query<RecommendTipPercentagesForOrderQuery, RecommendTipPercentagesForOrderQueryVariables> query={RecommendTipPercentagesForOrderDocument} {...props} />
    );
    

/**
 * __useRecommendTipPercentagesForOrderQuery__
 *
 * To run a query within a React component, call `useRecommendTipPercentagesForOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendTipPercentagesForOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendTipPercentagesForOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecommendTipPercentagesForOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RecommendTipPercentagesForOrderQuery, RecommendTipPercentagesForOrderQueryVariables>) {
        return ApolloReactHooks.useQuery<RecommendTipPercentagesForOrderQuery, RecommendTipPercentagesForOrderQueryVariables>(RecommendTipPercentagesForOrderDocument, baseOptions);
      }
export function useRecommendTipPercentagesForOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecommendTipPercentagesForOrderQuery, RecommendTipPercentagesForOrderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RecommendTipPercentagesForOrderQuery, RecommendTipPercentagesForOrderQueryVariables>(RecommendTipPercentagesForOrderDocument, baseOptions);
        }
export type RecommendTipPercentagesForOrderQueryHookResult = ReturnType<typeof useRecommendTipPercentagesForOrderQuery>;
export type RecommendTipPercentagesForOrderLazyQueryHookResult = ReturnType<typeof useRecommendTipPercentagesForOrderLazyQuery>;
export type RecommendTipPercentagesForOrderQueryResult = ApolloReactCommon.QueryResult<RecommendTipPercentagesForOrderQuery, RecommendTipPercentagesForOrderQueryVariables>;
export const CancelPaymentRequestForOrderDocument = gql`
    mutation CancelPaymentRequestForOrder($input: CancelPaymentRequestForOrderInput!) {
  cancelPaymentRequestForOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type CancelPaymentRequestForOrderMutationFn = ApolloReactCommon.MutationFunction<CancelPaymentRequestForOrderMutation, CancelPaymentRequestForOrderMutationVariables>;
export type CancelPaymentRequestForOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CancelPaymentRequestForOrderMutation, CancelPaymentRequestForOrderMutationVariables>, 'mutation'>;

    export const CancelPaymentRequestForOrderComponent = (props: CancelPaymentRequestForOrderComponentProps) => (
      <ApolloReactComponents.Mutation<CancelPaymentRequestForOrderMutation, CancelPaymentRequestForOrderMutationVariables> mutation={CancelPaymentRequestForOrderDocument} {...props} />
    );
    

/**
 * __useCancelPaymentRequestForOrderMutation__
 *
 * To run a mutation, you first call `useCancelPaymentRequestForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPaymentRequestForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPaymentRequestForOrderMutation, { data, loading, error }] = useCancelPaymentRequestForOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelPaymentRequestForOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelPaymentRequestForOrderMutation, CancelPaymentRequestForOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<CancelPaymentRequestForOrderMutation, CancelPaymentRequestForOrderMutationVariables>(CancelPaymentRequestForOrderDocument, baseOptions);
      }
export type CancelPaymentRequestForOrderMutationHookResult = ReturnType<typeof useCancelPaymentRequestForOrderMutation>;
export type CancelPaymentRequestForOrderMutationResult = ApolloReactCommon.MutationResult<CancelPaymentRequestForOrderMutation>;
export type CancelPaymentRequestForOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelPaymentRequestForOrderMutation, CancelPaymentRequestForOrderMutationVariables>;
export const DeleteAddressDocument = gql`
    mutation DeleteAddress($input: DeleteAddressInput!) {
  deleteAddress(input: $input) {
    error
    success
  }
}
    `;
export type DeleteAddressMutationFn = ApolloReactCommon.MutationFunction<DeleteAddressMutation, DeleteAddressMutationVariables>;
export type DeleteAddressComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteAddressMutation, DeleteAddressMutationVariables>, 'mutation'>;

    export const DeleteAddressComponent = (props: DeleteAddressComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteAddressMutation, DeleteAddressMutationVariables> mutation={DeleteAddressDocument} {...props} />
    );
    

/**
 * __useDeleteAddressMutation__
 *
 * To run a mutation, you first call `useDeleteAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAddressMutation, { data, loading, error }] = useDeleteAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAddressMutation, DeleteAddressMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteAddressMutation, DeleteAddressMutationVariables>(DeleteAddressDocument, baseOptions);
      }
export type DeleteAddressMutationHookResult = ReturnType<typeof useDeleteAddressMutation>;
export type DeleteAddressMutationResult = ApolloReactCommon.MutationResult<DeleteAddressMutation>;
export type DeleteAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAddressMutation, DeleteAddressMutationVariables>;
export const MarkPaymentPreApprovalFailedForOrderDocument = gql`
    mutation MarkPaymentPreApprovalFailedForOrder($input: MarkPaymentPreApprovalFailedForOrderInput!) {
  markPaymentPreApprovalFailedForOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type MarkPaymentPreApprovalFailedForOrderMutationFn = ApolloReactCommon.MutationFunction<MarkPaymentPreApprovalFailedForOrderMutation, MarkPaymentPreApprovalFailedForOrderMutationVariables>;
export type MarkPaymentPreApprovalFailedForOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MarkPaymentPreApprovalFailedForOrderMutation, MarkPaymentPreApprovalFailedForOrderMutationVariables>, 'mutation'>;

    export const MarkPaymentPreApprovalFailedForOrderComponent = (props: MarkPaymentPreApprovalFailedForOrderComponentProps) => (
      <ApolloReactComponents.Mutation<MarkPaymentPreApprovalFailedForOrderMutation, MarkPaymentPreApprovalFailedForOrderMutationVariables> mutation={MarkPaymentPreApprovalFailedForOrderDocument} {...props} />
    );
    

/**
 * __useMarkPaymentPreApprovalFailedForOrderMutation__
 *
 * To run a mutation, you first call `useMarkPaymentPreApprovalFailedForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPaymentPreApprovalFailedForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPaymentPreApprovalFailedForOrderMutation, { data, loading, error }] = useMarkPaymentPreApprovalFailedForOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkPaymentPreApprovalFailedForOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkPaymentPreApprovalFailedForOrderMutation, MarkPaymentPreApprovalFailedForOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<MarkPaymentPreApprovalFailedForOrderMutation, MarkPaymentPreApprovalFailedForOrderMutationVariables>(MarkPaymentPreApprovalFailedForOrderDocument, baseOptions);
      }
export type MarkPaymentPreApprovalFailedForOrderMutationHookResult = ReturnType<typeof useMarkPaymentPreApprovalFailedForOrderMutation>;
export type MarkPaymentPreApprovalFailedForOrderMutationResult = ApolloReactCommon.MutationResult<MarkPaymentPreApprovalFailedForOrderMutation>;
export type MarkPaymentPreApprovalFailedForOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkPaymentPreApprovalFailedForOrderMutation, MarkPaymentPreApprovalFailedForOrderMutationVariables>;
export const PayForOrderDocument = gql`
    mutation PayForOrder($input: PayForOrderInput!) {
  payForOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
    error
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type PayForOrderMutationFn = ApolloReactCommon.MutationFunction<PayForOrderMutation, PayForOrderMutationVariables>;
export type PayForOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<PayForOrderMutation, PayForOrderMutationVariables>, 'mutation'>;

    export const PayForOrderComponent = (props: PayForOrderComponentProps) => (
      <ApolloReactComponents.Mutation<PayForOrderMutation, PayForOrderMutationVariables> mutation={PayForOrderDocument} {...props} />
    );
    

/**
 * __usePayForOrderMutation__
 *
 * To run a mutation, you first call `usePayForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payForOrderMutation, { data, loading, error }] = usePayForOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePayForOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PayForOrderMutation, PayForOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<PayForOrderMutation, PayForOrderMutationVariables>(PayForOrderDocument, baseOptions);
      }
export type PayForOrderMutationHookResult = ReturnType<typeof usePayForOrderMutation>;
export type PayForOrderMutationResult = ApolloReactCommon.MutationResult<PayForOrderMutation>;
export type PayForOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<PayForOrderMutation, PayForOrderMutationVariables>;
export const ProductByFriendlyIdOrIdDocument = gql`
    query ProductByFriendlyIdOrId($friendlyIdOrId: String!) {
  findSellable(friendlyIdOrId: $friendlyIdOrId) {
    ...ProductDetails
  }
  aggregateExpertReport {
    ...ReviewStats
  }
}
    ${ProductDetailsFragmentDoc}
${ReviewStatsFragmentDoc}`;
export type ProductByFriendlyIdOrIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductByFriendlyIdOrIdQuery, ProductByFriendlyIdOrIdQueryVariables>, 'query'> & ({ variables: ProductByFriendlyIdOrIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductByFriendlyIdOrIdComponent = (props: ProductByFriendlyIdOrIdComponentProps) => (
      <ApolloReactComponents.Query<ProductByFriendlyIdOrIdQuery, ProductByFriendlyIdOrIdQueryVariables> query={ProductByFriendlyIdOrIdDocument} {...props} />
    );
    

/**
 * __useProductByFriendlyIdOrIdQuery__
 *
 * To run a query within a React component, call `useProductByFriendlyIdOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByFriendlyIdOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByFriendlyIdOrIdQuery({
 *   variables: {
 *      friendlyIdOrId: // value for 'friendlyIdOrId'
 *   },
 * });
 */
export function useProductByFriendlyIdOrIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductByFriendlyIdOrIdQuery, ProductByFriendlyIdOrIdQueryVariables>) {
        return ApolloReactHooks.useQuery<ProductByFriendlyIdOrIdQuery, ProductByFriendlyIdOrIdQueryVariables>(ProductByFriendlyIdOrIdDocument, baseOptions);
      }
export function useProductByFriendlyIdOrIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductByFriendlyIdOrIdQuery, ProductByFriendlyIdOrIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProductByFriendlyIdOrIdQuery, ProductByFriendlyIdOrIdQueryVariables>(ProductByFriendlyIdOrIdDocument, baseOptions);
        }
export type ProductByFriendlyIdOrIdQueryHookResult = ReturnType<typeof useProductByFriendlyIdOrIdQuery>;
export type ProductByFriendlyIdOrIdLazyQueryHookResult = ReturnType<typeof useProductByFriendlyIdOrIdLazyQuery>;
export type ProductByFriendlyIdOrIdQueryResult = ApolloReactCommon.QueryResult<ProductByFriendlyIdOrIdQuery, ProductByFriendlyIdOrIdQueryVariables>;
export const ProductExpertDocument = gql`
    query ProductExpert($consumerId: UserId!, $categoryId: CategoryId!) {
  recommendExpert2(consumerId: $consumerId, categoryId: $categoryId) {
    ...ProductRecommendedExpert
  }
}
    ${ProductRecommendedExpertFragmentDoc}`;
export type ProductExpertComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductExpertQuery, ProductExpertQueryVariables>, 'query'> & ({ variables: ProductExpertQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductExpertComponent = (props: ProductExpertComponentProps) => (
      <ApolloReactComponents.Query<ProductExpertQuery, ProductExpertQueryVariables> query={ProductExpertDocument} {...props} />
    );
    

/**
 * __useProductExpertQuery__
 *
 * To run a query within a React component, call `useProductExpertQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductExpertQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductExpertQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useProductExpertQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductExpertQuery, ProductExpertQueryVariables>) {
        return ApolloReactHooks.useQuery<ProductExpertQuery, ProductExpertQueryVariables>(ProductExpertDocument, baseOptions);
      }
export function useProductExpertLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductExpertQuery, ProductExpertQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProductExpertQuery, ProductExpertQueryVariables>(ProductExpertDocument, baseOptions);
        }
export type ProductExpertQueryHookResult = ReturnType<typeof useProductExpertQuery>;
export type ProductExpertLazyQueryHookResult = ReturnType<typeof useProductExpertLazyQuery>;
export type ProductExpertQueryResult = ApolloReactCommon.QueryResult<ProductExpertQuery, ProductExpertQueryVariables>;
export const ExpertSellableNotesDocument = gql`
    query ExpertSellableNotes($query: SuggestExpertCuratedItemNotesQueryInput!) {
  suggestExpertCuratedItemNotes(query: $query, sort: USAGES) {
    edges {
      node {
        ...ExpertCuratedItemNote
      }
    }
  }
}
    ${ExpertCuratedItemNoteFragmentDoc}`;
export type ExpertSellableNotesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExpertSellableNotesQuery, ExpertSellableNotesQueryVariables>, 'query'> & ({ variables: ExpertSellableNotesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExpertSellableNotesComponent = (props: ExpertSellableNotesComponentProps) => (
      <ApolloReactComponents.Query<ExpertSellableNotesQuery, ExpertSellableNotesQueryVariables> query={ExpertSellableNotesDocument} {...props} />
    );
    

/**
 * __useExpertSellableNotesQuery__
 *
 * To run a query within a React component, call `useExpertSellableNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertSellableNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertSellableNotesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useExpertSellableNotesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExpertSellableNotesQuery, ExpertSellableNotesQueryVariables>) {
        return ApolloReactHooks.useQuery<ExpertSellableNotesQuery, ExpertSellableNotesQueryVariables>(ExpertSellableNotesDocument, baseOptions);
      }
export function useExpertSellableNotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpertSellableNotesQuery, ExpertSellableNotesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExpertSellableNotesQuery, ExpertSellableNotesQueryVariables>(ExpertSellableNotesDocument, baseOptions);
        }
export type ExpertSellableNotesQueryHookResult = ReturnType<typeof useExpertSellableNotesQuery>;
export type ExpertSellableNotesLazyQueryHookResult = ReturnType<typeof useExpertSellableNotesLazyQuery>;
export type ExpertSellableNotesQueryResult = ApolloReactCommon.QueryResult<ExpertSellableNotesQuery, ExpertSellableNotesQueryVariables>;
export const RecommendedProductsByCategoryDocument = gql`
    query RecommendedProductsByCategory($query: RecommendedListsQuery!) {
  recommendedLists(query: $query) {
    edges {
      cursor
      node {
        displayName
        recommendedListDefinition {
          id
          rank
        }
        sellables {
          ...RecommendedListSellableCard
        }
      }
    }
  }
}
    ${RecommendedListSellableCardFragmentDoc}`;
export type RecommendedProductsByCategoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecommendedProductsByCategoryQuery, RecommendedProductsByCategoryQueryVariables>, 'query'> & ({ variables: RecommendedProductsByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RecommendedProductsByCategoryComponent = (props: RecommendedProductsByCategoryComponentProps) => (
      <ApolloReactComponents.Query<RecommendedProductsByCategoryQuery, RecommendedProductsByCategoryQueryVariables> query={RecommendedProductsByCategoryDocument} {...props} />
    );
    

/**
 * __useRecommendedProductsByCategoryQuery__
 *
 * To run a query within a React component, call `useRecommendedProductsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedProductsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedProductsByCategoryQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useRecommendedProductsByCategoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RecommendedProductsByCategoryQuery, RecommendedProductsByCategoryQueryVariables>) {
        return ApolloReactHooks.useQuery<RecommendedProductsByCategoryQuery, RecommendedProductsByCategoryQueryVariables>(RecommendedProductsByCategoryDocument, baseOptions);
      }
export function useRecommendedProductsByCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecommendedProductsByCategoryQuery, RecommendedProductsByCategoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RecommendedProductsByCategoryQuery, RecommendedProductsByCategoryQueryVariables>(RecommendedProductsByCategoryDocument, baseOptions);
        }
export type RecommendedProductsByCategoryQueryHookResult = ReturnType<typeof useRecommendedProductsByCategoryQuery>;
export type RecommendedProductsByCategoryLazyQueryHookResult = ReturnType<typeof useRecommendedProductsByCategoryLazyQuery>;
export type RecommendedProductsByCategoryQueryResult = ApolloReactCommon.QueryResult<RecommendedProductsByCategoryQuery, RecommendedProductsByCategoryQueryVariables>;
export const RequestSellablePriceMatchDocument = gql`
    mutation RequestSellablePriceMatch($input: RequestSellablePriceMatchInput!) {
  requestSellablePriceMatch(input: $input) {
    error
    lead {
      id
    }
  }
}
    `;
export type RequestSellablePriceMatchMutationFn = ApolloReactCommon.MutationFunction<RequestSellablePriceMatchMutation, RequestSellablePriceMatchMutationVariables>;
export type RequestSellablePriceMatchComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RequestSellablePriceMatchMutation, RequestSellablePriceMatchMutationVariables>, 'mutation'>;

    export const RequestSellablePriceMatchComponent = (props: RequestSellablePriceMatchComponentProps) => (
      <ApolloReactComponents.Mutation<RequestSellablePriceMatchMutation, RequestSellablePriceMatchMutationVariables> mutation={RequestSellablePriceMatchDocument} {...props} />
    );
    

/**
 * __useRequestSellablePriceMatchMutation__
 *
 * To run a mutation, you first call `useRequestSellablePriceMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSellablePriceMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSellablePriceMatchMutation, { data, loading, error }] = useRequestSellablePriceMatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestSellablePriceMatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestSellablePriceMatchMutation, RequestSellablePriceMatchMutationVariables>) {
        return ApolloReactHooks.useMutation<RequestSellablePriceMatchMutation, RequestSellablePriceMatchMutationVariables>(RequestSellablePriceMatchDocument, baseOptions);
      }
export type RequestSellablePriceMatchMutationHookResult = ReturnType<typeof useRequestSellablePriceMatchMutation>;
export type RequestSellablePriceMatchMutationResult = ApolloReactCommon.MutationResult<RequestSellablePriceMatchMutation>;
export type RequestSellablePriceMatchMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestSellablePriceMatchMutation, RequestSellablePriceMatchMutationVariables>;
export const SellablePriceComparisonsDocument = gql`
    query SellablePriceComparisons($sellableId: SellableId!) {
  sellable(id: $sellableId) {
    id
    otherOnlineRetailers {
      name
      salePrice {
        ...MonetaryAmount
      }
      freeShipping
    }
  }
}
    ${MonetaryAmountFragmentDoc}`;
export type SellablePriceComparisonsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SellablePriceComparisonsQuery, SellablePriceComparisonsQueryVariables>, 'query'> & ({ variables: SellablePriceComparisonsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellablePriceComparisonsComponent = (props: SellablePriceComparisonsComponentProps) => (
      <ApolloReactComponents.Query<SellablePriceComparisonsQuery, SellablePriceComparisonsQueryVariables> query={SellablePriceComparisonsDocument} {...props} />
    );
    

/**
 * __useSellablePriceComparisonsQuery__
 *
 * To run a query within a React component, call `useSellablePriceComparisonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellablePriceComparisonsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellablePriceComparisonsQuery({
 *   variables: {
 *      sellableId: // value for 'sellableId'
 *   },
 * });
 */
export function useSellablePriceComparisonsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SellablePriceComparisonsQuery, SellablePriceComparisonsQueryVariables>) {
        return ApolloReactHooks.useQuery<SellablePriceComparisonsQuery, SellablePriceComparisonsQueryVariables>(SellablePriceComparisonsDocument, baseOptions);
      }
export function useSellablePriceComparisonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SellablePriceComparisonsQuery, SellablePriceComparisonsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SellablePriceComparisonsQuery, SellablePriceComparisonsQueryVariables>(SellablePriceComparisonsDocument, baseOptions);
        }
export type SellablePriceComparisonsQueryHookResult = ReturnType<typeof useSellablePriceComparisonsQuery>;
export type SellablePriceComparisonsLazyQueryHookResult = ReturnType<typeof useSellablePriceComparisonsLazyQuery>;
export type SellablePriceComparisonsQueryResult = ApolloReactCommon.QueryResult<SellablePriceComparisonsQuery, SellablePriceComparisonsQueryVariables>;
export const UserLeadForSellableDepartmentDocument = gql`
    query UserLeadForSellableDepartment($id: DepartmentId!) {
  department(id: $id) {
    id
    mostRecentLeadForConsumer {
      id
      expert {
        id
      }
    }
  }
}
    `;
export type UserLeadForSellableDepartmentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserLeadForSellableDepartmentQuery, UserLeadForSellableDepartmentQueryVariables>, 'query'> & ({ variables: UserLeadForSellableDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UserLeadForSellableDepartmentComponent = (props: UserLeadForSellableDepartmentComponentProps) => (
      <ApolloReactComponents.Query<UserLeadForSellableDepartmentQuery, UserLeadForSellableDepartmentQueryVariables> query={UserLeadForSellableDepartmentDocument} {...props} />
    );
    

/**
 * __useUserLeadForSellableDepartmentQuery__
 *
 * To run a query within a React component, call `useUserLeadForSellableDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserLeadForSellableDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserLeadForSellableDepartmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserLeadForSellableDepartmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserLeadForSellableDepartmentQuery, UserLeadForSellableDepartmentQueryVariables>) {
        return ApolloReactHooks.useQuery<UserLeadForSellableDepartmentQuery, UserLeadForSellableDepartmentQueryVariables>(UserLeadForSellableDepartmentDocument, baseOptions);
      }
export function useUserLeadForSellableDepartmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserLeadForSellableDepartmentQuery, UserLeadForSellableDepartmentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<UserLeadForSellableDepartmentQuery, UserLeadForSellableDepartmentQueryVariables>(UserLeadForSellableDepartmentDocument, baseOptions);
        }
export type UserLeadForSellableDepartmentQueryHookResult = ReturnType<typeof useUserLeadForSellableDepartmentQuery>;
export type UserLeadForSellableDepartmentLazyQueryHookResult = ReturnType<typeof useUserLeadForSellableDepartmentLazyQuery>;
export type UserLeadForSellableDepartmentQueryResult = ApolloReactCommon.QueryResult<UserLeadForSellableDepartmentQuery, UserLeadForSellableDepartmentQueryVariables>;
export const AllowedToReferDocument = gql`
    query AllowedToRefer {
  me {
    id
    user {
      id
      isAllowedToRefer
    }
  }
}
    `;
export type AllowedToReferComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllowedToReferQuery, AllowedToReferQueryVariables>, 'query'>;

    export const AllowedToReferComponent = (props: AllowedToReferComponentProps) => (
      <ApolloReactComponents.Query<AllowedToReferQuery, AllowedToReferQueryVariables> query={AllowedToReferDocument} {...props} />
    );
    

/**
 * __useAllowedToReferQuery__
 *
 * To run a query within a React component, call `useAllowedToReferQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowedToReferQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowedToReferQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllowedToReferQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllowedToReferQuery, AllowedToReferQueryVariables>) {
        return ApolloReactHooks.useQuery<AllowedToReferQuery, AllowedToReferQueryVariables>(AllowedToReferDocument, baseOptions);
      }
export function useAllowedToReferLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllowedToReferQuery, AllowedToReferQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AllowedToReferQuery, AllowedToReferQueryVariables>(AllowedToReferDocument, baseOptions);
        }
export type AllowedToReferQueryHookResult = ReturnType<typeof useAllowedToReferQuery>;
export type AllowedToReferLazyQueryHookResult = ReturnType<typeof useAllowedToReferLazyQuery>;
export type AllowedToReferQueryResult = ApolloReactCommon.QueryResult<AllowedToReferQuery, AllowedToReferQueryVariables>;
export const ShareReferralCodeViaEmailDocument = gql`
    mutation shareReferralCodeViaEmail($referralCodeId: ReferralCodeId!, $emails: [String!]!, $note: String) {
  shareReferralCodeViaEmail(input: {referralCodeId: $referralCodeId, emails: $emails, note: $note}) {
    shareCount
    errors
  }
}
    `;
export type ShareReferralCodeViaEmailMutationFn = ApolloReactCommon.MutationFunction<ShareReferralCodeViaEmailMutation, ShareReferralCodeViaEmailMutationVariables>;
export type ShareReferralCodeViaEmailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ShareReferralCodeViaEmailMutation, ShareReferralCodeViaEmailMutationVariables>, 'mutation'>;

    export const ShareReferralCodeViaEmailComponent = (props: ShareReferralCodeViaEmailComponentProps) => (
      <ApolloReactComponents.Mutation<ShareReferralCodeViaEmailMutation, ShareReferralCodeViaEmailMutationVariables> mutation={ShareReferralCodeViaEmailDocument} {...props} />
    );
    

/**
 * __useShareReferralCodeViaEmailMutation__
 *
 * To run a mutation, you first call `useShareReferralCodeViaEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareReferralCodeViaEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareReferralCodeViaEmailMutation, { data, loading, error }] = useShareReferralCodeViaEmailMutation({
 *   variables: {
 *      referralCodeId: // value for 'referralCodeId'
 *      emails: // value for 'emails'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useShareReferralCodeViaEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShareReferralCodeViaEmailMutation, ShareReferralCodeViaEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<ShareReferralCodeViaEmailMutation, ShareReferralCodeViaEmailMutationVariables>(ShareReferralCodeViaEmailDocument, baseOptions);
      }
export type ShareReferralCodeViaEmailMutationHookResult = ReturnType<typeof useShareReferralCodeViaEmailMutation>;
export type ShareReferralCodeViaEmailMutationResult = ApolloReactCommon.MutationResult<ShareReferralCodeViaEmailMutation>;
export type ShareReferralCodeViaEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<ShareReferralCodeViaEmailMutation, ShareReferralCodeViaEmailMutationVariables>;
export const PotentialConsumerReferralSourcesDocument = gql`
    query PotentialConsumerReferralSources($sourceKey: String!, $expertId: BusinessUserId) {
  potentialConsumerReferralSources(expertId: $expertId) {
    ...ReferralCode
  }
}
    ${ReferralCodeFragmentDoc}`;
export type PotentialConsumerReferralSourcesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PotentialConsumerReferralSourcesQuery, PotentialConsumerReferralSourcesQueryVariables>, 'query'> & ({ variables: PotentialConsumerReferralSourcesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PotentialConsumerReferralSourcesComponent = (props: PotentialConsumerReferralSourcesComponentProps) => (
      <ApolloReactComponents.Query<PotentialConsumerReferralSourcesQuery, PotentialConsumerReferralSourcesQueryVariables> query={PotentialConsumerReferralSourcesDocument} {...props} />
    );
    

/**
 * __usePotentialConsumerReferralSourcesQuery__
 *
 * To run a query within a React component, call `usePotentialConsumerReferralSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePotentialConsumerReferralSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePotentialConsumerReferralSourcesQuery({
 *   variables: {
 *      sourceKey: // value for 'sourceKey'
 *      expertId: // value for 'expertId'
 *   },
 * });
 */
export function usePotentialConsumerReferralSourcesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PotentialConsumerReferralSourcesQuery, PotentialConsumerReferralSourcesQueryVariables>) {
        return ApolloReactHooks.useQuery<PotentialConsumerReferralSourcesQuery, PotentialConsumerReferralSourcesQueryVariables>(PotentialConsumerReferralSourcesDocument, baseOptions);
      }
export function usePotentialConsumerReferralSourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PotentialConsumerReferralSourcesQuery, PotentialConsumerReferralSourcesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PotentialConsumerReferralSourcesQuery, PotentialConsumerReferralSourcesQueryVariables>(PotentialConsumerReferralSourcesDocument, baseOptions);
        }
export type PotentialConsumerReferralSourcesQueryHookResult = ReturnType<typeof usePotentialConsumerReferralSourcesQuery>;
export type PotentialConsumerReferralSourcesLazyQueryHookResult = ReturnType<typeof usePotentialConsumerReferralSourcesLazyQuery>;
export type PotentialConsumerReferralSourcesQueryResult = ApolloReactCommon.QueryResult<PotentialConsumerReferralSourcesQuery, PotentialConsumerReferralSourcesQueryVariables>;
export const LookupRefereeExpertReviewDocument = gql`
    query LookupRefereeExpertReview($expertId: BusinessUserId!, $userId: UserId!) {
  user(userId: $userId) {
    id
    expertReviews(expertId: $expertId) {
      ...RefereeExpertReview
    }
  }
}
    ${RefereeExpertReviewFragmentDoc}`;
export type LookupRefereeExpertReviewComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LookupRefereeExpertReviewQuery, LookupRefereeExpertReviewQueryVariables>, 'query'> & ({ variables: LookupRefereeExpertReviewQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LookupRefereeExpertReviewComponent = (props: LookupRefereeExpertReviewComponentProps) => (
      <ApolloReactComponents.Query<LookupRefereeExpertReviewQuery, LookupRefereeExpertReviewQueryVariables> query={LookupRefereeExpertReviewDocument} {...props} />
    );
    

/**
 * __useLookupRefereeExpertReviewQuery__
 *
 * To run a query within a React component, call `useLookupRefereeExpertReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupRefereeExpertReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupRefereeExpertReviewQuery({
 *   variables: {
 *      expertId: // value for 'expertId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLookupRefereeExpertReviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LookupRefereeExpertReviewQuery, LookupRefereeExpertReviewQueryVariables>) {
        return ApolloReactHooks.useQuery<LookupRefereeExpertReviewQuery, LookupRefereeExpertReviewQueryVariables>(LookupRefereeExpertReviewDocument, baseOptions);
      }
export function useLookupRefereeExpertReviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LookupRefereeExpertReviewQuery, LookupRefereeExpertReviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LookupRefereeExpertReviewQuery, LookupRefereeExpertReviewQueryVariables>(LookupRefereeExpertReviewDocument, baseOptions);
        }
export type LookupRefereeExpertReviewQueryHookResult = ReturnType<typeof useLookupRefereeExpertReviewQuery>;
export type LookupRefereeExpertReviewLazyQueryHookResult = ReturnType<typeof useLookupRefereeExpertReviewLazyQuery>;
export type LookupRefereeExpertReviewQueryResult = ApolloReactCommon.QueryResult<LookupRefereeExpertReviewQuery, LookupRefereeExpertReviewQueryVariables>;
export const LookupReferralCodeDocument = gql`
    query LookupReferralCode($code: String!) {
  lookupReferralCode(code: $code) {
    errorCode
    referralCode {
      ...LookupReferralCode
    }
  }
}
    ${LookupReferralCodeFragmentDoc}`;
export type LookupReferralCodeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LookupReferralCodeQuery, LookupReferralCodeQueryVariables>, 'query'> & ({ variables: LookupReferralCodeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LookupReferralCodeComponent = (props: LookupReferralCodeComponentProps) => (
      <ApolloReactComponents.Query<LookupReferralCodeQuery, LookupReferralCodeQueryVariables> query={LookupReferralCodeDocument} {...props} />
    );
    

/**
 * __useLookupReferralCodeQuery__
 *
 * To run a query within a React component, call `useLookupReferralCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupReferralCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupReferralCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useLookupReferralCodeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LookupReferralCodeQuery, LookupReferralCodeQueryVariables>) {
        return ApolloReactHooks.useQuery<LookupReferralCodeQuery, LookupReferralCodeQueryVariables>(LookupReferralCodeDocument, baseOptions);
      }
export function useLookupReferralCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LookupReferralCodeQuery, LookupReferralCodeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LookupReferralCodeQuery, LookupReferralCodeQueryVariables>(LookupReferralCodeDocument, baseOptions);
        }
export type LookupReferralCodeQueryHookResult = ReturnType<typeof useLookupReferralCodeQuery>;
export type LookupReferralCodeLazyQueryHookResult = ReturnType<typeof useLookupReferralCodeLazyQuery>;
export type LookupReferralCodeQueryResult = ApolloReactCommon.QueryResult<LookupReferralCodeQuery, LookupReferralCodeQueryVariables>;
export const ActiveExpertCategoriesDocument = gql`
    query ActiveExpertCategories {
  departmentsForNavigation {
    ...ReferralDepartment
  }
}
    ${ReferralDepartmentFragmentDoc}`;
export type ActiveExpertCategoriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ActiveExpertCategoriesQuery, ActiveExpertCategoriesQueryVariables>, 'query'>;

    export const ActiveExpertCategoriesComponent = (props: ActiveExpertCategoriesComponentProps) => (
      <ApolloReactComponents.Query<ActiveExpertCategoriesQuery, ActiveExpertCategoriesQueryVariables> query={ActiveExpertCategoriesDocument} {...props} />
    );
    

/**
 * __useActiveExpertCategoriesQuery__
 *
 * To run a query within a React component, call `useActiveExpertCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveExpertCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveExpertCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveExpertCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveExpertCategoriesQuery, ActiveExpertCategoriesQueryVariables>) {
        return ApolloReactHooks.useQuery<ActiveExpertCategoriesQuery, ActiveExpertCategoriesQueryVariables>(ActiveExpertCategoriesDocument, baseOptions);
      }
export function useActiveExpertCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveExpertCategoriesQuery, ActiveExpertCategoriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ActiveExpertCategoriesQuery, ActiveExpertCategoriesQueryVariables>(ActiveExpertCategoriesDocument, baseOptions);
        }
export type ActiveExpertCategoriesQueryHookResult = ReturnType<typeof useActiveExpertCategoriesQuery>;
export type ActiveExpertCategoriesLazyQueryHookResult = ReturnType<typeof useActiveExpertCategoriesLazyQuery>;
export type ActiveExpertCategoriesQueryResult = ApolloReactCommon.QueryResult<ActiveExpertCategoriesQuery, ActiveExpertCategoriesQueryVariables>;
export const ReenterPathFlowPageDocument = gql`
    mutation ReenterPathFlowPage($input: ReenterPathFlowPageInput!) {
  reenterPathFlowPage(input: $input) {
    flow {
      ...PathFlow
    }
  }
}
    ${PathFlowFragmentDoc}`;
export type ReenterPathFlowPageMutationFn = ApolloReactCommon.MutationFunction<ReenterPathFlowPageMutation, ReenterPathFlowPageMutationVariables>;
export type ReenterPathFlowPageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ReenterPathFlowPageMutation, ReenterPathFlowPageMutationVariables>, 'mutation'>;

    export const ReenterPathFlowPageComponent = (props: ReenterPathFlowPageComponentProps) => (
      <ApolloReactComponents.Mutation<ReenterPathFlowPageMutation, ReenterPathFlowPageMutationVariables> mutation={ReenterPathFlowPageDocument} {...props} />
    );
    

/**
 * __useReenterPathFlowPageMutation__
 *
 * To run a mutation, you first call `useReenterPathFlowPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReenterPathFlowPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reenterPathFlowPageMutation, { data, loading, error }] = useReenterPathFlowPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReenterPathFlowPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReenterPathFlowPageMutation, ReenterPathFlowPageMutationVariables>) {
        return ApolloReactHooks.useMutation<ReenterPathFlowPageMutation, ReenterPathFlowPageMutationVariables>(ReenterPathFlowPageDocument, baseOptions);
      }
export type ReenterPathFlowPageMutationHookResult = ReturnType<typeof useReenterPathFlowPageMutation>;
export type ReenterPathFlowPageMutationResult = ApolloReactCommon.MutationResult<ReenterPathFlowPageMutation>;
export type ReenterPathFlowPageMutationOptions = ApolloReactCommon.BaseMutationOptions<ReenterPathFlowPageMutation, ReenterPathFlowPageMutationVariables>;
export const CommunityAggregateStatsDocument = gql`
    query CommunityAggregateStats {
  aggregateExpertReport {
    globalStats {
      ...GlobalStats
    }
  }
}
    ${GlobalStatsFragmentDoc}`;
export type CommunityAggregateStatsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CommunityAggregateStatsQuery, CommunityAggregateStatsQueryVariables>, 'query'>;

    export const CommunityAggregateStatsComponent = (props: CommunityAggregateStatsComponentProps) => (
      <ApolloReactComponents.Query<CommunityAggregateStatsQuery, CommunityAggregateStatsQueryVariables> query={CommunityAggregateStatsDocument} {...props} />
    );
    

/**
 * __useCommunityAggregateStatsQuery__
 *
 * To run a query within a React component, call `useCommunityAggregateStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityAggregateStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityAggregateStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunityAggregateStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CommunityAggregateStatsQuery, CommunityAggregateStatsQueryVariables>) {
        return ApolloReactHooks.useQuery<CommunityAggregateStatsQuery, CommunityAggregateStatsQueryVariables>(CommunityAggregateStatsDocument, baseOptions);
      }
export function useCommunityAggregateStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommunityAggregateStatsQuery, CommunityAggregateStatsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CommunityAggregateStatsQuery, CommunityAggregateStatsQueryVariables>(CommunityAggregateStatsDocument, baseOptions);
        }
export type CommunityAggregateStatsQueryHookResult = ReturnType<typeof useCommunityAggregateStatsQuery>;
export type CommunityAggregateStatsLazyQueryHookResult = ReturnType<typeof useCommunityAggregateStatsLazyQuery>;
export type CommunityAggregateStatsQueryResult = ApolloReactCommon.QueryResult<CommunityAggregateStatsQuery, CommunityAggregateStatsQueryVariables>;
export const DepartmentBySlugDocument = gql`
    query DepartmentBySlug($slug: String!) {
  departmentBySlug(slug: $slug) {
    ...DepartmentContext
    mostRecentLeadForConsumer {
      id
      expert {
        ...CommunityLeadExpert
      }
    }
    topLevelCategories {
      ...TopLevelCategory
    }
  }
}
    ${DepartmentContextFragmentDoc}
${CommunityLeadExpertFragmentDoc}
${TopLevelCategoryFragmentDoc}`;
export type DepartmentBySlugComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DepartmentBySlugQuery, DepartmentBySlugQueryVariables>, 'query'> & ({ variables: DepartmentBySlugQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DepartmentBySlugComponent = (props: DepartmentBySlugComponentProps) => (
      <ApolloReactComponents.Query<DepartmentBySlugQuery, DepartmentBySlugQueryVariables> query={DepartmentBySlugDocument} {...props} />
    );
    

/**
 * __useDepartmentBySlugQuery__
 *
 * To run a query within a React component, call `useDepartmentBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useDepartmentBySlugQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DepartmentBySlugQuery, DepartmentBySlugQueryVariables>) {
        return ApolloReactHooks.useQuery<DepartmentBySlugQuery, DepartmentBySlugQueryVariables>(DepartmentBySlugDocument, baseOptions);
      }
export function useDepartmentBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentBySlugQuery, DepartmentBySlugQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DepartmentBySlugQuery, DepartmentBySlugQueryVariables>(DepartmentBySlugDocument, baseOptions);
        }
export type DepartmentBySlugQueryHookResult = ReturnType<typeof useDepartmentBySlugQuery>;
export type DepartmentBySlugLazyQueryHookResult = ReturnType<typeof useDepartmentBySlugLazyQuery>;
export type DepartmentBySlugQueryResult = ApolloReactCommon.QueryResult<DepartmentBySlugQuery, DepartmentBySlugQueryVariables>;
export const DepartmentCuratedActivityFeedDocument = gql`
    query DepartmentCuratedActivityFeed($query: ConsumerReviewSearchQuery!, $after: String, $sortBy: ConsumerReviewSearchSort!) {
  consumerExpertReviewConnection(query: $query, after: $after, first: 10, sortBy: $sortBy) {
    pageInfo {
      ...PageInfo
    }
    count
    facets {
      ... on BucketedDisplayFacet {
        ...ReviewSummaryBuckets
      }
      displayName
      alias
      name
    }
    edges {
      cursor
      node {
        ...ConsumerExpertReview
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${ReviewSummaryBucketsFragmentDoc}
${ConsumerExpertReviewFragmentDoc}`;
export type DepartmentCuratedActivityFeedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DepartmentCuratedActivityFeedQuery, DepartmentCuratedActivityFeedQueryVariables>, 'query'> & ({ variables: DepartmentCuratedActivityFeedQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DepartmentCuratedActivityFeedComponent = (props: DepartmentCuratedActivityFeedComponentProps) => (
      <ApolloReactComponents.Query<DepartmentCuratedActivityFeedQuery, DepartmentCuratedActivityFeedQueryVariables> query={DepartmentCuratedActivityFeedDocument} {...props} />
    );
    

/**
 * __useDepartmentCuratedActivityFeedQuery__
 *
 * To run a query within a React component, call `useDepartmentCuratedActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentCuratedActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentCuratedActivityFeedQuery({
 *   variables: {
 *      query: // value for 'query'
 *      after: // value for 'after'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useDepartmentCuratedActivityFeedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DepartmentCuratedActivityFeedQuery, DepartmentCuratedActivityFeedQueryVariables>) {
        return ApolloReactHooks.useQuery<DepartmentCuratedActivityFeedQuery, DepartmentCuratedActivityFeedQueryVariables>(DepartmentCuratedActivityFeedDocument, baseOptions);
      }
export function useDepartmentCuratedActivityFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentCuratedActivityFeedQuery, DepartmentCuratedActivityFeedQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DepartmentCuratedActivityFeedQuery, DepartmentCuratedActivityFeedQueryVariables>(DepartmentCuratedActivityFeedDocument, baseOptions);
        }
export type DepartmentCuratedActivityFeedQueryHookResult = ReturnType<typeof useDepartmentCuratedActivityFeedQuery>;
export type DepartmentCuratedActivityFeedLazyQueryHookResult = ReturnType<typeof useDepartmentCuratedActivityFeedLazyQuery>;
export type DepartmentCuratedActivityFeedQueryResult = ApolloReactCommon.QueryResult<DepartmentCuratedActivityFeedQuery, DepartmentCuratedActivityFeedQueryVariables>;
export const GlobalReviewCountsDocument = gql`
    query GlobalReviewCounts {
  consumerExpertReviewConnection(query: {departmentIds: []}) {
    ...GlobalReviewStatistics
  }
}
    ${GlobalReviewStatisticsFragmentDoc}`;
export type GlobalReviewCountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GlobalReviewCountsQuery, GlobalReviewCountsQueryVariables>, 'query'>;

    export const GlobalReviewCountsComponent = (props: GlobalReviewCountsComponentProps) => (
      <ApolloReactComponents.Query<GlobalReviewCountsQuery, GlobalReviewCountsQueryVariables> query={GlobalReviewCountsDocument} {...props} />
    );
    

/**
 * __useGlobalReviewCountsQuery__
 *
 * To run a query within a React component, call `useGlobalReviewCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalReviewCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalReviewCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalReviewCountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalReviewCountsQuery, GlobalReviewCountsQueryVariables>) {
        return ApolloReactHooks.useQuery<GlobalReviewCountsQuery, GlobalReviewCountsQueryVariables>(GlobalReviewCountsDocument, baseOptions);
      }
export function useGlobalReviewCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalReviewCountsQuery, GlobalReviewCountsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GlobalReviewCountsQuery, GlobalReviewCountsQueryVariables>(GlobalReviewCountsDocument, baseOptions);
        }
export type GlobalReviewCountsQueryHookResult = ReturnType<typeof useGlobalReviewCountsQuery>;
export type GlobalReviewCountsLazyQueryHookResult = ReturnType<typeof useGlobalReviewCountsLazyQuery>;
export type GlobalReviewCountsQueryResult = ApolloReactCommon.QueryResult<GlobalReviewCountsQuery, GlobalReviewCountsQueryVariables>;
export const SellableByIdDocument = gql`
    query SellableById($friendlyIdOrId: String!) {
  findSellable(friendlyIdOrId: $friendlyIdOrId) {
    id
    friendlyId
    slug
    type
  }
}
    `;
export type SellableByIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SellableByIdQuery, SellableByIdQueryVariables>, 'query'> & ({ variables: SellableByIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellableByIdComponent = (props: SellableByIdComponentProps) => (
      <ApolloReactComponents.Query<SellableByIdQuery, SellableByIdQueryVariables> query={SellableByIdDocument} {...props} />
    );
    

/**
 * __useSellableByIdQuery__
 *
 * To run a query within a React component, call `useSellableByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellableByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellableByIdQuery({
 *   variables: {
 *      friendlyIdOrId: // value for 'friendlyIdOrId'
 *   },
 * });
 */
export function useSellableByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SellableByIdQuery, SellableByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<SellableByIdQuery, SellableByIdQueryVariables>(SellableByIdDocument, baseOptions);
      }
export function useSellableByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SellableByIdQuery, SellableByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SellableByIdQuery, SellableByIdQueryVariables>(SellableByIdDocument, baseOptions);
        }
export type SellableByIdQueryHookResult = ReturnType<typeof useSellableByIdQuery>;
export type SellableByIdLazyQueryHookResult = ReturnType<typeof useSellableByIdLazyQuery>;
export type SellableByIdQueryResult = ApolloReactCommon.QueryResult<SellableByIdQuery, SellableByIdQueryVariables>;
export const SearchOrderEscalationsDocument = gql`
    query SearchOrderEscalations($pageSize: Int = 100, $userIds: [UserId!]) {
  orderEscalations(query: {userIds: $userIds, facetedSearch: false}, first: $pageSize) {
    edges {
      ...OrderEscalationSearchResult
    }
  }
}
    ${OrderEscalationSearchResultFragmentDoc}`;
export type SearchOrderEscalationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchOrderEscalationsQuery, SearchOrderEscalationsQueryVariables>, 'query'>;

    export const SearchOrderEscalationsComponent = (props: SearchOrderEscalationsComponentProps) => (
      <ApolloReactComponents.Query<SearchOrderEscalationsQuery, SearchOrderEscalationsQueryVariables> query={SearchOrderEscalationsDocument} {...props} />
    );
    

/**
 * __useSearchOrderEscalationsQuery__
 *
 * To run a query within a React component, call `useSearchOrderEscalationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOrderEscalationsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOrderEscalationsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useSearchOrderEscalationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchOrderEscalationsQuery, SearchOrderEscalationsQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchOrderEscalationsQuery, SearchOrderEscalationsQueryVariables>(SearchOrderEscalationsDocument, baseOptions);
      }
export function useSearchOrderEscalationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchOrderEscalationsQuery, SearchOrderEscalationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchOrderEscalationsQuery, SearchOrderEscalationsQueryVariables>(SearchOrderEscalationsDocument, baseOptions);
        }
export type SearchOrderEscalationsQueryHookResult = ReturnType<typeof useSearchOrderEscalationsQuery>;
export type SearchOrderEscalationsLazyQueryHookResult = ReturnType<typeof useSearchOrderEscalationsLazyQuery>;
export type SearchOrderEscalationsQueryResult = ApolloReactCommon.QueryResult<SearchOrderEscalationsQuery, SearchOrderEscalationsQueryVariables>;
export const SellableDetailsForExpertItemDocument = gql`
    query SellableDetailsForExpertItem($friendlyIdOrId: String!) {
  findSellable(friendlyIdOrId: $friendlyIdOrId) {
    id
    title
    images {
      ...MediaFile
    }
    ...SellablePricingWithDefaultVariant
  }
}
    ${MediaFileFragmentDoc}
${SellablePricingWithDefaultVariantFragmentDoc}`;
export type SellableDetailsForExpertItemComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SellableDetailsForExpertItemQuery, SellableDetailsForExpertItemQueryVariables>, 'query'> & ({ variables: SellableDetailsForExpertItemQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellableDetailsForExpertItemComponent = (props: SellableDetailsForExpertItemComponentProps) => (
      <ApolloReactComponents.Query<SellableDetailsForExpertItemQuery, SellableDetailsForExpertItemQueryVariables> query={SellableDetailsForExpertItemDocument} {...props} />
    );
    

/**
 * __useSellableDetailsForExpertItemQuery__
 *
 * To run a query within a React component, call `useSellableDetailsForExpertItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellableDetailsForExpertItemQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellableDetailsForExpertItemQuery({
 *   variables: {
 *      friendlyIdOrId: // value for 'friendlyIdOrId'
 *   },
 * });
 */
export function useSellableDetailsForExpertItemQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SellableDetailsForExpertItemQuery, SellableDetailsForExpertItemQueryVariables>) {
        return ApolloReactHooks.useQuery<SellableDetailsForExpertItemQuery, SellableDetailsForExpertItemQueryVariables>(SellableDetailsForExpertItemDocument, baseOptions);
      }
export function useSellableDetailsForExpertItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SellableDetailsForExpertItemQuery, SellableDetailsForExpertItemQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SellableDetailsForExpertItemQuery, SellableDetailsForExpertItemQueryVariables>(SellableDetailsForExpertItemDocument, baseOptions);
        }
export type SellableDetailsForExpertItemQueryHookResult = ReturnType<typeof useSellableDetailsForExpertItemQuery>;
export type SellableDetailsForExpertItemLazyQueryHookResult = ReturnType<typeof useSellableDetailsForExpertItemLazyQuery>;
export type SellableDetailsForExpertItemQueryResult = ApolloReactCommon.QueryResult<SellableDetailsForExpertItemQuery, SellableDetailsForExpertItemQueryVariables>;
export const TopicExpertsDocument = gql`
    query TopicExperts($departmentId: DepartmentId!) {
  recommendExpertsForDepartment(departmentId: $departmentId, limit: 6) {
    expert {
      ...TopicPageExpert
    }
  }
}
    ${TopicPageExpertFragmentDoc}`;
export type TopicExpertsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TopicExpertsQuery, TopicExpertsQueryVariables>, 'query'> & ({ variables: TopicExpertsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TopicExpertsComponent = (props: TopicExpertsComponentProps) => (
      <ApolloReactComponents.Query<TopicExpertsQuery, TopicExpertsQueryVariables> query={TopicExpertsDocument} {...props} />
    );
    

/**
 * __useTopicExpertsQuery__
 *
 * To run a query within a React component, call `useTopicExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicExpertsQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useTopicExpertsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TopicExpertsQuery, TopicExpertsQueryVariables>) {
        return ApolloReactHooks.useQuery<TopicExpertsQuery, TopicExpertsQueryVariables>(TopicExpertsDocument, baseOptions);
      }
export function useTopicExpertsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TopicExpertsQuery, TopicExpertsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TopicExpertsQuery, TopicExpertsQueryVariables>(TopicExpertsDocument, baseOptions);
        }
export type TopicExpertsQueryHookResult = ReturnType<typeof useTopicExpertsQuery>;
export type TopicExpertsLazyQueryHookResult = ReturnType<typeof useTopicExpertsLazyQuery>;
export type TopicExpertsQueryResult = ApolloReactCommon.QueryResult<TopicExpertsQuery, TopicExpertsQueryVariables>;